//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.1.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { AccessTokenKey } from 'shared/constants';
import { getAuthStorageEngine } from 'shared/helpers/auth-storage-helper';
export class BaseClient {
    public async transformOptions(options: RequestInit): Promise<RequestInit> {
        let accessToken = await getAuthStorageEngine().getItem(AccessTokenKey);

        return Object.assign({}, options, {
            headers: {
                ...options.headers,
                Authorization: 'Bearer ' + accessToken,
                TimeZoneId: Intl.DateTimeFormat().resolvedOptions().timeZone,
            },
        });
    }
}

export class SkioldOneClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:31198";
    }

    activeAnimalReport_GenerateAnimalNumberOnlyReportPdf(matingWorkListTableItems: AnimalNumberOnlyItem[], animalCount: number | undefined, poolYoungFemaleCount: number | undefined, siteId: string | null | undefined, timeZoneId: string | null | undefined, lang: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/ActiveAnimalReport/AnimalNumberOnlyReportPdf?";
        if (animalCount === null)
            throw new Error("The parameter 'animalCount' cannot be null.");
        else if (animalCount !== undefined)
            url_ += "animalCount=" + encodeURIComponent("" + animalCount) + "&";
        if (poolYoungFemaleCount === null)
            throw new Error("The parameter 'poolYoungFemaleCount' cannot be null.");
        else if (poolYoungFemaleCount !== undefined)
            url_ += "poolYoungFemaleCount=" + encodeURIComponent("" + poolYoungFemaleCount) + "&";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (timeZoneId !== undefined && timeZoneId !== null)
            url_ += "timeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(matingWorkListTableItems);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processActiveAnimalReport_GenerateAnimalNumberOnlyReportPdf(_response);
        });
    }

    protected processActiveAnimalReport_GenerateAnimalNumberOnlyReportPdf(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    alarms_Get(): Promise<Notification[]> {
        let url_ = this.baseUrl + "/api/Alarms";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAlarms_Get(_response);
        });
    }

    protected processAlarms_Get(response: Response): Promise<Notification[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Notification.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Notification[]>(null as any);
    }

    alarms_Post(instanceId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/Alarms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(instanceId);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAlarms_Post(_response);
        });
    }

    protected processAlarms_Post(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    alarms_GetFeeding(): Promise<Notification[]> {
        let url_ = this.baseUrl + "/api/Alarms/feeding";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAlarms_GetFeeding(_response);
        });
    }

    protected processAlarms_GetFeeding(response: Response): Promise<Notification[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Notification.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Notification[]>(null as any);
    }

    alarms_GetMilling(): Promise<Notification[]> {
        let url_ = this.baseUrl + "/api/Alarms/milling";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAlarms_GetMilling(_response);
        });
    }

    protected processAlarms_GetMilling(response: Response): Promise<Notification[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Notification.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Notification[]>(null as any);
    }

    alarms_Sync(lastSyncDate: Date | undefined): Promise<SyncNotifcations> {
        let url_ = this.baseUrl + "/api/Alarms/Sync?";
        if (lastSyncDate === null)
            throw new Error("The parameter 'lastSyncDate' cannot be null.");
        else if (lastSyncDate !== undefined)
            url_ += "lastSyncDate=" + encodeURIComponent(lastSyncDate ? "" + lastSyncDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAlarms_Sync(_response);
        });
    }

    protected processAlarms_Sync(response: Response): Promise<SyncNotifcations> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SyncNotifcations.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncNotifcations>(null as any);
    }

    analysis_ResultPerLitter(siteId: string | null | undefined, fromDate: Date | null | undefined, toDate: Date | null | undefined, breed: string | null | undefined): Promise<ResultPerLitterTableData> {
        let url_ = this.baseUrl + "/api/Analysis/ResultPerLitter?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (breed !== undefined && breed !== null)
            url_ += "breed=" + encodeURIComponent("" + breed) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAnalysis_ResultPerLitter(_response);
        });
    }

    protected processAnalysis_ResultPerLitter(response: Response): Promise<ResultPerLitterTableData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultPerLitterTableData.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultPerLitterTableData>(null as any);
    }

    analysis_ResultYoungFemaleAge(siteId: string | null | undefined, fromDate: Date | null | undefined, toDate: Date | null | undefined): Promise<ResultYoungFemaleAgeTableData> {
        let url_ = this.baseUrl + "/api/Analysis/ResultYoungFemaleAge?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAnalysis_ResultYoungFemaleAge(_response);
        });
    }

    protected processAnalysis_ResultYoungFemaleAge(response: Response): Promise<ResultYoungFemaleAgeTableData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultYoungFemaleAgeTableData.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultYoungFemaleAgeTableData>(null as any);
    }

    analysis_AnalysisPregnancyTableData(siteId: string | null | undefined, fromDate: Date | null | undefined, toDate: Date | null | undefined): Promise<AnalysisPregnancyTableItem> {
        let url_ = this.baseUrl + "/api/Analysis/AnalysisPregnancyTableData?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAnalysis_AnalysisPregnancyTableData(_response);
        });
    }

    protected processAnalysis_AnalysisPregnancyTableData(response: Response): Promise<AnalysisPregnancyTableItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AnalysisPregnancyTableItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AnalysisPregnancyTableItem>(null as any);
    }

    analysis_ElaborationResultYoungFemaleAge(siteId: string | null | undefined, fromDate: Date | null | undefined, toDate: Date | null | undefined): Promise<ElaborationResultYoungFemaleAgeTableData> {
        let url_ = this.baseUrl + "/api/Analysis/ElaborationResultYoungFemaleAge?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAnalysis_ElaborationResultYoungFemaleAge(_response);
        });
    }

    protected processAnalysis_ElaborationResultYoungFemaleAge(response: Response): Promise<ElaborationResultYoungFemaleAgeTableData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ElaborationResultYoungFemaleAgeTableData.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ElaborationResultYoungFemaleAgeTableData>(null as any);
    }

    analysis_ResultAnalysisMatingsTable(siteId: string | null | undefined, fromDate: Date | null | undefined, toDate: Date | null | undefined, value: string | null | undefined, analysisModalMode: string | null | undefined): Promise<ResultAnalysisMatingsTableItem[]> {
        let url_ = this.baseUrl + "/api/Analysis/ResultAnalysisMatingsTable?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (value !== undefined && value !== null)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        if (analysisModalMode !== undefined && analysisModalMode !== null)
            url_ += "analysisModalMode=" + encodeURIComponent("" + analysisModalMode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAnalysis_ResultAnalysisMatingsTable(_response);
        });
    }

    protected processAnalysis_ResultAnalysisMatingsTable(response: Response): Promise<ResultAnalysisMatingsTableItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ResultAnalysisMatingsTableItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultAnalysisMatingsTableItem[]>(null as any);
    }

    analysis_ResultAnalysisFarrowingsTable(siteId: string | null | undefined, fromDate: Date | null | undefined, toDate: Date | null | undefined, value: string | null | undefined, analysisModalMode: string | null | undefined): Promise<ResultAnalysisFarrowingsTableItem[]> {
        let url_ = this.baseUrl + "/api/Analysis/ResultAnalysisFarrowingsTable?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (value !== undefined && value !== null)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        if (analysisModalMode !== undefined && analysisModalMode !== null)
            url_ += "analysisModalMode=" + encodeURIComponent("" + analysisModalMode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAnalysis_ResultAnalysisFarrowingsTable(_response);
        });
    }

    protected processAnalysis_ResultAnalysisFarrowingsTable(response: Response): Promise<ResultAnalysisFarrowingsTableItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ResultAnalysisFarrowingsTableItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultAnalysisFarrowingsTableItem[]>(null as any);
    }

    analysis_ResultAnalysisWeaningsTable(siteId: string | null | undefined, fromDate: Date | null | undefined, toDate: Date | null | undefined, value: string | null | undefined, analysisModalMode: string | null | undefined): Promise<ResultAnalysisWeaningsTableItem[]> {
        let url_ = this.baseUrl + "/api/Analysis/ResultAnalysisWeaningsTable?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (value !== undefined && value !== null)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        if (analysisModalMode !== undefined && analysisModalMode !== null)
            url_ += "analysisModalMode=" + encodeURIComponent("" + analysisModalMode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAnalysis_ResultAnalysisWeaningsTable(_response);
        });
    }

    protected processAnalysis_ResultAnalysisWeaningsTable(response: Response): Promise<ResultAnalysisWeaningsTableItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ResultAnalysisWeaningsTableItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultAnalysisWeaningsTableItem[]>(null as any);
    }

    analysis_GetElaborationAnalysisMatingPregnancy(siteId: string | null | undefined, fromDate: Date | null | undefined, toDate: Date | null | undefined): Promise<AnalysisMatingPregnancyTotalMatingTableItem[]> {
        let url_ = this.baseUrl + "/api/Analysis/GetElaborationAnalysisMatingPregnancy?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAnalysis_GetElaborationAnalysisMatingPregnancy(_response);
        });
    }

    protected processAnalysis_GetElaborationAnalysisMatingPregnancy(response: Response): Promise<AnalysisMatingPregnancyTotalMatingTableItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AnalysisMatingPregnancyTotalMatingTableItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AnalysisMatingPregnancyTotalMatingTableItem[]>(null as any);
    }

    analysis_ElaborationMatingPregnancyWeaningToMating(siteId: string | null | undefined, fromDate: Date | null | undefined, toDate: Date | null | undefined): Promise<AnalysisMatingPregnancyTableItem> {
        let url_ = this.baseUrl + "/api/Analysis/ElaborationMatingPregnancyWeaningToMating?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAnalysis_ElaborationMatingPregnancyWeaningToMating(_response);
        });
    }

    protected processAnalysis_ElaborationMatingPregnancyWeaningToMating(response: Response): Promise<AnalysisMatingPregnancyTableItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AnalysisMatingPregnancyTableItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AnalysisMatingPregnancyTableItem>(null as any);
    }

    analysis_ElaborationMatingPregnancyMatingToNonPregnant(siteId: string | null | undefined, fromDate: Date | null | undefined, toDate: Date | null | undefined): Promise<AnalysisMatingPregnancyTableItem> {
        let url_ = this.baseUrl + "/api/Analysis/ElaborationMatingPregnancyMatingToNonPregnant?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAnalysis_ElaborationMatingPregnancyMatingToNonPregnant(_response);
        });
    }

    protected processAnalysis_ElaborationMatingPregnancyMatingToNonPregnant(response: Response): Promise<AnalysisMatingPregnancyTableItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AnalysisMatingPregnancyTableItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AnalysisMatingPregnancyTableItem>(null as any);
    }

    analysis_ElaborationMatingPregnancyMatingToMating(siteId: string | null | undefined, fromDate: Date | null | undefined, toDate: Date | null | undefined): Promise<AnalysisMatingPregnancyTableItem> {
        let url_ = this.baseUrl + "/api/Analysis/ElaborationMatingPregnancyMatingToMating?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAnalysis_ElaborationMatingPregnancyMatingToMating(_response);
        });
    }

    protected processAnalysis_ElaborationMatingPregnancyMatingToMating(response: Response): Promise<AnalysisMatingPregnancyTableItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AnalysisMatingPregnancyTableItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AnalysisMatingPregnancyTableItem>(null as any);
    }

    analysis_ElaborationMatingPregnancyMatingToAbortionAndDeparture(siteId: string | null | undefined, fromDate: Date | null | undefined, toDate: Date | null | undefined): Promise<AnalysisMatingPregnancyTableItem> {
        let url_ = this.baseUrl + "/api/Analysis/ElaborationMatingPregnancyMatingToAbortionAndDeparture?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAnalysis_ElaborationMatingPregnancyMatingToAbortionAndDeparture(_response);
        });
    }

    protected processAnalysis_ElaborationMatingPregnancyMatingToAbortionAndDeparture(response: Response): Promise<AnalysisMatingPregnancyTableItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AnalysisMatingPregnancyTableItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AnalysisMatingPregnancyTableItem>(null as any);
    }

    analysis_AnalysisDepartureSow(siteId: string | null | undefined, asPercentage: boolean | undefined, fromDate: Date | null | undefined, toDate: Date | null | undefined, allowDepartureTypes: string | null | undefined): Promise<AnalysisDepartureSowTableData> {
        let url_ = this.baseUrl + "/api/Analysis/AnalysisDepartureSow?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (asPercentage === null)
            throw new Error("The parameter 'asPercentage' cannot be null.");
        else if (asPercentage !== undefined)
            url_ += "asPercentage=" + encodeURIComponent("" + asPercentage) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (allowDepartureTypes !== undefined && allowDepartureTypes !== null)
            url_ += "allowDepartureTypes=" + encodeURIComponent("" + allowDepartureTypes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAnalysis_AnalysisDepartureSow(_response);
        });
    }

    protected processAnalysis_AnalysisDepartureSow(response: Response): Promise<AnalysisDepartureSowTableData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AnalysisDepartureSowTableData.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AnalysisDepartureSowTableData>(null as any);
    }

    analysis_AnalysisDepartureGpe(request: AnalysisDepartureGpeRequestModel): Promise<AnalysisDepartureGpeTableData> {
        let url_ = this.baseUrl + "/api/Analysis/AnalysisDepartureGpe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAnalysis_AnalysisDepartureGpe(_response);
        });
    }

    protected processAnalysis_AnalysisDepartureGpe(response: Response): Promise<AnalysisDepartureGpeTableData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AnalysisDepartureGpeTableData.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AnalysisDepartureGpeTableData>(null as any);
    }

    analysisPdf_GetResultPerLitterFarrowingsItemPdf(data: ResultAnalysisFarrowingsData, siteId: string | null | undefined, timeZoneId: string | null | undefined, lang: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/AnalysisPdf/GetResultPerLitterFarrowingsItemPdf?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (timeZoneId !== undefined && timeZoneId !== null)
            url_ += "timeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAnalysisPdf_GetResultPerLitterFarrowingsItemPdf(_response);
        });
    }

    protected processAnalysisPdf_GetResultPerLitterFarrowingsItemPdf(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    analysisPdf_GetTotalMatingTableItemPdf(data: ResultAnalysisMatingsData, siteId: string | null | undefined, timeZoneId: string | null | undefined, lang: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/AnalysisPdf/GetResultPerLitterMatingsItemPdf?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (timeZoneId !== undefined && timeZoneId !== null)
            url_ += "timeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAnalysisPdf_GetTotalMatingTableItemPdf(_response);
        });
    }

    protected processAnalysisPdf_GetTotalMatingTableItemPdf(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    analysisPdf_GetTotalMatingTableItemPdf2(data: AnalysisMatingPregnancyTotalMatingData, siteId: string | null | undefined, timeZoneId: string | null | undefined, lang: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/AnalysisPdf/GetAnalysisTotalMatingsPregnancyItemPdf?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (timeZoneId !== undefined && timeZoneId !== null)
            url_ += "timeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAnalysisPdf_GetTotalMatingTableItemPdf2(_response);
        });
    }

    protected processAnalysisPdf_GetTotalMatingTableItemPdf2(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    analysisPdf_GetResultPerLitterWeaningsItemPdf(data: ResultAnalysisWeaningsData, siteId: string | null | undefined, timeZoneId: string | null | undefined, lang: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/AnalysisPdf/GetResultPerLitterWeaningsItemPdf?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (timeZoneId !== undefined && timeZoneId !== null)
            url_ += "timeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAnalysisPdf_GetResultPerLitterWeaningsItemPdf(_response);
        });
    }

    protected processAnalysisPdf_GetResultPerLitterWeaningsItemPdf(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    analysisPdf_GetResultsPerLitterPdf(data: ResultPerLitterData, siteId: string | null | undefined, timeZoneId: string | null | undefined, lang: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/AnalysisPdf/GetResultsPerLitterPdf?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (timeZoneId !== undefined && timeZoneId !== null)
            url_ += "timeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAnalysisPdf_GetResultsPerLitterPdf(_response);
        });
    }

    protected processAnalysisPdf_GetResultsPerLitterPdf(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    analysisPdf_GetResultsYoungAnimalAgePdf(data: ResultYoungFemaleAgeData, siteId: string | null | undefined, timeZoneId: string | null | undefined, agePeriods: AnalysisResultYoungFemaleAgePeriod[] | null | undefined, lang: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/AnalysisPdf/GetResultsYoungAnimalAgePdf?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (timeZoneId !== undefined && timeZoneId !== null)
            url_ += "timeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        if (agePeriods !== undefined && agePeriods !== null)
            agePeriods && agePeriods.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "agePeriods[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAnalysisPdf_GetResultsYoungAnimalAgePdf(_response);
        });
    }

    protected processAnalysisPdf_GetResultsYoungAnimalAgePdf(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    analysisPdf_GetAnalysisResultPregnancyPdf(data: AnalysisPregnancyData, siteId: string | null | undefined, timeZoneId: string | null | undefined, lang: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/AnalysisPdf/GetAnalysisResultPregnancyPdf?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (timeZoneId !== undefined && timeZoneId !== null)
            url_ += "timeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAnalysisPdf_GetAnalysisResultPregnancyPdf(_response);
        });
    }

    protected processAnalysisPdf_GetAnalysisResultPregnancyPdf(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    analysisPdf_GetAnalysisMatingPregnancyTableDataPdf(data: AnalysisMatingPregnancyData, siteId: string | null | undefined, timeZoneId: string | null | undefined, dataMode: string | null | undefined, lang: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/AnalysisPdf/GetAnalysisMatingPregnancyTableDataPdf?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (timeZoneId !== undefined && timeZoneId !== null)
            url_ += "timeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        if (dataMode !== undefined && dataMode !== null)
            url_ += "dataMode=" + encodeURIComponent("" + dataMode) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAnalysisPdf_GetAnalysisMatingPregnancyTableDataPdf(_response);
        });
    }

    protected processAnalysisPdf_GetAnalysisMatingPregnancyTableDataPdf(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    analysisPdf_GetAnalysisDepartureSowPdf(data: AnalysisDepartureSowTableData, siteId: string | null | undefined, timeZoneId: string | null | undefined, asPercentage: boolean | undefined, lang: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/AnalysisPdf/GetAnalysisDepartureSowPdf?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (timeZoneId !== undefined && timeZoneId !== null)
            url_ += "timeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        if (asPercentage === null)
            throw new Error("The parameter 'asPercentage' cannot be null.");
        else if (asPercentage !== undefined)
            url_ += "asPercentage=" + encodeURIComponent("" + asPercentage) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAnalysisPdf_GetAnalysisDepartureSowPdf(_response);
        });
    }

    protected processAnalysisPdf_GetAnalysisDepartureSowPdf(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    analysisPdf_GetAnalysisDepartureGpePdf(data: AnalysisDepartureGpeTableData, siteId: string | null | undefined, timeZoneId: string | null | undefined, asPercentage: boolean | undefined, lang: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/AnalysisPdf/GetAnalysisDepartureGpePdf?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (timeZoneId !== undefined && timeZoneId !== null)
            url_ += "timeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        if (asPercentage === null)
            throw new Error("The parameter 'asPercentage' cannot be null.");
        else if (asPercentage !== undefined)
            url_ += "asPercentage=" + encodeURIComponent("" + asPercentage) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAnalysisPdf_GetAnalysisDepartureGpePdf(_response);
        });
    }

    protected processAnalysisPdf_GetAnalysisDepartureGpePdf(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    analysisSettings_Upsert(settings: AnalysisSetting): Promise<string> {
        let url_ = this.baseUrl + "/api/AnalysisSettings/UpsertAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAnalysisSettings_Upsert(_response);
        });
    }

    protected processAnalysisSettings_Upsert(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    analysisSettings_GetbySiteId(siteId: string | null | undefined): Promise<AnalysisSetting[]> {
        let url_ = this.baseUrl + "/api/AnalysisSettings/GetBySiteId?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAnalysisSettings_GetbySiteId(_response);
        });
    }

    protected processAnalysisSettings_GetbySiteId(response: Response): Promise<AnalysisSetting[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AnalysisSetting.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AnalysisSetting[]>(null as any);
    }

    animalListReport_Post(activeSows: ActiveSow[], siteId: string | null | undefined, timeZoneId: string | null | undefined, lang: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/AnimalListReport?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (timeZoneId !== undefined && timeZoneId !== null)
            url_ += "timeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(activeSows);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAnimalListReport_Post(_response);
        });
    }

    protected processAnimalListReport_Post(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    animalListReport_PPrintDadMomTableListst(activeSows: DadMomTableItem[], siteId: string | null | undefined, timeZoneId: string | null | undefined, lang: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/AnimalListReport/PrintDadMomTableList?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (timeZoneId !== undefined && timeZoneId !== null)
            url_ += "timeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(activeSows);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAnimalListReport_PPrintDadMomTableListst(_response);
        });
    }

    protected processAnimalListReport_PPrintDadMomTableListst(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    animalListReport_Post2(youngAnimals: YoungAnimalTableItem[], siteId: string | null | undefined, timeZoneId: string | null | undefined, lang: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/AnimalListReport/PrintYoungAnimal?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (timeZoneId !== undefined && timeZoneId !== null)
            url_ += "timeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(youngAnimals);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAnimalListReport_Post2(_response);
        });
    }

    protected processAnimalListReport_Post2(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    animalListReport_PrintDepartedSowList(departedSows: DepartedSow[], siteId: string | null | undefined, timeZoneId: string | null | undefined, lang: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/AnimalListReport/PrintDpeartedSowList?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (timeZoneId !== undefined && timeZoneId !== null)
            url_ += "timeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(departedSows);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAnimalListReport_PrintDepartedSowList(_response);
        });
    }

    protected processAnimalListReport_PrintDepartedSowList(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    animalListReport_PrintMatingList(matingEvents: MatingEventPdfItem[], siteId: string | null | undefined, timeZoneId: string | null | undefined, lang: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/AnimalListReport/PrintMatingList?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (timeZoneId !== undefined && timeZoneId !== null)
            url_ += "timeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(matingEvents);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAnimalListReport_PrintMatingList(_response);
        });
    }

    protected processAnimalListReport_PrintMatingList(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    animalListReport_PrintScanningList(scanningEvents: ScanningEventPdfItem[], siteId: string | null | undefined, timeZoneId: string | null | undefined, lang: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/AnimalListReport/PrintScanningList?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (timeZoneId !== undefined && timeZoneId !== null)
            url_ += "timeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(scanningEvents);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAnimalListReport_PrintScanningList(_response);
        });
    }

    protected processAnimalListReport_PrintScanningList(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    animalListReport_PrintFarrowingList(farrowingEvents: FarrowingEventPdfItem[], siteId: string | null | undefined, timeZoneId: string | null | undefined, lang: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/AnimalListReport/PrintFarrowingList?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (timeZoneId !== undefined && timeZoneId !== null)
            url_ += "timeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(farrowingEvents);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAnimalListReport_PrintFarrowingList(_response);
        });
    }

    protected processAnimalListReport_PrintFarrowingList(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    animalListReport_PrintWeaningList(weaningEvents: WeaningEventPdfItem[], siteId: string | null | undefined, timeZoneId: string | null | undefined, lang: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/AnimalListReport/PrintWeaningList?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (timeZoneId !== undefined && timeZoneId !== null)
            url_ += "timeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(weaningEvents);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAnimalListReport_PrintWeaningList(_response);
        });
    }

    protected processAnimalListReport_PrintWeaningList(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    animalListReport_PrintDeadPigletsList(deadPigletEvents: DeadPigletsEventPdfItem[], siteId: string | null | undefined, timeZoneId: string | null | undefined, lang: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/AnimalListReport/PrintDeadPigletsList?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (timeZoneId !== undefined && timeZoneId !== null)
            url_ += "timeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deadPigletEvents);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAnimalListReport_PrintDeadPigletsList(_response);
        });
    }

    protected processAnimalListReport_PrintDeadPigletsList(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    animalReportSetting_Get(id: string | null | undefined): Promise<AnimalReportSetting> {
        let url_ = this.baseUrl + "/api/AnimalReportSetting?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAnimalReportSetting_Get(_response);
        });
    }

    protected processAnimalReportSetting_Get(response: Response): Promise<AnimalReportSetting> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AnimalReportSetting.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AnimalReportSetting>(null as any);
    }

    animalReportSetting_Upsert(animalReportSetting: AnimalReportSetting): Promise<string> {
        let url_ = this.baseUrl + "/api/AnimalReportSetting/Upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(animalReportSetting);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAnimalReportSetting_Upsert(_response);
        });
    }

    protected processAnimalReportSetting_Upsert(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    animalReportSetting_GetBySiteId(siteId: string | null | undefined): Promise<AnimalReportSetting[]> {
        let url_ = this.baseUrl + "/api/AnimalReportSetting/GetBySiteId?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAnimalReportSetting_GetBySiteId(_response);
        });
    }

    protected processAnimalReportSetting_GetBySiteId(response: Response): Promise<AnimalReportSetting[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AnimalReportSetting.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AnimalReportSetting[]>(null as any);
    }

    animalReportSetting_Sync(siteId: string | null | undefined, lastSyncDate: Date | undefined): Promise<SyncDataAnimalReportSetting> {
        let url_ = this.baseUrl + "/api/AnimalReportSetting/Sync?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (lastSyncDate === null)
            throw new Error("The parameter 'lastSyncDate' cannot be null.");
        else if (lastSyncDate !== undefined)
            url_ += "lastSyncDate=" + encodeURIComponent(lastSyncDate ? "" + lastSyncDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAnimalReportSetting_Sync(_response);
        });
    }

    protected processAnimalReportSetting_Sync(response: Response): Promise<SyncDataAnimalReportSetting> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SyncDataAnimalReportSetting.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncDataAnimalReportSetting>(null as any);
    }

    balanceWeanedPigs_GetCurrentPigsAtLocationByDate(siteId: string | null | undefined, toDate: Date | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/BalanceWeanedPigs/GetCurrentPigsAtLocationByDate?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBalanceWeanedPigs_GetCurrentPigsAtLocationByDate(_response);
        });
    }

    protected processBalanceWeanedPigs_GetCurrentPigsAtLocationByDate(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    balanceWeanedPigs_GetBalancePigEventsByDates(siteId: string | null | undefined, fromDate: Date | undefined, toDate: Date | undefined): Promise<BalancePigEventTotalWeightBalancePigEvents> {
        let url_ = this.baseUrl + "/api/BalanceWeanedPigs/GetBalancePigEventsByDates?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBalanceWeanedPigs_GetBalancePigEventsByDates(_response);
        });
    }

    protected processBalanceWeanedPigs_GetBalancePigEventsByDates(response: Response): Promise<BalancePigEventTotalWeightBalancePigEvents> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BalancePigEventTotalWeightBalancePigEvents.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BalancePigEventTotalWeightBalancePigEvents>(null as any);
    }

    bMPData_Get(lastSyncDate: Date | undefined): Promise<BMPData[]> {
        let url_ = this.baseUrl + "/api/BMPData?";
        if (lastSyncDate === null)
            throw new Error("The parameter 'lastSyncDate' cannot be null.");
        else if (lastSyncDate !== undefined)
            url_ += "lastSyncDate=" + encodeURIComponent(lastSyncDate ? "" + lastSyncDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBMPData_Get(_response);
        });
    }

    protected processBMPData_Get(response: Response): Promise<BMPData[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BMPData.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BMPData[]>(null as any);
    }

    bMPData_Post(bMPData: BMPData): Promise<void> {
        let url_ = this.baseUrl + "/api/BMPData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bMPData);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBMPData_Post(_response);
        });
    }

    protected processBMPData_Post(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    breedTableItem_UpsertMany(items: BreedTableItem[]): Promise<BreedTableItem[]> {
        let url_ = this.baseUrl + "/api/BreedTableItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(items);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBreedTableItem_UpsertMany(_response);
        });
    }

    protected processBreedTableItem_UpsertMany(response: Response): Promise<BreedTableItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BreedTableItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BreedTableItem[]>(null as any);
    }

    breedTableItem_Sync(lastSyncDate: Date | undefined): Promise<SyncDataBreedTableItem> {
        let url_ = this.baseUrl + "/api/BreedTableItem/Sync?";
        if (lastSyncDate === null)
            throw new Error("The parameter 'lastSyncDate' cannot be null.");
        else if (lastSyncDate !== undefined)
            url_ += "lastSyncDate=" + encodeURIComponent(lastSyncDate ? "" + lastSyncDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBreedTableItem_Sync(_response);
        });
    }

    protected processBreedTableItem_Sync(response: Response): Promise<SyncDataBreedTableItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SyncDataBreedTableItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncDataBreedTableItem>(null as any);
    }

    breedTableItem_GetUniqueDadBreeds(): Promise<string[]> {
        let url_ = this.baseUrl + "/api/BreedTableItem/GetUniqueDadBreeds";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBreedTableItem_GetUniqueDadBreeds(_response);
        });
    }

    protected processBreedTableItem_GetUniqueDadBreeds(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    breedTableItem_GetDanBredBreeds(): Promise<string[]> {
        let url_ = this.baseUrl + "/api/BreedTableItem/GetDanBredBreeds";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBreedTableItem_GetDanBredBreeds(_response);
        });
    }

    protected processBreedTableItem_GetDanBredBreeds(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    breedTableItem_DeleteByDadAndMom(dadMom: DadMomBreed): Promise<string[]> {
        let url_ = this.baseUrl + "/api/BreedTableItem/DeleteByDadAndMom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dadMom);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBreedTableItem_DeleteByDadAndMom(_response);
        });
    }

    protected processBreedTableItem_DeleteByDadAndMom(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    breedTableItem_GetSkioldBreeds(): Promise<string[]> {
        let url_ = this.baseUrl + "/api/BreedTableItem/GetSkioldBreeds";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBreedTableItem_GetSkioldBreeds(_response);
        });
    }

    protected processBreedTableItem_GetSkioldBreeds(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    buildings_GetAll(): Promise<Building[]> {
        let url_ = this.baseUrl + "/api/Buildings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBuildings_GetAll(_response);
        });
    }

    protected processBuildings_GetAll(response: Response): Promise<Building[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Building.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Building[]>(null as any);
    }

    buildings_Upsert(value: Building): Promise<string> {
        let url_ = this.baseUrl + "/api/Buildings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBuildings_Upsert(_response);
        });
    }

    protected processBuildings_Upsert(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    buildings_GetBySiteId(siteId: string | null | undefined): Promise<Building[]> {
        let url_ = this.baseUrl + "/api/Buildings/GetBySiteId?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBuildings_GetBySiteId(_response);
        });
    }

    protected processBuildings_GetBySiteId(response: Response): Promise<Building[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Building.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Building[]>(null as any);
    }

    buildings_Get(id: string | null): Promise<Building> {
        let url_ = this.baseUrl + "/api/Buildings/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBuildings_Get(_response);
        });
    }

    protected processBuildings_Get(response: Response): Promise<Building> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Building.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Building>(null as any);
    }

    buildings_Delete(id: string | null): Promise<void> {
        let url_ = this.baseUrl + "/api/Buildings/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBuildings_Delete(_response);
        });
    }

    protected processBuildings_Delete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    buildings_Upsert2(value: Building): Promise<string> {
        let url_ = this.baseUrl + "/api/Buildings/UpsertAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBuildings_Upsert2(_response);
        });
    }

    protected processBuildings_Upsert2(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    country_HttpGet(): Promise<Country[]> {
        let url_ = this.baseUrl + "/api/Country";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCountry_HttpGet(_response);
        });
    }

    protected processCountry_HttpGet(response: Response): Promise<Country[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Country.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Country[]>(null as any);
    }

    dashboard_GetDashboard(siteId: string | null | undefined): Promise<DashboardItem> {
        let url_ = this.baseUrl + "/api/Dashboard/GetDashboard?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDashboard_GetDashboard(_response);
        });
    }

    protected processDashboard_GetDashboard(response: Response): Promise<DashboardItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashboardItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardItem>(null as any);
    }

    dashboard_GetDashboardPdf(siteId: string | null | undefined, timeZoneId: string | null | undefined, lang: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Dashboard/GetDashboardPdf?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (timeZoneId !== undefined && timeZoneId !== null)
            url_ += "timeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDashboard_GetDashboardPdf(_response);
        });
    }

    protected processDashboard_GetDashboardPdf(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    dashboard_GetTotalMatingsTable(siteId: string | null | undefined, batchId: string | null | undefined): Promise<TotalMatingTableItem[]> {
        let url_ = this.baseUrl + "/api/Dashboard/GetTotalMatingsTable?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (batchId !== undefined && batchId !== null)
            url_ += "batchId=" + encodeURIComponent("" + batchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDashboard_GetTotalMatingsTable(_response);
        });
    }

    protected processDashboard_GetTotalMatingsTable(response: Response): Promise<TotalMatingTableItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TotalMatingTableItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TotalMatingTableItem[]>(null as any);
    }

    dashboard_GetAnimalToFarrowingTable(siteId: string | null | undefined, batchId: string | null | undefined): Promise<AnimalToFarrowingTableItem[]> {
        let url_ = this.baseUrl + "/api/Dashboard/GetAnimalToFarrowingTable?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (batchId !== undefined && batchId !== null)
            url_ += "batchId=" + encodeURIComponent("" + batchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDashboard_GetAnimalToFarrowingTable(_response);
        });
    }

    protected processDashboard_GetAnimalToFarrowingTable(response: Response): Promise<AnimalToFarrowingTableItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AnimalToFarrowingTableItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AnimalToFarrowingTableItem[]>(null as any);
    }

    dashboard_GetDeparturedFromBatchTable(siteId: string | null | undefined, batchId: string | null | undefined): Promise<TotalMatingTableItem[]> {
        let url_ = this.baseUrl + "/api/Dashboard/GetDeparturedFromBatchTable?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (batchId !== undefined && batchId !== null)
            url_ += "batchId=" + encodeURIComponent("" + batchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDashboard_GetDeparturedFromBatchTable(_response);
        });
    }

    protected processDashboard_GetDeparturedFromBatchTable(response: Response): Promise<TotalMatingTableItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TotalMatingTableItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TotalMatingTableItem[]>(null as any);
    }

    dashboard_GetTotalFarrowingTable(siteId: string | null | undefined, batchId: string | null | undefined): Promise<TotalFarrowingTableItem[]> {
        let url_ = this.baseUrl + "/api/Dashboard/GetTotalFarrowingTable?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (batchId !== undefined && batchId !== null)
            url_ += "batchId=" + encodeURIComponent("" + batchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDashboard_GetTotalFarrowingTable(_response);
        });
    }

    protected processDashboard_GetTotalFarrowingTable(response: Response): Promise<TotalFarrowingTableItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TotalFarrowingTableItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TotalFarrowingTableItem[]>(null as any);
    }

    dashboard_GetDeadPigletsByWeeks(siteId: string | null | undefined, batchId: string | null | undefined): Promise<DeadPigletsByWeek[]> {
        let url_ = this.baseUrl + "/api/Dashboard/GetDeadPigletsByWeeks?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (batchId !== undefined && batchId !== null)
            url_ += "batchId=" + encodeURIComponent("" + batchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDashboard_GetDeadPigletsByWeeks(_response);
        });
    }

    protected processDashboard_GetDeadPigletsByWeeks(response: Response): Promise<DeadPigletsByWeek[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeadPigletsByWeek.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeadPigletsByWeek[]>(null as any);
    }

    dashboard_GetNeedFarrowingTable(siteId: string | null | undefined, batchId: string | null | undefined): Promise<AnimalToFarrowingTableItem[]> {
        let url_ = this.baseUrl + "/api/Dashboard/GetNeedFarrowingTable?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (batchId !== undefined && batchId !== null)
            url_ += "batchId=" + encodeURIComponent("" + batchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDashboard_GetNeedFarrowingTable(_response);
        });
    }

    protected processDashboard_GetNeedFarrowingTable(response: Response): Promise<AnimalToFarrowingTableItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AnimalToFarrowingTableItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AnimalToFarrowingTableItem[]>(null as any);
    }

    dashboard_GetTotalWeaningTable(siteId: string | null | undefined, batchId: string | null | undefined): Promise<TotalWeaningTableItem[]> {
        let url_ = this.baseUrl + "/api/Dashboard/GetTotalWeaningTable?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (batchId !== undefined && batchId !== null)
            url_ += "batchId=" + encodeURIComponent("" + batchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDashboard_GetTotalWeaningTable(_response);
        });
    }

    protected processDashboard_GetTotalWeaningTable(response: Response): Promise<TotalWeaningTableItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TotalWeaningTableItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TotalWeaningTableItem[]>(null as any);
    }

    dashboard_GetNeedWeaningTable(siteId: string | null | undefined, batchId: string | null | undefined): Promise<NeedWeaningTableItem[]> {
        let url_ = this.baseUrl + "/api/Dashboard/GetNeedWeaningTable?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (batchId !== undefined && batchId !== null)
            url_ += "batchId=" + encodeURIComponent("" + batchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDashboard_GetNeedWeaningTable(_response);
        });
    }

    protected processDashboard_GetNeedWeaningTable(response: Response): Promise<NeedWeaningTableItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NeedWeaningTableItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NeedWeaningTableItem[]>(null as any);
    }

    dashboard_GetDashboardOverviewTable(siteId: string | null | undefined): Promise<DashboardOverviewData> {
        let url_ = this.baseUrl + "/api/Dashboard/GetDashboardOverviewTable?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDashboard_GetDashboardOverviewTable(_response);
        });
    }

    protected processDashboard_GetDashboardOverviewTable(response: Response): Promise<DashboardOverviewData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashboardOverviewData.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardOverviewData>(null as any);
    }

    dashboard_GetDashboardOverviewGraph(siteId: string | null | undefined, state: PregnancyState | undefined): Promise<DashboardOverviewData> {
        let url_ = this.baseUrl + "/api/Dashboard/GetDashboardOverviewGraph?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (state === null)
            throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "state=" + encodeURIComponent("" + state) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDashboard_GetDashboardOverviewGraph(_response);
        });
    }

    protected processDashboard_GetDashboardOverviewGraph(response: Response): Promise<DashboardOverviewData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashboardOverviewData.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardOverviewData>(null as any);
    }

    dashboardPdf_GetTotalMatingTableItemPdf(tableModels: TotalMatingTableItem[], siteId: string | null | undefined, timeZoneId: string | null | undefined, isDeparture: boolean | undefined, titleFrontend: string | null | undefined, lang: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/DashboardPdf/GetTotalMatingTableItemPdf?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (timeZoneId !== undefined && timeZoneId !== null)
            url_ += "timeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        if (isDeparture === null)
            throw new Error("The parameter 'isDeparture' cannot be null.");
        else if (isDeparture !== undefined)
            url_ += "isDeparture=" + encodeURIComponent("" + isDeparture) + "&";
        if (titleFrontend !== undefined && titleFrontend !== null)
            url_ += "titleFrontend=" + encodeURIComponent("" + titleFrontend) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tableModels);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDashboardPdf_GetTotalMatingTableItemPdf(_response);
        });
    }

    protected processDashboardPdf_GetTotalMatingTableItemPdf(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    dashboardPdf_GetAnimalToFarrowingTableItemPdf(tableModels: AnimalToFarrowingTableItem[], siteId: string | null | undefined, timeZoneId: string | null | undefined, needWeaning: boolean | undefined, lang: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/DashboardPdf/GetAnimalToFarrowingTableItemPdf?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (timeZoneId !== undefined && timeZoneId !== null)
            url_ += "timeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        if (needWeaning === null)
            throw new Error("The parameter 'needWeaning' cannot be null.");
        else if (needWeaning !== undefined)
            url_ += "needWeaning=" + encodeURIComponent("" + needWeaning) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tableModels);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDashboardPdf_GetAnimalToFarrowingTableItemPdf(_response);
        });
    }

    protected processDashboardPdf_GetAnimalToFarrowingTableItemPdf(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    dashboardPdf_GetTotalFarrowingTableItemPdf(tableModels: TotalFarrowingTableItem[], siteId: string | null | undefined, timeZoneId: string | null | undefined, lang: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/DashboardPdf/GetTotalFarrowingTableItemPdf?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (timeZoneId !== undefined && timeZoneId !== null)
            url_ += "timeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tableModels);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDashboardPdf_GetTotalFarrowingTableItemPdf(_response);
        });
    }

    protected processDashboardPdf_GetTotalFarrowingTableItemPdf(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    dashboardPdf_GetNeedWeaningTableItemPdf(tableModels: NeedWeaningTableItem[], siteId: string | null | undefined, timeZoneId: string | null | undefined, lang: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/DashboardPdf/GetNeedWeaningTableItemPdf?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (timeZoneId !== undefined && timeZoneId !== null)
            url_ += "timeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tableModels);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDashboardPdf_GetNeedWeaningTableItemPdf(_response);
        });
    }

    protected processDashboardPdf_GetNeedWeaningTableItemPdf(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    dashboardPdf_GetTotalWeaningTableItemPdf(tableModels: TotalWeaningTableItem[], siteId: string | null | undefined, timeZoneId: string | null | undefined, lang: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/DashboardPdf/GetTotalWeaningTableItemPdf?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (timeZoneId !== undefined && timeZoneId !== null)
            url_ += "timeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tableModels);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDashboardPdf_GetTotalWeaningTableItemPdf(_response);
        });
    }

    protected processDashboardPdf_GetTotalWeaningTableItemPdf(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    dashboardPdf_GetMatingBatchWeekPdf(tableModels: TotalMatingTableItem[], siteId: string | null | undefined, timeZoneId: string | null | undefined, title: string | null | undefined, lang: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/DashboardPdf/GetMatingBatchWeekPdf?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (timeZoneId !== undefined && timeZoneId !== null)
            url_ += "timeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        if (title !== undefined && title !== null)
            url_ += "title=" + encodeURIComponent("" + title) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tableModels);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDashboardPdf_GetMatingBatchWeekPdf(_response);
        });
    }

    protected processDashboardPdf_GetMatingBatchWeekPdf(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    dashboardSettings_Upsert(settings: DashboardSettings): Promise<string> {
        let url_ = this.baseUrl + "/api/DashboardSettings/Upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDashboardSettings_Upsert(_response);
        });
    }

    protected processDashboardSettings_Upsert(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    dashboardSettings_GetSettings(siteId: string | null | undefined): Promise<DashboardSettings> {
        let url_ = this.baseUrl + "/api/DashboardSettings?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDashboardSettings_GetSettings(_response);
        });
    }

    protected processDashboardSettings_GetSettings(response: Response): Promise<DashboardSettings> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashboardSettings.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardSettings>(null as any);
    }

    dashboardSettings_Sync(siteId: string | null | undefined, lastSyncDate: Date | undefined): Promise<SyncDashboardSettings> {
        let url_ = this.baseUrl + "/api/DashboardSettings/Sync?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (lastSyncDate === null)
            throw new Error("The parameter 'lastSyncDate' cannot be null.");
        else if (lastSyncDate !== undefined)
            url_ += "lastSyncDate=" + encodeURIComponent(lastSyncDate ? "" + lastSyncDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDashboardSettings_Sync(_response);
        });
    }

    protected processDashboardSettings_Sync(response: Response): Promise<SyncDashboardSettings> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SyncDashboardSettings.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncDashboardSettings>(null as any);
    }

    deadPigletsEvent_Post(deadPigletsEvent: DeadPigletsEvent): Promise<string> {
        let url_ = this.baseUrl + "/api/DeadPigletsEvent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deadPigletsEvent);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeadPigletsEvent_Post(_response);
        });
    }

    protected processDeadPigletsEvent_Post(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    deadPigletsEvent_Sync(siteId: string | null | undefined, lastSyncDate: Date | undefined): Promise<SyncDataDeadPigletsEvent> {
        let url_ = this.baseUrl + "/api/DeadPigletsEvent/Sync?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (lastSyncDate === null)
            throw new Error("The parameter 'lastSyncDate' cannot be null.");
        else if (lastSyncDate !== undefined)
            url_ += "lastSyncDate=" + encodeURIComponent(lastSyncDate ? "" + lastSyncDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeadPigletsEvent_Sync(_response);
        });
    }

    protected processDeadPigletsEvent_Sync(response: Response): Promise<SyncDataDeadPigletsEvent> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SyncDataDeadPigletsEvent.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncDataDeadPigletsEvent>(null as any);
    }

    deadPigletsEvent_GetDeadPigletsByPeriod(siteId: string | null | undefined, fromDate: Date | undefined, toDate: Date | undefined): Promise<DeadPigletsEvent[]> {
        let url_ = this.baseUrl + "/api/DeadPigletsEvent/GetDeadPigletsByPeriod?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeadPigletsEvent_GetDeadPigletsByPeriod(_response);
        });
    }

    protected processDeadPigletsEvent_GetDeadPigletsByPeriod(response: Response): Promise<DeadPigletsEvent[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeadPigletsEvent.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeadPigletsEvent[]>(null as any);
    }

    deadPigletsEvent_GetDeparturedDeadPigletsEvent(siteId: string | null | undefined): Promise<DeadPigletsEvent[]> {
        let url_ = this.baseUrl + "/api/DeadPigletsEvent/GetDeparturedDeadPigletsEvent?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeadPigletsEvent_GetDeparturedDeadPigletsEvent(_response);
        });
    }

    protected processDeadPigletsEvent_GetDeparturedDeadPigletsEvent(response: Response): Promise<DeadPigletsEvent[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeadPigletsEvent.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeadPigletsEvent[]>(null as any);
    }

    deadPigletsEvent_GetAnalysisGraphBySiteIdAndDates(siteId: string | null | undefined, fromDate: Date | undefined, toDate: Date | undefined): Promise<AnalysisDeadPigletsGraphModel[]> {
        let url_ = this.baseUrl + "/api/DeadPigletsEvent/GetAnalysisGraphBySiteIdAndDates?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeadPigletsEvent_GetAnalysisGraphBySiteIdAndDates(_response);
        });
    }

    protected processDeadPigletsEvent_GetAnalysisGraphBySiteIdAndDates(response: Response): Promise<AnalysisDeadPigletsGraphModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AnalysisDeadPigletsGraphModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AnalysisDeadPigletsGraphModel[]>(null as any);
    }

    device_Upsert(device: Device): Promise<void> {
        let url_ = this.baseUrl + "/api/Device";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(device);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDevice_Upsert(_response);
        });
    }

    protected processDevice_Upsert(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    device_RemoveDevice(hardwareId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/Device";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(hardwareId);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDevice_RemoveDevice(_response);
        });
    }

    protected processDevice_RemoveDevice(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    diagnoseCategories_Post(category: DiagnoseCategory): Promise<string> {
        let url_ = this.baseUrl + "/api/DiagnoseCategories";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(category);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDiagnoseCategories_Post(_response);
        });
    }

    protected processDiagnoseCategories_Post(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    diagnoseCategories_Put(category: DiagnoseCategory): Promise<string> {
        let url_ = this.baseUrl + "/api/DiagnoseCategories";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(category);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDiagnoseCategories_Put(_response);
        });
    }

    protected processDiagnoseCategories_Put(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    diagnoseCategories_GetAll(): Promise<DiagnoseCategory[]> {
        let url_ = this.baseUrl + "/api/DiagnoseCategories";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDiagnoseCategories_GetAll(_response);
        });
    }

    protected processDiagnoseCategories_GetAll(response: Response): Promise<DiagnoseCategory[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiagnoseCategory.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiagnoseCategory[]>(null as any);
    }

    diagnoseCategories_Get(id: string | null): Promise<DiagnoseCategory> {
        let url_ = this.baseUrl + "/api/DiagnoseCategories/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDiagnoseCategories_Get(_response);
        });
    }

    protected processDiagnoseCategories_Get(response: Response): Promise<DiagnoseCategory> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DiagnoseCategory.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiagnoseCategory>(null as any);
    }

    diagnoseCategories_Sync(lastSyncDate: Date | undefined): Promise<SyncDataDiagnoseCategory> {
        let url_ = this.baseUrl + "/api/DiagnoseCategories/Sync?";
        if (lastSyncDate === null)
            throw new Error("The parameter 'lastSyncDate' cannot be null.");
        else if (lastSyncDate !== undefined)
            url_ += "lastSyncDate=" + encodeURIComponent(lastSyncDate ? "" + lastSyncDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDiagnoseCategories_Sync(_response);
        });
    }

    protected processDiagnoseCategories_Sync(response: Response): Promise<SyncDataDiagnoseCategory> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SyncDataDiagnoseCategory.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncDataDiagnoseCategory>(null as any);
    }

    diagnose_Post(diagnose: Diagnose): Promise<Diagnose> {
        let url_ = this.baseUrl + "/api/Diagnose";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(diagnose);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDiagnose_Post(_response);
        });
    }

    protected processDiagnose_Post(response: Response): Promise<Diagnose> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Diagnose.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Diagnose>(null as any);
    }

    diagnose_Put(diagnose: Diagnose): Promise<Diagnose> {
        let url_ = this.baseUrl + "/api/Diagnose";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(diagnose);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDiagnose_Put(_response);
        });
    }

    protected processDiagnose_Put(response: Response): Promise<Diagnose> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Diagnose.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Diagnose>(null as any);
    }

    diagnose_GetAll(): Promise<Diagnose[]> {
        let url_ = this.baseUrl + "/api/Diagnose";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDiagnose_GetAll(_response);
        });
    }

    protected processDiagnose_GetAll(response: Response): Promise<Diagnose[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Diagnose.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Diagnose[]>(null as any);
    }

    diagnose_Get(id: string | null): Promise<Diagnose> {
        let url_ = this.baseUrl + "/api/Diagnose/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDiagnose_Get(_response);
        });
    }

    protected processDiagnose_Get(response: Response): Promise<Diagnose> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Diagnose.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Diagnose>(null as any);
    }

    diagnose_Sync(lastSyncDate: Date | undefined): Promise<SyncDataDiagnose> {
        let url_ = this.baseUrl + "/api/Diagnose/Sync?";
        if (lastSyncDate === null)
            throw new Error("The parameter 'lastSyncDate' cannot be null.");
        else if (lastSyncDate !== undefined)
            url_ += "lastSyncDate=" + encodeURIComponent(lastSyncDate ? "" + lastSyncDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDiagnose_Sync(_response);
        });
    }

    protected processDiagnose_Sync(response: Response): Promise<SyncDataDiagnose> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SyncDataDiagnose.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncDataDiagnose>(null as any);
    }

    distriwinFeedComponent_UpsertComponentsFromEventProcessor(components: FeedComponentModel[]): Promise<void> {
        let url_ = this.baseUrl + "/api/DistriwinFeedComponent/UpsertComponentsFromEventProcessor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(components);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDistriwinFeedComponent_UpsertComponentsFromEventProcessor(_response);
        });
    }

    protected processDistriwinFeedComponent_UpsertComponentsFromEventProcessor(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    distriwinFeedComponent_GetByLocationCode(siteId: string | null | undefined, code: string | null | undefined, lastSyncDate: Date | undefined): Promise<DistriwinFeedComponent[]> {
        let url_ = this.baseUrl + "/api/DistriwinFeedComponent/GetByLocationCode?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (lastSyncDate === null)
            throw new Error("The parameter 'lastSyncDate' cannot be null.");
        else if (lastSyncDate !== undefined)
            url_ += "lastSyncDate=" + encodeURIComponent(lastSyncDate ? "" + lastSyncDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDistriwinFeedComponent_GetByLocationCode(_response);
        });
    }

    protected processDistriwinFeedComponent_GetByLocationCode(response: Response): Promise<DistriwinFeedComponent[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DistriwinFeedComponent.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DistriwinFeedComponent[]>(null as any);
    }

    distriwinFeedComponent_GetBySiteId(siteId: string | null | undefined): Promise<DistriwinFeedComponent[]> {
        let url_ = this.baseUrl + "/api/DistriwinFeedComponent/GetBySiteId?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDistriwinFeedComponent_GetBySiteId(_response);
        });
    }

    protected processDistriwinFeedComponent_GetBySiteId(response: Response): Promise<DistriwinFeedComponent[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DistriwinFeedComponent.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DistriwinFeedComponent[]>(null as any);
    }

    distriwinFeedComponent_SetFeedingToComponentRelation(keyValuePair: { [key: string]: string; }): Promise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/api/DistriwinFeedComponent/SetFeedingToComponentRelation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(keyValuePair);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDistriwinFeedComponent_SetFeedingToComponentRelation(_response);
        });
    }

    protected processDistriwinFeedComponent_SetFeedingToComponentRelation(response: Response): Promise<{ [key: string]: string; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: string; }>(null as any);
    }

    distriwinFeedComponent_FetchComponents(siteId: string | null | undefined, code: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DistriwinFeedComponent/FetchComponents?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDistriwinFeedComponent_FetchComponents(_response);
        });
    }

    protected processDistriwinFeedComponent_FetchComponents(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    distriwinFeedConsumption_UpsertFeedConsumptionsFromEventProcessor(consumptions: FeedConsumptionModel[]): Promise<void> {
        let url_ = this.baseUrl + "/api/DistriwinFeedConsumption/UpsertFeedConsumptionsFromEventProcessor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(consumptions);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDistriwinFeedConsumption_UpsertFeedConsumptionsFromEventProcessor(_response);
        });
    }

    protected processDistriwinFeedConsumption_UpsertFeedConsumptionsFromEventProcessor(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    distriwinFeedConsumption_GetUsageByDate(fromDate: Date | undefined, toDate: Date | undefined, siteId: string | null | undefined): Promise<DistriwinFeedConsumptionDto[]> {
        let url_ = this.baseUrl + "/api/DistriwinFeedConsumption/GetUsageByDate?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDistriwinFeedConsumption_GetUsageByDate(_response);
        });
    }

    protected processDistriwinFeedConsumption_GetUsageByDate(response: Response): Promise<DistriwinFeedConsumptionDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DistriwinFeedConsumptionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DistriwinFeedConsumptionDto[]>(null as any);
    }

    distriwinFeedConsumption_Sync(siteId: string | null | undefined, lastSyncDate: Date | undefined): Promise<SyncDataDistriwinFeedConsumption> {
        let url_ = this.baseUrl + "/api/DistriwinFeedConsumption/Sync?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (lastSyncDate === null)
            throw new Error("The parameter 'lastSyncDate' cannot be null.");
        else if (lastSyncDate !== undefined)
            url_ += "lastSyncDate=" + encodeURIComponent(lastSyncDate ? "" + lastSyncDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDistriwinFeedConsumption_Sync(_response);
        });
    }

    protected processDistriwinFeedConsumption_Sync(response: Response): Promise<SyncDataDistriwinFeedConsumption> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SyncDataDistriwinFeedConsumption.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncDataDistriwinFeedConsumption>(null as any);
    }

    distriwinFeedRegistration_UpsertFeedRegistrationFromEventProcessor(feedRegistration: FeedRegistrationModel[]): Promise<void> {
        let url_ = this.baseUrl + "/api/DistriwinFeedRegistration/UpsertFeedRegistrationFromEventProcessor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(feedRegistration);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDistriwinFeedRegistration_UpsertFeedRegistrationFromEventProcessor(_response);
        });
    }

    protected processDistriwinFeedRegistration_UpsertFeedRegistrationFromEventProcessor(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    distriwinFeedRegistration_UpdateInformationFromValveGroups(valveGroupInfos: ValveInfoDTO[]): Promise<void> {
        let url_ = this.baseUrl + "/api/DistriwinFeedRegistration/UpdateInformationFromValveGroups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(valveGroupInfos);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDistriwinFeedRegistration_UpdateInformationFromValveGroups(_response);
        });
    }

    protected processDistriwinFeedRegistration_UpdateInformationFromValveGroups(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    distriwinFeedRegistration_GetBySiteId(siteId: string | null | undefined, fromDate: Date | undefined, toDate: Date | undefined): Promise<DistriwinFeedRegistration[]> {
        let url_ = this.baseUrl + "/api/DistriwinFeedRegistration/GetBySiteId?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDistriwinFeedRegistration_GetBySiteId(_response);
        });
    }

    protected processDistriwinFeedRegistration_GetBySiteId(response: Response): Promise<DistriwinFeedRegistration[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DistriwinFeedRegistration.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DistriwinFeedRegistration[]>(null as any);
    }

    distriwinOption_Post(option: DistriwinOption): Promise<void> {
        let url_ = this.baseUrl + "/api/DistriwinOption";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(option);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDistriwinOption_Post(_response);
        });
    }

    protected processDistriwinOption_Post(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    distriwinOption_Sync(siteId: string | null | undefined, lastSyncDate: Date | undefined): Promise<SyncDistriwinOption> {
        let url_ = this.baseUrl + "/api/DistriwinOption/Sync?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (lastSyncDate === null)
            throw new Error("The parameter 'lastSyncDate' cannot be null.");
        else if (lastSyncDate !== undefined)
            url_ += "lastSyncDate=" + encodeURIComponent(lastSyncDate ? "" + lastSyncDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDistriwinOption_Sync(_response);
        });
    }

    protected processDistriwinOption_Sync(response: Response): Promise<SyncDistriwinOption> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SyncDistriwinOption.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncDistriwinOption>(null as any);
    }

    distriwinTaskAlert_Get(location: string | null | undefined, controllerNumber: number | undefined, taskNumber: number | undefined): Promise<DistriwinTaskAlert> {
        let url_ = this.baseUrl + "/api/DistriwinTaskAlert?";
        if (location !== undefined && location !== null)
            url_ += "location=" + encodeURIComponent("" + location) + "&";
        if (controllerNumber === null)
            throw new Error("The parameter 'controllerNumber' cannot be null.");
        else if (controllerNumber !== undefined)
            url_ += "controllerNumber=" + encodeURIComponent("" + controllerNumber) + "&";
        if (taskNumber === null)
            throw new Error("The parameter 'taskNumber' cannot be null.");
        else if (taskNumber !== undefined)
            url_ += "taskNumber=" + encodeURIComponent("" + taskNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDistriwinTaskAlert_Get(_response);
        });
    }

    protected processDistriwinTaskAlert_Get(response: Response): Promise<DistriwinTaskAlert> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DistriwinTaskAlert.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DistriwinTaskAlert>(null as any);
    }

    distriwinTaskAlert_Post(distriwinTaskAlert: DistriwinTaskAlert): Promise<void> {
        let url_ = this.baseUrl + "/api/DistriwinTaskAlert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(distriwinTaskAlert);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDistriwinTaskAlert_Post(_response);
        });
    }

    protected processDistriwinTaskAlert_Post(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    distriwinTask_GetBySiteId(siteId: string | null | undefined): Promise<DistriwinTask[]> {
        let url_ = this.baseUrl + "/api/DistriwinTask?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDistriwinTask_GetBySiteId(_response);
        });
    }

    protected processDistriwinTask_GetBySiteId(response: Response): Promise<DistriwinTask[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DistriwinTask.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DistriwinTask[]>(null as any);
    }

    distriwinTask_Post(distriwinTaskModel: DistriwinTaskModel): Promise<void> {
        let url_ = this.baseUrl + "/api/DistriwinTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(distriwinTaskModel);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDistriwinTask_Post(_response);
        });
    }

    protected processDistriwinTask_Post(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    drug_GetBySiteId(siteId: string | null | undefined, startDate: Date | undefined, endDate: Date | undefined): Promise<Drug[]> {
        let url_ = this.baseUrl + "/api/Drug/GetBySiteId?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDrug_GetBySiteId(_response);
        });
    }

    protected processDrug_GetBySiteId(response: Response): Promise<Drug[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Drug.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Drug[]>(null as any);
    }

    drug_GetDrugsWithAdjustmentsBySiteId(siteId: string | null | undefined, startDate: Date | undefined, endDate: Date | undefined): Promise<DrugWithAdjustment[]> {
        let url_ = this.baseUrl + "/api/Drug/GetDrugsWithAdjustmentsBySiteIdAsync?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDrug_GetDrugsWithAdjustmentsBySiteId(_response);
        });
    }

    protected processDrug_GetDrugsWithAdjustmentsBySiteId(response: Response): Promise<DrugWithAdjustment[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DrugWithAdjustment.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DrugWithAdjustment[]>(null as any);
    }

    drug_DeleteAdjustment(drugWithAdjustment: DrugAdjustmentDeleteInformation): Promise<string> {
        let url_ = this.baseUrl + "/api/Drug/deleteAdjustment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(drugWithAdjustment);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDrug_DeleteAdjustment(_response);
        });
    }

    protected processDrug_DeleteAdjustment(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    drug_Put(drugCreate: DrugCreate): Promise<string> {
        let url_ = this.baseUrl + "/api/Drug";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(drugCreate);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDrug_Put(_response);
        });
    }

    protected processDrug_Put(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    drug_Delete(id: string | null): Promise<void> {
        let url_ = this.baseUrl + "/api/Drug/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDrug_Delete(_response);
        });
    }

    protected processDrug_Delete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    drug_ArchiveDrug(drug: Drug): Promise<Drug> {
        let url_ = this.baseUrl + "/api/Drug/ArchiveDrug";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(drug);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDrug_ArchiveDrug(_response);
        });
    }

    protected processDrug_ArchiveDrug(response: Response): Promise<Drug> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Drug.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Drug>(null as any);
    }

    drug_DeArchiveDrug(drug: Drug): Promise<Drug> {
        let url_ = this.baseUrl + "/api/Drug/DeArchiveDrug";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(drug);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDrug_DeArchiveDrug(_response);
        });
    }

    protected processDrug_DeArchiveDrug(response: Response): Promise<Drug> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Drug.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Drug>(null as any);
    }

    drugType_Post(drugType: DrugType): Promise<string> {
        let url_ = this.baseUrl + "/api/DrugType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(drugType);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDrugType_Post(_response);
        });
    }

    protected processDrugType_Post(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    drugType_Get(): Promise<DrugType[]> {
        let url_ = this.baseUrl + "/api/DrugType";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDrugType_Get(_response);
        });
    }

    protected processDrugType_Get(response: Response): Promise<DrugType[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DrugType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DrugType[]>(null as any);
    }

    drugType_Sync(lastSyncDate: Date | undefined): Promise<SyncDataDrugType> {
        let url_ = this.baseUrl + "/api/DrugType/Sync?";
        if (lastSyncDate === null)
            throw new Error("The parameter 'lastSyncDate' cannot be null.");
        else if (lastSyncDate !== undefined)
            url_ += "lastSyncDate=" + encodeURIComponent(lastSyncDate ? "" + lastSyncDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDrugType_Sync(_response);
        });
    }

    protected processDrugType_Sync(response: Response): Promise<SyncDataDrugType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SyncDataDrugType.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncDataDrugType>(null as any);
    }

    elistarCommunication_HandleAutoRegistrations(autoRegistrations: AutoRegistration[]): Promise<void> {
        let url_ = this.baseUrl + "/api/ElistarCommunication/HandleAutoRegistrations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(autoRegistrations);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processElistarCommunication_HandleAutoRegistrations(_response);
        });
    }

    protected processElistarCommunication_HandleAutoRegistrations(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    elistarCommunication_HandleUnknownAnimals(unknownAnimals: ElistarEsfAnimalInformation[]): Promise<void> {
        let url_ = this.baseUrl + "/api/ElistarCommunication/HandleUnknownAnimals";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(unknownAnimals);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processElistarCommunication_HandleUnknownAnimals(_response);
        });
    }

    protected processElistarCommunication_HandleUnknownAnimals(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    esfDailyStatus_UpsertEsfDailyStatus(esfDailyStatus: EsfDailyStatus): Promise<string> {
        let url_ = this.baseUrl + "/api/EsfDailyStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(esfDailyStatus);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEsfDailyStatus_UpsertEsfDailyStatus(_response);
        });
    }

    protected processEsfDailyStatus_UpsertEsfDailyStatus(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    esfDailyStatus_Sync(siteId: string | null | undefined, lastSyncDate: Date | undefined, dateYesterday: Date | undefined): Promise<SyncEsfDailyStatus> {
        let url_ = this.baseUrl + "/api/EsfDailyStatus/Sync?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (lastSyncDate === null)
            throw new Error("The parameter 'lastSyncDate' cannot be null.");
        else if (lastSyncDate !== undefined)
            url_ += "lastSyncDate=" + encodeURIComponent(lastSyncDate ? "" + lastSyncDate.toISOString() : "") + "&";
        if (dateYesterday === null)
            throw new Error("The parameter 'dateYesterday' cannot be null.");
        else if (dateYesterday !== undefined)
            url_ += "dateYesterday=" + encodeURIComponent(dateYesterday ? "" + dateYesterday.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEsfDailyStatus_Sync(_response);
        });
    }

    protected processEsfDailyStatus_Sync(response: Response): Promise<SyncEsfDailyStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SyncEsfDailyStatus.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncEsfDailyStatus>(null as any);
    }

    esfFeedCurve_Sync(siteId: string | null | undefined, lastSyncDate: Date | undefined): Promise<SyncEsfFeedCurve> {
        let url_ = this.baseUrl + "/api/EsfFeedCurve/Sync?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (lastSyncDate === null)
            throw new Error("The parameter 'lastSyncDate' cannot be null.");
        else if (lastSyncDate !== undefined)
            url_ += "lastSyncDate=" + encodeURIComponent(lastSyncDate ? "" + lastSyncDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEsfFeedCurve_Sync(_response);
        });
    }

    protected processEsfFeedCurve_Sync(response: Response): Promise<SyncEsfFeedCurve> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SyncEsfFeedCurve.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncEsfFeedCurve>(null as any);
    }

    esfFeedingStatus_UpdateFeeding(update: FeedingStatusUpdate): Promise<void> {
        let url_ = this.baseUrl + "/api/EsfFeedingStatus/UpdateFeeding";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(update);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEsfFeedingStatus_UpdateFeeding(_response);
        });
    }

    protected processEsfFeedingStatus_UpdateFeeding(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    esfFeedingStatus_AcknowledgeDate(acknowledge: EsfStatusAcknowledge): Promise<void> {
        let url_ = this.baseUrl + "/api/EsfFeedingStatus/AcknowledgeDate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(acknowledge);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEsfFeedingStatus_AcknowledgeDate(_response);
        });
    }

    protected processEsfFeedingStatus_AcknowledgeDate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    esfFeedingStatus_Sync(siteId: string | null | undefined, lastSyncDate: Date | undefined): Promise<SyncEsfFeedingStatus> {
        let url_ = this.baseUrl + "/api/EsfFeedingStatus/Sync?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (lastSyncDate === null)
            throw new Error("The parameter 'lastSyncDate' cannot be null.");
        else if (lastSyncDate !== undefined)
            url_ += "lastSyncDate=" + encodeURIComponent(lastSyncDate ? "" + lastSyncDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEsfFeedingStatus_Sync(_response);
        });
    }

    protected processEsfFeedingStatus_Sync(response: Response): Promise<SyncEsfFeedingStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SyncEsfFeedingStatus.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncEsfFeedingStatus>(null as any);
    }

    esfStation_RequestNewStations(siteId: string, code: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/EsfStation/RequestNewStations?";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(siteId);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEsfStation_RequestNewStations(_response);
        });
    }

    protected processEsfStation_RequestNewStations(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    esfStatus_UpsertFeedingStatus(feedingStatus: EsfFeedingStatusDto[]): Promise<void> {
        let url_ = this.baseUrl + "/api/EsfStatus/UpsertFeedingStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(feedingStatus);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEsfStatus_UpsertFeedingStatus(_response);
        });
    }

    protected processEsfStatus_UpsertFeedingStatus(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    esfStatus_InsertDailyStatus(dailyStatus: EsfDailyStatusDto[]): Promise<void> {
        let url_ = this.baseUrl + "/api/EsfStatus/InsertDailyStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dailyStatus);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEsfStatus_InsertDailyStatus(_response);
        });
    }

    protected processEsfStatus_InsertDailyStatus(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    esfStatus_UpdateStations(stations: EsfStation[]): Promise<void> {
        let url_ = this.baseUrl + "/api/EsfStatus/UpdateStations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(stations);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEsfStatus_UpdateStations(_response);
        });
    }

    protected processEsfStatus_UpdateStations(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    esfStatus_UpdateFeedCurves(feedCurves: FeedCurveStatusDto[]): Promise<void> {
        let url_ = this.baseUrl + "/api/EsfStatus/UpdateFeedCurves";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(feedCurves);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEsfStatus_UpdateFeedCurves(_response);
        });
    }

    protected processEsfStatus_UpdateFeedCurves(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    featureFlags_Get(): Promise<FeatureFlagsOptions> {
        let url_ = this.baseUrl + "/api/FeatureFlags";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFeatureFlags_Get(_response);
        });
    }

    protected processFeatureFlags_Get(response: Response): Promise<FeatureFlagsOptions> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FeatureFlagsOptions.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FeatureFlagsOptions>(null as any);
    }

    feedingCategories_Post(category: FeedingCategory): Promise<string> {
        let url_ = this.baseUrl + "/api/FeedingCategories";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(category);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFeedingCategories_Post(_response);
        });
    }

    protected processFeedingCategories_Post(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    feedingCategories_Put(category: FeedingCategory): Promise<string> {
        let url_ = this.baseUrl + "/api/FeedingCategories";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(category);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFeedingCategories_Put(_response);
        });
    }

    protected processFeedingCategories_Put(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    feedingCategories_GetAll(types: AnimalType[] | null | undefined): Promise<FeedingCategory[]> {
        let url_ = this.baseUrl + "/api/FeedingCategories?";
        if (types !== undefined && types !== null)
            types && types.forEach(item => { url_ += "types=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFeedingCategories_GetAll(_response);
        });
    }

    protected processFeedingCategories_GetAll(response: Response): Promise<FeedingCategory[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FeedingCategory.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FeedingCategory[]>(null as any);
    }

    feedingCategories_Get(id: string | null): Promise<FeedingCategory> {
        let url_ = this.baseUrl + "/api/FeedingCategories/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFeedingCategories_Get(_response);
        });
    }

    protected processFeedingCategories_Get(response: Response): Promise<FeedingCategory> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FeedingCategory.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FeedingCategory>(null as any);
    }

    feeding_GetBySiteIdV2(siteId: string | null | undefined, types: AnimalType[] | null | undefined): Promise<Feeding[]> {
        let url_ = this.baseUrl + "/api/Feeding/GetBySiteIdV2?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (types !== undefined && types !== null)
            types && types.forEach(item => { url_ += "types=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFeeding_GetBySiteIdV2(_response);
        });
    }

    protected processFeeding_GetBySiteIdV2(response: Response): Promise<Feeding[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Feeding.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Feeding[]>(null as any);
    }

    feeding_PutV2(feeding: Feeding): Promise<Feeding> {
        let url_ = this.baseUrl + "/api/Feeding/PutV2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(feeding);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFeeding_PutV2(_response);
        });
    }

    protected processFeeding_PutV2(response: Response): Promise<Feeding> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Feeding.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Feeding>(null as any);
    }

    feeding_GetBySiteId(siteId: string | null | undefined, types: AnimalType[] | null | undefined): Promise<Feeding[]> {
        let url_ = this.baseUrl + "/api/Feeding/GetBySiteId?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (types !== undefined && types !== null)
            types && types.forEach(item => { url_ += "types=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFeeding_GetBySiteId(_response);
        });
    }

    protected processFeeding_GetBySiteId(response: Response): Promise<Feeding[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Feeding.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Feeding[]>(null as any);
    }

    feeding_Put(feeding: Feeding): Promise<Feeding> {
        let url_ = this.baseUrl + "/api/Feeding";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(feeding);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFeeding_Put(_response);
        });
    }

    protected processFeeding_Put(response: Response): Promise<Feeding> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Feeding.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Feeding>(null as any);
    }

    feedingReport_GetFeedingReport(date: Date | undefined, buildingId: string | null | undefined, sectionIds: string[] | null | undefined, siteId: string | null | undefined, timeZoneId: string | null | undefined): Promise<FeedingReportTable> {
        let url_ = this.baseUrl + "/api/FeedingReport/GetFeedingReport?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (buildingId !== undefined && buildingId !== null)
            url_ += "buildingId=" + encodeURIComponent("" + buildingId) + "&";
        if (sectionIds !== undefined && sectionIds !== null)
            sectionIds && sectionIds.forEach(item => { url_ += "sectionIds=" + encodeURIComponent("" + item) + "&"; });
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (timeZoneId !== undefined && timeZoneId !== null)
            url_ += "timeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFeedingReport_GetFeedingReport(_response);
        });
    }

    protected processFeedingReport_GetFeedingReport(response: Response): Promise<FeedingReportTable> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FeedingReportTable.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FeedingReportTable>(null as any);
    }

    feedingReport_GetFeedingReportPdf(tableItems: FeedingReportTable, siteId: string | null | undefined, timeZoneId: string | null | undefined, lang: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/FeedingReport/GetFeedingReportPdf?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (timeZoneId !== undefined && timeZoneId !== null)
            url_ += "timeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tableItems);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFeedingReport_GetFeedingReportPdf(_response);
        });
    }

    protected processFeedingReport_GetFeedingReportPdf(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    feedingSubject_Post(feedingSubject: FeedingSubject): Promise<string> {
        let url_ = this.baseUrl + "/api/FeedingSubject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(feedingSubject);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFeedingSubject_Post(_response);
        });
    }

    protected processFeedingSubject_Post(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    feedingSubject_Put(feedingSubject: FeedingSubject): Promise<string> {
        let url_ = this.baseUrl + "/api/FeedingSubject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(feedingSubject);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFeedingSubject_Put(_response);
        });
    }

    protected processFeedingSubject_Put(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    feedingSubject_UpsertMany(feedingSubject: FeedingSubject): Promise<string> {
        let url_ = this.baseUrl + "/api/FeedingSubject/UpsertMany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(feedingSubject);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFeedingSubject_UpsertMany(_response);
        });
    }

    protected processFeedingSubject_UpsertMany(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    feedingSubject_Get(siteId: string | null | undefined): Promise<FeedingSubject[]> {
        let url_ = this.baseUrl + "/api/FeedingSubject/GetFeedingSubjectsBySiteId?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFeedingSubject_Get(_response);
        });
    }

    protected processFeedingSubject_Get(response: Response): Promise<FeedingSubject[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FeedingSubject.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FeedingSubject[]>(null as any);
    }

    feedUsage_GetByBuildingForApp(buildingId: string | null | undefined, locationTypes: LocationType[] | null | undefined): Promise<SectionFeedUsageDTO[]> {
        let url_ = this.baseUrl + "/api/FeedUsage/GetByBuildingForApp?";
        if (buildingId !== undefined && buildingId !== null)
            url_ += "buildingId=" + encodeURIComponent("" + buildingId) + "&";
        if (locationTypes !== undefined && locationTypes !== null)
            locationTypes && locationTypes.forEach(item => { url_ += "locationTypes=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFeedUsage_GetByBuildingForApp(_response);
        });
    }

    protected processFeedUsage_GetByBuildingForApp(response: Response): Promise<SectionFeedUsageDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SectionFeedUsageDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SectionFeedUsageDTO[]>(null as any);
    }

    feedUsage_GetBySectionForWeanerGraph(siteId: string | null | undefined, sectionId: string | null | undefined, fromDate: Date | undefined, toDate: Date | undefined): Promise<SectionWeanerGraphDTO> {
        let url_ = this.baseUrl + "/api/FeedUsage/GetBySectionForWeanerGraph?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (sectionId !== undefined && sectionId !== null)
            url_ += "sectionId=" + encodeURIComponent("" + sectionId) + "&";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFeedUsage_GetBySectionForWeanerGraph(_response);
        });
    }

    protected processFeedUsage_GetBySectionForWeanerGraph(response: Response): Promise<SectionWeanerGraphDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SectionWeanerGraphDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SectionWeanerGraphDTO>(null as any);
    }

    feedUsage_GetBySection(siteId: string | null | undefined, sectionId: string | null | undefined): Promise<PenFeedUsageDTO[]> {
        let url_ = this.baseUrl + "/api/FeedUsage/GetBySection?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (sectionId !== undefined && sectionId !== null)
            url_ += "sectionId=" + encodeURIComponent("" + sectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFeedUsage_GetBySection(_response);
        });
    }

    protected processFeedUsage_GetBySection(response: Response): Promise<PenFeedUsageDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PenFeedUsageDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PenFeedUsageDTO[]>(null as any);
    }

    feedUsage_GetByPenForGraph(siteId: string | null | undefined, penId: string | null | undefined, fromDate: Date | undefined, toDate: Date | undefined): Promise<PenGraphDTO> {
        let url_ = this.baseUrl + "/api/FeedUsage/GetByPenForGraph?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (penId !== undefined && penId !== null)
            url_ += "penId=" + encodeURIComponent("" + penId) + "&";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFeedUsage_GetByPenForGraph(_response);
        });
    }

    protected processFeedUsage_GetByPenForGraph(response: Response): Promise<PenGraphDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PenGraphDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PenGraphDTO>(null as any);
    }

    generalSettings_Upsert(generalSettings: GeneralSettings): Promise<string> {
        let url_ = this.baseUrl + "/api/GeneralSettings/Upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(generalSettings);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGeneralSettings_Upsert(_response);
        });
    }

    protected processGeneralSettings_Upsert(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    generalSettings_Sync(siteId: string | null | undefined, lastSyncDate: Date | undefined): Promise<SyncGeneralSettings> {
        let url_ = this.baseUrl + "/api/GeneralSettings/Sync?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (lastSyncDate === null)
            throw new Error("The parameter 'lastSyncDate' cannot be null.");
        else if (lastSyncDate !== undefined)
            url_ += "lastSyncDate=" + encodeURIComponent(lastSyncDate ? "" + lastSyncDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGeneralSettings_Sync(_response);
        });
    }

    protected processGeneralSettings_Sync(response: Response): Promise<SyncGeneralSettings> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SyncGeneralSettings.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncGeneralSettings>(null as any);
    }

    generateSowBoardPdf_Get(tableModels: SowBoardTableModel[], siteId: string | null | undefined, lang: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/GenerateSowBoardPdf?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tableModels);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGenerateSowBoardPdf_Get(_response);
        });
    }

    protected processGenerateSowBoardPdf_Get(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    growthPigsDashboardEvent_GenerateDashboardTableData(animalType: string | null | undefined, siteId: string | null | undefined): Promise<GrowthPigsDashboardDto[]> {
        let url_ = this.baseUrl + "/api/GrowthPigsDashboardEvent/generateGrowthPigsDashboardTableData?";
        if (animalType !== undefined && animalType !== null)
            url_ += "animalType=" + encodeURIComponent("" + animalType) + "&";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGrowthPigsDashboardEvent_GenerateDashboardTableData(_response);
        });
    }

    protected processGrowthPigsDashboardEvent_GenerateDashboardTableData(response: Response): Promise<GrowthPigsDashboardDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GrowthPigsDashboardDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GrowthPigsDashboardDto[]>(null as any);
    }

    growthPigsDashboardEvent_GrowthPigDashboardPrintPdf(data: DashboardEntranceDepartureTableItem, siteId: string | null | undefined, lang: string | null | undefined, timeZoneId: string | null | undefined, location: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/GrowthPigsDashboardEvent/GrowthPigDashboardPrintPdf?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        if (timeZoneId !== undefined && timeZoneId !== null)
            url_ += "timeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        if (location !== undefined && location !== null)
            url_ += "location=" + encodeURIComponent("" + location) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGrowthPigsDashboardEvent_GrowthPigDashboardPrintPdf(_response);
        });
    }

    protected processGrowthPigsDashboardEvent_GrowthPigDashboardPrintPdf(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    growthPigsEvent_PostGrowthPigEntranceEventDto(growthPigEntranceEventDto: GrowthPigEntranceEventDto[]): Promise<GrowthPigEventDto> {
        let url_ = this.baseUrl + "/api/GrowthPigsEvent/GrowthPigEntranceEventDto";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(growthPigEntranceEventDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGrowthPigsEvent_PostGrowthPigEntranceEventDto(_response);
        });
    }

    protected processGrowthPigsEvent_PostGrowthPigEntranceEventDto(response: Response): Promise<GrowthPigEventDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GrowthPigEventDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GrowthPigEventDto>(null as any);
    }

    growthPigsEvent_PostGrowthPigPigletMoveEventDto(growthPigEntranceEventDto: GrowthPigMoveEventDto[]): Promise<UpdateGrowthPigEventDto> {
        let url_ = this.baseUrl + "/api/GrowthPigsEvent/GrowthPigPigletMoveEventDto";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(growthPigEntranceEventDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGrowthPigsEvent_PostGrowthPigPigletMoveEventDto(_response);
        });
    }

    protected processGrowthPigsEvent_PostGrowthPigPigletMoveEventDto(response: Response): Promise<UpdateGrowthPigEventDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateGrowthPigEventDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateGrowthPigEventDto>(null as any);
    }

    growthPigsEvent_GrowthPigPigletMoveEventDtoAndUpdateEvents(growthPigPigletMoveEventDtoAndUpdateEvents: GrowthPigPigletMoveEventDtoAndUpdateEvents): Promise<UpdateGrowthPigEventDto> {
        let url_ = this.baseUrl + "/api/GrowthPigsEvent/GrowthPigPigletMoveEventDtoAndUpdateEvents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(growthPigPigletMoveEventDtoAndUpdateEvents);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGrowthPigsEvent_GrowthPigPigletMoveEventDtoAndUpdateEvents(_response);
        });
    }

    protected processGrowthPigsEvent_GrowthPigPigletMoveEventDtoAndUpdateEvents(response: Response): Promise<UpdateGrowthPigEventDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateGrowthPigEventDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateGrowthPigEventDto>(null as any);
    }

    growthPigsEvent_PostGrowthPigMoveEventDto(growthPigMoveEventDto: GrowthPigMoveEventDto[]): Promise<UpdateGrowthPigEventDto> {
        let url_ = this.baseUrl + "/api/GrowthPigsEvent/GrowthPigMoveEventDto";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(growthPigMoveEventDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGrowthPigsEvent_PostGrowthPigMoveEventDto(_response);
        });
    }

    protected processGrowthPigsEvent_PostGrowthPigMoveEventDto(response: Response): Promise<UpdateGrowthPigEventDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateGrowthPigEventDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateGrowthPigEventDto>(null as any);
    }

    growthPigsEvent_PostGrowthPigDepartureEventDto(growthPigDepartureEventDto: GrowthPigDepartureEventDto[]): Promise<GrowthPigEventDto> {
        let url_ = this.baseUrl + "/api/GrowthPigsEvent/GrowthPigDepartureEventDto";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(growthPigDepartureEventDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGrowthPigsEvent_PostGrowthPigDepartureEventDto(_response);
        });
    }

    protected processGrowthPigsEvent_PostGrowthPigDepartureEventDto(response: Response): Promise<GrowthPigEventDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GrowthPigEventDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GrowthPigEventDto>(null as any);
    }

    growthPigsEvent_PostGrowthPigPenDepartureEventDto(growthPigDepartureEventDto: GrowthPigDepartureFromPenEventDto[]): Promise<GrowthPigEventDto> {
        let url_ = this.baseUrl + "/api/GrowthPigsEvent/GrowthPigDepartureFromPenEventDto";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(growthPigDepartureEventDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGrowthPigsEvent_PostGrowthPigPenDepartureEventDto(_response);
        });
    }

    protected processGrowthPigsEvent_PostGrowthPigPenDepartureEventDto(response: Response): Promise<GrowthPigEventDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GrowthPigEventDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GrowthPigEventDto>(null as any);
    }

    growthPigsEvent_GetBySiteIdV4(siteId: string | null | undefined, lastSyncTime: Date | undefined, dailyLastSync: Date | undefined): Promise<SyncGrowthPigEvents> {
        let url_ = this.baseUrl + "/api/GrowthPigsEvent/GetBySiteIdV4?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (lastSyncTime === null)
            throw new Error("The parameter 'lastSyncTime' cannot be null.");
        else if (lastSyncTime !== undefined)
            url_ += "lastSyncTime=" + encodeURIComponent(lastSyncTime ? "" + lastSyncTime.toISOString() : "") + "&";
        if (dailyLastSync === null)
            throw new Error("The parameter 'dailyLastSync' cannot be null.");
        else if (dailyLastSync !== undefined)
            url_ += "dailyLastSync=" + encodeURIComponent(dailyLastSync ? "" + dailyLastSync.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGrowthPigsEvent_GetBySiteIdV4(_response);
        });
    }

    protected processGrowthPigsEvent_GetBySiteIdV4(response: Response): Promise<SyncGrowthPigEvents> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SyncGrowthPigEvents.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncGrowthPigEvents>(null as any);
    }

    growthPigsEvent_GetBySiteIdV5(siteId: string | null | undefined, lastSyncTime: Date | undefined, dailyLastSync: Date | undefined): Promise<SyncGrowthPigEvents> {
        let url_ = this.baseUrl + "/api/GrowthPigsEvent/GetBySiteIdV5?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (lastSyncTime === null)
            throw new Error("The parameter 'lastSyncTime' cannot be null.");
        else if (lastSyncTime !== undefined)
            url_ += "lastSyncTime=" + encodeURIComponent(lastSyncTime ? "" + lastSyncTime.toISOString() : "") + "&";
        if (dailyLastSync === null)
            throw new Error("The parameter 'dailyLastSync' cannot be null.");
        else if (dailyLastSync !== undefined)
            url_ += "dailyLastSync=" + encodeURIComponent(dailyLastSync ? "" + dailyLastSync.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGrowthPigsEvent_GetBySiteIdV5(_response);
        });
    }

    protected processGrowthPigsEvent_GetBySiteIdV5(response: Response): Promise<SyncGrowthPigEvents> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SyncGrowthPigEvents.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncGrowthPigEvents>(null as any);
    }

    growthPigsEvent_GetBySiteIdV3(siteId: string | null | undefined, lastSyncTime: Date | undefined, dailyLastSync: Date | undefined): Promise<SyncGrowthPigEvents> {
        let url_ = this.baseUrl + "/api/GrowthPigsEvent/GetBySiteIdV3?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (lastSyncTime === null)
            throw new Error("The parameter 'lastSyncTime' cannot be null.");
        else if (lastSyncTime !== undefined)
            url_ += "lastSyncTime=" + encodeURIComponent(lastSyncTime ? "" + lastSyncTime.toISOString() : "") + "&";
        if (dailyLastSync === null)
            throw new Error("The parameter 'dailyLastSync' cannot be null.");
        else if (dailyLastSync !== undefined)
            url_ += "dailyLastSync=" + encodeURIComponent(dailyLastSync ? "" + dailyLastSync.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGrowthPigsEvent_GetBySiteIdV3(_response);
        });
    }

    protected processGrowthPigsEvent_GetBySiteIdV3(response: Response): Promise<SyncGrowthPigEvents> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SyncGrowthPigEvents.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncGrowthPigEvents>(null as any);
    }

    growthPigsEvent_GetBySiteId(siteId: string | null | undefined, lastSyncTime: Date | undefined, dailyLastSync: Date | undefined): Promise<SyncGrowthPigEvents> {
        let url_ = this.baseUrl + "/api/GrowthPigsEvent/GetBySiteIdV2?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (lastSyncTime === null)
            throw new Error("The parameter 'lastSyncTime' cannot be null.");
        else if (lastSyncTime !== undefined)
            url_ += "lastSyncTime=" + encodeURIComponent(lastSyncTime ? "" + lastSyncTime.toISOString() : "") + "&";
        if (dailyLastSync === null)
            throw new Error("The parameter 'dailyLastSync' cannot be null.");
        else if (dailyLastSync !== undefined)
            url_ += "dailyLastSync=" + encodeURIComponent(dailyLastSync ? "" + dailyLastSync.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGrowthPigsEvent_GetBySiteId(_response);
        });
    }

    protected processGrowthPigsEvent_GetBySiteId(response: Response): Promise<SyncGrowthPigEvents> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SyncGrowthPigEvents.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncGrowthPigEvents>(null as any);
    }

    growthPigsEvent_GetBySiteId2(siteId: string | null | undefined, lastSyncTime: Date | undefined): Promise<SyncGrowthPigEvents> {
        let url_ = this.baseUrl + "/api/GrowthPigsEvent?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (lastSyncTime === null)
            throw new Error("The parameter 'lastSyncTime' cannot be null.");
        else if (lastSyncTime !== undefined)
            url_ += "lastSyncTime=" + encodeURIComponent(lastSyncTime ? "" + lastSyncTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGrowthPigsEvent_GetBySiteId2(_response);
        });
    }

    protected processGrowthPigsEvent_GetBySiteId2(response: Response): Promise<SyncGrowthPigEvents> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SyncGrowthPigEvents.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncGrowthPigEvents>(null as any);
    }

    growthPigsEvent_GetByGrowthPigEntranceEventsByDates(siteId: string | null | undefined, dateFrom: Date | undefined, dateTo: Date | undefined): Promise<GrowthPigsEvent[]> {
        let url_ = this.baseUrl + "/api/GrowthPigsEvent/GetByGrowthPigEntranceEventsByDates?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGrowthPigsEvent_GetByGrowthPigEntranceEventsByDates(_response);
        });
    }

    protected processGrowthPigsEvent_GetByGrowthPigEntranceEventsByDates(response: Response): Promise<GrowthPigsEvent[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GrowthPigsEvent.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GrowthPigsEvent[]>(null as any);
    }

    growthPigsEvent_GetByGrowthPigMoveEventsByDates(siteId: string | null | undefined, dateFrom: Date | undefined, dateTo: Date | undefined): Promise<GrowthPigsEvent[]> {
        let url_ = this.baseUrl + "/api/GrowthPigsEvent/GetByGrowthPigMoveEventsByDates?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGrowthPigsEvent_GetByGrowthPigMoveEventsByDates(_response);
        });
    }

    protected processGrowthPigsEvent_GetByGrowthPigMoveEventsByDates(response: Response): Promise<GrowthPigsEvent[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GrowthPigsEvent.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GrowthPigsEvent[]>(null as any);
    }

    growthPigsEvent_GetGrowthPigDepartureEventsByDates(siteId: string | null | undefined, dateFrom: Date | undefined, dateTo: Date | undefined): Promise<GrowthPigsEvent[]> {
        let url_ = this.baseUrl + "/api/GrowthPigsEvent/GetGrowthPigDepartureEventsByDates?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGrowthPigsEvent_GetGrowthPigDepartureEventsByDates(_response);
        });
    }

    protected processGrowthPigsEvent_GetGrowthPigDepartureEventsByDates(response: Response): Promise<GrowthPigsEvent[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GrowthPigsEvent.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GrowthPigsEvent[]>(null as any);
    }

    growthPigsEvent_GetGrowthPigEventsByDates(siteId: string | null | undefined, dateFrom: Date | undefined, dateTo: Date | undefined): Promise<GrowthPigsEvent[]> {
        let url_ = this.baseUrl + "/api/GrowthPigsEvent/GetGrowthPigEventsByDates?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGrowthPigsEvent_GetGrowthPigEventsByDates(_response);
        });
    }

    protected processGrowthPigsEvent_GetGrowthPigEventsByDates(response: Response): Promise<GrowthPigsEvent[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GrowthPigsEvent.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GrowthPigsEvent[]>(null as any);
    }

    growthPigsEvent_GetGrowthPigPenStatusByDate(siteId: string | null | undefined, dateTo: Date | undefined): Promise<{ [key: string]: GrowthPigPenDashboardStatus; }> {
        let url_ = this.baseUrl + "/api/GrowthPigsEvent/GetGrowthPigPenStatusByDate?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGrowthPigsEvent_GetGrowthPigPenStatusByDate(_response);
        });
    }

    protected processGrowthPigsEvent_GetGrowthPigPenStatusByDate(response: Response): Promise<{ [key: string]: GrowthPigPenDashboardStatus; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] ? GrowthPigPenDashboardStatus.fromJS(resultData200[key]) : new GrowthPigPenDashboardStatus();
                }
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: GrowthPigPenDashboardStatus; }>(null as any);
    }

    growthPigsEvent_UpsertGrowthPigsEvent(gpe: GrowthPigsEvent): Promise<void> {
        let url_ = this.baseUrl + "/api/GrowthPigsEvent/Upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(gpe);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGrowthPigsEvent_UpsertGrowthPigsEvent(_response);
        });
    }

    protected processGrowthPigsEvent_UpsertGrowthPigsEvent(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    growthPigsEvent_GetGrowthPigEventRegulations(siteId: string | null | undefined, fromDate: Date | undefined, toDate: Date | undefined): Promise<GrowthPigsEvent[]> {
        let url_ = this.baseUrl + "/api/GrowthPigsEvent/GetGrowthPigEventRegulations?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGrowthPigsEvent_GetGrowthPigEventRegulations(_response);
        });
    }

    protected processGrowthPigsEvent_GetGrowthPigEventRegulations(response: Response): Promise<GrowthPigsEvent[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GrowthPigsEvent.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GrowthPigsEvent[]>(null as any);
    }

    growthPigsEventPdf_GetByGrowthPigMoveEventsPdfByDates(ids: string[], siteId: string | null | undefined, timeZoneId: string | null | undefined, productionType: string | null | undefined, lang: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/GrowthPigsEventPdf/GetByGrowthPigMoveEventsPdfByDates?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (timeZoneId !== undefined && timeZoneId !== null)
            url_ += "timeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        if (productionType !== undefined && productionType !== null)
            url_ += "productionType=" + encodeURIComponent("" + productionType) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGrowthPigsEventPdf_GetByGrowthPigMoveEventsPdfByDates(_response);
        });
    }

    protected processGrowthPigsEventPdf_GetByGrowthPigMoveEventsPdfByDates(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    growthPigsEventPdf_GetGrowthPigDepartureEventsPdfByDates(ids: string[], siteId: string | null | undefined, timeZoneId: string | null | undefined, productionType: string | null | undefined, lang: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/GrowthPigsEventPdf/GetGrowthPigDepartureEventsPdfByDates?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (timeZoneId !== undefined && timeZoneId !== null)
            url_ += "timeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        if (productionType !== undefined && productionType !== null)
            url_ += "productionType=" + encodeURIComponent("" + productionType) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGrowthPigsEventPdf_GetGrowthPigDepartureEventsPdfByDates(_response);
        });
    }

    protected processGrowthPigsEventPdf_GetGrowthPigDepartureEventsPdfByDates(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    growthPigsEventPdf_GetByGrowthPigEntranceEventsPdfByDates(ids: string[], siteId: string | null | undefined, timeZoneId: string | null | undefined, productionType: string | null | undefined, lang: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/GrowthPigsEventPdf/GetByGrowthPigEntranceEventsPdfByDates?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (timeZoneId !== undefined && timeZoneId !== null)
            url_ += "timeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        if (productionType !== undefined && productionType !== null)
            url_ += "productionType=" + encodeURIComponent("" + productionType) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGrowthPigsEventPdf_GetByGrowthPigEntranceEventsPdfByDates(_response);
        });
    }

    protected processGrowthPigsEventPdf_GetByGrowthPigEntranceEventsPdfByDates(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    growthPigsEventPdf_GrowthShouldDepartureList(tableItems: GrowthPigShouldDepartureTableItem[], siteId: string | null | undefined, timeZoneId: string | null | undefined, productionType: string | null | undefined, lang: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/GrowthPigsEventPdf/GrowthShouldDepartureList?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (timeZoneId !== undefined && timeZoneId !== null)
            url_ += "timeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        if (productionType !== undefined && productionType !== null)
            url_ += "productionType=" + encodeURIComponent("" + productionType) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tableItems);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGrowthPigsEventPdf_GrowthShouldDepartureList(_response);
        });
    }

    protected processGrowthPigsEventPdf_GrowthShouldDepartureList(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    growthPigsReport_GetProductionReportByGrowthPigAnimalTypes(data: GrowthPigProductionReportData): Promise<GrowthPigPReportTableDatasType> {
        let url_ = this.baseUrl + "/api/GrowthPigsReport/ProductionReportByGrowthPigAnimalTypes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGrowthPigsReport_GetProductionReportByGrowthPigAnimalTypes(_response);
        });
    }

    protected processGrowthPigsReport_GetProductionReportByGrowthPigAnimalTypes(response: Response): Promise<GrowthPigPReportTableDatasType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GrowthPigPReportTableDatasType.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GrowthPigPReportTableDatasType>(null as any);
    }

    growthPigsReportPdf_GetProductionReportByGrowthPigAnimalTypes(data: ProductionReportByGrowthPigAnimalTypes, siteId: string | null | undefined, lang: string | null | undefined, timeZoneId: string | null | undefined, title: string | null | undefined, isSpecialPeriod: boolean | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/GrowthPigsReportPdf/ProductionReportByGrowthPigAnimalTypesPdf?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        if (timeZoneId !== undefined && timeZoneId !== null)
            url_ += "timeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        if (title !== undefined && title !== null)
            url_ += "title=" + encodeURIComponent("" + title) + "&";
        if (isSpecialPeriod === null)
            throw new Error("The parameter 'isSpecialPeriod' cannot be null.");
        else if (isSpecialPeriod !== undefined)
            url_ += "isSpecialPeriod=" + encodeURIComponent("" + isSpecialPeriod) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGrowthPigsReportPdf_GetProductionReportByGrowthPigAnimalTypes(_response);
        });
    }

    protected processGrowthPigsReportPdf_GetProductionReportByGrowthPigAnimalTypes(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    growthPigTuneProduction_Upsert(growthPigsEvent: GrowthPigTuneProduction[]): Promise<void> {
        let url_ = this.baseUrl + "/api/GrowthPigTuneProduction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(growthPigsEvent);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGrowthPigTuneProduction_Upsert(_response);
        });
    }

    protected processGrowthPigTuneProduction_Upsert(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    growthPigTuneProduction_GetBySiteId(siteId: string | null | undefined): Promise<GrowthPigTuneProduction[]> {
        let url_ = this.baseUrl + "/api/GrowthPigTuneProduction?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGrowthPigTuneProduction_GetBySiteId(_response);
        });
    }

    protected processGrowthPigTuneProduction_GetBySiteId(response: Response): Promise<GrowthPigTuneProduction[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GrowthPigTuneProduction.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GrowthPigTuneProduction[]>(null as any);
    }

    identity_Get(): Promise<UserProfile[]> {
        let url_ = this.baseUrl + "/api/Identity/current";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIdentity_Get(_response);
        });
    }

    protected processIdentity_Get(response: Response): Promise<UserProfile[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserProfile.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserProfile[]>(null as any);
    }

    identity_Post(profile: UserProfile2): Promise<UserProfile[]> {
        let url_ = this.baseUrl + "/api/Identity/current";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(profile);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIdentity_Post(_response);
        });
    }

    protected processIdentity_Post(response: Response): Promise<UserProfile[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserProfile.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserProfile[]>(null as any);
    }

    identity_Insert(profile: UserProfile2): Promise<string> {
        let url_ = this.baseUrl + "/api/Identity/current";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(profile);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIdentity_Insert(_response);
        });
    }

    protected processIdentity_Insert(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : <any>null;
    
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    identity_Activate(id: string | null): Promise<UserProfile[]> {
        let url_ = this.baseUrl + "/api/Identity/activate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIdentity_Activate(_response);
        });
    }

    protected processIdentity_Activate(response: Response): Promise<UserProfile[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserProfile.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserProfile[]>(null as any);
    }

    identityControllerV2_Get(): Promise<UserProfile> {
        let url_ = this.baseUrl + "/api/IdentityControllerV2/current";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIdentityControllerV2_Get(_response);
        });
    }

    protected processIdentityControllerV2_Get(response: Response): Promise<UserProfile> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserProfile.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserProfile>(null as any);
    }

    identityControllerV2_Post(profile: UserProfile2): Promise<UserProfile> {
        let url_ = this.baseUrl + "/api/IdentityControllerV2/current";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(profile);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIdentityControllerV2_Post(_response);
        });
    }

    protected processIdentityControllerV2_Post(response: Response): Promise<UserProfile> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserProfile.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserProfile>(null as any);
    }

    identityControllerV2_Insert(profile: UserProfile2): Promise<string> {
        let url_ = this.baseUrl + "/api/IdentityControllerV2/current";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(profile);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIdentityControllerV2_Insert(_response);
        });
    }

    protected processIdentityControllerV2_Insert(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : <any>null;
    
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    identityControllerV2_ActivateSiteId(siteId: string | null): Promise<UserProfile> {
        let url_ = this.baseUrl + "/api/IdentityControllerV2/ActivateSiteId/{siteId}";
        if (siteId === undefined || siteId === null)
            throw new Error("The parameter 'siteId' must be defined.");
        url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIdentityControllerV2_ActivateSiteId(_response);
        });
    }

    protected processIdentityControllerV2_ActivateSiteId(response: Response): Promise<UserProfile> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserProfile.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserProfile>(null as any);
    }

    identityControllerV2_ActivateSiteIdAdmin(siteId: string | null): Promise<UserProfile> {
        let url_ = this.baseUrl + "/api/IdentityControllerV2/ActivateSiteIdAdmin/{siteId}";
        if (siteId === undefined || siteId === null)
            throw new Error("The parameter 'siteId' must be defined.");
        url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIdentityControllerV2_ActivateSiteIdAdmin(_response);
        });
    }

    protected processIdentityControllerV2_ActivateSiteIdAdmin(response: Response): Promise<UserProfile> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserProfile.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserProfile>(null as any);
    }

    image_Post(image: Image): Promise<string> {
        let url_ = this.baseUrl + "/api/Image";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(image);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processImage_Post(_response);
        });
    }

    protected processImage_Post(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    image_Delete(id: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Image?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processImage_Delete(_response);
        });
    }

    protected processImage_Delete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    image_Get(id: string | null): Promise<Image> {
        let url_ = this.baseUrl + "/api/Image/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processImage_Get(_response);
        });
    }

    protected processImage_Get(response: Response): Promise<Image> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Image.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Image>(null as any);
    }

    image_GetAllDiagnoseImages(lastModified: Date | undefined): Promise<Image[]> {
        let url_ = this.baseUrl + "/api/Image/GetAllDiagnoseImages?";
        if (lastModified === null)
            throw new Error("The parameter 'lastModified' cannot be null.");
        else if (lastModified !== undefined)
            url_ += "lastModified=" + encodeURIComponent(lastModified ? "" + lastModified.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processImage_GetAllDiagnoseImages(_response);
        });
    }

    protected processImage_GetAllDiagnoseImages(response: Response): Promise<Image[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Image.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Image[]>(null as any);
    }

    iotHub_GetDeviceProxyProperties(edgeModule: DeviceEdgeModuleDto): Promise<DeviceEdgeModuleDto> {
        let url_ = this.baseUrl + "/api/IotHub/GetDeviceProxyProperties";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(edgeModule);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIotHub_GetDeviceProxyProperties(_response);
        });
    }

    protected processIotHub_GetDeviceProxyProperties(response: Response): Promise<DeviceEdgeModuleDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeviceEdgeModuleDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeviceEdgeModuleDto>(null as any);
    }

    iotHub_SetDeviceProxyProperties(edgeModule: DeviceEdgeModuleDto): Promise<DeviceEdgeModuleDto> {
        let url_ = this.baseUrl + "/api/IotHub/SetDeviceProxyProperties";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(edgeModule);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIotHub_SetDeviceProxyProperties(_response);
        });
    }

    protected processIotHub_SetDeviceProxyProperties(response: Response): Promise<DeviceEdgeModuleDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeviceEdgeModuleDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeviceEdgeModuleDto>(null as any);
    }

    iotHub_GetDeviceEdgeAgentProperties(deviceId: string | null | undefined, equipment: Equipment | undefined): Promise<DeviceEdgeAgentPropertiesDto> {
        let url_ = this.baseUrl + "/api/IotHub/EdgeAgentProperties?";
        if (deviceId !== undefined && deviceId !== null)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&";
        if (equipment === null)
            throw new Error("The parameter 'equipment' cannot be null.");
        else if (equipment !== undefined)
            url_ += "equipment=" + encodeURIComponent("" + equipment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIotHub_GetDeviceEdgeAgentProperties(_response);
        });
    }

    protected processIotHub_GetDeviceEdgeAgentProperties(response: Response): Promise<DeviceEdgeAgentPropertiesDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeviceEdgeAgentPropertiesDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeviceEdgeAgentPropertiesDto>(null as any);
    }

    iotHub_GetDeviceConnectionString(deviceId: string | null | undefined, equipment: Equipment | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/IotHub/ConnectionString?";
        if (deviceId !== undefined && deviceId !== null)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&";
        if (equipment === null)
            throw new Error("The parameter 'equipment' cannot be null.");
        else if (equipment !== undefined)
            url_ += "equipment=" + encodeURIComponent("" + equipment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIotHub_GetDeviceConnectionString(_response);
        });
    }

    protected processIotHub_GetDeviceConnectionString(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    lardScanningEvent_Upsert(lardScanningEvent: LardScanningEvent): Promise<string> {
        let url_ = this.baseUrl + "/api/LardScanningEvent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(lardScanningEvent);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLardScanningEvent_Upsert(_response);
        });
    }

    protected processLardScanningEvent_Upsert(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    lardScanningEvent_Sync(siteId: string | null | undefined, lastSyncDate: Date | undefined): Promise<SyncDataLardScanningEvent> {
        let url_ = this.baseUrl + "/api/LardScanningEvent/Sync?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (lastSyncDate === null)
            throw new Error("The parameter 'lastSyncDate' cannot be null.");
        else if (lastSyncDate !== undefined)
            url_ += "lastSyncDate=" + encodeURIComponent(lastSyncDate ? "" + lastSyncDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLardScanningEvent_Sync(_response);
        });
    }

    protected processLardScanningEvent_Sync(response: Response): Promise<SyncDataLardScanningEvent> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SyncDataLardScanningEvent.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncDataLardScanningEvent>(null as any);
    }

    lardScanningEvent_GetDepaturedLardScanningsBySiteId(siteId: string | null | undefined): Promise<LardScanningEvent[]> {
        let url_ = this.baseUrl + "/api/LardScanningEvent/GetDepaturedLardScanningsBySiteId?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLardScanningEvent_GetDepaturedLardScanningsBySiteId(_response);
        });
    }

    protected processLardScanningEvent_GetDepaturedLardScanningsBySiteId(response: Response): Promise<LardScanningEvent[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LardScanningEvent.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LardScanningEvent[]>(null as any);
    }

    licences_GetAll(): Promise<Licence[]> {
        let url_ = this.baseUrl + "/api/Licences";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLicences_GetAll(_response);
        });
    }

    protected processLicences_GetAll(response: Response): Promise<Licence[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Licence.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Licence[]>(null as any);
    }

    locations_Get(): Promise<LocationsV2> {
        let url_ = this.baseUrl + "/api/Locations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLocations_Get(_response);
        });
    }

    protected processLocations_Get(response: Response): Promise<LocationsV2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationsV2.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocationsV2>(null as any);
    }

    locations_Sync(siteId: string | null | undefined, lastSyncDate: Date | undefined): Promise<SyncDataLocationsV2> {
        let url_ = this.baseUrl + "/api/Locations/Sync?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (lastSyncDate === null)
            throw new Error("The parameter 'lastSyncDate' cannot be null.");
        else if (lastSyncDate !== undefined)
            url_ += "lastSyncDate=" + encodeURIComponent(lastSyncDate ? "" + lastSyncDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLocations_Sync(_response);
        });
    }

    protected processLocations_Sync(response: Response): Promise<SyncDataLocationsV2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SyncDataLocationsV2.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncDataLocationsV2>(null as any);
    }

    locationsV2_Get(): Promise<Locations> {
        let url_ = this.baseUrl + "/api/LocationsV2";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLocationsV2_Get(_response);
        });
    }

    protected processLocationsV2_Get(response: Response): Promise<Locations> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Locations.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Locations>(null as any);
    }

    locationsV2_Sync(siteId: string | null | undefined, lastSyncDate: Date | undefined): Promise<SyncDataLocations> {
        let url_ = this.baseUrl + "/api/LocationsV2/Sync?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (lastSyncDate === null)
            throw new Error("The parameter 'lastSyncDate' cannot be null.");
        else if (lastSyncDate !== undefined)
            url_ += "lastSyncDate=" + encodeURIComponent(lastSyncDate ? "" + lastSyncDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLocationsV2_Sync(_response);
        });
    }

    protected processLocationsV2_Sync(response: Response): Promise<SyncDataLocations> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SyncDataLocations.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncDataLocations>(null as any);
    }

    locationsV2_FetchLocations(siteId: string | null | undefined, code: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/LocationsV2/FetchLocations?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLocationsV2_FetchLocations(_response);
        });
    }

    protected processLocationsV2_FetchLocations(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    markings_Get(): Promise<Marking[]> {
        let url_ = this.baseUrl + "/api/Markings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMarkings_Get(_response);
        });
    }

    protected processMarkings_Get(response: Response): Promise<Marking[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Marking.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Marking[]>(null as any);
    }

    markings_Sync(lastSyncDate: Date | undefined): Promise<SyncDataMarking> {
        let url_ = this.baseUrl + "/api/Markings/Sync?";
        if (lastSyncDate === null)
            throw new Error("The parameter 'lastSyncDate' cannot be null.");
        else if (lastSyncDate !== undefined)
            url_ += "lastSyncDate=" + encodeURIComponent(lastSyncDate ? "" + lastSyncDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMarkings_Sync(_response);
        });
    }

    protected processMarkings_Sync(response: Response): Promise<SyncDataMarking> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SyncDataMarking.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncDataMarking>(null as any);
    }

    matingBatch_GetBySiteId(siteId: string | null | undefined): Promise<MatingBatch[]> {
        let url_ = this.baseUrl + "/api/MatingBatch/GetBySiteId?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMatingBatch_GetBySiteId(_response);
        });
    }

    protected processMatingBatch_GetBySiteId(response: Response): Promise<MatingBatch[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MatingBatch.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MatingBatch[]>(null as any);
    }

    matingBatch_UpsertMultiple(matingBathces: MatingBatch[]): Promise<void> {
        let url_ = this.baseUrl + "/api/MatingBatch/UpsertMultiple";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(matingBathces);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMatingBatch_UpsertMultiple(_response);
        });
    }

    protected processMatingBatch_UpsertMultiple(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    matingBatch_Sync(siteId: string | null | undefined, lastSyncDate: Date | undefined): Promise<SyncDataMatingBatch> {
        let url_ = this.baseUrl + "/api/MatingBatch/Sync?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (lastSyncDate === null)
            throw new Error("The parameter 'lastSyncDate' cannot be null.");
        else if (lastSyncDate !== undefined)
            url_ += "lastSyncDate=" + encodeURIComponent(lastSyncDate ? "" + lastSyncDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMatingBatch_Sync(_response);
        });
    }

    protected processMatingBatch_Sync(response: Response): Promise<SyncDataMatingBatch> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SyncDataMatingBatch.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncDataMatingBatch>(null as any);
    }

    matingBatch_DeleteMatingBatchesByDate(siteId: string | null | undefined, deletionDate: Date | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/MatingBatch/DeleteMatingBatchesByDate?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (deletionDate === null)
            throw new Error("The parameter 'deletionDate' cannot be null.");
        else if (deletionDate !== undefined)
            url_ += "deletionDate=" + encodeURIComponent(deletionDate ? "" + deletionDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMatingBatch_DeleteMatingBatchesByDate(_response);
        });
    }

    protected processMatingBatch_DeleteMatingBatchesByDate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    matingBatchReport_GetMatingBatchReport(date: Date | undefined, siteId: string | null | undefined): Promise<MatingBatchReports> {
        let url_ = this.baseUrl + "/api/MatingBatchReport/GetMatingBatchReport?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMatingBatchReport_GetMatingBatchReport(_response);
        });
    }

    protected processMatingBatchReport_GetMatingBatchReport(response: Response): Promise<MatingBatchReports> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MatingBatchReports.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MatingBatchReports>(null as any);
    }

    matingBatchReport_GetMatingBatchReportGraph(date: Date | undefined, siteId: string | null | undefined): Promise<MatingBatchReports> {
        let url_ = this.baseUrl + "/api/MatingBatchReport/GetMatingBatchReportGraph?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMatingBatchReport_GetMatingBatchReportGraph(_response);
        });
    }

    protected processMatingBatchReport_GetMatingBatchReportGraph(response: Response): Promise<MatingBatchReports> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MatingBatchReports.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MatingBatchReports>(null as any);
    }

    matingBatchReport_GetMatingBatchReportPdf(date: Date | undefined, siteId: string | null | undefined, timeZoneId: string | null | undefined, lang: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/MatingBatchReport/GetMatingBatchReportPdf?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (timeZoneId !== undefined && timeZoneId !== null)
            url_ += "timeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMatingBatchReport_GetMatingBatchReportPdf(_response);
        });
    }

    protected processMatingBatchReport_GetMatingBatchReportPdf(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    matingBatchReport_GetDashboardForMatingBatchReport(siteId: string | null | undefined, date: Date | undefined, mode: string | null | undefined): Promise<{ [key: string]: DashboardTableModel[]; }> {
        let url_ = this.baseUrl + "/api/MatingBatchReport/GetDashboardForMatingBatchReport?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (mode !== undefined && mode !== null)
            url_ += "mode=" + encodeURIComponent("" + mode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMatingBatchReport_GetDashboardForMatingBatchReport(_response);
        });
    }

    protected processMatingBatchReport_GetDashboardForMatingBatchReport(response: Response): Promise<{ [key: string]: DashboardTableModel[]; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] ? resultData200[key].map((i: any) => DashboardTableModel.fromJS(i)) : [];
                }
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: DashboardTableModel[]; }>(null as any);
    }

    matingBatchSetting_GetSettingBySiteId(siteId: string | null | undefined): Promise<MatingBatchSetting> {
        let url_ = this.baseUrl + "/api/MatingBatchSetting/GetSettingBySiteId?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMatingBatchSetting_GetSettingBySiteId(_response);
        });
    }

    protected processMatingBatchSetting_GetSettingBySiteId(response: Response): Promise<MatingBatchSetting> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MatingBatchSetting.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MatingBatchSetting>(null as any);
    }

    matingBatchSetting_GetBySiteId(siteId: string | null | undefined): Promise<MatingBatchSetting[]> {
        let url_ = this.baseUrl + "/api/MatingBatchSetting/GetBySiteId?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMatingBatchSetting_GetBySiteId(_response);
        });
    }

    protected processMatingBatchSetting_GetBySiteId(response: Response): Promise<MatingBatchSetting[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MatingBatchSetting.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MatingBatchSetting[]>(null as any);
    }

    matingBatchSetting_Upsert(matingBathcSetting: MatingBatchSetting): Promise<string> {
        let url_ = this.baseUrl + "/api/MatingBatchSetting/Upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(matingBathcSetting);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMatingBatchSetting_Upsert(_response);
        });
    }

    protected processMatingBatchSetting_Upsert(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    matingBatchSetting_DeleteAll(siteId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/MatingBatchSetting/DeleteAll?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMatingBatchSetting_DeleteAll(_response);
        });
    }

    protected processMatingBatchSetting_DeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    matingBatchSetting_Sync(siteId: string | null | undefined, lastSyncDate: Date | undefined): Promise<SyncDataMatingBatchSetting> {
        let url_ = this.baseUrl + "/api/MatingBatchSetting/Sync?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (lastSyncDate === null)
            throw new Error("The parameter 'lastSyncDate' cannot be null.");
        else if (lastSyncDate !== undefined)
            url_ += "lastSyncDate=" + encodeURIComponent(lastSyncDate ? "" + lastSyncDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMatingBatchSetting_Sync(_response);
        });
    }

    protected processMatingBatchSetting_Sync(response: Response): Promise<SyncDataMatingBatchSetting> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SyncDataMatingBatchSetting.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncDataMatingBatchSetting>(null as any);
    }

    monitor_Get(): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Monitor";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMonitor_Get(_response);
        });
    }

    protected processMonitor_Get(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    moveEvent_GetBySiteId(siteId: string | null | undefined): Promise<MoveEvent[]> {
        let url_ = this.baseUrl + "/api/MoveEvent/GetBySiteId?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMoveEvent_GetBySiteId(_response);
        });
    }

    protected processMoveEvent_GetBySiteId(response: Response): Promise<MoveEvent[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MoveEvent.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MoveEvent[]>(null as any);
    }

    moveEvent_GetByStemAnimalId(stemAnimalId: string | null | undefined): Promise<MoveEvent[]> {
        let url_ = this.baseUrl + "/api/MoveEvent/GetByStemAnimalId?";
        if (stemAnimalId !== undefined && stemAnimalId !== null)
            url_ += "stemAnimalId=" + encodeURIComponent("" + stemAnimalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMoveEvent_GetByStemAnimalId(_response);
        });
    }

    protected processMoveEvent_GetByStemAnimalId(response: Response): Promise<MoveEvent[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MoveEvent.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MoveEvent[]>(null as any);
    }

    moveEvent_Upsert(moveEvent: MoveEvent, skipDateValidation: boolean | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/MoveEvent/Upsert?";
        if (skipDateValidation === null)
            throw new Error("The parameter 'skipDateValidation' cannot be null.");
        else if (skipDateValidation !== undefined)
            url_ += "skipDateValidation=" + encodeURIComponent("" + skipDateValidation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(moveEvent);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMoveEvent_Upsert(_response);
        });
    }

    protected processMoveEvent_Upsert(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    moveEvent_Sync(siteId: string | null | undefined, lastSyncDate: Date | undefined): Promise<SyncDataMoveEvent> {
        let url_ = this.baseUrl + "/api/MoveEvent/Sync?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (lastSyncDate === null)
            throw new Error("The parameter 'lastSyncDate' cannot be null.");
        else if (lastSyncDate !== undefined)
            url_ += "lastSyncDate=" + encodeURIComponent(lastSyncDate ? "" + lastSyncDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMoveEvent_Sync(_response);
        });
    }

    protected processMoveEvent_Sync(response: Response): Promise<SyncDataMoveEvent> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SyncDataMoveEvent.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncDataMoveEvent>(null as any);
    }

    moveEvent_GetDeparturedMoveEvents(siteId: string | null | undefined): Promise<MoveEvent[]> {
        let url_ = this.baseUrl + "/api/MoveEvent/GetDeparturedMoveEvents?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMoveEvent_GetDeparturedMoveEvents(_response);
        });
    }

    protected processMoveEvent_GetDeparturedMoveEvents(response: Response): Promise<MoveEvent[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MoveEvent.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MoveEvent[]>(null as any);
    }

    moveEvent_GetMoveEventsByDate(siteId: string | null | undefined, fromDate: Date | undefined, toDate: Date | undefined): Promise<MoveEvent[]> {
        let url_ = this.baseUrl + "/api/MoveEvent/GetMoveEventsByDates?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMoveEvent_GetMoveEventsByDate(_response);
        });
    }

    protected processMoveEvent_GetMoveEventsByDate(response: Response): Promise<MoveEvent[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MoveEvent.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MoveEvent[]>(null as any);
    }

    moveEvent_GetMoveEventsByDatesAndStemIds(siteId: string | null | undefined, fromDate: Date | undefined, toDate: Date | undefined): Promise<MoveEvent[]> {
        let url_ = this.baseUrl + "/api/MoveEvent/GetMoveEventsByDatesAndStemIds?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMoveEvent_GetMoveEventsByDatesAndStemIds(_response);
        });
    }

    protected processMoveEvent_GetMoveEventsByDatesAndStemIds(response: Response): Promise<MoveEvent[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MoveEvent.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MoveEvent[]>(null as any);
    }

    moveEvent_GetMoveEventsByDateDictionary(stemIdDates: { [key: string]: Date; }): Promise<{ [key: string]: MoveEvent; }> {
        let url_ = this.baseUrl + "/api/MoveEvent/GetMoveEventsByDateDictionary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(stemIdDates);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMoveEvent_GetMoveEventsByDateDictionary(_response);
        });
    }

    protected processMoveEvent_GetMoveEventsByDateDictionary(response: Response): Promise<{ [key: string]: MoveEvent; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] ? MoveEvent.fromJS(resultData200[key]) : new MoveEvent();
                }
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: MoveEvent; }>(null as any);
    }

    moveEvent_UpsertManyMoveEvents(moveEvents: MoveEvent[]): Promise<MoveEvent[]> {
        let url_ = this.baseUrl + "/api/MoveEvent/UpsertManyMoveEvents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(moveEvents);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMoveEvent_UpsertManyMoveEvents(_response);
        });
    }

    protected processMoveEvent_UpsertManyMoveEvents(response: Response): Promise<MoveEvent[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MoveEvent.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MoveEvent[]>(null as any);
    }

    penRetentionTime_Post(penRetentionTime: PenRetentionTime): Promise<string> {
        let url_ = this.baseUrl + "/api/PenRetentionTime";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(penRetentionTime);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPenRetentionTime_Post(_response);
        });
    }

    protected processPenRetentionTime_Post(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    penRetentionTime_UpsertMultiple(penRetentionTimes: PenRetentionTime[]): Promise<string[]> {
        let url_ = this.baseUrl + "/api/PenRetentionTime/UpsertMultiple";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(penRetentionTimes);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPenRetentionTime_UpsertMultiple(_response);
        });
    }

    protected processPenRetentionTime_UpsertMultiple(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    penRetentionTime_Sync(siteId: string | null | undefined, lastSyncDate: Date | undefined): Promise<SyncPenRetentionTime> {
        let url_ = this.baseUrl + "/api/PenRetentionTime/Sync?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (lastSyncDate === null)
            throw new Error("The parameter 'lastSyncDate' cannot be null.");
        else if (lastSyncDate !== undefined)
            url_ += "lastSyncDate=" + encodeURIComponent(lastSyncDate ? "" + lastSyncDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPenRetentionTime_Sync(_response);
        });
    }

    protected processPenRetentionTime_Sync(response: Response): Promise<SyncPenRetentionTime> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SyncPenRetentionTime.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncPenRetentionTime>(null as any);
    }

    pens_GetAll(): Promise<Pen[]> {
        let url_ = this.baseUrl + "/api/Pens";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPens_GetAll(_response);
        });
    }

    protected processPens_GetAll(response: Response): Promise<Pen[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Pen.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Pen[]>(null as any);
    }

    pens_Upsert(value: Pen): Promise<string> {
        let url_ = this.baseUrl + "/api/Pens";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPens_Upsert(_response);
        });
    }

    protected processPens_Upsert(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    pens_Get(id: string | null): Promise<Pen> {
        let url_ = this.baseUrl + "/api/Pens/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPens_Get(_response);
        });
    }

    protected processPens_Get(response: Response): Promise<Pen> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Pen.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Pen>(null as any);
    }

    pens_Delete(id: string | null): Promise<void> {
        let url_ = this.baseUrl + "/api/Pens/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPens_Delete(_response);
        });
    }

    protected processPens_Delete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    pens_Upsert2(value: Pen): Promise<string> {
        let url_ = this.baseUrl + "/api/Pens/UpsertAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPens_Upsert2(_response);
        });
    }

    protected processPens_Upsert2(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    pens_UpsertMany(pens: Pen[]): Promise<void> {
        let url_ = this.baseUrl + "/api/Pens/UpsertManyAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pens);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPens_UpsertMany(_response);
        });
    }

    protected processPens_UpsertMany(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    poolYoungFemale_Sync(siteId: string | null | undefined, lastSyncDate: Date | undefined): Promise<SyncPoolYoungFemale> {
        let url_ = this.baseUrl + "/api/PoolYoungFemale/Sync?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (lastSyncDate === null)
            throw new Error("The parameter 'lastSyncDate' cannot be null.");
        else if (lastSyncDate !== undefined)
            url_ += "lastSyncDate=" + encodeURIComponent(lastSyncDate ? "" + lastSyncDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPoolYoungFemale_Sync(_response);
        });
    }

    protected processPoolYoungFemale_Sync(response: Response): Promise<SyncPoolYoungFemale> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SyncPoolYoungFemale.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncPoolYoungFemale>(null as any);
    }

    poolYoungFemale_Upsert(poolYoungFemale: PoolYoungFemale): Promise<string> {
        let url_ = this.baseUrl + "/api/PoolYoungFemale/Upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(poolYoungFemale);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPoolYoungFemale_Upsert(_response);
        });
    }

    protected processPoolYoungFemale_Upsert(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    poolYoungFemale_Delete(poolYoungFemale: PoolYoungFemale): Promise<void> {
        let url_ = this.baseUrl + "/api/PoolYoungFemale/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(poolYoungFemale);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPoolYoungFemale_Delete(_response);
        });
    }

    protected processPoolYoungFemale_Delete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    poolYoungFemale_UpsertMany(poolYoungFemales: PoolYoungFemale[]): Promise<string> {
        let url_ = this.baseUrl + "/api/PoolYoungFemale/UpsertMany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(poolYoungFemales);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPoolYoungFemale_UpsertMany(_response);
        });
    }

    protected processPoolYoungFemale_UpsertMany(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    poolYoungFemalePdf_PoolYoungFemalePdfPrint(ids: string[], siteId: string | null | undefined, lang: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/PoolYoungFemalePdf/PoolYoungFemalePdfPrint?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPoolYoungFemalePdf_PoolYoungFemalePdfPrint(_response);
        });
    }

    protected processPoolYoungFemalePdf_PoolYoungFemalePdfPrint(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    poolYoungFemalePdf_PoolYoungFemaleShouldDepartureList(tableItems: PoolYoungFemaleShouldDepartureTableItem[], siteId: string | null | undefined, timeZoneId: string | null | undefined, lang: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/PoolYoungFemalePdf/PoolYoungFemaleShouldDepartureList?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (timeZoneId !== undefined && timeZoneId !== null)
            url_ += "timeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tableItems);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPoolYoungFemalePdf_PoolYoungFemaleShouldDepartureList(_response);
        });
    }

    protected processPoolYoungFemalePdf_PoolYoungFemaleShouldDepartureList(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    pregnancyEvent_Get(pregnancyId: string | null | undefined): Promise<PregnancyEvent> {
        let url_ = this.baseUrl + "/api/PregnancyEvent?";
        if (pregnancyId !== undefined && pregnancyId !== null)
            url_ += "pregnancyId=" + encodeURIComponent("" + pregnancyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPregnancyEvent_Get(_response);
        });
    }

    protected processPregnancyEvent_Get(response: Response): Promise<PregnancyEvent> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PregnancyEvent.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PregnancyEvent>(null as any);
    }

    pregnancyEvent_Delete(idToDelete: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/PregnancyEvent?";
        if (idToDelete !== undefined && idToDelete !== null)
            url_ += "idToDelete=" + encodeURIComponent("" + idToDelete) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPregnancyEvent_Delete(_response);
        });
    }

    protected processPregnancyEvent_Delete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    pregnancyEvent_GetBySiteId(siteId: string | null | undefined): Promise<PregnancyEvent[]> {
        let url_ = this.baseUrl + "/api/PregnancyEvent/GetBySiteIdAsync?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPregnancyEvent_GetBySiteId(_response);
        });
    }

    protected processPregnancyEvent_GetBySiteId(response: Response): Promise<PregnancyEvent[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PregnancyEvent.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PregnancyEvent[]>(null as any);
    }

    pregnancyEvent_GetByPregnancyId(siteId: string | null | undefined): Promise<PregnancyEvent[]> {
        let url_ = this.baseUrl + "/api/PregnancyEvent/GetByPregnancyIdAsync?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPregnancyEvent_GetByPregnancyId(_response);
        });
    }

    protected processPregnancyEvent_GetByPregnancyId(response: Response): Promise<PregnancyEvent[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PregnancyEvent.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PregnancyEvent[]>(null as any);
    }

    pregnancyEvent_GetByStemAnimalId(stemAniamlId: string | null | undefined): Promise<PregnancyEvent[]> {
        let url_ = this.baseUrl + "/api/PregnancyEvent/GetByStemAnimalIdAsync?";
        if (stemAniamlId !== undefined && stemAniamlId !== null)
            url_ += "stemAniamlId=" + encodeURIComponent("" + stemAniamlId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPregnancyEvent_GetByStemAnimalId(_response);
        });
    }

    protected processPregnancyEvent_GetByStemAnimalId(response: Response): Promise<PregnancyEvent[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PregnancyEvent.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PregnancyEvent[]>(null as any);
    }

    pregnancyEvent_Upsert(pregEvent: PregnancyEvent): Promise<string> {
        let url_ = this.baseUrl + "/api/PregnancyEvent/Upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pregEvent);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPregnancyEvent_Upsert(_response);
        });
    }

    protected processPregnancyEvent_Upsert(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    pregnancyEvent_UpsertMany(pregnancyEvents: PregnancyEvent[]): Promise<string[]> {
        let url_ = this.baseUrl + "/api/PregnancyEvent/UpsertManyAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pregnancyEvents);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPregnancyEvent_UpsertMany(_response);
        });
    }

    protected processPregnancyEvent_UpsertMany(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    pregnancyEvent_UpsertPregnancyEventsWithIgnoredSowState(pregEvents: PregnancyEvent[]): Promise<void> {
        let url_ = this.baseUrl + "/api/PregnancyEvent/UpsertPregnancyEventsWithIgnoredSowState";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pregEvents);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPregnancyEvent_UpsertPregnancyEventsWithIgnoredSowState(_response);
        });
    }

    protected processPregnancyEvent_UpsertPregnancyEventsWithIgnoredSowState(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    pregnancyEvent_DeleteMany(idToDelete: string[] | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/PregnancyEvent/DeleteManyAsync?";
        if (idToDelete !== undefined && idToDelete !== null)
            idToDelete && idToDelete.forEach(item => { url_ += "idToDelete=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPregnancyEvent_DeleteMany(_response);
        });
    }

    protected processPregnancyEvent_DeleteMany(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    pregnancyEvent_Sync2(siteId: string | null | undefined, lastSyncDate: Date | undefined): Promise<SyncDataPregnancyV2> {
        let url_ = this.baseUrl + "/api/PregnancyEvent/SyncV2?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (lastSyncDate === null)
            throw new Error("The parameter 'lastSyncDate' cannot be null.");
        else if (lastSyncDate !== undefined)
            url_ += "lastSyncDate=" + encodeURIComponent(lastSyncDate ? "" + lastSyncDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPregnancyEvent_Sync2(_response);
        });
    }

    protected processPregnancyEvent_Sync2(response: Response): Promise<SyncDataPregnancyV2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SyncDataPregnancyV2.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncDataPregnancyV2>(null as any);
    }

    pregnancyEvent_GetDepaturedPregnanciesBySiteId(siteId: string | null | undefined): Promise<{ [key: string]: PregnancyEvent[]; }> {
        let url_ = this.baseUrl + "/api/PregnancyEvent/GetDepaturedPregnanciesBySiteId?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPregnancyEvent_GetDepaturedPregnanciesBySiteId(_response);
        });
    }

    protected processPregnancyEvent_GetDepaturedPregnanciesBySiteId(response: Response): Promise<{ [key: string]: PregnancyEvent[]; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] ? resultData200[key].map((i: any) => PregnancyEvent.fromJS(i)) : [];
                }
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: PregnancyEvent[]; }>(null as any);
    }

    processEquipment_GetBySiteId(siteId: string | null | undefined): Promise<ProcessEquipment[]> {
        let url_ = this.baseUrl + "/api/ProcessEquipment/GetBySiteId?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processProcessEquipment_GetBySiteId(_response);
        });
    }

    protected processProcessEquipment_GetBySiteId(response: Response): Promise<ProcessEquipment[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProcessEquipment.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProcessEquipment[]>(null as any);
    }

    processEquipment_Upsert(processEquiqment: ProcessEquipment): Promise<string> {
        let url_ = this.baseUrl + "/api/ProcessEquipment/Upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(processEquiqment);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processProcessEquipment_Upsert(_response);
        });
    }

    protected processProcessEquipment_Upsert(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    processEquipment_Sync(siteId: string | null | undefined, lastSyncDate: Date | undefined): Promise<SyncDataProcessEquipment> {
        let url_ = this.baseUrl + "/api/ProcessEquipment/Sync?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (lastSyncDate === null)
            throw new Error("The parameter 'lastSyncDate' cannot be null.");
        else if (lastSyncDate !== undefined)
            url_ += "lastSyncDate=" + encodeURIComponent(lastSyncDate ? "" + lastSyncDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processProcessEquipment_Sync(_response);
        });
    }

    protected processProcessEquipment_Sync(response: Response): Promise<SyncDataProcessEquipment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SyncDataProcessEquipment.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncDataProcessEquipment>(null as any);
    }

    processEquipment_Delete(idToDelete: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ProcessEquipment?";
        if (idToDelete !== undefined && idToDelete !== null)
            url_ += "idToDelete=" + encodeURIComponent("" + idToDelete) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processProcessEquipment_Delete(_response);
        });
    }

    protected processProcessEquipment_Delete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    processEquipmentLocationRelations_Upsert(processEquipmentData: ProcessEquipmentData, reset: boolean | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/ProcessEquipmentLocationRelations/UpsertProcessEquipmentData?";
        if (reset === null)
            throw new Error("The parameter 'reset' cannot be null.");
        else if (reset !== undefined)
            url_ += "reset=" + encodeURIComponent("" + reset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(processEquipmentData);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processProcessEquipmentLocationRelations_Upsert(_response);
        });
    }

    protected processProcessEquipmentLocationRelations_Upsert(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    processEquipmentLocationRelations_Upsert2(processEquipmentData: ProcessEquipmentData): Promise<string> {
        let url_ = this.baseUrl + "/api/ProcessEquipmentLocationRelations/UpsertProcessEquipmentDataFromUnitToPen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(processEquipmentData);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processProcessEquipmentLocationRelations_Upsert2(_response);
        });
    }

    protected processProcessEquipmentLocationRelations_Upsert2(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    processEquipmentLocationRelations_Upsert3(unitToPen: UnitToPen): Promise<string> {
        let url_ = this.baseUrl + "/api/ProcessEquipmentLocationRelations/UpsertUnitToPen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(unitToPen);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processProcessEquipmentLocationRelations_Upsert3(_response);
        });
    }

    protected processProcessEquipmentLocationRelations_Upsert3(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    processEquipmentLocationRelations_GetProcessEquipmentDataBySiteId(siteId: string | null | undefined): Promise<ProcessEquipmentData[]> {
        let url_ = this.baseUrl + "/api/ProcessEquipmentLocationRelations/GetProcessEquipmentDataBySiteId?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processProcessEquipmentLocationRelations_GetProcessEquipmentDataBySiteId(_response);
        });
    }

    protected processProcessEquipmentLocationRelations_GetProcessEquipmentDataBySiteId(response: Response): Promise<ProcessEquipmentData[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProcessEquipmentData.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProcessEquipmentData[]>(null as any);
    }

    processEquipmentLocationRelations_GetUnitToPenDataBySiteId(siteId: string | null | undefined, lastSyncDate: Date | undefined): Promise<SyncDataUnitToPen> {
        let url_ = this.baseUrl + "/api/ProcessEquipmentLocationRelations/GetUnitToPenDataBySiteId?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (lastSyncDate === null)
            throw new Error("The parameter 'lastSyncDate' cannot be null.");
        else if (lastSyncDate !== undefined)
            url_ += "lastSyncDate=" + encodeURIComponent(lastSyncDate ? "" + lastSyncDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processProcessEquipmentLocationRelations_GetUnitToPenDataBySiteId(_response);
        });
    }

    protected processProcessEquipmentLocationRelations_GetUnitToPenDataBySiteId(response: Response): Promise<SyncDataUnitToPen> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SyncDataUnitToPen.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncDataUnitToPen>(null as any);
    }

    processEquipmentLocationRelations_SyncProcessEquipmentData(siteId: string | null | undefined, lastSyncDate: Date | undefined): Promise<SyncProcessEquipmentData> {
        let url_ = this.baseUrl + "/api/ProcessEquipmentLocationRelations/ProcessEquipmentDataSync?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (lastSyncDate === null)
            throw new Error("The parameter 'lastSyncDate' cannot be null.");
        else if (lastSyncDate !== undefined)
            url_ += "lastSyncDate=" + encodeURIComponent(lastSyncDate ? "" + lastSyncDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processProcessEquipmentLocationRelations_SyncProcessEquipmentData(_response);
        });
    }

    protected processProcessEquipmentLocationRelations_SyncProcessEquipmentData(response: Response): Promise<SyncProcessEquipmentData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SyncProcessEquipmentData.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncProcessEquipmentData>(null as any);
    }

    productionReport_GetProductionReport(isSpecialPeriod: boolean | undefined, siteId: string | null | undefined, timeZoneId: string | null | undefined): Promise<ProductionReportItem> {
        let url_ = this.baseUrl + "/api/ProductionReport/GetProductionReport?";
        if (isSpecialPeriod === null)
            throw new Error("The parameter 'isSpecialPeriod' cannot be null.");
        else if (isSpecialPeriod !== undefined)
            url_ += "isSpecialPeriod=" + encodeURIComponent("" + isSpecialPeriod) + "&";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (timeZoneId !== undefined && timeZoneId !== null)
            url_ += "timeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processProductionReport_GetProductionReport(_response);
        });
    }

    protected processProductionReport_GetProductionReport(response: Response): Promise<ProductionReportItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductionReportItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductionReportItem>(null as any);
    }

    productionReport_GetProductionReportPdf(isSpecialPeriod: boolean | undefined, siteId: string | null | undefined, timeZoneId: string | null | undefined, lang: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/ProductionReport/GetProductionReportPdf?";
        if (isSpecialPeriod === null)
            throw new Error("The parameter 'isSpecialPeriod' cannot be null.");
        else if (isSpecialPeriod !== undefined)
            url_ += "isSpecialPeriod=" + encodeURIComponent("" + isSpecialPeriod) + "&";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (timeZoneId !== undefined && timeZoneId !== null)
            url_ += "timeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processProductionReport_GetProductionReportPdf(_response);
        });
    }

    protected processProductionReport_GetProductionReportPdf(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    productionReportSetting_Upsert(prodúctionReportSetting: ProductionReportSetting): Promise<string> {
        let url_ = this.baseUrl + "/api/ProductionReportSetting/UpsertAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(prodúctionReportSetting);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processProductionReportSetting_Upsert(_response);
        });
    }

    protected processProductionReportSetting_Upsert(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    productionReportSetting_GetGetBySiteIdBySite(siteId: string | null | undefined): Promise<ProductionReportSetting> {
        let url_ = this.baseUrl + "/api/ProductionReportSetting/GetBySiteId?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processProductionReportSetting_GetGetBySiteIdBySite(_response);
        });
    }

    protected processProductionReportSetting_GetGetBySiteIdBySite(response: Response): Promise<ProductionReportSetting> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductionReportSetting.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductionReportSetting>(null as any);
    }

    productionReportSetting_SyncSingle(siteId: string | null | undefined, lastSyncDate: Date | undefined): Promise<SyncSingleDataProductionReportSetting> {
        let url_ = this.baseUrl + "/api/ProductionReportSetting/Sync?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (lastSyncDate === null)
            throw new Error("The parameter 'lastSyncDate' cannot be null.");
        else if (lastSyncDate !== undefined)
            url_ += "lastSyncDate=" + encodeURIComponent(lastSyncDate ? "" + lastSyncDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processProductionReportSetting_SyncSingle(_response);
        });
    }

    protected processProductionReportSetting_SyncSingle(response: Response): Promise<SyncSingleDataProductionReportSetting> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SyncSingleDataProductionReportSetting.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncSingleDataProductionReportSetting>(null as any);
    }

    productionReportSetting_SyncData(siteId: string | null | undefined, lastSyncDate: Date | undefined): Promise<SyncDataProductionReportSetting> {
        let url_ = this.baseUrl + "/api/ProductionReportSetting/SyncData?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (lastSyncDate === null)
            throw new Error("The parameter 'lastSyncDate' cannot be null.");
        else if (lastSyncDate !== undefined)
            url_ += "lastSyncDate=" + encodeURIComponent(lastSyncDate ? "" + lastSyncDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processProductionReportSetting_SyncData(_response);
        });
    }

    protected processProductionReportSetting_SyncData(response: Response): Promise<SyncDataProductionReportSetting> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SyncDataProductionReportSetting.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncDataProductionReportSetting>(null as any);
    }

    reason_CreateReason(entity: Reason): Promise<string> {
        let url_ = this.baseUrl + "/api/Reason/CreateReason";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReason_CreateReason(_response);
        });
    }

    protected processReason_CreateReason(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    reason_UpdateReason(entity: Reason): Promise<string> {
        let url_ = this.baseUrl + "/api/Reason/UpdateReason";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReason_UpdateReason(_response);
        });
    }

    protected processReason_UpdateReason(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    reason_CreateReasonSettings(entity: ReasonSettings): Promise<string> {
        let url_ = this.baseUrl + "/api/Reason/CreateReasonSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReason_CreateReasonSettings(_response);
        });
    }

    protected processReason_CreateReasonSettings(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    reason_UpdateReasonSettings(entity: ReasonSettings): Promise<string> {
        let url_ = this.baseUrl + "/api/Reason/UpdateReasonSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReason_UpdateReasonSettings(_response);
        });
    }

    protected processReason_UpdateReasonSettings(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    reason_SyncV2(siteId: string | null | undefined, lastSyncDate: Date | undefined): Promise<SyncDataReason> {
        let url_ = this.baseUrl + "/api/Reason/SyncV2?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (lastSyncDate === null)
            throw new Error("The parameter 'lastSyncDate' cannot be null.");
        else if (lastSyncDate !== undefined)
            url_ += "lastSyncDate=" + encodeURIComponent(lastSyncDate ? "" + lastSyncDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReason_SyncV2(_response);
        });
    }

    protected processReason_SyncV2(response: Response): Promise<SyncDataReason> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SyncDataReason.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncDataReason>(null as any);
    }

    reason_Sync(siteId: string | null | undefined, lastSyncDate: Date | undefined): Promise<SyncDataReasonV1> {
        let url_ = this.baseUrl + "/api/Reason/Sync?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (lastSyncDate === null)
            throw new Error("The parameter 'lastSyncDate' cannot be null.");
        else if (lastSyncDate !== undefined)
            url_ += "lastSyncDate=" + encodeURIComponent(lastSyncDate ? "" + lastSyncDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReason_Sync(_response);
        });
    }

    protected processReason_Sync(response: Response): Promise<SyncDataReasonV1> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SyncDataReasonV1.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncDataReasonV1>(null as any);
    }

    recipe_UpdateRecipes(recipes: Recipe[]): Promise<void> {
        let url_ = this.baseUrl + "/api/Recipe/UpdateRecipes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(recipes);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRecipe_UpdateRecipes(_response);
        });
    }

    protected processRecipe_UpdateRecipes(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    recipe_GetRecipes(siteId: string | null | undefined): Promise<RecipeDto[]> {
        let url_ = this.baseUrl + "/api/Recipe/GetRecipes?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRecipe_GetRecipes(_response);
        });
    }

    protected processRecipe_GetRecipes(response: Response): Promise<RecipeDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecipeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecipeDto[]>(null as any);
    }

    recipe_UpsertSkioldDigitalRecipes(dto: RecipeDto): Promise<RecipeDto> {
        let url_ = this.baseUrl + "/api/Recipe/UpsertSkioldDigitalRecipes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRecipe_UpsertSkioldDigitalRecipes(_response);
        });
    }

    protected processRecipe_UpsertSkioldDigitalRecipes(response: Response): Promise<RecipeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RecipeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecipeDto>(null as any);
    }

    recipe_DeleteSkioldDigitalRecipes(dto: RecipeDto): Promise<RecipeDto> {
        let url_ = this.baseUrl + "/api/Recipe/DeleteSkioldDigitalRecipes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRecipe_DeleteSkioldDigitalRecipes(_response);
        });
    }

    protected processRecipe_DeleteSkioldDigitalRecipes(response: Response): Promise<RecipeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RecipeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecipeDto>(null as any);
    }

    registrationError_Post(error: RegistrationErrorDto, modelString: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/RegistrationError?";
        if (modelString !== undefined && modelString !== null)
            url_ += "modelString=" + encodeURIComponent("" + modelString) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(error);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRegistrationError_Post(_response);
        });
    }

    protected processRegistrationError_Post(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    registrationError_UnsavedData(unsavedData: any[]): Promise<void> {
        let url_ = this.baseUrl + "/api/RegistrationError/UnsavedData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(unsavedData);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRegistrationError_UnsavedData(_response);
        });
    }

    protected processRegistrationError_UnsavedData(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    weekReport_GetWeekReport(request: WeekReportRequest): Promise<WeekReportTableModel> {
        let url_ = this.baseUrl + "/api/WeekReport/GetWeekReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processWeekReport_GetWeekReport(_response);
        });
    }

    protected processWeekReport_GetWeekReport(response: Response): Promise<WeekReportTableModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WeekReportTableModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WeekReportTableModel>(null as any);
    }

    weekReport_GetWeekReportPdf(request: WeekReportRequest, timeZoneId: string | null | undefined, lang: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/WeekReport/GetWeekReportPdf?";
        if (timeZoneId !== undefined && timeZoneId !== null)
            url_ += "timeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processWeekReport_GetWeekReportPdf(_response);
        });
    }

    protected processWeekReport_GetWeekReportPdf(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    retryEsf_ResendEsf(stemAnimalIds: string[], siteId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/RetryEsf/ResendEsf?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(stemAnimalIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRetryEsf_ResendEsf(_response);
        });
    }

    protected processRetryEsf_ResendEsf(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    retryEsf_GetEsfCloudToDeviceMessages(siteId: string | null | undefined, fromDate: Date | undefined, toDate: Date | undefined): Promise<EsfCloudToDeviceMessage[]> {
        let url_ = this.baseUrl + "/api/RetryEsf/GetEsfCloudToDeviceMessages?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRetryEsf_GetEsfCloudToDeviceMessages(_response);
        });
    }

    protected processRetryEsf_GetEsfCloudToDeviceMessages(response: Response): Promise<EsfCloudToDeviceMessage[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EsfCloudToDeviceMessage.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EsfCloudToDeviceMessage[]>(null as any);
    }

    retryEsf_GetEsfCloudToDeviceMessageByIds(ids: string[]): Promise<EsfCloudToDeviceMessage[]> {
        let url_ = this.baseUrl + "/api/RetryEsf/GetEsfCloudToDeviceMessageByIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRetryEsf_GetEsfCloudToDeviceMessageByIds(_response);
        });
    }

    protected processRetryEsf_GetEsfCloudToDeviceMessageByIds(response: Response): Promise<EsfCloudToDeviceMessage[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EsfCloudToDeviceMessage.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EsfCloudToDeviceMessage[]>(null as any);
    }

    retryEsf_ResendEsfC2M(id: string | null | undefined, status: CloudToDeviceStatusEnum | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/RetryEsf/ResendEsfC2M?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRetryEsf_ResendEsfC2M(_response);
        });
    }

    protected processRetryEsf_ResendEsfC2M(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    retryEsf_ResendCycleDays(stemAnimalIds: string[]): Promise<void> {
        let url_ = this.baseUrl + "/api/RetryEsf/ResendCycleDays";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(stemAnimalIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRetryEsf_ResendCycleDays(_response);
        });
    }

    protected processRetryEsf_ResendCycleDays(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    sections_GetAll(): Promise<SectionV2[]> {
        let url_ = this.baseUrl + "/api/Sections";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSections_GetAll(_response);
        });
    }

    protected processSections_GetAll(response: Response): Promise<SectionV2[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SectionV2.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SectionV2[]>(null as any);
    }

    sections_Upsert(value: SectionV2): Promise<string> {
        let url_ = this.baseUrl + "/api/Sections";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSections_Upsert(_response);
        });
    }

    protected processSections_Upsert(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    sections_Get(id: string | null): Promise<SectionV2> {
        let url_ = this.baseUrl + "/api/Sections/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSections_Get(_response);
        });
    }

    protected processSections_Get(response: Response): Promise<SectionV2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SectionV2.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SectionV2>(null as any);
    }

    sections_Delete(id: string | null): Promise<void> {
        let url_ = this.baseUrl + "/api/Sections/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSections_Delete(_response);
        });
    }

    protected processSections_Delete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    sections_Upsert2(value: SectionV2): Promise<string> {
        let url_ = this.baseUrl + "/api/Sections/UpsertAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSections_Upsert2(_response);
        });
    }

    protected processSections_Upsert2(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    sectionsV2_GetAll(): Promise<Section[]> {
        let url_ = this.baseUrl + "/api/SectionsV2";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSectionsV2_GetAll(_response);
        });
    }

    protected processSectionsV2_GetAll(response: Response): Promise<Section[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Section.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Section[]>(null as any);
    }

    sectionsV2_Upsert(value: Section): Promise<string> {
        let url_ = this.baseUrl + "/api/SectionsV2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSectionsV2_Upsert(_response);
        });
    }

    protected processSectionsV2_Upsert(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    sectionsV2_Get(id: string | null): Promise<Section> {
        let url_ = this.baseUrl + "/api/SectionsV2/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSectionsV2_Get(_response);
        });
    }

    protected processSectionsV2_Get(response: Response): Promise<Section> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Section.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Section>(null as any);
    }

    sectionsV2_Delete(id: string | null): Promise<void> {
        let url_ = this.baseUrl + "/api/SectionsV2/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSectionsV2_Delete(_response);
        });
    }

    protected processSectionsV2_Delete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    sectionsV2_Upsert2(value: Section): Promise<string> {
        let url_ = this.baseUrl + "/api/SectionsV2/UpsertAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSectionsV2_Upsert2(_response);
        });
    }

    protected processSectionsV2_Upsert2(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    sites_GetV1(id: string | null): Promise<SiteV1> {
        let url_ = this.baseUrl + "/api/Sites/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSites_GetV1(_response);
        });
    }

    protected processSites_GetV1(response: Response): Promise<SiteV1> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SiteV1.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SiteV1>(null as any);
    }

    sites_Get(id: string | null): Promise<Site> {
        let url_ = this.baseUrl + "/api/Sites/GetSiteV2/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSites_Get(_response);
        });
    }

    protected processSites_Get(response: Response): Promise<Site> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Site.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Site>(null as any);
    }

    sites_PostV1(value: SiteV1): Promise<string> {
        let url_ = this.baseUrl + "/api/Sites";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSites_PostV1(_response);
        });
    }

    protected processSites_PostV1(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    sites_PutV1(siteV1: SiteV1): Promise<void> {
        let url_ = this.baseUrl + "/api/Sites";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(siteV1);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSites_PutV1(_response);
        });
    }

    protected processSites_PutV1(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    sites_Post(value: Site): Promise<string> {
        let url_ = this.baseUrl + "/api/Sites/PostV2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSites_Post(_response);
        });
    }

    protected processSites_Post(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    sites_CreateAndRegisterSite(setup: SiteSetupDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/Sites/CreateAndRegisterSite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(setup);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSites_CreateAndRegisterSite(_response);
        });
    }

    protected processSites_CreateAndRegisterSite(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    sites_UpsertV1(siteV1: SiteV1): Promise<string> {
        let url_ = this.baseUrl + "/api/Sites/Upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(siteV1);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSites_UpsertV1(_response);
        });
    }

    protected processSites_UpsertV1(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    sites_Upsert(site: Site): Promise<string> {
        let url_ = this.baseUrl + "/api/Sites/UpsertV2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(site);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSites_Upsert(_response);
        });
    }

    protected processSites_Upsert(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    sites_Put(value: Site): Promise<void> {
        let url_ = this.baseUrl + "/api/Sites/PutV2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSites_Put(_response);
        });
    }

    protected processSites_Put(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    sites_GetModules(id: string | null): Promise<Module[]> {
        let url_ = this.baseUrl + "/api/Sites/{id}/modules";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSites_GetModules(_response);
        });
    }

    protected processSites_GetModules(response: Response): Promise<Module[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Module.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Module[]>(null as any);
    }

    sites_GetUsers(id: string | null): Promise<UserProfile2[]> {
        let url_ = this.baseUrl + "/api/Sites/{id}/users";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSites_GetUsers(_response);
        });
    }

    protected processSites_GetUsers(response: Response): Promise<UserProfile2[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserProfile2.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserProfile2[]>(null as any);
    }

    sites_GetUserAuthorizations(id: string | null): Promise<SiteAuthorizations> {
        let url_ = this.baseUrl + "/api/Sites/{id}/authorizations";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSites_GetUserAuthorizations(_response);
        });
    }

    protected processSites_GetUserAuthorizations(response: Response): Promise<SiteAuthorizations> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SiteAuthorizations.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SiteAuthorizations>(null as any);
    }

    sites_PostUserAuthorization(id: string | null, update: SiteAuthorizationUpdate): Promise<SiteAuthorizations> {
        let url_ = this.baseUrl + "/api/Sites/{id}/authorizations";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(update);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSites_PostUserAuthorization(_response);
        });
    }

    protected processSites_PostUserAuthorization(response: Response): Promise<SiteAuthorizations> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SiteAuthorizations.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SiteAuthorizations>(null as any);
    }

    sites_Post2(id: string | null, licenceId: string | null): Promise<void> {
        let url_ = this.baseUrl + "/api/Sites/{id}/licences/{licenceId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (licenceId === undefined || licenceId === null)
            throw new Error("The parameter 'licenceId' must be defined.");
        url_ = url_.replace("{licenceId}", encodeURIComponent("" + licenceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSites_Post2(_response);
        });
    }

    protected processSites_Post2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    sites_GetByProfileV1(profileId: string | null | undefined): Promise<SiteV1> {
        let url_ = this.baseUrl + "/api/Sites/GetByProfile?";
        if (profileId !== undefined && profileId !== null)
            url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSites_GetByProfileV1(_response);
        });
    }

    protected processSites_GetByProfileV1(response: Response): Promise<SiteV1> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SiteV1.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SiteV1>(null as any);
    }

    sites_GetByProfile(profileId: string | null | undefined): Promise<Site> {
        let url_ = this.baseUrl + "/api/Sites/GetByProfileV2?";
        if (profileId !== undefined && profileId !== null)
            url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSites_GetByProfile(_response);
        });
    }

    protected processSites_GetByProfile(response: Response): Promise<Site> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Site.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Site>(null as any);
    }

    sites_FetchSkioldDigitalSitesInformation(): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Sites/FetchSkioldDigitalSitesInformation";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSites_FetchSkioldDigitalSitesInformation(_response);
        });
    }

    protected processSites_FetchSkioldDigitalSitesInformation(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    sites_GetAllSites(): Promise<Site[]> {
        let url_ = this.baseUrl + "/api/Sites/GetAllSites";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSites_GetAllSites(_response);
        });
    }

    protected processSites_GetAllSites(response: Response): Promise<Site[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Site.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Site[]>(null as any);
    }

    slaughterHouseConnection_CreateConnection(entity: SlaughterhouseConnectionDto): Promise<SlaughterhouseConnectionDto> {
        let url_ = this.baseUrl + "/api/SlaughterHouseConnection/CreateConnectionAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSlaughterHouseConnection_CreateConnection(_response);
        });
    }

    protected processSlaughterHouseConnection_CreateConnection(response: Response): Promise<SlaughterhouseConnectionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SlaughterhouseConnectionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SlaughterhouseConnectionDto>(null as any);
    }

    slaughterHouseConnection_Post(entity: SlaughterhouseConnectionDto): Promise<SlaughterhouseConnectionDto> {
        let url_ = this.baseUrl + "/api/SlaughterHouseConnection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSlaughterHouseConnection_Post(_response);
        });
    }

    protected processSlaughterHouseConnection_Post(response: Response): Promise<SlaughterhouseConnectionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SlaughterhouseConnectionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SlaughterhouseConnectionDto>(null as any);
    }

    slaughterHouseConnection_Get(id: string | null | undefined): Promise<SlaughterhouseConnectionDto> {
        let url_ = this.baseUrl + "/api/SlaughterHouseConnection?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSlaughterHouseConnection_Get(_response);
        });
    }

    protected processSlaughterHouseConnection_Get(response: Response): Promise<SlaughterhouseConnectionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SlaughterhouseConnectionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SlaughterhouseConnectionDto>(null as any);
    }

    slaughterHouseConnection_Delete(id: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/SlaughterHouseConnection?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSlaughterHouseConnection_Delete(_response);
        });
    }

    protected processSlaughterHouseConnection_Delete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    slaughterHouseConnection_Put(farmNumber: string | null | undefined, encryptedFarmNumber: string | null | undefined, password: string | null | undefined, encryptedPassword: string | null | undefined, supplierNumber: string | null | undefined, slaughterhouse: SlaughterhouseCompany | undefined, lastSyncTime: Date | undefined, refreshToken: string | null | undefined, slaughterHouseConnectionId: string | null | undefined, fromDate: Date | undefined, userNumber: string | null | undefined, lastManuelLogin: Date | null | undefined, lastAutoLogin: Date | null | undefined, registrationError: SlaughterDataRegistrationError | undefined, siteId: string | null | undefined, id: string | null | undefined, createdBy: string | null | undefined, createdOn: Date | null | undefined, modifiedBy: string | null | undefined, modifiedOn: Date | null | undefined, isDeleted: boolean | undefined): Promise<SlaughterhouseConnectionDto> {
        let url_ = this.baseUrl + "/api/SlaughterHouseConnection?";
        if (farmNumber !== undefined && farmNumber !== null)
            url_ += "FarmNumber=" + encodeURIComponent("" + farmNumber) + "&";
        if (encryptedFarmNumber !== undefined && encryptedFarmNumber !== null)
            url_ += "EncryptedFarmNumber=" + encodeURIComponent("" + encryptedFarmNumber) + "&";
        if (password !== undefined && password !== null)
            url_ += "Password=" + encodeURIComponent("" + password) + "&";
        if (encryptedPassword !== undefined && encryptedPassword !== null)
            url_ += "EncryptedPassword=" + encodeURIComponent("" + encryptedPassword) + "&";
        if (supplierNumber !== undefined && supplierNumber !== null)
            url_ += "SupplierNumber=" + encodeURIComponent("" + supplierNumber) + "&";
        if (slaughterhouse === null)
            throw new Error("The parameter 'slaughterhouse' cannot be null.");
        else if (slaughterhouse !== undefined)
            url_ += "Slaughterhouse=" + encodeURIComponent("" + slaughterhouse) + "&";
        if (lastSyncTime === null)
            throw new Error("The parameter 'lastSyncTime' cannot be null.");
        else if (lastSyncTime !== undefined)
            url_ += "LastSyncTime=" + encodeURIComponent(lastSyncTime ? "" + lastSyncTime.toISOString() : "") + "&";
        if (refreshToken !== undefined && refreshToken !== null)
            url_ += "RefreshToken=" + encodeURIComponent("" + refreshToken) + "&";
        if (slaughterHouseConnectionId !== undefined && slaughterHouseConnectionId !== null)
            url_ += "SlaughterHouseConnectionId=" + encodeURIComponent("" + slaughterHouseConnectionId) + "&";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (userNumber !== undefined && userNumber !== null)
            url_ += "UserNumber=" + encodeURIComponent("" + userNumber) + "&";
        if (lastManuelLogin !== undefined && lastManuelLogin !== null)
            url_ += "LastManuelLogin=" + encodeURIComponent(lastManuelLogin ? "" + lastManuelLogin.toISOString() : "") + "&";
        if (lastAutoLogin !== undefined && lastAutoLogin !== null)
            url_ += "LastAutoLogin=" + encodeURIComponent(lastAutoLogin ? "" + lastAutoLogin.toISOString() : "") + "&";
        if (registrationError === null)
            throw new Error("The parameter 'registrationError' cannot be null.");
        else if (registrationError !== undefined)
            url_ += "RegistrationError=" + encodeURIComponent("" + registrationError) + "&";
        if (siteId !== undefined && siteId !== null)
            url_ += "SiteId=" + encodeURIComponent("" + siteId) + "&";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (createdBy !== undefined && createdBy !== null)
            url_ += "CreatedBy=" + encodeURIComponent("" + createdBy) + "&";
        if (createdOn !== undefined && createdOn !== null)
            url_ += "CreatedOn=" + encodeURIComponent(createdOn ? "" + createdOn.toISOString() : "") + "&";
        if (modifiedBy !== undefined && modifiedBy !== null)
            url_ += "ModifiedBy=" + encodeURIComponent("" + modifiedBy) + "&";
        if (modifiedOn !== undefined && modifiedOn !== null)
            url_ += "ModifiedOn=" + encodeURIComponent(modifiedOn ? "" + modifiedOn.toISOString() : "") + "&";
        if (isDeleted === null)
            throw new Error("The parameter 'isDeleted' cannot be null.");
        else if (isDeleted !== undefined)
            url_ += "IsDeleted=" + encodeURIComponent("" + isDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSlaughterHouseConnection_Put(_response);
        });
    }

    protected processSlaughterHouseConnection_Put(response: Response): Promise<SlaughterhouseConnectionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SlaughterhouseConnectionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SlaughterhouseConnectionDto>(null as any);
    }

    slaughterHouseConnection_UpdateWithResetPassword(farmNumber: string | null | undefined, encryptedFarmNumber: string | null | undefined, password: string | null | undefined, encryptedPassword: string | null | undefined, supplierNumber: string | null | undefined, slaughterhouse: SlaughterhouseCompany | undefined, lastSyncTime: Date | undefined, refreshToken: string | null | undefined, slaughterHouseConnectionId: string | null | undefined, fromDate: Date | undefined, userNumber: string | null | undefined, lastManuelLogin: Date | null | undefined, lastAutoLogin: Date | null | undefined, registrationError: SlaughterDataRegistrationError | undefined, siteId: string | null | undefined, id: string | null | undefined, createdBy: string | null | undefined, createdOn: Date | null | undefined, modifiedBy: string | null | undefined, modifiedOn: Date | null | undefined, isDeleted: boolean | undefined): Promise<SlaughterhouseConnectionDto> {
        let url_ = this.baseUrl + "/api/SlaughterHouseConnection/UpdateWithResetPassword?";
        if (farmNumber !== undefined && farmNumber !== null)
            url_ += "FarmNumber=" + encodeURIComponent("" + farmNumber) + "&";
        if (encryptedFarmNumber !== undefined && encryptedFarmNumber !== null)
            url_ += "EncryptedFarmNumber=" + encodeURIComponent("" + encryptedFarmNumber) + "&";
        if (password !== undefined && password !== null)
            url_ += "Password=" + encodeURIComponent("" + password) + "&";
        if (encryptedPassword !== undefined && encryptedPassword !== null)
            url_ += "EncryptedPassword=" + encodeURIComponent("" + encryptedPassword) + "&";
        if (supplierNumber !== undefined && supplierNumber !== null)
            url_ += "SupplierNumber=" + encodeURIComponent("" + supplierNumber) + "&";
        if (slaughterhouse === null)
            throw new Error("The parameter 'slaughterhouse' cannot be null.");
        else if (slaughterhouse !== undefined)
            url_ += "Slaughterhouse=" + encodeURIComponent("" + slaughterhouse) + "&";
        if (lastSyncTime === null)
            throw new Error("The parameter 'lastSyncTime' cannot be null.");
        else if (lastSyncTime !== undefined)
            url_ += "LastSyncTime=" + encodeURIComponent(lastSyncTime ? "" + lastSyncTime.toISOString() : "") + "&";
        if (refreshToken !== undefined && refreshToken !== null)
            url_ += "RefreshToken=" + encodeURIComponent("" + refreshToken) + "&";
        if (slaughterHouseConnectionId !== undefined && slaughterHouseConnectionId !== null)
            url_ += "SlaughterHouseConnectionId=" + encodeURIComponent("" + slaughterHouseConnectionId) + "&";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (userNumber !== undefined && userNumber !== null)
            url_ += "UserNumber=" + encodeURIComponent("" + userNumber) + "&";
        if (lastManuelLogin !== undefined && lastManuelLogin !== null)
            url_ += "LastManuelLogin=" + encodeURIComponent(lastManuelLogin ? "" + lastManuelLogin.toISOString() : "") + "&";
        if (lastAutoLogin !== undefined && lastAutoLogin !== null)
            url_ += "LastAutoLogin=" + encodeURIComponent(lastAutoLogin ? "" + lastAutoLogin.toISOString() : "") + "&";
        if (registrationError === null)
            throw new Error("The parameter 'registrationError' cannot be null.");
        else if (registrationError !== undefined)
            url_ += "RegistrationError=" + encodeURIComponent("" + registrationError) + "&";
        if (siteId !== undefined && siteId !== null)
            url_ += "SiteId=" + encodeURIComponent("" + siteId) + "&";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (createdBy !== undefined && createdBy !== null)
            url_ += "CreatedBy=" + encodeURIComponent("" + createdBy) + "&";
        if (createdOn !== undefined && createdOn !== null)
            url_ += "CreatedOn=" + encodeURIComponent(createdOn ? "" + createdOn.toISOString() : "") + "&";
        if (modifiedBy !== undefined && modifiedBy !== null)
            url_ += "ModifiedBy=" + encodeURIComponent("" + modifiedBy) + "&";
        if (modifiedOn !== undefined && modifiedOn !== null)
            url_ += "ModifiedOn=" + encodeURIComponent(modifiedOn ? "" + modifiedOn.toISOString() : "") + "&";
        if (isDeleted === null)
            throw new Error("The parameter 'isDeleted' cannot be null.");
        else if (isDeleted !== undefined)
            url_ += "IsDeleted=" + encodeURIComponent("" + isDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSlaughterHouseConnection_UpdateWithResetPassword(_response);
        });
    }

    protected processSlaughterHouseConnection_UpdateWithResetPassword(response: Response): Promise<SlaughterhouseConnectionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SlaughterhouseConnectionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SlaughterhouseConnectionDto>(null as any);
    }

    slaughterHouseConnection_GetBySiteId(siteId: string | null | undefined): Promise<SlaughterhouseConnectionDto[]> {
        let url_ = this.baseUrl + "/api/SlaughterHouseConnection/GetBySiteId?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSlaughterHouseConnection_GetBySiteId(_response);
        });
    }

    protected processSlaughterHouseConnection_GetBySiteId(response: Response): Promise<SlaughterhouseConnectionDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SlaughterhouseConnectionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SlaughterhouseConnectionDto[]>(null as any);
    }

    slaughterHouseConnection_GetBySlaughterhouseId(slaughterhouseEnum: SlaughterhouseCompany | undefined, siteId: string | null | undefined): Promise<SlaughterhouseConnectionDto[]> {
        let url_ = this.baseUrl + "/api/SlaughterHouseConnection/GetBySlaughterhouseId?";
        if (slaughterhouseEnum === null)
            throw new Error("The parameter 'slaughterhouseEnum' cannot be null.");
        else if (slaughterhouseEnum !== undefined)
            url_ += "slaughterhouseEnum=" + encodeURIComponent("" + slaughterhouseEnum) + "&";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSlaughterHouseConnection_GetBySlaughterhouseId(_response);
        });
    }

    protected processSlaughterHouseConnection_GetBySlaughterhouseId(response: Response): Promise<SlaughterhouseConnectionDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SlaughterhouseConnectionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SlaughterhouseConnectionDto[]>(null as any);
    }

    slaughterHouseConnection_GenerateRefreshToken(code: string | null | undefined, siteId: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/SlaughterHouseConnection/GenerateRefreshToken?";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSlaughterHouseConnection_GenerateRefreshToken(_response);
        });
    }

    protected processSlaughterHouseConnection_GenerateRefreshToken(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    slaughterHouseConnection_GetDanishCrownAuthState(farmNumber: string | null | undefined, password: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SlaughterHouseConnection/GetDanishCrownAuthState?";
        if (farmNumber !== undefined && farmNumber !== null)
            url_ += "farmNumber=" + encodeURIComponent("" + farmNumber) + "&";
        if (password !== undefined && password !== null)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSlaughterHouseConnection_GetDanishCrownAuthState(_response);
        });
    }

    protected processSlaughterHouseConnection_GetDanishCrownAuthState(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    slaughterHouse_GetConnectedFarms(): Promise<SlaughterhouseConnectionDto[]> {
        let url_ = this.baseUrl + "/api/SlaughterHouse/GetConnectedFarms";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSlaughterHouse_GetConnectedFarms(_response);
        });
    }

    protected processSlaughterHouse_GetConnectedFarms(response: Response): Promise<SlaughterhouseConnectionDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SlaughterhouseConnectionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SlaughterhouseConnectionDto[]>(null as any);
    }

    slaughterHouse_CreateSlaughterData(listDatas: SlaughterData[]): Promise<void> {
        let url_ = this.baseUrl + "/api/SlaughterHouse/CreateSlaughterData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listDatas);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSlaughterHouse_CreateSlaughterData(_response);
        });
    }

    protected processSlaughterHouse_CreateSlaughterData(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    slaughterHouse_SaveNewRefreshToken(code: string | null | undefined, siteId: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/SlaughterHouse/SaveNewRefreshToken?";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSlaughterHouse_SaveNewRefreshToken(_response);
        });
    }

    protected processSlaughterHouse_SaveNewRefreshToken(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    slaughterHouseData_GetSlaughterHouseDataSiteData(siteId: string | null | undefined, dateFrom: Date | undefined, dateTo: Date | undefined): Promise<SlaughterSiteDataDto[]> {
        let url_ = this.baseUrl + "/api/SlaughterHouseData/GetSlaughterHouseDataSiteData?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSlaughterHouseData_GetSlaughterHouseDataSiteData(_response);
        });
    }

    protected processSlaughterHouseData_GetSlaughterHouseDataSiteData(response: Response): Promise<SlaughterSiteDataDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SlaughterSiteDataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SlaughterSiteDataDto[]>(null as any);
    }

    slaughterHouseData_UpdateSlaughterDataLocation(listDatas: string[], buildingId: string | null | undefined, sectionId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/SlaughterHouseData/UpdateSlaughterDataLocation?";
        if (buildingId !== undefined && buildingId !== null)
            url_ += "BuildingId=" + encodeURIComponent("" + buildingId) + "&";
        if (sectionId !== undefined && sectionId !== null)
            url_ += "SectionId=" + encodeURIComponent("" + sectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listDatas);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSlaughterHouseData_UpdateSlaughterDataLocation(_response);
        });
    }

    protected processSlaughterHouseData_UpdateSlaughterDataLocation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    slaughterHouseData_DeleteManySlaughterData(listDatas: string[]): Promise<void> {
        let url_ = this.baseUrl + "/api/SlaughterHouseData/DeleteManySlaughterData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listDatas);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSlaughterHouseData_DeleteManySlaughterData(_response);
        });
    }

    protected processSlaughterHouseData_DeleteManySlaughterData(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    slaughterHouseDataPdf_GetSlaughterHouseDataOverviewPdf(data: SlaughterHouseDataOverviewDto[], siteId: string | null | undefined, timeZoneId: string | null | undefined, lang: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/SlaughterHouseDataPdf/GetSlaughterHouseDataOverviewPdf?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (timeZoneId !== undefined && timeZoneId !== null)
            url_ += "timeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSlaughterHouseDataPdf_GetSlaughterHouseDataOverviewPdf(_response);
        });
    }

    protected processSlaughterHouseDataPdf_GetSlaughterHouseDataOverviewPdf(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    slaughterHouseDataPdf_GetSlaughterHouseDataRowModalPdf(data: SlaughterHouseDataRowModalDto[], siteId: string | null | undefined, timeZoneId: string | null | undefined, extraHeader: string | null | undefined, lang: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/SlaughterHouseDataPdf/GetSlaughterHouseDataRowModalPdf?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (timeZoneId !== undefined && timeZoneId !== null)
            url_ += "timeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        if (extraHeader !== undefined && extraHeader !== null)
            url_ += "extraHeader=" + encodeURIComponent("" + extraHeader) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSlaughterHouseDataPdf_GetSlaughterHouseDataRowModalPdf(_response);
        });
    }

    protected processSlaughterHouseDataPdf_GetSlaughterHouseDataRowModalPdf(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    station_GetbySiteId(siteId: string | null | undefined, lastSyncDate: Date | undefined): Promise<SyncStation> {
        let url_ = this.baseUrl + "/api/Station?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (lastSyncDate === null)
            throw new Error("The parameter 'lastSyncDate' cannot be null.");
        else if (lastSyncDate !== undefined)
            url_ += "lastSyncDate=" + encodeURIComponent(lastSyncDate ? "" + lastSyncDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processStation_GetbySiteId(_response);
        });
    }

    protected processStation_GetbySiteId(response: Response): Promise<SyncStation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SyncStation.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncStation>(null as any);
    }

    stemAnimal_UpsertAnimal(animal: StemAnimal, feedCurveNumber: string | null | undefined, fixedDeviation: number | null | undefined, deviationPeriod: number | null | undefined, tempFeedDeviation: number | null | undefined, hasIdSwap: boolean | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/StemAnimal/UpsertAnimal?";
        if (feedCurveNumber !== undefined && feedCurveNumber !== null)
            url_ += "feedCurveNumber=" + encodeURIComponent("" + feedCurveNumber) + "&";
        if (fixedDeviation !== undefined && fixedDeviation !== null)
            url_ += "fixedDeviation=" + encodeURIComponent("" + fixedDeviation) + "&";
        if (deviationPeriod !== undefined && deviationPeriod !== null)
            url_ += "deviationPeriod=" + encodeURIComponent("" + deviationPeriod) + "&";
        if (tempFeedDeviation !== undefined && tempFeedDeviation !== null)
            url_ += "tempFeedDeviation=" + encodeURIComponent("" + tempFeedDeviation) + "&";
        if (hasIdSwap === null)
            throw new Error("The parameter 'hasIdSwap' cannot be null.");
        else if (hasIdSwap !== undefined)
            url_ += "hasIdSwap=" + encodeURIComponent("" + hasIdSwap) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(animal);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processStemAnimal_UpsertAnimal(_response);
        });
    }

    protected processStemAnimal_UpsertAnimal(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    stemAnimal_Post(animal: StemAnimal, feedCurveNumber: string | null | undefined, fixedDeviation: number | null | undefined, hasIdSwap: boolean | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/StemAnimal?";
        if (feedCurveNumber !== undefined && feedCurveNumber !== null)
            url_ += "feedCurveNumber=" + encodeURIComponent("" + feedCurveNumber) + "&";
        if (fixedDeviation !== undefined && fixedDeviation !== null)
            url_ += "fixedDeviation=" + encodeURIComponent("" + fixedDeviation) + "&";
        if (hasIdSwap === null)
            throw new Error("The parameter 'hasIdSwap' cannot be null.");
        else if (hasIdSwap !== undefined)
            url_ += "hasIdSwap=" + encodeURIComponent("" + hasIdSwap) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(animal);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processStemAnimal_Post(_response);
        });
    }

    protected processStemAnimal_Post(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    stemAnimal_ImportYoungAnimals(fileBase64: ImportFileData): Promise<StemAnimal[]> {
        let url_ = this.baseUrl + "/api/StemAnimal/ImportYoungAnimals";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fileBase64);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processStemAnimal_ImportYoungAnimals(_response);
        });
    }

    protected processStemAnimal_ImportYoungAnimals(response: Response): Promise<StemAnimal[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StemAnimal.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StemAnimal[]>(null as any);
    }

    stemAnimal_Sync(siteId: string | null | undefined, lastSyncDate: Date | undefined): Promise<SyncDataStemAnimal> {
        let url_ = this.baseUrl + "/api/StemAnimal/Sync?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (lastSyncDate === null)
            throw new Error("The parameter 'lastSyncDate' cannot be null.");
        else if (lastSyncDate !== undefined)
            url_ += "lastSyncDate=" + encodeURIComponent(lastSyncDate ? "" + lastSyncDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processStemAnimal_Sync(_response);
        });
    }

    protected processStemAnimal_Sync(response: Response): Promise<SyncDataStemAnimal> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SyncDataStemAnimal.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncDataStemAnimal>(null as any);
    }

    stemAnimal_GetDeparturedAnimalsBySiteId(siteId: string | null | undefined): Promise<StemAnimal[]> {
        let url_ = this.baseUrl + "/api/StemAnimal/GetDeparturedAnimalsBySiteId?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processStemAnimal_GetDeparturedAnimalsBySiteId(_response);
        });
    }

    protected processStemAnimal_GetDeparturedAnimalsBySiteId(response: Response): Promise<StemAnimal[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StemAnimal.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StemAnimal[]>(null as any);
    }

    stemAnimal_FetchSingleAnimalInfo(stemAnimalId: string | null | undefined): Promise<SingleStemAnimalInfo> {
        let url_ = this.baseUrl + "/api/StemAnimal/FetchSingleAnimalInfo?";
        if (stemAnimalId !== undefined && stemAnimalId !== null)
            url_ += "stemAnimalId=" + encodeURIComponent("" + stemAnimalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processStemAnimal_FetchSingleAnimalInfo(_response);
        });
    }

    protected processStemAnimal_FetchSingleAnimalInfo(response: Response): Promise<SingleStemAnimalInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SingleStemAnimalInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SingleStemAnimalInfo>(null as any);
    }

    stemAnimal_DeleteYoungAnimalsByIds(youngAnimalIds: string[], siteId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/StemAnimal/DeleteYoungAnimalsByIds?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(youngAnimalIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processStemAnimal_DeleteYoungAnimalsByIds(_response);
        });
    }

    protected processStemAnimal_DeleteYoungAnimalsByIds(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    stemAnimal_UpdateYoungAnimal(animal: StemAnimal): Promise<string> {
        let url_ = this.baseUrl + "/api/StemAnimal/UpdateYoungAnimal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(animal);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processStemAnimal_UpdateYoungAnimal(_response);
        });
    }

    protected processStemAnimal_UpdateYoungAnimal(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    stemAnimal_UpsertManyYoungAnimals(animals: StemAnimal[]): Promise<StemAnimal[]> {
        let url_ = this.baseUrl + "/api/StemAnimal/UpsertManyYoungAnimals";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(animals);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processStemAnimal_UpsertManyYoungAnimals(_response);
        });
    }

    protected processStemAnimal_UpsertManyYoungAnimals(response: Response): Promise<StemAnimal[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StemAnimal.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StemAnimal[]>(null as any);
    }

    stemAnimal_GetAllIdNumbers(): Promise<string> {
        let url_ = this.baseUrl + "/api/StemAnimal/GetAllIdNumbers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processStemAnimal_GetAllIdNumbers(_response);
        });
    }

    protected processStemAnimal_GetAllIdNumbers(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    stemAnimal_GetDeparturedAnimalDataByDate(siteId: string | null | undefined, fromDate: Date | undefined, toTime: Date | undefined): Promise<DepartedAnimalData> {
        let url_ = this.baseUrl + "/api/StemAnimal/GetDeparturedAnimalDataByDate?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toTime === null)
            throw new Error("The parameter 'toTime' cannot be null.");
        else if (toTime !== undefined)
            url_ += "toTime=" + encodeURIComponent(toTime ? "" + toTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processStemAnimal_GetDeparturedAnimalDataByDate(_response);
        });
    }

    protected processStemAnimal_GetDeparturedAnimalDataByDate(response: Response): Promise<DepartedAnimalData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DepartedAnimalData.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DepartedAnimalData>(null as any);
    }

    stemAnimal_GetActiveYoungReportData(siteId: string | null | undefined, date: Date | undefined): Promise<YoungFemaleReportData> {
        let url_ = this.baseUrl + "/api/StemAnimal/GetActiveYoungReportData?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processStemAnimal_GetActiveYoungReportData(_response);
        });
    }

    protected processStemAnimal_GetActiveYoungReportData(response: Response): Promise<YoungFemaleReportData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = YoungFemaleReportData.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<YoungFemaleReportData>(null as any);
    }

    stemAnimal_CountFromYoung(siteId: string | null | undefined, date: Date | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/StemAnimal/CountFromYoung?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processStemAnimal_CountFromYoung(_response);
        });
    }

    protected processStemAnimal_CountFromYoung(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    stemAnimal_UpdateDistriwinValveAdjustments(valveAdjustments: DistriwinValveAdjustments): Promise<void> {
        let url_ = this.baseUrl + "/api/StemAnimal/UpdateDistriwinValveAdjustments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(valveAdjustments);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processStemAnimal_UpdateDistriwinValveAdjustments(_response);
        });
    }

    protected processStemAnimal_UpdateDistriwinValveAdjustments(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    supplierDetail_Post(entity: SupplierDetailDto): Promise<SupplierDetailDto> {
        let url_ = this.baseUrl + "/api/SupplierDetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSupplierDetail_Post(_response);
        });
    }

    protected processSupplierDetail_Post(response: Response): Promise<SupplierDetailDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupplierDetailDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SupplierDetailDto>(null as any);
    }

    supplierDetail_Get(id: string | null | undefined): Promise<SupplierDetailDto> {
        let url_ = this.baseUrl + "/api/SupplierDetail?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSupplierDetail_Get(_response);
        });
    }

    protected processSupplierDetail_Get(response: Response): Promise<SupplierDetailDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupplierDetailDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SupplierDetailDto>(null as any);
    }

    supplierDetail_Delete(id: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/SupplierDetail?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSupplierDetail_Delete(_response);
        });
    }

    protected processSupplierDetail_Delete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    supplierDetail_Put(slaughterhouseCompany: SlaughterhouseCompany | null | undefined, fromDate: Date | undefined, toDate: Date | undefined, buildingId: string | null | undefined, sectionId: string | null | undefined, supplierNumber: string | null | undefined, slaughterHouseConnectionId: string | null | undefined, registrationError: SlaughterDataRegistrationError | undefined, siteId: string | null | undefined, id: string | null | undefined, createdBy: string | null | undefined, createdOn: Date | null | undefined, modifiedBy: string | null | undefined, modifiedOn: Date | null | undefined, isDeleted: boolean | undefined): Promise<SupplierDetailDto> {
        let url_ = this.baseUrl + "/api/SupplierDetail?";
        if (slaughterhouseCompany !== undefined && slaughterhouseCompany !== null)
            url_ += "SlaughterhouseCompany=" + encodeURIComponent("" + slaughterhouseCompany) + "&";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (buildingId !== undefined && buildingId !== null)
            url_ += "BuildingId=" + encodeURIComponent("" + buildingId) + "&";
        if (sectionId !== undefined && sectionId !== null)
            url_ += "SectionId=" + encodeURIComponent("" + sectionId) + "&";
        if (supplierNumber !== undefined && supplierNumber !== null)
            url_ += "SupplierNumber=" + encodeURIComponent("" + supplierNumber) + "&";
        if (slaughterHouseConnectionId !== undefined && slaughterHouseConnectionId !== null)
            url_ += "SlaughterHouseConnectionId=" + encodeURIComponent("" + slaughterHouseConnectionId) + "&";
        if (registrationError === null)
            throw new Error("The parameter 'registrationError' cannot be null.");
        else if (registrationError !== undefined)
            url_ += "RegistrationError=" + encodeURIComponent("" + registrationError) + "&";
        if (siteId !== undefined && siteId !== null)
            url_ += "SiteId=" + encodeURIComponent("" + siteId) + "&";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (createdBy !== undefined && createdBy !== null)
            url_ += "CreatedBy=" + encodeURIComponent("" + createdBy) + "&";
        if (createdOn !== undefined && createdOn !== null)
            url_ += "CreatedOn=" + encodeURIComponent(createdOn ? "" + createdOn.toISOString() : "") + "&";
        if (modifiedBy !== undefined && modifiedBy !== null)
            url_ += "ModifiedBy=" + encodeURIComponent("" + modifiedBy) + "&";
        if (modifiedOn !== undefined && modifiedOn !== null)
            url_ += "ModifiedOn=" + encodeURIComponent(modifiedOn ? "" + modifiedOn.toISOString() : "") + "&";
        if (isDeleted === null)
            throw new Error("The parameter 'isDeleted' cannot be null.");
        else if (isDeleted !== undefined)
            url_ += "IsDeleted=" + encodeURIComponent("" + isDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSupplierDetail_Put(_response);
        });
    }

    protected processSupplierDetail_Put(response: Response): Promise<SupplierDetailDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupplierDetailDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SupplierDetailDto>(null as any);
    }

    supplierDetail_GetBySiteId(siteId: string | null | undefined): Promise<SupplierDetailDto[]> {
        let url_ = this.baseUrl + "/api/SupplierDetail/GetBySiteId?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSupplierDetail_GetBySiteId(_response);
        });
    }

    protected processSupplierDetail_GetBySiteId(response: Response): Promise<SupplierDetailDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SupplierDetailDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SupplierDetailDto[]>(null as any);
    }

    sync_GetSyncModel(syncParams: SyncParams): Promise<SyncModel> {
        let url_ = this.baseUrl + "/api/Sync/GetSyncData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(syncParams);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSync_GetSyncModel(_response);
        });
    }

    protected processSync_GetSyncModel(response: Response): Promise<SyncModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SyncModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncModel>(null as any);
    }

    treatment_Post(treatment: Treatment): Promise<string> {
        let url_ = this.baseUrl + "/api/Treatment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(treatment);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTreatment_Post(_response);
        });
    }

    protected processTreatment_Post(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    treatment_CreateTreatments(treatments: Treatment[]): Promise<string[]> {
        let url_ = this.baseUrl + "/api/Treatment/CreateTreatments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(treatments);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTreatment_CreateTreatments(_response);
        });
    }

    protected processTreatment_CreateTreatments(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    treatment_Post2(treatmentAndPlan: TreatmentAndTreatmentPlan): Promise<string> {
        let url_ = this.baseUrl + "/api/Treatment/PostV2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(treatmentAndPlan);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTreatment_Post2(_response);
        });
    }

    protected processTreatment_Post2(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    treatment_CreateTreatments2(treatmentAndPlan: TreatmentAndTreatmentPlanList): Promise<string[]> {
        let url_ = this.baseUrl + "/api/Treatment/CreateTreatmentsV2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(treatmentAndPlan);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTreatment_CreateTreatments2(_response);
        });
    }

    protected processTreatment_CreateTreatments2(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    treatment_SaveManyTreatments(treatments: Treatment[]): Promise<string[]> {
        let url_ = this.baseUrl + "/api/Treatment/SaveManyTreatments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(treatments);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTreatment_SaveManyTreatments(_response);
        });
    }

    protected processTreatment_SaveManyTreatments(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    treatment_GetBySiteId(siteId: string | null | undefined): Promise<Treatment[]> {
        let url_ = this.baseUrl + "/api/Treatment/GetBySiteId?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTreatment_GetBySiteId(_response);
        });
    }

    protected processTreatment_GetBySiteId(response: Response): Promise<Treatment[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Treatment.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Treatment[]>(null as any);
    }

    treatment_GetByStemAnimalId(stemAnimalId: string | null | undefined): Promise<Treatment[]> {
        let url_ = this.baseUrl + "/api/Treatment/GetByStemAnimalId?";
        if (stemAnimalId !== undefined && stemAnimalId !== null)
            url_ += "stemAnimalId=" + encodeURIComponent("" + stemAnimalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTreatment_GetByStemAnimalId(_response);
        });
    }

    protected processTreatment_GetByStemAnimalId(response: Response): Promise<Treatment[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Treatment.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Treatment[]>(null as any);
    }

    treatment_GetCompletedBySiteId(siteId: string | null | undefined, utcStart: Date | undefined, utcEnd: Date | undefined): Promise<Treatment[]> {
        let url_ = this.baseUrl + "/api/Treatment/GetCompletedBySiteId?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (utcStart === null)
            throw new Error("The parameter 'utcStart' cannot be null.");
        else if (utcStart !== undefined)
            url_ += "utcStart=" + encodeURIComponent(utcStart ? "" + utcStart.toISOString() : "") + "&";
        if (utcEnd === null)
            throw new Error("The parameter 'utcEnd' cannot be null.");
        else if (utcEnd !== undefined)
            url_ += "utcEnd=" + encodeURIComponent(utcEnd ? "" + utcEnd.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTreatment_GetCompletedBySiteId(_response);
        });
    }

    protected processTreatment_GetCompletedBySiteId(response: Response): Promise<Treatment[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Treatment.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Treatment[]>(null as any);
    }

    treatment_Sync(siteId: string | null | undefined, lastSyncDate: Date | undefined): Promise<SyncDataTreatment> {
        let url_ = this.baseUrl + "/api/Treatment/Sync?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (lastSyncDate === null)
            throw new Error("The parameter 'lastSyncDate' cannot be null.");
        else if (lastSyncDate !== undefined)
            url_ += "lastSyncDate=" + encodeURIComponent(lastSyncDate ? "" + lastSyncDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTreatment_Sync(_response);
        });
    }

    protected processTreatment_Sync(response: Response): Promise<SyncDataTreatment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SyncDataTreatment.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncDataTreatment>(null as any);
    }

    treatmentDefinition_Post(entity: TreatmentDefinition, isVaccination: boolean | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/TreatmentDefinition?";
        if (isVaccination === null)
            throw new Error("The parameter 'isVaccination' cannot be null.");
        else if (isVaccination !== undefined)
            url_ += "isVaccination=" + encodeURIComponent("" + isVaccination) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTreatmentDefinition_Post(_response);
        });
    }

    protected processTreatmentDefinition_Post(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    treatmentDefinition_GetTreatmentDefinitionsBySiteId(siteId: string | null | undefined): Promise<TreatmentDefinition[]> {
        let url_ = this.baseUrl + "/api/TreatmentDefinition/GetTreatmentDefinitionsBySiteId?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTreatmentDefinition_GetTreatmentDefinitionsBySiteId(_response);
        });
    }

    protected processTreatmentDefinition_GetTreatmentDefinitionsBySiteId(response: Response): Promise<TreatmentDefinition[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TreatmentDefinition.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TreatmentDefinition[]>(null as any);
    }

    treatmentDefinition_Sync(siteId: string | null | undefined, lastSyncDate: Date | undefined): Promise<SyncDataTreatmentDefinition> {
        let url_ = this.baseUrl + "/api/TreatmentDefinition/Sync?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (lastSyncDate === null)
            throw new Error("The parameter 'lastSyncDate' cannot be null.");
        else if (lastSyncDate !== undefined)
            url_ += "lastSyncDate=" + encodeURIComponent(lastSyncDate ? "" + lastSyncDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTreatmentDefinition_Sync(_response);
        });
    }

    protected processTreatmentDefinition_Sync(response: Response): Promise<SyncDataTreatmentDefinition> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SyncDataTreatmentDefinition.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncDataTreatmentDefinition>(null as any);
    }

    treatmentDefinition_GetArchivedTreatmentDefinitionsBySiteId(siteId: string | null | undefined): Promise<TreatmentDefinition[]> {
        let url_ = this.baseUrl + "/api/TreatmentDefinition/GetArchivedTreatmentDefinitionsBySiteId?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTreatmentDefinition_GetArchivedTreatmentDefinitionsBySiteId(_response);
        });
    }

    protected processTreatmentDefinition_GetArchivedTreatmentDefinitionsBySiteId(response: Response): Promise<TreatmentDefinition[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TreatmentDefinition.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TreatmentDefinition[]>(null as any);
    }

    treatmentDefinition_ArchiveTreatmentDefinition(treatmentDefinition: TreatmentDefinition): Promise<TreatmentDefinition> {
        let url_ = this.baseUrl + "/api/TreatmentDefinition/ArchiveTreatmentDefinition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(treatmentDefinition);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTreatmentDefinition_ArchiveTreatmentDefinition(_response);
        });
    }

    protected processTreatmentDefinition_ArchiveTreatmentDefinition(response: Response): Promise<TreatmentDefinition> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TreatmentDefinition.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TreatmentDefinition>(null as any);
    }

    treatmentDefinition_DeArchiveTreatmentDefinition(treatmentDefinition: TreatmentDefinition): Promise<TreatmentDefinition> {
        let url_ = this.baseUrl + "/api/TreatmentDefinition/DeArchiveTreatmentDefinition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(treatmentDefinition);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTreatmentDefinition_DeArchiveTreatmentDefinition(_response);
        });
    }

    protected processTreatmentDefinition_DeArchiveTreatmentDefinition(response: Response): Promise<TreatmentDefinition> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TreatmentDefinition.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TreatmentDefinition>(null as any);
    }

    treatmentPlan_Post(plan: TreatmentPlan): Promise<string> {
        let url_ = this.baseUrl + "/api/TreatmentPlan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(plan);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTreatmentPlan_Post(_response);
        });
    }

    protected processTreatmentPlan_Post(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    treatmentPlan_Put(plan: TreatmentPlan): Promise<string> {
        let url_ = this.baseUrl + "/api/TreatmentPlan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(plan);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTreatmentPlan_Put(_response);
        });
    }

    protected processTreatmentPlan_Put(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    treatmentPlan_GetTreatmentPlansBySiteId(siteId: string | null | undefined): Promise<TreatmentPlan[]> {
        let url_ = this.baseUrl + "/api/TreatmentPlan/GetTreatmentPlansBySiteId?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTreatmentPlan_GetTreatmentPlansBySiteId(_response);
        });
    }

    protected processTreatmentPlan_GetTreatmentPlansBySiteId(response: Response): Promise<TreatmentPlan[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TreatmentPlan.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TreatmentPlan[]>(null as any);
    }

    treatmentPlan_GetTreatmentPlansByStemAnimalId(stemAnimalId: string | null | undefined): Promise<TreatmentPlan[]> {
        let url_ = this.baseUrl + "/api/TreatmentPlan/GetTreatmentPlansByStemAnimalId?";
        if (stemAnimalId !== undefined && stemAnimalId !== null)
            url_ += "stemAnimalId=" + encodeURIComponent("" + stemAnimalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTreatmentPlan_GetTreatmentPlansByStemAnimalId(_response);
        });
    }

    protected processTreatmentPlan_GetTreatmentPlansByStemAnimalId(response: Response): Promise<TreatmentPlan[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TreatmentPlan.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TreatmentPlan[]>(null as any);
    }

    treatmentPlan_GetTreatmentPlansWithCompletedBySiteId(siteId: string | null | undefined, utcStart: Date | undefined, utcEnd: Date | undefined): Promise<TreatmentPlan[]> {
        let url_ = this.baseUrl + "/api/TreatmentPlan/GetTreatmentPlansWithCompletedBySiteId?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (utcStart === null)
            throw new Error("The parameter 'utcStart' cannot be null.");
        else if (utcStart !== undefined)
            url_ += "utcStart=" + encodeURIComponent(utcStart ? "" + utcStart.toISOString() : "") + "&";
        if (utcEnd === null)
            throw new Error("The parameter 'utcEnd' cannot be null.");
        else if (utcEnd !== undefined)
            url_ += "utcEnd=" + encodeURIComponent(utcEnd ? "" + utcEnd.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTreatmentPlan_GetTreatmentPlansWithCompletedBySiteId(_response);
        });
    }

    protected processTreatmentPlan_GetTreatmentPlansWithCompletedBySiteId(response: Response): Promise<TreatmentPlan[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TreatmentPlan.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TreatmentPlan[]>(null as any);
    }

    treatmentPlan_Sync(siteId: string | null | undefined, lastSyncDate: Date | undefined): Promise<SyncDataTreatmentPlan> {
        let url_ = this.baseUrl + "/api/TreatmentPlan/Sync?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (lastSyncDate === null)
            throw new Error("The parameter 'lastSyncDate' cannot be null.");
        else if (lastSyncDate !== undefined)
            url_ += "lastSyncDate=" + encodeURIComponent(lastSyncDate ? "" + lastSyncDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTreatmentPlan_Sync(_response);
        });
    }

    protected processTreatmentPlan_Sync(response: Response): Promise<SyncDataTreatmentPlan> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SyncDataTreatmentPlan.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncDataTreatmentPlan>(null as any);
    }

    treatmentPlan_CreateManyTreatmentPlans(treatmentPlans: TreatmentPlan[]): Promise<string[]> {
        let url_ = this.baseUrl + "/api/TreatmentPlan/CreateManyTreatmentPlans";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(treatmentPlans);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTreatmentPlan_CreateManyTreatmentPlans(_response);
        });
    }

    protected processTreatmentPlan_CreateManyTreatmentPlans(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    unknownAnimal_GetUnknownAnimalsBySiteId(siteId: string | null | undefined): Promise<UnknownAnimal[]> {
        let url_ = this.baseUrl + "/api/UnknownAnimal/GetUnknownAnimalsBySiteId?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUnknownAnimal_GetUnknownAnimalsBySiteId(_response);
        });
    }

    protected processUnknownAnimal_GetUnknownAnimalsBySiteId(response: Response): Promise<UnknownAnimal[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UnknownAnimal.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnknownAnimal[]>(null as any);
    }

    unknownAnimal_MapUnknownAnimals(mapUnknownAnimalModels: MapUnknownAnimalModel[]): Promise<string[]> {
        let url_ = this.baseUrl + "/api/UnknownAnimal/MapUnknownAnimals";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(mapUnknownAnimalModels);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUnknownAnimal_MapUnknownAnimals(_response);
        });
    }

    protected processUnknownAnimal_MapUnknownAnimals(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    userProfile_Sync(siteId: string | null | undefined, lastSyncDate: Date | undefined): Promise<SyncDataUserProfile> {
        let url_ = this.baseUrl + "/api/UserProfile/Sync?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (lastSyncDate === null)
            throw new Error("The parameter 'lastSyncDate' cannot be null.");
        else if (lastSyncDate !== undefined)
            url_ += "lastSyncDate=" + encodeURIComponent(lastSyncDate ? "" + lastSyncDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUserProfile_Sync(_response);
        });
    }

    protected processUserProfile_Sync(response: Response): Promise<SyncDataUserProfile> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SyncDataUserProfile.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncDataUserProfile>(null as any);
    }

    userProfile_UpdateInitials(id: string | null | undefined, initials: string | null | undefined): Promise<UserProfile2> {
        let url_ = this.baseUrl + "/api/UserProfile/UpdateInitials?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (initials !== undefined && initials !== null)
            url_ += "initials=" + encodeURIComponent("" + initials) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUserProfile_UpdateInitials(_response);
        });
    }

    protected processUserProfile_UpdateInitials(response: Response): Promise<UserProfile2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserProfile2.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserProfile2>(null as any);
    }

    userProfile_Delete(id: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/UserProfile/Delete?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUserProfile_Delete(_response);
        });
    }

    protected processUserProfile_Delete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    userProfile_Signup(email: string | null | undefined, authId: string | null | undefined, name: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/UserProfile/Signup?";
        if (email !== undefined && email !== null)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        if (authId !== undefined && authId !== null)
            url_ += "AuthId=" + encodeURIComponent("" + authId) + "&";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUserProfile_Signup(_response);
        });
    }

    protected processUserProfile_Signup(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    userProfile_CreateUserAndInviteUser(language: string | null | undefined, aDUserID: string | null | undefined, name: string | null | undefined, email: string | null | undefined, admin: boolean | undefined, initials: string | null | undefined, siteId: string | null | undefined, id: string | null | undefined, createdBy: string | null | undefined, createdOn: Date | null | undefined, modifiedBy: string | null | undefined, modifiedOn: Date | null | undefined, isDeleted: boolean | undefined): Promise<UserProfile2> {
        let url_ = this.baseUrl + "/api/UserProfile/CreateUserAndInviteUser?";
        if (language !== undefined && language !== null)
            url_ += "Language=" + encodeURIComponent("" + language) + "&";
        if (aDUserID !== undefined && aDUserID !== null)
            url_ += "ADUserID=" + encodeURIComponent("" + aDUserID) + "&";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (email !== undefined && email !== null)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        if (admin === null)
            throw new Error("The parameter 'admin' cannot be null.");
        else if (admin !== undefined)
            url_ += "Admin=" + encodeURIComponent("" + admin) + "&";
        if (initials !== undefined && initials !== null)
            url_ += "Initials=" + encodeURIComponent("" + initials) + "&";
        if (siteId !== undefined && siteId !== null)
            url_ += "SiteId=" + encodeURIComponent("" + siteId) + "&";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (createdBy !== undefined && createdBy !== null)
            url_ += "CreatedBy=" + encodeURIComponent("" + createdBy) + "&";
        if (createdOn !== undefined && createdOn !== null)
            url_ += "CreatedOn=" + encodeURIComponent(createdOn ? "" + createdOn.toISOString() : "") + "&";
        if (modifiedBy !== undefined && modifiedBy !== null)
            url_ += "ModifiedBy=" + encodeURIComponent("" + modifiedBy) + "&";
        if (modifiedOn !== undefined && modifiedOn !== null)
            url_ += "ModifiedOn=" + encodeURIComponent(modifiedOn ? "" + modifiedOn.toISOString() : "") + "&";
        if (isDeleted === null)
            throw new Error("The parameter 'isDeleted' cannot be null.");
        else if (isDeleted !== undefined)
            url_ += "IsDeleted=" + encodeURIComponent("" + isDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUserProfile_CreateUserAndInviteUser(_response);
        });
    }

    protected processUserProfile_CreateUserAndInviteUser(response: Response): Promise<UserProfile2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserProfile2.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserProfile2>(null as any);
    }

    userSite_GetUserSitesForUser(): Promise<UserSiteDTO[]> {
        let url_ = this.baseUrl + "/api/UserSite";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUserSite_GetUserSitesForUser(_response);
        });
    }

    protected processUserSite_GetUserSitesForUser(response: Response): Promise<UserSiteDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserSiteDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserSiteDTO[]>(null as any);
    }

    userSite_GetUserSitesForUser2(userId: string | null): Promise<UserSiteDTO[]> {
        let url_ = this.baseUrl + "/api/UserSite/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUserSite_GetUserSitesForUser2(_response);
        });
    }

    protected processUserSite_GetUserSitesForUser2(response: Response): Promise<UserSiteDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserSiteDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserSiteDTO[]>(null as any);
    }

    userSite_RemoveUserSiteAccess(userId: string | null | undefined, siteIds: string[] | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/UserSite/RemoveUserSiteAccess?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (siteIds !== undefined && siteIds !== null)
            siteIds && siteIds.forEach(item => { url_ += "siteIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUserSite_RemoveUserSiteAccess(_response);
        });
    }

    protected processUserSite_RemoveUserSiteAccess(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    vaccinationDefinition_Post(entity: VaccinationDefinition): Promise<string> {
        let url_ = this.baseUrl + "/api/VaccinationDefinition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processVaccinationDefinition_Post(_response);
        });
    }

    protected processVaccinationDefinition_Post(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    vaccinationDefinition_GetBySiteId(siteId: string | null | undefined): Promise<VaccinationDefinition[]> {
        let url_ = this.baseUrl + "/api/VaccinationDefinition/GetBySiteId?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processVaccinationDefinition_GetBySiteId(_response);
        });
    }

    protected processVaccinationDefinition_GetBySiteId(response: Response): Promise<VaccinationDefinition[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VaccinationDefinition.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VaccinationDefinition[]>(null as any);
    }

    validationSetup_Upsert(value: ValidationSetup): Promise<string> {
        let url_ = this.baseUrl + "/api/ValidationSetup/UpsertAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processValidationSetup_Upsert(_response);
        });
    }

    protected processValidationSetup_Upsert(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    validationSetup_GetBySite(siteId: string | null | undefined): Promise<ValidationSetup> {
        let url_ = this.baseUrl + "/api/ValidationSetup/GetBySite?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processValidationSetup_GetBySite(_response);
        });
    }

    protected processValidationSetup_GetBySite(response: Response): Promise<ValidationSetup> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValidationSetup.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationSetup>(null as any);
    }

    validationSetup_Sync(siteId: string | null | undefined, lastSyncDate: Date | undefined): Promise<SyncDataValidationSetup> {
        let url_ = this.baseUrl + "/api/ValidationSetup/Sync?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (lastSyncDate === null)
            throw new Error("The parameter 'lastSyncDate' cannot be null.");
        else if (lastSyncDate !== undefined)
            url_ += "lastSyncDate=" + encodeURIComponent(lastSyncDate ? "" + lastSyncDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processValidationSetup_Sync(_response);
        });
    }

    protected processValidationSetup_Sync(response: Response): Promise<SyncDataValidationSetup> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SyncDataValidationSetup.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncDataValidationSetup>(null as any);
    }

    valveGroupHistories_GetBySiteIdV1(siteId: string | null | undefined): Promise<ValveGroupHistory[]> {
        let url_ = this.baseUrl + "/api/ValveGroupHistories?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processValveGroupHistories_GetBySiteIdV1(_response);
        });
    }

    protected processValveGroupHistories_GetBySiteIdV1(response: Response): Promise<ValveGroupHistory[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ValveGroupHistory.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValveGroupHistory[]>(null as any);
    }

    valveGroupHistories_GetBySiteIdV2(siteId: string | null | undefined): Promise<ValveGroupHistoryDto[]> {
        let url_ = this.baseUrl + "/api/ValveGroupHistories/GetBySiteIdV2?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processValveGroupHistories_GetBySiteIdV2(_response);
        });
    }

    protected processValveGroupHistories_GetBySiteIdV2(response: Response): Promise<ValveGroupHistoryDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ValveGroupHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValveGroupHistoryDto[]>(null as any);
    }

    valveGroupHistories_GetByValveGroupId(valveGroupId: string | null | undefined): Promise<ValveGroupHistoryV1[]> {
        let url_ = this.baseUrl + "/api/ValveGroupHistories/ByValveGroupId?";
        if (valveGroupId !== undefined && valveGroupId !== null)
            url_ += "valveGroupId=" + encodeURIComponent("" + valveGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processValveGroupHistories_GetByValveGroupId(_response);
        });
    }

    protected processValveGroupHistories_GetByValveGroupId(response: Response): Promise<ValveGroupHistoryV1[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ValveGroupHistoryV1.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValveGroupHistoryV1[]>(null as any);
    }

    valveGroupHistories_GetByValveGroupIdV2(valveGroupId: string | null | undefined): Promise<ValveGroupHistory2[]> {
        let url_ = this.baseUrl + "/api/ValveGroupHistories/ByValveGroupIdV2?";
        if (valveGroupId !== undefined && valveGroupId !== null)
            url_ += "valveGroupId=" + encodeURIComponent("" + valveGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processValveGroupHistories_GetByValveGroupIdV2(_response);
        });
    }

    protected processValveGroupHistories_GetByValveGroupIdV2(response: Response): Promise<ValveGroupHistory2[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ValveGroupHistory2.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValveGroupHistory2[]>(null as any);
    }

    valveGroupHistories_GetByLatestByValveGroupIdV2(valveGroupId: string | null | undefined): Promise<ValveGroupHistory2> {
        let url_ = this.baseUrl + "/api/ValveGroupHistories/LatestByValveGroupIdV2?";
        if (valveGroupId !== undefined && valveGroupId !== null)
            url_ += "valveGroupId=" + encodeURIComponent("" + valveGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processValveGroupHistories_GetByLatestByValveGroupIdV2(_response);
        });
    }

    protected processValveGroupHistories_GetByLatestByValveGroupIdV2(response: Response): Promise<ValveGroupHistory2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValveGroupHistory2.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValveGroupHistory2>(null as any);
    }

    valveGroups_GetAll(): Promise<ValveGroup[]> {
        let url_ = this.baseUrl + "/api/ValveGroups";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processValveGroups_GetAll(_response);
        });
    }

    protected processValveGroups_GetAll(response: Response): Promise<ValveGroup[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ValveGroup.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValveGroup[]>(null as any);
    }

    valveGroups_SyncPOST(value: ValveGroupUpdate[]): Promise<ValveGroupsSyncResponse> {
        let url_ = this.baseUrl + "/api/ValveGroups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processValveGroups_SyncPOST(_response);
        });
    }

    protected processValveGroups_SyncPOST(response: Response): Promise<ValveGroupsSyncResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValveGroupsSyncResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = resultData500 !== undefined ? resultData500 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result503 = resultData503 !== undefined ? resultData503 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result503);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValveGroupsSyncResponse>(null as any);
    }

    valveGroups_Get(id: string | null): Promise<ValveGroup2> {
        let url_ = this.baseUrl + "/api/ValveGroups/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processValveGroups_Get(_response);
        });
    }

    protected processValveGroups_Get(response: Response): Promise<ValveGroup2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValveGroup2.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValveGroup2>(null as any);
    }

    valveGroups_UpdateValveGroup(value: ValveGroupUpdate): Promise<string> {
        let url_ = this.baseUrl + "/api/ValveGroups/UpdateValveGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processValveGroups_UpdateValveGroup(_response);
        });
    }

    protected processValveGroups_UpdateValveGroup(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    valveGroups_DistriwinFullSync(processEquipmentId: string | null | undefined): Promise<{ [key: string]: Date; }> {
        let url_ = this.baseUrl + "/api/ValveGroups/DistriwinFullSync?";
        if (processEquipmentId !== undefined && processEquipmentId !== null)
            url_ += "processEquipmentId=" + encodeURIComponent("" + processEquipmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processValveGroups_DistriwinFullSync(_response);
        });
    }

    protected processValveGroups_DistriwinFullSync(response: Response): Promise<{ [key: string]: Date; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] ? new Date(resultData200[key].toString()) : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: Date; }>(null as any);
    }

    valveGroups_UpdateValveGroupByUpdateDefinition(updates: ValveGroup2[]): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ValveGroups/UpdateValveGroupByUpdateDefinition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updates);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processValveGroups_UpdateValveGroupByUpdateDefinition(_response);
        });
    }

    protected processValveGroups_UpdateValveGroupByUpdateDefinition(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    valveGroups_GetUpdatedValveGroups(dictionary: { [key: string]: Date; }): Promise<number> {
        let url_ = this.baseUrl + "/api/ValveGroups/GetUpdatedValveGroups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dictionary);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processValveGroups_GetUpdatedValveGroups(_response);
        });
    }

    protected processValveGroups_GetUpdatedValveGroups(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    valveGroups_Create(valveGroup: ValveGroup): Promise<string> {
        let url_ = this.baseUrl + "/api/ValveGroups/Upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(valveGroup);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processValveGroups_Create(_response);
        });
    }

    protected processValveGroups_Create(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    valveGroups_SyncGET(siteId: string | null | undefined, lastSyncDate: Date | undefined): Promise<SyncDataValveGroup> {
        let url_ = this.baseUrl + "/api/ValveGroups/Sync?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (lastSyncDate === null)
            throw new Error("The parameter 'lastSyncDate' cannot be null.");
        else if (lastSyncDate !== undefined)
            url_ += "lastSyncDate=" + encodeURIComponent(lastSyncDate ? "" + lastSyncDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processValveGroups_SyncGET(_response);
        });
    }

    protected processValveGroups_SyncGET(response: Response): Promise<SyncDataValveGroup> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SyncDataValveGroup.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncDataValveGroup>(null as any);
    }

    valveGroups_UpdateValveGroupFromDistriwin(value: ValveGroup2): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ValveGroups/UpdateValveGroupFromDistriwin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processValveGroups_UpdateValveGroupFromDistriwin(_response);
        });
    }

    protected processValveGroups_UpdateValveGroupFromDistriwin(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    valveGroups_UpdateMultipleValveGroupFromDistriwin(vgs: ValveGroup2[]): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ValveGroups/UpdateMultipleValveGroupFromDistriwin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vgs);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processValveGroups_UpdateMultipleValveGroupFromDistriwin(_response);
        });
    }

    protected processValveGroups_UpdateMultipleValveGroupFromDistriwin(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    valveGroups_SaveGrowthPigAdjustFeed(siteId: string | null | undefined, adjustFeedUpdate: GrowthPigAdjustFeedUpdate[]): Promise<string> {
        let url_ = this.baseUrl + "/api/ValveGroups/SaveGrowthPigAdjustFeed?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(adjustFeedUpdate);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processValveGroups_SaveGrowthPigAdjustFeed(_response);
        });
    }

    protected processValveGroups_SaveGrowthPigAdjustFeed(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    valves_GetbySiteId(siteId: string | null): Promise<Valve2[]> {
        let url_ = this.baseUrl + "/api/Valves/{siteId}";
        if (siteId === undefined || siteId === null)
            throw new Error("The parameter 'siteId' must be defined.");
        url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processValves_GetbySiteId(_response);
        });
    }

    protected processValves_GetbySiteId(response: Response): Promise<Valve2[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Valve2.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Valve2[]>(null as any);
    }

    valves_Upsert(value: Valve): Promise<string> {
        let url_ = this.baseUrl + "/api/Valves";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processValves_Upsert(_response);
        });
    }

    protected processValves_Upsert(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    valves_Delete(id: string | null): Promise<void> {
        let url_ = this.baseUrl + "/api/Valves/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processValves_Delete(_response);
        });
    }

    protected processValves_Delete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    valveUpdateReport_Post(d: RetryAdjustFeedTableItem[], siteId: string | null | undefined, timeZoneId: string | null | undefined, lang: string | null | undefined, isSow: boolean | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/ValveUpdateReport?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (timeZoneId !== undefined && timeZoneId !== null)
            url_ += "timeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        if (isSow === null)
            throw new Error("The parameter 'isSow' cannot be null.");
        else if (isSow !== undefined)
            url_ += "isSow=" + encodeURIComponent("" + isSow) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(d);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processValveUpdateReport_Post(_response);
        });
    }

    protected processValveUpdateReport_Post(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    valveUpdates_GetValveFieldUpdates(siteId: string | null | undefined): Promise<ValveFieldUpdateDto[]> {
        let url_ = this.baseUrl + "/api/ValveUpdates?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processValveUpdates_GetValveFieldUpdates(_response);
        });
    }

    protected processValveUpdates_GetValveFieldUpdates(response: Response): Promise<ValveFieldUpdateDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ValveFieldUpdateDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValveFieldUpdateDto[]>(null as any);
    }

    valveUpdates_GetValveFieldUpdate(id: string | null): Promise<ValveFieldUpdateDto> {
        let url_ = this.baseUrl + "/api/ValveUpdates/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processValveUpdates_GetValveFieldUpdate(_response);
        });
    }

    protected processValveUpdates_GetValveFieldUpdate(response: Response): Promise<ValveFieldUpdateDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValveFieldUpdateDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValveFieldUpdateDto>(null as any);
    }

    valveUpdates_RetryValveFieldUpdate(id: string | null): Promise<ValveFieldUpdateDto> {
        let url_ = this.baseUrl + "/api/ValveUpdates/{id}/StartRetry";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processValveUpdates_RetryValveFieldUpdate(_response);
        });
    }

    protected processValveUpdates_RetryValveFieldUpdate(response: Response): Promise<ValveFieldUpdateDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValveFieldUpdateDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValveFieldUpdateDto>(null as any);
    }

    valveUpdates_AcknowledgeValveFieldUpdate(id: string | null): Promise<ValveFieldUpdateDto> {
        let url_ = this.baseUrl + "/api/ValveUpdates/{id}/Acknowledge";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processValveUpdates_AcknowledgeValveFieldUpdate(_response);
        });
    }

    protected processValveUpdates_AcknowledgeValveFieldUpdate(response: Response): Promise<ValveFieldUpdateDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValveFieldUpdateDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValveFieldUpdateDto>(null as any);
    }

    valveUpdates_RetryValveFieldUpdates(ids: string[]): Promise<ValveFieldUpdateDto[]> {
        let url_ = this.baseUrl + "/api/ValveUpdates/StartRetry";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processValveUpdates_RetryValveFieldUpdates(_response);
        });
    }

    protected processValveUpdates_RetryValveFieldUpdates(response: Response): Promise<ValveFieldUpdateDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ValveFieldUpdateDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValveFieldUpdateDto[]>(null as any);
    }

    valveUpdates_AcknowledgeValveFieldUpdates(ids: string[]): Promise<ValveFieldUpdateDto[]> {
        let url_ = this.baseUrl + "/api/ValveUpdates/Acknowledge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processValveUpdates_AcknowledgeValveFieldUpdates(_response);
        });
    }

    protected processValveUpdates_AcknowledgeValveFieldUpdates(response: Response): Promise<ValveFieldUpdateDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ValveFieldUpdateDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValveFieldUpdateDto[]>(null as any);
    }

    valveUpdates_GetValveUpdateErrors(siteId: string | null | undefined): Promise<ValveUpdateError[]> {
        let url_ = this.baseUrl + "/api/ValveUpdates/GetValveUpdateErrors?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processValveUpdates_GetValveUpdateErrors(_response);
        });
    }

    protected processValveUpdates_GetValveUpdateErrors(response: Response): Promise<ValveUpdateError[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ValveUpdateError.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValveUpdateError[]>(null as any);
    }

    warnings_Get(): Promise<Notification[]> {
        let url_ = this.baseUrl + "/api/Warnings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processWarnings_Get(_response);
        });
    }

    protected processWarnings_Get(response: Response): Promise<Notification[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Notification.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Notification[]>(null as any);
    }

    warnings_Post(instanceId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/Warnings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(instanceId);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processWarnings_Post(_response);
        });
    }

    protected processWarnings_Post(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    warnings_Sync(lastSyncDate: Date | undefined): Promise<SyncNotifcations> {
        let url_ = this.baseUrl + "/api/Warnings/Sync?";
        if (lastSyncDate === null)
            throw new Error("The parameter 'lastSyncDate' cannot be null.");
        else if (lastSyncDate !== undefined)
            url_ += "lastSyncDate=" + encodeURIComponent(lastSyncDate ? "" + lastSyncDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processWarnings_Sync(_response);
        });
    }

    protected processWarnings_Sync(response: Response): Promise<SyncNotifcations> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SyncNotifcations.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncNotifcations>(null as any);
    }

    workList_GenerateMatingWorkListPdf(matingWorkListTableItems: MatingWorkListTableItem[], siteId: string | null | undefined, timeZoneId: string | null | undefined, lang: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/WorkList/MatingWorkListPdf?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (timeZoneId !== undefined && timeZoneId !== null)
            url_ += "timeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(matingWorkListTableItems);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processWorkList_GenerateMatingWorkListPdf(_response);
        });
    }

    protected processWorkList_GenerateMatingWorkListPdf(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    workList_GenerateFarrowingWorkListPdf(farrowingWorkListTableItems: FarrowingWorkListTableItem[], siteId: string | null | undefined, timeZoneId: string | null | undefined, lang: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/WorkList/FarrowingWorkListPdf?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (timeZoneId !== undefined && timeZoneId !== null)
            url_ += "timeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(farrowingWorkListTableItems);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processWorkList_GenerateFarrowingWorkListPdf(_response);
        });
    }

    protected processWorkList_GenerateFarrowingWorkListPdf(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    workList_GenerateLardScanningEventWorkListPdf(lardScanningEventWorkListTableItems: LardScanningEventWorkListTableItem[], siteId: string | null | undefined, timeZoneId: string | null | undefined, lang: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/WorkList/LardScanningEventWorkListPdf?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (timeZoneId !== undefined && timeZoneId !== null)
            url_ += "timeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(lardScanningEventWorkListTableItems);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processWorkList_GenerateLardScanningEventWorkListPdf(_response);
        });
    }

    protected processWorkList_GenerateLardScanningEventWorkListPdf(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    workList_GenerateAllAnimalsEsfWorkListPdf(allAnimalsEsfWorkListTableItems: AllAnimalsEsfWorkListTableItem[], siteId: string | null | undefined, timeZoneId: string | null | undefined, lang: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/WorkList/AllAnimalsEsfWorkListPdf?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (timeZoneId !== undefined && timeZoneId !== null)
            url_ += "timeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(allAnimalsEsfWorkListTableItems);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processWorkList_GenerateAllAnimalsEsfWorkListPdf(_response);
        });
    }

    protected processWorkList_GenerateAllAnimalsEsfWorkListPdf(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    workList_GenerateAllAnimalsEsfWorkListPdf2(allAnimalsEsfWorkListTableItems: ShortageEsfWorkListTableItem[], siteId: string | null | undefined, timeZoneId: string | null | undefined, lang: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/WorkList/ShortageEsfWorkListPdf?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (timeZoneId !== undefined && timeZoneId !== null)
            url_ += "timeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(allAnimalsEsfWorkListTableItems);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processWorkList_GenerateAllAnimalsEsfWorkListPdf2(_response);
        });
    }

    protected processWorkList_GenerateAllAnimalsEsfWorkListPdf2(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    workList_GenerateMovingWorkListPdf(weaningWorkListTableItems: WeaningWorkListTableItem[], siteId: string | null | undefined, timeZoneId: string | null | undefined, lang: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/WorkList/WeaningWorkListPdf?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (timeZoneId !== undefined && timeZoneId !== null)
            url_ += "timeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(weaningWorkListTableItems);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processWorkList_GenerateMovingWorkListPdf(_response);
        });
    }

    protected processWorkList_GenerateMovingWorkListPdf(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    workList_GenerateMovingWorkListPdf2(movingWorkListTableItems: MovingWorkListTableItemPdf[], tableName: string | null | undefined, siteId: string | null | undefined, timeZoneId: string | null | undefined, lang: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/WorkList/MoveWorkListPdf?";
        if (tableName !== undefined && tableName !== null)
            url_ += "tableName=" + encodeURIComponent("" + tableName) + "&";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (timeZoneId !== undefined && timeZoneId !== null)
            url_ += "timeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(movingWorkListTableItems);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processWorkList_GenerateMovingWorkListPdf2(_response);
        });
    }

    protected processWorkList_GenerateMovingWorkListPdf2(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    workList_TasksInFarrowingStablePdf(tasksInFarrowingStableData: TasksInFarrowingStableData, siteId: string | null | undefined, timeZoneId: string | null | undefined, lang: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/WorkList/TasksInFarrowingStablePdf?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (timeZoneId !== undefined && timeZoneId !== null)
            url_ += "timeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tasksInFarrowingStableData);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processWorkList_TasksInFarrowingStablePdf(_response);
        });
    }

    protected processWorkList_TasksInFarrowingStablePdf(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    workList_VaccineWorkListPdf(vaccineWorkListData: VaccineWorkListPdfData, siteId: string | null | undefined, timeZoneId: string | null | undefined, lang: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/WorkList/VaccineWorkListPdf?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (timeZoneId !== undefined && timeZoneId !== null)
            url_ += "timeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vaccineWorkListData);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processWorkList_VaccineWorkListPdf(_response);
        });
    }

    protected processWorkList_VaccineWorkListPdf(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    workList_GenerateScanningWorkListPdf(matingWorkListTableItems: ScanningWorkListPdfData, siteId: string | null | undefined, timeZoneId: string | null | undefined, lang: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/WorkList/ScanningWorkListPdf?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (timeZoneId !== undefined && timeZoneId !== null)
            url_ += "timeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(matingWorkListTableItems);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processWorkList_GenerateScanningWorkListPdf(_response);
        });
    }

    protected processWorkList_GenerateScanningWorkListPdf(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    workList_DepartureWorkListPdf(departureWorkListData: DepartureWorkListTableItem[], siteId: string | null | undefined, timeZoneId: string | null | undefined, lang: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/WorkList/DepartureWorkListPdf?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (timeZoneId !== undefined && timeZoneId !== null)
            url_ += "timeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(departureWorkListData);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processWorkList_DepartureWorkListPdf(_response);
        });
    }

    protected processWorkList_DepartureWorkListPdf(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    workList_DistriwinAllAnimalsWorklistPdf(distriwinAllAnimalsWorkListData: DistriwinAllAnimalsWorkListTableItem[], siteId: string | null | undefined, timeZoneId: string | null | undefined, lang: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/WorkList/DistriwinAllAnimalsWorklistPdf?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (timeZoneId !== undefined && timeZoneId !== null)
            url_ += "timeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(distriwinAllAnimalsWorkListData);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processWorkList_DistriwinAllAnimalsWorklistPdf(_response);
        });
    }

    protected processWorkList_DistriwinAllAnimalsWorklistPdf(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    workList_BasicMoveListTableItemPdf(basicMoveListTableData: BasicMoveListTableItem[], siteId: string | null | undefined, timeZoneId: string | null | undefined, lang: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/WorkList/BasicMoveListTableItemPdf?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (timeZoneId !== undefined && timeZoneId !== null)
            url_ += "timeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(basicMoveListTableData);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processWorkList_BasicMoveListTableItemPdf(_response);
        });
    }

    protected processWorkList_BasicMoveListTableItemPdf(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    workListSetting_Get(id: string | null | undefined): Promise<WorkListSetting> {
        let url_ = this.baseUrl + "/api/WorkListSetting?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processWorkListSetting_Get(_response);
        });
    }

    protected processWorkListSetting_Get(response: Response): Promise<WorkListSetting> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkListSetting.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkListSetting>(null as any);
    }

    workListSetting_Upsert(worklist: WorkListSetting): Promise<string> {
        let url_ = this.baseUrl + "/api/WorkListSetting/Upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(worklist);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processWorkListSetting_Upsert(_response);
        });
    }

    protected processWorkListSetting_Upsert(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    workListSetting_GetBySiteId(siteId: string | null | undefined): Promise<WorkListSetting[]> {
        let url_ = this.baseUrl + "/api/WorkListSetting/GetBySiteId?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processWorkListSetting_GetBySiteId(_response);
        });
    }

    protected processWorkListSetting_GetBySiteId(response: Response): Promise<WorkListSetting[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkListSetting.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkListSetting[]>(null as any);
    }

    workListSetting_Sync(siteId: string | null | undefined, lastSyncDate: Date | undefined): Promise<SyncDataWorkListSetting> {
        let url_ = this.baseUrl + "/api/WorkListSetting/Sync?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (lastSyncDate === null)
            throw new Error("The parameter 'lastSyncDate' cannot be null.");
        else if (lastSyncDate !== undefined)
            url_ += "lastSyncDate=" + encodeURIComponent(lastSyncDate ? "" + lastSyncDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processWorkListSetting_Sync(_response);
        });
    }

    protected processWorkListSetting_Sync(response: Response): Promise<SyncDataWorkListSetting> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SyncDataWorkListSetting.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncDataWorkListSetting>(null as any);
    }

    workListToTreatmentPlan_Upsert(worklist: WorkListToTreatmentPlan): Promise<string> {
        let url_ = this.baseUrl + "/api/WorkListToTreatmentPlan/Upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(worklist);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processWorkListToTreatmentPlan_Upsert(_response);
        });
    }

    protected processWorkListToTreatmentPlan_Upsert(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    workListToTreatmentPlan_Sync(siteId: string | null | undefined, lastSyncDate: Date | undefined): Promise<SyncDataWorkListToTreatmentPlan> {
        let url_ = this.baseUrl + "/api/WorkListToTreatmentPlan/Sync?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (lastSyncDate === null)
            throw new Error("The parameter 'lastSyncDate' cannot be null.");
        else if (lastSyncDate !== undefined)
            url_ += "lastSyncDate=" + encodeURIComponent(lastSyncDate ? "" + lastSyncDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processWorkListToTreatmentPlan_Sync(_response);
        });
    }

    protected processWorkListToTreatmentPlan_Sync(response: Response): Promise<SyncDataWorkListToTreatmentPlan> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SyncDataWorkListToTreatmentPlan.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncDataWorkListToTreatmentPlan>(null as any);
    }

    nucleusManagementArchiveFile_GetBySiteId(siteId: string | null | undefined): Promise<NucleusManagementArchiveFile[]> {
        let url_ = this.baseUrl + "/api/NucleusManagementArchiveFile?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processNucleusManagementArchiveFile_GetBySiteId(_response);
        });
    }

    protected processNucleusManagementArchiveFile_GetBySiteId(response: Response): Promise<NucleusManagementArchiveFile[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NucleusManagementArchiveFile.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NucleusManagementArchiveFile[]>(null as any);
    }

    nucleusManagementArchiveFile_ResendFiles(archiveFileIds: string[]): Promise<void> {
        let url_ = this.baseUrl + "/api/NucleusManagementArchiveFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(archiveFileIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processNucleusManagementArchiveFile_ResendFiles(_response);
        });
    }

    protected processNucleusManagementArchiveFile_ResendFiles(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    nucleusManagementBreedingSettings_Get(siteId: string | null): Promise<NucleusManagementBreedingSettings[]> {
        let url_ = this.baseUrl + "/api/NucleusManagementBreedingSettings/{siteId}";
        if (siteId === undefined || siteId === null)
            throw new Error("The parameter 'siteId' must be defined.");
        url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processNucleusManagementBreedingSettings_Get(_response);
        });
    }

    protected processNucleusManagementBreedingSettings_Get(response: Response): Promise<NucleusManagementBreedingSettings[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NucleusManagementBreedingSettings.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NucleusManagementBreedingSettings[]>(null as any);
    }

    nucleusManagementBreedingSettings_Post(breedingSettings: NucleusManagementBreedingSettings): Promise<NucleusManagementBreedingSettings> {
        let url_ = this.baseUrl + "/api/NucleusManagementBreedingSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(breedingSettings);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processNucleusManagementBreedingSettings_Post(_response);
        });
    }

    protected processNucleusManagementBreedingSettings_Post(response: Response): Promise<NucleusManagementBreedingSettings> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NucleusManagementBreedingSettings.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NucleusManagementBreedingSettings>(null as any);
    }

    nucleusManagementBreedingSettings_UpsertMany(breedingSettingsList: NucleusManagementBreedingSettings[]): Promise<NucleusManagementBreedingSettings[]> {
        let url_ = this.baseUrl + "/api/NucleusManagementBreedingSettings/UpsertMany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(breedingSettingsList);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processNucleusManagementBreedingSettings_UpsertMany(_response);
        });
    }

    protected processNucleusManagementBreedingSettings_UpsertMany(response: Response): Promise<NucleusManagementBreedingSettings[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NucleusManagementBreedingSettings.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NucleusManagementBreedingSettings[]>(null as any);
    }

    nucleusManagementBreedingSettings_Sync(siteId: string | null | undefined, lastSyncDate: Date | undefined): Promise<SyncDataNucleusManagementBreedingSettings> {
        let url_ = this.baseUrl + "/api/NucleusManagementBreedingSettings/Sync?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (lastSyncDate === null)
            throw new Error("The parameter 'lastSyncDate' cannot be null.");
        else if (lastSyncDate !== undefined)
            url_ += "lastSyncDate=" + encodeURIComponent(lastSyncDate ? "" + lastSyncDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processNucleusManagementBreedingSettings_Sync(_response);
        });
    }

    protected processNucleusManagementBreedingSettings_Sync(response: Response): Promise<SyncDataNucleusManagementBreedingSettings> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SyncDataNucleusManagementBreedingSettings.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncDataNucleusManagementBreedingSettings>(null as any);
    }

    nucleusManagementCommunication_SendNucleusEventsToProvider(): Promise<void> {
        let url_ = this.baseUrl + "/api/NucleusManagementCommunication/SendNucleusEventsToProvider";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processNucleusManagementCommunication_SendNucleusEventsToProvider(_response);
        });
    }

    protected processNucleusManagementCommunication_SendNucleusEventsToProvider(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    nucleusManagementCommunication_SendNucleusEventsManually(connection: NucleusManagementConnection): Promise<void> {
        let url_ = this.baseUrl + "/api/NucleusManagementCommunication/SendNucleusEventsManually";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(connection);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processNucleusManagementCommunication_SendNucleusEventsManually(_response);
        });
    }

    protected processNucleusManagementCommunication_SendNucleusEventsManually(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    nucleusManagementCommunication_UpdateNucleusDataFromProvider(): Promise<void> {
        let url_ = this.baseUrl + "/api/NucleusManagementCommunication/UpdateNucleusDataFromProvider";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processNucleusManagementCommunication_UpdateNucleusDataFromProvider(_response);
        });
    }

    protected processNucleusManagementCommunication_UpdateNucleusDataFromProvider(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    nucleusManagementCommunication_ResendNucleusStemAnimal(stemAnimal: StemAnimal): Promise<void> {
        let url_ = this.baseUrl + "/api/NucleusManagementCommunication/ResendNucleusStemAnimal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(stemAnimal);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processNucleusManagementCommunication_ResendNucleusStemAnimal(_response);
        });
    }

    protected processNucleusManagementCommunication_ResendNucleusStemAnimal(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    nucleusManagementCommunication_ResendNucleusPregnancyEvent(pregnancyEvent: PregnancyEvent): Promise<void> {
        let url_ = this.baseUrl + "/api/NucleusManagementCommunication/ResendNucleusPregnancyEvent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pregnancyEvent);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processNucleusManagementCommunication_ResendNucleusPregnancyEvent(_response);
        });
    }

    protected processNucleusManagementCommunication_ResendNucleusPregnancyEvent(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    nucleusManagementCommunication_ResendNucleusYoungAnimal(youngAnimal: StemAnimal): Promise<void> {
        let url_ = this.baseUrl + "/api/NucleusManagementCommunication/ResendNucleusYoungAnimal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(youngAnimal);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processNucleusManagementCommunication_ResendNucleusYoungAnimal(_response);
        });
    }

    protected processNucleusManagementCommunication_ResendNucleusYoungAnimal(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    nucleusManagementConnection_Get(siteId: string | null): Promise<NucleusManagementConnection[]> {
        let url_ = this.baseUrl + "/api/NucleusManagementConnection/{siteId}";
        if (siteId === undefined || siteId === null)
            throw new Error("The parameter 'siteId' must be defined.");
        url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processNucleusManagementConnection_Get(_response);
        });
    }

    protected processNucleusManagementConnection_Get(response: Response): Promise<NucleusManagementConnection[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NucleusManagementConnection.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NucleusManagementConnection[]>(null as any);
    }

    nucleusManagementConnection_CreateConnection(creationDTO: NucleusManagementConnectionCreationDTO): Promise<NucleusManagementConnection> {
        let url_ = this.baseUrl + "/api/NucleusManagementConnection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(creationDTO);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processNucleusManagementConnection_CreateConnection(_response);
        });
    }

    protected processNucleusManagementConnection_CreateConnection(response: Response): Promise<NucleusManagementConnection> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NucleusManagementConnection.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NucleusManagementConnection>(null as any);
    }

    nucleusManagementConnection_UpdateConnection(updateDTO: NucleusManagementConnectionUpdateDTO): Promise<NucleusManagementConnection> {
        let url_ = this.baseUrl + "/api/NucleusManagementConnection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateDTO);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processNucleusManagementConnection_UpdateConnection(_response);
        });
    }

    protected processNucleusManagementConnection_UpdateConnection(response: Response): Promise<NucleusManagementConnection> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NucleusManagementConnection.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NucleusManagementConnection>(null as any);
    }

    nucleusManagementConnection_DeleteConnection(connectionId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/NucleusManagementConnection?";
        if (connectionId !== undefined && connectionId !== null)
            url_ += "connectionId=" + encodeURIComponent("" + connectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processNucleusManagementConnection_DeleteConnection(_response);
        });
    }

    protected processNucleusManagementConnection_DeleteConnection(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    nucleusManagementConnection_UpdateFetchSettings(nucleusManagementConnection: NucleusManagementConnection): Promise<NucleusManagementConnection> {
        let url_ = this.baseUrl + "/api/NucleusManagementConnection/UpdateFetchSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(nucleusManagementConnection);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processNucleusManagementConnection_UpdateFetchSettings(_response);
        });
    }

    protected processNucleusManagementConnection_UpdateFetchSettings(response: Response): Promise<NucleusManagementConnection> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NucleusManagementConnection.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NucleusManagementConnection>(null as any);
    }

    nucleusManagementConnection_UpdateSendSettings(nucleusManagementConnection: NucleusManagementConnection): Promise<NucleusManagementConnection> {
        let url_ = this.baseUrl + "/api/NucleusManagementConnection/UpdateSendSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(nucleusManagementConnection);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processNucleusManagementConnection_UpdateSendSettings(_response);
        });
    }

    protected processNucleusManagementConnection_UpdateSendSettings(response: Response): Promise<NucleusManagementConnection> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NucleusManagementConnection.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NucleusManagementConnection>(null as any);
    }

    adminFeatures_GetSubclassesOfSiteEnity(): Promise<string[]> {
        let url_ = this.baseUrl + "/api/AdminFeatures";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAdminFeatures_GetSubclassesOfSiteEnity(_response);
        });
    }

    protected processAdminFeatures_GetSubclassesOfSiteEnity(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    adminFeatures_MigrateDownstream(siteId: string | null | undefined, entities: string[]): Promise<void> {
        let url_ = this.baseUrl + "/api/AdminFeatures?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entities);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAdminFeatures_MigrateDownstream(_response);
        });
    }

    protected processAdminFeatures_MigrateDownstream(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    adminSites_Post(value: Site): Promise<string> {
        let url_ = this.baseUrl + "/api/AdminSites";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAdminSites_Post(_response);
        });
    }

    protected processAdminSites_Post(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    locationSynchronization_Get(): Promise<string> {
        let url_ = this.baseUrl + "/api/admin/LocationSynchronization";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLocationSynchronization_Get(_response);
        });
    }

    protected processLocationSynchronization_Get(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    locationSynchronization_Post(locationHierarchyDto: LocationHierarchyDto): Promise<string> {
        let url_ = this.baseUrl + "/api/admin/LocationSynchronization";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(locationHierarchyDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLocationSynchronization_Post(_response);
        });
    }

    protected processLocationSynchronization_Post(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Exception.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    locationSynchronization_Get2(delay: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/admin/LocationSynchronization/LongRunning?";
        if (delay === null)
            throw new Error("The parameter 'delay' cannot be null.");
        else if (delay !== undefined)
            url_ += "delay=" + encodeURIComponent("" + delay) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLocationSynchronization_Get2(_response);
        });
    }

    protected processLocationSynchronization_Get2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    locationSynchronization_Get3(delay: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/admin/LocationSynchronization/LongRunningAsync?";
        if (delay === null)
            throw new Error("The parameter 'delay' cannot be null.");
        else if (delay !== undefined)
            url_ += "delay=" + encodeURIComponent("" + delay) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLocationSynchronization_Get3(_response);
        });
    }

    protected processLocationSynchronization_Get3(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    migrateData_PostCloudFarms(file: FileParameter | null | undefined, siteId: string | null | undefined, buildingName: string | null | undefined, buildingNumber: string | null | undefined, equipment: Equipment | null | undefined, defaultPenId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/MigrateData/CloudFarms?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (buildingName !== undefined && buildingName !== null)
            url_ += "buildingName=" + encodeURIComponent("" + buildingName) + "&";
        if (buildingNumber !== undefined && buildingNumber !== null)
            url_ += "buildingNumber=" + encodeURIComponent("" + buildingNumber) + "&";
        if (equipment !== undefined && equipment !== null)
            url_ += "equipment=" + encodeURIComponent("" + equipment) + "&";
        if (defaultPenId !== undefined && defaultPenId !== null)
            url_ += "defaultPenId=" + encodeURIComponent("" + defaultPenId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMigrateData_PostCloudFarms(_response);
        });
    }

    protected processMigrateData_PostCloudFarms(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    migrateData_CloudFarmsMatingAndFarrowings(file: FileParameter | null | undefined, siteId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/MigrateData/CloudFarmsMatingAndFarrowings?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMigrateData_CloudFarmsMatingAndFarrowings(_response);
        });
    }

    protected processMigrateData_CloudFarmsMatingAndFarrowings(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    migrateData_MigrateYOungAnimals(file: FileParameter | null | undefined, siteId: string | null | undefined, penId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/MigrateData/MigrateYOungAnimals?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (penId !== undefined && penId !== null)
            url_ += "penId=" + encodeURIComponent("" + penId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMigrateData_MigrateYOungAnimals(_response);
        });
    }

    protected processMigrateData_MigrateYOungAnimals(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    migrateData_EditIdnumbers(file: FileParameter | null | undefined, siteId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/MigrateData/EditIdnumbers?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMigrateData_EditIdnumbers(_response);
        });
    }

    protected processMigrateData_EditIdnumbers(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    migrateData_EditStillborn(file: FileParameter | null | undefined, siteId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/MigrateData/EditStillborn?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMigrateData_EditStillborn(_response);
        });
    }

    protected processMigrateData_EditStillborn(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    migrateData_MigrateAIBoars(file: FileParameter | null | undefined, siteId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/MigrateData/MigrateAIBoars?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMigrateData_MigrateAIBoars(_response);
        });
    }

    protected processMigrateData_MigrateAIBoars(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    migrateData_EditMatingsBoar(file: FileParameter | null | undefined, siteId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/MigrateData/EditMatingsBoar?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMigrateData_EditMatingsBoar(_response);
        });
    }

    protected processMigrateData_EditMatingsBoar(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    migrateData_MigrateMissingPregnancies(file: FileParameter | null | undefined, siteId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/MigrateData/MigrateMissingPregnancies?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMigrateData_MigrateMissingPregnancies(_response);
        });
    }

    protected processMigrateData_MigrateMissingPregnancies(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    migrateData_MigrateDeparturesOnly(file: FileParameter | null | undefined, siteId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/MigrateData/MigrateDeparturesOnly?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMigrateData_MigrateDeparturesOnly(_response);
        });
    }

    protected processMigrateData_MigrateDeparturesOnly(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    migrateData_MigrateDeadPiglets(file: FileParameter | null | undefined, siteId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/MigrateData/MigrateDeadPiglets?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMigrateData_MigrateDeadPiglets(_response);
        });
    }

    protected processMigrateData_MigrateDeadPiglets(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    migrateData_UpdateStemAnimals(file: FileParameter | null | undefined, siteId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/MigrateData/UpdateStemAnimals?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMigrateData_UpdateStemAnimals(_response);
        });
    }

    protected processMigrateData_UpdateStemAnimals(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    migrateData_UpdateWeanings(file: FileParameter | null | undefined, siteId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/MigrateData/UpdateWeanings?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMigrateData_UpdateWeanings(_response);
        });
    }

    protected processMigrateData_UpdateWeanings(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    migrateData_HandleDepartureReasons(file: FileParameter | null | undefined, siteId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/MigrateData/HandleDepartureReasons?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMigrateData_HandleDepartureReasons(_response);
        });
    }

    protected processMigrateData_HandleDepartureReasons(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    mongoArchive_MigrateToArchive(siteId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/MongoArchive/MigrateToArchive?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMongoArchive_MigrateToArchive(_response);
        });
    }

    protected processMongoArchive_MigrateToArchive(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    mongoArchive_MigrateFromArchive(siteId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/MongoArchive/MigrateFromArchive?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMongoArchive_MigrateFromArchive(_response);
        });
    }

    protected processMongoArchive_MigrateFromArchive(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    mongoArchive_GetArchivedSties(): Promise<Site[]> {
        let url_ = this.baseUrl + "/api/MongoArchive/GetArchivedSties";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMongoArchive_GetArchivedSties(_response);
        });
    }

    protected processMongoArchive_GetArchivedSties(response: Response): Promise<Site[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Site.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Site[]>(null as any);
    }

    monitoring_GetSiteMonitoringReports(): Promise<SiteMonitoringReport[]> {
        let url_ = this.baseUrl + "/api/Monitoring/SiteMonitoringReport";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMonitoring_GetSiteMonitoringReports(_response);
        });
    }

    protected processMonitoring_GetSiteMonitoringReports(response: Response): Promise<SiteMonitoringReport[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SiteMonitoringReport.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SiteMonitoringReport[]>(null as any);
    }

    monitoring_GetSiteMessageTimestamps(siteId: string | null): Promise<Date> {
        let url_ = this.baseUrl + "/api/Monitoring/SiteMonitoringReport/{siteId}";
        if (siteId === undefined || siteId === null)
            throw new Error("The parameter 'siteId' must be defined.");
        url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMonitoring_GetSiteMessageTimestamps(_response);
        });
    }

    protected processMonitoring_GetSiteMessageTimestamps(response: Response): Promise<Date> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? new Date(resultData200.toString()) : <any>null;
    
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Date>(null as any);
    }

    notification_Post(notification: NotificationDto): Promise<string> {
        let url_ = this.baseUrl + "/api/admin/Notification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(notification);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processNotification_Post(_response);
        });
    }

    protected processNotification_Post(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Exception.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    notificationDefinition_Post(notificationDefinitions: NotificationDefinition[]): Promise<string> {
        let url_ = this.baseUrl + "/api/admin/NotificationDefinition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(notificationDefinitions);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processNotificationDefinition_Post(_response);
        });
    }

    protected processNotificationDefinition_Post(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Exception.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    pushNotification_Post(notification: PushNotification): Promise<void> {
        let url_ = this.baseUrl + "/api/admin/PushNotification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(notification);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPushNotification_Post(_response);
        });
    }

    protected processPushNotification_Post(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    userAdmin_Post(request: UserProfileCreationRequest[]): Promise<void> {
        let url_ = this.baseUrl + "/api/admin/UserAdmin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUserAdmin_Post(_response);
        });
    }

    protected processUserAdmin_Post(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    segesInsights_GetSegesInsightData(siteId: string | null | undefined, fromDate: Date | null | undefined, toDate: Date | null | undefined, limit: number | undefined, offset: number | undefined): Promise<SegesInsightModel> {
        let url_ = this.baseUrl + "/api/SegesInsights/GetSegesInsightData?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSegesInsights_GetSegesInsightData(_response);
        });
    }

    protected processSegesInsights_GetSegesInsightData(response: Response): Promise<SegesInsightModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SegesInsightModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SegesInsightModel>(null as any);
    }

    segesInsights_GetSegesInsightSow(siteId: string | null | undefined, fromDate: Date | null | undefined, toDate: Date | null | undefined, limit: number | undefined, offset: number | undefined): Promise<SegesInsightSowOnlyModel[]> {
        let url_ = this.baseUrl + "/api/SegesInsights/GetSegesInsightSow?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSegesInsights_GetSegesInsightSow(_response);
        });
    }

    protected processSegesInsights_GetSegesInsightSow(response: Response): Promise<SegesInsightSowOnlyModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SegesInsightSowOnlyModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SegesInsightSowOnlyModel[]>(null as any);
    }

    segesInsights_GetSegesInsightPregnancyData(siteId: string | null | undefined, fromDate: Date | null | undefined, toDate: Date | null | undefined, limit: number | undefined, offset: number | undefined): Promise<SegesInsightModel> {
        let url_ = this.baseUrl + "/api/SegesInsights/GetSegesInsightPregnancyData?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSegesInsights_GetSegesInsightPregnancyData(_response);
        });
    }

    protected processSegesInsights_GetSegesInsightPregnancyData(response: Response): Promise<SegesInsightModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SegesInsightModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SegesInsightModel>(null as any);
    }

    segesInsights_GetSitesWithConsent(): Promise<SegesInsightSite[]> {
        let url_ = this.baseUrl + "/api/SegesInsights/GetSitesWithConsent";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSegesInsights_GetSitesWithConsent(_response);
        });
    }

    protected processSegesInsights_GetSitesWithConsent(response: Response): Promise<SegesInsightSite[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SegesInsightSite.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SegesInsightSite[]>(null as any);
    }
}

export class AnimalNumberOnlyItem implements IAnimalNumberOnlyItem {
    animalNumberRow?: string[] | undefined;
    cellColorStyle!: CellColorStyle;

    constructor(data?: IAnimalNumberOnlyItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["animalNumberRow"])) {
                this.animalNumberRow = [] as any;
                for (let item of _data["animalNumberRow"])
                    this.animalNumberRow!.push(item);
            }
            this.cellColorStyle = _data["cellColorStyle"];
        }
    }

    static fromJS(data: any): AnimalNumberOnlyItem {
        data = typeof data === 'object' ? data : {};
        let result = new AnimalNumberOnlyItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.animalNumberRow)) {
            data["animalNumberRow"] = [];
            for (let item of this.animalNumberRow)
                data["animalNumberRow"].push(item);
        }
        data["cellColorStyle"] = this.cellColorStyle;
        return data;
    }
}

export interface IAnimalNumberOnlyItem {
    animalNumberRow?: string[] | undefined;
    cellColorStyle: CellColorStyle;
}

export enum CellColorStyle {
    Normal = "Normal",
    Red = "Red",
    Green = "Green",
    RedGreen = "RedGreen",
    LightGrey = "LightGrey",
    HeaderBackgroundColor = "HeaderBackgroundColor",
    Yellow = "Yellow",
}

export class Notification implements INotification {
    instanceID?: string | undefined;
    notificationType!: NotificationType;
    title?: string | undefined;
    description?: string | undefined;
    remedyDescription?: string | undefined;
    remedyRemoteActionID!: number;
    activeTimestamp!: Date;
    inactiveTimestamp?: Date | undefined;
    active!: boolean;
    userAcknowledged!: boolean;
    location?: string | undefined;
    definitionId?: string | undefined;
    sourceSystem!: SourceSystem;

    constructor(data?: INotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.instanceID = _data["instanceID"];
            this.notificationType = _data["notificationType"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.remedyDescription = _data["remedyDescription"];
            this.remedyRemoteActionID = _data["remedyRemoteActionID"];
            this.activeTimestamp = _data["activeTimestamp"] ? new Date(_data["activeTimestamp"].toString()) : <any>undefined;
            this.inactiveTimestamp = _data["inactiveTimestamp"] ? new Date(_data["inactiveTimestamp"].toString()) : <any>undefined;
            this.active = _data["active"];
            this.userAcknowledged = _data["userAcknowledged"];
            this.location = _data["location"];
            this.definitionId = _data["definitionId"];
            this.sourceSystem = _data["sourceSystem"];
        }
    }

    static fromJS(data: any): Notification {
        data = typeof data === 'object' ? data : {};
        let result = new Notification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["instanceID"] = this.instanceID;
        data["notificationType"] = this.notificationType;
        data["title"] = this.title;
        data["description"] = this.description;
        data["remedyDescription"] = this.remedyDescription;
        data["remedyRemoteActionID"] = this.remedyRemoteActionID;
        data["activeTimestamp"] = this.activeTimestamp ? this.activeTimestamp.toISOString() : <any>undefined;
        data["inactiveTimestamp"] = this.inactiveTimestamp ? this.inactiveTimestamp.toISOString() : <any>undefined;
        data["active"] = this.active;
        data["userAcknowledged"] = this.userAcknowledged;
        data["location"] = this.location;
        data["definitionId"] = this.definitionId;
        data["sourceSystem"] = this.sourceSystem;
        return data;
    }
}

export interface INotification {
    instanceID?: string | undefined;
    notificationType: NotificationType;
    title?: string | undefined;
    description?: string | undefined;
    remedyDescription?: string | undefined;
    remedyRemoteActionID: number;
    activeTimestamp: Date;
    inactiveTimestamp?: Date | undefined;
    active: boolean;
    userAcknowledged: boolean;
    location?: string | undefined;
    definitionId?: string | undefined;
    sourceSystem: SourceSystem;
}

export enum NotificationType {
    Alarm = "Alarm",
    Warning = "Warning",
}

export enum SourceSystem {
    Distriwin = "Distriwin",
    Flexmixpro = "Flexmixpro",
    ESF = "ESF",
    Elistar = "Elistar",
}

export abstract class BaseSyncOfNotification implements IBaseSyncOfNotification {
    syncTime!: Date;

    protected _discriminator: string;

    constructor(data?: IBaseSyncOfNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "BaseSyncOfNotification";
    }

    init(_data?: any) {
        if (_data) {
            this.syncTime = _data["syncTime"] ? new Date(_data["syncTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseSyncOfNotification {
        data = typeof data === 'object' ? data : {};
        if (data["_discriminator"] === "SyncNotifcations") {
            let result = new SyncNotifcations();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'BaseSyncOfNotification' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_discriminator"] = this._discriminator;
        data["syncTime"] = this.syncTime ? this.syncTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBaseSyncOfNotification {
    syncTime: Date;
}

export class SyncNotifcations extends BaseSyncOfNotification implements ISyncNotifcations {
    datas?: Notification[] | undefined;

    constructor(data?: ISyncNotifcations) {
        super(data);
        this._discriminator = "SyncNotifcations";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["datas"])) {
                this.datas = [] as any;
                for (let item of _data["datas"])
                    this.datas!.push(Notification.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): SyncNotifcations {
        data = typeof data === 'object' ? data : {};
        let result = new SyncNotifcations();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.datas)) {
            data["datas"] = [];
            for (let item of this.datas)
                data["datas"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISyncNotifcations extends IBaseSyncOfNotification {
    datas?: Notification[] | undefined;
}

export abstract class BaseSyncOfAnimalReportSetting implements IBaseSyncOfAnimalReportSetting {
    syncTime!: Date;

    protected _discriminator: string;

    constructor(data?: IBaseSyncOfAnimalReportSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "BaseSyncOfAnimalReportSetting";
    }

    init(_data?: any) {
        if (_data) {
            this.syncTime = _data["syncTime"] ? new Date(_data["syncTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseSyncOfAnimalReportSetting {
        data = typeof data === 'object' ? data : {};
        if (data["_discriminator"] === "SyncDataAnimalReportSetting") {
            let result = new SyncDataAnimalReportSetting();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'BaseSyncOfAnimalReportSetting' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_discriminator"] = this._discriminator;
        data["syncTime"] = this.syncTime ? this.syncTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBaseSyncOfAnimalReportSetting {
    syncTime: Date;
}

export class SyncDataAnimalReportSetting extends BaseSyncOfAnimalReportSetting implements ISyncDataAnimalReportSetting {
    datas?: AnimalReportSetting[] | undefined;

    constructor(data?: ISyncDataAnimalReportSetting) {
        super(data);
        this._discriminator = "SyncDataAnimalReportSetting";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["datas"])) {
                this.datas = [] as any;
                for (let item of _data["datas"])
                    this.datas!.push(AnimalReportSetting.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): SyncDataAnimalReportSetting {
        data = typeof data === 'object' ? data : {};
        let result = new SyncDataAnimalReportSetting();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.datas)) {
            data["datas"] = [];
            for (let item of this.datas)
                data["datas"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISyncDataAnimalReportSetting extends IBaseSyncOfAnimalReportSetting {
    datas?: AnimalReportSetting[] | undefined;
}

export abstract class Unique implements IUnique {
    id?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date | undefined;
    modifiedBy?: string | undefined;
    modifiedOn?: Date | undefined;
    isDeleted!: boolean;

    constructor(data?: IUnique) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): Unique {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'Unique' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IUnique {
    id?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date | undefined;
    modifiedBy?: string | undefined;
    modifiedOn?: Date | undefined;
    isDeleted: boolean;
}

export abstract class SiteEntity extends Unique implements ISiteEntity {
    siteId?: string | undefined;

    constructor(data?: ISiteEntity) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.siteId = _data["siteId"];
        }
    }

    static override fromJS(data: any): SiteEntity {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'SiteEntity' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siteId"] = this.siteId;
        super.toJSON(data);
        return data;
    }
}

export interface ISiteEntity extends IUnique {
    siteId?: string | undefined;
}

export class AnimalReportSetting extends SiteEntity implements IAnimalReportSetting {
    name?: string | undefined;
    showOnApp!: boolean;
    showOnWeb!: boolean;
    type!: AnimalReportType;

    protected _discriminator: string;

    constructor(data?: IAnimalReportSetting) {
        super(data);
        this._discriminator = "AnimalReportSetting";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.showOnApp = _data["showOnApp"];
            this.showOnWeb = _data["showOnWeb"];
            this.type = _data["type"];
        }
    }

    static override fromJS(data: any): AnimalReportSetting {
        data = typeof data === 'object' ? data : {};
        if (data["derivedTypeSelector"] === "MatingBatchReportSetting") {
            let result = new MatingBatchReportSetting();
            result.init(data);
            return result;
        }
        if (data["derivedTypeSelector"] === "ActiveAnimalsReportSetting") {
            let result = new ActiveAnimalsReportSetting();
            result.init(data);
            return result;
        }
        if (data["derivedTypeSelector"] === "SowBoardReportSetting") {
            let result = new SowBoardReportSetting();
            result.init(data);
            return result;
        }
        if (data["derivedTypeSelector"] === "FeedingESFReportSetting") {
            let result = new FeedingESFReportSetting();
            result.init(data);
            return result;
        }
        let result = new AnimalReportSetting();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["derivedTypeSelector"] = this._discriminator;
        data["name"] = this.name;
        data["showOnApp"] = this.showOnApp;
        data["showOnWeb"] = this.showOnWeb;
        data["type"] = this.type;
        super.toJSON(data);
        return data;
    }
}

export interface IAnimalReportSetting extends ISiteEntity {
    name?: string | undefined;
    showOnApp: boolean;
    showOnWeb: boolean;
    type: AnimalReportType;
}

export enum AnimalReportType {
    MatingBatchReportSetting = "MatingBatchReportSetting",
    ActiveAnimalsReportSetting = "ActiveAnimalsReportSetting",
    SowBoardReportSetting = "SowBoardReportSetting",
    FeedingESFReportSetting = "FeedingESFReportSetting",
}

export class MatingBatchReportSetting extends AnimalReportSetting implements IMatingBatchReportSetting {
    batchesPerColumn?: number[] | undefined;

    constructor(data?: IMatingBatchReportSetting) {
        super(data);
        this._discriminator = "MatingBatchReportSetting";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["batchesPerColumn"])) {
                this.batchesPerColumn = [] as any;
                for (let item of _data["batchesPerColumn"])
                    this.batchesPerColumn!.push(item);
            }
        }
    }

    static override fromJS(data: any): MatingBatchReportSetting {
        data = typeof data === 'object' ? data : {};
        let result = new MatingBatchReportSetting();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.batchesPerColumn)) {
            data["batchesPerColumn"] = [];
            for (let item of this.batchesPerColumn)
                data["batchesPerColumn"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IMatingBatchReportSetting extends IAnimalReportSetting {
    batchesPerColumn?: number[] | undefined;
}

export class ActiveAnimalsReportSetting extends AnimalReportSetting implements IActiveAnimalsReportSetting {
    option!: ActiveAnimalOption;

    constructor(data?: IActiveAnimalsReportSetting) {
        super(data);
        this._discriminator = "ActiveAnimalsReportSetting";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.option = _data["option"];
        }
    }

    static override fromJS(data: any): ActiveAnimalsReportSetting {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveAnimalsReportSetting();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["option"] = this.option;
        super.toJSON(data);
        return data;
    }
}

export interface IActiveAnimalsReportSetting extends IAnimalReportSetting {
    option: ActiveAnimalOption;
}

export enum ActiveAnimalOption {
    AnimalNumberOnly = "AnimalNumberOnly",
    AnimalNumberPerLocation = "AnimalNumberPerLocation",
}

export class SowBoardReportSetting extends AnimalReportSetting implements ISowBoardReportSetting {
    showMatingBatchInRightSide!: boolean;
    showFarrowingDateInRightSide!: boolean;
    repeatAnimalNumberAtBottom!: boolean;
    showComment!: boolean;

    constructor(data?: ISowBoardReportSetting) {
        super(data);
        this._discriminator = "SowBoardReportSetting";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.showMatingBatchInRightSide = _data["showMatingBatchInRightSide"];
            this.showFarrowingDateInRightSide = _data["showFarrowingDateInRightSide"];
            this.repeatAnimalNumberAtBottom = _data["repeatAnimalNumberAtBottom"];
            this.showComment = _data["showComment"];
        }
    }

    static override fromJS(data: any): SowBoardReportSetting {
        data = typeof data === 'object' ? data : {};
        let result = new SowBoardReportSetting();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["showMatingBatchInRightSide"] = this.showMatingBatchInRightSide;
        data["showFarrowingDateInRightSide"] = this.showFarrowingDateInRightSide;
        data["repeatAnimalNumberAtBottom"] = this.repeatAnimalNumberAtBottom;
        data["showComment"] = this.showComment;
        super.toJSON(data);
        return data;
    }
}

export interface ISowBoardReportSetting extends IAnimalReportSetting {
    showMatingBatchInRightSide: boolean;
    showFarrowingDateInRightSide: boolean;
    repeatAnimalNumberAtBottom: boolean;
    showComment: boolean;
}

export class FeedingESFReportSetting extends AnimalReportSetting implements IFeedingESFReportSetting {
    greenFromPercentage!: number;
    greenToPercentage!: number;
    redFromPercentage!: number;
    redToPercentage!: number;

    constructor(data?: IFeedingESFReportSetting) {
        super(data);
        this._discriminator = "FeedingESFReportSetting";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.greenFromPercentage = _data["greenFromPercentage"];
            this.greenToPercentage = _data["greenToPercentage"];
            this.redFromPercentage = _data["redFromPercentage"];
            this.redToPercentage = _data["redToPercentage"];
        }
    }

    static override fromJS(data: any): FeedingESFReportSetting {
        data = typeof data === 'object' ? data : {};
        let result = new FeedingESFReportSetting();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["greenFromPercentage"] = this.greenFromPercentage;
        data["greenToPercentage"] = this.greenToPercentage;
        data["redFromPercentage"] = this.redFromPercentage;
        data["redToPercentage"] = this.redToPercentage;
        super.toJSON(data);
        return data;
    }
}

export interface IFeedingESFReportSetting extends IAnimalReportSetting {
    greenFromPercentage: number;
    greenToPercentage: number;
    redFromPercentage: number;
    redToPercentage: number;
}

export class ResultPerLitterTableData implements IResultPerLitterTableData {
    matings?: { [key: string]: ResultPerLitterTableItem; } | undefined;
    farrowings?: { [key: string]: ResultPerLitterTableItem; } | undefined;
    weanings?: { [key: string]: ResultPerLitterTableItem; } | undefined;

    constructor(data?: IResultPerLitterTableData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["matings"]) {
                this.matings = {} as any;
                for (let key in _data["matings"]) {
                    if (_data["matings"].hasOwnProperty(key))
                        (<any>this.matings)![key] = _data["matings"][key] ? ResultPerLitterTableItem.fromJS(_data["matings"][key]) : new ResultPerLitterTableItem();
                }
            }
            if (_data["farrowings"]) {
                this.farrowings = {} as any;
                for (let key in _data["farrowings"]) {
                    if (_data["farrowings"].hasOwnProperty(key))
                        (<any>this.farrowings)![key] = _data["farrowings"][key] ? ResultPerLitterTableItem.fromJS(_data["farrowings"][key]) : new ResultPerLitterTableItem();
                }
            }
            if (_data["weanings"]) {
                this.weanings = {} as any;
                for (let key in _data["weanings"]) {
                    if (_data["weanings"].hasOwnProperty(key))
                        (<any>this.weanings)![key] = _data["weanings"][key] ? ResultPerLitterTableItem.fromJS(_data["weanings"][key]) : new ResultPerLitterTableItem();
                }
            }
        }
    }

    static fromJS(data: any): ResultPerLitterTableData {
        data = typeof data === 'object' ? data : {};
        let result = new ResultPerLitterTableData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.matings) {
            data["matings"] = {};
            for (let key in this.matings) {
                if (this.matings.hasOwnProperty(key))
                    (<any>data["matings"])[key] = this.matings[key] ? this.matings[key].toJSON() : <any>undefined;
            }
        }
        if (this.farrowings) {
            data["farrowings"] = {};
            for (let key in this.farrowings) {
                if (this.farrowings.hasOwnProperty(key))
                    (<any>data["farrowings"])[key] = this.farrowings[key] ? this.farrowings[key].toJSON() : <any>undefined;
            }
        }
        if (this.weanings) {
            data["weanings"] = {};
            for (let key in this.weanings) {
                if (this.weanings.hasOwnProperty(key))
                    (<any>data["weanings"])[key] = this.weanings[key] ? this.weanings[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IResultPerLitterTableData {
    matings?: { [key: string]: ResultPerLitterTableItem; } | undefined;
    farrowings?: { [key: string]: ResultPerLitterTableItem; } | undefined;
    weanings?: { [key: string]: ResultPerLitterTableItem; } | undefined;
}

export class ResultPerLitterTableItem implements IResultPerLitterTableItem {
    name?: string | undefined;
    litter1?: string | undefined;
    litter2?: string | undefined;
    litter3?: string | undefined;
    litter4?: string | undefined;
    litter5?: string | undefined;
    litter6?: string | undefined;
    litter7?: string | undefined;
    litter8?: string | undefined;
    litter9?: string | undefined;
    total!: number;
    cellColorStyle!: CellColorStyle;

    constructor(data?: IResultPerLitterTableItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.litter1 = _data["litter1"];
            this.litter2 = _data["litter2"];
            this.litter3 = _data["litter3"];
            this.litter4 = _data["litter4"];
            this.litter5 = _data["litter5"];
            this.litter6 = _data["litter6"];
            this.litter7 = _data["litter7"];
            this.litter8 = _data["litter8"];
            this.litter9 = _data["litter9"];
            this.total = _data["total"];
            this.cellColorStyle = _data["cellColorStyle"];
        }
    }

    static fromJS(data: any): ResultPerLitterTableItem {
        data = typeof data === 'object' ? data : {};
        let result = new ResultPerLitterTableItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["litter1"] = this.litter1;
        data["litter2"] = this.litter2;
        data["litter3"] = this.litter3;
        data["litter4"] = this.litter4;
        data["litter5"] = this.litter5;
        data["litter6"] = this.litter6;
        data["litter7"] = this.litter7;
        data["litter8"] = this.litter8;
        data["litter9"] = this.litter9;
        data["total"] = this.total;
        data["cellColorStyle"] = this.cellColorStyle;
        return data;
    }
}

export interface IResultPerLitterTableItem {
    name?: string | undefined;
    litter1?: string | undefined;
    litter2?: string | undefined;
    litter3?: string | undefined;
    litter4?: string | undefined;
    litter5?: string | undefined;
    litter6?: string | undefined;
    litter7?: string | undefined;
    litter8?: string | undefined;
    litter9?: string | undefined;
    total: number;
    cellColorStyle: CellColorStyle;
}

export class ResultYoungFemaleAgeTableData implements IResultYoungFemaleAgeTableData {
    matings?: { [key: string]: ResultYoungFemaleAgeTableItem; } | undefined;
    farrowings?: { [key: string]: ResultYoungFemaleAgeTableItem; } | undefined;
    weanings?: { [key: string]: ResultYoungFemaleAgeTableItem; } | undefined;

    constructor(data?: IResultYoungFemaleAgeTableData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["matings"]) {
                this.matings = {} as any;
                for (let key in _data["matings"]) {
                    if (_data["matings"].hasOwnProperty(key))
                        (<any>this.matings)![key] = _data["matings"][key] ? ResultYoungFemaleAgeTableItem.fromJS(_data["matings"][key]) : new ResultYoungFemaleAgeTableItem();
                }
            }
            if (_data["farrowings"]) {
                this.farrowings = {} as any;
                for (let key in _data["farrowings"]) {
                    if (_data["farrowings"].hasOwnProperty(key))
                        (<any>this.farrowings)![key] = _data["farrowings"][key] ? ResultYoungFemaleAgeTableItem.fromJS(_data["farrowings"][key]) : new ResultYoungFemaleAgeTableItem();
                }
            }
            if (_data["weanings"]) {
                this.weanings = {} as any;
                for (let key in _data["weanings"]) {
                    if (_data["weanings"].hasOwnProperty(key))
                        (<any>this.weanings)![key] = _data["weanings"][key] ? ResultYoungFemaleAgeTableItem.fromJS(_data["weanings"][key]) : new ResultYoungFemaleAgeTableItem();
                }
            }
        }
    }

    static fromJS(data: any): ResultYoungFemaleAgeTableData {
        data = typeof data === 'object' ? data : {};
        let result = new ResultYoungFemaleAgeTableData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.matings) {
            data["matings"] = {};
            for (let key in this.matings) {
                if (this.matings.hasOwnProperty(key))
                    (<any>data["matings"])[key] = this.matings[key] ? this.matings[key].toJSON() : <any>undefined;
            }
        }
        if (this.farrowings) {
            data["farrowings"] = {};
            for (let key in this.farrowings) {
                if (this.farrowings.hasOwnProperty(key))
                    (<any>data["farrowings"])[key] = this.farrowings[key] ? this.farrowings[key].toJSON() : <any>undefined;
            }
        }
        if (this.weanings) {
            data["weanings"] = {};
            for (let key in this.weanings) {
                if (this.weanings.hasOwnProperty(key))
                    (<any>data["weanings"])[key] = this.weanings[key] ? this.weanings[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IResultYoungFemaleAgeTableData {
    matings?: { [key: string]: ResultYoungFemaleAgeTableItem; } | undefined;
    farrowings?: { [key: string]: ResultYoungFemaleAgeTableItem; } | undefined;
    weanings?: { [key: string]: ResultYoungFemaleAgeTableItem; } | undefined;
}

export class ResultYoungFemaleAgeTableItem implements IResultYoungFemaleAgeTableItem {
    name?: string | undefined;
    agePeriod1!: number;
    agePeriod2!: number;
    agePeriod3!: number;
    agePeriod4!: number;
    agePeriod5!: number;
    total!: number;
    cellColorStyle!: CellColorStyle;

    constructor(data?: IResultYoungFemaleAgeTableItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.agePeriod1 = _data["agePeriod1"];
            this.agePeriod2 = _data["agePeriod2"];
            this.agePeriod3 = _data["agePeriod3"];
            this.agePeriod4 = _data["agePeriod4"];
            this.agePeriod5 = _data["agePeriod5"];
            this.total = _data["total"];
            this.cellColorStyle = _data["cellColorStyle"];
        }
    }

    static fromJS(data: any): ResultYoungFemaleAgeTableItem {
        data = typeof data === 'object' ? data : {};
        let result = new ResultYoungFemaleAgeTableItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["agePeriod1"] = this.agePeriod1;
        data["agePeriod2"] = this.agePeriod2;
        data["agePeriod3"] = this.agePeriod3;
        data["agePeriod4"] = this.agePeriod4;
        data["agePeriod5"] = this.agePeriod5;
        data["total"] = this.total;
        data["cellColorStyle"] = this.cellColorStyle;
        return data;
    }
}

export interface IResultYoungFemaleAgeTableItem {
    name?: string | undefined;
    agePeriod1: number;
    agePeriod2: number;
    agePeriod3: number;
    agePeriod4: number;
    agePeriod5: number;
    total: number;
    cellColorStyle: CellColorStyle;
}

export class AnalysisPregnancyTableItem implements IAnalysisPregnancyTableItem {
    matings!: number;
    tableData?: AnalysisPregnancyTableData[] | undefined;

    constructor(data?: IAnalysisPregnancyTableItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.matings = _data["matings"];
            if (Array.isArray(_data["tableData"])) {
                this.tableData = [] as any;
                for (let item of _data["tableData"])
                    this.tableData!.push(AnalysisPregnancyTableData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AnalysisPregnancyTableItem {
        data = typeof data === 'object' ? data : {};
        let result = new AnalysisPregnancyTableItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["matings"] = this.matings;
        if (Array.isArray(this.tableData)) {
            data["tableData"] = [];
            for (let item of this.tableData)
                data["tableData"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAnalysisPregnancyTableItem {
    matings: number;
    tableData?: AnalysisPregnancyTableData[] | undefined;
}

export class AnalysisPregnancyTableData implements IAnalysisPregnancyTableData {
    name?: string | undefined;
    weaningToMating?: number[] | undefined;
    matingToNonPregnant?: number[] | undefined;
    matingToMating?: number[] | undefined;
    abortion!: number;
    departure!: number;
    cellColorStyle!: CellColorStyle;

    constructor(data?: IAnalysisPregnancyTableData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["weaningToMating"])) {
                this.weaningToMating = [] as any;
                for (let item of _data["weaningToMating"])
                    this.weaningToMating!.push(item);
            }
            if (Array.isArray(_data["matingToNonPregnant"])) {
                this.matingToNonPregnant = [] as any;
                for (let item of _data["matingToNonPregnant"])
                    this.matingToNonPregnant!.push(item);
            }
            if (Array.isArray(_data["matingToMating"])) {
                this.matingToMating = [] as any;
                for (let item of _data["matingToMating"])
                    this.matingToMating!.push(item);
            }
            this.abortion = _data["abortion"];
            this.departure = _data["departure"];
            this.cellColorStyle = _data["cellColorStyle"];
        }
    }

    static fromJS(data: any): AnalysisPregnancyTableData {
        data = typeof data === 'object' ? data : {};
        let result = new AnalysisPregnancyTableData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.weaningToMating)) {
            data["weaningToMating"] = [];
            for (let item of this.weaningToMating)
                data["weaningToMating"].push(item);
        }
        if (Array.isArray(this.matingToNonPregnant)) {
            data["matingToNonPregnant"] = [];
            for (let item of this.matingToNonPregnant)
                data["matingToNonPregnant"].push(item);
        }
        if (Array.isArray(this.matingToMating)) {
            data["matingToMating"] = [];
            for (let item of this.matingToMating)
                data["matingToMating"].push(item);
        }
        data["abortion"] = this.abortion;
        data["departure"] = this.departure;
        data["cellColorStyle"] = this.cellColorStyle;
        return data;
    }
}

export interface IAnalysisPregnancyTableData {
    name?: string | undefined;
    weaningToMating?: number[] | undefined;
    matingToNonPregnant?: number[] | undefined;
    matingToMating?: number[] | undefined;
    abortion: number;
    departure: number;
    cellColorStyle: CellColorStyle;
}

export class ElaborationResultYoungFemaleAgeTableData implements IElaborationResultYoungFemaleAgeTableData {
    matings?: { [key: string]: ElaborationResultYoungFemaleAgeTableItem; } | undefined;
    farrowings?: { [key: string]: ElaborationResultYoungFemaleAgeTableItem; } | undefined;
    weanings?: { [key: string]: ElaborationResultYoungFemaleAgeTableItem; } | undefined;
    headers?: { [key: string]: { [key: string]: number[]; }; } | undefined;

    constructor(data?: IElaborationResultYoungFemaleAgeTableData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["matings"]) {
                this.matings = {} as any;
                for (let key in _data["matings"]) {
                    if (_data["matings"].hasOwnProperty(key))
                        (<any>this.matings)![key] = _data["matings"][key] ? ElaborationResultYoungFemaleAgeTableItem.fromJS(_data["matings"][key]) : new ElaborationResultYoungFemaleAgeTableItem();
                }
            }
            if (_data["farrowings"]) {
                this.farrowings = {} as any;
                for (let key in _data["farrowings"]) {
                    if (_data["farrowings"].hasOwnProperty(key))
                        (<any>this.farrowings)![key] = _data["farrowings"][key] ? ElaborationResultYoungFemaleAgeTableItem.fromJS(_data["farrowings"][key]) : new ElaborationResultYoungFemaleAgeTableItem();
                }
            }
            if (_data["weanings"]) {
                this.weanings = {} as any;
                for (let key in _data["weanings"]) {
                    if (_data["weanings"].hasOwnProperty(key))
                        (<any>this.weanings)![key] = _data["weanings"][key] ? ElaborationResultYoungFemaleAgeTableItem.fromJS(_data["weanings"][key]) : new ElaborationResultYoungFemaleAgeTableItem();
                }
            }
            if (_data["headers"]) {
                this.headers = {} as any;
                for (let key in _data["headers"]) {
                    if (_data["headers"].hasOwnProperty(key))
                        (<any>this.headers)![key] = _data["headers"][key] !== undefined ? _data["headers"][key] : {};
                }
            }
        }
    }

    static fromJS(data: any): ElaborationResultYoungFemaleAgeTableData {
        data = typeof data === 'object' ? data : {};
        let result = new ElaborationResultYoungFemaleAgeTableData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.matings) {
            data["matings"] = {};
            for (let key in this.matings) {
                if (this.matings.hasOwnProperty(key))
                    (<any>data["matings"])[key] = this.matings[key] ? this.matings[key].toJSON() : <any>undefined;
            }
        }
        if (this.farrowings) {
            data["farrowings"] = {};
            for (let key in this.farrowings) {
                if (this.farrowings.hasOwnProperty(key))
                    (<any>data["farrowings"])[key] = this.farrowings[key] ? this.farrowings[key].toJSON() : <any>undefined;
            }
        }
        if (this.weanings) {
            data["weanings"] = {};
            for (let key in this.weanings) {
                if (this.weanings.hasOwnProperty(key))
                    (<any>data["weanings"])[key] = this.weanings[key] ? this.weanings[key].toJSON() : <any>undefined;
            }
        }
        if (this.headers) {
            data["headers"] = {};
            for (let key in this.headers) {
                if (this.headers.hasOwnProperty(key))
                    (<any>data["headers"])[key] = (<any>this.headers)[key];
            }
        }
        return data;
    }
}

export interface IElaborationResultYoungFemaleAgeTableData {
    matings?: { [key: string]: ElaborationResultYoungFemaleAgeTableItem; } | undefined;
    farrowings?: { [key: string]: ElaborationResultYoungFemaleAgeTableItem; } | undefined;
    weanings?: { [key: string]: ElaborationResultYoungFemaleAgeTableItem; } | undefined;
    headers?: { [key: string]: { [key: string]: number[]; }; } | undefined;
}

export class ElaborationResultYoungFemaleAgeTableItem implements IElaborationResultYoungFemaleAgeTableItem {
    name?: string | undefined;
    agePeriod1?: { [key: string]: { [key: string]: number; }; } | undefined;
    agePeriod2?: { [key: string]: { [key: string]: number; }; } | undefined;
    agePeriod3?: { [key: string]: { [key: string]: number; }; } | undefined;
    agePeriod4?: { [key: string]: { [key: string]: number; }; } | undefined;
    agePeriod5?: { [key: string]: { [key: string]: number; }; } | undefined;
    total!: number;
    cellColorStyle!: CellColorStyle;

    constructor(data?: IElaborationResultYoungFemaleAgeTableItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (_data["agePeriod1"]) {
                this.agePeriod1 = {} as any;
                for (let key in _data["agePeriod1"]) {
                    if (_data["agePeriod1"].hasOwnProperty(key))
                        (<any>this.agePeriod1)![key] = _data["agePeriod1"][key] !== undefined ? _data["agePeriod1"][key] : {};
                }
            }
            if (_data["agePeriod2"]) {
                this.agePeriod2 = {} as any;
                for (let key in _data["agePeriod2"]) {
                    if (_data["agePeriod2"].hasOwnProperty(key))
                        (<any>this.agePeriod2)![key] = _data["agePeriod2"][key] !== undefined ? _data["agePeriod2"][key] : {};
                }
            }
            if (_data["agePeriod3"]) {
                this.agePeriod3 = {} as any;
                for (let key in _data["agePeriod3"]) {
                    if (_data["agePeriod3"].hasOwnProperty(key))
                        (<any>this.agePeriod3)![key] = _data["agePeriod3"][key] !== undefined ? _data["agePeriod3"][key] : {};
                }
            }
            if (_data["agePeriod4"]) {
                this.agePeriod4 = {} as any;
                for (let key in _data["agePeriod4"]) {
                    if (_data["agePeriod4"].hasOwnProperty(key))
                        (<any>this.agePeriod4)![key] = _data["agePeriod4"][key] !== undefined ? _data["agePeriod4"][key] : {};
                }
            }
            if (_data["agePeriod5"]) {
                this.agePeriod5 = {} as any;
                for (let key in _data["agePeriod5"]) {
                    if (_data["agePeriod5"].hasOwnProperty(key))
                        (<any>this.agePeriod5)![key] = _data["agePeriod5"][key] !== undefined ? _data["agePeriod5"][key] : {};
                }
            }
            this.total = _data["total"];
            this.cellColorStyle = _data["cellColorStyle"];
        }
    }

    static fromJS(data: any): ElaborationResultYoungFemaleAgeTableItem {
        data = typeof data === 'object' ? data : {};
        let result = new ElaborationResultYoungFemaleAgeTableItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.agePeriod1) {
            data["agePeriod1"] = {};
            for (let key in this.agePeriod1) {
                if (this.agePeriod1.hasOwnProperty(key))
                    (<any>data["agePeriod1"])[key] = (<any>this.agePeriod1)[key];
            }
        }
        if (this.agePeriod2) {
            data["agePeriod2"] = {};
            for (let key in this.agePeriod2) {
                if (this.agePeriod2.hasOwnProperty(key))
                    (<any>data["agePeriod2"])[key] = (<any>this.agePeriod2)[key];
            }
        }
        if (this.agePeriod3) {
            data["agePeriod3"] = {};
            for (let key in this.agePeriod3) {
                if (this.agePeriod3.hasOwnProperty(key))
                    (<any>data["agePeriod3"])[key] = (<any>this.agePeriod3)[key];
            }
        }
        if (this.agePeriod4) {
            data["agePeriod4"] = {};
            for (let key in this.agePeriod4) {
                if (this.agePeriod4.hasOwnProperty(key))
                    (<any>data["agePeriod4"])[key] = (<any>this.agePeriod4)[key];
            }
        }
        if (this.agePeriod5) {
            data["agePeriod5"] = {};
            for (let key in this.agePeriod5) {
                if (this.agePeriod5.hasOwnProperty(key))
                    (<any>data["agePeriod5"])[key] = (<any>this.agePeriod5)[key];
            }
        }
        data["total"] = this.total;
        data["cellColorStyle"] = this.cellColorStyle;
        return data;
    }
}

export interface IElaborationResultYoungFemaleAgeTableItem {
    name?: string | undefined;
    agePeriod1?: { [key: string]: { [key: string]: number; }; } | undefined;
    agePeriod2?: { [key: string]: { [key: string]: number; }; } | undefined;
    agePeriod3?: { [key: string]: { [key: string]: number; }; } | undefined;
    agePeriod4?: { [key: string]: { [key: string]: number; }; } | undefined;
    agePeriod5?: { [key: string]: { [key: string]: number; }; } | undefined;
    total: number;
    cellColorStyle: CellColorStyle;
}

export class BasicMatingTableItem implements IBasicMatingTableItem {
    animalNumber?: string | undefined;
    pregnancyDays?: number | undefined;
    litterNumber?: number | undefined;
    daysFromWeaning?: number | undefined;
    daysFromMating?: number | undefined;
    notPregnant?: number | undefined;
    prevNotPregnant?: number | undefined;
    abortion?: number | undefined;
    soldOrKilled?: number | undefined;
    deadOrPutDown?: number | undefined;
    sowId?: string | undefined;
    breedRace?: string | undefined;
    prevEvent?: PregnancyEvent | undefined;
    cellColorStyle!: CellColorStyle;

    constructor(data?: IBasicMatingTableItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.animalNumber = _data["animalNumber"];
            this.pregnancyDays = _data["pregnancyDays"];
            this.litterNumber = _data["litterNumber"];
            this.daysFromWeaning = _data["daysFromWeaning"];
            this.daysFromMating = _data["daysFromMating"];
            this.notPregnant = _data["notPregnant"];
            this.prevNotPregnant = _data["prevNotPregnant"];
            this.abortion = _data["abortion"];
            this.soldOrKilled = _data["soldOrKilled"];
            this.deadOrPutDown = _data["deadOrPutDown"];
            this.sowId = _data["sowId"];
            this.breedRace = _data["breedRace"];
            this.prevEvent = _data["prevEvent"] ? PregnancyEvent.fromJS(_data["prevEvent"]) : <any>undefined;
            this.cellColorStyle = _data["cellColorStyle"];
        }
    }

    static fromJS(data: any): BasicMatingTableItem {
        data = typeof data === 'object' ? data : {};
        let result = new BasicMatingTableItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["animalNumber"] = this.animalNumber;
        data["pregnancyDays"] = this.pregnancyDays;
        data["litterNumber"] = this.litterNumber;
        data["daysFromWeaning"] = this.daysFromWeaning;
        data["daysFromMating"] = this.daysFromMating;
        data["notPregnant"] = this.notPregnant;
        data["prevNotPregnant"] = this.prevNotPregnant;
        data["abortion"] = this.abortion;
        data["soldOrKilled"] = this.soldOrKilled;
        data["deadOrPutDown"] = this.deadOrPutDown;
        data["sowId"] = this.sowId;
        data["breedRace"] = this.breedRace;
        data["prevEvent"] = this.prevEvent ? this.prevEvent.toJSON() : <any>undefined;
        data["cellColorStyle"] = this.cellColorStyle;
        return data;
    }
}

export interface IBasicMatingTableItem {
    animalNumber?: string | undefined;
    pregnancyDays?: number | undefined;
    litterNumber?: number | undefined;
    daysFromWeaning?: number | undefined;
    daysFromMating?: number | undefined;
    notPregnant?: number | undefined;
    prevNotPregnant?: number | undefined;
    abortion?: number | undefined;
    soldOrKilled?: number | undefined;
    deadOrPutDown?: number | undefined;
    sowId?: string | undefined;
    breedRace?: string | undefined;
    prevEvent?: PregnancyEvent | undefined;
    cellColorStyle: CellColorStyle;
}

export class ResultAnalysisMatingsTableItem extends BasicMatingTableItem implements IResultAnalysisMatingsTableItem {
    matingDateFirstMating?: Date | undefined;
    matingDate?: Date | undefined;

    constructor(data?: IResultAnalysisMatingsTableItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.matingDateFirstMating = _data["matingDateFirstMating"] ? new Date(_data["matingDateFirstMating"].toString()) : <any>undefined;
            this.matingDate = _data["matingDate"] ? new Date(_data["matingDate"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): ResultAnalysisMatingsTableItem {
        data = typeof data === 'object' ? data : {};
        let result = new ResultAnalysisMatingsTableItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["matingDateFirstMating"] = this.matingDateFirstMating ? this.matingDateFirstMating.toISOString() : <any>undefined;
        data["matingDate"] = this.matingDate ? this.matingDate.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultAnalysisMatingsTableItem extends IBasicMatingTableItem {
    matingDateFirstMating?: Date | undefined;
    matingDate?: Date | undefined;
}

export abstract class PregnancyEvent extends SiteEntity implements IPregnancyEvent {
    date!: Date;
    stemAnimalId?: string | undefined;
    pregnancyId?: string | undefined;
    state!: PregnancyState;

    protected _discriminator: string;

    constructor(data?: IPregnancyEvent) {
        super(data);
        this._discriminator = "PregnancyEvent";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.stemAnimalId = _data["stemAnimalId"];
            this.pregnancyId = _data["pregnancyId"];
            this.state = _data["state"];
        }
    }

    static override fromJS(data: any): PregnancyEvent {
        data = typeof data === 'object' ? data : {};
        if (data["derivedTypeSelector"] === "Mated") {
            let result = new Mated();
            result.init(data);
            return result;
        }
        if (data["derivedTypeSelector"] === "Scanned") {
            let result = new Scanned();
            result.init(data);
            return result;
        }
        if (data["derivedTypeSelector"] === "FarrowingInProgress") {
            let result = new FarrowingInProgress();
            result.init(data);
            return result;
        }
        if (data["derivedTypeSelector"] === "Farrowing") {
            let result = new Farrowing();
            result.init(data);
            return result;
        }
        if (data["derivedTypeSelector"] === "Averted") {
            let result = new Averted();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'PregnancyEvent' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["derivedTypeSelector"] = this._discriminator;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["stemAnimalId"] = this.stemAnimalId;
        data["pregnancyId"] = this.pregnancyId;
        data["state"] = this.state;
        super.toJSON(data);
        return data;
    }
}

export interface IPregnancyEvent extends ISiteEntity {
    date: Date;
    stemAnimalId?: string | undefined;
    pregnancyId?: string | undefined;
    state: PregnancyState;
}

export enum PregnancyState {
    None = "None",
    Mated = "Mated",
    Scanned = "Scanned",
    FarrowingInProgress = "FarrowingInProgress",
    Farrowing = "Farrowing",
    Averted = "Averted",
}

export class Mated extends PregnancyEvent implements IMated {
    boarId?: string | undefined;
    grade?: MatingGrade | undefined;
    semenType!: SemenType;
    initials?: string | undefined;

    constructor(data?: IMated) {
        super(data);
        this._discriminator = "Mated";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.boarId = _data["boarId"];
            this.grade = _data["grade"];
            this.semenType = _data["semenType"];
            this.initials = _data["initials"];
        }
    }

    static override fromJS(data: any): Mated {
        data = typeof data === 'object' ? data : {};
        let result = new Mated();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["boarId"] = this.boarId;
        data["grade"] = this.grade;
        data["semenType"] = this.semenType;
        data["initials"] = this.initials;
        super.toJSON(data);
        return data;
    }
}

export interface IMated extends IPregnancyEvent {
    boarId?: string | undefined;
    grade?: MatingGrade | undefined;
    semenType: SemenType;
    initials?: string | undefined;
}

export enum MatingGrade {
    A = "A",
    B = "B",
    C = "C",
    D = "D",
    E = "E",
}

export enum SemenType {
    Nat = "Nat",
    KS = "KS",
}

export class Scanned extends PregnancyEvent implements IScanned {
    result!: ScanResult;

    constructor(data?: IScanned) {
        super(data);
        this._discriminator = "Scanned";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.result = _data["result"];
        }
    }

    static override fromJS(data: any): Scanned {
        data = typeof data === 'object' ? data : {};
        let result = new Scanned();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        super.toJSON(data);
        return data;
    }
}

export interface IScanned extends IPregnancyEvent {
    result: ScanResult;
}

export enum ScanResult {
    True = "True",
    False = "False",
    Maybe = "Maybe",
}

export class FarrowingInProgress extends PregnancyEvent implements IFarrowingInProgress {

    constructor(data?: IFarrowingInProgress) {
        super(data);
        this._discriminator = "FarrowingInProgress";
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): FarrowingInProgress {
        data = typeof data === 'object' ? data : {};
        let result = new FarrowingInProgress();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IFarrowingInProgress extends IPregnancyEvent {
}

export class Farrowing extends PregnancyEvent implements IFarrowing {
    numFemaleAlive?: number | undefined;
    numMaleAlive?: number | undefined;
    numAlive!: number;
    numDead?: number | undefined;
    abortion!: boolean;
    litterWeight?: number | undefined;
    mumified?: number | undefined;
    earNotch?: string | undefined;
    litterBreed?: string | undefined;

    constructor(data?: IFarrowing) {
        super(data);
        this._discriminator = "Farrowing";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.numFemaleAlive = _data["numFemaleAlive"];
            this.numMaleAlive = _data["numMaleAlive"];
            this.numAlive = _data["numAlive"];
            this.numDead = _data["numDead"];
            this.abortion = _data["abortion"];
            this.litterWeight = _data["litterWeight"];
            this.mumified = _data["mumified"];
            this.earNotch = _data["earNotch"];
            this.litterBreed = _data["litterBreed"];
        }
    }

    static override fromJS(data: any): Farrowing {
        data = typeof data === 'object' ? data : {};
        let result = new Farrowing();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numFemaleAlive"] = this.numFemaleAlive;
        data["numMaleAlive"] = this.numMaleAlive;
        data["numAlive"] = this.numAlive;
        data["numDead"] = this.numDead;
        data["abortion"] = this.abortion;
        data["litterWeight"] = this.litterWeight;
        data["mumified"] = this.mumified;
        data["earNotch"] = this.earNotch;
        data["litterBreed"] = this.litterBreed;
        super.toJSON(data);
        return data;
    }
}

export interface IFarrowing extends IPregnancyEvent {
    numFemaleAlive?: number | undefined;
    numMaleAlive?: number | undefined;
    numAlive: number;
    numDead?: number | undefined;
    abortion: boolean;
    litterWeight?: number | undefined;
    mumified?: number | undefined;
    earNotch?: string | undefined;
    litterBreed?: string | undefined;
}

export class Averted extends PregnancyEvent implements IAverted {
    isNursingSow!: boolean;
    numAlive!: number;
    comment?: string | undefined;
    totalWeight?: number | undefined;
    totalPrice?: number | undefined;
    weaningCode!: WeaningCode;

    constructor(data?: IAverted) {
        super(data);
        this._discriminator = "Averted";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isNursingSow = _data["isNursingSow"];
            this.numAlive = _data["numAlive"];
            this.comment = _data["comment"];
            this.totalWeight = _data["totalWeight"];
            this.totalPrice = _data["totalPrice"];
            this.weaningCode = _data["weaningCode"];
        }
    }

    static override fromJS(data: any): Averted {
        data = typeof data === 'object' ? data : {};
        let result = new Averted();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isNursingSow"] = this.isNursingSow;
        data["numAlive"] = this.numAlive;
        data["comment"] = this.comment;
        data["totalWeight"] = this.totalWeight;
        data["totalPrice"] = this.totalPrice;
        data["weaningCode"] = this.weaningCode;
        super.toJSON(data);
        return data;
    }
}

export interface IAverted extends IPregnancyEvent {
    isNursingSow: boolean;
    numAlive: number;
    comment?: string | undefined;
    totalWeight?: number | undefined;
    totalPrice?: number | undefined;
    weaningCode: WeaningCode;
}

export enum WeaningCode {
    Sold = "Sold",
    Moved = "Moved",
}

export enum SowState {
    Dry = "Dry",
    Pregnant = "Pregnant",
    Nursing = "Nursing",
    PregnantAndNursing = "PregnantAndNursing",
}

export class BasicFarrowingTableItem implements IBasicFarrowingTableItem {
    sowId?: string | undefined;
    pregnancyDays?: number | undefined;
    animalNumber?: string | undefined;
    litterNumber?: number | undefined;
    farrowingDate!: Date;
    aliveBorn?: number | undefined;
    stillborn?: number | undefined;
    breedRace?: string | undefined;
    cellColorStyle!: CellColorStyle;

    constructor(data?: IBasicFarrowingTableItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sowId = _data["sowId"];
            this.pregnancyDays = _data["pregnancyDays"];
            this.animalNumber = _data["animalNumber"];
            this.litterNumber = _data["litterNumber"];
            this.farrowingDate = _data["farrowingDate"] ? new Date(_data["farrowingDate"].toString()) : <any>undefined;
            this.aliveBorn = _data["aliveBorn"];
            this.stillborn = _data["stillborn"];
            this.breedRace = _data["breedRace"];
            this.cellColorStyle = _data["cellColorStyle"];
        }
    }

    static fromJS(data: any): BasicFarrowingTableItem {
        data = typeof data === 'object' ? data : {};
        let result = new BasicFarrowingTableItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sowId"] = this.sowId;
        data["pregnancyDays"] = this.pregnancyDays;
        data["animalNumber"] = this.animalNumber;
        data["litterNumber"] = this.litterNumber;
        data["farrowingDate"] = this.farrowingDate ? this.farrowingDate.toISOString() : <any>undefined;
        data["aliveBorn"] = this.aliveBorn;
        data["stillborn"] = this.stillborn;
        data["breedRace"] = this.breedRace;
        data["cellColorStyle"] = this.cellColorStyle;
        return data;
    }
}

export interface IBasicFarrowingTableItem {
    sowId?: string | undefined;
    pregnancyDays?: number | undefined;
    animalNumber?: string | undefined;
    litterNumber?: number | undefined;
    farrowingDate: Date;
    aliveBorn?: number | undefined;
    stillborn?: number | undefined;
    breedRace?: string | undefined;
    cellColorStyle: CellColorStyle;
}

export class ResultAnalysisFarrowingsTableItem extends BasicFarrowingTableItem implements IResultAnalysisFarrowingsTableItem {
    pregnancyId?: string | undefined;

    constructor(data?: IResultAnalysisFarrowingsTableItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pregnancyId = _data["pregnancyId"];
        }
    }

    static override fromJS(data: any): ResultAnalysisFarrowingsTableItem {
        data = typeof data === 'object' ? data : {};
        let result = new ResultAnalysisFarrowingsTableItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pregnancyId"] = this.pregnancyId;
        super.toJSON(data);
        return data;
    }
}

export interface IResultAnalysisFarrowingsTableItem extends IBasicFarrowingTableItem {
    pregnancyId?: string | undefined;
}

export class BasicWeaningTableItem implements IBasicWeaningTableItem {
    sowId?: string | undefined;
    animalNumber?: string | undefined;
    litterNumber?: number | undefined;
    nursingDays?: number | undefined;
    weaningDate!: Date;
    weanedPerLitter?: number | undefined;
    weightPerPiglet?: number | undefined;
    isNursingSow!: boolean;
    pregnancyId?: string | undefined;
    breedRace?: string | undefined;
    cellColorStyle!: CellColorStyle;

    constructor(data?: IBasicWeaningTableItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sowId = _data["sowId"];
            this.animalNumber = _data["animalNumber"];
            this.litterNumber = _data["litterNumber"];
            this.nursingDays = _data["nursingDays"];
            this.weaningDate = _data["weaningDate"] ? new Date(_data["weaningDate"].toString()) : <any>undefined;
            this.weanedPerLitter = _data["weanedPerLitter"];
            this.weightPerPiglet = _data["weightPerPiglet"];
            this.isNursingSow = _data["isNursingSow"];
            this.pregnancyId = _data["pregnancyId"];
            this.breedRace = _data["breedRace"];
            this.cellColorStyle = _data["cellColorStyle"];
        }
    }

    static fromJS(data: any): BasicWeaningTableItem {
        data = typeof data === 'object' ? data : {};
        let result = new BasicWeaningTableItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sowId"] = this.sowId;
        data["animalNumber"] = this.animalNumber;
        data["litterNumber"] = this.litterNumber;
        data["nursingDays"] = this.nursingDays;
        data["weaningDate"] = this.weaningDate ? this.weaningDate.toISOString() : <any>undefined;
        data["weanedPerLitter"] = this.weanedPerLitter;
        data["weightPerPiglet"] = this.weightPerPiglet;
        data["isNursingSow"] = this.isNursingSow;
        data["pregnancyId"] = this.pregnancyId;
        data["breedRace"] = this.breedRace;
        data["cellColorStyle"] = this.cellColorStyle;
        return data;
    }
}

export interface IBasicWeaningTableItem {
    sowId?: string | undefined;
    animalNumber?: string | undefined;
    litterNumber?: number | undefined;
    nursingDays?: number | undefined;
    weaningDate: Date;
    weanedPerLitter?: number | undefined;
    weightPerPiglet?: number | undefined;
    isNursingSow: boolean;
    pregnancyId?: string | undefined;
    breedRace?: string | undefined;
    cellColorStyle: CellColorStyle;
}

export class ResultAnalysisWeaningsTableItem extends BasicWeaningTableItem implements IResultAnalysisWeaningsTableItem {
    rowColorStyle!: CellColorStyle;

    constructor(data?: IResultAnalysisWeaningsTableItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.rowColorStyle = _data["rowColorStyle"];
        }
    }

    static override fromJS(data: any): ResultAnalysisWeaningsTableItem {
        data = typeof data === 'object' ? data : {};
        let result = new ResultAnalysisWeaningsTableItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowColorStyle"] = this.rowColorStyle;
        super.toJSON(data);
        return data;
    }
}

export interface IResultAnalysisWeaningsTableItem extends IBasicWeaningTableItem {
    rowColorStyle: CellColorStyle;
}

export class TotalMatingTableItem extends BasicMatingTableItem implements ITotalMatingTableItem {
    abortionToMatingDays?: number | undefined;
    matingDate?: Date | undefined;
    initials?: string | undefined;
    expectedFarrowingDate!: Date;

    constructor(data?: ITotalMatingTableItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.abortionToMatingDays = _data["abortionToMatingDays"];
            this.matingDate = _data["matingDate"] ? new Date(_data["matingDate"].toString()) : <any>undefined;
            this.initials = _data["initials"];
            this.expectedFarrowingDate = _data["expectedFarrowingDate"] ? new Date(_data["expectedFarrowingDate"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): TotalMatingTableItem {
        data = typeof data === 'object' ? data : {};
        let result = new TotalMatingTableItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["abortionToMatingDays"] = this.abortionToMatingDays;
        data["matingDate"] = this.matingDate ? this.matingDate.toISOString() : <any>undefined;
        data["initials"] = this.initials;
        data["expectedFarrowingDate"] = this.expectedFarrowingDate ? this.expectedFarrowingDate.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ITotalMatingTableItem extends IBasicMatingTableItem {
    abortionToMatingDays?: number | undefined;
    matingDate?: Date | undefined;
    initials?: string | undefined;
    expectedFarrowingDate: Date;
}

export class AnalysisMatingPregnancyTotalMatingTableItem extends TotalMatingTableItem implements IAnalysisMatingPregnancyTotalMatingTableItem {
    matingDateFirstMating?: Date | undefined;

    constructor(data?: IAnalysisMatingPregnancyTotalMatingTableItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.matingDateFirstMating = _data["matingDateFirstMating"] ? new Date(_data["matingDateFirstMating"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): AnalysisMatingPregnancyTotalMatingTableItem {
        data = typeof data === 'object' ? data : {};
        let result = new AnalysisMatingPregnancyTotalMatingTableItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["matingDateFirstMating"] = this.matingDateFirstMating ? this.matingDateFirstMating.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IAnalysisMatingPregnancyTotalMatingTableItem extends ITotalMatingTableItem {
    matingDateFirstMating?: Date | undefined;
}

export class AnalysisMatingPregnancyTableItem implements IAnalysisMatingPregnancyTableItem {
    matings!: number;
    tableDatas?: AnalysisMatingPregnancyTableData[] | undefined;

    constructor(data?: IAnalysisMatingPregnancyTableItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.matings = _data["matings"];
            if (Array.isArray(_data["tableDatas"])) {
                this.tableDatas = [] as any;
                for (let item of _data["tableDatas"])
                    this.tableDatas!.push(AnalysisMatingPregnancyTableData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AnalysisMatingPregnancyTableItem {
        data = typeof data === 'object' ? data : {};
        let result = new AnalysisMatingPregnancyTableItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["matings"] = this.matings;
        if (Array.isArray(this.tableDatas)) {
            data["tableDatas"] = [];
            for (let item of this.tableDatas)
                data["tableDatas"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAnalysisMatingPregnancyTableItem {
    matings: number;
    tableDatas?: AnalysisMatingPregnancyTableData[] | undefined;
}

export class AnalysisMatingPregnancyTableData implements IAnalysisMatingPregnancyTableData {
    name?: string | undefined;
    litters?: number[] | undefined;
    matings!: number;
    percentage!: number;
    avgDays!: number;
    boldName!: boolean;
    cellColorStyle!: CellColorStyle;

    constructor(data?: IAnalysisMatingPregnancyTableData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["litters"])) {
                this.litters = [] as any;
                for (let item of _data["litters"])
                    this.litters!.push(item);
            }
            this.matings = _data["matings"];
            this.percentage = _data["percentage"];
            this.avgDays = _data["avgDays"];
            this.boldName = _data["boldName"];
            this.cellColorStyle = _data["cellColorStyle"];
        }
    }

    static fromJS(data: any): AnalysisMatingPregnancyTableData {
        data = typeof data === 'object' ? data : {};
        let result = new AnalysisMatingPregnancyTableData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.litters)) {
            data["litters"] = [];
            for (let item of this.litters)
                data["litters"].push(item);
        }
        data["matings"] = this.matings;
        data["percentage"] = this.percentage;
        data["avgDays"] = this.avgDays;
        data["boldName"] = this.boldName;
        data["cellColorStyle"] = this.cellColorStyle;
        return data;
    }
}

export interface IAnalysisMatingPregnancyTableData {
    name?: string | undefined;
    litters?: number[] | undefined;
    matings: number;
    percentage: number;
    avgDays: number;
    boldName: boolean;
    cellColorStyle: CellColorStyle;
}

export class AnalysisDepartureSowTableData implements IAnalysisDepartureSowTableData {
    departureType?: { [key: string]: AnalysisDepartureSowTableItem; } | undefined;
    departureReason?: { [key: string]: AnalysisDepartureSowTableItem; } | undefined;
    period?: PeriodDto | undefined;

    constructor(data?: IAnalysisDepartureSowTableData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["departureType"]) {
                this.departureType = {} as any;
                for (let key in _data["departureType"]) {
                    if (_data["departureType"].hasOwnProperty(key))
                        (<any>this.departureType)![key] = _data["departureType"][key] ? AnalysisDepartureSowTableItem.fromJS(_data["departureType"][key]) : new AnalysisDepartureSowTableItem();
                }
            }
            if (_data["departureReason"]) {
                this.departureReason = {} as any;
                for (let key in _data["departureReason"]) {
                    if (_data["departureReason"].hasOwnProperty(key))
                        (<any>this.departureReason)![key] = _data["departureReason"][key] ? AnalysisDepartureSowTableItem.fromJS(_data["departureReason"][key]) : new AnalysisDepartureSowTableItem();
                }
            }
            this.period = _data["period"] ? PeriodDto.fromJS(_data["period"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AnalysisDepartureSowTableData {
        data = typeof data === 'object' ? data : {};
        let result = new AnalysisDepartureSowTableData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.departureType) {
            data["departureType"] = {};
            for (let key in this.departureType) {
                if (this.departureType.hasOwnProperty(key))
                    (<any>data["departureType"])[key] = this.departureType[key] ? this.departureType[key].toJSON() : <any>undefined;
            }
        }
        if (this.departureReason) {
            data["departureReason"] = {};
            for (let key in this.departureReason) {
                if (this.departureReason.hasOwnProperty(key))
                    (<any>data["departureReason"])[key] = this.departureReason[key] ? this.departureReason[key].toJSON() : <any>undefined;
            }
        }
        data["period"] = this.period ? this.period.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAnalysisDepartureSowTableData {
    departureType?: { [key: string]: AnalysisDepartureSowTableItem; } | undefined;
    departureReason?: { [key: string]: AnalysisDepartureSowTableItem; } | undefined;
    period?: PeriodDto | undefined;
}

export class AnalysisDepartureSowTableItem implements IAnalysisDepartureSowTableItem {
    animalCount!: number;
    name?: string | undefined;
    litter0!: number;
    litter1!: number;
    litter2!: number;
    litter3!: number;
    litter4!: number;
    litter5!: number;
    litter6!: number;
    litter7!: number;
    litter8!: number;
    litter9Plus!: number;
    totalPct!: number;
    cellColorStyle!: CellColorStyle;

    constructor(data?: IAnalysisDepartureSowTableItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.animalCount = _data["animalCount"];
            this.name = _data["name"];
            this.litter0 = _data["litter0"];
            this.litter1 = _data["litter1"];
            this.litter2 = _data["litter2"];
            this.litter3 = _data["litter3"];
            this.litter4 = _data["litter4"];
            this.litter5 = _data["litter5"];
            this.litter6 = _data["litter6"];
            this.litter7 = _data["litter7"];
            this.litter8 = _data["litter8"];
            this.litter9Plus = _data["litter9Plus"];
            this.totalPct = _data["totalPct"];
            this.cellColorStyle = _data["cellColorStyle"];
        }
    }

    static fromJS(data: any): AnalysisDepartureSowTableItem {
        data = typeof data === 'object' ? data : {};
        let result = new AnalysisDepartureSowTableItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["animalCount"] = this.animalCount;
        data["name"] = this.name;
        data["litter0"] = this.litter0;
        data["litter1"] = this.litter1;
        data["litter2"] = this.litter2;
        data["litter3"] = this.litter3;
        data["litter4"] = this.litter4;
        data["litter5"] = this.litter5;
        data["litter6"] = this.litter6;
        data["litter7"] = this.litter7;
        data["litter8"] = this.litter8;
        data["litter9Plus"] = this.litter9Plus;
        data["totalPct"] = this.totalPct;
        data["cellColorStyle"] = this.cellColorStyle;
        return data;
    }
}

export interface IAnalysisDepartureSowTableItem {
    animalCount: number;
    name?: string | undefined;
    litter0: number;
    litter1: number;
    litter2: number;
    litter3: number;
    litter4: number;
    litter5: number;
    litter6: number;
    litter7: number;
    litter8: number;
    litter9Plus: number;
    totalPct: number;
    cellColorStyle: CellColorStyle;
}

export class PeriodDto implements IPeriodDto {
    dateFrom?: string | undefined;
    dateTo?: string | undefined;

    constructor(data?: IPeriodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateFrom = _data["dateFrom"];
            this.dateTo = _data["dateTo"];
        }
    }

    static fromJS(data: any): PeriodDto {
        data = typeof data === 'object' ? data : {};
        let result = new PeriodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateFrom"] = this.dateFrom;
        data["dateTo"] = this.dateTo;
        return data;
    }
}

export interface IPeriodDto {
    dateFrom?: string | undefined;
    dateTo?: string | undefined;
}

export class AnalysisDepartureGpeTableData implements IAnalysisDepartureGpeTableData {
    type!: AnimalType;
    departureReason?: { [key: string]: AnalysisDepartureGpeTableItem; } | undefined;
    period?: PeriodDto | undefined;

    constructor(data?: IAnalysisDepartureGpeTableData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            if (_data["departureReason"]) {
                this.departureReason = {} as any;
                for (let key in _data["departureReason"]) {
                    if (_data["departureReason"].hasOwnProperty(key))
                        (<any>this.departureReason)![key] = _data["departureReason"][key] ? AnalysisDepartureGpeTableItem.fromJS(_data["departureReason"][key]) : new AnalysisDepartureGpeTableItem();
                }
            }
            this.period = _data["period"] ? PeriodDto.fromJS(_data["period"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AnalysisDepartureGpeTableData {
        data = typeof data === 'object' ? data : {};
        let result = new AnalysisDepartureGpeTableData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (this.departureReason) {
            data["departureReason"] = {};
            for (let key in this.departureReason) {
                if (this.departureReason.hasOwnProperty(key))
                    (<any>data["departureReason"])[key] = this.departureReason[key] ? this.departureReason[key].toJSON() : <any>undefined;
            }
        }
        data["period"] = this.period ? this.period.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAnalysisDepartureGpeTableData {
    type: AnimalType;
    departureReason?: { [key: string]: AnalysisDepartureGpeTableItem; } | undefined;
    period?: PeriodDto | undefined;
}

export enum AnimalType {
    Sow = "Sow",
    Weaner = "Weaner",
    Finisher = "Finisher",
    FRATS = "FRATS",
    YoungFemale = "YoungFemale",
    Piglet = "Piglet",
    Unknown = "Unknown",
}

export class AnalysisDepartureGpeTableItem implements IAnalysisDepartureGpeTableItem {
    animalCount!: number;
    name?: string | undefined;
    weekValue?: { [key: string]: number; } | undefined;
    totalPct!: number;
    cellColorStyle!: CellColorStyle;

    constructor(data?: IAnalysisDepartureGpeTableItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.animalCount = _data["animalCount"];
            this.name = _data["name"];
            if (_data["weekValue"]) {
                this.weekValue = {} as any;
                for (let key in _data["weekValue"]) {
                    if (_data["weekValue"].hasOwnProperty(key))
                        (<any>this.weekValue)![key] = _data["weekValue"][key];
                }
            }
            this.totalPct = _data["totalPct"];
            this.cellColorStyle = _data["cellColorStyle"];
        }
    }

    static fromJS(data: any): AnalysisDepartureGpeTableItem {
        data = typeof data === 'object' ? data : {};
        let result = new AnalysisDepartureGpeTableItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["animalCount"] = this.animalCount;
        data["name"] = this.name;
        if (this.weekValue) {
            data["weekValue"] = {};
            for (let key in this.weekValue) {
                if (this.weekValue.hasOwnProperty(key))
                    (<any>data["weekValue"])[key] = (<any>this.weekValue)[key];
            }
        }
        data["totalPct"] = this.totalPct;
        data["cellColorStyle"] = this.cellColorStyle;
        return data;
    }
}

export interface IAnalysisDepartureGpeTableItem {
    animalCount: number;
    name?: string | undefined;
    weekValue?: { [key: string]: number; } | undefined;
    totalPct: number;
    cellColorStyle: CellColorStyle;
}

export class AnalysisDepartureGpeRequestModel implements IAnalysisDepartureGpeRequestModel {
    siteId?: string | undefined;
    animalType!: AnimalType;
    fromDate!: Date;
    toDate!: Date;
    asPercentage!: boolean;
    allowDepartureTypes?: string[] | undefined;

    constructor(data?: IAnalysisDepartureGpeRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.siteId = _data["siteId"];
            this.animalType = _data["animalType"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : <any>undefined;
            this.asPercentage = _data["asPercentage"];
            if (Array.isArray(_data["allowDepartureTypes"])) {
                this.allowDepartureTypes = [] as any;
                for (let item of _data["allowDepartureTypes"])
                    this.allowDepartureTypes!.push(item);
            }
        }
    }

    static fromJS(data: any): AnalysisDepartureGpeRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new AnalysisDepartureGpeRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siteId"] = this.siteId;
        data["animalType"] = this.animalType;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["asPercentage"] = this.asPercentage;
        if (Array.isArray(this.allowDepartureTypes)) {
            data["allowDepartureTypes"] = [];
            for (let item of this.allowDepartureTypes)
                data["allowDepartureTypes"].push(item);
        }
        return data;
    }
}

export interface IAnalysisDepartureGpeRequestModel {
    siteId?: string | undefined;
    animalType: AnimalType;
    fromDate: Date;
    toDate: Date;
    asPercentage: boolean;
    allowDepartureTypes?: string[] | undefined;
}

export class ResultAnalysisFarrowingsData implements IResultAnalysisFarrowingsData {
    tableModels?: ResultAnalysisFarrowingsTableItem[] | undefined;
    period?: PeriodDto | undefined;

    constructor(data?: IResultAnalysisFarrowingsData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tableModels"])) {
                this.tableModels = [] as any;
                for (let item of _data["tableModels"])
                    this.tableModels!.push(ResultAnalysisFarrowingsTableItem.fromJS(item));
            }
            this.period = _data["period"] ? PeriodDto.fromJS(_data["period"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultAnalysisFarrowingsData {
        data = typeof data === 'object' ? data : {};
        let result = new ResultAnalysisFarrowingsData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tableModels)) {
            data["tableModels"] = [];
            for (let item of this.tableModels)
                data["tableModels"].push(item.toJSON());
        }
        data["period"] = this.period ? this.period.toJSON() : <any>undefined;
        return data;
    }
}

export interface IResultAnalysisFarrowingsData {
    tableModels?: ResultAnalysisFarrowingsTableItem[] | undefined;
    period?: PeriodDto | undefined;
}

export class ResultAnalysisMatingsData implements IResultAnalysisMatingsData {
    tableModels?: ResultAnalysisMatingsTableItem[] | undefined;
    period?: PeriodDto | undefined;

    constructor(data?: IResultAnalysisMatingsData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tableModels"])) {
                this.tableModels = [] as any;
                for (let item of _data["tableModels"])
                    this.tableModels!.push(ResultAnalysisMatingsTableItem.fromJS(item));
            }
            this.period = _data["period"] ? PeriodDto.fromJS(_data["period"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultAnalysisMatingsData {
        data = typeof data === 'object' ? data : {};
        let result = new ResultAnalysisMatingsData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tableModels)) {
            data["tableModels"] = [];
            for (let item of this.tableModels)
                data["tableModels"].push(item.toJSON());
        }
        data["period"] = this.period ? this.period.toJSON() : <any>undefined;
        return data;
    }
}

export interface IResultAnalysisMatingsData {
    tableModels?: ResultAnalysisMatingsTableItem[] | undefined;
    period?: PeriodDto | undefined;
}

export class AnalysisMatingPregnancyTotalMatingData implements IAnalysisMatingPregnancyTotalMatingData {
    tableModels?: AnalysisMatingPregnancyTotalMatingTableItem[] | undefined;
    period?: PeriodDto | undefined;

    constructor(data?: IAnalysisMatingPregnancyTotalMatingData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tableModels"])) {
                this.tableModels = [] as any;
                for (let item of _data["tableModels"])
                    this.tableModels!.push(AnalysisMatingPregnancyTotalMatingTableItem.fromJS(item));
            }
            this.period = _data["period"] ? PeriodDto.fromJS(_data["period"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AnalysisMatingPregnancyTotalMatingData {
        data = typeof data === 'object' ? data : {};
        let result = new AnalysisMatingPregnancyTotalMatingData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tableModels)) {
            data["tableModels"] = [];
            for (let item of this.tableModels)
                data["tableModels"].push(item.toJSON());
        }
        data["period"] = this.period ? this.period.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAnalysisMatingPregnancyTotalMatingData {
    tableModels?: AnalysisMatingPregnancyTotalMatingTableItem[] | undefined;
    period?: PeriodDto | undefined;
}

export class ResultAnalysisWeaningsData implements IResultAnalysisWeaningsData {
    tableModels?: ResultAnalysisWeaningsTableItem[] | undefined;
    period?: PeriodDto | undefined;

    constructor(data?: IResultAnalysisWeaningsData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tableModels"])) {
                this.tableModels = [] as any;
                for (let item of _data["tableModels"])
                    this.tableModels!.push(ResultAnalysisWeaningsTableItem.fromJS(item));
            }
            this.period = _data["period"] ? PeriodDto.fromJS(_data["period"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultAnalysisWeaningsData {
        data = typeof data === 'object' ? data : {};
        let result = new ResultAnalysisWeaningsData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tableModels)) {
            data["tableModels"] = [];
            for (let item of this.tableModels)
                data["tableModels"].push(item.toJSON());
        }
        data["period"] = this.period ? this.period.toJSON() : <any>undefined;
        return data;
    }
}

export interface IResultAnalysisWeaningsData {
    tableModels?: ResultAnalysisWeaningsTableItem[] | undefined;
    period?: PeriodDto | undefined;
}

export class ResultPerLitterData implements IResultPerLitterData {
    tableModels?: ResultPerLitterTableItem[] | undefined;
    period?: PeriodDto | undefined;

    constructor(data?: IResultPerLitterData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tableModels"])) {
                this.tableModels = [] as any;
                for (let item of _data["tableModels"])
                    this.tableModels!.push(ResultPerLitterTableItem.fromJS(item));
            }
            this.period = _data["period"] ? PeriodDto.fromJS(_data["period"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultPerLitterData {
        data = typeof data === 'object' ? data : {};
        let result = new ResultPerLitterData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tableModels)) {
            data["tableModels"] = [];
            for (let item of this.tableModels)
                data["tableModels"].push(item.toJSON());
        }
        data["period"] = this.period ? this.period.toJSON() : <any>undefined;
        return data;
    }
}

export interface IResultPerLitterData {
    tableModels?: ResultPerLitterTableItem[] | undefined;
    period?: PeriodDto | undefined;
}

export class ResultYoungFemaleAgeData implements IResultYoungFemaleAgeData {
    tableModels?: ResultYoungFemaleAgeTableItem[] | undefined;
    period?: PeriodDto | undefined;

    constructor(data?: IResultYoungFemaleAgeData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tableModels"])) {
                this.tableModels = [] as any;
                for (let item of _data["tableModels"])
                    this.tableModels!.push(ResultYoungFemaleAgeTableItem.fromJS(item));
            }
            this.period = _data["period"] ? PeriodDto.fromJS(_data["period"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultYoungFemaleAgeData {
        data = typeof data === 'object' ? data : {};
        let result = new ResultYoungFemaleAgeData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tableModels)) {
            data["tableModels"] = [];
            for (let item of this.tableModels)
                data["tableModels"].push(item.toJSON());
        }
        data["period"] = this.period ? this.period.toJSON() : <any>undefined;
        return data;
    }
}

export interface IResultYoungFemaleAgeData {
    tableModels?: ResultYoungFemaleAgeTableItem[] | undefined;
    period?: PeriodDto | undefined;
}

export class AnalysisResultYoungFemaleAgePeriod implements IAnalysisResultYoungFemaleAgePeriod {
    fromAge?: number | undefined;
    toAge?: number | undefined;
    agePeriod!: AnalysisResultYoungFemaleAge;
    isFrom!: boolean;

    constructor(data?: IAnalysisResultYoungFemaleAgePeriod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromAge = _data["fromAge"];
            this.toAge = _data["toAge"];
            this.agePeriod = _data["agePeriod"];
            this.isFrom = _data["isFrom"];
        }
    }

    static fromJS(data: any): AnalysisResultYoungFemaleAgePeriod {
        data = typeof data === 'object' ? data : {};
        let result = new AnalysisResultYoungFemaleAgePeriod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromAge"] = this.fromAge;
        data["toAge"] = this.toAge;
        data["agePeriod"] = this.agePeriod;
        data["isFrom"] = this.isFrom;
        return data;
    }
}

export interface IAnalysisResultYoungFemaleAgePeriod {
    fromAge?: number | undefined;
    toAge?: number | undefined;
    agePeriod: AnalysisResultYoungFemaleAge;
    isFrom: boolean;
}

export enum AnalysisResultYoungFemaleAge {
    AgePeriod1 = "AgePeriod1",
    AgePeriod2 = "AgePeriod2",
    AgePeriod3 = "AgePeriod3",
    AgePeriod4 = "AgePeriod4",
    AgePeriod5 = "AgePeriod5",
}

export class AnalysisPregnancyData implements IAnalysisPregnancyData {
    tableModels?: AnalysisPregnancyTableData[] | undefined;
    period?: PeriodDto | undefined;

    constructor(data?: IAnalysisPregnancyData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tableModels"])) {
                this.tableModels = [] as any;
                for (let item of _data["tableModels"])
                    this.tableModels!.push(AnalysisPregnancyTableData.fromJS(item));
            }
            this.period = _data["period"] ? PeriodDto.fromJS(_data["period"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AnalysisPregnancyData {
        data = typeof data === 'object' ? data : {};
        let result = new AnalysisPregnancyData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tableModels)) {
            data["tableModels"] = [];
            for (let item of this.tableModels)
                data["tableModels"].push(item.toJSON());
        }
        data["period"] = this.period ? this.period.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAnalysisPregnancyData {
    tableModels?: AnalysisPregnancyTableData[] | undefined;
    period?: PeriodDto | undefined;
}

export class AnalysisMatingPregnancyData implements IAnalysisMatingPregnancyData {
    tableModels?: AnalysisMatingPregnancyTableData[] | undefined;
    period?: PeriodDto | undefined;

    constructor(data?: IAnalysisMatingPregnancyData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tableModels"])) {
                this.tableModels = [] as any;
                for (let item of _data["tableModels"])
                    this.tableModels!.push(AnalysisMatingPregnancyTableData.fromJS(item));
            }
            this.period = _data["period"] ? PeriodDto.fromJS(_data["period"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AnalysisMatingPregnancyData {
        data = typeof data === 'object' ? data : {};
        let result = new AnalysisMatingPregnancyData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tableModels)) {
            data["tableModels"] = [];
            for (let item of this.tableModels)
                data["tableModels"].push(item.toJSON());
        }
        data["period"] = this.period ? this.period.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAnalysisMatingPregnancyData {
    tableModels?: AnalysisMatingPregnancyTableData[] | undefined;
    period?: PeriodDto | undefined;
}

export class AnalysisSetting extends SiteEntity implements IAnalysisSetting {
    name?: string | undefined;
    type!: AnalysisSettingType;

    protected _discriminator: string;

    constructor(data?: IAnalysisSetting) {
        super(data);
        this._discriminator = "AnalysisSetting";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.type = _data["type"];
        }
    }

    static override fromJS(data: any): AnalysisSetting {
        data = typeof data === 'object' ? data : {};
        if (data["derivedTypeSelector"] === "AnalysisResultYoungFemaleAgeSetting") {
            let result = new AnalysisResultYoungFemaleAgeSetting();
            result.init(data);
            return result;
        }
        if (data["derivedTypeSelector"] === "AnalysisResultPregnancySetting") {
            let result = new AnalysisResultPregnancySetting();
            result.init(data);
            return result;
        }
        let result = new AnalysisSetting();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["derivedTypeSelector"] = this._discriminator;
        data["name"] = this.name;
        data["type"] = this.type;
        super.toJSON(data);
        return data;
    }
}

export interface IAnalysisSetting extends ISiteEntity {
    name?: string | undefined;
    type: AnalysisSettingType;
}

export enum AnalysisSettingType {
    AnalysisResultYoungFemaleAgeSetting = "AnalysisResultYoungFemaleAgeSetting",
    AnalysisResultPregnancySetting = "AnalysisResultPregnancySetting",
}

export class AnalysisResultYoungFemaleAgeSetting extends AnalysisSetting implements IAnalysisResultYoungFemaleAgeSetting {
    agePeriods?: AnalysisResultYoungFemaleAgePeriod[] | undefined;

    constructor(data?: IAnalysisResultYoungFemaleAgeSetting) {
        super(data);
        this._discriminator = "AnalysisResultYoungFemaleAgeSetting";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["agePeriods"])) {
                this.agePeriods = [] as any;
                for (let item of _data["agePeriods"])
                    this.agePeriods!.push(AnalysisResultYoungFemaleAgePeriod.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AnalysisResultYoungFemaleAgeSetting {
        data = typeof data === 'object' ? data : {};
        let result = new AnalysisResultYoungFemaleAgeSetting();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.agePeriods)) {
            data["agePeriods"] = [];
            for (let item of this.agePeriods)
                data["agePeriods"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IAnalysisResultYoungFemaleAgeSetting extends IAnalysisSetting {
    agePeriods?: AnalysisResultYoungFemaleAgePeriod[] | undefined;
}

export class AnalysisResultPregnancySetting extends AnalysisSetting implements IAnalysisResultPregnancySetting {
    weaningToMating?: AnalysisResultPregnancyDayPeriod[] | undefined;
    matingToNonPregnant?: AnalysisResultPregnancyDayPeriod[] | undefined;
    matingToMating?: AnalysisResultPregnancyDayPeriod[] | undefined;

    constructor(data?: IAnalysisResultPregnancySetting) {
        super(data);
        this._discriminator = "AnalysisResultPregnancySetting";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["weaningToMating"])) {
                this.weaningToMating = [] as any;
                for (let item of _data["weaningToMating"])
                    this.weaningToMating!.push(AnalysisResultPregnancyDayPeriod.fromJS(item));
            }
            if (Array.isArray(_data["matingToNonPregnant"])) {
                this.matingToNonPregnant = [] as any;
                for (let item of _data["matingToNonPregnant"])
                    this.matingToNonPregnant!.push(AnalysisResultPregnancyDayPeriod.fromJS(item));
            }
            if (Array.isArray(_data["matingToMating"])) {
                this.matingToMating = [] as any;
                for (let item of _data["matingToMating"])
                    this.matingToMating!.push(AnalysisResultPregnancyDayPeriod.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AnalysisResultPregnancySetting {
        data = typeof data === 'object' ? data : {};
        let result = new AnalysisResultPregnancySetting();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.weaningToMating)) {
            data["weaningToMating"] = [];
            for (let item of this.weaningToMating)
                data["weaningToMating"].push(item.toJSON());
        }
        if (Array.isArray(this.matingToNonPregnant)) {
            data["matingToNonPregnant"] = [];
            for (let item of this.matingToNonPregnant)
                data["matingToNonPregnant"].push(item.toJSON());
        }
        if (Array.isArray(this.matingToMating)) {
            data["matingToMating"] = [];
            for (let item of this.matingToMating)
                data["matingToMating"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IAnalysisResultPregnancySetting extends IAnalysisSetting {
    weaningToMating?: AnalysisResultPregnancyDayPeriod[] | undefined;
    matingToNonPregnant?: AnalysisResultPregnancyDayPeriod[] | undefined;
    matingToMating?: AnalysisResultPregnancyDayPeriod[] | undefined;
}

export class AnalysisResultPregnancyDayPeriod implements IAnalysisResultPregnancyDayPeriod {
    from?: number | undefined;
    to?: number | undefined;

    constructor(data?: IAnalysisResultPregnancyDayPeriod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"];
            this.to = _data["to"];
        }
    }

    static fromJS(data: any): AnalysisResultPregnancyDayPeriod {
        data = typeof data === 'object' ? data : {};
        let result = new AnalysisResultPregnancyDayPeriod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from;
        data["to"] = this.to;
        return data;
    }
}

export interface IAnalysisResultPregnancyDayPeriod {
    from?: number | undefined;
    to?: number | undefined;
}

export class ActiveSow implements IActiveSow {
    race?: string | undefined;
    animalKind?: string | undefined;
    condition?: string | undefined;
    animalNumber?: string | undefined;
    entranceDate?: string | undefined;
    entranceType?: string | undefined;
    transponder?: string | undefined;
    cycleDays?: string | undefined;
    batch?: string | undefined;
    teats?: string | undefined;
    litterNumber?: number | undefined;
    cellColorStyle!: CellColorStyle;

    constructor(data?: IActiveSow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.race = _data["race"];
            this.animalKind = _data["animalKind"];
            this.condition = _data["condition"];
            this.animalNumber = _data["animalNumber"];
            this.entranceDate = _data["entranceDate"];
            this.entranceType = _data["entranceType"];
            this.transponder = _data["transponder"];
            this.cycleDays = _data["cycleDays"];
            this.batch = _data["batch"];
            this.teats = _data["teats"];
            this.litterNumber = _data["litterNumber"];
            this.cellColorStyle = _data["cellColorStyle"];
        }
    }

    static fromJS(data: any): ActiveSow {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveSow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["race"] = this.race;
        data["animalKind"] = this.animalKind;
        data["condition"] = this.condition;
        data["animalNumber"] = this.animalNumber;
        data["entranceDate"] = this.entranceDate;
        data["entranceType"] = this.entranceType;
        data["transponder"] = this.transponder;
        data["cycleDays"] = this.cycleDays;
        data["batch"] = this.batch;
        data["teats"] = this.teats;
        data["litterNumber"] = this.litterNumber;
        data["cellColorStyle"] = this.cellColorStyle;
        return data;
    }
}

export interface IActiveSow {
    race?: string | undefined;
    animalKind?: string | undefined;
    condition?: string | undefined;
    animalNumber?: string | undefined;
    entranceDate?: string | undefined;
    entranceType?: string | undefined;
    transponder?: string | undefined;
    cycleDays?: string | undefined;
    batch?: string | undefined;
    teats?: string | undefined;
    litterNumber?: number | undefined;
    cellColorStyle: CellColorStyle;
}

export class DadMomTableItem implements IDadMomTableItem {
    animalNumber?: string | undefined;
    idNumber?: string | undefined;
    race?: string | undefined;
    raceLine?: string | undefined;
    birthDate?: string | undefined;
    dadNr?: string | undefined;
    dadIdNumber?: string | undefined;
    momNr?: string | undefined;
    momIdNumber?: string | undefined;
    index?: string | undefined;
    cellColorStyle!: CellColorStyle;

    constructor(data?: IDadMomTableItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.animalNumber = _data["animalNumber"];
            this.idNumber = _data["idNumber"];
            this.race = _data["race"];
            this.raceLine = _data["raceLine"];
            this.birthDate = _data["birthDate"];
            this.dadNr = _data["dadNr"];
            this.dadIdNumber = _data["dadIdNumber"];
            this.momNr = _data["momNr"];
            this.momIdNumber = _data["momIdNumber"];
            this.index = _data["index"];
            this.cellColorStyle = _data["cellColorStyle"];
        }
    }

    static fromJS(data: any): DadMomTableItem {
        data = typeof data === 'object' ? data : {};
        let result = new DadMomTableItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["animalNumber"] = this.animalNumber;
        data["idNumber"] = this.idNumber;
        data["race"] = this.race;
        data["raceLine"] = this.raceLine;
        data["birthDate"] = this.birthDate;
        data["dadNr"] = this.dadNr;
        data["dadIdNumber"] = this.dadIdNumber;
        data["momNr"] = this.momNr;
        data["momIdNumber"] = this.momIdNumber;
        data["index"] = this.index;
        data["cellColorStyle"] = this.cellColorStyle;
        return data;
    }
}

export interface IDadMomTableItem {
    animalNumber?: string | undefined;
    idNumber?: string | undefined;
    race?: string | undefined;
    raceLine?: string | undefined;
    birthDate?: string | undefined;
    dadNr?: string | undefined;
    dadIdNumber?: string | undefined;
    momNr?: string | undefined;
    momIdNumber?: string | undefined;
    index?: string | undefined;
    cellColorStyle: CellColorStyle;
}

export class YoungAnimalTableItem implements IYoungAnimalTableItem {
    idNumber?: string | undefined;
    age?: string | undefined;
    race?: string | undefined;
    raceLine?: string | undefined;
    gender?: string | undefined;
    birthDate?: string | undefined;
    dadNr?: string | undefined;
    dadIdNumber?: string | undefined;
    momNr?: string | undefined;
    momIdNumber?: string | undefined;
    index?: string | undefined;
    cellColorStyle!: CellColorStyle;

    constructor(data?: IYoungAnimalTableItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idNumber = _data["idNumber"];
            this.age = _data["age"];
            this.race = _data["race"];
            this.raceLine = _data["raceLine"];
            this.gender = _data["gender"];
            this.birthDate = _data["birthDate"];
            this.dadNr = _data["dadNr"];
            this.dadIdNumber = _data["dadIdNumber"];
            this.momNr = _data["momNr"];
            this.momIdNumber = _data["momIdNumber"];
            this.index = _data["index"];
            this.cellColorStyle = _data["cellColorStyle"];
        }
    }

    static fromJS(data: any): YoungAnimalTableItem {
        data = typeof data === 'object' ? data : {};
        let result = new YoungAnimalTableItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idNumber"] = this.idNumber;
        data["age"] = this.age;
        data["race"] = this.race;
        data["raceLine"] = this.raceLine;
        data["gender"] = this.gender;
        data["birthDate"] = this.birthDate;
        data["dadNr"] = this.dadNr;
        data["dadIdNumber"] = this.dadIdNumber;
        data["momNr"] = this.momNr;
        data["momIdNumber"] = this.momIdNumber;
        data["index"] = this.index;
        data["cellColorStyle"] = this.cellColorStyle;
        return data;
    }
}

export interface IYoungAnimalTableItem {
    idNumber?: string | undefined;
    age?: string | undefined;
    race?: string | undefined;
    raceLine?: string | undefined;
    gender?: string | undefined;
    birthDate?: string | undefined;
    dadNr?: string | undefined;
    dadIdNumber?: string | undefined;
    momNr?: string | undefined;
    momIdNumber?: string | undefined;
    index?: string | undefined;
    cellColorStyle: CellColorStyle;
}

export class DepartedSow implements IDepartedSow {
    race?: string | undefined;
    animalKind?: string | undefined;
    condition?: string | undefined;
    animalNumber?: string | undefined;
    entranceDate?: string | undefined;
    entranceType?: string | undefined;
    departureDate?: string | undefined;
    departureType?: string | undefined;
    departureReason?: string | undefined;
    transponder?: string | undefined;
    batch?: string | undefined;
    teats?: string | undefined;
    cellColorStyle!: CellColorStyle;

    constructor(data?: IDepartedSow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.race = _data["race"];
            this.animalKind = _data["animalKind"];
            this.condition = _data["condition"];
            this.animalNumber = _data["animalNumber"];
            this.entranceDate = _data["entranceDate"];
            this.entranceType = _data["entranceType"];
            this.departureDate = _data["departureDate"];
            this.departureType = _data["departureType"];
            this.departureReason = _data["departureReason"];
            this.transponder = _data["transponder"];
            this.batch = _data["batch"];
            this.teats = _data["teats"];
            this.cellColorStyle = _data["cellColorStyle"];
        }
    }

    static fromJS(data: any): DepartedSow {
        data = typeof data === 'object' ? data : {};
        let result = new DepartedSow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["race"] = this.race;
        data["animalKind"] = this.animalKind;
        data["condition"] = this.condition;
        data["animalNumber"] = this.animalNumber;
        data["entranceDate"] = this.entranceDate;
        data["entranceType"] = this.entranceType;
        data["departureDate"] = this.departureDate;
        data["departureType"] = this.departureType;
        data["departureReason"] = this.departureReason;
        data["transponder"] = this.transponder;
        data["batch"] = this.batch;
        data["teats"] = this.teats;
        data["cellColorStyle"] = this.cellColorStyle;
        return data;
    }
}

export interface IDepartedSow {
    race?: string | undefined;
    animalKind?: string | undefined;
    condition?: string | undefined;
    animalNumber?: string | undefined;
    entranceDate?: string | undefined;
    entranceType?: string | undefined;
    departureDate?: string | undefined;
    departureType?: string | undefined;
    departureReason?: string | undefined;
    transponder?: string | undefined;
    batch?: string | undefined;
    teats?: string | undefined;
    cellColorStyle: CellColorStyle;
}

export class MatingEventPdfItem implements IMatingEventPdfItem {
    animalNumber?: string | undefined;
    race?: string | undefined;
    litter?: string | undefined;
    registrationDate?: string | undefined;
    boarNumber?: string | undefined;
    grade?: string | undefined;
    initials?: string | undefined;
    cellColorStyle!: CellColorStyle;

    constructor(data?: IMatingEventPdfItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.animalNumber = _data["animalNumber"];
            this.race = _data["race"];
            this.litter = _data["litter"];
            this.registrationDate = _data["registrationDate"];
            this.boarNumber = _data["boarNumber"];
            this.grade = _data["grade"];
            this.initials = _data["initials"];
            this.cellColorStyle = _data["cellColorStyle"];
        }
    }

    static fromJS(data: any): MatingEventPdfItem {
        data = typeof data === 'object' ? data : {};
        let result = new MatingEventPdfItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["animalNumber"] = this.animalNumber;
        data["race"] = this.race;
        data["litter"] = this.litter;
        data["registrationDate"] = this.registrationDate;
        data["boarNumber"] = this.boarNumber;
        data["grade"] = this.grade;
        data["initials"] = this.initials;
        data["cellColorStyle"] = this.cellColorStyle;
        return data;
    }
}

export interface IMatingEventPdfItem {
    animalNumber?: string | undefined;
    race?: string | undefined;
    litter?: string | undefined;
    registrationDate?: string | undefined;
    boarNumber?: string | undefined;
    grade?: string | undefined;
    initials?: string | undefined;
    cellColorStyle: CellColorStyle;
}

export class ScanningEventPdfItem implements IScanningEventPdfItem {
    animalNumber?: string | undefined;
    race?: string | undefined;
    litter?: string | undefined;
    registrationDate?: string | undefined;
    scanResult?: string | undefined;
    initials?: string | undefined;
    cellColorStyle!: CellColorStyle;

    constructor(data?: IScanningEventPdfItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.animalNumber = _data["animalNumber"];
            this.race = _data["race"];
            this.litter = _data["litter"];
            this.registrationDate = _data["registrationDate"];
            this.scanResult = _data["scanResult"];
            this.initials = _data["initials"];
            this.cellColorStyle = _data["cellColorStyle"];
        }
    }

    static fromJS(data: any): ScanningEventPdfItem {
        data = typeof data === 'object' ? data : {};
        let result = new ScanningEventPdfItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["animalNumber"] = this.animalNumber;
        data["race"] = this.race;
        data["litter"] = this.litter;
        data["registrationDate"] = this.registrationDate;
        data["scanResult"] = this.scanResult;
        data["initials"] = this.initials;
        data["cellColorStyle"] = this.cellColorStyle;
        return data;
    }
}

export interface IScanningEventPdfItem {
    animalNumber?: string | undefined;
    race?: string | undefined;
    litter?: string | undefined;
    registrationDate?: string | undefined;
    scanResult?: string | undefined;
    initials?: string | undefined;
    cellColorStyle: CellColorStyle;
}

export class FarrowingEventPdfItem implements IFarrowingEventPdfItem {
    animalNumber?: string | undefined;
    race?: string | undefined;
    location?: string | undefined;
    litter?: string | undefined;
    registrationDate?: string | undefined;
    alive?: string | undefined;
    dead?: string | undefined;
    abortion?: string | undefined;
    initials?: string | undefined;
    cellColorStyle!: CellColorStyle;

    constructor(data?: IFarrowingEventPdfItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.animalNumber = _data["animalNumber"];
            this.race = _data["race"];
            this.location = _data["location"];
            this.litter = _data["litter"];
            this.registrationDate = _data["registrationDate"];
            this.alive = _data["alive"];
            this.dead = _data["dead"];
            this.abortion = _data["abortion"];
            this.initials = _data["initials"];
            this.cellColorStyle = _data["cellColorStyle"];
        }
    }

    static fromJS(data: any): FarrowingEventPdfItem {
        data = typeof data === 'object' ? data : {};
        let result = new FarrowingEventPdfItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["animalNumber"] = this.animalNumber;
        data["race"] = this.race;
        data["location"] = this.location;
        data["litter"] = this.litter;
        data["registrationDate"] = this.registrationDate;
        data["alive"] = this.alive;
        data["dead"] = this.dead;
        data["abortion"] = this.abortion;
        data["initials"] = this.initials;
        data["cellColorStyle"] = this.cellColorStyle;
        return data;
    }
}

export interface IFarrowingEventPdfItem {
    animalNumber?: string | undefined;
    race?: string | undefined;
    location?: string | undefined;
    litter?: string | undefined;
    registrationDate?: string | undefined;
    alive?: string | undefined;
    dead?: string | undefined;
    abortion?: string | undefined;
    initials?: string | undefined;
    cellColorStyle: CellColorStyle;
}

export class WeaningEventPdfItem implements IWeaningEventPdfItem {
    animalNumber?: string | undefined;
    race?: string | undefined;
    location?: string | undefined;
    litter?: string | undefined;
    registrationDate?: string | undefined;
    weanedPcs?: string | undefined;
    avgWeight?: string | undefined;
    nursingSow?: string | undefined;
    initials?: string | undefined;
    cellColorStyle!: CellColorStyle;

    constructor(data?: IWeaningEventPdfItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.animalNumber = _data["animalNumber"];
            this.race = _data["race"];
            this.location = _data["location"];
            this.litter = _data["litter"];
            this.registrationDate = _data["registrationDate"];
            this.weanedPcs = _data["weanedPcs"];
            this.avgWeight = _data["avgWeight"];
            this.nursingSow = _data["nursingSow"];
            this.initials = _data["initials"];
            this.cellColorStyle = _data["cellColorStyle"];
        }
    }

    static fromJS(data: any): WeaningEventPdfItem {
        data = typeof data === 'object' ? data : {};
        let result = new WeaningEventPdfItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["animalNumber"] = this.animalNumber;
        data["race"] = this.race;
        data["location"] = this.location;
        data["litter"] = this.litter;
        data["registrationDate"] = this.registrationDate;
        data["weanedPcs"] = this.weanedPcs;
        data["avgWeight"] = this.avgWeight;
        data["nursingSow"] = this.nursingSow;
        data["initials"] = this.initials;
        data["cellColorStyle"] = this.cellColorStyle;
        return data;
    }
}

export interface IWeaningEventPdfItem {
    animalNumber?: string | undefined;
    race?: string | undefined;
    location?: string | undefined;
    litter?: string | undefined;
    registrationDate?: string | undefined;
    weanedPcs?: string | undefined;
    avgWeight?: string | undefined;
    nursingSow?: string | undefined;
    initials?: string | undefined;
    cellColorStyle: CellColorStyle;
}

export class DeadPigletsEventPdfItem implements IDeadPigletsEventPdfItem {
    race?: string | undefined;
    animalNumber?: string | undefined;
    litter?: string | undefined;
    registrationDate?: string | undefined;
    deadPiglets?: string | undefined;
    departureReason?: string | undefined;
    matingBatch?: string | undefined;
    departureType?: string | undefined;
    initials?: string | undefined;
    cellColorStyle!: CellColorStyle;

    constructor(data?: IDeadPigletsEventPdfItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.race = _data["race"];
            this.animalNumber = _data["animalNumber"];
            this.litter = _data["litter"];
            this.registrationDate = _data["registrationDate"];
            this.deadPiglets = _data["deadPiglets"];
            this.departureReason = _data["departureReason"];
            this.matingBatch = _data["matingBatch"];
            this.departureType = _data["departureType"];
            this.initials = _data["initials"];
            this.cellColorStyle = _data["cellColorStyle"];
        }
    }

    static fromJS(data: any): DeadPigletsEventPdfItem {
        data = typeof data === 'object' ? data : {};
        let result = new DeadPigletsEventPdfItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["race"] = this.race;
        data["animalNumber"] = this.animalNumber;
        data["litter"] = this.litter;
        data["registrationDate"] = this.registrationDate;
        data["deadPiglets"] = this.deadPiglets;
        data["departureReason"] = this.departureReason;
        data["matingBatch"] = this.matingBatch;
        data["departureType"] = this.departureType;
        data["initials"] = this.initials;
        data["cellColorStyle"] = this.cellColorStyle;
        return data;
    }
}

export interface IDeadPigletsEventPdfItem {
    race?: string | undefined;
    animalNumber?: string | undefined;
    litter?: string | undefined;
    registrationDate?: string | undefined;
    deadPiglets?: string | undefined;
    departureReason?: string | undefined;
    matingBatch?: string | undefined;
    departureType?: string | undefined;
    initials?: string | undefined;
    cellColorStyle: CellColorStyle;
}

export class BalancePigEventTotalWeightBalancePigEvents implements IBalancePigEventTotalWeightBalancePigEvents {
    currentPigsOnStable!: number;
    totalWeightToCalculateWith?: TotalWeight | undefined;
    balanceWeanedPigEvents?: BalanceWeanedPigEvent[] | undefined;

    constructor(data?: IBalancePigEventTotalWeightBalancePigEvents) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPigsOnStable = _data["currentPigsOnStable"];
            this.totalWeightToCalculateWith = _data["totalWeightToCalculateWith"] ? TotalWeight.fromJS(_data["totalWeightToCalculateWith"]) : <any>undefined;
            if (Array.isArray(_data["balanceWeanedPigEvents"])) {
                this.balanceWeanedPigEvents = [] as any;
                for (let item of _data["balanceWeanedPigEvents"])
                    this.balanceWeanedPigEvents!.push(BalanceWeanedPigEvent.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BalancePigEventTotalWeightBalancePigEvents {
        data = typeof data === 'object' ? data : {};
        let result = new BalancePigEventTotalWeightBalancePigEvents();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPigsOnStable"] = this.currentPigsOnStable;
        data["totalWeightToCalculateWith"] = this.totalWeightToCalculateWith ? this.totalWeightToCalculateWith.toJSON() : <any>undefined;
        if (Array.isArray(this.balanceWeanedPigEvents)) {
            data["balanceWeanedPigEvents"] = [];
            for (let item of this.balanceWeanedPigEvents)
                data["balanceWeanedPigEvents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBalancePigEventTotalWeightBalancePigEvents {
    currentPigsOnStable: number;
    totalWeightToCalculateWith?: TotalWeight | undefined;
    balanceWeanedPigEvents?: BalanceWeanedPigEvent[] | undefined;
}

export class TotalWeight implements ITotalWeight {
    total!: number;
    weight!: number;

    constructor(data?: ITotalWeight) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            this.weight = _data["weight"];
        }
    }

    static fromJS(data: any): TotalWeight {
        data = typeof data === 'object' ? data : {};
        let result = new TotalWeight();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["weight"] = this.weight;
        return data;
    }
}

export interface ITotalWeight {
    total: number;
    weight: number;
}

export class BalanceWeanedPigEvent implements IBalanceWeanedPigEvent {
    date?: Date | undefined;
    totalAmount!: number;
    growthPigEventType!: GrowthPigEventType;
    eventId?: string | undefined;
    totalWeight!: number;

    constructor(data?: IBalanceWeanedPigEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.totalAmount = _data["totalAmount"];
            this.growthPigEventType = _data["growthPigEventType"];
            this.eventId = _data["eventId"];
            this.totalWeight = _data["totalWeight"];
        }
    }

    static fromJS(data: any): BalanceWeanedPigEvent {
        data = typeof data === 'object' ? data : {};
        let result = new BalanceWeanedPigEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["totalAmount"] = this.totalAmount;
        data["growthPigEventType"] = this.growthPigEventType;
        data["eventId"] = this.eventId;
        data["totalWeight"] = this.totalWeight;
        return data;
    }
}

export interface IBalanceWeanedPigEvent {
    date?: Date | undefined;
    totalAmount: number;
    growthPigEventType: GrowthPigEventType;
    eventId?: string | undefined;
    totalWeight: number;
}

export enum GrowthPigEventType {
    GrowthPigEntranceEvent = "GrowthPigEntranceEvent",
    GrowthPigMoveEvent = "GrowthPigMoveEvent",
    GrowthPigDepartureEvent = "GrowthPigDepartureEvent",
    GrowthPigPenDepartureEvent = "GrowthPigPenDepartureEvent",
    PigletWeanedEvent = "PigletWeanedEvent",
    PigletDepartureSoldEvent = "PigletDepartureSoldEvent",
    PigletMovedEvent = "PigletMovedEvent",
    Regulation = "Regulation",
    RegulationWeight = "RegulationWeight",
}

export class BMPData extends Unique implements IBMPData {
    maxPigArea?: number[] | undefined;
    maxSeqArea?: number[] | undefined;
    maxTemp?: number[] | undefined;
    minPigArea?: number[] | undefined;
    minTemp?: number[] | undefined;
    pigs?: { [key: string]: Pig; } | undefined;
    timestamp!: Date;

    constructor(data?: IBMPData) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["maxPigArea"])) {
                this.maxPigArea = [] as any;
                for (let item of _data["maxPigArea"])
                    this.maxPigArea!.push(item);
            }
            if (Array.isArray(_data["maxSeqArea"])) {
                this.maxSeqArea = [] as any;
                for (let item of _data["maxSeqArea"])
                    this.maxSeqArea!.push(item);
            }
            if (Array.isArray(_data["maxTemp"])) {
                this.maxTemp = [] as any;
                for (let item of _data["maxTemp"])
                    this.maxTemp!.push(item);
            }
            if (Array.isArray(_data["minPigArea"])) {
                this.minPigArea = [] as any;
                for (let item of _data["minPigArea"])
                    this.minPigArea!.push(item);
            }
            if (Array.isArray(_data["minTemp"])) {
                this.minTemp = [] as any;
                for (let item of _data["minTemp"])
                    this.minTemp!.push(item);
            }
            if (_data["pigs"]) {
                this.pigs = {} as any;
                for (let key in _data["pigs"]) {
                    if (_data["pigs"].hasOwnProperty(key))
                        (<any>this.pigs)![key] = _data["pigs"][key] ? Pig.fromJS(_data["pigs"][key]) : new Pig();
                }
            }
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): BMPData {
        data = typeof data === 'object' ? data : {};
        let result = new BMPData();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.maxPigArea)) {
            data["maxPigArea"] = [];
            for (let item of this.maxPigArea)
                data["maxPigArea"].push(item);
        }
        if (Array.isArray(this.maxSeqArea)) {
            data["maxSeqArea"] = [];
            for (let item of this.maxSeqArea)
                data["maxSeqArea"].push(item);
        }
        if (Array.isArray(this.maxTemp)) {
            data["maxTemp"] = [];
            for (let item of this.maxTemp)
                data["maxTemp"].push(item);
        }
        if (Array.isArray(this.minPigArea)) {
            data["minPigArea"] = [];
            for (let item of this.minPigArea)
                data["minPigArea"].push(item);
        }
        if (Array.isArray(this.minTemp)) {
            data["minTemp"] = [];
            for (let item of this.minTemp)
                data["minTemp"].push(item);
        }
        if (this.pigs) {
            data["pigs"] = {};
            for (let key in this.pigs) {
                if (this.pigs.hasOwnProperty(key))
                    (<any>data["pigs"])[key] = this.pigs[key] ? this.pigs[key].toJSON() : <any>undefined;
            }
        }
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IBMPData extends IUnique {
    maxPigArea?: number[] | undefined;
    maxSeqArea?: number[] | undefined;
    maxTemp?: number[] | undefined;
    minPigArea?: number[] | undefined;
    minTemp?: number[] | undefined;
    pigs?: { [key: string]: Pig; } | undefined;
    timestamp: Date;
}

export class Pig implements IPig {
    avArea?: number | undefined;
    avAreaCorr?: number | undefined;
    avDist?: number | undefined;
    avDistCorr?: number | undefined;
    avTemp?: number | undefined;
    frameNum?: number | undefined;

    constructor(data?: IPig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.avArea = _data["avArea"];
            this.avAreaCorr = _data["avAreaCorr"];
            this.avDist = _data["avDist"];
            this.avDistCorr = _data["avDistCorr"];
            this.avTemp = _data["avTemp"];
            this.frameNum = _data["frameNum"];
        }
    }

    static fromJS(data: any): Pig {
        data = typeof data === 'object' ? data : {};
        let result = new Pig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["avArea"] = this.avArea;
        data["avAreaCorr"] = this.avAreaCorr;
        data["avDist"] = this.avDist;
        data["avDistCorr"] = this.avDistCorr;
        data["avTemp"] = this.avTemp;
        data["frameNum"] = this.frameNum;
        return data;
    }
}

export interface IPig {
    avArea?: number | undefined;
    avAreaCorr?: number | undefined;
    avDist?: number | undefined;
    avDistCorr?: number | undefined;
    avTemp?: number | undefined;
    frameNum?: number | undefined;
}

export class BreedTableItem extends Unique implements IBreedTableItem {
    breedRace?: string | undefined;
    momBreedRace?: string | undefined;
    dadBreedRace?: string | undefined;
    breedTableColumnEnum!: BreedTableColumnEnum;

    constructor(data?: IBreedTableItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.breedRace = _data["breedRace"];
            this.momBreedRace = _data["momBreedRace"];
            this.dadBreedRace = _data["dadBreedRace"];
            this.breedTableColumnEnum = _data["breedTableColumnEnum"];
        }
    }

    static override fromJS(data: any): BreedTableItem {
        data = typeof data === 'object' ? data : {};
        let result = new BreedTableItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["breedRace"] = this.breedRace;
        data["momBreedRace"] = this.momBreedRace;
        data["dadBreedRace"] = this.dadBreedRace;
        data["breedTableColumnEnum"] = this.breedTableColumnEnum;
        super.toJSON(data);
        return data;
    }
}

export interface IBreedTableItem extends IUnique {
    breedRace?: string | undefined;
    momBreedRace?: string | undefined;
    dadBreedRace?: string | undefined;
    breedTableColumnEnum: BreedTableColumnEnum;
}

export enum BreedTableColumnEnum {
    SKIOLD = "SKIOLD",
    DANBRED = "DANBRED",
    DANBRED_NUMBER = "DANBRED_NUMBER",
    DANISH_GENETICS = "DANISH_GENETICS",
    DANISH_GENETICS_ID_NUMMER = "DANISH_GENETICS_ID_NUMMER",
}

export abstract class BaseSyncOfBreedTableItem implements IBaseSyncOfBreedTableItem {
    syncTime!: Date;

    protected _discriminator: string;

    constructor(data?: IBaseSyncOfBreedTableItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "BaseSyncOfBreedTableItem";
    }

    init(_data?: any) {
        if (_data) {
            this.syncTime = _data["syncTime"] ? new Date(_data["syncTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseSyncOfBreedTableItem {
        data = typeof data === 'object' ? data : {};
        if (data["_discriminator"] === "SyncDataBreedTableItem") {
            let result = new SyncDataBreedTableItem();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'BaseSyncOfBreedTableItem' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_discriminator"] = this._discriminator;
        data["syncTime"] = this.syncTime ? this.syncTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBaseSyncOfBreedTableItem {
    syncTime: Date;
}

export class SyncDataBreedTableItem extends BaseSyncOfBreedTableItem implements ISyncDataBreedTableItem {
    datas?: BreedTableItem[] | undefined;

    constructor(data?: ISyncDataBreedTableItem) {
        super(data);
        this._discriminator = "SyncDataBreedTableItem";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["datas"])) {
                this.datas = [] as any;
                for (let item of _data["datas"])
                    this.datas!.push(BreedTableItem.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): SyncDataBreedTableItem {
        data = typeof data === 'object' ? data : {};
        let result = new SyncDataBreedTableItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.datas)) {
            data["datas"] = [];
            for (let item of this.datas)
                data["datas"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISyncDataBreedTableItem extends IBaseSyncOfBreedTableItem {
    datas?: BreedTableItem[] | undefined;
}

export class DadMomBreed implements IDadMomBreed {
    dad?: string | undefined;
    mom?: string | undefined;

    constructor(data?: IDadMomBreed) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dad = _data["dad"];
            this.mom = _data["mom"];
        }
    }

    static fromJS(data: any): DadMomBreed {
        data = typeof data === 'object' ? data : {};
        let result = new DadMomBreed();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dad"] = this.dad;
        data["mom"] = this.mom;
        return data;
    }
}

export interface IDadMomBreed {
    dad?: string | undefined;
    mom?: string | undefined;
}

export class Building extends SiteEntity implements IBuilding {
    name?: string | undefined;
    productionForm!: ProductionForm;
    buildingNumber!: number;
    useSections!: boolean;
    code?: string | undefined;
    isUsingQRCode!: boolean;
    order!: number;

    constructor(data?: IBuilding) {
        super(data);
        if (!data) {
            this.useSections = true;
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.productionForm = _data["productionForm"];
            this.buildingNumber = _data["buildingNumber"];
            this.useSections = _data["useSections"] !== undefined ? _data["useSections"] : true;
            this.code = _data["code"];
            this.isUsingQRCode = _data["isUsingQRCode"];
            this.order = _data["order"];
        }
    }

    static override fromJS(data: any): Building {
        data = typeof data === 'object' ? data : {};
        let result = new Building();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["productionForm"] = this.productionForm;
        data["buildingNumber"] = this.buildingNumber;
        data["useSections"] = this.useSections;
        data["code"] = this.code;
        data["isUsingQRCode"] = this.isUsingQRCode;
        data["order"] = this.order;
        super.toJSON(data);
        return data;
    }
}

export interface IBuilding extends ISiteEntity {
    name?: string | undefined;
    productionForm: ProductionForm;
    buildingNumber: number;
    useSections: boolean;
    code?: string | undefined;
    isUsingQRCode: boolean;
    order: number;
}

export enum ProductionForm {
    PigProduction = "PigProduction",
    GrainMill = "GrainMill",
    Feed = "Feed",
    Mills = "Mills",
}

export class Country extends Unique implements ICountry {
    name?: string | undefined;
    code?: string | undefined;

    constructor(data?: ICountry) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
        }
    }

    static override fromJS(data: any): Country {
        data = typeof data === 'object' ? data : {};
        let result = new Country();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        super.toJSON(data);
        return data;
    }
}

export interface ICountry extends IUnique {
    name?: string | undefined;
    code?: string | undefined;
}

export class DashboardItem implements IDashboardItem {
    matingDashboard?: MatingReport[] | undefined;
    farrowingDashboard?: FarrowingReport[] | undefined;
    weaningDashboard?: WeaningReport[] | undefined;

    constructor(data?: IDashboardItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["matingDashboard"])) {
                this.matingDashboard = [] as any;
                for (let item of _data["matingDashboard"])
                    this.matingDashboard!.push(MatingReport.fromJS(item));
            }
            if (Array.isArray(_data["farrowingDashboard"])) {
                this.farrowingDashboard = [] as any;
                for (let item of _data["farrowingDashboard"])
                    this.farrowingDashboard!.push(FarrowingReport.fromJS(item));
            }
            if (Array.isArray(_data["weaningDashboard"])) {
                this.weaningDashboard = [] as any;
                for (let item of _data["weaningDashboard"])
                    this.weaningDashboard!.push(WeaningReport.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DashboardItem {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.matingDashboard)) {
            data["matingDashboard"] = [];
            for (let item of this.matingDashboard)
                data["matingDashboard"].push(item.toJSON());
        }
        if (Array.isArray(this.farrowingDashboard)) {
            data["farrowingDashboard"] = [];
            for (let item of this.farrowingDashboard)
                data["farrowingDashboard"].push(item.toJSON());
        }
        if (Array.isArray(this.weaningDashboard)) {
            data["weaningDashboard"] = [];
            for (let item of this.weaningDashboard)
                data["weaningDashboard"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDashboardItem {
    matingDashboard?: MatingReport[] | undefined;
    farrowingDashboard?: FarrowingReport[] | undefined;
    weaningDashboard?: WeaningReport[] | undefined;
}

export class MatingReport implements IMatingReport {
    matingBatch?: MatingBatch | undefined;
    totalMatings?: number | undefined;
    youngAnimalMatings?: number | undefined;
    returnSows?: number | undefined;
    totalDepartures?: number | undefined;
    departureNonPregnant?: number | undefined;
    thereOfAbortions?: number | undefined;
    departureKilled?: number | undefined;
    departureDead?: number | undefined;
    weaningToFirstMating?: number | undefined;
    avgWasteDays?: number | undefined;
    animalsToFarrowing?: number | undefined;

    constructor(data?: IMatingReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.matingBatch = _data["matingBatch"] ? MatingBatch.fromJS(_data["matingBatch"]) : <any>undefined;
            this.totalMatings = _data["totalMatings"];
            this.youngAnimalMatings = _data["youngAnimalMatings"];
            this.returnSows = _data["returnSows"];
            this.totalDepartures = _data["totalDepartures"];
            this.departureNonPregnant = _data["departureNonPregnant"];
            this.thereOfAbortions = _data["thereOfAbortions"];
            this.departureKilled = _data["departureKilled"];
            this.departureDead = _data["departureDead"];
            this.weaningToFirstMating = _data["weaningToFirstMating"];
            this.avgWasteDays = _data["avgWasteDays"];
            this.animalsToFarrowing = _data["animalsToFarrowing"];
        }
    }

    static fromJS(data: any): MatingReport {
        data = typeof data === 'object' ? data : {};
        let result = new MatingReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["matingBatch"] = this.matingBatch ? this.matingBatch.toJSON() : <any>undefined;
        data["totalMatings"] = this.totalMatings;
        data["youngAnimalMatings"] = this.youngAnimalMatings;
        data["returnSows"] = this.returnSows;
        data["totalDepartures"] = this.totalDepartures;
        data["departureNonPregnant"] = this.departureNonPregnant;
        data["thereOfAbortions"] = this.thereOfAbortions;
        data["departureKilled"] = this.departureKilled;
        data["departureDead"] = this.departureDead;
        data["weaningToFirstMating"] = this.weaningToFirstMating;
        data["avgWasteDays"] = this.avgWasteDays;
        data["animalsToFarrowing"] = this.animalsToFarrowing;
        return data;
    }
}

export interface IMatingReport {
    matingBatch?: MatingBatch | undefined;
    totalMatings?: number | undefined;
    youngAnimalMatings?: number | undefined;
    returnSows?: number | undefined;
    totalDepartures?: number | undefined;
    departureNonPregnant?: number | undefined;
    thereOfAbortions?: number | undefined;
    departureKilled?: number | undefined;
    departureDead?: number | undefined;
    weaningToFirstMating?: number | undefined;
    avgWasteDays?: number | undefined;
    animalsToFarrowing?: number | undefined;
}

export class MatingBatch extends SiteEntity implements IMatingBatch {
    batchNumber!: number;
    matingPeriodStart!: Date;
    matingPeriodEnd!: Date;
    farrowingPeriodStart!: Date;
    farrowingPeriodEnd!: Date;

    constructor(data?: IMatingBatch) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.batchNumber = _data["batchNumber"];
            this.matingPeriodStart = _data["matingPeriodStart"] ? new Date(_data["matingPeriodStart"].toString()) : <any>undefined;
            this.matingPeriodEnd = _data["matingPeriodEnd"] ? new Date(_data["matingPeriodEnd"].toString()) : <any>undefined;
            this.farrowingPeriodStart = _data["farrowingPeriodStart"] ? new Date(_data["farrowingPeriodStart"].toString()) : <any>undefined;
            this.farrowingPeriodEnd = _data["farrowingPeriodEnd"] ? new Date(_data["farrowingPeriodEnd"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): MatingBatch {
        data = typeof data === 'object' ? data : {};
        let result = new MatingBatch();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchNumber"] = this.batchNumber;
        data["matingPeriodStart"] = this.matingPeriodStart ? this.matingPeriodStart.toISOString() : <any>undefined;
        data["matingPeriodEnd"] = this.matingPeriodEnd ? this.matingPeriodEnd.toISOString() : <any>undefined;
        data["farrowingPeriodStart"] = this.farrowingPeriodStart ? this.farrowingPeriodStart.toISOString() : <any>undefined;
        data["farrowingPeriodEnd"] = this.farrowingPeriodEnd ? this.farrowingPeriodEnd.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IMatingBatch extends ISiteEntity {
    batchNumber: number;
    matingPeriodStart: Date;
    matingPeriodEnd: Date;
    farrowingPeriodStart: Date;
    farrowingPeriodEnd: Date;
}

export class FarrowingReport implements IFarrowingReport {
    matingBatch?: MatingBatch | undefined;
    totalFarrowings?: number | undefined;
    thereOfFirstParity?: number | undefined;
    needFarrowing?: number | undefined;
    totalLiveBorn?: number | undefined;
    avgAlive?: number | undefined;
    avgLivebornFirstParity?: number | undefined;
    avgDead?: number | undefined;
    stillbornToAliveRate?: number | undefined;
    deadPiglets?: number | undefined;
    pctDeadPiglets?: number | undefined;
    farrowingRate?: number | undefined;
    avgPregnantDays?: number | undefined;
    avgDeadPiglets?: number | undefined;

    constructor(data?: IFarrowingReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.matingBatch = _data["matingBatch"] ? MatingBatch.fromJS(_data["matingBatch"]) : <any>undefined;
            this.totalFarrowings = _data["totalFarrowings"];
            this.thereOfFirstParity = _data["thereOfFirstParity"];
            this.needFarrowing = _data["needFarrowing"];
            this.totalLiveBorn = _data["totalLiveBorn"];
            this.avgAlive = _data["avgAlive"];
            this.avgLivebornFirstParity = _data["avgLivebornFirstParity"];
            this.avgDead = _data["avgDead"];
            this.stillbornToAliveRate = _data["stillbornToAliveRate"];
            this.deadPiglets = _data["deadPiglets"];
            this.pctDeadPiglets = _data["pctDeadPiglets"];
            this.farrowingRate = _data["farrowingRate"];
            this.avgPregnantDays = _data["avgPregnantDays"];
            this.avgDeadPiglets = _data["avgDeadPiglets"];
        }
    }

    static fromJS(data: any): FarrowingReport {
        data = typeof data === 'object' ? data : {};
        let result = new FarrowingReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["matingBatch"] = this.matingBatch ? this.matingBatch.toJSON() : <any>undefined;
        data["totalFarrowings"] = this.totalFarrowings;
        data["thereOfFirstParity"] = this.thereOfFirstParity;
        data["needFarrowing"] = this.needFarrowing;
        data["totalLiveBorn"] = this.totalLiveBorn;
        data["avgAlive"] = this.avgAlive;
        data["avgLivebornFirstParity"] = this.avgLivebornFirstParity;
        data["avgDead"] = this.avgDead;
        data["stillbornToAliveRate"] = this.stillbornToAliveRate;
        data["deadPiglets"] = this.deadPiglets;
        data["pctDeadPiglets"] = this.pctDeadPiglets;
        data["farrowingRate"] = this.farrowingRate;
        data["avgPregnantDays"] = this.avgPregnantDays;
        data["avgDeadPiglets"] = this.avgDeadPiglets;
        return data;
    }
}

export interface IFarrowingReport {
    matingBatch?: MatingBatch | undefined;
    totalFarrowings?: number | undefined;
    thereOfFirstParity?: number | undefined;
    needFarrowing?: number | undefined;
    totalLiveBorn?: number | undefined;
    avgAlive?: number | undefined;
    avgLivebornFirstParity?: number | undefined;
    avgDead?: number | undefined;
    stillbornToAliveRate?: number | undefined;
    deadPiglets?: number | undefined;
    pctDeadPiglets?: number | undefined;
    farrowingRate?: number | undefined;
    avgPregnantDays?: number | undefined;
    avgDeadPiglets?: number | undefined;
}

export class WeaningReport implements IWeaningReport {
    matingBatch?: MatingBatch | undefined;
    totalWeanings?: number | undefined;
    nursingSows?: number | undefined;
    needWeaning?: number | undefined;
    avgAlivePerLitter?: number | undefined;
    avgDeadPerLitter?: number | undefined;
    avgWeanedPerLitter?: number | undefined;
    avgWeanedPerWeaninig?: number | undefined;
    avgWeight?: number | undefined;
    totalWeanedPiglets?: number | undefined;
    deadToAliveRate?: number | undefined;
    avgNursingDays?: number | undefined;
    thereOfFirstLitterPcs?: number | undefined;
    firstLitterPercent?: number | undefined;

    constructor(data?: IWeaningReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.matingBatch = _data["matingBatch"] ? MatingBatch.fromJS(_data["matingBatch"]) : <any>undefined;
            this.totalWeanings = _data["totalWeanings"];
            this.nursingSows = _data["nursingSows"];
            this.needWeaning = _data["needWeaning"];
            this.avgAlivePerLitter = _data["avgAlivePerLitter"];
            this.avgDeadPerLitter = _data["avgDeadPerLitter"];
            this.avgWeanedPerLitter = _data["avgWeanedPerLitter"];
            this.avgWeanedPerWeaninig = _data["avgWeanedPerWeaninig"];
            this.avgWeight = _data["avgWeight"];
            this.totalWeanedPiglets = _data["totalWeanedPiglets"];
            this.deadToAliveRate = _data["deadToAliveRate"];
            this.avgNursingDays = _data["avgNursingDays"];
            this.thereOfFirstLitterPcs = _data["thereOfFirstLitterPcs"];
            this.firstLitterPercent = _data["firstLitterPercent"];
        }
    }

    static fromJS(data: any): WeaningReport {
        data = typeof data === 'object' ? data : {};
        let result = new WeaningReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["matingBatch"] = this.matingBatch ? this.matingBatch.toJSON() : <any>undefined;
        data["totalWeanings"] = this.totalWeanings;
        data["nursingSows"] = this.nursingSows;
        data["needWeaning"] = this.needWeaning;
        data["avgAlivePerLitter"] = this.avgAlivePerLitter;
        data["avgDeadPerLitter"] = this.avgDeadPerLitter;
        data["avgWeanedPerLitter"] = this.avgWeanedPerLitter;
        data["avgWeanedPerWeaninig"] = this.avgWeanedPerWeaninig;
        data["avgWeight"] = this.avgWeight;
        data["totalWeanedPiglets"] = this.totalWeanedPiglets;
        data["deadToAliveRate"] = this.deadToAliveRate;
        data["avgNursingDays"] = this.avgNursingDays;
        data["thereOfFirstLitterPcs"] = this.thereOfFirstLitterPcs;
        data["firstLitterPercent"] = this.firstLitterPercent;
        return data;
    }
}

export interface IWeaningReport {
    matingBatch?: MatingBatch | undefined;
    totalWeanings?: number | undefined;
    nursingSows?: number | undefined;
    needWeaning?: number | undefined;
    avgAlivePerLitter?: number | undefined;
    avgDeadPerLitter?: number | undefined;
    avgWeanedPerLitter?: number | undefined;
    avgWeanedPerWeaninig?: number | undefined;
    avgWeight?: number | undefined;
    totalWeanedPiglets?: number | undefined;
    deadToAliveRate?: number | undefined;
    avgNursingDays?: number | undefined;
    thereOfFirstLitterPcs?: number | undefined;
    firstLitterPercent?: number | undefined;
}

export class AnimalToFarrowingTableItem implements IAnimalToFarrowingTableItem {
    sowId?: string | undefined;
    pregnancyDays?: number | undefined;
    animalNumber?: string | undefined;
    litterNumber?: number | undefined;
    avgPregnancyDays?: number | undefined;
    expectedFarrowingDate?: Date | undefined;
    matingDate?: Date | undefined;
    hasFarrowed!: boolean;
    breedRace?: string | undefined;
    cellColorStyle!: CellColorStyle;

    constructor(data?: IAnimalToFarrowingTableItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sowId = _data["sowId"];
            this.pregnancyDays = _data["pregnancyDays"];
            this.animalNumber = _data["animalNumber"];
            this.litterNumber = _data["litterNumber"];
            this.avgPregnancyDays = _data["avgPregnancyDays"];
            this.expectedFarrowingDate = _data["expectedFarrowingDate"] ? new Date(_data["expectedFarrowingDate"].toString()) : <any>undefined;
            this.matingDate = _data["matingDate"] ? new Date(_data["matingDate"].toString()) : <any>undefined;
            this.hasFarrowed = _data["hasFarrowed"];
            this.breedRace = _data["breedRace"];
            this.cellColorStyle = _data["cellColorStyle"];
        }
    }

    static fromJS(data: any): AnimalToFarrowingTableItem {
        data = typeof data === 'object' ? data : {};
        let result = new AnimalToFarrowingTableItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sowId"] = this.sowId;
        data["pregnancyDays"] = this.pregnancyDays;
        data["animalNumber"] = this.animalNumber;
        data["litterNumber"] = this.litterNumber;
        data["avgPregnancyDays"] = this.avgPregnancyDays;
        data["expectedFarrowingDate"] = this.expectedFarrowingDate ? this.expectedFarrowingDate.toISOString() : <any>undefined;
        data["matingDate"] = this.matingDate ? this.matingDate.toISOString() : <any>undefined;
        data["hasFarrowed"] = this.hasFarrowed;
        data["breedRace"] = this.breedRace;
        data["cellColorStyle"] = this.cellColorStyle;
        return data;
    }
}

export interface IAnimalToFarrowingTableItem {
    sowId?: string | undefined;
    pregnancyDays?: number | undefined;
    animalNumber?: string | undefined;
    litterNumber?: number | undefined;
    avgPregnancyDays?: number | undefined;
    expectedFarrowingDate?: Date | undefined;
    matingDate?: Date | undefined;
    hasFarrowed: boolean;
    breedRace?: string | undefined;
    cellColorStyle: CellColorStyle;
}

export class TotalFarrowingTableItem extends BasicFarrowingTableItem implements ITotalFarrowingTableItem {
    nursingDays?: number | undefined;

    constructor(data?: ITotalFarrowingTableItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.nursingDays = _data["nursingDays"];
        }
    }

    static override fromJS(data: any): TotalFarrowingTableItem {
        data = typeof data === 'object' ? data : {};
        let result = new TotalFarrowingTableItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nursingDays"] = this.nursingDays;
        super.toJSON(data);
        return data;
    }
}

export interface ITotalFarrowingTableItem extends IBasicFarrowingTableItem {
    nursingDays?: number | undefined;
}

export class DeadPigletsByWeek implements IDeadPigletsByWeek {
    deadPiglets?: number | undefined;
    week?: string | undefined;
    cellColorStyle!: CellColorStyle;

    constructor(data?: IDeadPigletsByWeek) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deadPiglets = _data["deadPiglets"];
            this.week = _data["week"];
            this.cellColorStyle = _data["cellColorStyle"];
        }
    }

    static fromJS(data: any): DeadPigletsByWeek {
        data = typeof data === 'object' ? data : {};
        let result = new DeadPigletsByWeek();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deadPiglets"] = this.deadPiglets;
        data["week"] = this.week;
        data["cellColorStyle"] = this.cellColorStyle;
        return data;
    }
}

export interface IDeadPigletsByWeek {
    deadPiglets?: number | undefined;
    week?: string | undefined;
    cellColorStyle: CellColorStyle;
}

export class TotalWeaningTableItem extends BasicWeaningTableItem implements ITotalWeaningTableItem {

    constructor(data?: ITotalWeaningTableItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): TotalWeaningTableItem {
        data = typeof data === 'object' ? data : {};
        let result = new TotalWeaningTableItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ITotalWeaningTableItem extends IBasicWeaningTableItem {
}

export class NeedWeaningTableItem implements INeedWeaningTableItem {
    sowId?: string | undefined;
    nursingDays?: number | undefined;
    animalNumber?: string | undefined;
    litterNumber?: number | undefined;
    farrowingDate!: Date;
    aliveBorn?: number | undefined;
    stillborn?: number | undefined;
    breedRace?: string | undefined;
    cellColorStyle!: CellColorStyle;

    constructor(data?: INeedWeaningTableItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sowId = _data["sowId"];
            this.nursingDays = _data["nursingDays"];
            this.animalNumber = _data["animalNumber"];
            this.litterNumber = _data["litterNumber"];
            this.farrowingDate = _data["farrowingDate"] ? new Date(_data["farrowingDate"].toString()) : <any>undefined;
            this.aliveBorn = _data["aliveBorn"];
            this.stillborn = _data["stillborn"];
            this.breedRace = _data["breedRace"];
            this.cellColorStyle = _data["cellColorStyle"];
        }
    }

    static fromJS(data: any): NeedWeaningTableItem {
        data = typeof data === 'object' ? data : {};
        let result = new NeedWeaningTableItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sowId"] = this.sowId;
        data["nursingDays"] = this.nursingDays;
        data["animalNumber"] = this.animalNumber;
        data["litterNumber"] = this.litterNumber;
        data["farrowingDate"] = this.farrowingDate ? this.farrowingDate.toISOString() : <any>undefined;
        data["aliveBorn"] = this.aliveBorn;
        data["stillborn"] = this.stillborn;
        data["breedRace"] = this.breedRace;
        data["cellColorStyle"] = this.cellColorStyle;
        return data;
    }
}

export interface INeedWeaningTableItem {
    sowId?: string | undefined;
    nursingDays?: number | undefined;
    animalNumber?: string | undefined;
    litterNumber?: number | undefined;
    farrowingDate: Date;
    aliveBorn?: number | undefined;
    stillborn?: number | undefined;
    breedRace?: string | undefined;
    cellColorStyle: CellColorStyle;
}

export class DashboardOverviewData implements IDashboardOverviewData {
    allCurrentLitters?: { [key: string]: number; } | undefined;
    dashboardTableData?: { [key: string]: DashboardTableModel[]; } | undefined;

    constructor(data?: IDashboardOverviewData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["allCurrentLitters"]) {
                this.allCurrentLitters = {} as any;
                for (let key in _data["allCurrentLitters"]) {
                    if (_data["allCurrentLitters"].hasOwnProperty(key))
                        (<any>this.allCurrentLitters)![key] = _data["allCurrentLitters"][key];
                }
            }
            if (_data["dashboardTableData"]) {
                this.dashboardTableData = {} as any;
                for (let key in _data["dashboardTableData"]) {
                    if (_data["dashboardTableData"].hasOwnProperty(key))
                        (<any>this.dashboardTableData)![key] = _data["dashboardTableData"][key] ? _data["dashboardTableData"][key].map((i: any) => DashboardTableModel.fromJS(i)) : [];
                }
            }
        }
    }

    static fromJS(data: any): DashboardOverviewData {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardOverviewData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.allCurrentLitters) {
            data["allCurrentLitters"] = {};
            for (let key in this.allCurrentLitters) {
                if (this.allCurrentLitters.hasOwnProperty(key))
                    (<any>data["allCurrentLitters"])[key] = (<any>this.allCurrentLitters)[key];
            }
        }
        if (this.dashboardTableData) {
            data["dashboardTableData"] = {};
            for (let key in this.dashboardTableData) {
                if (this.dashboardTableData.hasOwnProperty(key))
                    (<any>data["dashboardTableData"])[key] = (<any>this.dashboardTableData)[key];
            }
        }
        return data;
    }
}

export interface IDashboardOverviewData {
    allCurrentLitters?: { [key: string]: number; } | undefined;
    dashboardTableData?: { [key: string]: DashboardTableModel[]; } | undefined;
}

export class DashboardTableModel implements IDashboardTableModel {
    name?: string | undefined;
    achievedYear?: string | undefined;
    overGoalYear!: number;
    goalYear!: number;
    planValue?: DashboardSettingItem | undefined;
    data?: { [key: string]: DashboardTableModelItem; } | undefined;

    constructor(data?: IDashboardTableModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.achievedYear = _data["achievedYear"];
            this.overGoalYear = _data["overGoalYear"];
            this.goalYear = _data["goalYear"];
            this.planValue = _data["planValue"] ? DashboardSettingItem.fromJS(_data["planValue"]) : <any>undefined;
            if (_data["data"]) {
                this.data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        (<any>this.data)![key] = _data["data"][key] ? DashboardTableModelItem.fromJS(_data["data"][key]) : new DashboardTableModelItem();
                }
            }
        }
    }

    static fromJS(data: any): DashboardTableModel {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardTableModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["achievedYear"] = this.achievedYear;
        data["overGoalYear"] = this.overGoalYear;
        data["goalYear"] = this.goalYear;
        data["planValue"] = this.planValue ? this.planValue.toJSON() : <any>undefined;
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    (<any>data["data"])[key] = this.data[key] ? this.data[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IDashboardTableModel {
    name?: string | undefined;
    achievedYear?: string | undefined;
    overGoalYear: number;
    goalYear: number;
    planValue?: DashboardSettingItem | undefined;
    data?: { [key: string]: DashboardTableModelItem; } | undefined;
}

export class DashboardSettingItem implements IDashboardSettingItem {
    pcs!: number;
    plusDeviation!: number;
    negativeDeviation!: number;

    constructor(data?: IDashboardSettingItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pcs = _data["pcs"];
            this.plusDeviation = _data["plusDeviation"];
            this.negativeDeviation = _data["negativeDeviation"];
        }
    }

    static fromJS(data: any): DashboardSettingItem {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardSettingItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pcs"] = this.pcs;
        data["plusDeviation"] = this.plusDeviation;
        data["negativeDeviation"] = this.negativeDeviation;
        return data;
    }
}

export interface IDashboardSettingItem {
    pcs: number;
    plusDeviation: number;
    negativeDeviation: number;
}

export class DashboardTableModelItem implements IDashboardTableModelItem {
    matingBatch?: MatingBatch | undefined;
    value?: string | undefined;

    constructor(data?: IDashboardTableModelItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.matingBatch = _data["matingBatch"] ? MatingBatch.fromJS(_data["matingBatch"]) : <any>undefined;
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): DashboardTableModelItem {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardTableModelItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["matingBatch"] = this.matingBatch ? this.matingBatch.toJSON() : <any>undefined;
        data["value"] = this.value;
        return data;
    }
}

export interface IDashboardTableModelItem {
    matingBatch?: MatingBatch | undefined;
    value?: string | undefined;
}

export class DashboardSettings extends SiteEntity implements IDashboardSettings {
    matingsPcs?: DashboardSettingItem | undefined;
    percentageYoungAnimalMatings?: DashboardSettingItem | undefined;
    percentageReMatings?: DashboardSettingItem | undefined;
    daysFromWeaningToFirstMating?: DashboardSettingItem | undefined;
    averageWasteDaysPerMatingBatch?: DashboardSettingItem | undefined;
    farrowingsPcs?: DashboardSettingItem | undefined;
    aliveBornPerFarrowingPcs?: DashboardSettingItem | undefined;
    aliveBornPerFarrowingFirstLegPcs?: DashboardSettingItem | undefined;
    deadBornPerFarrowingPcs?: DashboardSettingItem | undefined;
    weanedPerFarrowingPcs?: DashboardSettingItem | undefined;
    weightPerWeanedPig?: DashboardSettingItem | undefined;
    stillbornToAliveRate?: DashboardSettingItem | undefined;
    startMatingBatchId?: string | undefined;
    endMatingBatchId?: string | undefined;
    rollingYear!: boolean;
    gpeDashboardSettingItems?: GpeDashboardSettingItem[] | undefined;

    constructor(data?: IDashboardSettings) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.matingsPcs = _data["matingsPcs"] ? DashboardSettingItem.fromJS(_data["matingsPcs"]) : <any>undefined;
            this.percentageYoungAnimalMatings = _data["percentageYoungAnimalMatings"] ? DashboardSettingItem.fromJS(_data["percentageYoungAnimalMatings"]) : <any>undefined;
            this.percentageReMatings = _data["percentageReMatings"] ? DashboardSettingItem.fromJS(_data["percentageReMatings"]) : <any>undefined;
            this.daysFromWeaningToFirstMating = _data["daysFromWeaningToFirstMating"] ? DashboardSettingItem.fromJS(_data["daysFromWeaningToFirstMating"]) : <any>undefined;
            this.averageWasteDaysPerMatingBatch = _data["averageWasteDaysPerMatingBatch"] ? DashboardSettingItem.fromJS(_data["averageWasteDaysPerMatingBatch"]) : <any>undefined;
            this.farrowingsPcs = _data["farrowingsPcs"] ? DashboardSettingItem.fromJS(_data["farrowingsPcs"]) : <any>undefined;
            this.aliveBornPerFarrowingPcs = _data["aliveBornPerFarrowingPcs"] ? DashboardSettingItem.fromJS(_data["aliveBornPerFarrowingPcs"]) : <any>undefined;
            this.aliveBornPerFarrowingFirstLegPcs = _data["aliveBornPerFarrowingFirstLegPcs"] ? DashboardSettingItem.fromJS(_data["aliveBornPerFarrowingFirstLegPcs"]) : <any>undefined;
            this.deadBornPerFarrowingPcs = _data["deadBornPerFarrowingPcs"] ? DashboardSettingItem.fromJS(_data["deadBornPerFarrowingPcs"]) : <any>undefined;
            this.weanedPerFarrowingPcs = _data["weanedPerFarrowingPcs"] ? DashboardSettingItem.fromJS(_data["weanedPerFarrowingPcs"]) : <any>undefined;
            this.weightPerWeanedPig = _data["weightPerWeanedPig"] ? DashboardSettingItem.fromJS(_data["weightPerWeanedPig"]) : <any>undefined;
            this.stillbornToAliveRate = _data["stillbornToAliveRate"] ? DashboardSettingItem.fromJS(_data["stillbornToAliveRate"]) : <any>undefined;
            this.startMatingBatchId = _data["startMatingBatchId"];
            this.endMatingBatchId = _data["endMatingBatchId"];
            this.rollingYear = _data["rollingYear"];
            if (Array.isArray(_data["gpeDashboardSettingItems"])) {
                this.gpeDashboardSettingItems = [] as any;
                for (let item of _data["gpeDashboardSettingItems"])
                    this.gpeDashboardSettingItems!.push(GpeDashboardSettingItem.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): DashboardSettings {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardSettings();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["matingsPcs"] = this.matingsPcs ? this.matingsPcs.toJSON() : <any>undefined;
        data["percentageYoungAnimalMatings"] = this.percentageYoungAnimalMatings ? this.percentageYoungAnimalMatings.toJSON() : <any>undefined;
        data["percentageReMatings"] = this.percentageReMatings ? this.percentageReMatings.toJSON() : <any>undefined;
        data["daysFromWeaningToFirstMating"] = this.daysFromWeaningToFirstMating ? this.daysFromWeaningToFirstMating.toJSON() : <any>undefined;
        data["averageWasteDaysPerMatingBatch"] = this.averageWasteDaysPerMatingBatch ? this.averageWasteDaysPerMatingBatch.toJSON() : <any>undefined;
        data["farrowingsPcs"] = this.farrowingsPcs ? this.farrowingsPcs.toJSON() : <any>undefined;
        data["aliveBornPerFarrowingPcs"] = this.aliveBornPerFarrowingPcs ? this.aliveBornPerFarrowingPcs.toJSON() : <any>undefined;
        data["aliveBornPerFarrowingFirstLegPcs"] = this.aliveBornPerFarrowingFirstLegPcs ? this.aliveBornPerFarrowingFirstLegPcs.toJSON() : <any>undefined;
        data["deadBornPerFarrowingPcs"] = this.deadBornPerFarrowingPcs ? this.deadBornPerFarrowingPcs.toJSON() : <any>undefined;
        data["weanedPerFarrowingPcs"] = this.weanedPerFarrowingPcs ? this.weanedPerFarrowingPcs.toJSON() : <any>undefined;
        data["weightPerWeanedPig"] = this.weightPerWeanedPig ? this.weightPerWeanedPig.toJSON() : <any>undefined;
        data["stillbornToAliveRate"] = this.stillbornToAliveRate ? this.stillbornToAliveRate.toJSON() : <any>undefined;
        data["startMatingBatchId"] = this.startMatingBatchId;
        data["endMatingBatchId"] = this.endMatingBatchId;
        data["rollingYear"] = this.rollingYear;
        if (Array.isArray(this.gpeDashboardSettingItems)) {
            data["gpeDashboardSettingItems"] = [];
            for (let item of this.gpeDashboardSettingItems)
                data["gpeDashboardSettingItems"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDashboardSettings extends ISiteEntity {
    matingsPcs?: DashboardSettingItem | undefined;
    percentageYoungAnimalMatings?: DashboardSettingItem | undefined;
    percentageReMatings?: DashboardSettingItem | undefined;
    daysFromWeaningToFirstMating?: DashboardSettingItem | undefined;
    averageWasteDaysPerMatingBatch?: DashboardSettingItem | undefined;
    farrowingsPcs?: DashboardSettingItem | undefined;
    aliveBornPerFarrowingPcs?: DashboardSettingItem | undefined;
    aliveBornPerFarrowingFirstLegPcs?: DashboardSettingItem | undefined;
    deadBornPerFarrowingPcs?: DashboardSettingItem | undefined;
    weanedPerFarrowingPcs?: DashboardSettingItem | undefined;
    weightPerWeanedPig?: DashboardSettingItem | undefined;
    stillbornToAliveRate?: DashboardSettingItem | undefined;
    startMatingBatchId?: string | undefined;
    endMatingBatchId?: string | undefined;
    rollingYear: boolean;
    gpeDashboardSettingItems?: GpeDashboardSettingItem[] | undefined;
}

export class GpeDashboardSettingItem implements IGpeDashboardSettingItem {
    subGoal?: number | undefined;
    predictedWeightAtSale?: number | undefined;
    buildingId?: string | undefined;
    animalType!: AnimalType;

    constructor(data?: IGpeDashboardSettingItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subGoal = _data["subGoal"];
            this.predictedWeightAtSale = _data["predictedWeightAtSale"];
            this.buildingId = _data["buildingId"];
            this.animalType = _data["animalType"];
        }
    }

    static fromJS(data: any): GpeDashboardSettingItem {
        data = typeof data === 'object' ? data : {};
        let result = new GpeDashboardSettingItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subGoal"] = this.subGoal;
        data["predictedWeightAtSale"] = this.predictedWeightAtSale;
        data["buildingId"] = this.buildingId;
        data["animalType"] = this.animalType;
        return data;
    }
}

export interface IGpeDashboardSettingItem {
    subGoal?: number | undefined;
    predictedWeightAtSale?: number | undefined;
    buildingId?: string | undefined;
    animalType: AnimalType;
}

export class SyncDashboardSettings implements ISyncDashboardSettings {
    syncTime!: Date;
    datas?: DashboardSettings | undefined;

    constructor(data?: ISyncDashboardSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.syncTime = _data["syncTime"] ? new Date(_data["syncTime"].toString()) : <any>undefined;
            this.datas = _data["datas"] ? DashboardSettings.fromJS(_data["datas"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SyncDashboardSettings {
        data = typeof data === 'object' ? data : {};
        let result = new SyncDashboardSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["syncTime"] = this.syncTime ? this.syncTime.toISOString() : <any>undefined;
        data["datas"] = this.datas ? this.datas.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISyncDashboardSettings {
    syncTime: Date;
    datas?: DashboardSettings | undefined;
}

export class DeadPigletsEvent extends SiteEntity implements IDeadPigletsEvent {
    registrationDate!: Date;
    deadPiglets!: number;
    reasonId?: string | undefined;
    pregnancyId?: string | undefined;
    stemAnimalId?: string | undefined;
    youngAnimalIdNumber?: string | undefined;
    youngAnimalId?: string | undefined;
    departureType?: string | undefined;

    constructor(data?: IDeadPigletsEvent) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.registrationDate = _data["registrationDate"] ? new Date(_data["registrationDate"].toString()) : <any>undefined;
            this.deadPiglets = _data["deadPiglets"];
            this.reasonId = _data["reasonId"];
            this.pregnancyId = _data["pregnancyId"];
            this.stemAnimalId = _data["stemAnimalId"];
            this.youngAnimalIdNumber = _data["youngAnimalIdNumber"];
            this.youngAnimalId = _data["youngAnimalId"];
            this.departureType = _data["departureType"];
        }
    }

    static override fromJS(data: any): DeadPigletsEvent {
        data = typeof data === 'object' ? data : {};
        let result = new DeadPigletsEvent();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registrationDate"] = this.registrationDate ? this.registrationDate.toISOString() : <any>undefined;
        data["deadPiglets"] = this.deadPiglets;
        data["reasonId"] = this.reasonId;
        data["pregnancyId"] = this.pregnancyId;
        data["stemAnimalId"] = this.stemAnimalId;
        data["youngAnimalIdNumber"] = this.youngAnimalIdNumber;
        data["youngAnimalId"] = this.youngAnimalId;
        data["departureType"] = this.departureType;
        super.toJSON(data);
        return data;
    }
}

export interface IDeadPigletsEvent extends ISiteEntity {
    registrationDate: Date;
    deadPiglets: number;
    reasonId?: string | undefined;
    pregnancyId?: string | undefined;
    stemAnimalId?: string | undefined;
    youngAnimalIdNumber?: string | undefined;
    youngAnimalId?: string | undefined;
    departureType?: string | undefined;
}

export abstract class BaseSyncOfDeadPigletsEvent implements IBaseSyncOfDeadPigletsEvent {
    syncTime!: Date;

    protected _discriminator: string;

    constructor(data?: IBaseSyncOfDeadPigletsEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "BaseSyncOfDeadPigletsEvent";
    }

    init(_data?: any) {
        if (_data) {
            this.syncTime = _data["syncTime"] ? new Date(_data["syncTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseSyncOfDeadPigletsEvent {
        data = typeof data === 'object' ? data : {};
        if (data["_discriminator"] === "SyncDataDeadPigletsEvent") {
            let result = new SyncDataDeadPigletsEvent();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'BaseSyncOfDeadPigletsEvent' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_discriminator"] = this._discriminator;
        data["syncTime"] = this.syncTime ? this.syncTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBaseSyncOfDeadPigletsEvent {
    syncTime: Date;
}

export class SyncDataDeadPigletsEvent extends BaseSyncOfDeadPigletsEvent implements ISyncDataDeadPigletsEvent {
    datas?: DeadPigletsEvent[] | undefined;

    constructor(data?: ISyncDataDeadPigletsEvent) {
        super(data);
        this._discriminator = "SyncDataDeadPigletsEvent";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["datas"])) {
                this.datas = [] as any;
                for (let item of _data["datas"])
                    this.datas!.push(DeadPigletsEvent.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): SyncDataDeadPigletsEvent {
        data = typeof data === 'object' ? data : {};
        let result = new SyncDataDeadPigletsEvent();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.datas)) {
            data["datas"] = [];
            for (let item of this.datas)
                data["datas"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISyncDataDeadPigletsEvent extends IBaseSyncOfDeadPigletsEvent {
    datas?: DeadPigletsEvent[] | undefined;
}

export class AnalysisDeadPigletsGraphModel implements IAnalysisDeadPigletsGraphModel {
    litter!: number;
    week?: string | undefined;
    age?: string | undefined;
    departureDate!: Date;
    reasonId?: string | undefined;
    count!: number;

    constructor(data?: IAnalysisDeadPigletsGraphModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.litter = _data["litter"];
            this.week = _data["week"];
            this.age = _data["age"];
            this.departureDate = _data["departureDate"] ? new Date(_data["departureDate"].toString()) : <any>undefined;
            this.reasonId = _data["reasonId"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): AnalysisDeadPigletsGraphModel {
        data = typeof data === 'object' ? data : {};
        let result = new AnalysisDeadPigletsGraphModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["litter"] = this.litter;
        data["week"] = this.week;
        data["age"] = this.age;
        data["departureDate"] = this.departureDate ? this.departureDate.toISOString() : <any>undefined;
        data["reasonId"] = this.reasonId;
        data["count"] = this.count;
        return data;
    }
}

export interface IAnalysisDeadPigletsGraphModel {
    litter: number;
    week?: string | undefined;
    age?: string | undefined;
    departureDate: Date;
    reasonId?: string | undefined;
    count: number;
}

export class Device implements IDevice {
    hardwareID?: string | undefined;
    name?: string | undefined;
    fcmToken?: string | undefined;
    osType!: DeviceOSType;
    osVersion?: string | undefined;

    constructor(data?: IDevice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hardwareID = _data["hardwareID"];
            this.name = _data["name"];
            this.fcmToken = _data["fcmToken"];
            this.osType = _data["osType"];
            this.osVersion = _data["osVersion"];
        }
    }

    static fromJS(data: any): Device {
        data = typeof data === 'object' ? data : {};
        let result = new Device();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hardwareID"] = this.hardwareID;
        data["name"] = this.name;
        data["fcmToken"] = this.fcmToken;
        data["osType"] = this.osType;
        data["osVersion"] = this.osVersion;
        return data;
    }
}

export interface IDevice {
    hardwareID?: string | undefined;
    name?: string | undefined;
    fcmToken?: string | undefined;
    osType: DeviceOSType;
    osVersion?: string | undefined;
}

export enum DeviceOSType {
    IOS = "IOS",
    ANDROID = "ANDROID",
}

export class DiagnoseCategory extends Unique implements IDiagnoseCategory {
    name?: { [key: string]: string; } | undefined;
    priority!: number;

    constructor(data?: IDiagnoseCategory) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (_data["name"]) {
                this.name = {} as any;
                for (let key in _data["name"]) {
                    if (_data["name"].hasOwnProperty(key))
                        (<any>this.name)![key] = _data["name"][key];
                }
            }
            this.priority = _data["priority"];
        }
    }

    static override fromJS(data: any): DiagnoseCategory {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnoseCategory();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.name) {
            data["name"] = {};
            for (let key in this.name) {
                if (this.name.hasOwnProperty(key))
                    (<any>data["name"])[key] = (<any>this.name)[key];
            }
        }
        data["priority"] = this.priority;
        super.toJSON(data);
        return data;
    }
}

export interface IDiagnoseCategory extends IUnique {
    name?: { [key: string]: string; } | undefined;
    priority: number;
}

export abstract class BaseSyncOfDiagnoseCategory implements IBaseSyncOfDiagnoseCategory {
    syncTime!: Date;

    protected _discriminator: string;

    constructor(data?: IBaseSyncOfDiagnoseCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "BaseSyncOfDiagnoseCategory";
    }

    init(_data?: any) {
        if (_data) {
            this.syncTime = _data["syncTime"] ? new Date(_data["syncTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseSyncOfDiagnoseCategory {
        data = typeof data === 'object' ? data : {};
        if (data["_discriminator"] === "SyncDataDiagnoseCategory") {
            let result = new SyncDataDiagnoseCategory();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'BaseSyncOfDiagnoseCategory' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_discriminator"] = this._discriminator;
        data["syncTime"] = this.syncTime ? this.syncTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBaseSyncOfDiagnoseCategory {
    syncTime: Date;
}

export class SyncDataDiagnoseCategory extends BaseSyncOfDiagnoseCategory implements ISyncDataDiagnoseCategory {
    datas?: DiagnoseCategory[] | undefined;

    constructor(data?: ISyncDataDiagnoseCategory) {
        super(data);
        this._discriminator = "SyncDataDiagnoseCategory";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["datas"])) {
                this.datas = [] as any;
                for (let item of _data["datas"])
                    this.datas!.push(DiagnoseCategory.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): SyncDataDiagnoseCategory {
        data = typeof data === 'object' ? data : {};
        let result = new SyncDataDiagnoseCategory();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.datas)) {
            data["datas"] = [];
            for (let item of this.datas)
                data["datas"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISyncDataDiagnoseCategory extends IBaseSyncOfDiagnoseCategory {
    datas?: DiagnoseCategory[] | undefined;
}

export class Diagnose extends Unique implements IDiagnose {
    name?: { [key: string]: string; } | undefined;
    description?: { [key: string]: string; } | undefined;
    availableIn?: string[] | undefined;
    imageId?: string | undefined;
    diagnoseCategoryId?: string | undefined;
    animalKinds?: AnimalKind[] | undefined;
    isVaccination!: boolean;

    constructor(data?: IDiagnose) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (_data["name"]) {
                this.name = {} as any;
                for (let key in _data["name"]) {
                    if (_data["name"].hasOwnProperty(key))
                        (<any>this.name)![key] = _data["name"][key];
                }
            }
            if (_data["description"]) {
                this.description = {} as any;
                for (let key in _data["description"]) {
                    if (_data["description"].hasOwnProperty(key))
                        (<any>this.description)![key] = _data["description"][key];
                }
            }
            if (Array.isArray(_data["availableIn"])) {
                this.availableIn = [] as any;
                for (let item of _data["availableIn"])
                    this.availableIn!.push(item);
            }
            this.imageId = _data["imageId"];
            this.diagnoseCategoryId = _data["diagnoseCategoryId"];
            if (Array.isArray(_data["animalKinds"])) {
                this.animalKinds = [] as any;
                for (let item of _data["animalKinds"])
                    this.animalKinds!.push(item);
            }
            this.isVaccination = _data["isVaccination"];
        }
    }

    static override fromJS(data: any): Diagnose {
        data = typeof data === 'object' ? data : {};
        let result = new Diagnose();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.name) {
            data["name"] = {};
            for (let key in this.name) {
                if (this.name.hasOwnProperty(key))
                    (<any>data["name"])[key] = (<any>this.name)[key];
            }
        }
        if (this.description) {
            data["description"] = {};
            for (let key in this.description) {
                if (this.description.hasOwnProperty(key))
                    (<any>data["description"])[key] = (<any>this.description)[key];
            }
        }
        if (Array.isArray(this.availableIn)) {
            data["availableIn"] = [];
            for (let item of this.availableIn)
                data["availableIn"].push(item);
        }
        data["imageId"] = this.imageId;
        data["diagnoseCategoryId"] = this.diagnoseCategoryId;
        if (Array.isArray(this.animalKinds)) {
            data["animalKinds"] = [];
            for (let item of this.animalKinds)
                data["animalKinds"].push(item);
        }
        data["isVaccination"] = this.isVaccination;
        super.toJSON(data);
        return data;
    }
}

export interface IDiagnose extends IUnique {
    name?: { [key: string]: string; } | undefined;
    description?: { [key: string]: string; } | undefined;
    availableIn?: string[] | undefined;
    imageId?: string | undefined;
    diagnoseCategoryId?: string | undefined;
    animalKinds?: AnimalKind[] | undefined;
    isVaccination: boolean;
}

export enum AnimalKind {
    Unknown = "Unknown",
    YoungFemale = "YoungFemale",
    Gilt = "Gilt",
    Sow = "Sow",
    Boar = "Boar",
    Piglet = "Piglet",
    YoungAnimal = "YoungAnimal",
    Finisher = "Finisher",
    Weaner = "Weaner",
    FRATS = "FRATS",
    AIBoar = "AIBoar",
}

export abstract class BaseSyncOfDiagnose implements IBaseSyncOfDiagnose {
    syncTime!: Date;

    protected _discriminator: string;

    constructor(data?: IBaseSyncOfDiagnose) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "BaseSyncOfDiagnose";
    }

    init(_data?: any) {
        if (_data) {
            this.syncTime = _data["syncTime"] ? new Date(_data["syncTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseSyncOfDiagnose {
        data = typeof data === 'object' ? data : {};
        if (data["_discriminator"] === "SyncDataDiagnose") {
            let result = new SyncDataDiagnose();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'BaseSyncOfDiagnose' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_discriminator"] = this._discriminator;
        data["syncTime"] = this.syncTime ? this.syncTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBaseSyncOfDiagnose {
    syncTime: Date;
}

export class SyncDataDiagnose extends BaseSyncOfDiagnose implements ISyncDataDiagnose {
    datas?: Diagnose[] | undefined;

    constructor(data?: ISyncDataDiagnose) {
        super(data);
        this._discriminator = "SyncDataDiagnose";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["datas"])) {
                this.datas = [] as any;
                for (let item of _data["datas"])
                    this.datas!.push(Diagnose.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): SyncDataDiagnose {
        data = typeof data === 'object' ? data : {};
        let result = new SyncDataDiagnose();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.datas)) {
            data["datas"] = [];
            for (let item of this.datas)
                data["datas"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISyncDataDiagnose extends IBaseSyncOfDiagnose {
    datas?: Diagnose[] | undefined;
}

export class BaseAvailableResource implements IBaseAvailableResource {
    name?: string | undefined;
    id!: number;
    type?: string | undefined;
    location?: string | undefined;
    controller1!: boolean;
    controller2!: boolean;
    controller3!: boolean;
    controller4!: boolean;
    controller5!: boolean;
    controller6!: boolean;
    controller7!: boolean;
    controller8!: boolean;
    controller9!: boolean;

    constructor(data?: IBaseAvailableResource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
            this.type = _data["type"];
            this.location = _data["location"];
            this.controller1 = _data["controller1"];
            this.controller2 = _data["controller2"];
            this.controller3 = _data["controller3"];
            this.controller4 = _data["controller4"];
            this.controller5 = _data["controller5"];
            this.controller6 = _data["controller6"];
            this.controller7 = _data["controller7"];
            this.controller8 = _data["controller8"];
            this.controller9 = _data["controller9"];
        }
    }

    static fromJS(data: any): BaseAvailableResource {
        data = typeof data === 'object' ? data : {};
        let result = new BaseAvailableResource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        data["type"] = this.type;
        data["location"] = this.location;
        data["controller1"] = this.controller1;
        data["controller2"] = this.controller2;
        data["controller3"] = this.controller3;
        data["controller4"] = this.controller4;
        data["controller5"] = this.controller5;
        data["controller6"] = this.controller6;
        data["controller7"] = this.controller7;
        data["controller8"] = this.controller8;
        data["controller9"] = this.controller9;
        return data;
    }
}

export interface IBaseAvailableResource {
    name?: string | undefined;
    id: number;
    type?: string | undefined;
    location?: string | undefined;
    controller1: boolean;
    controller2: boolean;
    controller3: boolean;
    controller4: boolean;
    controller5: boolean;
    controller6: boolean;
    controller7: boolean;
    controller8: boolean;
    controller9: boolean;
}

export class FeedComponentModel extends BaseAvailableResource implements IFeedComponentModel {
    energy_1!: number;
    energy_2!: number;
    energy_1_name?: string | undefined;
    energy_2_name?: string | undefined;

    constructor(data?: IFeedComponentModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.energy_1 = _data["energy_1"];
            this.energy_2 = _data["energy_2"];
            this.energy_1_name = _data["energy_1_name"];
            this.energy_2_name = _data["energy_2_name"];
        }
    }

    static override fromJS(data: any): FeedComponentModel {
        data = typeof data === 'object' ? data : {};
        let result = new FeedComponentModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["energy_1"] = this.energy_1;
        data["energy_2"] = this.energy_2;
        data["energy_1_name"] = this.energy_1_name;
        data["energy_2_name"] = this.energy_2_name;
        super.toJSON(data);
        return data;
    }
}

export interface IFeedComponentModel extends IBaseAvailableResource {
    energy_1: number;
    energy_2: number;
    energy_1_name?: string | undefined;
    energy_2_name?: string | undefined;
}

export class DistriwinFeedComponent extends SiteEntity implements IDistriwinFeedComponent {
    name?: string | undefined;
    componentId!: number;
    type!: DistriwinComponentType;
    energy1!: number;
    energy2!: number;
    feedingId?: string | undefined;
    noRelation!: boolean;
    locationCode?: string | undefined;
    controller1!: boolean;
    controller2!: boolean;
    controller3!: boolean;
    controller4!: boolean;
    controller5!: boolean;
    controller6!: boolean;
    controller7!: boolean;
    controller8!: boolean;
    controller9!: boolean;

    constructor(data?: IDistriwinFeedComponent) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.componentId = _data["componentId"];
            this.type = _data["type"];
            this.energy1 = _data["energy1"];
            this.energy2 = _data["energy2"];
            this.feedingId = _data["feedingId"];
            this.noRelation = _data["noRelation"];
            this.locationCode = _data["locationCode"];
            this.controller1 = _data["controller1"];
            this.controller2 = _data["controller2"];
            this.controller3 = _data["controller3"];
            this.controller4 = _data["controller4"];
            this.controller5 = _data["controller5"];
            this.controller6 = _data["controller6"];
            this.controller7 = _data["controller7"];
            this.controller8 = _data["controller8"];
            this.controller9 = _data["controller9"];
        }
    }

    static override fromJS(data: any): DistriwinFeedComponent {
        data = typeof data === 'object' ? data : {};
        let result = new DistriwinFeedComponent();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["componentId"] = this.componentId;
        data["type"] = this.type;
        data["energy1"] = this.energy1;
        data["energy2"] = this.energy2;
        data["feedingId"] = this.feedingId;
        data["noRelation"] = this.noRelation;
        data["locationCode"] = this.locationCode;
        data["controller1"] = this.controller1;
        data["controller2"] = this.controller2;
        data["controller3"] = this.controller3;
        data["controller4"] = this.controller4;
        data["controller5"] = this.controller5;
        data["controller6"] = this.controller6;
        data["controller7"] = this.controller7;
        data["controller8"] = this.controller8;
        data["controller9"] = this.controller9;
        super.toJSON(data);
        return data;
    }
}

export interface IDistriwinFeedComponent extends ISiteEntity {
    name?: string | undefined;
    componentId: number;
    type: DistriwinComponentType;
    energy1: number;
    energy2: number;
    feedingId?: string | undefined;
    noRelation: boolean;
    locationCode?: string | undefined;
    controller1: boolean;
    controller2: boolean;
    controller3: boolean;
    controller4: boolean;
    controller5: boolean;
    controller6: boolean;
    controller7: boolean;
    controller8: boolean;
    controller9: boolean;
}

export enum DistriwinComponentType {
    Water = "Water",
    Premix = "Premix",
    Other = "Other",
}

export class FeedConsumptionModel implements IFeedConsumptionModel {
    date?: string | undefined;
    valve?: number | undefined;
    recipe_id?: number | undefined;
    component_id?: number | undefined;
    quantity?: number | undefined;
    location?: string | undefined;

    constructor(data?: IFeedConsumptionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"];
            this.valve = _data["valve"];
            this.recipe_id = _data["recipe_id"];
            this.component_id = _data["component_id"];
            this.quantity = _data["quantity"];
            this.location = _data["location"];
        }
    }

    static fromJS(data: any): FeedConsumptionModel {
        data = typeof data === 'object' ? data : {};
        let result = new FeedConsumptionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        data["valve"] = this.valve;
        data["recipe_id"] = this.recipe_id;
        data["component_id"] = this.component_id;
        data["quantity"] = this.quantity;
        data["location"] = this.location;
        return data;
    }
}

export interface IFeedConsumptionModel {
    date?: string | undefined;
    valve?: number | undefined;
    recipe_id?: number | undefined;
    component_id?: number | undefined;
    quantity?: number | undefined;
    location?: string | undefined;
}

export class DistriwinFeedConsumptionDto implements IDistriwinFeedConsumptionDto {
    periodFrom!: Date;
    periodTo!: Date;
    animalKind!: AnimalKind;
    locationType!: LocationType;
    animalType!: AnimalType;
    buildingId?: string | undefined;
    buildningName?: string | undefined;
    sectionId?: string | undefined;
    sectionName?: string | undefined;
    feedingId?: string | undefined;
    feedingSubjectName?: { [key: string]: string; } | undefined;
    feedingCategoryName?: { [key: string]: string; } | undefined;
    componentName?: string | undefined;
    componentId!: number;
    distriwinComponentType!: DistriwinComponentType;
    penId?: string | undefined;
    penName?: string | undefined;
    quantity!: number;
    totalEnergy1!: number;
    totalEnergy2!: number;
    avgEnergy1!: number;
    avgEnergy2!: number;
    recipeName?: string | undefined;
    recipeType?: string | undefined;
    recipeId!: number;

    constructor(data?: IDistriwinFeedConsumptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.periodFrom = _data["periodFrom"] ? new Date(_data["periodFrom"].toString()) : <any>undefined;
            this.periodTo = _data["periodTo"] ? new Date(_data["periodTo"].toString()) : <any>undefined;
            this.animalKind = _data["animalKind"];
            this.locationType = _data["locationType"];
            this.animalType = _data["animalType"];
            this.buildingId = _data["buildingId"];
            this.buildningName = _data["buildningName"];
            this.sectionId = _data["sectionId"];
            this.sectionName = _data["sectionName"];
            this.feedingId = _data["feedingId"];
            if (_data["feedingSubjectName"]) {
                this.feedingSubjectName = {} as any;
                for (let key in _data["feedingSubjectName"]) {
                    if (_data["feedingSubjectName"].hasOwnProperty(key))
                        (<any>this.feedingSubjectName)![key] = _data["feedingSubjectName"][key];
                }
            }
            if (_data["feedingCategoryName"]) {
                this.feedingCategoryName = {} as any;
                for (let key in _data["feedingCategoryName"]) {
                    if (_data["feedingCategoryName"].hasOwnProperty(key))
                        (<any>this.feedingCategoryName)![key] = _data["feedingCategoryName"][key];
                }
            }
            this.componentName = _data["componentName"];
            this.componentId = _data["componentId"];
            this.distriwinComponentType = _data["distriwinComponentType"];
            this.penId = _data["penId"];
            this.penName = _data["penName"];
            this.quantity = _data["quantity"];
            this.totalEnergy1 = _data["totalEnergy1"];
            this.totalEnergy2 = _data["totalEnergy2"];
            this.avgEnergy1 = _data["avgEnergy1"];
            this.avgEnergy2 = _data["avgEnergy2"];
            this.recipeName = _data["recipeName"];
            this.recipeType = _data["recipeType"];
            this.recipeId = _data["recipeId"];
        }
    }

    static fromJS(data: any): DistriwinFeedConsumptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new DistriwinFeedConsumptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["periodFrom"] = this.periodFrom ? this.periodFrom.toISOString() : <any>undefined;
        data["periodTo"] = this.periodTo ? this.periodTo.toISOString() : <any>undefined;
        data["animalKind"] = this.animalKind;
        data["locationType"] = this.locationType;
        data["animalType"] = this.animalType;
        data["buildingId"] = this.buildingId;
        data["buildningName"] = this.buildningName;
        data["sectionId"] = this.sectionId;
        data["sectionName"] = this.sectionName;
        data["feedingId"] = this.feedingId;
        if (this.feedingSubjectName) {
            data["feedingSubjectName"] = {};
            for (let key in this.feedingSubjectName) {
                if (this.feedingSubjectName.hasOwnProperty(key))
                    (<any>data["feedingSubjectName"])[key] = (<any>this.feedingSubjectName)[key];
            }
        }
        if (this.feedingCategoryName) {
            data["feedingCategoryName"] = {};
            for (let key in this.feedingCategoryName) {
                if (this.feedingCategoryName.hasOwnProperty(key))
                    (<any>data["feedingCategoryName"])[key] = (<any>this.feedingCategoryName)[key];
            }
        }
        data["componentName"] = this.componentName;
        data["componentId"] = this.componentId;
        data["distriwinComponentType"] = this.distriwinComponentType;
        data["penId"] = this.penId;
        data["penName"] = this.penName;
        data["quantity"] = this.quantity;
        data["totalEnergy1"] = this.totalEnergy1;
        data["totalEnergy2"] = this.totalEnergy2;
        data["avgEnergy1"] = this.avgEnergy1;
        data["avgEnergy2"] = this.avgEnergy2;
        data["recipeName"] = this.recipeName;
        data["recipeType"] = this.recipeType;
        data["recipeId"] = this.recipeId;
        return data;
    }
}

export interface IDistriwinFeedConsumptionDto {
    periodFrom: Date;
    periodTo: Date;
    animalKind: AnimalKind;
    locationType: LocationType;
    animalType: AnimalType;
    buildingId?: string | undefined;
    buildningName?: string | undefined;
    sectionId?: string | undefined;
    sectionName?: string | undefined;
    feedingId?: string | undefined;
    feedingSubjectName?: { [key: string]: string; } | undefined;
    feedingCategoryName?: { [key: string]: string; } | undefined;
    componentName?: string | undefined;
    componentId: number;
    distriwinComponentType: DistriwinComponentType;
    penId?: string | undefined;
    penName?: string | undefined;
    quantity: number;
    totalEnergy1: number;
    totalEnergy2: number;
    avgEnergy1: number;
    avgEnergy2: number;
    recipeName?: string | undefined;
    recipeType?: string | undefined;
    recipeId: number;
}

export enum LocationType {
    Mating = "Mating",
    Pregnant = "Pregnant",
    Farrowing = "Farrowing",
    YoungFemale = "YoungFemale",
    Boars = "Boars",
    Relief = "Relief",
    Holistic = "Holistic",
    Weaners = "Weaners",
    Finisher = "Finisher",
    Silo = "Silo",
    PostponeSows = "PostponeSows",
    ReliefFinisher = "ReliefFinisher",
    ReliefWeaners = "ReliefWeaners",
    WeanedPiglets = "WeanedPiglets",
    YoungAnimal = "YoungAnimal",
}

export abstract class BaseSyncOfDistriwinFeedConsumption implements IBaseSyncOfDistriwinFeedConsumption {
    syncTime!: Date;

    protected _discriminator: string;

    constructor(data?: IBaseSyncOfDistriwinFeedConsumption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "BaseSyncOfDistriwinFeedConsumption";
    }

    init(_data?: any) {
        if (_data) {
            this.syncTime = _data["syncTime"] ? new Date(_data["syncTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseSyncOfDistriwinFeedConsumption {
        data = typeof data === 'object' ? data : {};
        if (data["_discriminator"] === "SyncDataDistriwinFeedConsumption") {
            let result = new SyncDataDistriwinFeedConsumption();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'BaseSyncOfDistriwinFeedConsumption' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_discriminator"] = this._discriminator;
        data["syncTime"] = this.syncTime ? this.syncTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBaseSyncOfDistriwinFeedConsumption {
    syncTime: Date;
}

export class SyncDataDistriwinFeedConsumption extends BaseSyncOfDistriwinFeedConsumption implements ISyncDataDistriwinFeedConsumption {
    datas?: DistriwinFeedConsumption[] | undefined;

    constructor(data?: ISyncDataDistriwinFeedConsumption) {
        super(data);
        this._discriminator = "SyncDataDistriwinFeedConsumption";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["datas"])) {
                this.datas = [] as any;
                for (let item of _data["datas"])
                    this.datas!.push(DistriwinFeedConsumption.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): SyncDataDistriwinFeedConsumption {
        data = typeof data === 'object' ? data : {};
        let result = new SyncDataDistriwinFeedConsumption();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.datas)) {
            data["datas"] = [];
            for (let item of this.datas)
                data["datas"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISyncDataDistriwinFeedConsumption extends IBaseSyncOfDistriwinFeedConsumption {
    datas?: DistriwinFeedConsumption[] | undefined;
}

export class DistriwinFeedConsumption extends SiteEntity implements IDistriwinFeedConsumption {
    date!: Date;
    valveId?: number | undefined;
    recipeNumber?: number | undefined;
    componentId?: number | undefined;
    quantity?: number | undefined;
    totalEnergy1?: number | undefined;
    totalEnergy2?: number | undefined;
    location?: string | undefined;
    penId?: string | undefined;
    sectionId?: string | undefined;
    buildingId?: string | undefined;

    constructor(data?: IDistriwinFeedConsumption) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.valveId = _data["valveId"];
            this.recipeNumber = _data["recipeNumber"];
            this.componentId = _data["componentId"];
            this.quantity = _data["quantity"];
            this.totalEnergy1 = _data["totalEnergy1"];
            this.totalEnergy2 = _data["totalEnergy2"];
            this.location = _data["location"];
            this.penId = _data["penId"];
            this.sectionId = _data["sectionId"];
            this.buildingId = _data["buildingId"];
        }
    }

    static override fromJS(data: any): DistriwinFeedConsumption {
        data = typeof data === 'object' ? data : {};
        let result = new DistriwinFeedConsumption();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["valveId"] = this.valveId;
        data["recipeNumber"] = this.recipeNumber;
        data["componentId"] = this.componentId;
        data["quantity"] = this.quantity;
        data["totalEnergy1"] = this.totalEnergy1;
        data["totalEnergy2"] = this.totalEnergy2;
        data["location"] = this.location;
        data["penId"] = this.penId;
        data["sectionId"] = this.sectionId;
        data["buildingId"] = this.buildingId;
        super.toJSON(data);
        return data;
    }
}

export interface IDistriwinFeedConsumption extends ISiteEntity {
    date: Date;
    valveId?: number | undefined;
    recipeNumber?: number | undefined;
    componentId?: number | undefined;
    quantity?: number | undefined;
    totalEnergy1?: number | undefined;
    totalEnergy2?: number | undefined;
    location?: string | undefined;
    penId?: string | undefined;
    sectionId?: string | undefined;
    buildingId?: string | undefined;
}

export class FeedRegistrationModel implements IFeedRegistrationModel {
    feed_registration!: number;
    energy_registration!: number;
    qty_pig!: number;
    energy_pig!: number;
    curve_ration!: number;
    date_registration?: string | undefined;
    date_consumption?: string | undefined;
    penDays!: number;
    weight!: number;
    location?: string | undefined;
    id?: string | undefined;

    constructor(data?: IFeedRegistrationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.feed_registration = _data["feed_registration"];
            this.energy_registration = _data["energy_registration"];
            this.qty_pig = _data["qty_pig"];
            this.energy_pig = _data["energy_pig"];
            this.curve_ration = _data["curve_ration"];
            this.date_registration = _data["date_registration"];
            this.date_consumption = _data["date_consumption"];
            this.penDays = _data["penDays"];
            this.weight = _data["weight"];
            this.location = _data["location"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): FeedRegistrationModel {
        data = typeof data === 'object' ? data : {};
        let result = new FeedRegistrationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["feed_registration"] = this.feed_registration;
        data["energy_registration"] = this.energy_registration;
        data["qty_pig"] = this.qty_pig;
        data["energy_pig"] = this.energy_pig;
        data["curve_ration"] = this.curve_ration;
        data["date_registration"] = this.date_registration;
        data["date_consumption"] = this.date_consumption;
        data["penDays"] = this.penDays;
        data["weight"] = this.weight;
        data["location"] = this.location;
        data["id"] = this.id;
        return data;
    }
}

export interface IFeedRegistrationModel {
    feed_registration: number;
    energy_registration: number;
    qty_pig: number;
    energy_pig: number;
    curve_ration: number;
    date_registration?: string | undefined;
    date_consumption?: string | undefined;
    penDays: number;
    weight: number;
    location?: string | undefined;
    id?: string | undefined;
}

export class ValveInfoDTO implements IValveInfoDTO {
    siteId?: string | undefined;
    location?: string | undefined;
    weight!: number;
    penDays!: number;

    constructor(data?: IValveInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.siteId = _data["siteId"];
            this.location = _data["location"];
            this.weight = _data["weight"];
            this.penDays = _data["penDays"];
        }
    }

    static fromJS(data: any): ValveInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ValveInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siteId"] = this.siteId;
        data["location"] = this.location;
        data["weight"] = this.weight;
        data["penDays"] = this.penDays;
        return data;
    }
}

export interface IValveInfoDTO {
    siteId?: string | undefined;
    location?: string | undefined;
    weight: number;
    penDays: number;
}

export class DistriwinFeedRegistration extends SiteEntity implements IDistriwinFeedRegistration {
    feedRegistrationValue!: number;
    energyRegistrationValue!: number;
    quantityPig!: number;
    energyPig!: number;
    curveRation!: number;
    weight!: number;
    penDays!: number;
    dateRegistration!: Date;
    dateConsumption!: Date;
    location?: string | undefined;

    constructor(data?: IDistriwinFeedRegistration) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.feedRegistrationValue = _data["feedRegistrationValue"];
            this.energyRegistrationValue = _data["energyRegistrationValue"];
            this.quantityPig = _data["quantityPig"];
            this.energyPig = _data["energyPig"];
            this.curveRation = _data["curveRation"];
            this.weight = _data["weight"];
            this.penDays = _data["penDays"];
            this.dateRegistration = _data["dateRegistration"] ? new Date(_data["dateRegistration"].toString()) : <any>undefined;
            this.dateConsumption = _data["dateConsumption"] ? new Date(_data["dateConsumption"].toString()) : <any>undefined;
            this.location = _data["location"];
        }
    }

    static override fromJS(data: any): DistriwinFeedRegistration {
        data = typeof data === 'object' ? data : {};
        let result = new DistriwinFeedRegistration();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["feedRegistrationValue"] = this.feedRegistrationValue;
        data["energyRegistrationValue"] = this.energyRegistrationValue;
        data["quantityPig"] = this.quantityPig;
        data["energyPig"] = this.energyPig;
        data["curveRation"] = this.curveRation;
        data["weight"] = this.weight;
        data["penDays"] = this.penDays;
        data["dateRegistration"] = this.dateRegistration ? this.dateRegistration.toISOString() : <any>undefined;
        data["dateConsumption"] = this.dateConsumption ? this.dateConsumption.toISOString() : <any>undefined;
        data["location"] = this.location;
        super.toJSON(data);
        return data;
    }
}

export interface IDistriwinFeedRegistration extends ISiteEntity {
    feedRegistrationValue: number;
    energyRegistrationValue: number;
    quantityPig: number;
    energyPig: number;
    curveRation: number;
    weight: number;
    penDays: number;
    dateRegistration: Date;
    dateConsumption: Date;
    location?: string | undefined;
}

export class DistriwinOption extends SiteEntity implements IDistriwinOption {
    pigManagement!: boolean;
    location?: string | undefined;

    constructor(data?: IDistriwinOption) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pigManagement = _data["pigManagement"];
            this.location = _data["location"];
        }
    }

    static override fromJS(data: any): DistriwinOption {
        data = typeof data === 'object' ? data : {};
        let result = new DistriwinOption();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pigManagement"] = this.pigManagement;
        data["location"] = this.location;
        super.toJSON(data);
        return data;
    }
}

export interface IDistriwinOption extends ISiteEntity {
    pigManagement: boolean;
    location?: string | undefined;
}

export abstract class BaseSingleSyncOfDistriwinOption implements IBaseSingleSyncOfDistriwinOption {
    syncTime!: Date;

    constructor(data?: IBaseSingleSyncOfDistriwinOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.syncTime = _data["syncTime"] ? new Date(_data["syncTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseSingleSyncOfDistriwinOption {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseSingleSyncOfDistriwinOption' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["syncTime"] = this.syncTime ? this.syncTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBaseSingleSyncOfDistriwinOption {
    syncTime: Date;
}

export class SyncDistriwinOption extends BaseSingleSyncOfDistriwinOption implements ISyncDistriwinOption {
    data?: DistriwinOption | undefined;

    constructor(data?: ISyncDistriwinOption) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? DistriwinOption.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): SyncDistriwinOption {
        data = typeof data === 'object' ? data : {};
        let result = new SyncDistriwinOption();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ISyncDistriwinOption extends IBaseSingleSyncOfDistriwinOption {
    data?: DistriwinOption | undefined;
}

export class DistriwinTaskAlert extends SiteEntity implements IDistriwinTaskAlert {
    controllerNumber!: number;
    taskNumber!: number;
    location?: string | undefined;
    text?: string | undefined;
    status?: string | undefined;
    extra?: string | undefined;

    constructor(data?: IDistriwinTaskAlert) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.controllerNumber = _data["controllerNumber"];
            this.taskNumber = _data["taskNumber"];
            this.location = _data["location"];
            this.text = _data["text"];
            this.status = _data["status"];
            this.extra = _data["extra"];
        }
    }

    static override fromJS(data: any): DistriwinTaskAlert {
        data = typeof data === 'object' ? data : {};
        let result = new DistriwinTaskAlert();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["controllerNumber"] = this.controllerNumber;
        data["taskNumber"] = this.taskNumber;
        data["location"] = this.location;
        data["text"] = this.text;
        data["status"] = this.status;
        data["extra"] = this.extra;
        super.toJSON(data);
        return data;
    }
}

export interface IDistriwinTaskAlert extends ISiteEntity {
    controllerNumber: number;
    taskNumber: number;
    location?: string | undefined;
    text?: string | undefined;
    status?: string | undefined;
    extra?: string | undefined;
}

export class DistriwinTask extends SiteEntity implements IDistriwinTask {
    controllerNumber!: number;
    taskNumber!: number;
    name?: string | undefined;
    functionName?: string | undefined;
    subFunctionName?: string | undefined;
    timeTableName?: string | undefined;
    sequenceTableName?: string | undefined;
    status!: number;
    location?: string | undefined;

    constructor(data?: IDistriwinTask) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.controllerNumber = _data["controllerNumber"];
            this.taskNumber = _data["taskNumber"];
            this.name = _data["name"];
            this.functionName = _data["functionName"];
            this.subFunctionName = _data["subFunctionName"];
            this.timeTableName = _data["timeTableName"];
            this.sequenceTableName = _data["sequenceTableName"];
            this.status = _data["status"];
            this.location = _data["location"];
        }
    }

    static override fromJS(data: any): DistriwinTask {
        data = typeof data === 'object' ? data : {};
        let result = new DistriwinTask();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["controllerNumber"] = this.controllerNumber;
        data["taskNumber"] = this.taskNumber;
        data["name"] = this.name;
        data["functionName"] = this.functionName;
        data["subFunctionName"] = this.subFunctionName;
        data["timeTableName"] = this.timeTableName;
        data["sequenceTableName"] = this.sequenceTableName;
        data["status"] = this.status;
        data["location"] = this.location;
        super.toJSON(data);
        return data;
    }
}

export interface IDistriwinTask extends ISiteEntity {
    controllerNumber: number;
    taskNumber: number;
    name?: string | undefined;
    functionName?: string | undefined;
    subFunctionName?: string | undefined;
    timeTableName?: string | undefined;
    sequenceTableName?: string | undefined;
    status: number;
    location?: string | undefined;
}

export class DistriwinTaskModel implements IDistriwinTaskModel {
    controllerNumber!: number;
    taskNumber!: number;
    name?: string | undefined;
    function?: string | undefined;
    sub_function?: string | undefined;
    time_table_name?: string | undefined;
    seq_table_name?: string | undefined;
    status!: number;
    location?: string | undefined;

    constructor(data?: IDistriwinTaskModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.controllerNumber = _data["controllerNumber"];
            this.taskNumber = _data["taskNumber"];
            this.name = _data["name"];
            this.function = _data["function"];
            this.sub_function = _data["sub_function"];
            this.time_table_name = _data["time_table_name"];
            this.seq_table_name = _data["seq_table_name"];
            this.status = _data["status"];
            this.location = _data["location"];
        }
    }

    static fromJS(data: any): DistriwinTaskModel {
        data = typeof data === 'object' ? data : {};
        let result = new DistriwinTaskModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["controllerNumber"] = this.controllerNumber;
        data["taskNumber"] = this.taskNumber;
        data["name"] = this.name;
        data["function"] = this.function;
        data["sub_function"] = this.sub_function;
        data["time_table_name"] = this.time_table_name;
        data["seq_table_name"] = this.seq_table_name;
        data["status"] = this.status;
        data["location"] = this.location;
        return data;
    }
}

export interface IDistriwinTaskModel {
    controllerNumber: number;
    taskNumber: number;
    name?: string | undefined;
    function?: string | undefined;
    sub_function?: string | undefined;
    time_table_name?: string | undefined;
    seq_table_name?: string | undefined;
    status: number;
    location?: string | undefined;
}

export class Drug extends SiteEntity implements IDrug {
    drugTypeId?: string | undefined;
    animalKinds?: AnimalKind[] | undefined;
    isArchived!: boolean;
    startDate!: Date;
    archiveDate?: Date | undefined;
    lastAdjusted!: Date;
    waste!: number;
    usage!: number;
    total!: number;

    constructor(data?: IDrug) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.drugTypeId = _data["drugTypeId"];
            if (Array.isArray(_data["animalKinds"])) {
                this.animalKinds = [] as any;
                for (let item of _data["animalKinds"])
                    this.animalKinds!.push(item);
            }
            this.isArchived = _data["isArchived"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.archiveDate = _data["archiveDate"] ? new Date(_data["archiveDate"].toString()) : <any>undefined;
            this.lastAdjusted = _data["lastAdjusted"] ? new Date(_data["lastAdjusted"].toString()) : <any>undefined;
            this.waste = _data["waste"];
            this.usage = _data["usage"];
            this.total = _data["total"];
        }
    }

    static override fromJS(data: any): Drug {
        data = typeof data === 'object' ? data : {};
        let result = new Drug();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["drugTypeId"] = this.drugTypeId;
        if (Array.isArray(this.animalKinds)) {
            data["animalKinds"] = [];
            for (let item of this.animalKinds)
                data["animalKinds"].push(item);
        }
        data["isArchived"] = this.isArchived;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["archiveDate"] = this.archiveDate ? this.archiveDate.toISOString() : <any>undefined;
        data["lastAdjusted"] = this.lastAdjusted ? this.lastAdjusted.toISOString() : <any>undefined;
        data["waste"] = this.waste;
        data["usage"] = this.usage;
        data["total"] = this.total;
        super.toJSON(data);
        return data;
    }
}

export interface IDrug extends ISiteEntity {
    drugTypeId?: string | undefined;
    animalKinds?: AnimalKind[] | undefined;
    isArchived: boolean;
    startDate: Date;
    archiveDate?: Date | undefined;
    lastAdjusted: Date;
    waste: number;
    usage: number;
    total: number;
}

export class DrugWithAdjustment extends SiteEntity implements IDrugWithAdjustment {
    adjustmentId?: string | undefined;
    drugTypeId?: string | undefined;
    animalKinds?: AnimalKind[] | undefined;
    date!: Date;
    type!: AmountType;
    registeredBy?: string | undefined;
    amount?: number | undefined;
    price?: number | undefined;
    reason?: string | undefined;

    constructor(data?: IDrugWithAdjustment) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.adjustmentId = _data["adjustmentId"];
            this.drugTypeId = _data["drugTypeId"];
            if (Array.isArray(_data["animalKinds"])) {
                this.animalKinds = [] as any;
                for (let item of _data["animalKinds"])
                    this.animalKinds!.push(item);
            }
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.type = _data["type"];
            this.registeredBy = _data["registeredBy"];
            this.amount = _data["amount"];
            this.price = _data["price"];
            this.reason = _data["reason"];
        }
    }

    static override fromJS(data: any): DrugWithAdjustment {
        data = typeof data === 'object' ? data : {};
        let result = new DrugWithAdjustment();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adjustmentId"] = this.adjustmentId;
        data["drugTypeId"] = this.drugTypeId;
        if (Array.isArray(this.animalKinds)) {
            data["animalKinds"] = [];
            for (let item of this.animalKinds)
                data["animalKinds"].push(item);
        }
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["type"] = this.type;
        data["registeredBy"] = this.registeredBy;
        data["amount"] = this.amount;
        data["price"] = this.price;
        data["reason"] = this.reason;
        super.toJSON(data);
        return data;
    }
}

export interface IDrugWithAdjustment extends ISiteEntity {
    adjustmentId?: string | undefined;
    drugTypeId?: string | undefined;
    animalKinds?: AnimalKind[] | undefined;
    date: Date;
    type: AmountType;
    registeredBy?: string | undefined;
    amount?: number | undefined;
    price?: number | undefined;
    reason?: string | undefined;
}

export enum AmountType {
    Waste = "Waste",
    Usage = "Usage",
    Adjustment = "Adjustment",
    SystemAdjustment = "SystemAdjustment",
}

export class DrugAdjustmentDeleteInformation implements IDrugAdjustmentDeleteInformation {
    drugId?: string | undefined;
    adjustmentId?: string | undefined;
    date!: Date;
    siteId?: string | undefined;

    constructor(data?: IDrugAdjustmentDeleteInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.drugId = _data["drugId"];
            this.adjustmentId = _data["adjustmentId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.siteId = _data["siteId"];
        }
    }

    static fromJS(data: any): DrugAdjustmentDeleteInformation {
        data = typeof data === 'object' ? data : {};
        let result = new DrugAdjustmentDeleteInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["drugId"] = this.drugId;
        data["adjustmentId"] = this.adjustmentId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["siteId"] = this.siteId;
        return data;
    }
}

export interface IDrugAdjustmentDeleteInformation {
    drugId?: string | undefined;
    adjustmentId?: string | undefined;
    date: Date;
    siteId?: string | undefined;
}

export class DrugCreate implements IDrugCreate {
    drug?: Drug | undefined;
    adjustment?: AmountBase | undefined;

    constructor(data?: IDrugCreate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.drug = _data["drug"] ? Drug.fromJS(_data["drug"]) : <any>undefined;
            this.adjustment = _data["adjustment"] ? AmountBase.fromJS(_data["adjustment"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DrugCreate {
        data = typeof data === 'object' ? data : {};
        let result = new DrugCreate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["drug"] = this.drug ? this.drug.toJSON() : <any>undefined;
        data["adjustment"] = this.adjustment ? this.adjustment.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDrugCreate {
    drug?: Drug | undefined;
    adjustment?: AmountBase | undefined;
}

export abstract class AmountBase extends SiteEntity implements IAmountBase {
    drugId?: string | undefined;
    type!: AmountType;
    amount?: number | undefined;
    price?: number | undefined;
    date!: Date;

    protected _discriminator: string;

    constructor(data?: IAmountBase) {
        super(data);
        this._discriminator = "AmountBase";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.drugId = _data["drugId"];
            this.type = _data["type"];
            this.amount = _data["amount"];
            this.price = _data["price"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): AmountBase {
        data = typeof data === 'object' ? data : {};
        if (data["derivedTypeSelector"] === "SystemAdjustment") {
            let result = new SystemAdjustment();
            result.init(data);
            return result;
        }
        if (data["derivedTypeSelector"] === "Waste") {
            let result = new Waste();
            result.init(data);
            return result;
        }
        if (data["derivedTypeSelector"] === "Usage") {
            let result = new Usage();
            result.init(data);
            return result;
        }
        if (data["derivedTypeSelector"] === "Adjustment") {
            let result = new Adjustment();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'AmountBase' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["derivedTypeSelector"] = this._discriminator;
        data["drugId"] = this.drugId;
        data["type"] = this.type;
        data["amount"] = this.amount;
        data["price"] = this.price;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IAmountBase extends ISiteEntity {
    drugId?: string | undefined;
    type: AmountType;
    amount?: number | undefined;
    price?: number | undefined;
    date: Date;
}

export class SystemAdjustment extends AmountBase implements ISystemAdjustment {
    reason!: SystemAdjustmentReason;

    constructor(data?: ISystemAdjustment) {
        super(data);
        this._discriminator = "SystemAdjustment";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.reason = _data["reason"];
        }
    }

    static override fromJS(data: any): SystemAdjustment {
        data = typeof data === 'object' ? data : {};
        let result = new SystemAdjustment();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason;
        super.toJSON(data);
        return data;
    }
}

export interface ISystemAdjustment extends IAmountBase {
    reason: SystemAdjustmentReason;
}

export enum SystemAdjustmentReason {
    Deletion = "Deletion",
}

export class Waste extends AmountBase implements IWaste {
    reason?: string | undefined;
    registeredById?: string | undefined;

    constructor(data?: IWaste) {
        super(data);
        this._discriminator = "Waste";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.reason = _data["reason"];
            this.registeredById = _data["registeredById"];
        }
    }

    static override fromJS(data: any): Waste {
        data = typeof data === 'object' ? data : {};
        let result = new Waste();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason;
        data["registeredById"] = this.registeredById;
        super.toJSON(data);
        return data;
    }
}

export interface IWaste extends IAmountBase {
    reason?: string | undefined;
    registeredById?: string | undefined;
}

export class Usage extends AmountBase implements IUsage {
    treatmentId?: string | undefined;

    constructor(data?: IUsage) {
        super(data);
        this._discriminator = "Usage";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.treatmentId = _data["treatmentId"];
        }
    }

    static override fromJS(data: any): Usage {
        data = typeof data === 'object' ? data : {};
        let result = new Usage();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["treatmentId"] = this.treatmentId;
        super.toJSON(data);
        return data;
    }
}

export interface IUsage extends IAmountBase {
    treatmentId?: string | undefined;
}

export class Adjustment extends AmountBase implements IAdjustment {
    registeredById?: string | undefined;

    constructor(data?: IAdjustment) {
        super(data);
        this._discriminator = "Adjustment";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.registeredById = _data["registeredById"];
        }
    }

    static override fromJS(data: any): Adjustment {
        data = typeof data === 'object' ? data : {};
        let result = new Adjustment();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registeredById"] = this.registeredById;
        super.toJSON(data);
        return data;
    }
}

export interface IAdjustment extends IAmountBase {
    registeredById?: string | undefined;
}

export class DrugType extends Unique implements IDrugType {
    name?: string | undefined;
    unitOfMeasurement?: string | undefined;
    avaliableIn?: string[] | undefined;
    type!: DrugTypeType;

    constructor(data?: IDrugType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.unitOfMeasurement = _data["unitOfMeasurement"];
            if (Array.isArray(_data["avaliableIn"])) {
                this.avaliableIn = [] as any;
                for (let item of _data["avaliableIn"])
                    this.avaliableIn!.push(item);
            }
            this.type = _data["type"];
        }
    }

    static override fromJS(data: any): DrugType {
        data = typeof data === 'object' ? data : {};
        let result = new DrugType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["unitOfMeasurement"] = this.unitOfMeasurement;
        if (Array.isArray(this.avaliableIn)) {
            data["avaliableIn"] = [];
            for (let item of this.avaliableIn)
                data["avaliableIn"].push(item);
        }
        data["type"] = this.type;
        super.toJSON(data);
        return data;
    }
}

export interface IDrugType extends IUnique {
    name?: string | undefined;
    unitOfMeasurement?: string | undefined;
    avaliableIn?: string[] | undefined;
    type: DrugTypeType;
}

export enum DrugTypeType {
    Medicine = "Medicine",
    Vaccine = "Vaccine",
}

export abstract class BaseSyncOfDrugType implements IBaseSyncOfDrugType {
    syncTime!: Date;

    protected _discriminator: string;

    constructor(data?: IBaseSyncOfDrugType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "BaseSyncOfDrugType";
    }

    init(_data?: any) {
        if (_data) {
            this.syncTime = _data["syncTime"] ? new Date(_data["syncTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseSyncOfDrugType {
        data = typeof data === 'object' ? data : {};
        if (data["_discriminator"] === "SyncDataDrugType") {
            let result = new SyncDataDrugType();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'BaseSyncOfDrugType' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_discriminator"] = this._discriminator;
        data["syncTime"] = this.syncTime ? this.syncTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBaseSyncOfDrugType {
    syncTime: Date;
}

export class SyncDataDrugType extends BaseSyncOfDrugType implements ISyncDataDrugType {
    datas?: DrugType[] | undefined;

    constructor(data?: ISyncDataDrugType) {
        super(data);
        this._discriminator = "SyncDataDrugType";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["datas"])) {
                this.datas = [] as any;
                for (let item of _data["datas"])
                    this.datas!.push(DrugType.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): SyncDataDrugType {
        data = typeof data === 'object' ? data : {};
        let result = new SyncDataDrugType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.datas)) {
            data["datas"] = [];
            for (let item of this.datas)
                data["datas"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISyncDataDrugType extends IBaseSyncOfDrugType {
    datas?: DrugType[] | undefined;
}

export class BaseStatusModel implements IBaseStatusModel {
    locationCode?: string | undefined;
    location?: string | undefined;
    eventTime!: Date;

    constructor(data?: IBaseStatusModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationCode = _data["locationCode"];
            this.location = _data["location"];
            this.eventTime = _data["eventTime"] ? new Date(_data["eventTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseStatusModel {
        data = typeof data === 'object' ? data : {};
        let result = new BaseStatusModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationCode"] = this.locationCode;
        data["location"] = this.location;
        data["eventTime"] = this.eventTime ? this.eventTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBaseStatusModel {
    locationCode?: string | undefined;
    location?: string | undefined;
    eventTime: Date;
}

export class AutoRegistration extends BaseStatusModel implements IAutoRegistration {
    animalNumber?: string | undefined;
    locationNumber?: string | undefined;
    locationType?: string | undefined;
    transferDate?: string | undefined;
    transferTime?: string | undefined;
    transferReason?: string | undefined;
    toLocationNumber?: string | undefined;
    toLocationType?: string | undefined;
    fromLocationCode?: string | undefined;
    transferDateTime!: Date;

    constructor(data?: IAutoRegistration) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.animalNumber = _data["animalNumber"];
            this.locationNumber = _data["locationNumber"];
            this.locationType = _data["locationType"];
            this.transferDate = _data["transferDate"];
            this.transferTime = _data["transferTime"];
            this.transferReason = _data["transferReason"];
            this.toLocationNumber = _data["toLocationNumber"];
            this.toLocationType = _data["toLocationType"];
            this.fromLocationCode = _data["fromLocationCode"];
            this.transferDateTime = _data["transferDateTime"] ? new Date(_data["transferDateTime"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): AutoRegistration {
        data = typeof data === 'object' ? data : {};
        let result = new AutoRegistration();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["animalNumber"] = this.animalNumber;
        data["locationNumber"] = this.locationNumber;
        data["locationType"] = this.locationType;
        data["transferDate"] = this.transferDate;
        data["transferTime"] = this.transferTime;
        data["transferReason"] = this.transferReason;
        data["toLocationNumber"] = this.toLocationNumber;
        data["toLocationType"] = this.toLocationType;
        data["fromLocationCode"] = this.fromLocationCode;
        data["transferDateTime"] = this.transferDateTime ? this.transferDateTime.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IAutoRegistration extends IBaseStatusModel {
    animalNumber?: string | undefined;
    locationNumber?: string | undefined;
    locationType?: string | undefined;
    transferDate?: string | undefined;
    transferTime?: string | undefined;
    transferReason?: string | undefined;
    toLocationNumber?: string | undefined;
    toLocationType?: string | undefined;
    fromLocationCode?: string | undefined;
    transferDateTime: Date;
}

export class ElistarEsfAnimalInformation extends BaseStatusModel implements IElistarEsfAnimalInformation {
    animalNumber?: string | undefined;
    animalId?: string | undefined;
    entryDate!: Date;
    departureDate!: Date;
    gender?: string | undefined;
    birthDate!: Date;
    transponder?: string | undefined;

    constructor(data?: IElistarEsfAnimalInformation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.animalNumber = _data["animalNumber"];
            this.animalId = _data["animalId"];
            this.entryDate = _data["entryDate"] ? new Date(_data["entryDate"].toString()) : <any>undefined;
            this.departureDate = _data["departureDate"] ? new Date(_data["departureDate"].toString()) : <any>undefined;
            this.gender = _data["gender"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.transponder = _data["transponder"];
        }
    }

    static override fromJS(data: any): ElistarEsfAnimalInformation {
        data = typeof data === 'object' ? data : {};
        let result = new ElistarEsfAnimalInformation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["animalNumber"] = this.animalNumber;
        data["animalId"] = this.animalId;
        data["entryDate"] = this.entryDate ? this.entryDate.toISOString() : <any>undefined;
        data["departureDate"] = this.departureDate ? this.departureDate.toISOString() : <any>undefined;
        data["gender"] = this.gender;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["transponder"] = this.transponder;
        super.toJSON(data);
        return data;
    }
}

export interface IElistarEsfAnimalInformation extends IBaseStatusModel {
    animalNumber?: string | undefined;
    animalId?: string | undefined;
    entryDate: Date;
    departureDate: Date;
    gender?: string | undefined;
    birthDate: Date;
    transponder?: string | undefined;
}

export class BaseAnimalStatusModel extends BaseStatusModel implements IBaseAnimalStatusModel {
    animalId?: string | undefined;
    feedCurveAmount!: number;
    animalNumber?: string | undefined;

    constructor(data?: IBaseAnimalStatusModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.animalId = _data["animalId"];
            this.feedCurveAmount = _data["feedCurveAmount"];
            this.animalNumber = _data["animalNumber"];
        }
    }

    static override fromJS(data: any): BaseAnimalStatusModel {
        data = typeof data === 'object' ? data : {};
        let result = new BaseAnimalStatusModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["animalId"] = this.animalId;
        data["feedCurveAmount"] = this.feedCurveAmount;
        data["animalNumber"] = this.animalNumber;
        super.toJSON(data);
        return data;
    }
}

export interface IBaseAnimalStatusModel extends IBaseStatusModel {
    animalId?: string | undefined;
    feedCurveAmount: number;
    animalNumber?: string | undefined;
}

export class EsfDailyStatusDto extends BaseAnimalStatusModel implements IEsfDailyStatusDto {
    feedToday!: number;
    acknowledged!: boolean;
    totalEnergyDosed!: number;
    date!: Date;

    constructor(data?: IEsfDailyStatusDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.feedToday = _data["feedToday"];
            this.acknowledged = _data["acknowledged"];
            this.totalEnergyDosed = _data["totalEnergyDosed"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): EsfDailyStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new EsfDailyStatusDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["feedToday"] = this.feedToday;
        data["acknowledged"] = this.acknowledged;
        data["totalEnergyDosed"] = this.totalEnergyDosed;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IEsfDailyStatusDto extends IBaseAnimalStatusModel {
    feedToday: number;
    acknowledged: boolean;
    totalEnergyDosed: number;
    date: Date;
}

export class EsfDailyStatus extends EsfDailyStatusDto implements IEsfDailyStatus {
    stemAnimalId?: string | undefined;
    calculatedFeedToday!: number;
    id?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date | undefined;
    modifiedBy?: string | undefined;
    modifiedOn?: Date | undefined;
    isDeleted!: boolean;
    siteId?: string | undefined;

    constructor(data?: IEsfDailyStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.stemAnimalId = _data["stemAnimalId"];
            this.calculatedFeedToday = _data["calculatedFeedToday"];
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.siteId = _data["siteId"];
        }
    }

    static override fromJS(data: any): EsfDailyStatus {
        data = typeof data === 'object' ? data : {};
        let result = new EsfDailyStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stemAnimalId"] = this.stemAnimalId;
        data["calculatedFeedToday"] = this.calculatedFeedToday;
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["siteId"] = this.siteId;
        super.toJSON(data);
        return data;
    }
}

export interface IEsfDailyStatus extends IEsfDailyStatusDto {
    stemAnimalId?: string | undefined;
    calculatedFeedToday: number;
    id?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date | undefined;
    modifiedBy?: string | undefined;
    modifiedOn?: Date | undefined;
    isDeleted: boolean;
    siteId?: string | undefined;
}

export abstract class BaseSyncOfEsfDailyStatus implements IBaseSyncOfEsfDailyStatus {
    syncTime!: Date;

    protected _discriminator: string;

    constructor(data?: IBaseSyncOfEsfDailyStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "BaseSyncOfEsfDailyStatus";
    }

    init(_data?: any) {
        if (_data) {
            this.syncTime = _data["syncTime"] ? new Date(_data["syncTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseSyncOfEsfDailyStatus {
        data = typeof data === 'object' ? data : {};
        if (data["_discriminator"] === "SyncEsfDailyStatus") {
            let result = new SyncEsfDailyStatus();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'BaseSyncOfEsfDailyStatus' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_discriminator"] = this._discriminator;
        data["syncTime"] = this.syncTime ? this.syncTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBaseSyncOfEsfDailyStatus {
    syncTime: Date;
}

export class SyncEsfDailyStatus extends BaseSyncOfEsfDailyStatus implements ISyncEsfDailyStatus {
    datas?: EsfDailyStatus[] | undefined;

    constructor(data?: ISyncEsfDailyStatus) {
        super(data);
        this._discriminator = "SyncEsfDailyStatus";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["datas"])) {
                this.datas = [] as any;
                for (let item of _data["datas"])
                    this.datas!.push(EsfDailyStatus.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): SyncEsfDailyStatus {
        data = typeof data === 'object' ? data : {};
        let result = new SyncEsfDailyStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.datas)) {
            data["datas"] = [];
            for (let item of this.datas)
                data["datas"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISyncEsfDailyStatus extends IBaseSyncOfEsfDailyStatus {
    datas?: EsfDailyStatus[] | undefined;
}

export abstract class BaseSyncOfEsfFeedCurve implements IBaseSyncOfEsfFeedCurve {
    syncTime!: Date;

    protected _discriminator: string;

    constructor(data?: IBaseSyncOfEsfFeedCurve) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "BaseSyncOfEsfFeedCurve";
    }

    init(_data?: any) {
        if (_data) {
            this.syncTime = _data["syncTime"] ? new Date(_data["syncTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseSyncOfEsfFeedCurve {
        data = typeof data === 'object' ? data : {};
        if (data["_discriminator"] === "SyncEsfFeedCurve") {
            let result = new SyncEsfFeedCurve();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'BaseSyncOfEsfFeedCurve' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_discriminator"] = this._discriminator;
        data["syncTime"] = this.syncTime ? this.syncTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBaseSyncOfEsfFeedCurve {
    syncTime: Date;
}

export class SyncEsfFeedCurve extends BaseSyncOfEsfFeedCurve implements ISyncEsfFeedCurve {
    datas?: EsfFeedCurve[] | undefined;

    constructor(data?: ISyncEsfFeedCurve) {
        super(data);
        this._discriminator = "SyncEsfFeedCurve";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["datas"])) {
                this.datas = [] as any;
                for (let item of _data["datas"])
                    this.datas!.push(EsfFeedCurve.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): SyncEsfFeedCurve {
        data = typeof data === 'object' ? data : {};
        let result = new SyncEsfFeedCurve();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.datas)) {
            data["datas"] = [];
            for (let item of this.datas)
                data["datas"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISyncEsfFeedCurve extends IBaseSyncOfEsfFeedCurve {
    datas?: EsfFeedCurve[] | undefined;
}

export class FeedCurveStatusDto extends BaseStatusModel implements IFeedCurveStatusDto {
    feedCurveName?: string | undefined;
    feedCurveNumber!: number;
    feedCurveType?: number | undefined;

    constructor(data?: IFeedCurveStatusDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.feedCurveName = _data["feedCurveName"];
            this.feedCurveNumber = _data["feedCurveNumber"];
            this.feedCurveType = _data["feedCurveType"];
        }
    }

    static override fromJS(data: any): FeedCurveStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeedCurveStatusDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["feedCurveName"] = this.feedCurveName;
        data["feedCurveNumber"] = this.feedCurveNumber;
        data["feedCurveType"] = this.feedCurveType;
        super.toJSON(data);
        return data;
    }
}

export interface IFeedCurveStatusDto extends IBaseStatusModel {
    feedCurveName?: string | undefined;
    feedCurveNumber: number;
    feedCurveType?: number | undefined;
}

export class EsfFeedCurve extends FeedCurveStatusDto implements IEsfFeedCurve {
    id?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date | undefined;
    modifiedBy?: string | undefined;
    modifiedOn?: Date | undefined;
    isDeleted!: boolean;
    siteId?: string | undefined;

    constructor(data?: IEsfFeedCurve) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.siteId = _data["siteId"];
        }
    }

    static override fromJS(data: any): EsfFeedCurve {
        data = typeof data === 'object' ? data : {};
        let result = new EsfFeedCurve();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["siteId"] = this.siteId;
        super.toJSON(data);
        return data;
    }
}

export interface IEsfFeedCurve extends IFeedCurveStatusDto {
    id?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date | undefined;
    modifiedBy?: string | undefined;
    modifiedOn?: Date | undefined;
    isDeleted: boolean;
    siteId?: string | undefined;
}

export class FeedingStatusUpdate implements IFeedingStatusUpdate {
    id?: string | undefined;
    feedCurveNumber?: number | undefined;
    fixedDeviation?: number | undefined;
    animalNumber?: string | undefined;
    deviationPeriod?: number | undefined;
    tempFeedDeviation?: number | undefined;

    constructor(data?: IFeedingStatusUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.feedCurveNumber = _data["feedCurveNumber"];
            this.fixedDeviation = _data["fixedDeviation"];
            this.animalNumber = _data["animalNumber"];
            this.deviationPeriod = _data["deviationPeriod"];
            this.tempFeedDeviation = _data["tempFeedDeviation"];
        }
    }

    static fromJS(data: any): FeedingStatusUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new FeedingStatusUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["feedCurveNumber"] = this.feedCurveNumber;
        data["fixedDeviation"] = this.fixedDeviation;
        data["animalNumber"] = this.animalNumber;
        data["deviationPeriod"] = this.deviationPeriod;
        data["tempFeedDeviation"] = this.tempFeedDeviation;
        return data;
    }
}

export interface IFeedingStatusUpdate {
    id?: string | undefined;
    feedCurveNumber?: number | undefined;
    fixedDeviation?: number | undefined;
    animalNumber?: string | undefined;
    deviationPeriod?: number | undefined;
    tempFeedDeviation?: number | undefined;
}

export class EsfStatusAcknowledge implements IEsfStatusAcknowledge {
    id?: string | undefined;
    acknowledgeDate?: Date | undefined;

    constructor(data?: IEsfStatusAcknowledge) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.acknowledgeDate = _data["acknowledgeDate"] ? new Date(_data["acknowledgeDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EsfStatusAcknowledge {
        data = typeof data === 'object' ? data : {};
        let result = new EsfStatusAcknowledge();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["acknowledgeDate"] = this.acknowledgeDate ? this.acknowledgeDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IEsfStatusAcknowledge {
    id?: string | undefined;
    acknowledgeDate?: Date | undefined;
}

export abstract class BaseSyncOfEsfFeedingStatus implements IBaseSyncOfEsfFeedingStatus {
    syncTime!: Date;

    protected _discriminator: string;

    constructor(data?: IBaseSyncOfEsfFeedingStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "BaseSyncOfEsfFeedingStatus";
    }

    init(_data?: any) {
        if (_data) {
            this.syncTime = _data["syncTime"] ? new Date(_data["syncTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseSyncOfEsfFeedingStatus {
        data = typeof data === 'object' ? data : {};
        if (data["_discriminator"] === "SyncEsfFeedingStatus") {
            let result = new SyncEsfFeedingStatus();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'BaseSyncOfEsfFeedingStatus' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_discriminator"] = this._discriminator;
        data["syncTime"] = this.syncTime ? this.syncTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBaseSyncOfEsfFeedingStatus {
    syncTime: Date;
}

export class SyncEsfFeedingStatus extends BaseSyncOfEsfFeedingStatus implements ISyncEsfFeedingStatus {
    datas?: EsfFeedingStatus[] | undefined;

    constructor(data?: ISyncEsfFeedingStatus) {
        super(data);
        this._discriminator = "SyncEsfFeedingStatus";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["datas"])) {
                this.datas = [] as any;
                for (let item of _data["datas"])
                    this.datas!.push(EsfFeedingStatus.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): SyncEsfFeedingStatus {
        data = typeof data === 'object' ? data : {};
        let result = new SyncEsfFeedingStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.datas)) {
            data["datas"] = [];
            for (let item of this.datas)
                data["datas"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISyncEsfFeedingStatus extends IBaseSyncOfEsfFeedingStatus {
    datas?: EsfFeedingStatus[] | undefined;
}

export class EsfFeedingStatusDto extends BaseAnimalStatusModel implements IEsfFeedingStatusDto {
    feedToday!: number;
    remainingFeedRation!: number;
    feedCurveNumber!: number;
    feedCurveType!: number;
    fixedDeviation!: number;
    deviationPeriod?: number | undefined;
    tempFeedDeviation?: number | undefined;
    visit1?: Visit | undefined;
    visit2?: Visit | undefined;
    visit3?: Visit | undefined;
    visit4?: Visit | undefined;

    constructor(data?: IEsfFeedingStatusDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.feedToday = _data["feedToday"];
            this.remainingFeedRation = _data["remainingFeedRation"];
            this.feedCurveNumber = _data["feedCurveNumber"];
            this.feedCurveType = _data["feedCurveType"];
            this.fixedDeviation = _data["fixedDeviation"];
            this.deviationPeriod = _data["deviationPeriod"];
            this.tempFeedDeviation = _data["tempFeedDeviation"];
            this.visit1 = _data["visit1"] ? Visit.fromJS(_data["visit1"]) : <any>undefined;
            this.visit2 = _data["visit2"] ? Visit.fromJS(_data["visit2"]) : <any>undefined;
            this.visit3 = _data["visit3"] ? Visit.fromJS(_data["visit3"]) : <any>undefined;
            this.visit4 = _data["visit4"] ? Visit.fromJS(_data["visit4"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): EsfFeedingStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new EsfFeedingStatusDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["feedToday"] = this.feedToday;
        data["remainingFeedRation"] = this.remainingFeedRation;
        data["feedCurveNumber"] = this.feedCurveNumber;
        data["feedCurveType"] = this.feedCurveType;
        data["fixedDeviation"] = this.fixedDeviation;
        data["deviationPeriod"] = this.deviationPeriod;
        data["tempFeedDeviation"] = this.tempFeedDeviation;
        data["visit1"] = this.visit1 ? this.visit1.toJSON() : <any>undefined;
        data["visit2"] = this.visit2 ? this.visit2.toJSON() : <any>undefined;
        data["visit3"] = this.visit3 ? this.visit3.toJSON() : <any>undefined;
        data["visit4"] = this.visit4 ? this.visit4.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IEsfFeedingStatusDto extends IBaseAnimalStatusModel {
    feedToday: number;
    remainingFeedRation: number;
    feedCurveNumber: number;
    feedCurveType: number;
    fixedDeviation: number;
    deviationPeriod?: number | undefined;
    tempFeedDeviation?: number | undefined;
    visit1?: Visit | undefined;
    visit2?: Visit | undefined;
    visit3?: Visit | undefined;
    visit4?: Visit | undefined;
}

export class EsfFeedingStatus extends EsfFeedingStatusDto implements IEsfFeedingStatus {
    stemAnimalId?: string | undefined;
    acknowledgeDate?: Date | undefined;
    id?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date | undefined;
    modifiedBy?: string | undefined;
    modifiedOn?: Date | undefined;
    isDeleted!: boolean;
    siteId?: string | undefined;

    constructor(data?: IEsfFeedingStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.stemAnimalId = _data["stemAnimalId"];
            this.acknowledgeDate = _data["acknowledgeDate"] ? new Date(_data["acknowledgeDate"].toString()) : <any>undefined;
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.siteId = _data["siteId"];
        }
    }

    static override fromJS(data: any): EsfFeedingStatus {
        data = typeof data === 'object' ? data : {};
        let result = new EsfFeedingStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stemAnimalId"] = this.stemAnimalId;
        data["acknowledgeDate"] = this.acknowledgeDate ? this.acknowledgeDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["siteId"] = this.siteId;
        super.toJSON(data);
        return data;
    }
}

export interface IEsfFeedingStatus extends IEsfFeedingStatusDto {
    stemAnimalId?: string | undefined;
    acknowledgeDate?: Date | undefined;
    id?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date | undefined;
    modifiedBy?: string | undefined;
    modifiedOn?: Date | undefined;
    isDeleted: boolean;
    siteId?: string | undefined;
}

export class Visit implements IVisit {
    feed!: number;
    date!: Date;
    stationNumber?: string | undefined;

    constructor(data?: IVisit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.feed = _data["feed"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.stationNumber = _data["stationNumber"];
        }
    }

    static fromJS(data: any): Visit {
        data = typeof data === 'object' ? data : {};
        let result = new Visit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["feed"] = this.feed;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["stationNumber"] = this.stationNumber;
        return data;
    }
}

export interface IVisit {
    feed: number;
    date: Date;
    stationNumber?: string | undefined;
}

export class EsfStation extends BaseStatusModel implements IEsfStation {
    stationNumber?: string | undefined;
    locationName?: string | undefined;

    constructor(data?: IEsfStation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.stationNumber = _data["stationNumber"];
            this.locationName = _data["locationName"];
        }
    }

    static override fromJS(data: any): EsfStation {
        data = typeof data === 'object' ? data : {};
        let result = new EsfStation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stationNumber"] = this.stationNumber;
        data["locationName"] = this.locationName;
        super.toJSON(data);
        return data;
    }
}

export interface IEsfStation extends IBaseStatusModel {
    stationNumber?: string | undefined;
    locationName?: string | undefined;
}

export class FeatureFlagsOptions implements IFeatureFlagsOptions {
    workListV2!: boolean;
    saveSowLogging!: boolean;
    userManagement!: boolean;
    createSite!: boolean;
    quickSearch!: boolean;
    siteMigration!: boolean;

    constructor(data?: IFeatureFlagsOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workListV2 = _data["workListV2"];
            this.saveSowLogging = _data["saveSowLogging"];
            this.userManagement = _data["userManagement"];
            this.createSite = _data["createSite"];
            this.quickSearch = _data["quickSearch"];
            this.siteMigration = _data["siteMigration"];
        }
    }

    static fromJS(data: any): FeatureFlagsOptions {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureFlagsOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workListV2"] = this.workListV2;
        data["saveSowLogging"] = this.saveSowLogging;
        data["userManagement"] = this.userManagement;
        data["createSite"] = this.createSite;
        data["quickSearch"] = this.quickSearch;
        data["siteMigration"] = this.siteMigration;
        return data;
    }
}

export interface IFeatureFlagsOptions {
    workListV2: boolean;
    saveSowLogging: boolean;
    userManagement: boolean;
    createSite: boolean;
    quickSearch: boolean;
    siteMigration: boolean;
}

export class FeedingCategory extends Unique implements IFeedingCategory {
    name?: { [key: string]: string; } | undefined;
    animalTypes?: AnimalType[] | undefined;

    constructor(data?: IFeedingCategory) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (_data["name"]) {
                this.name = {} as any;
                for (let key in _data["name"]) {
                    if (_data["name"].hasOwnProperty(key))
                        (<any>this.name)![key] = _data["name"][key];
                }
            }
            if (Array.isArray(_data["animalTypes"])) {
                this.animalTypes = [] as any;
                for (let item of _data["animalTypes"])
                    this.animalTypes!.push(item);
            }
        }
    }

    static override fromJS(data: any): FeedingCategory {
        data = typeof data === 'object' ? data : {};
        let result = new FeedingCategory();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.name) {
            data["name"] = {};
            for (let key in this.name) {
                if (this.name.hasOwnProperty(key))
                    (<any>data["name"])[key] = (<any>this.name)[key];
            }
        }
        if (Array.isArray(this.animalTypes)) {
            data["animalTypes"] = [];
            for (let item of this.animalTypes)
                data["animalTypes"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IFeedingCategory extends IUnique {
    name?: { [key: string]: string; } | undefined;
    animalTypes?: AnimalType[] | undefined;
}

export class Feeding extends SiteEntity implements IFeeding {
    feedingSubjectId?: string | undefined;
    animalTypes?: AnimalType[] | undefined;
    isArchived!: boolean;
    startDate!: Date;
    archiveDate?: Date | undefined;
    adjustments?: FeedingAdjustmentBase[] | undefined;
    lastAdjusted!: Date;

    constructor(data?: IFeeding) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.feedingSubjectId = _data["feedingSubjectId"];
            if (Array.isArray(_data["animalTypes"])) {
                this.animalTypes = [] as any;
                for (let item of _data["animalTypes"])
                    this.animalTypes!.push(item);
            }
            this.isArchived = _data["isArchived"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.archiveDate = _data["archiveDate"] ? new Date(_data["archiveDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["adjustments"])) {
                this.adjustments = [] as any;
                for (let item of _data["adjustments"])
                    this.adjustments!.push(FeedingAdjustmentBase.fromJS(item));
            }
            this.lastAdjusted = _data["lastAdjusted"] ? new Date(_data["lastAdjusted"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): Feeding {
        data = typeof data === 'object' ? data : {};
        let result = new Feeding();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["feedingSubjectId"] = this.feedingSubjectId;
        if (Array.isArray(this.animalTypes)) {
            data["animalTypes"] = [];
            for (let item of this.animalTypes)
                data["animalTypes"].push(item);
        }
        data["isArchived"] = this.isArchived;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["archiveDate"] = this.archiveDate ? this.archiveDate.toISOString() : <any>undefined;
        if (Array.isArray(this.adjustments)) {
            data["adjustments"] = [];
            for (let item of this.adjustments)
                data["adjustments"].push(item.toJSON());
        }
        data["lastAdjusted"] = this.lastAdjusted ? this.lastAdjusted.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IFeeding extends ISiteEntity {
    feedingSubjectId?: string | undefined;
    animalTypes?: AnimalType[] | undefined;
    isArchived: boolean;
    startDate: Date;
    archiveDate?: Date | undefined;
    adjustments?: FeedingAdjustmentBase[] | undefined;
    lastAdjusted: Date;
}

export abstract class FeedingAdjustmentBase extends Unique implements IFeedingAdjustmentBase {
    type!: FeedingAmountType;
    amount!: number;
    date!: Date;

    protected _discriminator: string;

    constructor(data?: IFeedingAdjustmentBase) {
        super(data);
        this._discriminator = "FeedingAdjustmentBase";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"];
            this.amount = _data["amount"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): FeedingAdjustmentBase {
        data = typeof data === 'object' ? data : {};
        if (data["derivedTypeSelector"] === "FeedingUsage") {
            let result = new FeedingUsage();
            result.init(data);
            return result;
        }
        if (data["derivedTypeSelector"] === "FeedingAdjustment") {
            let result = new FeedingAdjustment();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'FeedingAdjustmentBase' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["derivedTypeSelector"] = this._discriminator;
        data["type"] = this.type;
        data["amount"] = this.amount;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IFeedingAdjustmentBase extends IUnique {
    type: FeedingAmountType;
    amount: number;
    date: Date;
}

export enum FeedingAmountType {
    FeedingUsage = "FeedingUsage",
    FeedingAdjustment = "FeedingAdjustment",
}

export class FeedingUsage extends FeedingAdjustmentBase implements IFeedingUsage {
    periodFrom!: Date;
    periodTo!: Date;
    buildingId?: string | undefined;
    sectionId?: string | undefined;
    defaultBuildingName?: string | undefined;
    animalType!: AnimalType;
    productionType?: AnimalType | undefined;
    recipeId?: string | undefined;

    constructor(data?: IFeedingUsage) {
        super(data);
        this._discriminator = "FeedingUsage";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.periodFrom = _data["periodFrom"] ? new Date(_data["periodFrom"].toString()) : <any>undefined;
            this.periodTo = _data["periodTo"] ? new Date(_data["periodTo"].toString()) : <any>undefined;
            this.buildingId = _data["buildingId"];
            this.sectionId = _data["sectionId"];
            this.defaultBuildingName = _data["defaultBuildingName"];
            this.animalType = _data["animalType"];
            this.productionType = _data["productionType"];
            this.recipeId = _data["recipeId"];
        }
    }

    static override fromJS(data: any): FeedingUsage {
        data = typeof data === 'object' ? data : {};
        let result = new FeedingUsage();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["periodFrom"] = this.periodFrom ? this.periodFrom.toISOString() : <any>undefined;
        data["periodTo"] = this.periodTo ? this.periodTo.toISOString() : <any>undefined;
        data["buildingId"] = this.buildingId;
        data["sectionId"] = this.sectionId;
        data["defaultBuildingName"] = this.defaultBuildingName;
        data["animalType"] = this.animalType;
        data["productionType"] = this.productionType;
        data["recipeId"] = this.recipeId;
        super.toJSON(data);
        return data;
    }
}

export interface IFeedingUsage extends IFeedingAdjustmentBase {
    periodFrom: Date;
    periodTo: Date;
    buildingId?: string | undefined;
    sectionId?: string | undefined;
    defaultBuildingName?: string | undefined;
    animalType: AnimalType;
    productionType?: AnimalType | undefined;
    recipeId?: string | undefined;
}

export class FeedingAdjustment extends FeedingAdjustmentBase implements IFeedingAdjustment {
    rawProtein!: number;
    energy2PerKg!: number;
    energy1PerKg!: number;
    fosforGPerKg!: number;
    pricePer100Kg!: number;

    constructor(data?: IFeedingAdjustment) {
        super(data);
        this._discriminator = "FeedingAdjustment";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.rawProtein = _data["rawProtein"];
            this.energy2PerKg = _data["energy2PerKg"];
            this.energy1PerKg = _data["energy1PerKg"];
            this.fosforGPerKg = _data["fosforGPerKg"];
            this.pricePer100Kg = _data["pricePer100Kg"];
        }
    }

    static override fromJS(data: any): FeedingAdjustment {
        data = typeof data === 'object' ? data : {};
        let result = new FeedingAdjustment();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rawProtein"] = this.rawProtein;
        data["energy2PerKg"] = this.energy2PerKg;
        data["energy1PerKg"] = this.energy1PerKg;
        data["fosforGPerKg"] = this.fosforGPerKg;
        data["pricePer100Kg"] = this.pricePer100Kg;
        super.toJSON(data);
        return data;
    }
}

export interface IFeedingAdjustment extends IFeedingAdjustmentBase {
    rawProtein: number;
    energy2PerKg: number;
    energy1PerKg: number;
    fosforGPerKg: number;
    pricePer100Kg: number;
}

export class FeedingReportTable implements IFeedingReportTable {
    header?: FeedingReportItem | undefined;
    tableItems?: FeedingReportItem[] | undefined;

    constructor(data?: IFeedingReportTable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.header = _data["header"] ? FeedingReportItem.fromJS(_data["header"]) : <any>undefined;
            if (Array.isArray(_data["tableItems"])) {
                this.tableItems = [] as any;
                for (let item of _data["tableItems"])
                    this.tableItems!.push(FeedingReportItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FeedingReportTable {
        data = typeof data === 'object' ? data : {};
        let result = new FeedingReportTable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["header"] = this.header ? this.header.toJSON() : <any>undefined;
        if (Array.isArray(this.tableItems)) {
            data["tableItems"] = [];
            for (let item of this.tableItems)
                data["tableItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFeedingReportTable {
    header?: FeedingReportItem | undefined;
    tableItems?: FeedingReportItem[] | undefined;
}

export class FeedingReportItem implements IFeedingReportItem {
    location?: string | undefined;
    days?: string | undefined;
    animalNumber?: string | undefined;
    idNumber?: string | undefined;
    datesValues?: FeedingReportDateValue[] | undefined;
    sectionId?: string | undefined;
    stemAnimalId?: string | undefined;
    sortNumber!: number;
    totalFeed!: number;
    totalFeedToEventDate?: Date | undefined;
    totalFeedFromEventDate?: Date | undefined;
    cellColorStyle!: CellColorStyle;

    constructor(data?: IFeedingReportItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.location = _data["location"];
            this.days = _data["days"];
            this.animalNumber = _data["animalNumber"];
            this.idNumber = _data["idNumber"];
            if (Array.isArray(_data["datesValues"])) {
                this.datesValues = [] as any;
                for (let item of _data["datesValues"])
                    this.datesValues!.push(FeedingReportDateValue.fromJS(item));
            }
            this.sectionId = _data["sectionId"];
            this.stemAnimalId = _data["stemAnimalId"];
            this.sortNumber = _data["sortNumber"];
            this.totalFeed = _data["totalFeed"];
            this.totalFeedToEventDate = _data["totalFeedToEventDate"] ? new Date(_data["totalFeedToEventDate"].toString()) : <any>undefined;
            this.totalFeedFromEventDate = _data["totalFeedFromEventDate"] ? new Date(_data["totalFeedFromEventDate"].toString()) : <any>undefined;
            this.cellColorStyle = _data["cellColorStyle"];
        }
    }

    static fromJS(data: any): FeedingReportItem {
        data = typeof data === 'object' ? data : {};
        let result = new FeedingReportItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["location"] = this.location;
        data["days"] = this.days;
        data["animalNumber"] = this.animalNumber;
        data["idNumber"] = this.idNumber;
        if (Array.isArray(this.datesValues)) {
            data["datesValues"] = [];
            for (let item of this.datesValues)
                data["datesValues"].push(item.toJSON());
        }
        data["sectionId"] = this.sectionId;
        data["stemAnimalId"] = this.stemAnimalId;
        data["sortNumber"] = this.sortNumber;
        data["totalFeed"] = this.totalFeed;
        data["totalFeedToEventDate"] = this.totalFeedToEventDate ? this.totalFeedToEventDate.toISOString() : <any>undefined;
        data["totalFeedFromEventDate"] = this.totalFeedFromEventDate ? this.totalFeedFromEventDate.toISOString() : <any>undefined;
        data["cellColorStyle"] = this.cellColorStyle;
        return data;
    }
}

export interface IFeedingReportItem {
    location?: string | undefined;
    days?: string | undefined;
    animalNumber?: string | undefined;
    idNumber?: string | undefined;
    datesValues?: FeedingReportDateValue[] | undefined;
    sectionId?: string | undefined;
    stemAnimalId?: string | undefined;
    sortNumber: number;
    totalFeed: number;
    totalFeedToEventDate?: Date | undefined;
    totalFeedFromEventDate?: Date | undefined;
    cellColorStyle: CellColorStyle;
}

export class FeedingReportDateValue implements IFeedingReportDateValue {
    number!: number;
    date!: Date;
    tableValue?: string | undefined;
    cellColorStyle!: CellColorStyle;

    constructor(data?: IFeedingReportDateValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.tableValue = _data["tableValue"];
            this.cellColorStyle = _data["cellColorStyle"];
        }
    }

    static fromJS(data: any): FeedingReportDateValue {
        data = typeof data === 'object' ? data : {};
        let result = new FeedingReportDateValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["tableValue"] = this.tableValue;
        data["cellColorStyle"] = this.cellColorStyle;
        return data;
    }
}

export interface IFeedingReportDateValue {
    number: number;
    date: Date;
    tableValue?: string | undefined;
    cellColorStyle: CellColorStyle;
}

export class FeedingSubject extends SiteEntity implements IFeedingSubject {
    name?: { [key: string]: string; } | undefined;
    feedingCategoryId?: string | undefined;
    euNumber?: string | undefined;
    order?: number | undefined;

    constructor(data?: IFeedingSubject) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (_data["name"]) {
                this.name = {} as any;
                for (let key in _data["name"]) {
                    if (_data["name"].hasOwnProperty(key))
                        (<any>this.name)![key] = _data["name"][key];
                }
            }
            this.feedingCategoryId = _data["feedingCategoryId"];
            this.euNumber = _data["euNumber"];
            this.order = _data["order"];
        }
    }

    static override fromJS(data: any): FeedingSubject {
        data = typeof data === 'object' ? data : {};
        let result = new FeedingSubject();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.name) {
            data["name"] = {};
            for (let key in this.name) {
                if (this.name.hasOwnProperty(key))
                    (<any>data["name"])[key] = (<any>this.name)[key];
            }
        }
        data["feedingCategoryId"] = this.feedingCategoryId;
        data["euNumber"] = this.euNumber;
        data["order"] = this.order;
        super.toJSON(data);
        return data;
    }
}

export interface IFeedingSubject extends ISiteEntity {
    name?: { [key: string]: string; } | undefined;
    feedingCategoryId?: string | undefined;
    euNumber?: string | undefined;
    order?: number | undefined;
}

export class SectionFeedUsageDTO implements ISectionFeedUsageDTO {
    buildingId?: string | undefined;
    sectionId?: string | undefined;
    sectionName?: string | undefined;
    sectionOrder!: number;
    weight!: number;
    penDays!: number;
    curveRation!: number;
    feedPerPigToday!: number;
    feedUnitPrDay?: { [key: string]: number; } | undefined;

    constructor(data?: ISectionFeedUsageDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buildingId = _data["buildingId"];
            this.sectionId = _data["sectionId"];
            this.sectionName = _data["sectionName"];
            this.sectionOrder = _data["sectionOrder"];
            this.weight = _data["weight"];
            this.penDays = _data["penDays"];
            this.curveRation = _data["curveRation"];
            this.feedPerPigToday = _data["feedPerPigToday"];
            if (_data["feedUnitPrDay"]) {
                this.feedUnitPrDay = {} as any;
                for (let key in _data["feedUnitPrDay"]) {
                    if (_data["feedUnitPrDay"].hasOwnProperty(key))
                        (<any>this.feedUnitPrDay)![key] = _data["feedUnitPrDay"][key];
                }
            }
        }
    }

    static fromJS(data: any): SectionFeedUsageDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SectionFeedUsageDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buildingId"] = this.buildingId;
        data["sectionId"] = this.sectionId;
        data["sectionName"] = this.sectionName;
        data["sectionOrder"] = this.sectionOrder;
        data["weight"] = this.weight;
        data["penDays"] = this.penDays;
        data["curveRation"] = this.curveRation;
        data["feedPerPigToday"] = this.feedPerPigToday;
        if (this.feedUnitPrDay) {
            data["feedUnitPrDay"] = {};
            for (let key in this.feedUnitPrDay) {
                if (this.feedUnitPrDay.hasOwnProperty(key))
                    (<any>data["feedUnitPrDay"])[key] = (<any>this.feedUnitPrDay)[key];
            }
        }
        return data;
    }
}

export interface ISectionFeedUsageDTO {
    buildingId?: string | undefined;
    sectionId?: string | undefined;
    sectionName?: string | undefined;
    sectionOrder: number;
    weight: number;
    penDays: number;
    curveRation: number;
    feedPerPigToday: number;
    feedUnitPrDay?: { [key: string]: number; } | undefined;
}

export class SectionWeanerGraphDTO implements ISectionWeanerGraphDTO {
    sectionId?: string | undefined;
    feedUnitsCurve?: { [key: string]: number; } | undefined;
    weights?: { [key: string]: number; } | undefined;
    feedUnitsPerDay?: { [key: string]: number; } | undefined;
    penDays?: { [key: string]: number; } | undefined;
    adjustments?: { [key: string]: AdjustmentDTO[]; } | undefined;

    constructor(data?: ISectionWeanerGraphDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sectionId = _data["sectionId"];
            if (_data["feedUnitsCurve"]) {
                this.feedUnitsCurve = {} as any;
                for (let key in _data["feedUnitsCurve"]) {
                    if (_data["feedUnitsCurve"].hasOwnProperty(key))
                        (<any>this.feedUnitsCurve)![key] = _data["feedUnitsCurve"][key];
                }
            }
            if (_data["weights"]) {
                this.weights = {} as any;
                for (let key in _data["weights"]) {
                    if (_data["weights"].hasOwnProperty(key))
                        (<any>this.weights)![key] = _data["weights"][key];
                }
            }
            if (_data["feedUnitsPerDay"]) {
                this.feedUnitsPerDay = {} as any;
                for (let key in _data["feedUnitsPerDay"]) {
                    if (_data["feedUnitsPerDay"].hasOwnProperty(key))
                        (<any>this.feedUnitsPerDay)![key] = _data["feedUnitsPerDay"][key];
                }
            }
            if (_data["penDays"]) {
                this.penDays = {} as any;
                for (let key in _data["penDays"]) {
                    if (_data["penDays"].hasOwnProperty(key))
                        (<any>this.penDays)![key] = _data["penDays"][key];
                }
            }
            if (_data["adjustments"]) {
                this.adjustments = {} as any;
                for (let key in _data["adjustments"]) {
                    if (_data["adjustments"].hasOwnProperty(key))
                        (<any>this.adjustments)![key] = _data["adjustments"][key] ? _data["adjustments"][key].map((i: any) => AdjustmentDTO.fromJS(i)) : [];
                }
            }
        }
    }

    static fromJS(data: any): SectionWeanerGraphDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SectionWeanerGraphDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sectionId"] = this.sectionId;
        if (this.feedUnitsCurve) {
            data["feedUnitsCurve"] = {};
            for (let key in this.feedUnitsCurve) {
                if (this.feedUnitsCurve.hasOwnProperty(key))
                    (<any>data["feedUnitsCurve"])[key] = (<any>this.feedUnitsCurve)[key];
            }
        }
        if (this.weights) {
            data["weights"] = {};
            for (let key in this.weights) {
                if (this.weights.hasOwnProperty(key))
                    (<any>data["weights"])[key] = (<any>this.weights)[key];
            }
        }
        if (this.feedUnitsPerDay) {
            data["feedUnitsPerDay"] = {};
            for (let key in this.feedUnitsPerDay) {
                if (this.feedUnitsPerDay.hasOwnProperty(key))
                    (<any>data["feedUnitsPerDay"])[key] = (<any>this.feedUnitsPerDay)[key];
            }
        }
        if (this.penDays) {
            data["penDays"] = {};
            for (let key in this.penDays) {
                if (this.penDays.hasOwnProperty(key))
                    (<any>data["penDays"])[key] = (<any>this.penDays)[key];
            }
        }
        if (this.adjustments) {
            data["adjustments"] = {};
            for (let key in this.adjustments) {
                if (this.adjustments.hasOwnProperty(key))
                    (<any>data["adjustments"])[key] = (<any>this.adjustments)[key];
            }
        }
        return data;
    }
}

export interface ISectionWeanerGraphDTO {
    sectionId?: string | undefined;
    feedUnitsCurve?: { [key: string]: number; } | undefined;
    weights?: { [key: string]: number; } | undefined;
    feedUnitsPerDay?: { [key: string]: number; } | undefined;
    penDays?: { [key: string]: number; } | undefined;
    adjustments?: { [key: string]: AdjustmentDTO[]; } | undefined;
}

export class AdjustmentDTO implements IAdjustmentDTO {
    updates?: ValveGroupHistoryUpdate[] | undefined;
    penId?: string | undefined;
    penName?: string | undefined;
    adjustmentDate?: Date | undefined;

    constructor(data?: IAdjustmentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["updates"])) {
                this.updates = [] as any;
                for (let item of _data["updates"])
                    this.updates!.push(ValveGroupHistoryUpdate.fromJS(item));
            }
            this.penId = _data["penId"];
            this.penName = _data["penName"];
            this.adjustmentDate = _data["adjustmentDate"] ? new Date(_data["adjustmentDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AdjustmentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AdjustmentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.updates)) {
            data["updates"] = [];
            for (let item of this.updates)
                data["updates"].push(item.toJSON());
        }
        data["penId"] = this.penId;
        data["penName"] = this.penName;
        data["adjustmentDate"] = this.adjustmentDate ? this.adjustmentDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAdjustmentDTO {
    updates?: ValveGroupHistoryUpdate[] | undefined;
    penId?: string | undefined;
    penName?: string | undefined;
    adjustmentDate?: Date | undefined;
}

export class ValveGroupHistoryUpdate implements IValveGroupHistoryUpdate {
    property!: ValveGroupHistoryUpdateEnum;
    prevValue?: string | undefined;
    newValue?: string | undefined;

    constructor(data?: IValveGroupHistoryUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.property = _data["property"];
            this.prevValue = _data["prevValue"];
            this.newValue = _data["newValue"];
        }
    }

    static fromJS(data: any): ValveGroupHistoryUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new ValveGroupHistoryUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["property"] = this.property;
        data["prevValue"] = this.prevValue;
        data["newValue"] = this.newValue;
        return data;
    }
}

export interface IValveGroupHistoryUpdate {
    property: ValveGroupHistoryUpdateEnum;
    prevValue?: string | undefined;
    newValue?: string | undefined;
}

export enum ValveGroupHistoryUpdateEnum {
    ConstantDeviation = "ConstantDeviation",
    Deviation = "Deviation",
    DeviationDays = "DeviationDays",
    FeedingCurve = "FeedingCurve",
    SowCycle = "SowCycle",
    PenDays = "PenDays",
    PigCount = "PigCount",
    Weight = "Weight",
    PigletCount = "PigletCount",
}

export class PenFeedUsageDTO implements IPenFeedUsageDTO {
    penId?: string | undefined;
    sectionId?: string | undefined;
    penName?: string | undefined;
    weight!: number;
    penDays!: number;
    curveRation!: number;
    curveRecept?: string | undefined;
    feedPerPigToday!: number;
    feedUnitPrDay?: { [key: string]: number; } | undefined;

    constructor(data?: IPenFeedUsageDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.penId = _data["penId"];
            this.sectionId = _data["sectionId"];
            this.penName = _data["penName"];
            this.weight = _data["weight"];
            this.penDays = _data["penDays"];
            this.curveRation = _data["curveRation"];
            this.curveRecept = _data["curveRecept"];
            this.feedPerPigToday = _data["feedPerPigToday"];
            if (_data["feedUnitPrDay"]) {
                this.feedUnitPrDay = {} as any;
                for (let key in _data["feedUnitPrDay"]) {
                    if (_data["feedUnitPrDay"].hasOwnProperty(key))
                        (<any>this.feedUnitPrDay)![key] = _data["feedUnitPrDay"][key];
                }
            }
        }
    }

    static fromJS(data: any): PenFeedUsageDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PenFeedUsageDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["penId"] = this.penId;
        data["sectionId"] = this.sectionId;
        data["penName"] = this.penName;
        data["weight"] = this.weight;
        data["penDays"] = this.penDays;
        data["curveRation"] = this.curveRation;
        data["curveRecept"] = this.curveRecept;
        data["feedPerPigToday"] = this.feedPerPigToday;
        if (this.feedUnitPrDay) {
            data["feedUnitPrDay"] = {};
            for (let key in this.feedUnitPrDay) {
                if (this.feedUnitPrDay.hasOwnProperty(key))
                    (<any>data["feedUnitPrDay"])[key] = (<any>this.feedUnitPrDay)[key];
            }
        }
        return data;
    }
}

export interface IPenFeedUsageDTO {
    penId?: string | undefined;
    sectionId?: string | undefined;
    penName?: string | undefined;
    weight: number;
    penDays: number;
    curveRation: number;
    curveRecept?: string | undefined;
    feedPerPigToday: number;
    feedUnitPrDay?: { [key: string]: number; } | undefined;
}

export class PenGraphDTO implements IPenGraphDTO {
    penId?: string | undefined;
    penName?: string | undefined;
    feedUnitsCurve?: { [key: string]: number; } | undefined;
    weights?: { [key: string]: number; } | undefined;
    feedUnitsPerDay?: { [key: string]: number; } | undefined;
    penDays?: { [key: string]: number; } | undefined;
    adjustments?: { [key: string]: AdjustmentDTO[]; } | undefined;

    constructor(data?: IPenGraphDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.penId = _data["penId"];
            this.penName = _data["penName"];
            if (_data["feedUnitsCurve"]) {
                this.feedUnitsCurve = {} as any;
                for (let key in _data["feedUnitsCurve"]) {
                    if (_data["feedUnitsCurve"].hasOwnProperty(key))
                        (<any>this.feedUnitsCurve)![key] = _data["feedUnitsCurve"][key];
                }
            }
            if (_data["weights"]) {
                this.weights = {} as any;
                for (let key in _data["weights"]) {
                    if (_data["weights"].hasOwnProperty(key))
                        (<any>this.weights)![key] = _data["weights"][key];
                }
            }
            if (_data["feedUnitsPerDay"]) {
                this.feedUnitsPerDay = {} as any;
                for (let key in _data["feedUnitsPerDay"]) {
                    if (_data["feedUnitsPerDay"].hasOwnProperty(key))
                        (<any>this.feedUnitsPerDay)![key] = _data["feedUnitsPerDay"][key];
                }
            }
            if (_data["penDays"]) {
                this.penDays = {} as any;
                for (let key in _data["penDays"]) {
                    if (_data["penDays"].hasOwnProperty(key))
                        (<any>this.penDays)![key] = _data["penDays"][key];
                }
            }
            if (_data["adjustments"]) {
                this.adjustments = {} as any;
                for (let key in _data["adjustments"]) {
                    if (_data["adjustments"].hasOwnProperty(key))
                        (<any>this.adjustments)![key] = _data["adjustments"][key] ? _data["adjustments"][key].map((i: any) => AdjustmentDTO.fromJS(i)) : [];
                }
            }
        }
    }

    static fromJS(data: any): PenGraphDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PenGraphDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["penId"] = this.penId;
        data["penName"] = this.penName;
        if (this.feedUnitsCurve) {
            data["feedUnitsCurve"] = {};
            for (let key in this.feedUnitsCurve) {
                if (this.feedUnitsCurve.hasOwnProperty(key))
                    (<any>data["feedUnitsCurve"])[key] = (<any>this.feedUnitsCurve)[key];
            }
        }
        if (this.weights) {
            data["weights"] = {};
            for (let key in this.weights) {
                if (this.weights.hasOwnProperty(key))
                    (<any>data["weights"])[key] = (<any>this.weights)[key];
            }
        }
        if (this.feedUnitsPerDay) {
            data["feedUnitsPerDay"] = {};
            for (let key in this.feedUnitsPerDay) {
                if (this.feedUnitsPerDay.hasOwnProperty(key))
                    (<any>data["feedUnitsPerDay"])[key] = (<any>this.feedUnitsPerDay)[key];
            }
        }
        if (this.penDays) {
            data["penDays"] = {};
            for (let key in this.penDays) {
                if (this.penDays.hasOwnProperty(key))
                    (<any>data["penDays"])[key] = (<any>this.penDays)[key];
            }
        }
        if (this.adjustments) {
            data["adjustments"] = {};
            for (let key in this.adjustments) {
                if (this.adjustments.hasOwnProperty(key))
                    (<any>data["adjustments"])[key] = (<any>this.adjustments)[key];
            }
        }
        return data;
    }
}

export interface IPenGraphDTO {
    penId?: string | undefined;
    penName?: string | undefined;
    feedUnitsCurve?: { [key: string]: number; } | undefined;
    weights?: { [key: string]: number; } | undefined;
    feedUnitsPerDay?: { [key: string]: number; } | undefined;
    penDays?: { [key: string]: number; } | undefined;
    adjustments?: { [key: string]: AdjustmentDTO[]; } | undefined;
}

export class GeneralSettings extends SiteEntity implements IGeneralSettings {
    defaultWeightWeaning!: number;
    stemAnimalShowMomDadData!: boolean;
    stemAnimalShowFamilyTree!: boolean;
    stemAnimalShowInitials!: boolean;
    minAgeInDaysAtFirstMating!: number;
    maxDaysAfterBoarDepartureSemen!: number;
    farrowingShowAliveFemales!: boolean;
    farrowingShowAliveMales!: boolean;
    farrowingShowRaceOnLitter!: boolean;
    farrowingRegisterLitterWeight!: boolean;
    farrowingRegisterMumifiedPigs!: boolean;
    farrowingYoungAnimalsPenId?: string | undefined;
    farrowingYoungAnimalsSectionId?: string | undefined;
    registerEarNotch!: boolean;
    startWeekDay?: DayOfWeek | undefined;
    calculateEarNotch!: boolean;
    assignNumbersToBornPiglets!: boolean;
    weanedPenId?: string | undefined;
    weanedSectionId?: string | undefined;
    handleRetentionTime!: boolean;
    usePrivateSlaughterhouse!: boolean;
    registerIdForGpeDeparture!: boolean;
    useLettersForAnimalNumber!: boolean;
    useLettersForBoarNumber!: boolean;
    showRaceLine!: boolean;
    registerIdForTurnoverPoolYoungAnimals!: boolean;
    sendDataToDistriwinWeaner!: boolean;
    sendDataToDistriwinFinisher!: boolean;
    fetchDistriwinFeeding!: boolean;
    distriwinFeedUnitType!: DistriwinFeedUnitType;
    showFuOrKgSow!: FuOrKg;
    showFuOrKgWeaner!: FuOrKg;
    showFuOrKgFinisher!: FuOrKg;
    feedAttactedToRecipe!: boolean;
    sendEntranceDepartureDistriwinWeaner!: boolean;
    sendEntranceDepartureDistriwinFinisher!: boolean;
    notifyCapacityWeaner?: number | undefined;
    sendEntranceDepartureDistriwinSows!: boolean;
    sendSowCycleDistriwinSows!: boolean;
    distriwinNotifyCapacityMatingLocations?: number | undefined;
    distriwinNotifyCapacityPregnantLocations?: number | undefined;
    distriwinNotifyCapacityFarrowingLocations?: number | undefined;
    sendCycleDaysAsNegativeForPregnantSows!: boolean;
    enableDistriwinPenUpdate!: boolean;
    distriwinValveCycleDaysCalculationMethod!: ValveCycleDaysCalculationMethod;
    sendCycleDaysAsNegative!: boolean;
    notifyCapacityFinisher?: number | undefined;
    elistarEsfAdjustFeedFixedDeviation!: boolean;
    elistarEsfAdjustTempFeedAndPeriodDevation!: boolean;
    resendCycleDaysElistar!: boolean;
    reader?: ESFReader | undefined;
    segesInsightConsent!: boolean;

    constructor(data?: IGeneralSettings) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.defaultWeightWeaning = _data["defaultWeightWeaning"];
            this.stemAnimalShowMomDadData = _data["stemAnimalShowMomDadData"];
            this.stemAnimalShowFamilyTree = _data["stemAnimalShowFamilyTree"];
            this.stemAnimalShowInitials = _data["stemAnimalShowInitials"];
            this.minAgeInDaysAtFirstMating = _data["minAgeInDaysAtFirstMating"];
            this.maxDaysAfterBoarDepartureSemen = _data["maxDaysAfterBoarDepartureSemen"];
            this.farrowingShowAliveFemales = _data["farrowingShowAliveFemales"];
            this.farrowingShowAliveMales = _data["farrowingShowAliveMales"];
            this.farrowingShowRaceOnLitter = _data["farrowingShowRaceOnLitter"];
            this.farrowingRegisterLitterWeight = _data["farrowingRegisterLitterWeight"];
            this.farrowingRegisterMumifiedPigs = _data["farrowingRegisterMumifiedPigs"];
            this.farrowingYoungAnimalsPenId = _data["farrowingYoungAnimalsPenId"];
            this.farrowingYoungAnimalsSectionId = _data["farrowingYoungAnimalsSectionId"];
            this.registerEarNotch = _data["registerEarNotch"];
            this.startWeekDay = _data["startWeekDay"];
            this.calculateEarNotch = _data["calculateEarNotch"];
            this.assignNumbersToBornPiglets = _data["assignNumbersToBornPiglets"];
            this.weanedPenId = _data["weanedPenId"];
            this.weanedSectionId = _data["weanedSectionId"];
            this.handleRetentionTime = _data["handleRetentionTime"];
            this.usePrivateSlaughterhouse = _data["usePrivateSlaughterhouse"];
            this.registerIdForGpeDeparture = _data["registerIdForGpeDeparture"];
            this.useLettersForAnimalNumber = _data["useLettersForAnimalNumber"];
            this.useLettersForBoarNumber = _data["useLettersForBoarNumber"];
            this.showRaceLine = _data["showRaceLine"];
            this.registerIdForTurnoverPoolYoungAnimals = _data["registerIdForTurnoverPoolYoungAnimals"];
            this.sendDataToDistriwinWeaner = _data["sendDataToDistriwinWeaner"];
            this.sendDataToDistriwinFinisher = _data["sendDataToDistriwinFinisher"];
            this.fetchDistriwinFeeding = _data["fetchDistriwinFeeding"];
            this.distriwinFeedUnitType = _data["distriwinFeedUnitType"];
            this.showFuOrKgSow = _data["showFuOrKgSow"];
            this.showFuOrKgWeaner = _data["showFuOrKgWeaner"];
            this.showFuOrKgFinisher = _data["showFuOrKgFinisher"];
            this.feedAttactedToRecipe = _data["feedAttactedToRecipe"];
            this.sendEntranceDepartureDistriwinWeaner = _data["sendEntranceDepartureDistriwinWeaner"];
            this.sendEntranceDepartureDistriwinFinisher = _data["sendEntranceDepartureDistriwinFinisher"];
            this.notifyCapacityWeaner = _data["notifyCapacityWeaner"];
            this.sendEntranceDepartureDistriwinSows = _data["sendEntranceDepartureDistriwinSows"];
            this.sendSowCycleDistriwinSows = _data["sendSowCycleDistriwinSows"];
            this.distriwinNotifyCapacityMatingLocations = _data["distriwinNotifyCapacityMatingLocations"];
            this.distriwinNotifyCapacityPregnantLocations = _data["distriwinNotifyCapacityPregnantLocations"];
            this.distriwinNotifyCapacityFarrowingLocations = _data["distriwinNotifyCapacityFarrowingLocations"];
            this.sendCycleDaysAsNegativeForPregnantSows = _data["sendCycleDaysAsNegativeForPregnantSows"];
            this.enableDistriwinPenUpdate = _data["enableDistriwinPenUpdate"];
            this.distriwinValveCycleDaysCalculationMethod = _data["distriwinValveCycleDaysCalculationMethod"];
            this.sendCycleDaysAsNegative = _data["sendCycleDaysAsNegative"];
            this.notifyCapacityFinisher = _data["notifyCapacityFinisher"];
            this.elistarEsfAdjustFeedFixedDeviation = _data["elistarEsfAdjustFeedFixedDeviation"];
            this.elistarEsfAdjustTempFeedAndPeriodDevation = _data["elistarEsfAdjustTempFeedAndPeriodDevation"];
            this.resendCycleDaysElistar = _data["resendCycleDaysElistar"];
            this.reader = _data["reader"];
            this.segesInsightConsent = _data["segesInsightConsent"];
        }
    }

    static override fromJS(data: any): GeneralSettings {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralSettings();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultWeightWeaning"] = this.defaultWeightWeaning;
        data["stemAnimalShowMomDadData"] = this.stemAnimalShowMomDadData;
        data["stemAnimalShowFamilyTree"] = this.stemAnimalShowFamilyTree;
        data["stemAnimalShowInitials"] = this.stemAnimalShowInitials;
        data["minAgeInDaysAtFirstMating"] = this.minAgeInDaysAtFirstMating;
        data["maxDaysAfterBoarDepartureSemen"] = this.maxDaysAfterBoarDepartureSemen;
        data["farrowingShowAliveFemales"] = this.farrowingShowAliveFemales;
        data["farrowingShowAliveMales"] = this.farrowingShowAliveMales;
        data["farrowingShowRaceOnLitter"] = this.farrowingShowRaceOnLitter;
        data["farrowingRegisterLitterWeight"] = this.farrowingRegisterLitterWeight;
        data["farrowingRegisterMumifiedPigs"] = this.farrowingRegisterMumifiedPigs;
        data["farrowingYoungAnimalsPenId"] = this.farrowingYoungAnimalsPenId;
        data["farrowingYoungAnimalsSectionId"] = this.farrowingYoungAnimalsSectionId;
        data["registerEarNotch"] = this.registerEarNotch;
        data["startWeekDay"] = this.startWeekDay;
        data["calculateEarNotch"] = this.calculateEarNotch;
        data["assignNumbersToBornPiglets"] = this.assignNumbersToBornPiglets;
        data["weanedPenId"] = this.weanedPenId;
        data["weanedSectionId"] = this.weanedSectionId;
        data["handleRetentionTime"] = this.handleRetentionTime;
        data["usePrivateSlaughterhouse"] = this.usePrivateSlaughterhouse;
        data["registerIdForGpeDeparture"] = this.registerIdForGpeDeparture;
        data["useLettersForAnimalNumber"] = this.useLettersForAnimalNumber;
        data["useLettersForBoarNumber"] = this.useLettersForBoarNumber;
        data["showRaceLine"] = this.showRaceLine;
        data["registerIdForTurnoverPoolYoungAnimals"] = this.registerIdForTurnoverPoolYoungAnimals;
        data["sendDataToDistriwinWeaner"] = this.sendDataToDistriwinWeaner;
        data["sendDataToDistriwinFinisher"] = this.sendDataToDistriwinFinisher;
        data["fetchDistriwinFeeding"] = this.fetchDistriwinFeeding;
        data["distriwinFeedUnitType"] = this.distriwinFeedUnitType;
        data["showFuOrKgSow"] = this.showFuOrKgSow;
        data["showFuOrKgWeaner"] = this.showFuOrKgWeaner;
        data["showFuOrKgFinisher"] = this.showFuOrKgFinisher;
        data["feedAttactedToRecipe"] = this.feedAttactedToRecipe;
        data["sendEntranceDepartureDistriwinWeaner"] = this.sendEntranceDepartureDistriwinWeaner;
        data["sendEntranceDepartureDistriwinFinisher"] = this.sendEntranceDepartureDistriwinFinisher;
        data["notifyCapacityWeaner"] = this.notifyCapacityWeaner;
        data["sendEntranceDepartureDistriwinSows"] = this.sendEntranceDepartureDistriwinSows;
        data["sendSowCycleDistriwinSows"] = this.sendSowCycleDistriwinSows;
        data["distriwinNotifyCapacityMatingLocations"] = this.distriwinNotifyCapacityMatingLocations;
        data["distriwinNotifyCapacityPregnantLocations"] = this.distriwinNotifyCapacityPregnantLocations;
        data["distriwinNotifyCapacityFarrowingLocations"] = this.distriwinNotifyCapacityFarrowingLocations;
        data["sendCycleDaysAsNegativeForPregnantSows"] = this.sendCycleDaysAsNegativeForPregnantSows;
        data["enableDistriwinPenUpdate"] = this.enableDistriwinPenUpdate;
        data["distriwinValveCycleDaysCalculationMethod"] = this.distriwinValveCycleDaysCalculationMethod;
        data["sendCycleDaysAsNegative"] = this.sendCycleDaysAsNegative;
        data["notifyCapacityFinisher"] = this.notifyCapacityFinisher;
        data["elistarEsfAdjustFeedFixedDeviation"] = this.elistarEsfAdjustFeedFixedDeviation;
        data["elistarEsfAdjustTempFeedAndPeriodDevation"] = this.elistarEsfAdjustTempFeedAndPeriodDevation;
        data["resendCycleDaysElistar"] = this.resendCycleDaysElistar;
        data["reader"] = this.reader;
        data["segesInsightConsent"] = this.segesInsightConsent;
        super.toJSON(data);
        return data;
    }
}

export interface IGeneralSettings extends ISiteEntity {
    defaultWeightWeaning: number;
    stemAnimalShowMomDadData: boolean;
    stemAnimalShowFamilyTree: boolean;
    stemAnimalShowInitials: boolean;
    minAgeInDaysAtFirstMating: number;
    maxDaysAfterBoarDepartureSemen: number;
    farrowingShowAliveFemales: boolean;
    farrowingShowAliveMales: boolean;
    farrowingShowRaceOnLitter: boolean;
    farrowingRegisterLitterWeight: boolean;
    farrowingRegisterMumifiedPigs: boolean;
    farrowingYoungAnimalsPenId?: string | undefined;
    farrowingYoungAnimalsSectionId?: string | undefined;
    registerEarNotch: boolean;
    startWeekDay?: DayOfWeek | undefined;
    calculateEarNotch: boolean;
    assignNumbersToBornPiglets: boolean;
    weanedPenId?: string | undefined;
    weanedSectionId?: string | undefined;
    handleRetentionTime: boolean;
    usePrivateSlaughterhouse: boolean;
    registerIdForGpeDeparture: boolean;
    useLettersForAnimalNumber: boolean;
    useLettersForBoarNumber: boolean;
    showRaceLine: boolean;
    registerIdForTurnoverPoolYoungAnimals: boolean;
    sendDataToDistriwinWeaner: boolean;
    sendDataToDistriwinFinisher: boolean;
    fetchDistriwinFeeding: boolean;
    distriwinFeedUnitType: DistriwinFeedUnitType;
    showFuOrKgSow: FuOrKg;
    showFuOrKgWeaner: FuOrKg;
    showFuOrKgFinisher: FuOrKg;
    feedAttactedToRecipe: boolean;
    sendEntranceDepartureDistriwinWeaner: boolean;
    sendEntranceDepartureDistriwinFinisher: boolean;
    notifyCapacityWeaner?: number | undefined;
    sendEntranceDepartureDistriwinSows: boolean;
    sendSowCycleDistriwinSows: boolean;
    distriwinNotifyCapacityMatingLocations?: number | undefined;
    distriwinNotifyCapacityPregnantLocations?: number | undefined;
    distriwinNotifyCapacityFarrowingLocations?: number | undefined;
    sendCycleDaysAsNegativeForPregnantSows: boolean;
    enableDistriwinPenUpdate: boolean;
    distriwinValveCycleDaysCalculationMethod: ValveCycleDaysCalculationMethod;
    sendCycleDaysAsNegative: boolean;
    notifyCapacityFinisher?: number | undefined;
    elistarEsfAdjustFeedFixedDeviation: boolean;
    elistarEsfAdjustTempFeedAndPeriodDevation: boolean;
    resendCycleDaysElistar: boolean;
    reader?: ESFReader | undefined;
    segesInsightConsent: boolean;
}

export enum DayOfWeek {
    Sunday = "Sunday",
    Monday = "Monday",
    Tuesday = "Tuesday",
    Wednesday = "Wednesday",
    Thursday = "Thursday",
    Friday = "Friday",
    Saturday = "Saturday",
}

export enum DistriwinFeedUnitType {
    FE = "FE",
    MJ = "MJ",
    KCAL = "KCAL",
    FEsoFEsv = "FEsoFEsv",
}

export enum FuOrKg {
    Fu = "Fu",
    Kg = "Kg",
}

export enum ValveCycleDaysCalculationMethod {
    Avg = "Avg",
    Min = "Min",
    Max = "Max",
}

export enum ESFReader {
    AWR250StickReader = "AWR250StickReader",
    AWR300StickReader = "AWR300StickReader",
}

export class SyncGeneralSettings implements ISyncGeneralSettings {
    syncTime!: Date;
    datas?: GeneralSettings | undefined;

    constructor(data?: ISyncGeneralSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.syncTime = _data["syncTime"] ? new Date(_data["syncTime"].toString()) : <any>undefined;
            this.datas = _data["datas"] ? GeneralSettings.fromJS(_data["datas"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SyncGeneralSettings {
        data = typeof data === 'object' ? data : {};
        let result = new SyncGeneralSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["syncTime"] = this.syncTime ? this.syncTime.toISOString() : <any>undefined;
        data["datas"] = this.datas ? this.datas.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISyncGeneralSettings {
    syncTime: Date;
    datas?: GeneralSettings | undefined;
}

export class SowBoardTableModel implements ISowBoardTableModel {
    race?: string | undefined;
    location?: string | undefined;
    batch?: string | undefined;
    idNr?: string | undefined;
    farrowingDateShort?: string | undefined;
    animalNumber?: string | undefined;
    teats?: number | undefined;
    butcherQuarantine?: string | undefined;
    comment?: string | undefined;
    index?: number | undefined;
    pregnancyTableModel?: PregnancyTableModel[] | undefined;
    treatmentTableModel?: TreatmentTableModel[] | undefined;

    constructor(data?: ISowBoardTableModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.race = _data["race"];
            this.location = _data["location"];
            this.batch = _data["batch"];
            this.idNr = _data["idNr"];
            this.farrowingDateShort = _data["farrowingDateShort"];
            this.animalNumber = _data["animalNumber"];
            this.teats = _data["teats"];
            this.butcherQuarantine = _data["butcherQuarantine"];
            this.comment = _data["comment"];
            this.index = _data["index"];
            if (Array.isArray(_data["pregnancyTableModel"])) {
                this.pregnancyTableModel = [] as any;
                for (let item of _data["pregnancyTableModel"])
                    this.pregnancyTableModel!.push(PregnancyTableModel.fromJS(item));
            }
            if (Array.isArray(_data["treatmentTableModel"])) {
                this.treatmentTableModel = [] as any;
                for (let item of _data["treatmentTableModel"])
                    this.treatmentTableModel!.push(TreatmentTableModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SowBoardTableModel {
        data = typeof data === 'object' ? data : {};
        let result = new SowBoardTableModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["race"] = this.race;
        data["location"] = this.location;
        data["batch"] = this.batch;
        data["idNr"] = this.idNr;
        data["farrowingDateShort"] = this.farrowingDateShort;
        data["animalNumber"] = this.animalNumber;
        data["teats"] = this.teats;
        data["butcherQuarantine"] = this.butcherQuarantine;
        data["comment"] = this.comment;
        data["index"] = this.index;
        if (Array.isArray(this.pregnancyTableModel)) {
            data["pregnancyTableModel"] = [];
            for (let item of this.pregnancyTableModel)
                data["pregnancyTableModel"].push(item.toJSON());
        }
        if (Array.isArray(this.treatmentTableModel)) {
            data["treatmentTableModel"] = [];
            for (let item of this.treatmentTableModel)
                data["treatmentTableModel"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISowBoardTableModel {
    race?: string | undefined;
    location?: string | undefined;
    batch?: string | undefined;
    idNr?: string | undefined;
    farrowingDateShort?: string | undefined;
    animalNumber?: string | undefined;
    teats?: number | undefined;
    butcherQuarantine?: string | undefined;
    comment?: string | undefined;
    index?: number | undefined;
    pregnancyTableModel?: PregnancyTableModel[] | undefined;
    treatmentTableModel?: TreatmentTableModel[] | undefined;
}

export class PregnancyTableModel implements IPregnancyTableModel {
    abortion!: boolean;
    boar?: string | undefined;
    farrowingDate?: string | undefined;
    farrowingId?: string | undefined;
    hasFarrowing!: boolean;
    isEditable!: boolean;
    isNursingSow!: boolean;
    k?: string | undefined;
    litter?: string | undefined;
    matedId?: string | undefined;
    matingDate?: string | undefined;
    move?: number | undefined;
    numAlive?: number | undefined;
    numDead?: number | undefined;
    mumified?: number | undefined;
    nursingDays?: string | undefined;
    pcs?: number | undefined;
    pigSow?: number | undefined;
    pregnancyDays?: number | undefined;
    pregnant?: string | undefined;
    scannedId?: string | undefined;
    totalDeadPiglets?: number | undefined;
    wasteDays?: number | undefined;
    weaningDate?: string | undefined;
    weaningId?: string | undefined;
    weight?: number | undefined;
    cellColorStyle!: CellColorStyle;

    constructor(data?: IPregnancyTableModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.abortion = _data["abortion"];
            this.boar = _data["boar"];
            this.farrowingDate = _data["farrowingDate"];
            this.farrowingId = _data["farrowingId"];
            this.hasFarrowing = _data["hasFarrowing"];
            this.isEditable = _data["isEditable"];
            this.isNursingSow = _data["isNursingSow"];
            this.k = _data["k"];
            this.litter = _data["litter"];
            this.matedId = _data["matedId"];
            this.matingDate = _data["matingDate"];
            this.move = _data["move"];
            this.numAlive = _data["numAlive"];
            this.numDead = _data["numDead"];
            this.mumified = _data["mumified"];
            this.nursingDays = _data["nursingDays"];
            this.pcs = _data["pcs"];
            this.pigSow = _data["pigSow"];
            this.pregnancyDays = _data["pregnancyDays"];
            this.pregnant = _data["pregnant"];
            this.scannedId = _data["scannedId"];
            this.totalDeadPiglets = _data["totalDeadPiglets"];
            this.wasteDays = _data["wasteDays"];
            this.weaningDate = _data["weaningDate"];
            this.weaningId = _data["weaningId"];
            this.weight = _data["weight"];
            this.cellColorStyle = _data["cellColorStyle"];
        }
    }

    static fromJS(data: any): PregnancyTableModel {
        data = typeof data === 'object' ? data : {};
        let result = new PregnancyTableModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["abortion"] = this.abortion;
        data["boar"] = this.boar;
        data["farrowingDate"] = this.farrowingDate;
        data["farrowingId"] = this.farrowingId;
        data["hasFarrowing"] = this.hasFarrowing;
        data["isEditable"] = this.isEditable;
        data["isNursingSow"] = this.isNursingSow;
        data["k"] = this.k;
        data["litter"] = this.litter;
        data["matedId"] = this.matedId;
        data["matingDate"] = this.matingDate;
        data["move"] = this.move;
        data["numAlive"] = this.numAlive;
        data["numDead"] = this.numDead;
        data["mumified"] = this.mumified;
        data["nursingDays"] = this.nursingDays;
        data["pcs"] = this.pcs;
        data["pigSow"] = this.pigSow;
        data["pregnancyDays"] = this.pregnancyDays;
        data["pregnant"] = this.pregnant;
        data["scannedId"] = this.scannedId;
        data["totalDeadPiglets"] = this.totalDeadPiglets;
        data["wasteDays"] = this.wasteDays;
        data["weaningDate"] = this.weaningDate;
        data["weaningId"] = this.weaningId;
        data["weight"] = this.weight;
        data["cellColorStyle"] = this.cellColorStyle;
        return data;
    }
}

export interface IPregnancyTableModel {
    abortion: boolean;
    boar?: string | undefined;
    farrowingDate?: string | undefined;
    farrowingId?: string | undefined;
    hasFarrowing: boolean;
    isEditable: boolean;
    isNursingSow: boolean;
    k?: string | undefined;
    litter?: string | undefined;
    matedId?: string | undefined;
    matingDate?: string | undefined;
    move?: number | undefined;
    numAlive?: number | undefined;
    numDead?: number | undefined;
    mumified?: number | undefined;
    nursingDays?: string | undefined;
    pcs?: number | undefined;
    pigSow?: number | undefined;
    pregnancyDays?: number | undefined;
    pregnant?: string | undefined;
    scannedId?: string | undefined;
    totalDeadPiglets?: number | undefined;
    wasteDays?: number | undefined;
    weaningDate?: string | undefined;
    weaningId?: string | undefined;
    weight?: number | undefined;
    cellColorStyle: CellColorStyle;
}

export class TreatmentTableModel implements ITreatmentTableModel {
    firstTreatment?: TreatmentModel | undefined;
    secondTreatment?: TreatmentModel | undefined;
    cellColorStyle!: CellColorStyle;

    constructor(data?: ITreatmentTableModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstTreatment = _data["firstTreatment"] ? TreatmentModel.fromJS(_data["firstTreatment"]) : <any>undefined;
            this.secondTreatment = _data["secondTreatment"] ? TreatmentModel.fromJS(_data["secondTreatment"]) : <any>undefined;
            this.cellColorStyle = _data["cellColorStyle"];
        }
    }

    static fromJS(data: any): TreatmentTableModel {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentTableModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstTreatment"] = this.firstTreatment ? this.firstTreatment.toJSON() : <any>undefined;
        data["secondTreatment"] = this.secondTreatment ? this.secondTreatment.toJSON() : <any>undefined;
        data["cellColorStyle"] = this.cellColorStyle;
        return data;
    }
}

export interface ITreatmentTableModel {
    firstTreatment?: TreatmentModel | undefined;
    secondTreatment?: TreatmentModel | undefined;
    cellColorStyle: CellColorStyle;
}

export class TreatmentModel implements ITreatmentModel {
    dateFirstTreatment?: string | undefined;
    diagnose?: string | undefined;
    litter?: string | undefined;

    constructor(data?: ITreatmentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateFirstTreatment = _data["dateFirstTreatment"];
            this.diagnose = _data["diagnose"];
            this.litter = _data["litter"];
        }
    }

    static fromJS(data: any): TreatmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateFirstTreatment"] = this.dateFirstTreatment;
        data["diagnose"] = this.diagnose;
        data["litter"] = this.litter;
        return data;
    }
}

export interface ITreatmentModel {
    dateFirstTreatment?: string | undefined;
    diagnose?: string | undefined;
    litter?: string | undefined;
}

export class GrowthPigsDashboardDto implements IGrowthPigsDashboardDto {
    dailyGain!: number;
    days!: number;
    deadLastSevenDays!: number;
    entryWeight!: number;
    expectedDeliveryAdjust!: number;
    expectedDeliveryDate?: Date | undefined;
    feedCurveWeight!: number;
    feedPerPigCurve!: number;
    feedPerPigToday!: number;
    feedPerPigTotal!: number;
    feedPerPigWeight!: number;
    hasQuarantine!: boolean;
    numOfPig!: number;
    penId?: string | undefined;
    sectionId?: string | undefined;
    treatedLastSevenDays!: number;
    treatedLastSevenDaysOnSection!: number;
    productionType!: AnimalType;
    hasEventsSinceLastTune!: boolean;
    avgDaysToDeparture!: number;
    hasProcessEquipmentData!: boolean;

    constructor(data?: IGrowthPigsDashboardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dailyGain = _data["dailyGain"];
            this.days = _data["days"];
            this.deadLastSevenDays = _data["deadLastSevenDays"];
            this.entryWeight = _data["entryWeight"];
            this.expectedDeliveryAdjust = _data["expectedDeliveryAdjust"];
            this.expectedDeliveryDate = _data["expectedDeliveryDate"] ? new Date(_data["expectedDeliveryDate"].toString()) : <any>undefined;
            this.feedCurveWeight = _data["feedCurveWeight"];
            this.feedPerPigCurve = _data["feedPerPigCurve"];
            this.feedPerPigToday = _data["feedPerPigToday"];
            this.feedPerPigTotal = _data["feedPerPigTotal"];
            this.feedPerPigWeight = _data["feedPerPigWeight"];
            this.hasQuarantine = _data["hasQuarantine"];
            this.numOfPig = _data["numOfPig"];
            this.penId = _data["penId"];
            this.sectionId = _data["sectionId"];
            this.treatedLastSevenDays = _data["treatedLastSevenDays"];
            this.treatedLastSevenDaysOnSection = _data["treatedLastSevenDaysOnSection"];
            this.productionType = _data["productionType"];
            this.hasEventsSinceLastTune = _data["hasEventsSinceLastTune"];
            this.avgDaysToDeparture = _data["avgDaysToDeparture"];
            this.hasProcessEquipmentData = _data["hasProcessEquipmentData"];
        }
    }

    static fromJS(data: any): GrowthPigsDashboardDto {
        data = typeof data === 'object' ? data : {};
        let result = new GrowthPigsDashboardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dailyGain"] = this.dailyGain;
        data["days"] = this.days;
        data["deadLastSevenDays"] = this.deadLastSevenDays;
        data["entryWeight"] = this.entryWeight;
        data["expectedDeliveryAdjust"] = this.expectedDeliveryAdjust;
        data["expectedDeliveryDate"] = this.expectedDeliveryDate ? this.expectedDeliveryDate.toISOString() : <any>undefined;
        data["feedCurveWeight"] = this.feedCurveWeight;
        data["feedPerPigCurve"] = this.feedPerPigCurve;
        data["feedPerPigToday"] = this.feedPerPigToday;
        data["feedPerPigTotal"] = this.feedPerPigTotal;
        data["feedPerPigWeight"] = this.feedPerPigWeight;
        data["hasQuarantine"] = this.hasQuarantine;
        data["numOfPig"] = this.numOfPig;
        data["penId"] = this.penId;
        data["sectionId"] = this.sectionId;
        data["treatedLastSevenDays"] = this.treatedLastSevenDays;
        data["treatedLastSevenDaysOnSection"] = this.treatedLastSevenDaysOnSection;
        data["productionType"] = this.productionType;
        data["hasEventsSinceLastTune"] = this.hasEventsSinceLastTune;
        data["avgDaysToDeparture"] = this.avgDaysToDeparture;
        data["hasProcessEquipmentData"] = this.hasProcessEquipmentData;
        return data;
    }
}

export interface IGrowthPigsDashboardDto {
    dailyGain: number;
    days: number;
    deadLastSevenDays: number;
    entryWeight: number;
    expectedDeliveryAdjust: number;
    expectedDeliveryDate?: Date | undefined;
    feedCurveWeight: number;
    feedPerPigCurve: number;
    feedPerPigToday: number;
    feedPerPigTotal: number;
    feedPerPigWeight: number;
    hasQuarantine: boolean;
    numOfPig: number;
    penId?: string | undefined;
    sectionId?: string | undefined;
    treatedLastSevenDays: number;
    treatedLastSevenDaysOnSection: number;
    productionType: AnimalType;
    hasEventsSinceLastTune: boolean;
    avgDaysToDeparture: number;
    hasProcessEquipmentData: boolean;
}

export class DashboardEntranceDepartureTableItem implements IDashboardEntranceDepartureTableItem {
    totalSummaryEntered?: string | undefined;
    totalSummaryDeparted?: string | undefined;
    entered?: DashboardElaborationTableItem[] | undefined;
    departed?: DashboardElaborationTableItem[] | undefined;

    constructor(data?: IDashboardEntranceDepartureTableItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalSummaryEntered = _data["totalSummaryEntered"];
            this.totalSummaryDeparted = _data["totalSummaryDeparted"];
            if (Array.isArray(_data["entered"])) {
                this.entered = [] as any;
                for (let item of _data["entered"])
                    this.entered!.push(DashboardElaborationTableItem.fromJS(item));
            }
            if (Array.isArray(_data["departed"])) {
                this.departed = [] as any;
                for (let item of _data["departed"])
                    this.departed!.push(DashboardElaborationTableItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DashboardEntranceDepartureTableItem {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardEntranceDepartureTableItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalSummaryEntered"] = this.totalSummaryEntered;
        data["totalSummaryDeparted"] = this.totalSummaryDeparted;
        if (Array.isArray(this.entered)) {
            data["entered"] = [];
            for (let item of this.entered)
                data["entered"].push(item.toJSON());
        }
        if (Array.isArray(this.departed)) {
            data["departed"] = [];
            for (let item of this.departed)
                data["departed"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDashboardEntranceDepartureTableItem {
    totalSummaryEntered?: string | undefined;
    totalSummaryDeparted?: string | undefined;
    entered?: DashboardElaborationTableItem[] | undefined;
    departed?: DashboardElaborationTableItem[] | undefined;
}

export abstract class PdfTableCellItemsWithDefinedWidths implements IPdfTableCellItemsWithDefinedWidths {
    cellColorStyle!: CellColorStyle;

    constructor(data?: IPdfTableCellItemsWithDefinedWidths) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cellColorStyle = _data["cellColorStyle"];
        }
    }

    static fromJS(data: any): PdfTableCellItemsWithDefinedWidths {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'PdfTableCellItemsWithDefinedWidths' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cellColorStyle"] = this.cellColorStyle;
        return data;
    }
}

export interface IPdfTableCellItemsWithDefinedWidths {
    cellColorStyle: CellColorStyle;
}

export class DashboardElaborationTableItem extends PdfTableCellItemsWithDefinedWidths implements IDashboardElaborationTableItem {
    gpeEventType?: string | undefined;
    dateString?: string | undefined;
    pigCount?: string | undefined;
    totalWeight?: string | undefined;
    avgWeight?: string | undefined;
    isSummaryRow!: boolean;
    isExpanded!: boolean;

    constructor(data?: IDashboardElaborationTableItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.gpeEventType = _data["gpeEventType"];
            this.dateString = _data["dateString"];
            this.pigCount = _data["pigCount"];
            this.totalWeight = _data["totalWeight"];
            this.avgWeight = _data["avgWeight"];
            this.isSummaryRow = _data["isSummaryRow"];
            this.isExpanded = _data["isExpanded"];
        }
    }

    static override fromJS(data: any): DashboardElaborationTableItem {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardElaborationTableItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gpeEventType"] = this.gpeEventType;
        data["dateString"] = this.dateString;
        data["pigCount"] = this.pigCount;
        data["totalWeight"] = this.totalWeight;
        data["avgWeight"] = this.avgWeight;
        data["isSummaryRow"] = this.isSummaryRow;
        data["isExpanded"] = this.isExpanded;
        super.toJSON(data);
        return data;
    }
}

export interface IDashboardElaborationTableItem extends IPdfTableCellItemsWithDefinedWidths {
    gpeEventType?: string | undefined;
    dateString?: string | undefined;
    pigCount?: string | undefined;
    totalWeight?: string | undefined;
    avgWeight?: string | undefined;
    isSummaryRow: boolean;
    isExpanded: boolean;
}

export class GrowthPigEventDto implements IGrowthPigEventDto {
    hasQuarantine!: boolean;
    sectionId?: string | undefined;
    isDeleted!: boolean;
    growthPigEventDistributions?: GrowthPigEventDistribution[] | undefined;
    productionType!: AnimalType;
    bundleIdentifier?: string | undefined;

    constructor(data?: IGrowthPigEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasQuarantine = _data["hasQuarantine"];
            this.sectionId = _data["sectionId"];
            this.isDeleted = _data["isDeleted"];
            if (Array.isArray(_data["growthPigEventDistributions"])) {
                this.growthPigEventDistributions = [] as any;
                for (let item of _data["growthPigEventDistributions"])
                    this.growthPigEventDistributions!.push(GrowthPigEventDistribution.fromJS(item));
            }
            this.productionType = _data["productionType"];
            this.bundleIdentifier = _data["bundleIdentifier"];
        }
    }

    static fromJS(data: any): GrowthPigEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new GrowthPigEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasQuarantine"] = this.hasQuarantine;
        data["sectionId"] = this.sectionId;
        data["isDeleted"] = this.isDeleted;
        if (Array.isArray(this.growthPigEventDistributions)) {
            data["growthPigEventDistributions"] = [];
            for (let item of this.growthPigEventDistributions)
                data["growthPigEventDistributions"].push(item.toJSON());
        }
        data["productionType"] = this.productionType;
        data["bundleIdentifier"] = this.bundleIdentifier;
        return data;
    }
}

export interface IGrowthPigEventDto {
    hasQuarantine: boolean;
    sectionId?: string | undefined;
    isDeleted: boolean;
    growthPigEventDistributions?: GrowthPigEventDistribution[] | undefined;
    productionType: AnimalType;
    bundleIdentifier?: string | undefined;
}

export class GrowthPigEventDistribution implements IGrowthPigEventDistribution {
    date?: Date | undefined;
    retentionDate?: Date | undefined;
    hasQuarantine?: boolean | undefined;
    penId?: string | undefined;
    growthPigEventId?: string | undefined;
    amount!: number;
    createdOn?: Date | undefined;
    totalWeight?: number | undefined;
    totalWeightCurve?: number | undefined;
    productionType!: AnimalType;
    isSameProduction?: boolean | undefined;
    growthPigEventType!: GrowthPigEventType;

    constructor(data?: IGrowthPigEventDistribution) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.retentionDate = _data["retentionDate"] ? new Date(_data["retentionDate"].toString()) : <any>undefined;
            this.hasQuarantine = _data["hasQuarantine"];
            this.penId = _data["penId"];
            this.growthPigEventId = _data["growthPigEventId"];
            this.amount = _data["amount"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.totalWeight = _data["totalWeight"];
            this.totalWeightCurve = _data["totalWeightCurve"];
            this.productionType = _data["productionType"];
            this.isSameProduction = _data["isSameProduction"];
            this.growthPigEventType = _data["growthPigEventType"];
        }
    }

    static fromJS(data: any): GrowthPigEventDistribution {
        data = typeof data === 'object' ? data : {};
        let result = new GrowthPigEventDistribution();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["retentionDate"] = this.retentionDate ? this.retentionDate.toISOString() : <any>undefined;
        data["hasQuarantine"] = this.hasQuarantine;
        data["penId"] = this.penId;
        data["growthPigEventId"] = this.growthPigEventId;
        data["amount"] = this.amount;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["totalWeight"] = this.totalWeight;
        data["totalWeightCurve"] = this.totalWeightCurve;
        data["productionType"] = this.productionType;
        data["isSameProduction"] = this.isSameProduction;
        data["growthPigEventType"] = this.growthPigEventType;
        return data;
    }
}

export interface IGrowthPigEventDistribution {
    date?: Date | undefined;
    retentionDate?: Date | undefined;
    hasQuarantine?: boolean | undefined;
    penId?: string | undefined;
    growthPigEventId?: string | undefined;
    amount: number;
    createdOn?: Date | undefined;
    totalWeight?: number | undefined;
    totalWeightCurve?: number | undefined;
    productionType: AnimalType;
    isSameProduction?: boolean | undefined;
    growthPigEventType: GrowthPigEventType;
}

export class GrowthPigEntranceEventDto extends SiteEntity implements IGrowthPigEntranceEventDto {
    name?: string | undefined;
    date!: Date;
    retentionDate?: Date | undefined;
    toBuildingId?: string | undefined;
    toSectionId?: string | undefined;
    toPenId?: string | undefined;
    toProductionType!: AnimalType;
    correctToProductionType!: AnimalType;
    amount!: number;
    avgWeight!: number;
    totalWeight!: number;
    growthPigEventType!: GrowthPigEventType;
    bundleIdentifier?: string | undefined;
    feedCurve?: number | undefined;
    recipe?: number | undefined;

    constructor(data?: IGrowthPigEntranceEventDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.retentionDate = _data["retentionDate"] ? new Date(_data["retentionDate"].toString()) : <any>undefined;
            this.toBuildingId = _data["toBuildingId"];
            this.toSectionId = _data["toSectionId"];
            this.toPenId = _data["toPenId"];
            this.toProductionType = _data["toProductionType"];
            this.correctToProductionType = _data["correctToProductionType"];
            this.amount = _data["amount"];
            this.avgWeight = _data["avgWeight"];
            this.totalWeight = _data["totalWeight"];
            this.growthPigEventType = _data["growthPigEventType"];
            this.bundleIdentifier = _data["bundleIdentifier"];
            this.feedCurve = _data["feedCurve"];
            this.recipe = _data["recipe"];
        }
    }

    static override fromJS(data: any): GrowthPigEntranceEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new GrowthPigEntranceEventDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["retentionDate"] = this.retentionDate ? this.retentionDate.toISOString() : <any>undefined;
        data["toBuildingId"] = this.toBuildingId;
        data["toSectionId"] = this.toSectionId;
        data["toPenId"] = this.toPenId;
        data["toProductionType"] = this.toProductionType;
        data["correctToProductionType"] = this.correctToProductionType;
        data["amount"] = this.amount;
        data["avgWeight"] = this.avgWeight;
        data["totalWeight"] = this.totalWeight;
        data["growthPigEventType"] = this.growthPigEventType;
        data["bundleIdentifier"] = this.bundleIdentifier;
        data["feedCurve"] = this.feedCurve;
        data["recipe"] = this.recipe;
        super.toJSON(data);
        return data;
    }
}

export interface IGrowthPigEntranceEventDto extends ISiteEntity {
    name?: string | undefined;
    date: Date;
    retentionDate?: Date | undefined;
    toBuildingId?: string | undefined;
    toSectionId?: string | undefined;
    toPenId?: string | undefined;
    toProductionType: AnimalType;
    correctToProductionType: AnimalType;
    amount: number;
    avgWeight: number;
    totalWeight: number;
    growthPigEventType: GrowthPigEventType;
    bundleIdentifier?: string | undefined;
    feedCurve?: number | undefined;
    recipe?: number | undefined;
}

export class UpdateGrowthPigEventDto extends SiteEntity implements IUpdateGrowthPigEventDto {
    updateFrom?: GrowthPigEventDto | undefined;
    updateTo?: GrowthPigEventDto | undefined;

    constructor(data?: IUpdateGrowthPigEventDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.updateFrom = _data["updateFrom"] ? GrowthPigEventDto.fromJS(_data["updateFrom"]) : <any>undefined;
            this.updateTo = _data["updateTo"] ? GrowthPigEventDto.fromJS(_data["updateTo"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): UpdateGrowthPigEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGrowthPigEventDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updateFrom"] = this.updateFrom ? this.updateFrom.toJSON() : <any>undefined;
        data["updateTo"] = this.updateTo ? this.updateTo.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateGrowthPigEventDto extends ISiteEntity {
    updateFrom?: GrowthPigEventDto | undefined;
    updateTo?: GrowthPigEventDto | undefined;
}

export class GrowthPigMoveEventDto extends SiteEntity implements IGrowthPigMoveEventDto {
    name?: string | undefined;
    date!: Date;
    toBuildingId?: string | undefined;
    toSectionId?: string | undefined;
    toPenId?: string | undefined;
    fromBuildingId?: string | undefined;
    fromSectionId?: string | undefined;
    fromPenId?: string | undefined;
    fromProductionType!: AnimalType;
    toProductionType!: AnimalType;
    correctFromProductionType!: AnimalType;
    correctToProductionType!: AnimalType;
    amount!: number;
    avgWeight!: number;
    totalWeight!: number;
    oldTotalWeight?: number | undefined;
    poolYoungFemaleId?: string | undefined;
    growthPigEventType!: GrowthPigEventType;
    bundleIdentifier?: string | undefined;
    retentionDate?: Date | undefined;
    feedCurve?: number | undefined;
    recipe?: number | undefined;

    constructor(data?: IGrowthPigMoveEventDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.toBuildingId = _data["toBuildingId"];
            this.toSectionId = _data["toSectionId"];
            this.toPenId = _data["toPenId"];
            this.fromBuildingId = _data["fromBuildingId"];
            this.fromSectionId = _data["fromSectionId"];
            this.fromPenId = _data["fromPenId"];
            this.fromProductionType = _data["fromProductionType"];
            this.toProductionType = _data["toProductionType"];
            this.correctFromProductionType = _data["correctFromProductionType"];
            this.correctToProductionType = _data["correctToProductionType"];
            this.amount = _data["amount"];
            this.avgWeight = _data["avgWeight"];
            this.totalWeight = _data["totalWeight"];
            this.oldTotalWeight = _data["oldTotalWeight"];
            this.poolYoungFemaleId = _data["poolYoungFemaleId"];
            this.growthPigEventType = _data["growthPigEventType"];
            this.bundleIdentifier = _data["bundleIdentifier"];
            this.retentionDate = _data["retentionDate"] ? new Date(_data["retentionDate"].toString()) : <any>undefined;
            this.feedCurve = _data["feedCurve"];
            this.recipe = _data["recipe"];
        }
    }

    static override fromJS(data: any): GrowthPigMoveEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new GrowthPigMoveEventDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["toBuildingId"] = this.toBuildingId;
        data["toSectionId"] = this.toSectionId;
        data["toPenId"] = this.toPenId;
        data["fromBuildingId"] = this.fromBuildingId;
        data["fromSectionId"] = this.fromSectionId;
        data["fromPenId"] = this.fromPenId;
        data["fromProductionType"] = this.fromProductionType;
        data["toProductionType"] = this.toProductionType;
        data["correctFromProductionType"] = this.correctFromProductionType;
        data["correctToProductionType"] = this.correctToProductionType;
        data["amount"] = this.amount;
        data["avgWeight"] = this.avgWeight;
        data["totalWeight"] = this.totalWeight;
        data["oldTotalWeight"] = this.oldTotalWeight;
        data["poolYoungFemaleId"] = this.poolYoungFemaleId;
        data["growthPigEventType"] = this.growthPigEventType;
        data["bundleIdentifier"] = this.bundleIdentifier;
        data["retentionDate"] = this.retentionDate ? this.retentionDate.toISOString() : <any>undefined;
        data["feedCurve"] = this.feedCurve;
        data["recipe"] = this.recipe;
        super.toJSON(data);
        return data;
    }
}

export interface IGrowthPigMoveEventDto extends ISiteEntity {
    name?: string | undefined;
    date: Date;
    toBuildingId?: string | undefined;
    toSectionId?: string | undefined;
    toPenId?: string | undefined;
    fromBuildingId?: string | undefined;
    fromSectionId?: string | undefined;
    fromPenId?: string | undefined;
    fromProductionType: AnimalType;
    toProductionType: AnimalType;
    correctFromProductionType: AnimalType;
    correctToProductionType: AnimalType;
    amount: number;
    avgWeight: number;
    totalWeight: number;
    oldTotalWeight?: number | undefined;
    poolYoungFemaleId?: string | undefined;
    growthPigEventType: GrowthPigEventType;
    bundleIdentifier?: string | undefined;
    retentionDate?: Date | undefined;
    feedCurve?: number | undefined;
    recipe?: number | undefined;
}

export class GrowthPigPigletMoveEventDtoAndUpdateEvents implements IGrowthPigPigletMoveEventDtoAndUpdateEvents {
    growthPigEntranceEventDto?: GrowthPigMoveEventDto[] | undefined;
    growthPigsEvents?: GrowthPigsEvent[] | undefined;

    constructor(data?: IGrowthPigPigletMoveEventDtoAndUpdateEvents) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["growthPigEntranceEventDto"])) {
                this.growthPigEntranceEventDto = [] as any;
                for (let item of _data["growthPigEntranceEventDto"])
                    this.growthPigEntranceEventDto!.push(GrowthPigMoveEventDto.fromJS(item));
            }
            if (Array.isArray(_data["growthPigsEvents"])) {
                this.growthPigsEvents = [] as any;
                for (let item of _data["growthPigsEvents"])
                    this.growthPigsEvents!.push(GrowthPigsEvent.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GrowthPigPigletMoveEventDtoAndUpdateEvents {
        data = typeof data === 'object' ? data : {};
        let result = new GrowthPigPigletMoveEventDtoAndUpdateEvents();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.growthPigEntranceEventDto)) {
            data["growthPigEntranceEventDto"] = [];
            for (let item of this.growthPigEntranceEventDto)
                data["growthPigEntranceEventDto"].push(item.toJSON());
        }
        if (Array.isArray(this.growthPigsEvents)) {
            data["growthPigsEvents"] = [];
            for (let item of this.growthPigsEvents)
                data["growthPigsEvents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGrowthPigPigletMoveEventDtoAndUpdateEvents {
    growthPigEntranceEventDto?: GrowthPigMoveEventDto[] | undefined;
    growthPigsEvents?: GrowthPigsEvent[] | undefined;
}

export class GrowthPigsEvent extends SiteEntity implements IGrowthPigsEvent {
    date!: Date;
    retentionDate?: Date | undefined;
    toBuildingId?: string | undefined;
    toSectionId?: string | undefined;
    toPenId?: string | undefined;
    fromBuildingId?: string | undefined;
    fromSectionId?: string | undefined;
    fromPenId?: string | undefined;
    fromProductionType!: AnimalType;
    toProductionType!: AnimalType;
    correctFromProductionType!: AnimalType;
    correctToProductionType!: AnimalType;
    departureType?: string | undefined;
    departureReasonId?: string | undefined;
    amount!: number;
    oldTotalWeight?: number | undefined;
    totalWeight!: number;
    poolYoungFemaleId?: string | undefined;
    growthPigEventType!: GrowthPigEventType;
    bundleIdentifier?: string | undefined;
    isWeightRegulation!: boolean;
    animalIdNumber?: string | undefined;

    constructor(data?: IGrowthPigsEvent) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.retentionDate = _data["retentionDate"] ? new Date(_data["retentionDate"].toString()) : <any>undefined;
            this.toBuildingId = _data["toBuildingId"];
            this.toSectionId = _data["toSectionId"];
            this.toPenId = _data["toPenId"];
            this.fromBuildingId = _data["fromBuildingId"];
            this.fromSectionId = _data["fromSectionId"];
            this.fromPenId = _data["fromPenId"];
            this.fromProductionType = _data["fromProductionType"];
            this.toProductionType = _data["toProductionType"];
            this.correctFromProductionType = _data["correctFromProductionType"];
            this.correctToProductionType = _data["correctToProductionType"];
            this.departureType = _data["departureType"];
            this.departureReasonId = _data["departureReasonId"];
            this.amount = _data["amount"];
            this.oldTotalWeight = _data["oldTotalWeight"];
            this.totalWeight = _data["totalWeight"];
            this.poolYoungFemaleId = _data["poolYoungFemaleId"];
            this.growthPigEventType = _data["growthPigEventType"];
            this.bundleIdentifier = _data["bundleIdentifier"];
            this.isWeightRegulation = _data["isWeightRegulation"];
            this.animalIdNumber = _data["animalIdNumber"];
        }
    }

    static override fromJS(data: any): GrowthPigsEvent {
        data = typeof data === 'object' ? data : {};
        let result = new GrowthPigsEvent();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["retentionDate"] = this.retentionDate ? this.retentionDate.toISOString() : <any>undefined;
        data["toBuildingId"] = this.toBuildingId;
        data["toSectionId"] = this.toSectionId;
        data["toPenId"] = this.toPenId;
        data["fromBuildingId"] = this.fromBuildingId;
        data["fromSectionId"] = this.fromSectionId;
        data["fromPenId"] = this.fromPenId;
        data["fromProductionType"] = this.fromProductionType;
        data["toProductionType"] = this.toProductionType;
        data["correctFromProductionType"] = this.correctFromProductionType;
        data["correctToProductionType"] = this.correctToProductionType;
        data["departureType"] = this.departureType;
        data["departureReasonId"] = this.departureReasonId;
        data["amount"] = this.amount;
        data["oldTotalWeight"] = this.oldTotalWeight;
        data["totalWeight"] = this.totalWeight;
        data["poolYoungFemaleId"] = this.poolYoungFemaleId;
        data["growthPigEventType"] = this.growthPigEventType;
        data["bundleIdentifier"] = this.bundleIdentifier;
        data["isWeightRegulation"] = this.isWeightRegulation;
        data["animalIdNumber"] = this.animalIdNumber;
        super.toJSON(data);
        return data;
    }
}

export interface IGrowthPigsEvent extends ISiteEntity {
    date: Date;
    retentionDate?: Date | undefined;
    toBuildingId?: string | undefined;
    toSectionId?: string | undefined;
    toPenId?: string | undefined;
    fromBuildingId?: string | undefined;
    fromSectionId?: string | undefined;
    fromPenId?: string | undefined;
    fromProductionType: AnimalType;
    toProductionType: AnimalType;
    correctFromProductionType: AnimalType;
    correctToProductionType: AnimalType;
    departureType?: string | undefined;
    departureReasonId?: string | undefined;
    amount: number;
    oldTotalWeight?: number | undefined;
    totalWeight: number;
    poolYoungFemaleId?: string | undefined;
    growthPigEventType: GrowthPigEventType;
    bundleIdentifier?: string | undefined;
    isWeightRegulation: boolean;
    animalIdNumber?: string | undefined;
}

export class GrowthPigDepartureEventDto extends SiteEntity implements IGrowthPigDepartureEventDto {
    name?: string | undefined;
    date!: Date;
    fromBuildingId?: string | undefined;
    fromSectionId?: string | undefined;
    fromPenId?: string | undefined;
    fromProductionType!: AnimalType;
    correctFromProductionType!: AnimalType;
    departureType?: string | undefined;
    amount!: number;
    avgWeight?: number | undefined;
    totalWeight!: number;
    oldTotalWeight?: number | undefined;
    growthPigEventType!: GrowthPigEventType;
    bundleIdentifier?: string | undefined;

    constructor(data?: IGrowthPigDepartureEventDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.fromBuildingId = _data["fromBuildingId"];
            this.fromSectionId = _data["fromSectionId"];
            this.fromPenId = _data["fromPenId"];
            this.fromProductionType = _data["fromProductionType"];
            this.correctFromProductionType = _data["correctFromProductionType"];
            this.departureType = _data["departureType"];
            this.amount = _data["amount"];
            this.avgWeight = _data["avgWeight"];
            this.totalWeight = _data["totalWeight"];
            this.oldTotalWeight = _data["oldTotalWeight"];
            this.growthPigEventType = _data["growthPigEventType"];
            this.bundleIdentifier = _data["bundleIdentifier"];
        }
    }

    static override fromJS(data: any): GrowthPigDepartureEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new GrowthPigDepartureEventDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["fromBuildingId"] = this.fromBuildingId;
        data["fromSectionId"] = this.fromSectionId;
        data["fromPenId"] = this.fromPenId;
        data["fromProductionType"] = this.fromProductionType;
        data["correctFromProductionType"] = this.correctFromProductionType;
        data["departureType"] = this.departureType;
        data["amount"] = this.amount;
        data["avgWeight"] = this.avgWeight;
        data["totalWeight"] = this.totalWeight;
        data["oldTotalWeight"] = this.oldTotalWeight;
        data["growthPigEventType"] = this.growthPigEventType;
        data["bundleIdentifier"] = this.bundleIdentifier;
        super.toJSON(data);
        return data;
    }
}

export interface IGrowthPigDepartureEventDto extends ISiteEntity {
    name?: string | undefined;
    date: Date;
    fromBuildingId?: string | undefined;
    fromSectionId?: string | undefined;
    fromPenId?: string | undefined;
    fromProductionType: AnimalType;
    correctFromProductionType: AnimalType;
    departureType?: string | undefined;
    amount: number;
    avgWeight?: number | undefined;
    totalWeight: number;
    oldTotalWeight?: number | undefined;
    growthPigEventType: GrowthPigEventType;
    bundleIdentifier?: string | undefined;
}

export class GrowthPigDepartureFromPenEventDto extends SiteEntity implements IGrowthPigDepartureFromPenEventDto {
    name?: string | undefined;
    date!: Date;
    fromBuildingId?: string | undefined;
    fromSectionId?: string | undefined;
    fromPenId?: string | undefined;
    fromProductionType!: AnimalType;
    correctFromProductionType!: AnimalType;
    departureType?: string | undefined;
    departureReasonId?: string | undefined;
    amount!: number;
    avgWeight!: number;
    totalWeight!: number;
    oldTotalWeight?: number | undefined;
    growthPigEventType!: GrowthPigEventType;
    bundleIdentifier?: string | undefined;
    animalIdNumber?: string | undefined;

    constructor(data?: IGrowthPigDepartureFromPenEventDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.fromBuildingId = _data["fromBuildingId"];
            this.fromSectionId = _data["fromSectionId"];
            this.fromPenId = _data["fromPenId"];
            this.fromProductionType = _data["fromProductionType"];
            this.correctFromProductionType = _data["correctFromProductionType"];
            this.departureType = _data["departureType"];
            this.departureReasonId = _data["departureReasonId"];
            this.amount = _data["amount"];
            this.avgWeight = _data["avgWeight"];
            this.totalWeight = _data["totalWeight"];
            this.oldTotalWeight = _data["oldTotalWeight"];
            this.growthPigEventType = _data["growthPigEventType"];
            this.bundleIdentifier = _data["bundleIdentifier"];
            this.animalIdNumber = _data["animalIdNumber"];
        }
    }

    static override fromJS(data: any): GrowthPigDepartureFromPenEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new GrowthPigDepartureFromPenEventDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["fromBuildingId"] = this.fromBuildingId;
        data["fromSectionId"] = this.fromSectionId;
        data["fromPenId"] = this.fromPenId;
        data["fromProductionType"] = this.fromProductionType;
        data["correctFromProductionType"] = this.correctFromProductionType;
        data["departureType"] = this.departureType;
        data["departureReasonId"] = this.departureReasonId;
        data["amount"] = this.amount;
        data["avgWeight"] = this.avgWeight;
        data["totalWeight"] = this.totalWeight;
        data["oldTotalWeight"] = this.oldTotalWeight;
        data["growthPigEventType"] = this.growthPigEventType;
        data["bundleIdentifier"] = this.bundleIdentifier;
        data["animalIdNumber"] = this.animalIdNumber;
        super.toJSON(data);
        return data;
    }
}

export interface IGrowthPigDepartureFromPenEventDto extends ISiteEntity {
    name?: string | undefined;
    date: Date;
    fromBuildingId?: string | undefined;
    fromSectionId?: string | undefined;
    fromPenId?: string | undefined;
    fromProductionType: AnimalType;
    correctFromProductionType: AnimalType;
    departureType?: string | undefined;
    departureReasonId?: string | undefined;
    amount: number;
    avgWeight: number;
    totalWeight: number;
    oldTotalWeight?: number | undefined;
    growthPigEventType: GrowthPigEventType;
    bundleIdentifier?: string | undefined;
    animalIdNumber?: string | undefined;
}

export class SyncGrowthPigEvents implements ISyncGrowthPigEvents {
    syncTime!: Date;
    dailySync!: Date;
    datas?: GrowthPigEventDto[] | undefined;
    deletedGrowthPigEvents?: string[] | undefined;

    constructor(data?: ISyncGrowthPigEvents) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.syncTime = _data["syncTime"] ? new Date(_data["syncTime"].toString()) : <any>undefined;
            this.dailySync = _data["dailySync"] ? new Date(_data["dailySync"].toString()) : <any>undefined;
            if (Array.isArray(_data["datas"])) {
                this.datas = [] as any;
                for (let item of _data["datas"])
                    this.datas!.push(GrowthPigEventDto.fromJS(item));
            }
            if (Array.isArray(_data["deletedGrowthPigEvents"])) {
                this.deletedGrowthPigEvents = [] as any;
                for (let item of _data["deletedGrowthPigEvents"])
                    this.deletedGrowthPigEvents!.push(item);
            }
        }
    }

    static fromJS(data: any): SyncGrowthPigEvents {
        data = typeof data === 'object' ? data : {};
        let result = new SyncGrowthPigEvents();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["syncTime"] = this.syncTime ? this.syncTime.toISOString() : <any>undefined;
        data["dailySync"] = this.dailySync ? this.dailySync.toISOString() : <any>undefined;
        if (Array.isArray(this.datas)) {
            data["datas"] = [];
            for (let item of this.datas)
                data["datas"].push(item.toJSON());
        }
        if (Array.isArray(this.deletedGrowthPigEvents)) {
            data["deletedGrowthPigEvents"] = [];
            for (let item of this.deletedGrowthPigEvents)
                data["deletedGrowthPigEvents"].push(item);
        }
        return data;
    }
}

export interface ISyncGrowthPigEvents {
    syncTime: Date;
    dailySync: Date;
    datas?: GrowthPigEventDto[] | undefined;
    deletedGrowthPigEvents?: string[] | undefined;
}

export class GrowthPigPenDashboardStatus implements IGrowthPigPenDashboardStatus {
    pigCount!: number;
    totalDays!: number;
    totalWeight!: number;
    totalWeightAtEntrance!: number;
    productionType!: AnimalType;
    sectionId?: string | undefined;
    totalDaysToDeparture!: number;
    feedPerPigToday!: number;
    feedPerPigCurve!: number;
    feedPerPigTotal!: number;
    feedPerPigWeight!: number;

    constructor(data?: IGrowthPigPenDashboardStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pigCount = _data["pigCount"];
            this.totalDays = _data["totalDays"];
            this.totalWeight = _data["totalWeight"];
            this.totalWeightAtEntrance = _data["totalWeightAtEntrance"];
            this.productionType = _data["productionType"];
            this.sectionId = _data["sectionId"];
            this.totalDaysToDeparture = _data["totalDaysToDeparture"];
            this.feedPerPigToday = _data["feedPerPigToday"];
            this.feedPerPigCurve = _data["feedPerPigCurve"];
            this.feedPerPigTotal = _data["feedPerPigTotal"];
            this.feedPerPigWeight = _data["feedPerPigWeight"];
        }
    }

    static fromJS(data: any): GrowthPigPenDashboardStatus {
        data = typeof data === 'object' ? data : {};
        let result = new GrowthPigPenDashboardStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pigCount"] = this.pigCount;
        data["totalDays"] = this.totalDays;
        data["totalWeight"] = this.totalWeight;
        data["totalWeightAtEntrance"] = this.totalWeightAtEntrance;
        data["productionType"] = this.productionType;
        data["sectionId"] = this.sectionId;
        data["totalDaysToDeparture"] = this.totalDaysToDeparture;
        data["feedPerPigToday"] = this.feedPerPigToday;
        data["feedPerPigCurve"] = this.feedPerPigCurve;
        data["feedPerPigTotal"] = this.feedPerPigTotal;
        data["feedPerPigWeight"] = this.feedPerPigWeight;
        return data;
    }
}

export interface IGrowthPigPenDashboardStatus {
    pigCount: number;
    totalDays: number;
    totalWeight: number;
    totalWeightAtEntrance: number;
    productionType: AnimalType;
    sectionId?: string | undefined;
    totalDaysToDeparture: number;
    feedPerPigToday: number;
    feedPerPigCurve: number;
    feedPerPigTotal: number;
    feedPerPigWeight: number;
}

export class GrowthPigShouldDepartureTableItem extends PdfTableCellItemsWithDefinedWidths implements IGrowthPigShouldDepartureTableItem {
    locationString?: string | undefined;
    penString?: string | undefined;
    registrationDate!: Date;
    pigCount?: number | undefined;
    avgWeight?: number | undefined;
    departureType?: string | undefined;
    reasonString?: string | undefined;
    retentionDate!: Date;
    checked!: boolean;
    reasonId?: string | undefined;
    gpeId?: string | undefined;
    penOrder!: number;
    sectionOrder!: number;
    buildingOrder!: number;
    penId?: string | undefined;
    sectionId?: string | undefined;

    constructor(data?: IGrowthPigShouldDepartureTableItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.locationString = _data["locationString"];
            this.penString = _data["penString"];
            this.registrationDate = _data["registrationDate"] ? new Date(_data["registrationDate"].toString()) : <any>undefined;
            this.pigCount = _data["pigCount"];
            this.avgWeight = _data["avgWeight"];
            this.departureType = _data["departureType"];
            this.reasonString = _data["reasonString"];
            this.retentionDate = _data["retentionDate"] ? new Date(_data["retentionDate"].toString()) : <any>undefined;
            this.checked = _data["checked"];
            this.reasonId = _data["reasonId"];
            this.gpeId = _data["gpeId"];
            this.penOrder = _data["penOrder"];
            this.sectionOrder = _data["sectionOrder"];
            this.buildingOrder = _data["buildingOrder"];
            this.penId = _data["penId"];
            this.sectionId = _data["sectionId"];
        }
    }

    static override fromJS(data: any): GrowthPigShouldDepartureTableItem {
        data = typeof data === 'object' ? data : {};
        let result = new GrowthPigShouldDepartureTableItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationString"] = this.locationString;
        data["penString"] = this.penString;
        data["registrationDate"] = this.registrationDate ? this.registrationDate.toISOString() : <any>undefined;
        data["pigCount"] = this.pigCount;
        data["avgWeight"] = this.avgWeight;
        data["departureType"] = this.departureType;
        data["reasonString"] = this.reasonString;
        data["retentionDate"] = this.retentionDate ? this.retentionDate.toISOString() : <any>undefined;
        data["checked"] = this.checked;
        data["reasonId"] = this.reasonId;
        data["gpeId"] = this.gpeId;
        data["penOrder"] = this.penOrder;
        data["sectionOrder"] = this.sectionOrder;
        data["buildingOrder"] = this.buildingOrder;
        data["penId"] = this.penId;
        data["sectionId"] = this.sectionId;
        super.toJSON(data);
        return data;
    }
}

export interface IGrowthPigShouldDepartureTableItem extends IPdfTableCellItemsWithDefinedWidths {
    locationString?: string | undefined;
    penString?: string | undefined;
    registrationDate: Date;
    pigCount?: number | undefined;
    avgWeight?: number | undefined;
    departureType?: string | undefined;
    reasonString?: string | undefined;
    retentionDate: Date;
    checked: boolean;
    reasonId?: string | undefined;
    gpeId?: string | undefined;
    penOrder: number;
    sectionOrder: number;
    buildingOrder: number;
    penId?: string | undefined;
    sectionId?: string | undefined;
}

export class GrowthPigPReportTableDatasType implements IGrowthPigPReportTableDatasType {
    tableData?: GrowthPigPReportTableData[] | undefined;
    feedUsageItems?: FeedUsagePerAnimal[] | undefined;
    errorTranslationKey?: string | undefined;

    constructor(data?: IGrowthPigPReportTableDatasType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tableData"])) {
                this.tableData = [] as any;
                for (let item of _data["tableData"])
                    this.tableData!.push(GrowthPigPReportTableData.fromJS(item));
            }
            if (Array.isArray(_data["feedUsageItems"])) {
                this.feedUsageItems = [] as any;
                for (let item of _data["feedUsageItems"])
                    this.feedUsageItems!.push(FeedUsagePerAnimal.fromJS(item));
            }
            this.errorTranslationKey = _data["errorTranslationKey"];
        }
    }

    static fromJS(data: any): GrowthPigPReportTableDatasType {
        data = typeof data === 'object' ? data : {};
        let result = new GrowthPigPReportTableDatasType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tableData)) {
            data["tableData"] = [];
            for (let item of this.tableData)
                data["tableData"].push(item.toJSON());
        }
        if (Array.isArray(this.feedUsageItems)) {
            data["feedUsageItems"] = [];
            for (let item of this.feedUsageItems)
                data["feedUsageItems"].push(item.toJSON());
        }
        data["errorTranslationKey"] = this.errorTranslationKey;
        return data;
    }
}

export interface IGrowthPigPReportTableDatasType {
    tableData?: GrowthPigPReportTableData[] | undefined;
    feedUsageItems?: FeedUsagePerAnimal[] | undefined;
    errorTranslationKey?: string | undefined;
}

export class GrowthPigPReportTableData implements IGrowthPigPReportTableData {
    values?: number[] | undefined;
    name?: string | undefined;
    isHeader!: boolean;

    constructor(data?: IGrowthPigPReportTableData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
            this.name = _data["name"];
            this.isHeader = _data["isHeader"];
        }
    }

    static fromJS(data: any): GrowthPigPReportTableData {
        data = typeof data === 'object' ? data : {};
        let result = new GrowthPigPReportTableData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        data["name"] = this.name;
        data["isHeader"] = this.isHeader;
        return data;
    }
}

export interface IGrowthPigPReportTableData {
    values?: number[] | undefined;
    name?: string | undefined;
    isHeader: boolean;
}

export class FeedUsagePerAnimal implements IFeedUsagePerAnimal {
    animalType?: AnimalType | undefined;
    feedSubjects?: FeedUsageItem[] | undefined;
    isTotal!: boolean;
    cellColorStyle!: CellColorStyle;
    fuOrKg!: FuOrKg;

    constructor(data?: IFeedUsagePerAnimal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.animalType = _data["animalType"];
            if (Array.isArray(_data["feedSubjects"])) {
                this.feedSubjects = [] as any;
                for (let item of _data["feedSubjects"])
                    this.feedSubjects!.push(FeedUsageItem.fromJS(item));
            }
            this.isTotal = _data["isTotal"];
            this.cellColorStyle = _data["cellColorStyle"];
            this.fuOrKg = _data["fuOrKg"];
        }
    }

    static fromJS(data: any): FeedUsagePerAnimal {
        data = typeof data === 'object' ? data : {};
        let result = new FeedUsagePerAnimal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["animalType"] = this.animalType;
        if (Array.isArray(this.feedSubjects)) {
            data["feedSubjects"] = [];
            for (let item of this.feedSubjects)
                data["feedSubjects"].push(item.toJSON());
        }
        data["isTotal"] = this.isTotal;
        data["cellColorStyle"] = this.cellColorStyle;
        data["fuOrKg"] = this.fuOrKg;
        return data;
    }
}

export interface IFeedUsagePerAnimal {
    animalType?: AnimalType | undefined;
    feedSubjects?: FeedUsageItem[] | undefined;
    isTotal: boolean;
    cellColorStyle: CellColorStyle;
    fuOrKg: FuOrKg;
}

export class FeedUsageItem implements IFeedUsageItem {
    name?: string | undefined;
    energy1PerKg!: number;
    rawProtein!: number;
    energy2PerKg!: number;
    fosforPerKg!: number;
    totalKg!: number;
    totalFE!: number;
    fePercent!: number;
    kgPercent!: number;
    isDistriwinFeed!: boolean;
    isTotal!: boolean;
    isRecipe!: boolean;
    feedingSubject?: FeedingSubject | undefined;

    constructor(data?: IFeedUsageItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.energy1PerKg = _data["energy1PerKg"];
            this.rawProtein = _data["rawProtein"];
            this.energy2PerKg = _data["energy2PerKg"];
            this.fosforPerKg = _data["fosforPerKg"];
            this.totalKg = _data["totalKg"];
            this.totalFE = _data["totalFE"];
            this.fePercent = _data["fePercent"];
            this.kgPercent = _data["kgPercent"];
            this.isDistriwinFeed = _data["isDistriwinFeed"];
            this.isTotal = _data["isTotal"];
            this.isRecipe = _data["isRecipe"];
            this.feedingSubject = _data["feedingSubject"] ? FeedingSubject.fromJS(_data["feedingSubject"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FeedUsageItem {
        data = typeof data === 'object' ? data : {};
        let result = new FeedUsageItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["energy1PerKg"] = this.energy1PerKg;
        data["rawProtein"] = this.rawProtein;
        data["energy2PerKg"] = this.energy2PerKg;
        data["fosforPerKg"] = this.fosforPerKg;
        data["totalKg"] = this.totalKg;
        data["totalFE"] = this.totalFE;
        data["fePercent"] = this.fePercent;
        data["kgPercent"] = this.kgPercent;
        data["isDistriwinFeed"] = this.isDistriwinFeed;
        data["isTotal"] = this.isTotal;
        data["isRecipe"] = this.isRecipe;
        data["feedingSubject"] = this.feedingSubject ? this.feedingSubject.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFeedUsageItem {
    name?: string | undefined;
    energy1PerKg: number;
    rawProtein: number;
    energy2PerKg: number;
    fosforPerKg: number;
    totalKg: number;
    totalFE: number;
    fePercent: number;
    kgPercent: number;
    isDistriwinFeed: boolean;
    isTotal: boolean;
    isRecipe: boolean;
    feedingSubject?: FeedingSubject | undefined;
}

export class GrowthPigProductionReportData implements IGrowthPigProductionReportData {
    isSpecialPeriod!: boolean;
    timeZoneId?: string | undefined;
    siteId?: string | undefined;
    sectionId?: string | undefined;
    animalType!: AnimalType;
    correctAnimalType!: AnimalType;

    constructor(data?: IGrowthPigProductionReportData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSpecialPeriod = _data["isSpecialPeriod"];
            this.timeZoneId = _data["timeZoneId"];
            this.siteId = _data["siteId"];
            this.sectionId = _data["sectionId"];
            this.animalType = _data["animalType"];
            this.correctAnimalType = _data["correctAnimalType"];
        }
    }

    static fromJS(data: any): GrowthPigProductionReportData {
        data = typeof data === 'object' ? data : {};
        let result = new GrowthPigProductionReportData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSpecialPeriod"] = this.isSpecialPeriod;
        data["timeZoneId"] = this.timeZoneId;
        data["siteId"] = this.siteId;
        data["sectionId"] = this.sectionId;
        data["animalType"] = this.animalType;
        data["correctAnimalType"] = this.correctAnimalType;
        return data;
    }
}

export interface IGrowthPigProductionReportData {
    isSpecialPeriod: boolean;
    timeZoneId?: string | undefined;
    siteId?: string | undefined;
    sectionId?: string | undefined;
    animalType: AnimalType;
    correctAnimalType: AnimalType;
}

export class ProductionReportByGrowthPigAnimalTypes implements IProductionReportByGrowthPigAnimalTypes {
    feedUsages?: FeedUsagePerAnimal[] | undefined;
    rows?: GrowthPigPReportTableData[] | undefined;
    animalType!: AnimalType;

    constructor(data?: IProductionReportByGrowthPigAnimalTypes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["feedUsages"])) {
                this.feedUsages = [] as any;
                for (let item of _data["feedUsages"])
                    this.feedUsages!.push(FeedUsagePerAnimal.fromJS(item));
            }
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(GrowthPigPReportTableData.fromJS(item));
            }
            this.animalType = _data["animalType"];
        }
    }

    static fromJS(data: any): ProductionReportByGrowthPigAnimalTypes {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionReportByGrowthPigAnimalTypes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.feedUsages)) {
            data["feedUsages"] = [];
            for (let item of this.feedUsages)
                data["feedUsages"].push(item.toJSON());
        }
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["animalType"] = this.animalType;
        return data;
    }
}

export interface IProductionReportByGrowthPigAnimalTypes {
    feedUsages?: FeedUsagePerAnimal[] | undefined;
    rows?: GrowthPigPReportTableData[] | undefined;
    animalType: AnimalType;
}

export class GrowthPigTuneProduction extends SiteEntity implements IGrowthPigTuneProduction {
    date!: Date;
    buildingId?: string | undefined;
    sectionId?: string | undefined;
    penId?: string | undefined;
    weight!: number;
    amount!: number;
    animalType!: AnimalType;

    constructor(data?: IGrowthPigTuneProduction) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.buildingId = _data["buildingId"];
            this.sectionId = _data["sectionId"];
            this.penId = _data["penId"];
            this.weight = _data["weight"];
            this.amount = _data["amount"];
            this.animalType = _data["animalType"];
        }
    }

    static override fromJS(data: any): GrowthPigTuneProduction {
        data = typeof data === 'object' ? data : {};
        let result = new GrowthPigTuneProduction();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["buildingId"] = this.buildingId;
        data["sectionId"] = this.sectionId;
        data["penId"] = this.penId;
        data["weight"] = this.weight;
        data["amount"] = this.amount;
        data["animalType"] = this.animalType;
        super.toJSON(data);
        return data;
    }
}

export interface IGrowthPigTuneProduction extends ISiteEntity {
    date: Date;
    buildingId?: string | undefined;
    sectionId?: string | undefined;
    penId?: string | undefined;
    weight: number;
    amount: number;
    animalType: AnimalType;
}

export class UserProfile2 extends SiteEntity implements IUserProfile2 {
    language?: string | undefined;
    adUserID?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    admin!: boolean;
    initials?: string | undefined;

    constructor(data?: IUserProfile2) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.language = _data["language"];
            this.adUserID = _data["adUserID"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.admin = _data["admin"];
            this.initials = _data["initials"];
        }
    }

    static override fromJS(data: any): UserProfile2 {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfile2();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language;
        data["adUserID"] = this.adUserID;
        data["name"] = this.name;
        data["email"] = this.email;
        data["admin"] = this.admin;
        data["initials"] = this.initials;
        super.toJSON(data);
        return data;
    }
}

export interface IUserProfile2 extends ISiteEntity {
    language?: string | undefined;
    adUserID?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    admin: boolean;
    initials?: string | undefined;
}

export class UserProfile extends UserProfile2 implements IUserProfile {
    siteName?: string | undefined;
    modules?: string[] | undefined;
    processes?: string[] | undefined;
    active!: boolean;
    userSiteId?: string | undefined;

    constructor(data?: IUserProfile) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.siteName = _data["siteName"];
            if (Array.isArray(_data["modules"])) {
                this.modules = [] as any;
                for (let item of _data["modules"])
                    this.modules!.push(item);
            }
            if (Array.isArray(_data["processes"])) {
                this.processes = [] as any;
                for (let item of _data["processes"])
                    this.processes!.push(item);
            }
            this.active = _data["active"];
            this.userSiteId = _data["userSiteId"];
        }
    }

    static override fromJS(data: any): UserProfile {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfile();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siteName"] = this.siteName;
        if (Array.isArray(this.modules)) {
            data["modules"] = [];
            for (let item of this.modules)
                data["modules"].push(item);
        }
        if (Array.isArray(this.processes)) {
            data["processes"] = [];
            for (let item of this.processes)
                data["processes"].push(item);
        }
        data["active"] = this.active;
        data["userSiteId"] = this.userSiteId;
        super.toJSON(data);
        return data;
    }
}

export interface IUserProfile extends IUserProfile2 {
    siteName?: string | undefined;
    modules?: string[] | undefined;
    processes?: string[] | undefined;
    active: boolean;
    userSiteId?: string | undefined;
}

export class Image extends Unique implements IImage {
    base64Data?: string | undefined;

    constructor(data?: IImage) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.base64Data = _data["base64Data"];
        }
    }

    static override fromJS(data: any): Image {
        data = typeof data === 'object' ? data : {};
        let result = new Image();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["base64Data"] = this.base64Data;
        super.toJSON(data);
        return data;
    }
}

export interface IImage extends IUnique {
    base64Data?: string | undefined;
}

export class DeviceEdgeModuleDto implements IDeviceEdgeModuleDto {
    code?: string | undefined;
    equipment!: Equipment;
    properties?: DeviceTwinPropertyDto[] | undefined;
    desiredLastUpdate!: Date;
    reportedLastUpdate!: Date;

    constructor(data?: IDeviceEdgeModuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.equipment = _data["equipment"];
            if (Array.isArray(_data["properties"])) {
                this.properties = [] as any;
                for (let item of _data["properties"])
                    this.properties!.push(DeviceTwinPropertyDto.fromJS(item));
            }
            this.desiredLastUpdate = _data["desiredLastUpdate"] ? new Date(_data["desiredLastUpdate"].toString()) : <any>undefined;
            this.reportedLastUpdate = _data["reportedLastUpdate"] ? new Date(_data["reportedLastUpdate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DeviceEdgeModuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceEdgeModuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["equipment"] = this.equipment;
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item of this.properties)
                data["properties"].push(item.toJSON());
        }
        data["desiredLastUpdate"] = this.desiredLastUpdate ? this.desiredLastUpdate.toISOString() : <any>undefined;
        data["reportedLastUpdate"] = this.reportedLastUpdate ? this.reportedLastUpdate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDeviceEdgeModuleDto {
    code?: string | undefined;
    equipment: Equipment;
    properties?: DeviceTwinPropertyDto[] | undefined;
    desiredLastUpdate: Date;
    reportedLastUpdate: Date;
}

export enum Equipment {
    Distriwin = "Distriwin",
    ESF = "ESF",
    Elistar = "Elistar",
}

export class DeviceTwinPropertyDto implements IDeviceTwinPropertyDto {
    propertyName?: string | undefined;
    state!: PropertyState;
    value?: string | undefined;
    type!: PropertyType;

    constructor(data?: IDeviceTwinPropertyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertyName = _data["propertyName"];
            this.state = _data["state"];
            this.value = _data["value"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): DeviceTwinPropertyDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceTwinPropertyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyName"] = this.propertyName;
        data["state"] = this.state;
        data["value"] = this.value;
        data["type"] = this.type;
        return data;
    }
}

export interface IDeviceTwinPropertyDto {
    propertyName?: string | undefined;
    state: PropertyState;
    value?: string | undefined;
    type: PropertyType;
}

export enum PropertyState {
    Desired = "Desired",
    Reported = "Reported",
}

export enum PropertyType {
    Unknown = "Unknown",
    Text = "Text",
    Number = "Number",
    DateTime = "DateTime",
    IpAddress = "IpAddress",
}

export class DeviceEdgeAgentPropertiesDto implements IDeviceEdgeAgentPropertiesDto {
    runTimeStatus?: string | undefined;
    statusDescription?: string | undefined;
    exitCode!: number;
    lastStartTime!: Date;
    lastExitTime!: Date;
    restartCount!: number;

    constructor(data?: IDeviceEdgeAgentPropertiesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.runTimeStatus = _data["runTimeStatus"];
            this.statusDescription = _data["statusDescription"];
            this.exitCode = _data["exitCode"];
            this.lastStartTime = _data["lastStartTime"] ? new Date(_data["lastStartTime"].toString()) : <any>undefined;
            this.lastExitTime = _data["lastExitTime"] ? new Date(_data["lastExitTime"].toString()) : <any>undefined;
            this.restartCount = _data["restartCount"];
        }
    }

    static fromJS(data: any): DeviceEdgeAgentPropertiesDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceEdgeAgentPropertiesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["runTimeStatus"] = this.runTimeStatus;
        data["statusDescription"] = this.statusDescription;
        data["exitCode"] = this.exitCode;
        data["lastStartTime"] = this.lastStartTime ? this.lastStartTime.toISOString() : <any>undefined;
        data["lastExitTime"] = this.lastExitTime ? this.lastExitTime.toISOString() : <any>undefined;
        data["restartCount"] = this.restartCount;
        return data;
    }
}

export interface IDeviceEdgeAgentPropertiesDto {
    runTimeStatus?: string | undefined;
    statusDescription?: string | undefined;
    exitCode: number;
    lastStartTime: Date;
    lastExitTime: Date;
    restartCount: number;
}

export class LardScanningEvent extends SiteEntity implements ILardScanningEvent {
    stemAnimalId?: string | undefined;
    date!: Date;
    width?: number | undefined;
    weight?: number | undefined;

    constructor(data?: ILardScanningEvent) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.stemAnimalId = _data["stemAnimalId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.width = _data["width"];
            this.weight = _data["weight"];
        }
    }

    static override fromJS(data: any): LardScanningEvent {
        data = typeof data === 'object' ? data : {};
        let result = new LardScanningEvent();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stemAnimalId"] = this.stemAnimalId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["width"] = this.width;
        data["weight"] = this.weight;
        super.toJSON(data);
        return data;
    }
}

export interface ILardScanningEvent extends ISiteEntity {
    stemAnimalId?: string | undefined;
    date: Date;
    width?: number | undefined;
    weight?: number | undefined;
}

export abstract class BaseSyncOfLardScanningEvent implements IBaseSyncOfLardScanningEvent {
    syncTime!: Date;

    protected _discriminator: string;

    constructor(data?: IBaseSyncOfLardScanningEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "BaseSyncOfLardScanningEvent";
    }

    init(_data?: any) {
        if (_data) {
            this.syncTime = _data["syncTime"] ? new Date(_data["syncTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseSyncOfLardScanningEvent {
        data = typeof data === 'object' ? data : {};
        if (data["_discriminator"] === "SyncDataLardScanningEvent") {
            let result = new SyncDataLardScanningEvent();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'BaseSyncOfLardScanningEvent' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_discriminator"] = this._discriminator;
        data["syncTime"] = this.syncTime ? this.syncTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBaseSyncOfLardScanningEvent {
    syncTime: Date;
}

export class SyncDataLardScanningEvent extends BaseSyncOfLardScanningEvent implements ISyncDataLardScanningEvent {
    datas?: LardScanningEvent[] | undefined;

    constructor(data?: ISyncDataLardScanningEvent) {
        super(data);
        this._discriminator = "SyncDataLardScanningEvent";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["datas"])) {
                this.datas = [] as any;
                for (let item of _data["datas"])
                    this.datas!.push(LardScanningEvent.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): SyncDataLardScanningEvent {
        data = typeof data === 'object' ? data : {};
        let result = new SyncDataLardScanningEvent();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.datas)) {
            data["datas"] = [];
            for (let item of this.datas)
                data["datas"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISyncDataLardScanningEvent extends IBaseSyncOfLardScanningEvent {
    datas?: LardScanningEvent[] | undefined;
}

export class Licence extends Unique implements ILicence {
    name?: string | undefined;
    licenceCategory!: LicenceCategory;

    constructor(data?: ILicence) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.licenceCategory = _data["licenceCategory"];
        }
    }

    static override fromJS(data: any): Licence {
        data = typeof data === 'object' ? data : {};
        let result = new Licence();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["licenceCategory"] = this.licenceCategory;
        super.toJSON(data);
        return data;
    }
}

export interface ILicence extends IUnique {
    name?: string | undefined;
    licenceCategory: LicenceCategory;
}

export enum LicenceCategory {
    Sows = "Sows",
    ClimatePigs = "ClimatePigs",
    Finisher = "Finisher",
    NucleusManagement = "NucleusManagement",
}

export class LocationsV2 implements ILocationsV2 {
    buildings?: Building[] | undefined;
    sections?: SectionV2[] | undefined;
    pens?: Pen[] | undefined;
    valves?: Valve[] | undefined;

    constructor(data?: ILocationsV2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["buildings"])) {
                this.buildings = [] as any;
                for (let item of _data["buildings"])
                    this.buildings!.push(Building.fromJS(item));
            }
            if (Array.isArray(_data["sections"])) {
                this.sections = [] as any;
                for (let item of _data["sections"])
                    this.sections!.push(SectionV2.fromJS(item));
            }
            if (Array.isArray(_data["pens"])) {
                this.pens = [] as any;
                for (let item of _data["pens"])
                    this.pens!.push(Pen.fromJS(item));
            }
            if (Array.isArray(_data["valves"])) {
                this.valves = [] as any;
                for (let item of _data["valves"])
                    this.valves!.push(Valve.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LocationsV2 {
        data = typeof data === 'object' ? data : {};
        let result = new LocationsV2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.buildings)) {
            data["buildings"] = [];
            for (let item of this.buildings)
                data["buildings"].push(item.toJSON());
        }
        if (Array.isArray(this.sections)) {
            data["sections"] = [];
            for (let item of this.sections)
                data["sections"].push(item.toJSON());
        }
        if (Array.isArray(this.pens)) {
            data["pens"] = [];
            for (let item of this.pens)
                data["pens"].push(item.toJSON());
        }
        if (Array.isArray(this.valves)) {
            data["valves"] = [];
            for (let item of this.valves)
                data["valves"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILocationsV2 {
    buildings?: Building[] | undefined;
    sections?: SectionV2[] | undefined;
    pens?: Pen[] | undefined;
    valves?: Valve[] | undefined;
}

export class SectionV2 extends SiteEntity implements ISectionV2 {
    name?: string | undefined;
    buildingId?: string | undefined;
    type!: LocationTypeV2;
    usePens!: boolean;
    code?: string | undefined;
    order!: number;
    animalType?: AnimalType | undefined;
    number?: number | undefined;

    constructor(data?: ISectionV2) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.buildingId = _data["buildingId"];
            this.type = _data["type"];
            this.usePens = _data["usePens"];
            this.code = _data["code"];
            this.order = _data["order"];
            this.animalType = _data["animalType"];
            this.number = _data["number"];
        }
    }

    static override fromJS(data: any): SectionV2 {
        data = typeof data === 'object' ? data : {};
        let result = new SectionV2();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["buildingId"] = this.buildingId;
        data["type"] = this.type;
        data["usePens"] = this.usePens;
        data["code"] = this.code;
        data["order"] = this.order;
        data["animalType"] = this.animalType;
        data["number"] = this.number;
        super.toJSON(data);
        return data;
    }
}

export interface ISectionV2 extends ISiteEntity {
    name?: string | undefined;
    buildingId?: string | undefined;
    type: LocationTypeV2;
    usePens: boolean;
    code?: string | undefined;
    order: number;
    animalType?: AnimalType | undefined;
    number?: number | undefined;
}

export enum LocationTypeV2 {
    Mating = "Mating",
    Pregnant = "Pregnant",
    Farrowing = "Farrowing",
    Gilt = "Gilt",
    Boars = "Boars",
    Relief = "Relief",
    Holistic = "Holistic",
    Weaners = "Weaners",
    Finisher = "Finisher",
    Silo = "Silo",
    PostponeSows = "PostponeSows",
}

export class Pen extends SiteEntity implements IPen {
    name?: string | undefined;
    buildingId?: string | undefined;
    sectionId?: string | undefined;
    zoneId?: string | undefined;
    sowCount!: number;
    pigCount!: number;
    penDays!: number;
    sowCycle!: SowCycleType;
    pigletCount!: number;
    weight!: number;
    code?: string | undefined;
    capacity!: number;
    order!: number;
    number?: number | undefined;
    retentionTime?: Date | undefined;

    constructor(data?: IPen) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.buildingId = _data["buildingId"];
            this.sectionId = _data["sectionId"];
            this.zoneId = _data["zoneId"];
            this.sowCount = _data["sowCount"];
            this.pigCount = _data["pigCount"];
            this.penDays = _data["penDays"];
            this.sowCycle = _data["sowCycle"];
            this.pigletCount = _data["pigletCount"];
            this.weight = _data["weight"];
            this.code = _data["code"];
            this.capacity = _data["capacity"];
            this.order = _data["order"];
            this.number = _data["number"];
            this.retentionTime = _data["retentionTime"] ? new Date(_data["retentionTime"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): Pen {
        data = typeof data === 'object' ? data : {};
        let result = new Pen();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["buildingId"] = this.buildingId;
        data["sectionId"] = this.sectionId;
        data["zoneId"] = this.zoneId;
        data["sowCount"] = this.sowCount;
        data["pigCount"] = this.pigCount;
        data["penDays"] = this.penDays;
        data["sowCycle"] = this.sowCycle;
        data["pigletCount"] = this.pigletCount;
        data["weight"] = this.weight;
        data["code"] = this.code;
        data["capacity"] = this.capacity;
        data["order"] = this.order;
        data["number"] = this.number;
        data["retentionTime"] = this.retentionTime ? this.retentionTime.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPen extends ISiteEntity {
    name?: string | undefined;
    buildingId?: string | undefined;
    sectionId?: string | undefined;
    zoneId?: string | undefined;
    sowCount: number;
    pigCount: number;
    penDays: number;
    sowCycle: SowCycleType;
    pigletCount: number;
    weight: number;
    code?: string | undefined;
    capacity: number;
    order: number;
    number?: number | undefined;
    retentionTime?: Date | undefined;
}

export enum SowCycleType {
    Null = "Null",
    Weaning = "Weaning",
    Gestation = "Gestation",
    Maternity = "Maternity",
}

export class Valve implements IValve {
    id?: string | undefined;
    siteId?: string | undefined;
    valveGroupId?: string | undefined;
    scale!: number;
    locationCode?: string | undefined;

    constructor(data?: IValve) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.siteId = _data["siteId"];
            this.valveGroupId = _data["valveGroupId"];
            this.scale = _data["scale"];
            this.locationCode = _data["locationCode"];
        }
    }

    static fromJS(data: any): Valve {
        data = typeof data === 'object' ? data : {};
        let result = new Valve();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["siteId"] = this.siteId;
        data["valveGroupId"] = this.valveGroupId;
        data["scale"] = this.scale;
        data["locationCode"] = this.locationCode;
        return data;
    }
}

export interface IValve {
    id?: string | undefined;
    siteId?: string | undefined;
    valveGroupId?: string | undefined;
    scale: number;
    locationCode?: string | undefined;
}

export abstract class BaseSingleSyncOfLocationsV2 implements IBaseSingleSyncOfLocationsV2 {
    syncTime!: Date;

    constructor(data?: IBaseSingleSyncOfLocationsV2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.syncTime = _data["syncTime"] ? new Date(_data["syncTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseSingleSyncOfLocationsV2 {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseSingleSyncOfLocationsV2' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["syncTime"] = this.syncTime ? this.syncTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBaseSingleSyncOfLocationsV2 {
    syncTime: Date;
}

export class SyncDataLocationsV2 extends BaseSingleSyncOfLocationsV2 implements ISyncDataLocationsV2 {
    data?: LocationsV2 | undefined;

    constructor(data?: ISyncDataLocationsV2) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? LocationsV2.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): SyncDataLocationsV2 {
        data = typeof data === 'object' ? data : {};
        let result = new SyncDataLocationsV2();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ISyncDataLocationsV2 extends IBaseSingleSyncOfLocationsV2 {
    data?: LocationsV2 | undefined;
}

export class Locations implements ILocations {
    buildings?: Building[] | undefined;
    sections?: Section[] | undefined;
    pens?: Pen[] | undefined;
    valves?: Valve[] | undefined;

    constructor(data?: ILocations) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["buildings"])) {
                this.buildings = [] as any;
                for (let item of _data["buildings"])
                    this.buildings!.push(Building.fromJS(item));
            }
            if (Array.isArray(_data["sections"])) {
                this.sections = [] as any;
                for (let item of _data["sections"])
                    this.sections!.push(Section.fromJS(item));
            }
            if (Array.isArray(_data["pens"])) {
                this.pens = [] as any;
                for (let item of _data["pens"])
                    this.pens!.push(Pen.fromJS(item));
            }
            if (Array.isArray(_data["valves"])) {
                this.valves = [] as any;
                for (let item of _data["valves"])
                    this.valves!.push(Valve.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Locations {
        data = typeof data === 'object' ? data : {};
        let result = new Locations();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.buildings)) {
            data["buildings"] = [];
            for (let item of this.buildings)
                data["buildings"].push(item.toJSON());
        }
        if (Array.isArray(this.sections)) {
            data["sections"] = [];
            for (let item of this.sections)
                data["sections"].push(item.toJSON());
        }
        if (Array.isArray(this.pens)) {
            data["pens"] = [];
            for (let item of this.pens)
                data["pens"].push(item.toJSON());
        }
        if (Array.isArray(this.valves)) {
            data["valves"] = [];
            for (let item of this.valves)
                data["valves"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILocations {
    buildings?: Building[] | undefined;
    sections?: Section[] | undefined;
    pens?: Pen[] | undefined;
    valves?: Valve[] | undefined;
}

export class Section extends SiteEntity implements ISection {
    name?: string | undefined;
    buildingId?: string | undefined;
    type!: LocationType;
    usePens!: boolean;
    code?: string | undefined;
    order!: number;
    animalType?: AnimalType | undefined;
    number?: number | undefined;

    constructor(data?: ISection) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.buildingId = _data["buildingId"];
            this.type = _data["type"];
            this.usePens = _data["usePens"];
            this.code = _data["code"];
            this.order = _data["order"];
            this.animalType = _data["animalType"];
            this.number = _data["number"];
        }
    }

    static override fromJS(data: any): Section {
        data = typeof data === 'object' ? data : {};
        let result = new Section();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["buildingId"] = this.buildingId;
        data["type"] = this.type;
        data["usePens"] = this.usePens;
        data["code"] = this.code;
        data["order"] = this.order;
        data["animalType"] = this.animalType;
        data["number"] = this.number;
        super.toJSON(data);
        return data;
    }
}

export interface ISection extends ISiteEntity {
    name?: string | undefined;
    buildingId?: string | undefined;
    type: LocationType;
    usePens: boolean;
    code?: string | undefined;
    order: number;
    animalType?: AnimalType | undefined;
    number?: number | undefined;
}

export abstract class BaseSingleSyncOfLocations implements IBaseSingleSyncOfLocations {
    syncTime!: Date;

    constructor(data?: IBaseSingleSyncOfLocations) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.syncTime = _data["syncTime"] ? new Date(_data["syncTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseSingleSyncOfLocations {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseSingleSyncOfLocations' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["syncTime"] = this.syncTime ? this.syncTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBaseSingleSyncOfLocations {
    syncTime: Date;
}

export class SyncDataLocations extends BaseSingleSyncOfLocations implements ISyncDataLocations {
    data?: Locations | undefined;

    constructor(data?: ISyncDataLocations) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? Locations.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): SyncDataLocations {
        data = typeof data === 'object' ? data : {};
        let result = new SyncDataLocations();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ISyncDataLocations extends IBaseSingleSyncOfLocations {
    data?: Locations | undefined;
}

export class Marking extends Unique implements IMarking {
    translationKey?: string | undefined;
    color?: string | undefined;

    constructor(data?: IMarking) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.translationKey = _data["translationKey"];
            this.color = _data["color"];
        }
    }

    static override fromJS(data: any): Marking {
        data = typeof data === 'object' ? data : {};
        let result = new Marking();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["translationKey"] = this.translationKey;
        data["color"] = this.color;
        super.toJSON(data);
        return data;
    }
}

export interface IMarking extends IUnique {
    translationKey?: string | undefined;
    color?: string | undefined;
}

export abstract class BaseSyncOfMarking implements IBaseSyncOfMarking {
    syncTime!: Date;

    protected _discriminator: string;

    constructor(data?: IBaseSyncOfMarking) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "BaseSyncOfMarking";
    }

    init(_data?: any) {
        if (_data) {
            this.syncTime = _data["syncTime"] ? new Date(_data["syncTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseSyncOfMarking {
        data = typeof data === 'object' ? data : {};
        if (data["_discriminator"] === "SyncDataMarking") {
            let result = new SyncDataMarking();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'BaseSyncOfMarking' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_discriminator"] = this._discriminator;
        data["syncTime"] = this.syncTime ? this.syncTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBaseSyncOfMarking {
    syncTime: Date;
}

export class SyncDataMarking extends BaseSyncOfMarking implements ISyncDataMarking {
    datas?: Marking[] | undefined;

    constructor(data?: ISyncDataMarking) {
        super(data);
        this._discriminator = "SyncDataMarking";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["datas"])) {
                this.datas = [] as any;
                for (let item of _data["datas"])
                    this.datas!.push(Marking.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): SyncDataMarking {
        data = typeof data === 'object' ? data : {};
        let result = new SyncDataMarking();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.datas)) {
            data["datas"] = [];
            for (let item of this.datas)
                data["datas"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISyncDataMarking extends IBaseSyncOfMarking {
    datas?: Marking[] | undefined;
}

export abstract class BaseSyncOfMatingBatch implements IBaseSyncOfMatingBatch {
    syncTime!: Date;

    protected _discriminator: string;

    constructor(data?: IBaseSyncOfMatingBatch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "BaseSyncOfMatingBatch";
    }

    init(_data?: any) {
        if (_data) {
            this.syncTime = _data["syncTime"] ? new Date(_data["syncTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseSyncOfMatingBatch {
        data = typeof data === 'object' ? data : {};
        if (data["_discriminator"] === "SyncDataMatingBatch") {
            let result = new SyncDataMatingBatch();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'BaseSyncOfMatingBatch' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_discriminator"] = this._discriminator;
        data["syncTime"] = this.syncTime ? this.syncTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBaseSyncOfMatingBatch {
    syncTime: Date;
}

export class SyncDataMatingBatch extends BaseSyncOfMatingBatch implements ISyncDataMatingBatch {
    datas?: MatingBatch[] | undefined;

    constructor(data?: ISyncDataMatingBatch) {
        super(data);
        this._discriminator = "SyncDataMatingBatch";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["datas"])) {
                this.datas = [] as any;
                for (let item of _data["datas"])
                    this.datas!.push(MatingBatch.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): SyncDataMatingBatch {
        data = typeof data === 'object' ? data : {};
        let result = new SyncDataMatingBatch();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.datas)) {
            data["datas"] = [];
            for (let item of this.datas)
                data["datas"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISyncDataMatingBatch extends IBaseSyncOfMatingBatch {
    datas?: MatingBatch[] | undefined;
}

export class MatingBatchReports extends Unique implements IMatingBatchReports {
    matingReport?: MatingReport[] | undefined;
    farrowingReport?: FarrowingReport[] | undefined;
    weaningReport?: WeaningReport[] | undefined;

    constructor(data?: IMatingBatchReports) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["matingReport"])) {
                this.matingReport = [] as any;
                for (let item of _data["matingReport"])
                    this.matingReport!.push(MatingReport.fromJS(item));
            }
            if (Array.isArray(_data["farrowingReport"])) {
                this.farrowingReport = [] as any;
                for (let item of _data["farrowingReport"])
                    this.farrowingReport!.push(FarrowingReport.fromJS(item));
            }
            if (Array.isArray(_data["weaningReport"])) {
                this.weaningReport = [] as any;
                for (let item of _data["weaningReport"])
                    this.weaningReport!.push(WeaningReport.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): MatingBatchReports {
        data = typeof data === 'object' ? data : {};
        let result = new MatingBatchReports();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.matingReport)) {
            data["matingReport"] = [];
            for (let item of this.matingReport)
                data["matingReport"].push(item.toJSON());
        }
        if (Array.isArray(this.farrowingReport)) {
            data["farrowingReport"] = [];
            for (let item of this.farrowingReport)
                data["farrowingReport"].push(item.toJSON());
        }
        if (Array.isArray(this.weaningReport)) {
            data["weaningReport"] = [];
            for (let item of this.weaningReport)
                data["weaningReport"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IMatingBatchReports extends IUnique {
    matingReport?: MatingReport[] | undefined;
    farrowingReport?: FarrowingReport[] | undefined;
    weaningReport?: WeaningReport[] | undefined;
}

export class MatingBatchSetting extends SiteEntity implements IMatingBatchSetting {
    startDate!: Date;
    endDate!: Date;
    weekday!: Weekdays;
    matingPeriod!: number;
    weekCycle!: number;
    pregnantDay!: number;
    nursingDays!: number;
    batchNumberRotation!: number;
    isManuel!: boolean;

    constructor(data?: IMatingBatchSetting) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.weekday = _data["weekday"];
            this.matingPeriod = _data["matingPeriod"];
            this.weekCycle = _data["weekCycle"];
            this.pregnantDay = _data["pregnantDay"];
            this.nursingDays = _data["nursingDays"];
            this.batchNumberRotation = _data["batchNumberRotation"];
            this.isManuel = _data["isManuel"];
        }
    }

    static override fromJS(data: any): MatingBatchSetting {
        data = typeof data === 'object' ? data : {};
        let result = new MatingBatchSetting();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["weekday"] = this.weekday;
        data["matingPeriod"] = this.matingPeriod;
        data["weekCycle"] = this.weekCycle;
        data["pregnantDay"] = this.pregnantDay;
        data["nursingDays"] = this.nursingDays;
        data["batchNumberRotation"] = this.batchNumberRotation;
        data["isManuel"] = this.isManuel;
        super.toJSON(data);
        return data;
    }
}

export interface IMatingBatchSetting extends ISiteEntity {
    startDate: Date;
    endDate: Date;
    weekday: Weekdays;
    matingPeriod: number;
    weekCycle: number;
    pregnantDay: number;
    nursingDays: number;
    batchNumberRotation: number;
    isManuel: boolean;
}

export enum Weekdays {
    Monday = "Monday",
    Tuesday = "Tuesday",
    Wednesday = "Wednesday",
    Thursday = "Thursday",
    Friday = "Friday",
    Saturday = "Saturday",
    Sunday = "Sunday",
}

export abstract class BaseSyncOfMatingBatchSetting implements IBaseSyncOfMatingBatchSetting {
    syncTime!: Date;

    protected _discriminator: string;

    constructor(data?: IBaseSyncOfMatingBatchSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "BaseSyncOfMatingBatchSetting";
    }

    init(_data?: any) {
        if (_data) {
            this.syncTime = _data["syncTime"] ? new Date(_data["syncTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseSyncOfMatingBatchSetting {
        data = typeof data === 'object' ? data : {};
        if (data["_discriminator"] === "SyncDataMatingBatchSetting") {
            let result = new SyncDataMatingBatchSetting();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'BaseSyncOfMatingBatchSetting' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_discriminator"] = this._discriminator;
        data["syncTime"] = this.syncTime ? this.syncTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBaseSyncOfMatingBatchSetting {
    syncTime: Date;
}

export class SyncDataMatingBatchSetting extends BaseSyncOfMatingBatchSetting implements ISyncDataMatingBatchSetting {
    datas?: MatingBatchSetting[] | undefined;

    constructor(data?: ISyncDataMatingBatchSetting) {
        super(data);
        this._discriminator = "SyncDataMatingBatchSetting";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["datas"])) {
                this.datas = [] as any;
                for (let item of _data["datas"])
                    this.datas!.push(MatingBatchSetting.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): SyncDataMatingBatchSetting {
        data = typeof data === 'object' ? data : {};
        let result = new SyncDataMatingBatchSetting();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.datas)) {
            data["datas"] = [];
            for (let item of this.datas)
                data["datas"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISyncDataMatingBatchSetting extends IBaseSyncOfMatingBatchSetting {
    datas?: MatingBatchSetting[] | undefined;
}

export class MoveEvent extends SiteEntity implements IMoveEvent {
    stemAnimalId?: string | undefined;
    penId?: string | undefined;
    moveDate!: Date;
    feedCurveNumber?: number | undefined;
    fixedDeviation?: number | undefined;
    deviationPeriod?: number | undefined;
    tempFeedDeviation?: number | undefined;
    transponder?: string | undefined;

    constructor(data?: IMoveEvent) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.stemAnimalId = _data["stemAnimalId"];
            this.penId = _data["penId"];
            this.moveDate = _data["moveDate"] ? new Date(_data["moveDate"].toString()) : <any>undefined;
            this.feedCurveNumber = _data["feedCurveNumber"];
            this.fixedDeviation = _data["fixedDeviation"];
            this.deviationPeriod = _data["deviationPeriod"];
            this.tempFeedDeviation = _data["tempFeedDeviation"];
            this.transponder = _data["transponder"];
        }
    }

    static override fromJS(data: any): MoveEvent {
        data = typeof data === 'object' ? data : {};
        let result = new MoveEvent();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stemAnimalId"] = this.stemAnimalId;
        data["penId"] = this.penId;
        data["moveDate"] = this.moveDate ? this.moveDate.toISOString() : <any>undefined;
        data["feedCurveNumber"] = this.feedCurveNumber;
        data["fixedDeviation"] = this.fixedDeviation;
        data["deviationPeriod"] = this.deviationPeriod;
        data["tempFeedDeviation"] = this.tempFeedDeviation;
        data["transponder"] = this.transponder;
        super.toJSON(data);
        return data;
    }
}

export interface IMoveEvent extends ISiteEntity {
    stemAnimalId?: string | undefined;
    penId?: string | undefined;
    moveDate: Date;
    feedCurveNumber?: number | undefined;
    fixedDeviation?: number | undefined;
    deviationPeriod?: number | undefined;
    tempFeedDeviation?: number | undefined;
    transponder?: string | undefined;
}

export abstract class BaseSyncOfMoveEvent implements IBaseSyncOfMoveEvent {
    syncTime!: Date;

    protected _discriminator: string;

    constructor(data?: IBaseSyncOfMoveEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "BaseSyncOfMoveEvent";
    }

    init(_data?: any) {
        if (_data) {
            this.syncTime = _data["syncTime"] ? new Date(_data["syncTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseSyncOfMoveEvent {
        data = typeof data === 'object' ? data : {};
        if (data["_discriminator"] === "SyncDataMoveEvent") {
            let result = new SyncDataMoveEvent();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'BaseSyncOfMoveEvent' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_discriminator"] = this._discriminator;
        data["syncTime"] = this.syncTime ? this.syncTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBaseSyncOfMoveEvent {
    syncTime: Date;
}

export class SyncDataMoveEvent extends BaseSyncOfMoveEvent implements ISyncDataMoveEvent {
    datas?: MoveEvent[] | undefined;

    constructor(data?: ISyncDataMoveEvent) {
        super(data);
        this._discriminator = "SyncDataMoveEvent";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["datas"])) {
                this.datas = [] as any;
                for (let item of _data["datas"])
                    this.datas!.push(MoveEvent.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): SyncDataMoveEvent {
        data = typeof data === 'object' ? data : {};
        let result = new SyncDataMoveEvent();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.datas)) {
            data["datas"] = [];
            for (let item of this.datas)
                data["datas"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISyncDataMoveEvent extends IBaseSyncOfMoveEvent {
    datas?: MoveEvent[] | undefined;
}

export class PenRetentionTime extends SiteEntity implements IPenRetentionTime {
    penId?: string | undefined;
    retentionTime?: Date | undefined;

    constructor(data?: IPenRetentionTime) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.penId = _data["penId"];
            this.retentionTime = _data["retentionTime"] ? new Date(_data["retentionTime"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): PenRetentionTime {
        data = typeof data === 'object' ? data : {};
        let result = new PenRetentionTime();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["penId"] = this.penId;
        data["retentionTime"] = this.retentionTime ? this.retentionTime.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPenRetentionTime extends ISiteEntity {
    penId?: string | undefined;
    retentionTime?: Date | undefined;
}

export abstract class BaseSyncOfPenRetentionTime implements IBaseSyncOfPenRetentionTime {
    syncTime!: Date;

    protected _discriminator: string;

    constructor(data?: IBaseSyncOfPenRetentionTime) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "BaseSyncOfPenRetentionTime";
    }

    init(_data?: any) {
        if (_data) {
            this.syncTime = _data["syncTime"] ? new Date(_data["syncTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseSyncOfPenRetentionTime {
        data = typeof data === 'object' ? data : {};
        if (data["_discriminator"] === "SyncPenRetentionTime") {
            let result = new SyncPenRetentionTime();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'BaseSyncOfPenRetentionTime' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_discriminator"] = this._discriminator;
        data["syncTime"] = this.syncTime ? this.syncTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBaseSyncOfPenRetentionTime {
    syncTime: Date;
}

export class SyncPenRetentionTime extends BaseSyncOfPenRetentionTime implements ISyncPenRetentionTime {
    datas?: PenRetentionTime[] | undefined;

    constructor(data?: ISyncPenRetentionTime) {
        super(data);
        this._discriminator = "SyncPenRetentionTime";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["datas"])) {
                this.datas = [] as any;
                for (let item of _data["datas"])
                    this.datas!.push(PenRetentionTime.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): SyncPenRetentionTime {
        data = typeof data === 'object' ? data : {};
        let result = new SyncPenRetentionTime();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.datas)) {
            data["datas"] = [];
            for (let item of this.datas)
                data["datas"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISyncPenRetentionTime extends IBaseSyncOfPenRetentionTime {
    datas?: PenRetentionTime[] | undefined;
}

export abstract class BaseSyncOfPoolYoungFemale implements IBaseSyncOfPoolYoungFemale {
    syncTime!: Date;

    protected _discriminator: string;

    constructor(data?: IBaseSyncOfPoolYoungFemale) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "BaseSyncOfPoolYoungFemale";
    }

    init(_data?: any) {
        if (_data) {
            this.syncTime = _data["syncTime"] ? new Date(_data["syncTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseSyncOfPoolYoungFemale {
        data = typeof data === 'object' ? data : {};
        if (data["_discriminator"] === "SyncPoolYoungFemale") {
            let result = new SyncPoolYoungFemale();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'BaseSyncOfPoolYoungFemale' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_discriminator"] = this._discriminator;
        data["syncTime"] = this.syncTime ? this.syncTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBaseSyncOfPoolYoungFemale {
    syncTime: Date;
}

export class SyncPoolYoungFemale extends BaseSyncOfPoolYoungFemale implements ISyncPoolYoungFemale {
    datas?: PoolYoungFemale[] | undefined;

    constructor(data?: ISyncPoolYoungFemale) {
        super(data);
        this._discriminator = "SyncPoolYoungFemale";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["datas"])) {
                this.datas = [] as any;
                for (let item of _data["datas"])
                    this.datas!.push(PoolYoungFemale.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): SyncPoolYoungFemale {
        data = typeof data === 'object' ? data : {};
        let result = new SyncPoolYoungFemale();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.datas)) {
            data["datas"] = [];
            for (let item of this.datas)
                data["datas"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISyncPoolYoungFemale extends IBaseSyncOfPoolYoungFemale {
    datas?: PoolYoungFemale[] | undefined;
}

export class PoolYoungFemale extends SiteEntity implements IPoolYoungFemale {
    registrationDate!: Date;
    penId?: string | undefined;
    total!: number;
    eventType?: string | undefined;
    departureReasonId?: string | undefined;
    stemAnimalId?: string | undefined;
    idNumber?: string | undefined;

    constructor(data?: IPoolYoungFemale) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.registrationDate = _data["registrationDate"] ? new Date(_data["registrationDate"].toString()) : <any>undefined;
            this.penId = _data["penId"];
            this.total = _data["total"];
            this.eventType = _data["eventType"];
            this.departureReasonId = _data["departureReasonId"];
            this.stemAnimalId = _data["stemAnimalId"];
            this.idNumber = _data["idNumber"];
        }
    }

    static override fromJS(data: any): PoolYoungFemale {
        data = typeof data === 'object' ? data : {};
        let result = new PoolYoungFemale();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registrationDate"] = this.registrationDate ? this.registrationDate.toISOString() : <any>undefined;
        data["penId"] = this.penId;
        data["total"] = this.total;
        data["eventType"] = this.eventType;
        data["departureReasonId"] = this.departureReasonId;
        data["stemAnimalId"] = this.stemAnimalId;
        data["idNumber"] = this.idNumber;
        super.toJSON(data);
        return data;
    }
}

export interface IPoolYoungFemale extends ISiteEntity {
    registrationDate: Date;
    penId?: string | undefined;
    total: number;
    eventType?: string | undefined;
    departureReasonId?: string | undefined;
    stemAnimalId?: string | undefined;
    idNumber?: string | undefined;
}

export class PoolYoungFemaleShouldDepartureTableItem extends PdfTableCellItemsWithDefinedWidths implements IPoolYoungFemaleShouldDepartureTableItem {
    retentionDate!: Date;
    locationString?: string | undefined;
    penString?: string | undefined;
    registrationDate!: Date;
    pigCount!: number;
    departureType?: string | undefined;
    reasonString?: string | undefined;
    checked!: boolean;
    reasonId?: string | undefined;
    poolYoungFemaleId?: string | undefined;

    constructor(data?: IPoolYoungFemaleShouldDepartureTableItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.retentionDate = _data["retentionDate"] ? new Date(_data["retentionDate"].toString()) : <any>undefined;
            this.locationString = _data["locationString"];
            this.penString = _data["penString"];
            this.registrationDate = _data["registrationDate"] ? new Date(_data["registrationDate"].toString()) : <any>undefined;
            this.pigCount = _data["pigCount"];
            this.departureType = _data["departureType"];
            this.reasonString = _data["reasonString"];
            this.checked = _data["checked"];
            this.reasonId = _data["reasonId"];
            this.poolYoungFemaleId = _data["poolYoungFemaleId"];
        }
    }

    static override fromJS(data: any): PoolYoungFemaleShouldDepartureTableItem {
        data = typeof data === 'object' ? data : {};
        let result = new PoolYoungFemaleShouldDepartureTableItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["retentionDate"] = this.retentionDate ? this.retentionDate.toISOString() : <any>undefined;
        data["locationString"] = this.locationString;
        data["penString"] = this.penString;
        data["registrationDate"] = this.registrationDate ? this.registrationDate.toISOString() : <any>undefined;
        data["pigCount"] = this.pigCount;
        data["departureType"] = this.departureType;
        data["reasonString"] = this.reasonString;
        data["checked"] = this.checked;
        data["reasonId"] = this.reasonId;
        data["poolYoungFemaleId"] = this.poolYoungFemaleId;
        super.toJSON(data);
        return data;
    }
}

export interface IPoolYoungFemaleShouldDepartureTableItem extends IPdfTableCellItemsWithDefinedWidths {
    retentionDate: Date;
    locationString?: string | undefined;
    penString?: string | undefined;
    registrationDate: Date;
    pigCount: number;
    departureType?: string | undefined;
    reasonString?: string | undefined;
    checked: boolean;
    reasonId?: string | undefined;
    poolYoungFemaleId?: string | undefined;
}

export class SyncDataPregnancyV2 implements ISyncDataPregnancyV2 {
    syncTime!: Date;
    datas?: { [key: string]: PregnancyEvent[]; } | undefined;

    constructor(data?: ISyncDataPregnancyV2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.syncTime = _data["syncTime"] ? new Date(_data["syncTime"].toString()) : <any>undefined;
            if (_data["datas"]) {
                this.datas = {} as any;
                for (let key in _data["datas"]) {
                    if (_data["datas"].hasOwnProperty(key))
                        (<any>this.datas)![key] = _data["datas"][key] ? _data["datas"][key].map((i: any) => PregnancyEvent.fromJS(i)) : [];
                }
            }
        }
    }

    static fromJS(data: any): SyncDataPregnancyV2 {
        data = typeof data === 'object' ? data : {};
        let result = new SyncDataPregnancyV2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["syncTime"] = this.syncTime ? this.syncTime.toISOString() : <any>undefined;
        if (this.datas) {
            data["datas"] = {};
            for (let key in this.datas) {
                if (this.datas.hasOwnProperty(key))
                    (<any>data["datas"])[key] = (<any>this.datas)[key];
            }
        }
        return data;
    }
}

export interface ISyncDataPregnancyV2 {
    syncTime: Date;
    datas?: { [key: string]: PregnancyEvent[]; } | undefined;
}

export class ProcessEquipment extends SiteEntity implements IProcessEquipment {
    unit!: ProcessUnit;
    equipment!: Equipment;
    code?: string | undefined;
    name?: string | undefined;
    feedCurves?: FeedCurve[] | undefined;
    isEsfOrElistar!: boolean;
    lastSuccessfulHeartbeatOn?: Date | undefined;
    lastHeartbeatAttemptOn?: Date | undefined;

    constructor(data?: IProcessEquipment) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.unit = _data["unit"];
            this.equipment = _data["equipment"];
            this.code = _data["code"];
            this.name = _data["name"];
            if (Array.isArray(_data["feedCurves"])) {
                this.feedCurves = [] as any;
                for (let item of _data["feedCurves"])
                    this.feedCurves!.push(FeedCurve.fromJS(item));
            }
            this.isEsfOrElistar = _data["isEsfOrElistar"];
            this.lastSuccessfulHeartbeatOn = _data["lastSuccessfulHeartbeatOn"] ? new Date(_data["lastSuccessfulHeartbeatOn"].toString()) : <any>undefined;
            this.lastHeartbeatAttemptOn = _data["lastHeartbeatAttemptOn"] ? new Date(_data["lastHeartbeatAttemptOn"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): ProcessEquipment {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessEquipment();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unit"] = this.unit;
        data["equipment"] = this.equipment;
        data["code"] = this.code;
        data["name"] = this.name;
        if (Array.isArray(this.feedCurves)) {
            data["feedCurves"] = [];
            for (let item of this.feedCurves)
                data["feedCurves"].push(item.toJSON());
        }
        data["isEsfOrElistar"] = this.isEsfOrElistar;
        data["lastSuccessfulHeartbeatOn"] = this.lastSuccessfulHeartbeatOn ? this.lastSuccessfulHeartbeatOn.toISOString() : <any>undefined;
        data["lastHeartbeatAttemptOn"] = this.lastHeartbeatAttemptOn ? this.lastHeartbeatAttemptOn.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IProcessEquipment extends ISiteEntity {
    unit: ProcessUnit;
    equipment: Equipment;
    code?: string | undefined;
    name?: string | undefined;
    feedCurves?: FeedCurve[] | undefined;
    isEsfOrElistar: boolean;
    lastSuccessfulHeartbeatOn?: Date | undefined;
    lastHeartbeatAttemptOn?: Date | undefined;
}

export enum ProcessUnit {
    Valve = "Valve",
    Station = "Station",
}

export class FeedCurve implements IFeedCurve {
    id!: number;
    curveId!: number;
    name?: string | undefined;
    type?: string | undefined;
    detail1?: FeedCurveDetail[] | undefined;
    detail2?: FeedCurveDetail[] | undefined;
    detail3?: FeedCurveDetail[] | undefined;

    constructor(data?: IFeedCurve) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.curveId = _data["curveId"];
            this.name = _data["name"];
            this.type = _data["type"];
            if (Array.isArray(_data["detail1"])) {
                this.detail1 = [] as any;
                for (let item of _data["detail1"])
                    this.detail1!.push(FeedCurveDetail.fromJS(item));
            }
            if (Array.isArray(_data["detail2"])) {
                this.detail2 = [] as any;
                for (let item of _data["detail2"])
                    this.detail2!.push(FeedCurveDetail.fromJS(item));
            }
            if (Array.isArray(_data["detail3"])) {
                this.detail3 = [] as any;
                for (let item of _data["detail3"])
                    this.detail3!.push(FeedCurveDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FeedCurve {
        data = typeof data === 'object' ? data : {};
        let result = new FeedCurve();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["curveId"] = this.curveId;
        data["name"] = this.name;
        data["type"] = this.type;
        if (Array.isArray(this.detail1)) {
            data["detail1"] = [];
            for (let item of this.detail1)
                data["detail1"].push(item.toJSON());
        }
        if (Array.isArray(this.detail2)) {
            data["detail2"] = [];
            for (let item of this.detail2)
                data["detail2"].push(item.toJSON());
        }
        if (Array.isArray(this.detail3)) {
            data["detail3"] = [];
            for (let item of this.detail3)
                data["detail3"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFeedCurve {
    id: number;
    curveId: number;
    name?: string | undefined;
    type?: string | undefined;
    detail1?: FeedCurveDetail[] | undefined;
    detail2?: FeedCurveDetail[] | undefined;
    detail3?: FeedCurveDetail[] | undefined;
}

export class FeedCurveDetail implements IFeedCurveDetail {
    line?: number | undefined;
    days?: number | undefined;
    weight?: number | undefined;
    ration?: number | undefined;

    constructor(data?: IFeedCurveDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.line = _data["line"];
            this.days = _data["days"];
            this.weight = _data["weight"];
            this.ration = _data["ration"];
        }
    }

    static fromJS(data: any): FeedCurveDetail {
        data = typeof data === 'object' ? data : {};
        let result = new FeedCurveDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["line"] = this.line;
        data["days"] = this.days;
        data["weight"] = this.weight;
        data["ration"] = this.ration;
        return data;
    }
}

export interface IFeedCurveDetail {
    line?: number | undefined;
    days?: number | undefined;
    weight?: number | undefined;
    ration?: number | undefined;
}

export abstract class BaseSyncOfProcessEquipment implements IBaseSyncOfProcessEquipment {
    syncTime!: Date;

    protected _discriminator: string;

    constructor(data?: IBaseSyncOfProcessEquipment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "BaseSyncOfProcessEquipment";
    }

    init(_data?: any) {
        if (_data) {
            this.syncTime = _data["syncTime"] ? new Date(_data["syncTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseSyncOfProcessEquipment {
        data = typeof data === 'object' ? data : {};
        if (data["_discriminator"] === "SyncDataProcessEquipment") {
            let result = new SyncDataProcessEquipment();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'BaseSyncOfProcessEquipment' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_discriminator"] = this._discriminator;
        data["syncTime"] = this.syncTime ? this.syncTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBaseSyncOfProcessEquipment {
    syncTime: Date;
}

export class SyncDataProcessEquipment extends BaseSyncOfProcessEquipment implements ISyncDataProcessEquipment {
    datas?: ProcessEquipment[] | undefined;

    constructor(data?: ISyncDataProcessEquipment) {
        super(data);
        this._discriminator = "SyncDataProcessEquipment";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["datas"])) {
                this.datas = [] as any;
                for (let item of _data["datas"])
                    this.datas!.push(ProcessEquipment.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): SyncDataProcessEquipment {
        data = typeof data === 'object' ? data : {};
        let result = new SyncDataProcessEquipment();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.datas)) {
            data["datas"] = [];
            for (let item of this.datas)
                data["datas"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISyncDataProcessEquipment extends IBaseSyncOfProcessEquipment {
    datas?: ProcessEquipment[] | undefined;
}

export class ProcessEquipmentData extends SiteEntity implements IProcessEquipmentData {
    equipmentType?: Equipment | undefined;
    isFromImport!: boolean;
    code?: string | undefined;
    buildingCode?: string | undefined;
    sectionCode?: string | undefined;
    buildingId?: string | undefined;
    sectionId?: string | undefined;
    isEsfOrElistar!: boolean;
    unitCodes?: UnitData[] | undefined;

    constructor(data?: IProcessEquipmentData) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.equipmentType = _data["equipmentType"];
            this.isFromImport = _data["isFromImport"];
            this.code = _data["code"];
            this.buildingCode = _data["buildingCode"];
            this.sectionCode = _data["sectionCode"];
            this.buildingId = _data["buildingId"];
            this.sectionId = _data["sectionId"];
            this.isEsfOrElistar = _data["isEsfOrElistar"];
            if (Array.isArray(_data["unitCodes"])) {
                this.unitCodes = [] as any;
                for (let item of _data["unitCodes"])
                    this.unitCodes!.push(UnitData.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ProcessEquipmentData {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessEquipmentData();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["equipmentType"] = this.equipmentType;
        data["isFromImport"] = this.isFromImport;
        data["code"] = this.code;
        data["buildingCode"] = this.buildingCode;
        data["sectionCode"] = this.sectionCode;
        data["buildingId"] = this.buildingId;
        data["sectionId"] = this.sectionId;
        data["isEsfOrElistar"] = this.isEsfOrElistar;
        if (Array.isArray(this.unitCodes)) {
            data["unitCodes"] = [];
            for (let item of this.unitCodes)
                data["unitCodes"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IProcessEquipmentData extends ISiteEntity {
    equipmentType?: Equipment | undefined;
    isFromImport: boolean;
    code?: string | undefined;
    buildingCode?: string | undefined;
    sectionCode?: string | undefined;
    buildingId?: string | undefined;
    sectionId?: string | undefined;
    isEsfOrElistar: boolean;
    unitCodes?: UnitData[] | undefined;
}

export class UnitData implements IUnitData {
    unit?: string | undefined;
    unitGroupId?: string | undefined;
    unitCodes?: string[] | undefined;

    constructor(data?: IUnitData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unit = _data["unit"];
            this.unitGroupId = _data["unitGroupId"];
            if (Array.isArray(_data["unitCodes"])) {
                this.unitCodes = [] as any;
                for (let item of _data["unitCodes"])
                    this.unitCodes!.push(item);
            }
        }
    }

    static fromJS(data: any): UnitData {
        data = typeof data === 'object' ? data : {};
        let result = new UnitData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unit"] = this.unit;
        data["unitGroupId"] = this.unitGroupId;
        if (Array.isArray(this.unitCodes)) {
            data["unitCodes"] = [];
            for (let item of this.unitCodes)
                data["unitCodes"].push(item);
        }
        return data;
    }
}

export interface IUnitData {
    unit?: string | undefined;
    unitGroupId?: string | undefined;
    unitCodes?: string[] | undefined;
}

export class UnitToPen extends SiteEntity implements IUnitToPen {
    penId?: string | undefined;
    processEquipmentDataId?: string | undefined;
    unitGroupId?: string | undefined;
    number!: number;

    constructor(data?: IUnitToPen) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.penId = _data["penId"];
            this.processEquipmentDataId = _data["processEquipmentDataId"];
            this.unitGroupId = _data["unitGroupId"];
            this.number = _data["number"];
        }
    }

    static override fromJS(data: any): UnitToPen {
        data = typeof data === 'object' ? data : {};
        let result = new UnitToPen();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["penId"] = this.penId;
        data["processEquipmentDataId"] = this.processEquipmentDataId;
        data["unitGroupId"] = this.unitGroupId;
        data["number"] = this.number;
        super.toJSON(data);
        return data;
    }
}

export interface IUnitToPen extends ISiteEntity {
    penId?: string | undefined;
    processEquipmentDataId?: string | undefined;
    unitGroupId?: string | undefined;
    number: number;
}

export abstract class BaseSyncOfUnitToPen implements IBaseSyncOfUnitToPen {
    syncTime!: Date;

    protected _discriminator: string;

    constructor(data?: IBaseSyncOfUnitToPen) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "BaseSyncOfUnitToPen";
    }

    init(_data?: any) {
        if (_data) {
            this.syncTime = _data["syncTime"] ? new Date(_data["syncTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseSyncOfUnitToPen {
        data = typeof data === 'object' ? data : {};
        if (data["_discriminator"] === "SyncDataUnitToPen") {
            let result = new SyncDataUnitToPen();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'BaseSyncOfUnitToPen' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_discriminator"] = this._discriminator;
        data["syncTime"] = this.syncTime ? this.syncTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBaseSyncOfUnitToPen {
    syncTime: Date;
}

export class SyncDataUnitToPen extends BaseSyncOfUnitToPen implements ISyncDataUnitToPen {
    datas?: UnitToPen[] | undefined;

    constructor(data?: ISyncDataUnitToPen) {
        super(data);
        this._discriminator = "SyncDataUnitToPen";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["datas"])) {
                this.datas = [] as any;
                for (let item of _data["datas"])
                    this.datas!.push(UnitToPen.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): SyncDataUnitToPen {
        data = typeof data === 'object' ? data : {};
        let result = new SyncDataUnitToPen();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.datas)) {
            data["datas"] = [];
            for (let item of this.datas)
                data["datas"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISyncDataUnitToPen extends IBaseSyncOfUnitToPen {
    datas?: UnitToPen[] | undefined;
}

export abstract class BaseSyncOfProcessEquipmentData implements IBaseSyncOfProcessEquipmentData {
    syncTime!: Date;

    protected _discriminator: string;

    constructor(data?: IBaseSyncOfProcessEquipmentData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "BaseSyncOfProcessEquipmentData";
    }

    init(_data?: any) {
        if (_data) {
            this.syncTime = _data["syncTime"] ? new Date(_data["syncTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseSyncOfProcessEquipmentData {
        data = typeof data === 'object' ? data : {};
        if (data["_discriminator"] === "SyncProcessEquipmentData") {
            let result = new SyncProcessEquipmentData();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'BaseSyncOfProcessEquipmentData' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_discriminator"] = this._discriminator;
        data["syncTime"] = this.syncTime ? this.syncTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBaseSyncOfProcessEquipmentData {
    syncTime: Date;
}

export class SyncProcessEquipmentData extends BaseSyncOfProcessEquipmentData implements ISyncProcessEquipmentData {
    datas?: ProcessEquipmentData[] | undefined;

    constructor(data?: ISyncProcessEquipmentData) {
        super(data);
        this._discriminator = "SyncProcessEquipmentData";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["datas"])) {
                this.datas = [] as any;
                for (let item of _data["datas"])
                    this.datas!.push(ProcessEquipmentData.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): SyncProcessEquipmentData {
        data = typeof data === 'object' ? data : {};
        let result = new SyncProcessEquipmentData();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.datas)) {
            data["datas"] = [];
            for (let item of this.datas)
                data["datas"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISyncProcessEquipmentData extends IBaseSyncOfProcessEquipmentData {
    datas?: ProcessEquipmentData[] | undefined;
}

export class ProductionReportItem implements IProductionReportItem {
    matingItems?: MatingItem[] | undefined;
    farrowingItems?: FarrowingItem[] | undefined;
    weaningItems?: WeaningItem[] | undefined;
    productionScaleFeedReproduction?: ScaleFeedReproduction | undefined;
    statusItems?: StatusItem[] | undefined;
    feedUsageItems?: FeedUsagePerAnimal[] | undefined;
    mappedDates?: ProductionMappedDate[] | undefined;

    constructor(data?: IProductionReportItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["matingItems"])) {
                this.matingItems = [] as any;
                for (let item of _data["matingItems"])
                    this.matingItems!.push(MatingItem.fromJS(item));
            }
            if (Array.isArray(_data["farrowingItems"])) {
                this.farrowingItems = [] as any;
                for (let item of _data["farrowingItems"])
                    this.farrowingItems!.push(FarrowingItem.fromJS(item));
            }
            if (Array.isArray(_data["weaningItems"])) {
                this.weaningItems = [] as any;
                for (let item of _data["weaningItems"])
                    this.weaningItems!.push(WeaningItem.fromJS(item));
            }
            this.productionScaleFeedReproduction = _data["productionScaleFeedReproduction"] ? ScaleFeedReproduction.fromJS(_data["productionScaleFeedReproduction"]) : <any>undefined;
            if (Array.isArray(_data["statusItems"])) {
                this.statusItems = [] as any;
                for (let item of _data["statusItems"])
                    this.statusItems!.push(StatusItem.fromJS(item));
            }
            if (Array.isArray(_data["feedUsageItems"])) {
                this.feedUsageItems = [] as any;
                for (let item of _data["feedUsageItems"])
                    this.feedUsageItems!.push(FeedUsagePerAnimal.fromJS(item));
            }
            if (Array.isArray(_data["mappedDates"])) {
                this.mappedDates = [] as any;
                for (let item of _data["mappedDates"])
                    this.mappedDates!.push(ProductionMappedDate.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductionReportItem {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionReportItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.matingItems)) {
            data["matingItems"] = [];
            for (let item of this.matingItems)
                data["matingItems"].push(item.toJSON());
        }
        if (Array.isArray(this.farrowingItems)) {
            data["farrowingItems"] = [];
            for (let item of this.farrowingItems)
                data["farrowingItems"].push(item.toJSON());
        }
        if (Array.isArray(this.weaningItems)) {
            data["weaningItems"] = [];
            for (let item of this.weaningItems)
                data["weaningItems"].push(item.toJSON());
        }
        data["productionScaleFeedReproduction"] = this.productionScaleFeedReproduction ? this.productionScaleFeedReproduction.toJSON() : <any>undefined;
        if (Array.isArray(this.statusItems)) {
            data["statusItems"] = [];
            for (let item of this.statusItems)
                data["statusItems"].push(item.toJSON());
        }
        if (Array.isArray(this.feedUsageItems)) {
            data["feedUsageItems"] = [];
            for (let item of this.feedUsageItems)
                data["feedUsageItems"].push(item.toJSON());
        }
        if (Array.isArray(this.mappedDates)) {
            data["mappedDates"] = [];
            for (let item of this.mappedDates)
                data["mappedDates"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProductionReportItem {
    matingItems?: MatingItem[] | undefined;
    farrowingItems?: FarrowingItem[] | undefined;
    weaningItems?: WeaningItem[] | undefined;
    productionScaleFeedReproduction?: ScaleFeedReproduction | undefined;
    statusItems?: StatusItem[] | undefined;
    feedUsageItems?: FeedUsagePerAnimal[] | undefined;
    mappedDates?: ProductionMappedDate[] | undefined;
}

export class MatingItem implements IMatingItem {
    matingBatch?: MatingBatch | undefined;
    totalMatings?: number | undefined;
    youngAnimalMatings?: number | undefined;
    reMatingPercent?: number | undefined;
    weaningToFirstMating?: number | undefined;
    avgWasteDays?: number | undefined;

    constructor(data?: IMatingItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.matingBatch = _data["matingBatch"] ? MatingBatch.fromJS(_data["matingBatch"]) : <any>undefined;
            this.totalMatings = _data["totalMatings"];
            this.youngAnimalMatings = _data["youngAnimalMatings"];
            this.reMatingPercent = _data["reMatingPercent"];
            this.weaningToFirstMating = _data["weaningToFirstMating"];
            this.avgWasteDays = _data["avgWasteDays"];
        }
    }

    static fromJS(data: any): MatingItem {
        data = typeof data === 'object' ? data : {};
        let result = new MatingItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["matingBatch"] = this.matingBatch ? this.matingBatch.toJSON() : <any>undefined;
        data["totalMatings"] = this.totalMatings;
        data["youngAnimalMatings"] = this.youngAnimalMatings;
        data["reMatingPercent"] = this.reMatingPercent;
        data["weaningToFirstMating"] = this.weaningToFirstMating;
        data["avgWasteDays"] = this.avgWasteDays;
        return data;
    }
}

export interface IMatingItem {
    matingBatch?: MatingBatch | undefined;
    totalMatings?: number | undefined;
    youngAnimalMatings?: number | undefined;
    reMatingPercent?: number | undefined;
    weaningToFirstMating?: number | undefined;
    avgWasteDays?: number | undefined;
}

export class FarrowingItem implements IFarrowingItem {
    matingBatch?: MatingBatch | undefined;
    totalFarrowings?: number | undefined;
    thereOfGiltsPcs?: number | undefined;
    alivePerLitterPcs?: number | undefined;
    deadPerLitter?: number | undefined;
    farrowingPercent?: number | undefined;
    avgPregnantDaysPerLitter?: number | undefined;
    farrowingPeriodStart!: Date;
    farrowingPeriodEnd!: Date;

    constructor(data?: IFarrowingItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.matingBatch = _data["matingBatch"] ? MatingBatch.fromJS(_data["matingBatch"]) : <any>undefined;
            this.totalFarrowings = _data["totalFarrowings"];
            this.thereOfGiltsPcs = _data["thereOfGiltsPcs"];
            this.alivePerLitterPcs = _data["alivePerLitterPcs"];
            this.deadPerLitter = _data["deadPerLitter"];
            this.farrowingPercent = _data["farrowingPercent"];
            this.avgPregnantDaysPerLitter = _data["avgPregnantDaysPerLitter"];
            this.farrowingPeriodStart = _data["farrowingPeriodStart"] ? new Date(_data["farrowingPeriodStart"].toString()) : <any>undefined;
            this.farrowingPeriodEnd = _data["farrowingPeriodEnd"] ? new Date(_data["farrowingPeriodEnd"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FarrowingItem {
        data = typeof data === 'object' ? data : {};
        let result = new FarrowingItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["matingBatch"] = this.matingBatch ? this.matingBatch.toJSON() : <any>undefined;
        data["totalFarrowings"] = this.totalFarrowings;
        data["thereOfGiltsPcs"] = this.thereOfGiltsPcs;
        data["alivePerLitterPcs"] = this.alivePerLitterPcs;
        data["deadPerLitter"] = this.deadPerLitter;
        data["farrowingPercent"] = this.farrowingPercent;
        data["avgPregnantDaysPerLitter"] = this.avgPregnantDaysPerLitter;
        data["farrowingPeriodStart"] = this.farrowingPeriodStart ? this.farrowingPeriodStart.toISOString() : <any>undefined;
        data["farrowingPeriodEnd"] = this.farrowingPeriodEnd ? this.farrowingPeriodEnd.toISOString() : <any>undefined;
        return data;
    }
}

export interface IFarrowingItem {
    matingBatch?: MatingBatch | undefined;
    totalFarrowings?: number | undefined;
    thereOfGiltsPcs?: number | undefined;
    alivePerLitterPcs?: number | undefined;
    deadPerLitter?: number | undefined;
    farrowingPercent?: number | undefined;
    avgPregnantDaysPerLitter?: number | undefined;
    farrowingPeriodStart: Date;
    farrowingPeriodEnd: Date;
}

export class WeaningItem implements IWeaningItem {
    matingBatch?: MatingBatch | undefined;
    totalWeanings?: number | undefined;
    thereOfFirstLitterPcs?: number | undefined;
    firstLitterPercent?: number | undefined;
    nursingSows?: number | undefined;
    nursingSowPercent?: number | undefined;
    avgAlivePerLitter?: number | undefined;
    avgDeadPerLitter?: number | undefined;
    avgWeanedPerLitter?: number | undefined;
    weanedPerWeaningPcs?: number | undefined;
    avgWeight?: number | undefined;
    deadTillWeaningPercent?: number | undefined;
    avgNursingDays?: number | undefined;
    weaningPeriodStart!: Date;
    weaningPeriodEnd!: Date;

    constructor(data?: IWeaningItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.matingBatch = _data["matingBatch"] ? MatingBatch.fromJS(_data["matingBatch"]) : <any>undefined;
            this.totalWeanings = _data["totalWeanings"];
            this.thereOfFirstLitterPcs = _data["thereOfFirstLitterPcs"];
            this.firstLitterPercent = _data["firstLitterPercent"];
            this.nursingSows = _data["nursingSows"];
            this.nursingSowPercent = _data["nursingSowPercent"];
            this.avgAlivePerLitter = _data["avgAlivePerLitter"];
            this.avgDeadPerLitter = _data["avgDeadPerLitter"];
            this.avgWeanedPerLitter = _data["avgWeanedPerLitter"];
            this.weanedPerWeaningPcs = _data["weanedPerWeaningPcs"];
            this.avgWeight = _data["avgWeight"];
            this.deadTillWeaningPercent = _data["deadTillWeaningPercent"];
            this.avgNursingDays = _data["avgNursingDays"];
            this.weaningPeriodStart = _data["weaningPeriodStart"] ? new Date(_data["weaningPeriodStart"].toString()) : <any>undefined;
            this.weaningPeriodEnd = _data["weaningPeriodEnd"] ? new Date(_data["weaningPeriodEnd"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): WeaningItem {
        data = typeof data === 'object' ? data : {};
        let result = new WeaningItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["matingBatch"] = this.matingBatch ? this.matingBatch.toJSON() : <any>undefined;
        data["totalWeanings"] = this.totalWeanings;
        data["thereOfFirstLitterPcs"] = this.thereOfFirstLitterPcs;
        data["firstLitterPercent"] = this.firstLitterPercent;
        data["nursingSows"] = this.nursingSows;
        data["nursingSowPercent"] = this.nursingSowPercent;
        data["avgAlivePerLitter"] = this.avgAlivePerLitter;
        data["avgDeadPerLitter"] = this.avgDeadPerLitter;
        data["avgWeanedPerLitter"] = this.avgWeanedPerLitter;
        data["weanedPerWeaningPcs"] = this.weanedPerWeaningPcs;
        data["avgWeight"] = this.avgWeight;
        data["deadTillWeaningPercent"] = this.deadTillWeaningPercent;
        data["avgNursingDays"] = this.avgNursingDays;
        data["weaningPeriodStart"] = this.weaningPeriodStart ? this.weaningPeriodStart.toISOString() : <any>undefined;
        data["weaningPeriodEnd"] = this.weaningPeriodEnd ? this.weaningPeriodEnd.toISOString() : <any>undefined;
        return data;
    }
}

export interface IWeaningItem {
    matingBatch?: MatingBatch | undefined;
    totalWeanings?: number | undefined;
    thereOfFirstLitterPcs?: number | undefined;
    firstLitterPercent?: number | undefined;
    nursingSows?: number | undefined;
    nursingSowPercent?: number | undefined;
    avgAlivePerLitter?: number | undefined;
    avgDeadPerLitter?: number | undefined;
    avgWeanedPerLitter?: number | undefined;
    weanedPerWeaningPcs?: number | undefined;
    avgWeight?: number | undefined;
    deadTillWeaningPercent?: number | undefined;
    avgNursingDays?: number | undefined;
    weaningPeriodStart: Date;
    weaningPeriodEnd: Date;
}

export class ScaleFeedReproduction implements IScaleFeedReproduction {
    productionScaleItems?: ProductionScaleItem[] | undefined;
    feedItems?: FeedItem[] | undefined;
    reproductions?: Reproduction[] | undefined;

    constructor(data?: IScaleFeedReproduction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["productionScaleItems"])) {
                this.productionScaleItems = [] as any;
                for (let item of _data["productionScaleItems"])
                    this.productionScaleItems!.push(ProductionScaleItem.fromJS(item));
            }
            if (Array.isArray(_data["feedItems"])) {
                this.feedItems = [] as any;
                for (let item of _data["feedItems"])
                    this.feedItems!.push(FeedItem.fromJS(item));
            }
            if (Array.isArray(_data["reproductions"])) {
                this.reproductions = [] as any;
                for (let item of _data["reproductions"])
                    this.reproductions!.push(Reproduction.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScaleFeedReproduction {
        data = typeof data === 'object' ? data : {};
        let result = new ScaleFeedReproduction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.productionScaleItems)) {
            data["productionScaleItems"] = [];
            for (let item of this.productionScaleItems)
                data["productionScaleItems"].push(item.toJSON());
        }
        if (Array.isArray(this.feedItems)) {
            data["feedItems"] = [];
            for (let item of this.feedItems)
                data["feedItems"].push(item.toJSON());
        }
        if (Array.isArray(this.reproductions)) {
            data["reproductions"] = [];
            for (let item of this.reproductions)
                data["reproductions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IScaleFeedReproduction {
    productionScaleItems?: ProductionScaleItem[] | undefined;
    feedItems?: FeedItem[] | undefined;
    reproductions?: Reproduction[] | undefined;
}

export class ProductionScaleItem implements IProductionScaleItem {
    yearSowPcs?: number | undefined;
    weanedPigletsPcs?: number | undefined;
    avgWeanedPerLitter?: number | undefined;
    avgWeightPerPiglet?: number | undefined;
    percentDeadSowGilts?: number | undefined;
    periodFeedDaysSowAndGilt?: number | undefined;
    periodFeedDaysYoungFemale?: number | undefined;
    productionDays?: number | undefined;
    nonProductiveDays?: number | undefined;
    correctedDays?: number | undefined;
    periodYearSowPcs?: number | undefined;
    periodPregnantDays?: number | undefined;

    constructor(data?: IProductionScaleItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.yearSowPcs = _data["yearSowPcs"];
            this.weanedPigletsPcs = _data["weanedPigletsPcs"];
            this.avgWeanedPerLitter = _data["avgWeanedPerLitter"];
            this.avgWeightPerPiglet = _data["avgWeightPerPiglet"];
            this.percentDeadSowGilts = _data["percentDeadSowGilts"];
            this.periodFeedDaysSowAndGilt = _data["periodFeedDaysSowAndGilt"];
            this.periodFeedDaysYoungFemale = _data["periodFeedDaysYoungFemale"];
            this.productionDays = _data["productionDays"];
            this.nonProductiveDays = _data["nonProductiveDays"];
            this.correctedDays = _data["correctedDays"];
            this.periodYearSowPcs = _data["periodYearSowPcs"];
            this.periodPregnantDays = _data["periodPregnantDays"];
        }
    }

    static fromJS(data: any): ProductionScaleItem {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionScaleItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["yearSowPcs"] = this.yearSowPcs;
        data["weanedPigletsPcs"] = this.weanedPigletsPcs;
        data["avgWeanedPerLitter"] = this.avgWeanedPerLitter;
        data["avgWeightPerPiglet"] = this.avgWeightPerPiglet;
        data["percentDeadSowGilts"] = this.percentDeadSowGilts;
        data["periodFeedDaysSowAndGilt"] = this.periodFeedDaysSowAndGilt;
        data["periodFeedDaysYoungFemale"] = this.periodFeedDaysYoungFemale;
        data["productionDays"] = this.productionDays;
        data["nonProductiveDays"] = this.nonProductiveDays;
        data["correctedDays"] = this.correctedDays;
        data["periodYearSowPcs"] = this.periodYearSowPcs;
        data["periodPregnantDays"] = this.periodPregnantDays;
        return data;
    }
}

export interface IProductionScaleItem {
    yearSowPcs?: number | undefined;
    weanedPigletsPcs?: number | undefined;
    avgWeanedPerLitter?: number | undefined;
    avgWeightPerPiglet?: number | undefined;
    percentDeadSowGilts?: number | undefined;
    periodFeedDaysSowAndGilt?: number | undefined;
    periodFeedDaysYoungFemale?: number | undefined;
    productionDays?: number | undefined;
    nonProductiveDays?: number | undefined;
    correctedDays?: number | undefined;
    periodYearSowPcs?: number | undefined;
    periodPregnantDays?: number | undefined;
}

export class FeedItem implements IFeedItem {
    sowFoodFeYearSow?: number | undefined;
    thereOfYoungAnimalFood?: number | undefined;
    fePerYearSowPerDay?: number | undefined;
    fePerYearYoungFemalePerDay?: number | undefined;

    constructor(data?: IFeedItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sowFoodFeYearSow = _data["sowFoodFeYearSow"];
            this.thereOfYoungAnimalFood = _data["thereOfYoungAnimalFood"];
            this.fePerYearSowPerDay = _data["fePerYearSowPerDay"];
            this.fePerYearYoungFemalePerDay = _data["fePerYearYoungFemalePerDay"];
        }
    }

    static fromJS(data: any): FeedItem {
        data = typeof data === 'object' ? data : {};
        let result = new FeedItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sowFoodFeYearSow"] = this.sowFoodFeYearSow;
        data["thereOfYoungAnimalFood"] = this.thereOfYoungAnimalFood;
        data["fePerYearSowPerDay"] = this.fePerYearSowPerDay;
        data["fePerYearYoungFemalePerDay"] = this.fePerYearYoungFemalePerDay;
        return data;
    }
}

export interface IFeedItem {
    sowFoodFeYearSow?: number | undefined;
    thereOfYoungAnimalFood?: number | undefined;
    fePerYearSowPerDay?: number | undefined;
    fePerYearYoungFemalePerDay?: number | undefined;
}

export class Reproduction implements IReproduction {
    wasteDaysPerDay?: number | undefined;
    thereOfAdjustedDays?: number | undefined;
    litterPerYearSowPcs?: number | undefined;
    weanedPigletsPerYearSowPcs?: number | undefined;
    producedLitters?: number | undefined;

    constructor(data?: IReproduction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wasteDaysPerDay = _data["wasteDaysPerDay"];
            this.thereOfAdjustedDays = _data["thereOfAdjustedDays"];
            this.litterPerYearSowPcs = _data["litterPerYearSowPcs"];
            this.weanedPigletsPerYearSowPcs = _data["weanedPigletsPerYearSowPcs"];
            this.producedLitters = _data["producedLitters"];
        }
    }

    static fromJS(data: any): Reproduction {
        data = typeof data === 'object' ? data : {};
        let result = new Reproduction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wasteDaysPerDay"] = this.wasteDaysPerDay;
        data["thereOfAdjustedDays"] = this.thereOfAdjustedDays;
        data["litterPerYearSowPcs"] = this.litterPerYearSowPcs;
        data["weanedPigletsPerYearSowPcs"] = this.weanedPigletsPerYearSowPcs;
        data["producedLitters"] = this.producedLitters;
        return data;
    }
}

export interface IReproduction {
    wasteDaysPerDay?: number | undefined;
    thereOfAdjustedDays?: number | undefined;
    litterPerYearSowPcs?: number | undefined;
    weanedPigletsPerYearSowPcs?: number | undefined;
    producedLitters?: number | undefined;
}

export class StatusItem implements IStatusItem {
    sowAndGiltPcs?: number | undefined;
    sowAndGiltEntrance?: number | undefined;
    sowAndGiltDepartured?: number | undefined;
    youngFemalePcs?: number | undefined;
    youngFemaleEntrance?: number | undefined;
    youngFemaleEntranceToGilt?: number | undefined;
    youngFemaleDepartured?: number | undefined;
    boarPcs?: number | undefined;
    boarEntrance?: number | undefined;
    boarDepartured?: number | undefined;
    pigletPcs?: number | undefined;
    sowAndGiltPregnantDays?: number | undefined;

    constructor(data?: IStatusItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sowAndGiltPcs = _data["sowAndGiltPcs"];
            this.sowAndGiltEntrance = _data["sowAndGiltEntrance"];
            this.sowAndGiltDepartured = _data["sowAndGiltDepartured"];
            this.youngFemalePcs = _data["youngFemalePcs"];
            this.youngFemaleEntrance = _data["youngFemaleEntrance"];
            this.youngFemaleEntranceToGilt = _data["youngFemaleEntranceToGilt"];
            this.youngFemaleDepartured = _data["youngFemaleDepartured"];
            this.boarPcs = _data["boarPcs"];
            this.boarEntrance = _data["boarEntrance"];
            this.boarDepartured = _data["boarDepartured"];
            this.pigletPcs = _data["pigletPcs"];
            this.sowAndGiltPregnantDays = _data["sowAndGiltPregnantDays"];
        }
    }

    static fromJS(data: any): StatusItem {
        data = typeof data === 'object' ? data : {};
        let result = new StatusItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sowAndGiltPcs"] = this.sowAndGiltPcs;
        data["sowAndGiltEntrance"] = this.sowAndGiltEntrance;
        data["sowAndGiltDepartured"] = this.sowAndGiltDepartured;
        data["youngFemalePcs"] = this.youngFemalePcs;
        data["youngFemaleEntrance"] = this.youngFemaleEntrance;
        data["youngFemaleEntranceToGilt"] = this.youngFemaleEntranceToGilt;
        data["youngFemaleDepartured"] = this.youngFemaleDepartured;
        data["boarPcs"] = this.boarPcs;
        data["boarEntrance"] = this.boarEntrance;
        data["boarDepartured"] = this.boarDepartured;
        data["pigletPcs"] = this.pigletPcs;
        data["sowAndGiltPregnantDays"] = this.sowAndGiltPregnantDays;
        return data;
    }
}

export interface IStatusItem {
    sowAndGiltPcs?: number | undefined;
    sowAndGiltEntrance?: number | undefined;
    sowAndGiltDepartured?: number | undefined;
    youngFemalePcs?: number | undefined;
    youngFemaleEntrance?: number | undefined;
    youngFemaleEntranceToGilt?: number | undefined;
    youngFemaleDepartured?: number | undefined;
    boarPcs?: number | undefined;
    boarEntrance?: number | undefined;
    boarDepartured?: number | undefined;
    pigletPcs?: number | undefined;
    sowAndGiltPregnantDays?: number | undefined;
}

export class ProductionMappedDate implements IProductionMappedDate {
    toDate?: string | undefined;
    fromDate?: string | undefined;
    difference?: string | undefined;

    constructor(data?: IProductionMappedDate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.toDate = _data["toDate"];
            this.fromDate = _data["fromDate"];
            this.difference = _data["difference"];
        }
    }

    static fromJS(data: any): ProductionMappedDate {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionMappedDate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["toDate"] = this.toDate;
        data["fromDate"] = this.fromDate;
        data["difference"] = this.difference;
        return data;
    }
}

export interface IProductionMappedDate {
    toDate?: string | undefined;
    fromDate?: string | undefined;
    difference?: string | undefined;
}

export class ProductionReportSetting extends SiteEntity implements IProductionReportSetting {
    keyNumbers?: { [key: string]: boolean; } | undefined;
    periods?: PReportPeriod[] | undefined;
    specialFromDate?: Date | undefined;
    specialToDate?: Date | undefined;
    growthPigPReportProduction?: GrowthProductionReportSettingProductionKey | undefined;
    growthPigPReportFeed?: GrowthProductionReportSettingFeedKey | undefined;
    growthPigPReportDiverseInformation?: GrowthProductionReportSettingDiverseInformationKey | undefined;
    growthPigPReportSlaughterHouseData?: GrowthProductionReportSettingSlaughterDataKey | undefined;
    growthPigPReportState?: GrowthProductionReportSettingStateKey | undefined;
    growthPigPReportSubResults?: GrowthProductionReportSettingSubResultKey | undefined;
    showFeedUsage!: boolean;
    animaltype!: AnimalType;

    constructor(data?: IProductionReportSetting) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (_data["keyNumbers"]) {
                this.keyNumbers = {} as any;
                for (let key in _data["keyNumbers"]) {
                    if (_data["keyNumbers"].hasOwnProperty(key))
                        (<any>this.keyNumbers)![key] = _data["keyNumbers"][key];
                }
            }
            if (Array.isArray(_data["periods"])) {
                this.periods = [] as any;
                for (let item of _data["periods"])
                    this.periods!.push(PReportPeriod.fromJS(item));
            }
            this.specialFromDate = _data["specialFromDate"] ? new Date(_data["specialFromDate"].toString()) : <any>undefined;
            this.specialToDate = _data["specialToDate"] ? new Date(_data["specialToDate"].toString()) : <any>undefined;
            this.growthPigPReportProduction = _data["growthPigPReportProduction"] ? GrowthProductionReportSettingProductionKey.fromJS(_data["growthPigPReportProduction"]) : <any>undefined;
            this.growthPigPReportFeed = _data["growthPigPReportFeed"] ? GrowthProductionReportSettingFeedKey.fromJS(_data["growthPigPReportFeed"]) : <any>undefined;
            this.growthPigPReportDiverseInformation = _data["growthPigPReportDiverseInformation"] ? GrowthProductionReportSettingDiverseInformationKey.fromJS(_data["growthPigPReportDiverseInformation"]) : <any>undefined;
            this.growthPigPReportSlaughterHouseData = _data["growthPigPReportSlaughterHouseData"] ? GrowthProductionReportSettingSlaughterDataKey.fromJS(_data["growthPigPReportSlaughterHouseData"]) : <any>undefined;
            this.growthPigPReportState = _data["growthPigPReportState"] ? GrowthProductionReportSettingStateKey.fromJS(_data["growthPigPReportState"]) : <any>undefined;
            this.growthPigPReportSubResults = _data["growthPigPReportSubResults"] ? GrowthProductionReportSettingSubResultKey.fromJS(_data["growthPigPReportSubResults"]) : <any>undefined;
            this.showFeedUsage = _data["showFeedUsage"];
            this.animaltype = _data["animaltype"];
        }
    }

    static override fromJS(data: any): ProductionReportSetting {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionReportSetting();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.keyNumbers) {
            data["keyNumbers"] = {};
            for (let key in this.keyNumbers) {
                if (this.keyNumbers.hasOwnProperty(key))
                    (<any>data["keyNumbers"])[key] = (<any>this.keyNumbers)[key];
            }
        }
        if (Array.isArray(this.periods)) {
            data["periods"] = [];
            for (let item of this.periods)
                data["periods"].push(item.toJSON());
        }
        data["specialFromDate"] = this.specialFromDate ? this.specialFromDate.toISOString() : <any>undefined;
        data["specialToDate"] = this.specialToDate ? this.specialToDate.toISOString() : <any>undefined;
        data["growthPigPReportProduction"] = this.growthPigPReportProduction ? this.growthPigPReportProduction.toJSON() : <any>undefined;
        data["growthPigPReportFeed"] = this.growthPigPReportFeed ? this.growthPigPReportFeed.toJSON() : <any>undefined;
        data["growthPigPReportDiverseInformation"] = this.growthPigPReportDiverseInformation ? this.growthPigPReportDiverseInformation.toJSON() : <any>undefined;
        data["growthPigPReportSlaughterHouseData"] = this.growthPigPReportSlaughterHouseData ? this.growthPigPReportSlaughterHouseData.toJSON() : <any>undefined;
        data["growthPigPReportState"] = this.growthPigPReportState ? this.growthPigPReportState.toJSON() : <any>undefined;
        data["growthPigPReportSubResults"] = this.growthPigPReportSubResults ? this.growthPigPReportSubResults.toJSON() : <any>undefined;
        data["showFeedUsage"] = this.showFeedUsage;
        data["animaltype"] = this.animaltype;
        super.toJSON(data);
        return data;
    }
}

export interface IProductionReportSetting extends ISiteEntity {
    keyNumbers?: { [key: string]: boolean; } | undefined;
    periods?: PReportPeriod[] | undefined;
    specialFromDate?: Date | undefined;
    specialToDate?: Date | undefined;
    growthPigPReportProduction?: GrowthProductionReportSettingProductionKey | undefined;
    growthPigPReportFeed?: GrowthProductionReportSettingFeedKey | undefined;
    growthPigPReportDiverseInformation?: GrowthProductionReportSettingDiverseInformationKey | undefined;
    growthPigPReportSlaughterHouseData?: GrowthProductionReportSettingSlaughterDataKey | undefined;
    growthPigPReportState?: GrowthProductionReportSettingStateKey | undefined;
    growthPigPReportSubResults?: GrowthProductionReportSettingSubResultKey | undefined;
    showFeedUsage: boolean;
    animaltype: AnimalType;
}

export class PReportPeriod implements IPReportPeriod {
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    periodNumber!: number;

    constructor(data?: IPReportPeriod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : <any>undefined;
            this.periodNumber = _data["periodNumber"];
        }
    }

    static fromJS(data: any): PReportPeriod {
        data = typeof data === 'object' ? data : {};
        let result = new PReportPeriod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["periodNumber"] = this.periodNumber;
        return data;
    }
}

export interface IPReportPeriod {
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    periodNumber: number;
}

export class GrowthProductionReportSettingProductionKey implements IGrowthProductionReportSettingProductionKey {
    producedPigsPcs!: boolean;
    dailyGrowth!: boolean;
    referenceDailyGrowth!: boolean;

    constructor(data?: IGrowthProductionReportSettingProductionKey) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.producedPigsPcs = _data["producedPigsPcs"];
            this.dailyGrowth = _data["dailyGrowth"];
            this.referenceDailyGrowth = _data["referenceDailyGrowth"];
        }
    }

    static fromJS(data: any): GrowthProductionReportSettingProductionKey {
        data = typeof data === 'object' ? data : {};
        let result = new GrowthProductionReportSettingProductionKey();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["producedPigsPcs"] = this.producedPigsPcs;
        data["dailyGrowth"] = this.dailyGrowth;
        data["referenceDailyGrowth"] = this.referenceDailyGrowth;
        return data;
    }
}

export interface IGrowthProductionReportSettingProductionKey {
    producedPigsPcs: boolean;
    dailyGrowth: boolean;
    referenceDailyGrowth: boolean;
}

export class GrowthProductionReportSettingFeedKey implements IGrowthProductionReportSettingFeedKey {
    feedPerPigDaily!: boolean;
    feedPerKgGrowth!: boolean;
    referenceFeedUsage!: boolean;
    feedPerProducedPig!: boolean;

    constructor(data?: IGrowthProductionReportSettingFeedKey) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.feedPerPigDaily = _data["feedPerPigDaily"];
            this.feedPerKgGrowth = _data["feedPerKgGrowth"];
            this.referenceFeedUsage = _data["referenceFeedUsage"];
            this.feedPerProducedPig = _data["feedPerProducedPig"];
        }
    }

    static fromJS(data: any): GrowthProductionReportSettingFeedKey {
        data = typeof data === 'object' ? data : {};
        let result = new GrowthProductionReportSettingFeedKey();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["feedPerPigDaily"] = this.feedPerPigDaily;
        data["feedPerKgGrowth"] = this.feedPerKgGrowth;
        data["referenceFeedUsage"] = this.referenceFeedUsage;
        data["feedPerProducedPig"] = this.feedPerProducedPig;
        return data;
    }
}

export interface IGrowthProductionReportSettingFeedKey {
    feedPerPigDaily: boolean;
    feedPerKgGrowth: boolean;
    referenceFeedUsage: boolean;
    feedPerProducedPig: boolean;
}

export class GrowthProductionReportSettingDiverseInformationKey implements IGrowthProductionReportSettingDiverseInformationKey {
    growthPerPigKg!: boolean;
    avgWeightAtEntry!: boolean;
    avgWeightAtDeparture!: boolean;
    feedDaysPerProducedPigs!: boolean;
    diversePercentDead!: boolean;

    constructor(data?: IGrowthProductionReportSettingDiverseInformationKey) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.growthPerPigKg = _data["growthPerPigKg"];
            this.avgWeightAtEntry = _data["avgWeightAtEntry"];
            this.avgWeightAtDeparture = _data["avgWeightAtDeparture"];
            this.feedDaysPerProducedPigs = _data["feedDaysPerProducedPigs"];
            this.diversePercentDead = _data["diversePercentDead"];
        }
    }

    static fromJS(data: any): GrowthProductionReportSettingDiverseInformationKey {
        data = typeof data === 'object' ? data : {};
        let result = new GrowthProductionReportSettingDiverseInformationKey();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["growthPerPigKg"] = this.growthPerPigKg;
        data["avgWeightAtEntry"] = this.avgWeightAtEntry;
        data["avgWeightAtDeparture"] = this.avgWeightAtDeparture;
        data["feedDaysPerProducedPigs"] = this.feedDaysPerProducedPigs;
        data["diversePercentDead"] = this.diversePercentDead;
        return data;
    }
}

export interface IGrowthProductionReportSettingDiverseInformationKey {
    growthPerPigKg: boolean;
    avgWeightAtEntry: boolean;
    avgWeightAtDeparture: boolean;
    feedDaysPerProducedPigs: boolean;
    diversePercentDead: boolean;
}

export class GrowthProductionReportSettingSlaughterDataKey implements IGrowthProductionReportSettingSlaughterDataKey {
    amountBasicPcs!: boolean;
    amountOverPcs!: boolean;
    amountUnderPcs!: boolean;
    avgSlaughterWeight!: boolean;
    avgMeatPercentage!: boolean;
    avgDiscarded!: boolean;

    constructor(data?: IGrowthProductionReportSettingSlaughterDataKey) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amountBasicPcs = _data["amountBasicPcs"];
            this.amountOverPcs = _data["amountOverPcs"];
            this.amountUnderPcs = _data["amountUnderPcs"];
            this.avgSlaughterWeight = _data["avgSlaughterWeight"];
            this.avgMeatPercentage = _data["avgMeatPercentage"];
            this.avgDiscarded = _data["avgDiscarded"];
        }
    }

    static fromJS(data: any): GrowthProductionReportSettingSlaughterDataKey {
        data = typeof data === 'object' ? data : {};
        let result = new GrowthProductionReportSettingSlaughterDataKey();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amountBasicPcs"] = this.amountBasicPcs;
        data["amountOverPcs"] = this.amountOverPcs;
        data["amountUnderPcs"] = this.amountUnderPcs;
        data["avgSlaughterWeight"] = this.avgSlaughterWeight;
        data["avgMeatPercentage"] = this.avgMeatPercentage;
        data["avgDiscarded"] = this.avgDiscarded;
        return data;
    }
}

export interface IGrowthProductionReportSettingSlaughterDataKey {
    amountBasicPcs: boolean;
    amountOverPcs: boolean;
    amountUnderPcs: boolean;
    avgSlaughterWeight: boolean;
    avgMeatPercentage: boolean;
    avgDiscarded: boolean;
}

export class GrowthProductionReportSettingStateKey implements IGrowthProductionReportSettingStateKey {
    activePcs!: boolean;
    activeWeight!: boolean;
    totalEntryInPeriod!: boolean;
    entryFromWeaning!: boolean;
    entryFromBought!: boolean;
    entryFromTransfered!: boolean;
    avgWeightAtEntry!: boolean;
    deadPutDownPcs!: boolean;
    avgWeightDeadPutDown!: boolean;
    soldTransferedPcs!: boolean;
    transferedToYoungFemale!: boolean;
    avgWeightSoldTransfered!: boolean;
    delieveredPcs!: boolean;
    avgWeightDelievered!: boolean;
    totalSlaughteredRegistrations!: boolean;
    avgWeightSlaughteredRegistrations!: boolean;

    constructor(data?: IGrowthProductionReportSettingStateKey) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activePcs = _data["activePcs"];
            this.activeWeight = _data["activeWeight"];
            this.totalEntryInPeriod = _data["totalEntryInPeriod"];
            this.entryFromWeaning = _data["entryFromWeaning"];
            this.entryFromBought = _data["entryFromBought"];
            this.entryFromTransfered = _data["entryFromTransfered"];
            this.avgWeightAtEntry = _data["avgWeightAtEntry"];
            this.deadPutDownPcs = _data["deadPutDownPcs"];
            this.avgWeightDeadPutDown = _data["avgWeightDeadPutDown"];
            this.soldTransferedPcs = _data["soldTransferedPcs"];
            this.transferedToYoungFemale = _data["transferedToYoungFemale"];
            this.avgWeightSoldTransfered = _data["avgWeightSoldTransfered"];
            this.delieveredPcs = _data["delieveredPcs"];
            this.avgWeightDelievered = _data["avgWeightDelievered"];
            this.totalSlaughteredRegistrations = _data["totalSlaughteredRegistrations"];
            this.avgWeightSlaughteredRegistrations = _data["avgWeightSlaughteredRegistrations"];
        }
    }

    static fromJS(data: any): GrowthProductionReportSettingStateKey {
        data = typeof data === 'object' ? data : {};
        let result = new GrowthProductionReportSettingStateKey();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activePcs"] = this.activePcs;
        data["activeWeight"] = this.activeWeight;
        data["totalEntryInPeriod"] = this.totalEntryInPeriod;
        data["entryFromWeaning"] = this.entryFromWeaning;
        data["entryFromBought"] = this.entryFromBought;
        data["entryFromTransfered"] = this.entryFromTransfered;
        data["avgWeightAtEntry"] = this.avgWeightAtEntry;
        data["deadPutDownPcs"] = this.deadPutDownPcs;
        data["avgWeightDeadPutDown"] = this.avgWeightDeadPutDown;
        data["soldTransferedPcs"] = this.soldTransferedPcs;
        data["transferedToYoungFemale"] = this.transferedToYoungFemale;
        data["avgWeightSoldTransfered"] = this.avgWeightSoldTransfered;
        data["delieveredPcs"] = this.delieveredPcs;
        data["avgWeightDelievered"] = this.avgWeightDelievered;
        data["totalSlaughteredRegistrations"] = this.totalSlaughteredRegistrations;
        data["avgWeightSlaughteredRegistrations"] = this.avgWeightSlaughteredRegistrations;
        return data;
    }
}

export interface IGrowthProductionReportSettingStateKey {
    activePcs: boolean;
    activeWeight: boolean;
    totalEntryInPeriod: boolean;
    entryFromWeaning: boolean;
    entryFromBought: boolean;
    entryFromTransfered: boolean;
    avgWeightAtEntry: boolean;
    deadPutDownPcs: boolean;
    avgWeightDeadPutDown: boolean;
    soldTransferedPcs: boolean;
    transferedToYoungFemale: boolean;
    avgWeightSoldTransfered: boolean;
    delieveredPcs: boolean;
    avgWeightDelievered: boolean;
    totalSlaughteredRegistrations: boolean;
    avgWeightSlaughteredRegistrations: boolean;
}

export class GrowthProductionReportSettingSubResultKey implements IGrowthProductionReportSettingSubResultKey {
    feedDays!: boolean;
    periodGrowth!: boolean;

    constructor(data?: IGrowthProductionReportSettingSubResultKey) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.feedDays = _data["feedDays"];
            this.periodGrowth = _data["periodGrowth"];
        }
    }

    static fromJS(data: any): GrowthProductionReportSettingSubResultKey {
        data = typeof data === 'object' ? data : {};
        let result = new GrowthProductionReportSettingSubResultKey();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["feedDays"] = this.feedDays;
        data["periodGrowth"] = this.periodGrowth;
        return data;
    }
}

export interface IGrowthProductionReportSettingSubResultKey {
    feedDays: boolean;
    periodGrowth: boolean;
}

export abstract class BaseSingleSyncOfProductionReportSetting implements IBaseSingleSyncOfProductionReportSetting {
    syncTime!: Date;

    constructor(data?: IBaseSingleSyncOfProductionReportSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.syncTime = _data["syncTime"] ? new Date(_data["syncTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseSingleSyncOfProductionReportSetting {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseSingleSyncOfProductionReportSetting' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["syncTime"] = this.syncTime ? this.syncTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBaseSingleSyncOfProductionReportSetting {
    syncTime: Date;
}

export class SyncSingleDataProductionReportSetting extends BaseSingleSyncOfProductionReportSetting implements ISyncSingleDataProductionReportSetting {
    data?: ProductionReportSetting | undefined;

    constructor(data?: ISyncSingleDataProductionReportSetting) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? ProductionReportSetting.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): SyncSingleDataProductionReportSetting {
        data = typeof data === 'object' ? data : {};
        let result = new SyncSingleDataProductionReportSetting();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ISyncSingleDataProductionReportSetting extends IBaseSingleSyncOfProductionReportSetting {
    data?: ProductionReportSetting | undefined;
}

export abstract class BaseSyncOfProductionReportSetting implements IBaseSyncOfProductionReportSetting {
    syncTime!: Date;

    protected _discriminator: string;

    constructor(data?: IBaseSyncOfProductionReportSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "BaseSyncOfProductionReportSetting";
    }

    init(_data?: any) {
        if (_data) {
            this.syncTime = _data["syncTime"] ? new Date(_data["syncTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseSyncOfProductionReportSetting {
        data = typeof data === 'object' ? data : {};
        if (data["_discriminator"] === "SyncDataProductionReportSetting") {
            let result = new SyncDataProductionReportSetting();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'BaseSyncOfProductionReportSetting' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_discriminator"] = this._discriminator;
        data["syncTime"] = this.syncTime ? this.syncTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBaseSyncOfProductionReportSetting {
    syncTime: Date;
}

export class SyncDataProductionReportSetting extends BaseSyncOfProductionReportSetting implements ISyncDataProductionReportSetting {
    datas?: ProductionReportSetting[] | undefined;

    constructor(data?: ISyncDataProductionReportSetting) {
        super(data);
        this._discriminator = "SyncDataProductionReportSetting";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["datas"])) {
                this.datas = [] as any;
                for (let item of _data["datas"])
                    this.datas!.push(ProductionReportSetting.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): SyncDataProductionReportSetting {
        data = typeof data === 'object' ? data : {};
        let result = new SyncDataProductionReportSetting();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.datas)) {
            data["datas"] = [];
            for (let item of this.datas)
                data["datas"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISyncDataProductionReportSetting extends IBaseSyncOfProductionReportSetting {
    datas?: ProductionReportSetting[] | undefined;
}

export class Reason extends Unique implements IReason {
    name?: { [key: string]: string; } | undefined;
    priorityCode!: number;

    constructor(data?: IReason) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (_data["name"]) {
                this.name = {} as any;
                for (let key in _data["name"]) {
                    if (_data["name"].hasOwnProperty(key))
                        (<any>this.name)![key] = _data["name"][key];
                }
            }
            this.priorityCode = _data["priorityCode"];
        }
    }

    static override fromJS(data: any): Reason {
        data = typeof data === 'object' ? data : {};
        let result = new Reason();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.name) {
            data["name"] = {};
            for (let key in this.name) {
                if (this.name.hasOwnProperty(key))
                    (<any>data["name"])[key] = (<any>this.name)[key];
            }
        }
        data["priorityCode"] = this.priorityCode;
        super.toJSON(data);
        return data;
    }
}

export interface IReason extends IUnique {
    name?: { [key: string]: string; } | undefined;
    priorityCode: number;
}

export class ReasonSettings extends SiteEntity implements IReasonSettings {
    reasonId?: string | undefined;
    pigletDead!: boolean;
    pigletPutDown!: boolean;
    stemAnimalDead!: boolean;
    stemAnimalDeparture!: boolean;
    finisherDead!: boolean;
    weanerDead!: boolean;
    finisherPutDown!: boolean;
    weanerPutDown!: boolean;
    weanerSold!: boolean;
    finisherSold!: boolean;
    finisherSlaughtered!: boolean;

    constructor(data?: IReasonSettings) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.reasonId = _data["reasonId"];
            this.pigletDead = _data["pigletDead"];
            this.pigletPutDown = _data["pigletPutDown"];
            this.stemAnimalDead = _data["stemAnimalDead"];
            this.stemAnimalDeparture = _data["stemAnimalDeparture"];
            this.finisherDead = _data["finisherDead"];
            this.weanerDead = _data["weanerDead"];
            this.finisherPutDown = _data["finisherPutDown"];
            this.weanerPutDown = _data["weanerPutDown"];
            this.weanerSold = _data["weanerSold"];
            this.finisherSold = _data["finisherSold"];
            this.finisherSlaughtered = _data["finisherSlaughtered"];
        }
    }

    static override fromJS(data: any): ReasonSettings {
        data = typeof data === 'object' ? data : {};
        let result = new ReasonSettings();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reasonId"] = this.reasonId;
        data["pigletDead"] = this.pigletDead;
        data["pigletPutDown"] = this.pigletPutDown;
        data["stemAnimalDead"] = this.stemAnimalDead;
        data["stemAnimalDeparture"] = this.stemAnimalDeparture;
        data["finisherDead"] = this.finisherDead;
        data["weanerDead"] = this.weanerDead;
        data["finisherPutDown"] = this.finisherPutDown;
        data["weanerPutDown"] = this.weanerPutDown;
        data["weanerSold"] = this.weanerSold;
        data["finisherSold"] = this.finisherSold;
        data["finisherSlaughtered"] = this.finisherSlaughtered;
        super.toJSON(data);
        return data;
    }
}

export interface IReasonSettings extends ISiteEntity {
    reasonId?: string | undefined;
    pigletDead: boolean;
    pigletPutDown: boolean;
    stemAnimalDead: boolean;
    stemAnimalDeparture: boolean;
    finisherDead: boolean;
    weanerDead: boolean;
    finisherPutDown: boolean;
    weanerPutDown: boolean;
    weanerSold: boolean;
    finisherSold: boolean;
    finisherSlaughtered: boolean;
}

export abstract class BaseSyncOfReasonDto implements IBaseSyncOfReasonDto {
    syncTime!: Date;

    protected _discriminator: string;

    constructor(data?: IBaseSyncOfReasonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "BaseSyncOfReasonDto";
    }

    init(_data?: any) {
        if (_data) {
            this.syncTime = _data["syncTime"] ? new Date(_data["syncTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseSyncOfReasonDto {
        data = typeof data === 'object' ? data : {};
        if (data["_discriminator"] === "SyncDataReason") {
            let result = new SyncDataReason();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'BaseSyncOfReasonDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_discriminator"] = this._discriminator;
        data["syncTime"] = this.syncTime ? this.syncTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBaseSyncOfReasonDto {
    syncTime: Date;
}

export class SyncDataReason extends BaseSyncOfReasonDto implements ISyncDataReason {
    datas?: ReasonDto[] | undefined;

    constructor(data?: ISyncDataReason) {
        super(data);
        this._discriminator = "SyncDataReason";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["datas"])) {
                this.datas = [] as any;
                for (let item of _data["datas"])
                    this.datas!.push(ReasonDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): SyncDataReason {
        data = typeof data === 'object' ? data : {};
        let result = new SyncDataReason();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.datas)) {
            data["datas"] = [];
            for (let item of this.datas)
                data["datas"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISyncDataReason extends IBaseSyncOfReasonDto {
    datas?: ReasonDto[] | undefined;
}

export class ReasonDto implements IReasonDto {
    reason?: Reason | undefined;
    reasonSettings?: ReasonSettings | undefined;

    constructor(data?: IReasonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reason = _data["reason"] ? Reason.fromJS(_data["reason"]) : <any>undefined;
            this.reasonSettings = _data["reasonSettings"] ? ReasonSettings.fromJS(_data["reasonSettings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ReasonDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReasonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason ? this.reason.toJSON() : <any>undefined;
        data["reasonSettings"] = this.reasonSettings ? this.reasonSettings.toJSON() : <any>undefined;
        return data;
    }
}

export interface IReasonDto {
    reason?: Reason | undefined;
    reasonSettings?: ReasonSettings | undefined;
}

export abstract class BaseSyncOfReasonDtoV1 implements IBaseSyncOfReasonDtoV1 {
    syncTime!: Date;

    protected _discriminator: string;

    constructor(data?: IBaseSyncOfReasonDtoV1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "BaseSyncOfReasonDtoV1";
    }

    init(_data?: any) {
        if (_data) {
            this.syncTime = _data["syncTime"] ? new Date(_data["syncTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseSyncOfReasonDtoV1 {
        data = typeof data === 'object' ? data : {};
        if (data["_discriminator"] === "SyncDataReasonV1") {
            let result = new SyncDataReasonV1();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'BaseSyncOfReasonDtoV1' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_discriminator"] = this._discriminator;
        data["syncTime"] = this.syncTime ? this.syncTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBaseSyncOfReasonDtoV1 {
    syncTime: Date;
}

export class SyncDataReasonV1 extends BaseSyncOfReasonDtoV1 implements ISyncDataReasonV1 {
    datas?: ReasonDtoV1[] | undefined;

    constructor(data?: ISyncDataReasonV1) {
        super(data);
        this._discriminator = "SyncDataReasonV1";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["datas"])) {
                this.datas = [] as any;
                for (let item of _data["datas"])
                    this.datas!.push(ReasonDtoV1.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): SyncDataReasonV1 {
        data = typeof data === 'object' ? data : {};
        let result = new SyncDataReasonV1();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.datas)) {
            data["datas"] = [];
            for (let item of this.datas)
                data["datas"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISyncDataReasonV1 extends IBaseSyncOfReasonDtoV1 {
    datas?: ReasonDtoV1[] | undefined;
}

export class ReasonDtoV1 implements IReasonDtoV1 {
    reason?: ReasonOld | undefined;
    reasonSettings?: ReasonSettings | undefined;

    constructor(data?: IReasonDtoV1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reason = _data["reason"] ? ReasonOld.fromJS(_data["reason"]) : <any>undefined;
            this.reasonSettings = _data["reasonSettings"] ? ReasonSettings.fromJS(_data["reasonSettings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ReasonDtoV1 {
        data = typeof data === 'object' ? data : {};
        let result = new ReasonDtoV1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason ? this.reason.toJSON() : <any>undefined;
        data["reasonSettings"] = this.reasonSettings ? this.reasonSettings.toJSON() : <any>undefined;
        return data;
    }
}

export interface IReasonDtoV1 {
    reason?: ReasonOld | undefined;
    reasonSettings?: ReasonSettings | undefined;
}

export class ReasonOld extends Unique implements IReasonOld {
    name?: string | undefined;
    priorityCode!: number;

    constructor(data?: IReasonOld) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.priorityCode = _data["priorityCode"];
        }
    }

    static override fromJS(data: any): ReasonOld {
        data = typeof data === 'object' ? data : {};
        let result = new ReasonOld();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["priorityCode"] = this.priorityCode;
        super.toJSON(data);
        return data;
    }
}

export interface IReasonOld extends IUnique {
    name?: string | undefined;
    priorityCode: number;
}

export class Recipe extends BaseAvailableResource implements IRecipe {

    constructor(data?: IRecipe) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): Recipe {
        data = typeof data === 'object' ? data : {};
        let result = new Recipe();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IRecipe extends IBaseAvailableResource {
}

export class RecipeDto implements IRecipeDto {
    name?: string | undefined;
    recipeNumber!: number;
    type?: string | undefined;
    location?: string | undefined;
    id?: string | undefined;
    siteId?: string | undefined;
    isSkioldDigitalRecipe!: boolean;
    animalType!: AnimalType;
    locationType!: LocationType;

    constructor(data?: IRecipeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.recipeNumber = _data["recipeNumber"];
            this.type = _data["type"];
            this.location = _data["location"];
            this.id = _data["id"];
            this.siteId = _data["siteId"];
            this.isSkioldDigitalRecipe = _data["isSkioldDigitalRecipe"];
            this.animalType = _data["animalType"];
            this.locationType = _data["locationType"];
        }
    }

    static fromJS(data: any): RecipeDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecipeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["recipeNumber"] = this.recipeNumber;
        data["type"] = this.type;
        data["location"] = this.location;
        data["id"] = this.id;
        data["siteId"] = this.siteId;
        data["isSkioldDigitalRecipe"] = this.isSkioldDigitalRecipe;
        data["animalType"] = this.animalType;
        data["locationType"] = this.locationType;
        return data;
    }
}

export interface IRecipeDto {
    name?: string | undefined;
    recipeNumber: number;
    type?: string | undefined;
    location?: string | undefined;
    id?: string | undefined;
    siteId?: string | undefined;
    isSkioldDigitalRecipe: boolean;
    animalType: AnimalType;
    locationType: LocationType;
}

export class RegistrationErrorDto implements IRegistrationErrorDto {
    model?: { [key: string]: any; } | undefined;
    error?: string | undefined;

    constructor(data?: IRegistrationErrorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["model"]) {
                this.model = {} as any;
                for (let key in _data["model"]) {
                    if (_data["model"].hasOwnProperty(key))
                        (<any>this.model)![key] = _data["model"][key];
                }
            }
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): RegistrationErrorDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationErrorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.model) {
            data["model"] = {};
            for (let key in this.model) {
                if (this.model.hasOwnProperty(key))
                    (<any>data["model"])[key] = (<any>this.model)[key];
            }
        }
        data["error"] = this.error;
        return data;
    }
}

export interface IRegistrationErrorDto {
    model?: { [key: string]: any; } | undefined;
    error?: string | undefined;
}

export class WeekReportTableModel implements IWeekReportTableModel {
    periods?: PReportPeriod[] | undefined;
    weekReportTableItems?: WeekReportTableItem[] | undefined;

    constructor(data?: IWeekReportTableModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["periods"])) {
                this.periods = [] as any;
                for (let item of _data["periods"])
                    this.periods!.push(PReportPeriod.fromJS(item));
            }
            if (Array.isArray(_data["weekReportTableItems"])) {
                this.weekReportTableItems = [] as any;
                for (let item of _data["weekReportTableItems"])
                    this.weekReportTableItems!.push(WeekReportTableItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WeekReportTableModel {
        data = typeof data === 'object' ? data : {};
        let result = new WeekReportTableModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.periods)) {
            data["periods"] = [];
            for (let item of this.periods)
                data["periods"].push(item.toJSON());
        }
        if (Array.isArray(this.weekReportTableItems)) {
            data["weekReportTableItems"] = [];
            for (let item of this.weekReportTableItems)
                data["weekReportTableItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IWeekReportTableModel {
    periods?: PReportPeriod[] | undefined;
    weekReportTableItems?: WeekReportTableItem[] | undefined;
}

export class WeekReportTableItem implements IWeekReportTableItem {
    name?: string | undefined;
    periods?: { [key: string]: string; } | undefined;

    constructor(data?: IWeekReportTableItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (_data["periods"]) {
                this.periods = {} as any;
                for (let key in _data["periods"]) {
                    if (_data["periods"].hasOwnProperty(key))
                        (<any>this.periods)![key] = _data["periods"][key];
                }
            }
        }
    }

    static fromJS(data: any): WeekReportTableItem {
        data = typeof data === 'object' ? data : {};
        let result = new WeekReportTableItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.periods) {
            data["periods"] = {};
            for (let key in this.periods) {
                if (this.periods.hasOwnProperty(key))
                    (<any>data["periods"])[key] = (<any>this.periods)[key];
            }
        }
        return data;
    }
}

export interface IWeekReportTableItem {
    name?: string | undefined;
    periods?: { [key: string]: string; } | undefined;
}

export class WeekReportRequest implements IWeekReportRequest {
    siteId?: string | undefined;
    periods?: PReportPeriod[] | undefined;

    constructor(data?: IWeekReportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.siteId = _data["siteId"];
            if (Array.isArray(_data["periods"])) {
                this.periods = [] as any;
                for (let item of _data["periods"])
                    this.periods!.push(PReportPeriod.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WeekReportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new WeekReportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siteId"] = this.siteId;
        if (Array.isArray(this.periods)) {
            data["periods"] = [];
            for (let item of this.periods)
                data["periods"].push(item.toJSON());
        }
        return data;
    }
}

export interface IWeekReportRequest {
    siteId?: string | undefined;
    periods?: PReportPeriod[] | undefined;
}

export class EsfCloudToDeviceMessage implements IEsfCloudToDeviceMessage {
    messageType!: CloudToDeviceTypeEnum;
    message?: string | undefined;
    location?: string | undefined;
    status!: CloudToDeviceStatusEnum;
    animalId?: string | undefined;
    sequenceNumber!: number;
    createdOn?: Date | undefined;
    id?: string | undefined;
    animalNumber?: string | undefined;
    transponder?: string | undefined;

    constructor(data?: IEsfCloudToDeviceMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageType = _data["messageType"];
            this.message = _data["message"];
            this.location = _data["location"];
            this.status = _data["status"];
            this.animalId = _data["animalId"];
            this.sequenceNumber = _data["sequenceNumber"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.id = _data["id"];
            this.animalNumber = _data["animalNumber"];
            this.transponder = _data["transponder"];
        }
    }

    static fromJS(data: any): EsfCloudToDeviceMessage {
        data = typeof data === 'object' ? data : {};
        let result = new EsfCloudToDeviceMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageType"] = this.messageType;
        data["message"] = this.message;
        data["location"] = this.location;
        data["status"] = this.status;
        data["animalId"] = this.animalId;
        data["sequenceNumber"] = this.sequenceNumber;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["id"] = this.id;
        data["animalNumber"] = this.animalNumber;
        data["transponder"] = this.transponder;
        return data;
    }
}

export interface IEsfCloudToDeviceMessage {
    messageType: CloudToDeviceTypeEnum;
    message?: string | undefined;
    location?: string | undefined;
    status: CloudToDeviceStatusEnum;
    animalId?: string | undefined;
    sequenceNumber: number;
    createdOn?: Date | undefined;
    id?: string | undefined;
    animalNumber?: string | undefined;
    transponder?: string | undefined;
}

export enum CloudToDeviceTypeEnum {
    ValveUpdate = "ValveUpdate",
    FullSync = "FullSync",
    FetchLocations = "FetchLocations",
    FetchFeedConsumption = "FetchFeedConsumption",
    FetchFeedComponent = "FetchFeedComponent",
    InsertAnimal = "InsertAnimal",
    RemoveAnimal = "RemoveAnimal",
    MoveAnimal = "MoveAnimal",
    UpdateFeeding = "UpdateFeeding",
    UpdateCycleDay = "UpdateCycleDay",
    BulkInsert = "BulkInsert",
    FetchStations = "FetchStations",
    UpdateAnimal = "UpdateAnimal",
    HeartBeat = "HeartBeat",
}

export enum CloudToDeviceStatusEnum {
    Created = "Created",
    Pending = "Pending",
    Ok = "Ok",
    Error = "Error",
    Acknowledged = "Acknowledged",
    Notified = "Notified",
    Invalidated = "Invalidated",
    Deleted = "Deleted",
    Resend = "Resend",
}

export class SiteV1 extends Unique implements ISiteV1 {
    name?: string | undefined;
    code?: string | undefined;
    enterpriseId?: string | undefined;
    countryId?: string | undefined;
    feedCurves?: FeedCurve[] | undefined;
    availableModules?: string[] | undefined;
    activeLicences?: string[] | undefined;
    opcUris?: { [key in keyof typeof SourceSystem]?: string; } | undefined;
    address?: string | undefined;
    city?: string | undefined;
    chRnum!: number;
    postalCode!: number;
    default!: boolean;
    deviceId?: string | undefined;
    latestMessageTimestamp!: Date;

    constructor(data?: ISiteV1) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.enterpriseId = _data["enterpriseId"];
            this.countryId = _data["countryId"];
            if (Array.isArray(_data["feedCurves"])) {
                this.feedCurves = [] as any;
                for (let item of _data["feedCurves"])
                    this.feedCurves!.push(FeedCurve.fromJS(item));
            }
            if (Array.isArray(_data["availableModules"])) {
                this.availableModules = [] as any;
                for (let item of _data["availableModules"])
                    this.availableModules!.push(item);
            }
            if (Array.isArray(_data["activeLicences"])) {
                this.activeLicences = [] as any;
                for (let item of _data["activeLicences"])
                    this.activeLicences!.push(item);
            }
            if (_data["opcUris"]) {
                this.opcUris = {} as any;
                for (let key in _data["opcUris"]) {
                    if (_data["opcUris"].hasOwnProperty(key))
                        (<any>this.opcUris)![key] = _data["opcUris"][key];
                }
            }
            this.address = _data["address"];
            this.city = _data["city"];
            this.chRnum = _data["chRnum"];
            this.postalCode = _data["postalCode"];
            this.default = _data["default"];
            this.deviceId = _data["deviceId"];
            this.latestMessageTimestamp = _data["latestMessageTimestamp"] ? new Date(_data["latestMessageTimestamp"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): SiteV1 {
        data = typeof data === 'object' ? data : {};
        let result = new SiteV1();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["enterpriseId"] = this.enterpriseId;
        data["countryId"] = this.countryId;
        if (Array.isArray(this.feedCurves)) {
            data["feedCurves"] = [];
            for (let item of this.feedCurves)
                data["feedCurves"].push(item.toJSON());
        }
        if (Array.isArray(this.availableModules)) {
            data["availableModules"] = [];
            for (let item of this.availableModules)
                data["availableModules"].push(item);
        }
        if (Array.isArray(this.activeLicences)) {
            data["activeLicences"] = [];
            for (let item of this.activeLicences)
                data["activeLicences"].push(item);
        }
        if (this.opcUris) {
            data["opcUris"] = {};
            for (let key in this.opcUris) {
                if (this.opcUris.hasOwnProperty(key))
                    (<any>data["opcUris"])[key] = (<any>this.opcUris)[key];
            }
        }
        data["address"] = this.address;
        data["city"] = this.city;
        data["chRnum"] = this.chRnum;
        data["postalCode"] = this.postalCode;
        data["default"] = this.default;
        data["deviceId"] = this.deviceId;
        data["latestMessageTimestamp"] = this.latestMessageTimestamp ? this.latestMessageTimestamp.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ISiteV1 extends IUnique {
    name?: string | undefined;
    code?: string | undefined;
    enterpriseId?: string | undefined;
    countryId?: string | undefined;
    feedCurves?: FeedCurve[] | undefined;
    availableModules?: string[] | undefined;
    activeLicences?: string[] | undefined;
    opcUris?: { [key in keyof typeof SourceSystem]?: string; } | undefined;
    address?: string | undefined;
    city?: string | undefined;
    chRnum: number;
    postalCode: number;
    default: boolean;
    deviceId?: string | undefined;
    latestMessageTimestamp: Date;
}

export class Site extends Unique implements ISite {
    siteName?: string | undefined;
    ownerName?: string | undefined;
    code?: string | undefined;
    enterpriseId?: string | undefined;
    countryId?: string | undefined;
    activeLicences?: string[] | undefined;
    siteAddress?: string | undefined;
    ownerAddress?: string | undefined;
    ownerCity?: string | undefined;
    siteCity?: string | undefined;
    chRnum!: number;
    cvRnum!: number;
    siteZipCode!: number;
    ownerZipCode!: number;
    default!: boolean;
    deviceId?: string | undefined;
    latestMessageTimestamp!: Date;

    constructor(data?: ISite) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.siteName = _data["siteName"];
            this.ownerName = _data["ownerName"];
            this.code = _data["code"];
            this.enterpriseId = _data["enterpriseId"];
            this.countryId = _data["countryId"];
            if (Array.isArray(_data["activeLicences"])) {
                this.activeLicences = [] as any;
                for (let item of _data["activeLicences"])
                    this.activeLicences!.push(item);
            }
            this.siteAddress = _data["siteAddress"];
            this.ownerAddress = _data["ownerAddress"];
            this.ownerCity = _data["ownerCity"];
            this.siteCity = _data["siteCity"];
            this.chRnum = _data["chRnum"];
            this.cvRnum = _data["cvRnum"];
            this.siteZipCode = _data["siteZipCode"];
            this.ownerZipCode = _data["ownerZipCode"];
            this.default = _data["default"];
            this.deviceId = _data["deviceId"];
            this.latestMessageTimestamp = _data["latestMessageTimestamp"] ? new Date(_data["latestMessageTimestamp"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): Site {
        data = typeof data === 'object' ? data : {};
        let result = new Site();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siteName"] = this.siteName;
        data["ownerName"] = this.ownerName;
        data["code"] = this.code;
        data["enterpriseId"] = this.enterpriseId;
        data["countryId"] = this.countryId;
        if (Array.isArray(this.activeLicences)) {
            data["activeLicences"] = [];
            for (let item of this.activeLicences)
                data["activeLicences"].push(item);
        }
        data["siteAddress"] = this.siteAddress;
        data["ownerAddress"] = this.ownerAddress;
        data["ownerCity"] = this.ownerCity;
        data["siteCity"] = this.siteCity;
        data["chRnum"] = this.chRnum;
        data["cvRnum"] = this.cvRnum;
        data["siteZipCode"] = this.siteZipCode;
        data["ownerZipCode"] = this.ownerZipCode;
        data["default"] = this.default;
        data["deviceId"] = this.deviceId;
        data["latestMessageTimestamp"] = this.latestMessageTimestamp ? this.latestMessageTimestamp.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ISite extends IUnique {
    siteName?: string | undefined;
    ownerName?: string | undefined;
    code?: string | undefined;
    enterpriseId?: string | undefined;
    countryId?: string | undefined;
    activeLicences?: string[] | undefined;
    siteAddress?: string | undefined;
    ownerAddress?: string | undefined;
    ownerCity?: string | undefined;
    siteCity?: string | undefined;
    chRnum: number;
    cvRnum: number;
    siteZipCode: number;
    ownerZipCode: number;
    default: boolean;
    deviceId?: string | undefined;
    latestMessageTimestamp: Date;
}

export class SiteSetupDTO implements ISiteSetupDTO {
    site?: Site | undefined;
    equipments?: SiteEquipment[] | undefined;

    constructor(data?: ISiteSetupDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.site = _data["site"] ? Site.fromJS(_data["site"]) : <any>undefined;
            if (Array.isArray(_data["equipments"])) {
                this.equipments = [] as any;
                for (let item of _data["equipments"])
                    this.equipments!.push(SiteEquipment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SiteSetupDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SiteSetupDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["site"] = this.site ? this.site.toJSON() : <any>undefined;
        if (Array.isArray(this.equipments)) {
            data["equipments"] = [];
            for (let item of this.equipments)
                data["equipments"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISiteSetupDTO {
    site?: Site | undefined;
    equipments?: SiteEquipment[] | undefined;
}

export class SiteEquipment implements ISiteEquipment {
    ipAddress?: string | undefined;
    equipment!: Equipment;
    timeZone?: string | undefined;
    code?: string | undefined;

    constructor(data?: ISiteEquipment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ipAddress = _data["ipAddress"];
            this.equipment = _data["equipment"];
            this.timeZone = _data["timeZone"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): SiteEquipment {
        data = typeof data === 'object' ? data : {};
        let result = new SiteEquipment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ipAddress"] = this.ipAddress;
        data["equipment"] = this.equipment;
        data["timeZone"] = this.timeZone;
        data["code"] = this.code;
        return data;
    }
}

export interface ISiteEquipment {
    ipAddress?: string | undefined;
    equipment: Equipment;
    timeZone?: string | undefined;
    code?: string | undefined;
}

export class Module extends Unique implements IModule {
    name?: string | undefined;
    processes?: WorkProcess[] | undefined;
    licences?: string[] | undefined;

    constructor(data?: IModule) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["processes"])) {
                this.processes = [] as any;
                for (let item of _data["processes"])
                    this.processes!.push(WorkProcess.fromJS(item));
            }
            if (Array.isArray(_data["licences"])) {
                this.licences = [] as any;
                for (let item of _data["licences"])
                    this.licences!.push(item);
            }
        }
    }

    static override fromJS(data: any): Module {
        data = typeof data === 'object' ? data : {};
        let result = new Module();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.processes)) {
            data["processes"] = [];
            for (let item of this.processes)
                data["processes"].push(item.toJSON());
        }
        if (Array.isArray(this.licences)) {
            data["licences"] = [];
            for (let item of this.licences)
                data["licences"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IModule extends IUnique {
    name?: string | undefined;
    processes?: WorkProcess[] | undefined;
    licences?: string[] | undefined;
}

export class WorkProcess implements IWorkProcess {
    id?: string | undefined;
    name?: string | undefined;
    licenceId?: string | undefined;

    constructor(data?: IWorkProcess) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.licenceId = _data["licenceId"];
        }
    }

    static fromJS(data: any): WorkProcess {
        data = typeof data === 'object' ? data : {};
        let result = new WorkProcess();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["licenceId"] = this.licenceId;
        return data;
    }
}

export interface IWorkProcess {
    id?: string | undefined;
    name?: string | undefined;
    licenceId?: string | undefined;
}

export class SiteAuthorizations implements ISiteAuthorizations {
    userProfiles?: UserProfile2[] | undefined;
    moduleAuthorizations?: ModuleAuth[] | undefined;

    constructor(data?: ISiteAuthorizations) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userProfiles"])) {
                this.userProfiles = [] as any;
                for (let item of _data["userProfiles"])
                    this.userProfiles!.push(UserProfile2.fromJS(item));
            }
            if (Array.isArray(_data["moduleAuthorizations"])) {
                this.moduleAuthorizations = [] as any;
                for (let item of _data["moduleAuthorizations"])
                    this.moduleAuthorizations!.push(ModuleAuth.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SiteAuthorizations {
        data = typeof data === 'object' ? data : {};
        let result = new SiteAuthorizations();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userProfiles)) {
            data["userProfiles"] = [];
            for (let item of this.userProfiles)
                data["userProfiles"].push(item.toJSON());
        }
        if (Array.isArray(this.moduleAuthorizations)) {
            data["moduleAuthorizations"] = [];
            for (let item of this.moduleAuthorizations)
                data["moduleAuthorizations"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISiteAuthorizations {
    userProfiles?: UserProfile2[] | undefined;
    moduleAuthorizations?: ModuleAuth[] | undefined;
}

export class ModuleAuth implements IModuleAuth {
    module?: Module | undefined;
    authorizations?: boolean[] | undefined;
    processAuthorizations?: ProcessAuth[] | undefined;

    constructor(data?: IModuleAuth) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            if (Array.isArray(_data["authorizations"])) {
                this.authorizations = [] as any;
                for (let item of _data["authorizations"])
                    this.authorizations!.push(item);
            }
            if (Array.isArray(_data["processAuthorizations"])) {
                this.processAuthorizations = [] as any;
                for (let item of _data["processAuthorizations"])
                    this.processAuthorizations!.push(ProcessAuth.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ModuleAuth {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleAuth();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.authorizations)) {
            data["authorizations"] = [];
            for (let item of this.authorizations)
                data["authorizations"].push(item);
        }
        if (Array.isArray(this.processAuthorizations)) {
            data["processAuthorizations"] = [];
            for (let item of this.processAuthorizations)
                data["processAuthorizations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IModuleAuth {
    module?: Module | undefined;
    authorizations?: boolean[] | undefined;
    processAuthorizations?: ProcessAuth[] | undefined;
}

export class ProcessAuth implements IProcessAuth {
    process?: WorkProcess | undefined;
    authorizations?: boolean[] | undefined;

    constructor(data?: IProcessAuth) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.process = _data["process"] ? WorkProcess.fromJS(_data["process"]) : <any>undefined;
            if (Array.isArray(_data["authorizations"])) {
                this.authorizations = [] as any;
                for (let item of _data["authorizations"])
                    this.authorizations!.push(item);
            }
        }
    }

    static fromJS(data: any): ProcessAuth {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessAuth();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["process"] = this.process ? this.process.toJSON() : <any>undefined;
        if (Array.isArray(this.authorizations)) {
            data["authorizations"] = [];
            for (let item of this.authorizations)
                data["authorizations"].push(item);
        }
        return data;
    }
}

export interface IProcessAuth {
    process?: WorkProcess | undefined;
    authorizations?: boolean[] | undefined;
}

export class SiteAuthorizationUpdate implements ISiteAuthorizationUpdate {
    userId?: string | undefined;
    moduleId?: string | undefined;
    processIds?: string[] | undefined;
    authorized!: boolean;

    constructor(data?: ISiteAuthorizationUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.moduleId = _data["moduleId"];
            if (Array.isArray(_data["processIds"])) {
                this.processIds = [] as any;
                for (let item of _data["processIds"])
                    this.processIds!.push(item);
            }
            this.authorized = _data["authorized"];
        }
    }

    static fromJS(data: any): SiteAuthorizationUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new SiteAuthorizationUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["moduleId"] = this.moduleId;
        if (Array.isArray(this.processIds)) {
            data["processIds"] = [];
            for (let item of this.processIds)
                data["processIds"].push(item);
        }
        data["authorized"] = this.authorized;
        return data;
    }
}

export interface ISiteAuthorizationUpdate {
    userId?: string | undefined;
    moduleId?: string | undefined;
    processIds?: string[] | undefined;
    authorized: boolean;
}

export class SlaughterDataRegistrationErrorBase extends SiteEntity implements ISlaughterDataRegistrationErrorBase {
    registrationError!: SlaughterDataRegistrationError;

    constructor(data?: ISlaughterDataRegistrationErrorBase) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.registrationError = _data["registrationError"];
        }
    }

    static override fromJS(data: any): SlaughterDataRegistrationErrorBase {
        data = typeof data === 'object' ? data : {};
        let result = new SlaughterDataRegistrationErrorBase();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registrationError"] = this.registrationError;
        super.toJSON(data);
        return data;
    }
}

export interface ISlaughterDataRegistrationErrorBase extends ISiteEntity {
    registrationError: SlaughterDataRegistrationError;
}

export class SlaughterhouseConnectionDto extends SlaughterDataRegistrationErrorBase implements ISlaughterhouseConnectionDto {
    farmNumber?: string | undefined;
    encryptedFarmNumber?: string | undefined;
    password?: string | undefined;
    encryptedPassword?: string | undefined;
    supplierNumber?: string | undefined;
    slaughterhouse!: SlaughterhouseCompany;
    lastSyncTime!: Date;
    refreshToken?: string | undefined;
    slaughterHouseConnectionId?: string | undefined;
    fromDate!: Date;
    userNumber?: string | undefined;
    lastManuelLogin?: Date | undefined;
    lastAutoLogin?: Date | undefined;

    constructor(data?: ISlaughterhouseConnectionDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.farmNumber = _data["farmNumber"];
            this.encryptedFarmNumber = _data["encryptedFarmNumber"];
            this.password = _data["password"];
            this.encryptedPassword = _data["encryptedPassword"];
            this.supplierNumber = _data["supplierNumber"];
            this.slaughterhouse = _data["slaughterhouse"];
            this.lastSyncTime = _data["lastSyncTime"] ? new Date(_data["lastSyncTime"].toString()) : <any>undefined;
            this.refreshToken = _data["refreshToken"];
            this.slaughterHouseConnectionId = _data["slaughterHouseConnectionId"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : <any>undefined;
            this.userNumber = _data["userNumber"];
            this.lastManuelLogin = _data["lastManuelLogin"] ? new Date(_data["lastManuelLogin"].toString()) : <any>undefined;
            this.lastAutoLogin = _data["lastAutoLogin"] ? new Date(_data["lastAutoLogin"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): SlaughterhouseConnectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SlaughterhouseConnectionDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["farmNumber"] = this.farmNumber;
        data["encryptedFarmNumber"] = this.encryptedFarmNumber;
        data["password"] = this.password;
        data["encryptedPassword"] = this.encryptedPassword;
        data["supplierNumber"] = this.supplierNumber;
        data["slaughterhouse"] = this.slaughterhouse;
        data["lastSyncTime"] = this.lastSyncTime ? this.lastSyncTime.toISOString() : <any>undefined;
        data["refreshToken"] = this.refreshToken;
        data["slaughterHouseConnectionId"] = this.slaughterHouseConnectionId;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["userNumber"] = this.userNumber;
        data["lastManuelLogin"] = this.lastManuelLogin ? this.lastManuelLogin.toISOString() : <any>undefined;
        data["lastAutoLogin"] = this.lastAutoLogin ? this.lastAutoLogin.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ISlaughterhouseConnectionDto extends ISlaughterDataRegistrationErrorBase {
    farmNumber?: string | undefined;
    encryptedFarmNumber?: string | undefined;
    password?: string | undefined;
    encryptedPassword?: string | undefined;
    supplierNumber?: string | undefined;
    slaughterhouse: SlaughterhouseCompany;
    lastSyncTime: Date;
    refreshToken?: string | undefined;
    slaughterHouseConnectionId?: string | undefined;
    fromDate: Date;
    userNumber?: string | undefined;
    lastManuelLogin?: Date | undefined;
    lastAutoLogin?: Date | undefined;
}

export enum SlaughterhouseCompany {
    DanishCrown = "DanishCrown",
    Tican = "Tican",
}

export enum SlaughterDataRegistrationError {
    NoError = "NoError",
    WrongLocationType = "WrongLocationType",
    InvalidData = "InvalidData",
    InvalidLocation = "InvalidLocation",
    SowNumberOrPigIdRequired = "SowNumberOrPigIdRequired",
    SowNumberAlreadyInUse = "SowNumberAlreadyInUse",
    GiltHasSowNumberSet = "GiltHasSowNumberSet",
    PigIdExist = "PigIdExist",
    SowNumberExistPigIdEmpty = "SowNumberExistPigIdEmpty",
    SowNotFound = "SowNotFound",
    NoSowId = "NoSowId",
    NoSowNumber = "NoSowNumber",
    MovingBetweenInvalidTypes = "MovingBetweenInvalidTypes",
    WrongStyType = "WrongStyType",
    SowNumberOrSowIdRequired = "SowNumberOrSowIdRequired",
    PigIdReuired = "PigIdReuired",
    SowNotFoundAndCouldNotBeCreated = "SowNotFoundAndCouldNotBeCreated",
    NumberOfPigsInStyIsZeroOrLower = "NumberOfPigsInStyIsZeroOrLower",
    NoDestinationPregnancy = "NoDestinationPregnancy",
    NoSourcePregnancy = "NoSourcePregnancy",
    CanOnlyUpdateOneSow = "CanOnlyUpdateOneSow",
    WeightRequired = "WeightRequired",
    NoSowNumberOrSowId = "NoSowNumberOrSowId",
    GiltHasNoPigId = "GiltHasNoPigId",
    NoTreatmentForId = "NoTreatmentForId",
    SectionAndStableNotFound = "SectionAndStableNotFound",
    NoStableWithId = "NoStableWithId",
    NoSectionWithId = "NoSectionWithId",
    StyIdOrFarmIdIsNull = "StyIdOrFarmIdIsNull",
    StableNotFoundOnStyId = "StableNotFoundOnStyId",
    StyNotOnFarm = "StyNotOnFarm",
    NoDiagnose = "NoDiagnose",
    PregnancystateRequired = "PregnancystateRequired",
    StyRequired = "StyRequired",
    DueDateRequired = "DueDateRequired",
    FarmRequired = "FarmRequired",
    CantDecryptPassword = "CantDecryptPassword",
    WrongPasswordOrFarmNr = "WrongPasswordOrFarmNr",
    NoDataForTimeInterval = "NoDataForTimeInterval",
    CouldNotConnectToDC = "CouldNotConnectToDC",
    CantConvertData = "CantConvertData",
}

export class SlaughterData extends SiteEntity implements ISlaughterData {
    slaughterNumber?: string | undefined;
    supplier?: string | undefined;
    supplierName?: string | undefined;
    companyCode?: string | undefined;
    settlement!: Date;
    deliveryDate!: Date;
    paymentNumber?: string | undefined;
    material?: string | undefined;
    f1?: string | undefined;
    productHierarchy?: string | undefined;
    f2?: string | undefined;
    diseaseCode1?: string | undefined;
    diseaseCode2?: string | undefined;
    diseaseCode3?: string | undefined;
    diseaseCode4?: string | undefined;
    diseaseCode5?: string | undefined;
    diseaseCode6?: string | undefined;
    diseaseCode7?: string | undefined;
    diseaseCode8?: string | undefined;
    diseaseCode9?: string | undefined;
    genderCode?: string | undefined;
    encore?: string | undefined;
    numberInQoutation!: number;
    amountObese!: number;
    amountUnderweight!: number;
    meatPercentage!: number;
    eliminationTotal!: number;
    listing!: number;
    listingKg!: number;
    calculatedPricePrKg!: number;
    weightToDeduction!: number;
    meatPercentageToDeduction!: number;
    specToDeduction!: number;
    diseaseToDeduction!: number;
    calculatedPriceAnimal!: number;
    variousForDeduction!: number;
    invoiceAmount!: number;
    calculatedWeight!: number;
    otherCosts!: number;
    buildingId?: string | undefined;
    sectionId?: string | undefined;

    constructor(data?: ISlaughterData) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.slaughterNumber = _data["slaughterNumber"];
            this.supplier = _data["supplier"];
            this.supplierName = _data["supplierName"];
            this.companyCode = _data["companyCode"];
            this.settlement = _data["settlement"] ? new Date(_data["settlement"].toString()) : <any>undefined;
            this.deliveryDate = _data["deliveryDate"] ? new Date(_data["deliveryDate"].toString()) : <any>undefined;
            this.paymentNumber = _data["paymentNumber"];
            this.material = _data["material"];
            this.f1 = _data["f1"];
            this.productHierarchy = _data["productHierarchy"];
            this.f2 = _data["f2"];
            this.diseaseCode1 = _data["diseaseCode1"];
            this.diseaseCode2 = _data["diseaseCode2"];
            this.diseaseCode3 = _data["diseaseCode3"];
            this.diseaseCode4 = _data["diseaseCode4"];
            this.diseaseCode5 = _data["diseaseCode5"];
            this.diseaseCode6 = _data["diseaseCode6"];
            this.diseaseCode7 = _data["diseaseCode7"];
            this.diseaseCode8 = _data["diseaseCode8"];
            this.diseaseCode9 = _data["diseaseCode9"];
            this.genderCode = _data["genderCode"];
            this.encore = _data["encore"];
            this.numberInQoutation = _data["numberInQoutation"];
            this.amountObese = _data["amountObese"];
            this.amountUnderweight = _data["amountUnderweight"];
            this.meatPercentage = _data["meatPercentage"];
            this.eliminationTotal = _data["eliminationTotal"];
            this.listing = _data["listing"];
            this.listingKg = _data["listingKg"];
            this.calculatedPricePrKg = _data["calculatedPricePrKg"];
            this.weightToDeduction = _data["weightToDeduction"];
            this.meatPercentageToDeduction = _data["meatPercentageToDeduction"];
            this.specToDeduction = _data["specToDeduction"];
            this.diseaseToDeduction = _data["diseaseToDeduction"];
            this.calculatedPriceAnimal = _data["calculatedPriceAnimal"];
            this.variousForDeduction = _data["variousForDeduction"];
            this.invoiceAmount = _data["invoiceAmount"];
            this.calculatedWeight = _data["calculatedWeight"];
            this.otherCosts = _data["otherCosts"];
            this.buildingId = _data["buildingId"];
            this.sectionId = _data["sectionId"];
        }
    }

    static override fromJS(data: any): SlaughterData {
        data = typeof data === 'object' ? data : {};
        let result = new SlaughterData();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["slaughterNumber"] = this.slaughterNumber;
        data["supplier"] = this.supplier;
        data["supplierName"] = this.supplierName;
        data["companyCode"] = this.companyCode;
        data["settlement"] = this.settlement ? this.settlement.toISOString() : <any>undefined;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : <any>undefined;
        data["paymentNumber"] = this.paymentNumber;
        data["material"] = this.material;
        data["f1"] = this.f1;
        data["productHierarchy"] = this.productHierarchy;
        data["f2"] = this.f2;
        data["diseaseCode1"] = this.diseaseCode1;
        data["diseaseCode2"] = this.diseaseCode2;
        data["diseaseCode3"] = this.diseaseCode3;
        data["diseaseCode4"] = this.diseaseCode4;
        data["diseaseCode5"] = this.diseaseCode5;
        data["diseaseCode6"] = this.diseaseCode6;
        data["diseaseCode7"] = this.diseaseCode7;
        data["diseaseCode8"] = this.diseaseCode8;
        data["diseaseCode9"] = this.diseaseCode9;
        data["genderCode"] = this.genderCode;
        data["encore"] = this.encore;
        data["numberInQoutation"] = this.numberInQoutation;
        data["amountObese"] = this.amountObese;
        data["amountUnderweight"] = this.amountUnderweight;
        data["meatPercentage"] = this.meatPercentage;
        data["eliminationTotal"] = this.eliminationTotal;
        data["listing"] = this.listing;
        data["listingKg"] = this.listingKg;
        data["calculatedPricePrKg"] = this.calculatedPricePrKg;
        data["weightToDeduction"] = this.weightToDeduction;
        data["meatPercentageToDeduction"] = this.meatPercentageToDeduction;
        data["specToDeduction"] = this.specToDeduction;
        data["diseaseToDeduction"] = this.diseaseToDeduction;
        data["calculatedPriceAnimal"] = this.calculatedPriceAnimal;
        data["variousForDeduction"] = this.variousForDeduction;
        data["invoiceAmount"] = this.invoiceAmount;
        data["calculatedWeight"] = this.calculatedWeight;
        data["otherCosts"] = this.otherCosts;
        data["buildingId"] = this.buildingId;
        data["sectionId"] = this.sectionId;
        super.toJSON(data);
        return data;
    }
}

export interface ISlaughterData extends ISiteEntity {
    slaughterNumber?: string | undefined;
    supplier?: string | undefined;
    supplierName?: string | undefined;
    companyCode?: string | undefined;
    settlement: Date;
    deliveryDate: Date;
    paymentNumber?: string | undefined;
    material?: string | undefined;
    f1?: string | undefined;
    productHierarchy?: string | undefined;
    f2?: string | undefined;
    diseaseCode1?: string | undefined;
    diseaseCode2?: string | undefined;
    diseaseCode3?: string | undefined;
    diseaseCode4?: string | undefined;
    diseaseCode5?: string | undefined;
    diseaseCode6?: string | undefined;
    diseaseCode7?: string | undefined;
    diseaseCode8?: string | undefined;
    diseaseCode9?: string | undefined;
    genderCode?: string | undefined;
    encore?: string | undefined;
    numberInQoutation: number;
    amountObese: number;
    amountUnderweight: number;
    meatPercentage: number;
    eliminationTotal: number;
    listing: number;
    listingKg: number;
    calculatedPricePrKg: number;
    weightToDeduction: number;
    meatPercentageToDeduction: number;
    specToDeduction: number;
    diseaseToDeduction: number;
    calculatedPriceAnimal: number;
    variousForDeduction: number;
    invoiceAmount: number;
    calculatedWeight: number;
    otherCosts: number;
    buildingId?: string | undefined;
    sectionId?: string | undefined;
}

export class SlaughterSiteDataDto extends SlaughterDataRegistrationErrorBase implements ISlaughterSiteDataDto {
    sectionId?: string | undefined;
    buildingId?: string | undefined;
    supplier?: string | undefined;
    weight!: number;
    difference!: number;
    meat!: number;
    reg!: number;
    slaughterNumber?: string | undefined;
    price!: number;
    aliveWeight!: number;
    remarks?: string[] | undefined;
    gender!: SlaughterDataGender;
    noting!: SlaughterDataNoting;
    type!: SlaughterDataType;
    label?: string | undefined;
    amount!: number;
    date!: Date;
    variousForDeduction!: number;
    weightToDeduction!: number;
    meatPercentageToDeduction!: number;
    specToDeduction!: number;
    diseaseToDeduction!: number;
    listingKg!: number;
    pricePrPig!: number;
    otherCosts!: number;

    constructor(data?: ISlaughterSiteDataDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sectionId = _data["sectionId"];
            this.buildingId = _data["buildingId"];
            this.supplier = _data["supplier"];
            this.weight = _data["weight"];
            this.difference = _data["difference"];
            this.meat = _data["meat"];
            this.reg = _data["reg"];
            this.slaughterNumber = _data["slaughterNumber"];
            this.price = _data["price"];
            this.aliveWeight = _data["aliveWeight"];
            if (Array.isArray(_data["remarks"])) {
                this.remarks = [] as any;
                for (let item of _data["remarks"])
                    this.remarks!.push(item);
            }
            this.gender = _data["gender"];
            this.noting = _data["noting"];
            this.type = _data["type"];
            this.label = _data["label"];
            this.amount = _data["amount"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.variousForDeduction = _data["variousForDeduction"];
            this.weightToDeduction = _data["weightToDeduction"];
            this.meatPercentageToDeduction = _data["meatPercentageToDeduction"];
            this.specToDeduction = _data["specToDeduction"];
            this.diseaseToDeduction = _data["diseaseToDeduction"];
            this.listingKg = _data["listingKg"];
            this.pricePrPig = _data["pricePrPig"];
            this.otherCosts = _data["otherCosts"];
        }
    }

    static override fromJS(data: any): SlaughterSiteDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new SlaughterSiteDataDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sectionId"] = this.sectionId;
        data["buildingId"] = this.buildingId;
        data["supplier"] = this.supplier;
        data["weight"] = this.weight;
        data["difference"] = this.difference;
        data["meat"] = this.meat;
        data["reg"] = this.reg;
        data["slaughterNumber"] = this.slaughterNumber;
        data["price"] = this.price;
        data["aliveWeight"] = this.aliveWeight;
        if (Array.isArray(this.remarks)) {
            data["remarks"] = [];
            for (let item of this.remarks)
                data["remarks"].push(item);
        }
        data["gender"] = this.gender;
        data["noting"] = this.noting;
        data["type"] = this.type;
        data["label"] = this.label;
        data["amount"] = this.amount;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["variousForDeduction"] = this.variousForDeduction;
        data["weightToDeduction"] = this.weightToDeduction;
        data["meatPercentageToDeduction"] = this.meatPercentageToDeduction;
        data["specToDeduction"] = this.specToDeduction;
        data["diseaseToDeduction"] = this.diseaseToDeduction;
        data["listingKg"] = this.listingKg;
        data["pricePrPig"] = this.pricePrPig;
        data["otherCosts"] = this.otherCosts;
        super.toJSON(data);
        return data;
    }
}

export interface ISlaughterSiteDataDto extends ISlaughterDataRegistrationErrorBase {
    sectionId?: string | undefined;
    buildingId?: string | undefined;
    supplier?: string | undefined;
    weight: number;
    difference: number;
    meat: number;
    reg: number;
    slaughterNumber?: string | undefined;
    price: number;
    aliveWeight: number;
    remarks?: string[] | undefined;
    gender: SlaughterDataGender;
    noting: SlaughterDataNoting;
    type: SlaughterDataType;
    label?: string | undefined;
    amount: number;
    date: Date;
    variousForDeduction: number;
    weightToDeduction: number;
    meatPercentageToDeduction: number;
    specToDeduction: number;
    diseaseToDeduction: number;
    listingKg: number;
    pricePrPig: number;
    otherCosts: number;
}

export enum SlaughterDataGender {
    Sow = "Sow",
    Male = "Male",
    Barrow = "Barrow",
    Unknown = "Unknown",
}

export enum SlaughterDataNoting {
    Basic = "Basic",
    Over = "Over",
    Under = "Under",
}

export enum SlaughterDataType {
    APig = "APig",
    Discarded = "Discarded",
    BesBoar = "BesBoar",
    Sow = "Sow",
    ReturnPig = "ReturnPig",
    OtherDelievered = "OtherDelievered",
    RemovedMale = "RemovedMale",
    DiscardedSow = "DiscardedSow",
    DiscardedBesBoar = "DiscardedBesBoar",
}

export class SlaughterHouseDataOverviewDto extends PdfTableCellItemsWithDefinedWidths implements ISlaughterHouseDataOverviewDto {
    date?: string | undefined;
    amount?: string | undefined;
    slaughterWeight?: string | undefined;
    meatPercentage?: string | undefined;
    locationString?: string | undefined;
    price?: string | undefined;
    supplier?: string | undefined;

    constructor(data?: ISlaughterHouseDataOverviewDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.date = _data["date"];
            this.amount = _data["amount"];
            this.slaughterWeight = _data["slaughterWeight"];
            this.meatPercentage = _data["meatPercentage"];
            this.locationString = _data["locationString"];
            this.price = _data["price"];
            this.supplier = _data["supplier"];
        }
    }

    static override fromJS(data: any): SlaughterHouseDataOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new SlaughterHouseDataOverviewDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        data["amount"] = this.amount;
        data["slaughterWeight"] = this.slaughterWeight;
        data["meatPercentage"] = this.meatPercentage;
        data["locationString"] = this.locationString;
        data["price"] = this.price;
        data["supplier"] = this.supplier;
        super.toJSON(data);
        return data;
    }
}

export interface ISlaughterHouseDataOverviewDto extends IPdfTableCellItemsWithDefinedWidths {
    date?: string | undefined;
    amount?: string | undefined;
    slaughterWeight?: string | undefined;
    meatPercentage?: string | undefined;
    locationString?: string | undefined;
    price?: string | undefined;
    supplier?: string | undefined;
}

export class SlaughterHouseDataRowModalDto extends PdfTableCellItemsWithDefinedWidths implements ISlaughterHouseDataRowModalDto {
    date?: string | undefined;
    slaughterWeight?: string | undefined;
    meatPercentage?: string | undefined;
    gender?: string | undefined;
    noting?: string | undefined;
    price?: string | undefined;
    pricePrPig?: string | undefined;
    deductionWeight?: string | undefined;
    deductionMeatPercentage?: string | undefined;
    deductionDisease?: string | undefined;
    deductionSpec?: string | undefined;
    listingKg?: string | undefined;
    type?: string | undefined;
    aliveWeight?: string | undefined;
    slaughterNumber?: string | undefined;
    remarks?: string[] | undefined;
    priceIncludingAdditionsDeductions?: string | undefined;

    constructor(data?: ISlaughterHouseDataRowModalDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.date = _data["date"];
            this.slaughterWeight = _data["slaughterWeight"];
            this.meatPercentage = _data["meatPercentage"];
            this.gender = _data["gender"];
            this.noting = _data["noting"];
            this.price = _data["price"];
            this.pricePrPig = _data["pricePrPig"];
            this.deductionWeight = _data["deductionWeight"];
            this.deductionMeatPercentage = _data["deductionMeatPercentage"];
            this.deductionDisease = _data["deductionDisease"];
            this.deductionSpec = _data["deductionSpec"];
            this.listingKg = _data["listingKg"];
            this.type = _data["type"];
            this.aliveWeight = _data["aliveWeight"];
            this.slaughterNumber = _data["slaughterNumber"];
            if (Array.isArray(_data["remarks"])) {
                this.remarks = [] as any;
                for (let item of _data["remarks"])
                    this.remarks!.push(item);
            }
            this.priceIncludingAdditionsDeductions = _data["priceIncludingAdditionsDeductions"];
        }
    }

    static override fromJS(data: any): SlaughterHouseDataRowModalDto {
        data = typeof data === 'object' ? data : {};
        let result = new SlaughterHouseDataRowModalDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        data["slaughterWeight"] = this.slaughterWeight;
        data["meatPercentage"] = this.meatPercentage;
        data["gender"] = this.gender;
        data["noting"] = this.noting;
        data["price"] = this.price;
        data["pricePrPig"] = this.pricePrPig;
        data["deductionWeight"] = this.deductionWeight;
        data["deductionMeatPercentage"] = this.deductionMeatPercentage;
        data["deductionDisease"] = this.deductionDisease;
        data["deductionSpec"] = this.deductionSpec;
        data["listingKg"] = this.listingKg;
        data["type"] = this.type;
        data["aliveWeight"] = this.aliveWeight;
        data["slaughterNumber"] = this.slaughterNumber;
        if (Array.isArray(this.remarks)) {
            data["remarks"] = [];
            for (let item of this.remarks)
                data["remarks"].push(item);
        }
        data["priceIncludingAdditionsDeductions"] = this.priceIncludingAdditionsDeductions;
        super.toJSON(data);
        return data;
    }
}

export interface ISlaughterHouseDataRowModalDto extends IPdfTableCellItemsWithDefinedWidths {
    date?: string | undefined;
    slaughterWeight?: string | undefined;
    meatPercentage?: string | undefined;
    gender?: string | undefined;
    noting?: string | undefined;
    price?: string | undefined;
    pricePrPig?: string | undefined;
    deductionWeight?: string | undefined;
    deductionMeatPercentage?: string | undefined;
    deductionDisease?: string | undefined;
    deductionSpec?: string | undefined;
    listingKg?: string | undefined;
    type?: string | undefined;
    aliveWeight?: string | undefined;
    slaughterNumber?: string | undefined;
    remarks?: string[] | undefined;
    priceIncludingAdditionsDeductions?: string | undefined;
}

export abstract class BaseSyncOfStation implements IBaseSyncOfStation {
    syncTime!: Date;

    protected _discriminator: string;

    constructor(data?: IBaseSyncOfStation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "BaseSyncOfStation";
    }

    init(_data?: any) {
        if (_data) {
            this.syncTime = _data["syncTime"] ? new Date(_data["syncTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseSyncOfStation {
        data = typeof data === 'object' ? data : {};
        if (data["_discriminator"] === "SyncStation") {
            let result = new SyncStation();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'BaseSyncOfStation' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_discriminator"] = this._discriminator;
        data["syncTime"] = this.syncTime ? this.syncTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBaseSyncOfStation {
    syncTime: Date;
}

export class SyncStation extends BaseSyncOfStation implements ISyncStation {
    datas?: Station[] | undefined;

    constructor(data?: ISyncStation) {
        super(data);
        this._discriminator = "SyncStation";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["datas"])) {
                this.datas = [] as any;
                for (let item of _data["datas"])
                    this.datas!.push(Station.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): SyncStation {
        data = typeof data === 'object' ? data : {};
        let result = new SyncStation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.datas)) {
            data["datas"] = [];
            for (let item of this.datas)
                data["datas"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISyncStation extends IBaseSyncOfStation {
    datas?: Station[] | undefined;
}

export class Station extends SiteEntity implements IStation {
    code?: string | undefined;
    unitGroupId?: string | undefined;

    constructor(data?: IStation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.code = _data["code"];
            this.unitGroupId = _data["unitGroupId"];
        }
    }

    static override fromJS(data: any): Station {
        data = typeof data === 'object' ? data : {};
        let result = new Station();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["unitGroupId"] = this.unitGroupId;
        super.toJSON(data);
        return data;
    }
}

export interface IStation extends ISiteEntity {
    code?: string | undefined;
    unitGroupId?: string | undefined;
}

export class StemAnimal extends SiteEntity implements IStemAnimal {
    animalNumber?: string | undefined;
    entrancePenId?: string | undefined;
    transponder?: string | undefined;
    entranceLitterNumber!: number;
    entranceKind!: AnimalKind;
    gender!: Gender;
    teats?: number | undefined;
    comments?: string | undefined;
    idNumber?: string | undefined;
    birthDate?: Date | undefined;
    retentionTime?: Date | undefined;
    entranceDate?: Date | undefined;
    youngAnimalEntranceDate?: Date | undefined;
    entrancePrice?: number | undefined;
    entranceType?: string | undefined;
    departureMarking?: string | undefined;
    departureType?: string | undefined;
    departureReasonId?: string | undefined;
    departureDate?: Date | undefined;
    departurePrice?: number | undefined;
    breedIndex?: number | undefined;
    breedIndexDate?: Date | undefined;
    race?: string | undefined;
    breedLetter?: string | undefined;
    momBreedLetter?: string | undefined;
    dadBreedLetter?: string | undefined;
    momAnimalNumber?: string | undefined;
    momIdNumber?: string | undefined;
    dadAnimalNumber?: string | undefined;
    dadIdNumber?: string | undefined;
    breedingNumber?: string | undefined;
    momRace?: string | undefined;
    dadRace?: string | undefined;
    dadMongoId?: string | undefined;
    momMongoId?: string | undefined;
    fromPregnancyId?: string | undefined;
    usageCode?: string | undefined;
    earNotch?: string | undefined;
    raceLine?: string | undefined;
    entranceFeedCurveNumber?: number | undefined;

    constructor(data?: IStemAnimal) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.animalNumber = _data["animalNumber"];
            this.entrancePenId = _data["entrancePenId"];
            this.transponder = _data["transponder"];
            this.entranceLitterNumber = _data["entranceLitterNumber"];
            this.entranceKind = _data["entranceKind"];
            this.gender = _data["gender"];
            this.teats = _data["teats"];
            this.comments = _data["comments"];
            this.idNumber = _data["idNumber"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.retentionTime = _data["retentionTime"] ? new Date(_data["retentionTime"].toString()) : <any>undefined;
            this.entranceDate = _data["entranceDate"] ? new Date(_data["entranceDate"].toString()) : <any>undefined;
            this.youngAnimalEntranceDate = _data["youngAnimalEntranceDate"] ? new Date(_data["youngAnimalEntranceDate"].toString()) : <any>undefined;
            this.entrancePrice = _data["entrancePrice"];
            this.entranceType = _data["entranceType"];
            this.departureMarking = _data["departureMarking"];
            this.departureType = _data["departureType"];
            this.departureReasonId = _data["departureReasonId"];
            this.departureDate = _data["departureDate"] ? new Date(_data["departureDate"].toString()) : <any>undefined;
            this.departurePrice = _data["departurePrice"];
            this.breedIndex = _data["breedIndex"];
            this.breedIndexDate = _data["breedIndexDate"] ? new Date(_data["breedIndexDate"].toString()) : <any>undefined;
            this.race = _data["race"];
            this.breedLetter = _data["breedLetter"];
            this.momBreedLetter = _data["momBreedLetter"];
            this.dadBreedLetter = _data["dadBreedLetter"];
            this.momAnimalNumber = _data["momAnimalNumber"];
            this.momIdNumber = _data["momIdNumber"];
            this.dadAnimalNumber = _data["dadAnimalNumber"];
            this.dadIdNumber = _data["dadIdNumber"];
            this.breedingNumber = _data["breedingNumber"];
            this.momRace = _data["momRace"];
            this.dadRace = _data["dadRace"];
            this.dadMongoId = _data["dadMongoId"];
            this.momMongoId = _data["momMongoId"];
            this.fromPregnancyId = _data["fromPregnancyId"];
            this.usageCode = _data["usageCode"];
            this.earNotch = _data["earNotch"];
            this.raceLine = _data["raceLine"];
            this.entranceFeedCurveNumber = _data["entranceFeedCurveNumber"];
        }
    }

    static override fromJS(data: any): StemAnimal {
        data = typeof data === 'object' ? data : {};
        let result = new StemAnimal();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["animalNumber"] = this.animalNumber;
        data["entrancePenId"] = this.entrancePenId;
        data["transponder"] = this.transponder;
        data["entranceLitterNumber"] = this.entranceLitterNumber;
        data["entranceKind"] = this.entranceKind;
        data["gender"] = this.gender;
        data["teats"] = this.teats;
        data["comments"] = this.comments;
        data["idNumber"] = this.idNumber;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["retentionTime"] = this.retentionTime ? this.retentionTime.toISOString() : <any>undefined;
        data["entranceDate"] = this.entranceDate ? this.entranceDate.toISOString() : <any>undefined;
        data["youngAnimalEntranceDate"] = this.youngAnimalEntranceDate ? this.youngAnimalEntranceDate.toISOString() : <any>undefined;
        data["entrancePrice"] = this.entrancePrice;
        data["entranceType"] = this.entranceType;
        data["departureMarking"] = this.departureMarking;
        data["departureType"] = this.departureType;
        data["departureReasonId"] = this.departureReasonId;
        data["departureDate"] = this.departureDate ? this.departureDate.toISOString() : <any>undefined;
        data["departurePrice"] = this.departurePrice;
        data["breedIndex"] = this.breedIndex;
        data["breedIndexDate"] = this.breedIndexDate ? this.breedIndexDate.toISOString() : <any>undefined;
        data["race"] = this.race;
        data["breedLetter"] = this.breedLetter;
        data["momBreedLetter"] = this.momBreedLetter;
        data["dadBreedLetter"] = this.dadBreedLetter;
        data["momAnimalNumber"] = this.momAnimalNumber;
        data["momIdNumber"] = this.momIdNumber;
        data["dadAnimalNumber"] = this.dadAnimalNumber;
        data["dadIdNumber"] = this.dadIdNumber;
        data["breedingNumber"] = this.breedingNumber;
        data["momRace"] = this.momRace;
        data["dadRace"] = this.dadRace;
        data["dadMongoId"] = this.dadMongoId;
        data["momMongoId"] = this.momMongoId;
        data["fromPregnancyId"] = this.fromPregnancyId;
        data["usageCode"] = this.usageCode;
        data["earNotch"] = this.earNotch;
        data["raceLine"] = this.raceLine;
        data["entranceFeedCurveNumber"] = this.entranceFeedCurveNumber;
        super.toJSON(data);
        return data;
    }
}

export interface IStemAnimal extends ISiteEntity {
    animalNumber?: string | undefined;
    entrancePenId?: string | undefined;
    transponder?: string | undefined;
    entranceLitterNumber: number;
    entranceKind: AnimalKind;
    gender: Gender;
    teats?: number | undefined;
    comments?: string | undefined;
    idNumber?: string | undefined;
    birthDate?: Date | undefined;
    retentionTime?: Date | undefined;
    entranceDate?: Date | undefined;
    youngAnimalEntranceDate?: Date | undefined;
    entrancePrice?: number | undefined;
    entranceType?: string | undefined;
    departureMarking?: string | undefined;
    departureType?: string | undefined;
    departureReasonId?: string | undefined;
    departureDate?: Date | undefined;
    departurePrice?: number | undefined;
    breedIndex?: number | undefined;
    breedIndexDate?: Date | undefined;
    race?: string | undefined;
    breedLetter?: string | undefined;
    momBreedLetter?: string | undefined;
    dadBreedLetter?: string | undefined;
    momAnimalNumber?: string | undefined;
    momIdNumber?: string | undefined;
    dadAnimalNumber?: string | undefined;
    dadIdNumber?: string | undefined;
    breedingNumber?: string | undefined;
    momRace?: string | undefined;
    dadRace?: string | undefined;
    dadMongoId?: string | undefined;
    momMongoId?: string | undefined;
    fromPregnancyId?: string | undefined;
    usageCode?: string | undefined;
    earNotch?: string | undefined;
    raceLine?: string | undefined;
    entranceFeedCurveNumber?: number | undefined;
}

export enum Gender {
    Female = "Female",
    Male = "Male",
}

export abstract class ImportIndex implements IImportIndex {
    indexMomSowNumber!: number;
    indexPigId!: number;
    indexBirthdate!: number;
    indexDadSowNumber!: number;
    indexGender!: number;
    indexRace!: number;
    indexRaceLine!: number;
    indexMomPigId!: number;
    indexDadPigId!: number;
    indexIndex!: number;
    indexEntranceDate!: number;

    constructor(data?: IImportIndex) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.indexMomSowNumber = _data["indexMomSowNumber"];
            this.indexPigId = _data["indexPigId"];
            this.indexBirthdate = _data["indexBirthdate"];
            this.indexDadSowNumber = _data["indexDadSowNumber"];
            this.indexGender = _data["indexGender"];
            this.indexRace = _data["indexRace"];
            this.indexRaceLine = _data["indexRaceLine"];
            this.indexMomPigId = _data["indexMomPigId"];
            this.indexDadPigId = _data["indexDadPigId"];
            this.indexIndex = _data["indexIndex"];
            this.indexEntranceDate = _data["indexEntranceDate"];
        }
    }

    static fromJS(data: any): ImportIndex {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ImportIndex' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["indexMomSowNumber"] = this.indexMomSowNumber;
        data["indexPigId"] = this.indexPigId;
        data["indexBirthdate"] = this.indexBirthdate;
        data["indexDadSowNumber"] = this.indexDadSowNumber;
        data["indexGender"] = this.indexGender;
        data["indexRace"] = this.indexRace;
        data["indexRaceLine"] = this.indexRaceLine;
        data["indexMomPigId"] = this.indexMomPigId;
        data["indexDadPigId"] = this.indexDadPigId;
        data["indexIndex"] = this.indexIndex;
        data["indexEntranceDate"] = this.indexEntranceDate;
        return data;
    }
}

export interface IImportIndex {
    indexMomSowNumber: number;
    indexPigId: number;
    indexBirthdate: number;
    indexDadSowNumber: number;
    indexGender: number;
    indexRace: number;
    indexRaceLine: number;
    indexMomPigId: number;
    indexDadPigId: number;
    indexIndex: number;
    indexEntranceDate: number;
}

export class ImportFileData extends ImportIndex implements IImportFileData {
    base64String?: string | undefined;
    siteId?: string | undefined;
    penIds?: string[] | undefined;
    totalWeight?: number | undefined;
    avgWeight?: number | undefined;
    locationType!: LocationType;
    animalType!: AnimalType;
    breedingNumber?: string | undefined;

    constructor(data?: IImportFileData) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.base64String = _data["base64String"];
            this.siteId = _data["siteId"];
            if (Array.isArray(_data["penIds"])) {
                this.penIds = [] as any;
                for (let item of _data["penIds"])
                    this.penIds!.push(item);
            }
            this.totalWeight = _data["totalWeight"];
            this.avgWeight = _data["avgWeight"];
            this.locationType = _data["locationType"];
            this.animalType = _data["animalType"];
            this.breedingNumber = _data["breedingNumber"];
        }
    }

    static override fromJS(data: any): ImportFileData {
        data = typeof data === 'object' ? data : {};
        let result = new ImportFileData();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["base64String"] = this.base64String;
        data["siteId"] = this.siteId;
        if (Array.isArray(this.penIds)) {
            data["penIds"] = [];
            for (let item of this.penIds)
                data["penIds"].push(item);
        }
        data["totalWeight"] = this.totalWeight;
        data["avgWeight"] = this.avgWeight;
        data["locationType"] = this.locationType;
        data["animalType"] = this.animalType;
        data["breedingNumber"] = this.breedingNumber;
        super.toJSON(data);
        return data;
    }
}

export interface IImportFileData extends IImportIndex {
    base64String?: string | undefined;
    siteId?: string | undefined;
    penIds?: string[] | undefined;
    totalWeight?: number | undefined;
    avgWeight?: number | undefined;
    locationType: LocationType;
    animalType: AnimalType;
    breedingNumber?: string | undefined;
}

export abstract class BaseSyncOfStemAnimal implements IBaseSyncOfStemAnimal {
    syncTime!: Date;

    protected _discriminator: string;

    constructor(data?: IBaseSyncOfStemAnimal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "BaseSyncOfStemAnimal";
    }

    init(_data?: any) {
        if (_data) {
            this.syncTime = _data["syncTime"] ? new Date(_data["syncTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseSyncOfStemAnimal {
        data = typeof data === 'object' ? data : {};
        if (data["_discriminator"] === "SyncDataStemAnimal") {
            let result = new SyncDataStemAnimal();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'BaseSyncOfStemAnimal' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_discriminator"] = this._discriminator;
        data["syncTime"] = this.syncTime ? this.syncTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBaseSyncOfStemAnimal {
    syncTime: Date;
}

export class SyncDataStemAnimal extends BaseSyncOfStemAnimal implements ISyncDataStemAnimal {
    datas?: StemAnimal[] | undefined;

    constructor(data?: ISyncDataStemAnimal) {
        super(data);
        this._discriminator = "SyncDataStemAnimal";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["datas"])) {
                this.datas = [] as any;
                for (let item of _data["datas"])
                    this.datas!.push(StemAnimal.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): SyncDataStemAnimal {
        data = typeof data === 'object' ? data : {};
        let result = new SyncDataStemAnimal();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.datas)) {
            data["datas"] = [];
            for (let item of this.datas)
                data["datas"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISyncDataStemAnimal extends IBaseSyncOfStemAnimal {
    datas?: StemAnimal[] | undefined;
}

export class SingleStemAnimalInfo implements ISingleStemAnimalInfo {
    stemAnimal?: StemAnimal | undefined;
    pregnancies?: PregnancyEvent[] | undefined;
    moveEvent?: MoveEvent | undefined;
    lardScanningEvents?: LardScanningEvent[] | undefined;
    treatments?: Treatment[] | undefined;
    treatmentPlans?: TreatmentPlan[] | undefined;
    deadPigletEvents?: DeadPigletsEvent[] | undefined;

    constructor(data?: ISingleStemAnimalInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stemAnimal = _data["stemAnimal"] ? StemAnimal.fromJS(_data["stemAnimal"]) : <any>undefined;
            if (Array.isArray(_data["pregnancies"])) {
                this.pregnancies = [] as any;
                for (let item of _data["pregnancies"])
                    this.pregnancies!.push(PregnancyEvent.fromJS(item));
            }
            this.moveEvent = _data["moveEvent"] ? MoveEvent.fromJS(_data["moveEvent"]) : <any>undefined;
            if (Array.isArray(_data["lardScanningEvents"])) {
                this.lardScanningEvents = [] as any;
                for (let item of _data["lardScanningEvents"])
                    this.lardScanningEvents!.push(LardScanningEvent.fromJS(item));
            }
            if (Array.isArray(_data["treatments"])) {
                this.treatments = [] as any;
                for (let item of _data["treatments"])
                    this.treatments!.push(Treatment.fromJS(item));
            }
            if (Array.isArray(_data["treatmentPlans"])) {
                this.treatmentPlans = [] as any;
                for (let item of _data["treatmentPlans"])
                    this.treatmentPlans!.push(TreatmentPlan.fromJS(item));
            }
            if (Array.isArray(_data["deadPigletEvents"])) {
                this.deadPigletEvents = [] as any;
                for (let item of _data["deadPigletEvents"])
                    this.deadPigletEvents!.push(DeadPigletsEvent.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SingleStemAnimalInfo {
        data = typeof data === 'object' ? data : {};
        let result = new SingleStemAnimalInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stemAnimal"] = this.stemAnimal ? this.stemAnimal.toJSON() : <any>undefined;
        if (Array.isArray(this.pregnancies)) {
            data["pregnancies"] = [];
            for (let item of this.pregnancies)
                data["pregnancies"].push(item.toJSON());
        }
        data["moveEvent"] = this.moveEvent ? this.moveEvent.toJSON() : <any>undefined;
        if (Array.isArray(this.lardScanningEvents)) {
            data["lardScanningEvents"] = [];
            for (let item of this.lardScanningEvents)
                data["lardScanningEvents"].push(item.toJSON());
        }
        if (Array.isArray(this.treatments)) {
            data["treatments"] = [];
            for (let item of this.treatments)
                data["treatments"].push(item.toJSON());
        }
        if (Array.isArray(this.treatmentPlans)) {
            data["treatmentPlans"] = [];
            for (let item of this.treatmentPlans)
                data["treatmentPlans"].push(item.toJSON());
        }
        if (Array.isArray(this.deadPigletEvents)) {
            data["deadPigletEvents"] = [];
            for (let item of this.deadPigletEvents)
                data["deadPigletEvents"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISingleStemAnimalInfo {
    stemAnimal?: StemAnimal | undefined;
    pregnancies?: PregnancyEvent[] | undefined;
    moveEvent?: MoveEvent | undefined;
    lardScanningEvents?: LardScanningEvent[] | undefined;
    treatments?: Treatment[] | undefined;
    treatmentPlans?: TreatmentPlan[] | undefined;
    deadPigletEvents?: DeadPigletsEvent[] | undefined;
}

export class Treatment extends SiteEntity implements ITreatment {
    treatmentPlanId?: string | undefined;
    plannedDate!: Date;
    executedDate?: Date | undefined;
    executedByProfileId?: string | undefined;
    treatmentNumber!: number;
    pigletAmount?: number | undefined;
    animalWeight?: number | undefined;
    feedWeight?: number | undefined;
    amount?: number | undefined;
    animalType!: AnimalType;
    buildingId?: string | undefined;
    sectionId?: string | undefined;
    penId?: string | undefined;
    severity?: number | undefined;
    isRegistration!: boolean;

    constructor(data?: ITreatment) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.treatmentPlanId = _data["treatmentPlanId"];
            this.plannedDate = _data["plannedDate"] ? new Date(_data["plannedDate"].toString()) : <any>undefined;
            this.executedDate = _data["executedDate"] ? new Date(_data["executedDate"].toString()) : <any>undefined;
            this.executedByProfileId = _data["executedByProfileId"];
            this.treatmentNumber = _data["treatmentNumber"];
            this.pigletAmount = _data["pigletAmount"];
            this.animalWeight = _data["animalWeight"];
            this.feedWeight = _data["feedWeight"];
            this.amount = _data["amount"];
            this.animalType = _data["animalType"];
            this.buildingId = _data["buildingId"];
            this.sectionId = _data["sectionId"];
            this.penId = _data["penId"];
            this.severity = _data["severity"];
            this.isRegistration = _data["isRegistration"];
        }
    }

    static override fromJS(data: any): Treatment {
        data = typeof data === 'object' ? data : {};
        let result = new Treatment();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["treatmentPlanId"] = this.treatmentPlanId;
        data["plannedDate"] = this.plannedDate ? this.plannedDate.toISOString() : <any>undefined;
        data["executedDate"] = this.executedDate ? this.executedDate.toISOString() : <any>undefined;
        data["executedByProfileId"] = this.executedByProfileId;
        data["treatmentNumber"] = this.treatmentNumber;
        data["pigletAmount"] = this.pigletAmount;
        data["animalWeight"] = this.animalWeight;
        data["feedWeight"] = this.feedWeight;
        data["amount"] = this.amount;
        data["animalType"] = this.animalType;
        data["buildingId"] = this.buildingId;
        data["sectionId"] = this.sectionId;
        data["penId"] = this.penId;
        data["severity"] = this.severity;
        data["isRegistration"] = this.isRegistration;
        super.toJSON(data);
        return data;
    }
}

export interface ITreatment extends ISiteEntity {
    treatmentPlanId?: string | undefined;
    plannedDate: Date;
    executedDate?: Date | undefined;
    executedByProfileId?: string | undefined;
    treatmentNumber: number;
    pigletAmount?: number | undefined;
    animalWeight?: number | undefined;
    feedWeight?: number | undefined;
    amount?: number | undefined;
    animalType: AnimalType;
    buildingId?: string | undefined;
    sectionId?: string | undefined;
    penId?: string | undefined;
    severity?: number | undefined;
    isRegistration: boolean;
}

export class TreatmentPlan extends SiteEntity implements ITreatmentPlan {
    treatmentDefinitionId?: string | undefined;
    stemAnimalId?: string | undefined;
    marking?: string | undefined;
    gender!: Gender;
    isSowActive!: boolean;
    avgWeight?: number | undefined;
    isRegistration!: boolean;

    constructor(data?: ITreatmentPlan) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.treatmentDefinitionId = _data["treatmentDefinitionId"];
            this.stemAnimalId = _data["stemAnimalId"];
            this.marking = _data["marking"];
            this.gender = _data["gender"];
            this.isSowActive = _data["isSowActive"];
            this.avgWeight = _data["avgWeight"];
            this.isRegistration = _data["isRegistration"];
        }
    }

    static override fromJS(data: any): TreatmentPlan {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentPlan();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["treatmentDefinitionId"] = this.treatmentDefinitionId;
        data["stemAnimalId"] = this.stemAnimalId;
        data["marking"] = this.marking;
        data["gender"] = this.gender;
        data["isSowActive"] = this.isSowActive;
        data["avgWeight"] = this.avgWeight;
        data["isRegistration"] = this.isRegistration;
        super.toJSON(data);
        return data;
    }
}

export interface ITreatmentPlan extends ISiteEntity {
    treatmentDefinitionId?: string | undefined;
    stemAnimalId?: string | undefined;
    marking?: string | undefined;
    gender: Gender;
    isSowActive: boolean;
    avgWeight?: number | undefined;
    isRegistration: boolean;
}

export class DepartedAnimalData implements IDepartedAnimalData {
    departedStemAnimals?: StemAnimal[] | undefined;
    departedPregnancies?: { [key: string]: PregnancyEvent[]; } | undefined;
    departedMoveEvents?: MoveEvent[] | undefined;
    departedLardScanningEvents?: LardScanningEvent[] | undefined;

    constructor(data?: IDepartedAnimalData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["departedStemAnimals"])) {
                this.departedStemAnimals = [] as any;
                for (let item of _data["departedStemAnimals"])
                    this.departedStemAnimals!.push(StemAnimal.fromJS(item));
            }
            if (_data["departedPregnancies"]) {
                this.departedPregnancies = {} as any;
                for (let key in _data["departedPregnancies"]) {
                    if (_data["departedPregnancies"].hasOwnProperty(key))
                        (<any>this.departedPregnancies)![key] = _data["departedPregnancies"][key] ? _data["departedPregnancies"][key].map((i: any) => PregnancyEvent.fromJS(i)) : [];
                }
            }
            if (Array.isArray(_data["departedMoveEvents"])) {
                this.departedMoveEvents = [] as any;
                for (let item of _data["departedMoveEvents"])
                    this.departedMoveEvents!.push(MoveEvent.fromJS(item));
            }
            if (Array.isArray(_data["departedLardScanningEvents"])) {
                this.departedLardScanningEvents = [] as any;
                for (let item of _data["departedLardScanningEvents"])
                    this.departedLardScanningEvents!.push(LardScanningEvent.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DepartedAnimalData {
        data = typeof data === 'object' ? data : {};
        let result = new DepartedAnimalData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.departedStemAnimals)) {
            data["departedStemAnimals"] = [];
            for (let item of this.departedStemAnimals)
                data["departedStemAnimals"].push(item.toJSON());
        }
        if (this.departedPregnancies) {
            data["departedPregnancies"] = {};
            for (let key in this.departedPregnancies) {
                if (this.departedPregnancies.hasOwnProperty(key))
                    (<any>data["departedPregnancies"])[key] = (<any>this.departedPregnancies)[key];
            }
        }
        if (Array.isArray(this.departedMoveEvents)) {
            data["departedMoveEvents"] = [];
            for (let item of this.departedMoveEvents)
                data["departedMoveEvents"].push(item.toJSON());
        }
        if (Array.isArray(this.departedLardScanningEvents)) {
            data["departedLardScanningEvents"] = [];
            for (let item of this.departedLardScanningEvents)
                data["departedLardScanningEvents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDepartedAnimalData {
    departedStemAnimals?: StemAnimal[] | undefined;
    departedPregnancies?: { [key: string]: PregnancyEvent[]; } | undefined;
    departedMoveEvents?: MoveEvent[] | undefined;
    departedLardScanningEvents?: LardScanningEvent[] | undefined;
}

export class YoungFemaleReportData implements IYoungFemaleReportData {
    departedFromPool!: number;
    animalNumbers?: string[] | undefined;

    constructor(data?: IYoungFemaleReportData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.departedFromPool = _data["departedFromPool"];
            if (Array.isArray(_data["animalNumbers"])) {
                this.animalNumbers = [] as any;
                for (let item of _data["animalNumbers"])
                    this.animalNumbers!.push(item);
            }
        }
    }

    static fromJS(data: any): YoungFemaleReportData {
        data = typeof data === 'object' ? data : {};
        let result = new YoungFemaleReportData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["departedFromPool"] = this.departedFromPool;
        if (Array.isArray(this.animalNumbers)) {
            data["animalNumbers"] = [];
            for (let item of this.animalNumbers)
                data["animalNumbers"].push(item);
        }
        return data;
    }
}

export interface IYoungFemaleReportData {
    departedFromPool: number;
    animalNumbers?: string[] | undefined;
}

export class DistriwinValveAdjustments extends SiteEntity implements IDistriwinValveAdjustments {
    penIds?: PenAndCurve[] | undefined;

    constructor(data?: IDistriwinValveAdjustments) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["penIds"])) {
                this.penIds = [] as any;
                for (let item of _data["penIds"])
                    this.penIds!.push(PenAndCurve.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): DistriwinValveAdjustments {
        data = typeof data === 'object' ? data : {};
        let result = new DistriwinValveAdjustments();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.penIds)) {
            data["penIds"] = [];
            for (let item of this.penIds)
                data["penIds"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDistriwinValveAdjustments extends ISiteEntity {
    penIds?: PenAndCurve[] | undefined;
}

export class PenAndCurve implements IPenAndCurve {
    penId?: string | undefined;
    curveNumber?: string | undefined;

    constructor(data?: IPenAndCurve) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.penId = _data["penId"];
            this.curveNumber = _data["curveNumber"];
        }
    }

    static fromJS(data: any): PenAndCurve {
        data = typeof data === 'object' ? data : {};
        let result = new PenAndCurve();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["penId"] = this.penId;
        data["curveNumber"] = this.curveNumber;
        return data;
    }
}

export interface IPenAndCurve {
    penId?: string | undefined;
    curveNumber?: string | undefined;
}

export class SupplierDetailDto extends SlaughterDataRegistrationErrorBase implements ISupplierDetailDto {
    slaughterhouseCompany?: SlaughterhouseCompany | undefined;
    fromDate!: Date;
    toDate!: Date;
    buildingId?: string | undefined;
    sectionId?: string | undefined;
    supplierNumber?: string | undefined;
    slaughterHouseConnectionId?: string | undefined;

    constructor(data?: ISupplierDetailDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.slaughterhouseCompany = _data["slaughterhouseCompany"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : <any>undefined;
            this.buildingId = _data["buildingId"];
            this.sectionId = _data["sectionId"];
            this.supplierNumber = _data["supplierNumber"];
            this.slaughterHouseConnectionId = _data["slaughterHouseConnectionId"];
        }
    }

    static override fromJS(data: any): SupplierDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierDetailDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["slaughterhouseCompany"] = this.slaughterhouseCompany;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["buildingId"] = this.buildingId;
        data["sectionId"] = this.sectionId;
        data["supplierNumber"] = this.supplierNumber;
        data["slaughterHouseConnectionId"] = this.slaughterHouseConnectionId;
        super.toJSON(data);
        return data;
    }
}

export interface ISupplierDetailDto extends ISlaughterDataRegistrationErrorBase {
    slaughterhouseCompany?: SlaughterhouseCompany | undefined;
    fromDate: Date;
    toDate: Date;
    buildingId?: string | undefined;
    sectionId?: string | undefined;
    supplierNumber?: string | undefined;
    slaughterHouseConnectionId?: string | undefined;
}

export class SyncModel implements ISyncModel {
    stemAnimals?: SyncDataStemAnimal | undefined;
    growthPigEvents?: SyncGrowthPigEvents | undefined;
    pregnancies?: SyncDataPregnancyV2 | undefined;
    generalSettings?: SyncGeneralSettings | undefined;
    lardScanningEvents?: SyncDataLardScanningEvent | undefined;
    workListSettings?: SyncDataWorkListSetting | undefined;
    drugTypes?: SyncDataDrugType | undefined;
    markings?: SyncDataMarking | undefined;
    diagnoseCategories?: SyncDataDiagnoseCategory | undefined;
    diagnoses?: SyncDataDiagnose | undefined;
    reasons?: SyncDataReason | undefined;
    validationSetup?: SyncDataValidationSetup | undefined;
    treatments?: SyncDataTreatment | undefined;
    stations?: SyncStation | undefined;
    unitToPens?: SyncDataUnitToPen | undefined;
    esfFeedCurves?: SyncEsfFeedCurve | undefined;
    esfFeedingStatus?: SyncEsfFeedingStatus | undefined;
    treatmentPlans?: SyncDataTreatmentPlan | undefined;
    treatmentDefinitions?: SyncDataTreatmentDefinition | undefined;
    matingBatches?: SyncDataMatingBatch | undefined;
    moveEvents?: SyncDataMoveEvent | undefined;
    matingBatchSettings?: SyncDataMatingBatchSetting | undefined;
    locations?: SyncDataLocations | undefined;
    valveGroups?: SyncDataValveGroup | undefined;
    workListToTreatmentPlans?: SyncDataWorkListToTreatmentPlan | undefined;
    processEquipments?: SyncDataProcessEquipment | undefined;
    processEquipmentData?: SyncProcessEquipmentData | undefined;
    esfDailyStatus?: SyncEsfDailyStatus | undefined;
    deadPigletsEvents?: SyncDataDeadPigletsEvent | undefined;
    poolYoungFemales?: SyncPoolYoungFemale | undefined;
    distriwinOption?: SyncDistriwinOption | undefined;
    nucleusManagementBreedingSettings?: SyncDataNucleusManagementBreedingSettings | undefined;
    breedTableItems?: SyncDataBreedTableItem | undefined;

    constructor(data?: ISyncModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stemAnimals = _data["stemAnimals"] ? SyncDataStemAnimal.fromJS(_data["stemAnimals"]) : <any>undefined;
            this.growthPigEvents = _data["growthPigEvents"] ? SyncGrowthPigEvents.fromJS(_data["growthPigEvents"]) : <any>undefined;
            this.pregnancies = _data["pregnancies"] ? SyncDataPregnancyV2.fromJS(_data["pregnancies"]) : <any>undefined;
            this.generalSettings = _data["generalSettings"] ? SyncGeneralSettings.fromJS(_data["generalSettings"]) : <any>undefined;
            this.lardScanningEvents = _data["lardScanningEvents"] ? SyncDataLardScanningEvent.fromJS(_data["lardScanningEvents"]) : <any>undefined;
            this.workListSettings = _data["workListSettings"] ? SyncDataWorkListSetting.fromJS(_data["workListSettings"]) : <any>undefined;
            this.drugTypes = _data["drugTypes"] ? SyncDataDrugType.fromJS(_data["drugTypes"]) : <any>undefined;
            this.markings = _data["markings"] ? SyncDataMarking.fromJS(_data["markings"]) : <any>undefined;
            this.diagnoseCategories = _data["diagnoseCategories"] ? SyncDataDiagnoseCategory.fromJS(_data["diagnoseCategories"]) : <any>undefined;
            this.diagnoses = _data["diagnoses"] ? SyncDataDiagnose.fromJS(_data["diagnoses"]) : <any>undefined;
            this.reasons = _data["reasons"] ? SyncDataReason.fromJS(_data["reasons"]) : <any>undefined;
            this.validationSetup = _data["validationSetup"] ? SyncDataValidationSetup.fromJS(_data["validationSetup"]) : <any>undefined;
            this.treatments = _data["treatments"] ? SyncDataTreatment.fromJS(_data["treatments"]) : <any>undefined;
            this.stations = _data["stations"] ? SyncStation.fromJS(_data["stations"]) : <any>undefined;
            this.unitToPens = _data["unitToPens"] ? SyncDataUnitToPen.fromJS(_data["unitToPens"]) : <any>undefined;
            this.esfFeedCurves = _data["esfFeedCurves"] ? SyncEsfFeedCurve.fromJS(_data["esfFeedCurves"]) : <any>undefined;
            this.esfFeedingStatus = _data["esfFeedingStatus"] ? SyncEsfFeedingStatus.fromJS(_data["esfFeedingStatus"]) : <any>undefined;
            this.treatmentPlans = _data["treatmentPlans"] ? SyncDataTreatmentPlan.fromJS(_data["treatmentPlans"]) : <any>undefined;
            this.treatmentDefinitions = _data["treatmentDefinitions"] ? SyncDataTreatmentDefinition.fromJS(_data["treatmentDefinitions"]) : <any>undefined;
            this.matingBatches = _data["matingBatches"] ? SyncDataMatingBatch.fromJS(_data["matingBatches"]) : <any>undefined;
            this.moveEvents = _data["moveEvents"] ? SyncDataMoveEvent.fromJS(_data["moveEvents"]) : <any>undefined;
            this.matingBatchSettings = _data["matingBatchSettings"] ? SyncDataMatingBatchSetting.fromJS(_data["matingBatchSettings"]) : <any>undefined;
            this.locations = _data["locations"] ? SyncDataLocations.fromJS(_data["locations"]) : <any>undefined;
            this.valveGroups = _data["valveGroups"] ? SyncDataValveGroup.fromJS(_data["valveGroups"]) : <any>undefined;
            this.workListToTreatmentPlans = _data["workListToTreatmentPlans"] ? SyncDataWorkListToTreatmentPlan.fromJS(_data["workListToTreatmentPlans"]) : <any>undefined;
            this.processEquipments = _data["processEquipments"] ? SyncDataProcessEquipment.fromJS(_data["processEquipments"]) : <any>undefined;
            this.processEquipmentData = _data["processEquipmentData"] ? SyncProcessEquipmentData.fromJS(_data["processEquipmentData"]) : <any>undefined;
            this.esfDailyStatus = _data["esfDailyStatus"] ? SyncEsfDailyStatus.fromJS(_data["esfDailyStatus"]) : <any>undefined;
            this.deadPigletsEvents = _data["deadPigletsEvents"] ? SyncDataDeadPigletsEvent.fromJS(_data["deadPigletsEvents"]) : <any>undefined;
            this.poolYoungFemales = _data["poolYoungFemales"] ? SyncPoolYoungFemale.fromJS(_data["poolYoungFemales"]) : <any>undefined;
            this.distriwinOption = _data["distriwinOption"] ? SyncDistriwinOption.fromJS(_data["distriwinOption"]) : <any>undefined;
            this.nucleusManagementBreedingSettings = _data["nucleusManagementBreedingSettings"] ? SyncDataNucleusManagementBreedingSettings.fromJS(_data["nucleusManagementBreedingSettings"]) : <any>undefined;
            this.breedTableItems = _data["breedTableItems"] ? SyncDataBreedTableItem.fromJS(_data["breedTableItems"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SyncModel {
        data = typeof data === 'object' ? data : {};
        let result = new SyncModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stemAnimals"] = this.stemAnimals ? this.stemAnimals.toJSON() : <any>undefined;
        data["growthPigEvents"] = this.growthPigEvents ? this.growthPigEvents.toJSON() : <any>undefined;
        data["pregnancies"] = this.pregnancies ? this.pregnancies.toJSON() : <any>undefined;
        data["generalSettings"] = this.generalSettings ? this.generalSettings.toJSON() : <any>undefined;
        data["lardScanningEvents"] = this.lardScanningEvents ? this.lardScanningEvents.toJSON() : <any>undefined;
        data["workListSettings"] = this.workListSettings ? this.workListSettings.toJSON() : <any>undefined;
        data["drugTypes"] = this.drugTypes ? this.drugTypes.toJSON() : <any>undefined;
        data["markings"] = this.markings ? this.markings.toJSON() : <any>undefined;
        data["diagnoseCategories"] = this.diagnoseCategories ? this.diagnoseCategories.toJSON() : <any>undefined;
        data["diagnoses"] = this.diagnoses ? this.diagnoses.toJSON() : <any>undefined;
        data["reasons"] = this.reasons ? this.reasons.toJSON() : <any>undefined;
        data["validationSetup"] = this.validationSetup ? this.validationSetup.toJSON() : <any>undefined;
        data["treatments"] = this.treatments ? this.treatments.toJSON() : <any>undefined;
        data["stations"] = this.stations ? this.stations.toJSON() : <any>undefined;
        data["unitToPens"] = this.unitToPens ? this.unitToPens.toJSON() : <any>undefined;
        data["esfFeedCurves"] = this.esfFeedCurves ? this.esfFeedCurves.toJSON() : <any>undefined;
        data["esfFeedingStatus"] = this.esfFeedingStatus ? this.esfFeedingStatus.toJSON() : <any>undefined;
        data["treatmentPlans"] = this.treatmentPlans ? this.treatmentPlans.toJSON() : <any>undefined;
        data["treatmentDefinitions"] = this.treatmentDefinitions ? this.treatmentDefinitions.toJSON() : <any>undefined;
        data["matingBatches"] = this.matingBatches ? this.matingBatches.toJSON() : <any>undefined;
        data["moveEvents"] = this.moveEvents ? this.moveEvents.toJSON() : <any>undefined;
        data["matingBatchSettings"] = this.matingBatchSettings ? this.matingBatchSettings.toJSON() : <any>undefined;
        data["locations"] = this.locations ? this.locations.toJSON() : <any>undefined;
        data["valveGroups"] = this.valveGroups ? this.valveGroups.toJSON() : <any>undefined;
        data["workListToTreatmentPlans"] = this.workListToTreatmentPlans ? this.workListToTreatmentPlans.toJSON() : <any>undefined;
        data["processEquipments"] = this.processEquipments ? this.processEquipments.toJSON() : <any>undefined;
        data["processEquipmentData"] = this.processEquipmentData ? this.processEquipmentData.toJSON() : <any>undefined;
        data["esfDailyStatus"] = this.esfDailyStatus ? this.esfDailyStatus.toJSON() : <any>undefined;
        data["deadPigletsEvents"] = this.deadPigletsEvents ? this.deadPigletsEvents.toJSON() : <any>undefined;
        data["poolYoungFemales"] = this.poolYoungFemales ? this.poolYoungFemales.toJSON() : <any>undefined;
        data["distriwinOption"] = this.distriwinOption ? this.distriwinOption.toJSON() : <any>undefined;
        data["nucleusManagementBreedingSettings"] = this.nucleusManagementBreedingSettings ? this.nucleusManagementBreedingSettings.toJSON() : <any>undefined;
        data["breedTableItems"] = this.breedTableItems ? this.breedTableItems.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISyncModel {
    stemAnimals?: SyncDataStemAnimal | undefined;
    growthPigEvents?: SyncGrowthPigEvents | undefined;
    pregnancies?: SyncDataPregnancyV2 | undefined;
    generalSettings?: SyncGeneralSettings | undefined;
    lardScanningEvents?: SyncDataLardScanningEvent | undefined;
    workListSettings?: SyncDataWorkListSetting | undefined;
    drugTypes?: SyncDataDrugType | undefined;
    markings?: SyncDataMarking | undefined;
    diagnoseCategories?: SyncDataDiagnoseCategory | undefined;
    diagnoses?: SyncDataDiagnose | undefined;
    reasons?: SyncDataReason | undefined;
    validationSetup?: SyncDataValidationSetup | undefined;
    treatments?: SyncDataTreatment | undefined;
    stations?: SyncStation | undefined;
    unitToPens?: SyncDataUnitToPen | undefined;
    esfFeedCurves?: SyncEsfFeedCurve | undefined;
    esfFeedingStatus?: SyncEsfFeedingStatus | undefined;
    treatmentPlans?: SyncDataTreatmentPlan | undefined;
    treatmentDefinitions?: SyncDataTreatmentDefinition | undefined;
    matingBatches?: SyncDataMatingBatch | undefined;
    moveEvents?: SyncDataMoveEvent | undefined;
    matingBatchSettings?: SyncDataMatingBatchSetting | undefined;
    locations?: SyncDataLocations | undefined;
    valveGroups?: SyncDataValveGroup | undefined;
    workListToTreatmentPlans?: SyncDataWorkListToTreatmentPlan | undefined;
    processEquipments?: SyncDataProcessEquipment | undefined;
    processEquipmentData?: SyncProcessEquipmentData | undefined;
    esfDailyStatus?: SyncEsfDailyStatus | undefined;
    deadPigletsEvents?: SyncDataDeadPigletsEvent | undefined;
    poolYoungFemales?: SyncPoolYoungFemale | undefined;
    distriwinOption?: SyncDistriwinOption | undefined;
    nucleusManagementBreedingSettings?: SyncDataNucleusManagementBreedingSettings | undefined;
    breedTableItems?: SyncDataBreedTableItem | undefined;
}

export abstract class BaseSyncOfWorkListSetting implements IBaseSyncOfWorkListSetting {
    syncTime!: Date;

    protected _discriminator: string;

    constructor(data?: IBaseSyncOfWorkListSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "BaseSyncOfWorkListSetting";
    }

    init(_data?: any) {
        if (_data) {
            this.syncTime = _data["syncTime"] ? new Date(_data["syncTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseSyncOfWorkListSetting {
        data = typeof data === 'object' ? data : {};
        if (data["_discriminator"] === "SyncDataWorkListSetting") {
            let result = new SyncDataWorkListSetting();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'BaseSyncOfWorkListSetting' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_discriminator"] = this._discriminator;
        data["syncTime"] = this.syncTime ? this.syncTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBaseSyncOfWorkListSetting {
    syncTime: Date;
}

export class SyncDataWorkListSetting extends BaseSyncOfWorkListSetting implements ISyncDataWorkListSetting {
    datas?: WorkListSetting[] | undefined;

    constructor(data?: ISyncDataWorkListSetting) {
        super(data);
        this._discriminator = "SyncDataWorkListSetting";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["datas"])) {
                this.datas = [] as any;
                for (let item of _data["datas"])
                    this.datas!.push(WorkListSetting.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): SyncDataWorkListSetting {
        data = typeof data === 'object' ? data : {};
        let result = new SyncDataWorkListSetting();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.datas)) {
            data["datas"] = [];
            for (let item of this.datas)
                data["datas"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISyncDataWorkListSetting extends IBaseSyncOfWorkListSetting {
    datas?: WorkListSetting[] | undefined;
}

export class WorkListSetting extends SiteEntity implements IWorkListSetting {
    name?: string | undefined;
    showOnApp!: boolean;
    showOnWeb!: boolean;
    type!: WorkListType;

    protected _discriminator: string;

    constructor(data?: IWorkListSetting) {
        super(data);
        this._discriminator = "WorkListSetting";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.showOnApp = _data["showOnApp"];
            this.showOnWeb = _data["showOnWeb"];
            this.type = _data["type"];
        }
    }

    static override fromJS(data: any): WorkListSetting {
        data = typeof data === 'object' ? data : {};
        if (data["derivedTypeSelector"] === "MoveToPregnancyLocation") {
            let result = new MoveToPregnancyLocation();
            result.init(data);
            return result;
        }
        if (data["derivedTypeSelector"] === "LardScanningEventListSetting") {
            let result = new LardScanningEventListSetting();
            result.init(data);
            return result;
        }
        if (data["derivedTypeSelector"] === "LardScanningEventListSettingBase") {
            let result = new LardScanningEventListSettingBase();
            result.init(data);
            return result;
        }
        if (data["derivedTypeSelector"] === "LardScanningEventListSetting2") {
            let result = new LardScanningEventListSetting2();
            result.init(data);
            return result;
        }
        if (data["derivedTypeSelector"] === "MoveToFarrowingLocation") {
            let result = new MoveToFarrowingLocation();
            result.init(data);
            return result;
        }
        if (data["derivedTypeSelector"] === "MoveToMatingLocation") {
            let result = new MoveToMatingLocation();
            result.init(data);
            return result;
        }
        if (data["derivedTypeSelector"] === "AllAnimalsEsfListSetting") {
            let result = new AllAnimalsEsfListSetting();
            result.init(data);
            return result;
        }
        if (data["derivedTypeSelector"] === "DistriwinAllAnimalsListSetting") {
            let result = new DistriwinAllAnimalsListSetting();
            result.init(data);
            return result;
        }
        if (data["derivedTypeSelector"] === "ShortageEsfListSetting") {
            let result = new ShortageEsfListSetting();
            result.init(data);
            return result;
        }
        if (data["derivedTypeSelector"] === "FarrowingListSetting") {
            let result = new FarrowingListSetting();
            result.init(data);
            return result;
        }
        if (data["derivedTypeSelector"] === "WeaningListSetting") {
            let result = new WeaningListSetting();
            result.init(data);
            return result;
        }
        if (data["derivedTypeSelector"] === "MatingListSetting") {
            let result = new MatingListSetting();
            result.init(data);
            return result;
        }
        if (data["derivedTypeSelector"] === "TasksInFarrowingStableSetting") {
            let result = new TasksInFarrowingStableSetting();
            result.init(data);
            return result;
        }
        if (data["derivedTypeSelector"] === "TasksInFarrowingBase") {
            let result = new TasksInFarrowingBase();
            result.init(data);
            return result;
        }
        if (data["derivedTypeSelector"] === "TasksInFarrowingStableSetting2") {
            let result = new TasksInFarrowingStableSetting2();
            result.init(data);
            return result;
        }
        if (data["derivedTypeSelector"] === "ScanningListSetting") {
            let result = new ScanningListSetting();
            result.init(data);
            return result;
        }
        if (data["derivedTypeSelector"] === "ScanningListSettingBase") {
            let result = new ScanningListSettingBase();
            result.init(data);
            return result;
        }
        if (data["derivedTypeSelector"] === "ScanningListSetting2") {
            let result = new ScanningListSetting2();
            result.init(data);
            return result;
        }
        if (data["derivedTypeSelector"] === "VaccineListSetting") {
            let result = new VaccineListSetting();
            result.init(data);
            return result;
        }
        if (data["derivedTypeSelector"] === "VaccineListSetting1") {
            let result = new VaccineListSetting1();
            result.init(data);
            return result;
        }
        if (data["derivedTypeSelector"] === "VaccineListSetting2") {
            let result = new VaccineListSetting2();
            result.init(data);
            return result;
        }
        if (data["derivedTypeSelector"] === "VaccineListSetting3") {
            let result = new VaccineListSetting3();
            result.init(data);
            return result;
        }
        if (data["derivedTypeSelector"] === "MoveFromPregToPregSetting") {
            let result = new MoveFromPregToPregSetting();
            result.init(data);
            return result;
        }
        if (data["derivedTypeSelector"] === "MoveMatingToMatingSetting") {
            let result = new MoveMatingToMatingSetting();
            result.init(data);
            return result;
        }
        if (data["derivedTypeSelector"] === "DepartureWorkListSetting") {
            let result = new DepartureWorkListSetting();
            result.init(data);
            return result;
        }
        if (data["derivedTypeSelector"] === "SowTaskSettings") {
            let result = new SowTaskSettings();
            result.init(data);
            return result;
        }
        if (data["derivedTypeSelector"] === "SowTaskSettings1") {
            let result = new SowTaskSettings1();
            result.init(data);
            return result;
        }
        if (data["derivedTypeSelector"] === "SowTaskSettings2") {
            let result = new SowTaskSettings2();
            result.init(data);
            return result;
        }
        if (data["derivedTypeSelector"] === "BasicMoveListSetting") {
            let result = new BasicMoveListSetting();
            result.init(data);
            return result;
        }
        let result = new WorkListSetting();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["derivedTypeSelector"] = this._discriminator;
        data["name"] = this.name;
        data["showOnApp"] = this.showOnApp;
        data["showOnWeb"] = this.showOnWeb;
        data["type"] = this.type;
        super.toJSON(data);
        return data;
    }
}

export interface IWorkListSetting extends ISiteEntity {
    name?: string | undefined;
    showOnApp: boolean;
    showOnWeb: boolean;
    type: WorkListType;
}

export enum WorkListType {
    MoveToPregnancyLocation = "MoveToPregnancyLocation",
    MoveToFarrowingLocation = "MoveToFarrowingLocation",
    MoveToMatingLocation = "MoveToMatingLocation",
    MatingListSetting = "MatingListSetting",
    FarrowingListSetting = "FarrowingListSetting",
    WeaningListSetting = "WeaningListSetting",
    ScanningListSetting = "ScanningListSetting",
    ScanningListSetting2 = "ScanningListSetting2",
    TasksInFarrowingStableSetting = "TasksInFarrowingStableSetting",
    TasksInFarrowingStableSetting2 = "TasksInFarrowingStableSetting2",
    VaccineListSetting1 = "VaccineListSetting1",
    VaccineListSetting2 = "VaccineListSetting2",
    AllAnimalsEsfListSetting = "AllAnimalsEsfListSetting",
    ShortageEsfListSetting = "ShortageEsfListSetting",
    MoveFromPregToPregSetting = "MoveFromPregToPregSetting",
    MoveMatingToMatingSetting = "MoveMatingToMatingSetting",
    DepartureWorkListSetting = "DepartureWorkListSetting",
    LardScanningEventListSetting = "LardScanningEventListSetting",
    LardScanningEventListSetting2 = "LardScanningEventListSetting2",
    SowTaskSettings1 = "SowTaskSettings1",
    SowTaskSettings2 = "SowTaskSettings2",
    VaccineListSetting3 = "VaccineListSetting3",
    DistriwinAllAnimalsListSetting = "DistriwinAllAnimalsListSetting",
    BasicMoveListSetting = "BasicMoveListSetting",
}

export class MoveToPregnancyLocation extends WorkListSetting implements IMoveToPregnancyLocation {
    batchCycleDays?: number | undefined;
    cycleDaysFrom?: number | undefined;
    cycleDaysTo?: number | undefined;
    feedCurve?: FeedCurve | undefined;
    buildingId?: string | undefined;
    sectionId?: string | undefined;
    penId?: string | undefined;
    selectedType!: MoveToLocationTypes;
    negativeCycleDays!: boolean;
    reader?: ESFReader | undefined;
    defaultFeedCurves?: DefaultFeedCurve[] | undefined;

    constructor(data?: IMoveToPregnancyLocation) {
        super(data);
        this._discriminator = "MoveToPregnancyLocation";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.batchCycleDays = _data["batchCycleDays"];
            this.cycleDaysFrom = _data["cycleDaysFrom"];
            this.cycleDaysTo = _data["cycleDaysTo"];
            this.feedCurve = _data["feedCurve"] ? FeedCurve.fromJS(_data["feedCurve"]) : <any>undefined;
            this.buildingId = _data["buildingId"];
            this.sectionId = _data["sectionId"];
            this.penId = _data["penId"];
            this.selectedType = _data["selectedType"];
            this.negativeCycleDays = _data["negativeCycleDays"];
            this.reader = _data["reader"];
            if (Array.isArray(_data["defaultFeedCurves"])) {
                this.defaultFeedCurves = [] as any;
                for (let item of _data["defaultFeedCurves"])
                    this.defaultFeedCurves!.push(DefaultFeedCurve.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): MoveToPregnancyLocation {
        data = typeof data === 'object' ? data : {};
        let result = new MoveToPregnancyLocation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchCycleDays"] = this.batchCycleDays;
        data["cycleDaysFrom"] = this.cycleDaysFrom;
        data["cycleDaysTo"] = this.cycleDaysTo;
        data["feedCurve"] = this.feedCurve ? this.feedCurve.toJSON() : <any>undefined;
        data["buildingId"] = this.buildingId;
        data["sectionId"] = this.sectionId;
        data["penId"] = this.penId;
        data["selectedType"] = this.selectedType;
        data["negativeCycleDays"] = this.negativeCycleDays;
        data["reader"] = this.reader;
        if (Array.isArray(this.defaultFeedCurves)) {
            data["defaultFeedCurves"] = [];
            for (let item of this.defaultFeedCurves)
                data["defaultFeedCurves"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IMoveToPregnancyLocation extends IWorkListSetting {
    batchCycleDays?: number | undefined;
    cycleDaysFrom?: number | undefined;
    cycleDaysTo?: number | undefined;
    feedCurve?: FeedCurve | undefined;
    buildingId?: string | undefined;
    sectionId?: string | undefined;
    penId?: string | undefined;
    selectedType: MoveToLocationTypes;
    negativeCycleDays: boolean;
    reader?: ESFReader | undefined;
    defaultFeedCurves?: DefaultFeedCurve[] | undefined;
}

export enum MoveToLocationTypes {
    Location = "Location",
    MatingBatch = "MatingBatch",
    PregnacyDays = "PregnacyDays",
    Date = "Date",
    Blank = "Blank",
}

export class DefaultFeedCurve implements IDefaultFeedCurve {
    animalKind!: AnimalKind;
    feedCurveNumber?: number | undefined;
    locationCode?: string | undefined;

    constructor(data?: IDefaultFeedCurve) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.animalKind = _data["animalKind"];
            this.feedCurveNumber = _data["feedCurveNumber"];
            this.locationCode = _data["locationCode"];
        }
    }

    static fromJS(data: any): DefaultFeedCurve {
        data = typeof data === 'object' ? data : {};
        let result = new DefaultFeedCurve();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["animalKind"] = this.animalKind;
        data["feedCurveNumber"] = this.feedCurveNumber;
        data["locationCode"] = this.locationCode;
        return data;
    }
}

export interface IDefaultFeedCurve {
    animalKind: AnimalKind;
    feedCurveNumber?: number | undefined;
    locationCode?: string | undefined;
}

export class LardScanningEventListSettingBase extends WorkListSetting implements ILardScanningEventListSettingBase {
    selectedType!: LardScanningEventTypes;
    batchCycleDays?: number | undefined;
    cycleDaysFrom?: number | undefined;
    cycleDaysTo?: number | undefined;
    daysAfterEvent?: number | undefined;
    negativeCycleDays!: boolean;
    sowState?: SowState | undefined;
    weeksAfterEvent?: number | undefined;

    constructor(data?: ILardScanningEventListSettingBase) {
        super(data);
        this._discriminator = "LardScanningEventListSettingBase";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.selectedType = _data["selectedType"];
            this.batchCycleDays = _data["batchCycleDays"];
            this.cycleDaysFrom = _data["cycleDaysFrom"];
            this.cycleDaysTo = _data["cycleDaysTo"];
            this.daysAfterEvent = _data["daysAfterEvent"];
            this.negativeCycleDays = _data["negativeCycleDays"];
            this.sowState = _data["sowState"];
            this.weeksAfterEvent = _data["weeksAfterEvent"];
        }
    }

    static override fromJS(data: any): LardScanningEventListSettingBase {
        data = typeof data === 'object' ? data : {};
        if (data["derivedTypeSelector"] === "LardScanningEventListSetting") {
            let result = new LardScanningEventListSetting();
            result.init(data);
            return result;
        }
        if (data["derivedTypeSelector"] === "LardScanningEventListSetting2") {
            let result = new LardScanningEventListSetting2();
            result.init(data);
            return result;
        }
        let result = new LardScanningEventListSettingBase();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selectedType"] = this.selectedType;
        data["batchCycleDays"] = this.batchCycleDays;
        data["cycleDaysFrom"] = this.cycleDaysFrom;
        data["cycleDaysTo"] = this.cycleDaysTo;
        data["daysAfterEvent"] = this.daysAfterEvent;
        data["negativeCycleDays"] = this.negativeCycleDays;
        data["sowState"] = this.sowState;
        data["weeksAfterEvent"] = this.weeksAfterEvent;
        super.toJSON(data);
        return data;
    }
}

export interface ILardScanningEventListSettingBase extends IWorkListSetting {
    selectedType: LardScanningEventTypes;
    batchCycleDays?: number | undefined;
    cycleDaysFrom?: number | undefined;
    cycleDaysTo?: number | undefined;
    daysAfterEvent?: number | undefined;
    negativeCycleDays: boolean;
    sowState?: SowState | undefined;
    weeksAfterEvent?: number | undefined;
}

export class LardScanningEventListSetting extends LardScanningEventListSettingBase implements ILardScanningEventListSetting {

    constructor(data?: ILardScanningEventListSetting) {
        super(data);
        this._discriminator = "LardScanningEventListSetting";
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): LardScanningEventListSetting {
        data = typeof data === 'object' ? data : {};
        let result = new LardScanningEventListSetting();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ILardScanningEventListSetting extends ILardScanningEventListSettingBase {
}

export enum LardScanningEventTypes {
    Mating = "Mating",
    Farrowing = "Farrowing",
    MatingBatch = "MatingBatch",
}

export class LardScanningEventListSetting2 extends LardScanningEventListSettingBase implements ILardScanningEventListSetting2 {

    constructor(data?: ILardScanningEventListSetting2) {
        super(data);
        this._discriminator = "LardScanningEventListSetting2";
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): LardScanningEventListSetting2 {
        data = typeof data === 'object' ? data : {};
        let result = new LardScanningEventListSetting2();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ILardScanningEventListSetting2 extends ILardScanningEventListSettingBase {
}

export class MoveToFarrowingLocation extends WorkListSetting implements IMoveToFarrowingLocation {
    batchCycleDays?: number | undefined;
    cycleDaysFrom?: number | undefined;
    cycleDaysTo?: number | undefined;
    feedCurve?: FeedCurve | undefined;
    buildingId?: string | undefined;
    sectionId?: string | undefined;
    penId?: string | undefined;
    selectedType!: MoveToLocationTypes;
    negativeCycleDays!: boolean;
    usesLocation!: boolean;
    showAvgPregnancyDays!: boolean;

    constructor(data?: IMoveToFarrowingLocation) {
        super(data);
        this._discriminator = "MoveToFarrowingLocation";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.batchCycleDays = _data["batchCycleDays"];
            this.cycleDaysFrom = _data["cycleDaysFrom"];
            this.cycleDaysTo = _data["cycleDaysTo"];
            this.feedCurve = _data["feedCurve"] ? FeedCurve.fromJS(_data["feedCurve"]) : <any>undefined;
            this.buildingId = _data["buildingId"];
            this.sectionId = _data["sectionId"];
            this.penId = _data["penId"];
            this.selectedType = _data["selectedType"];
            this.negativeCycleDays = _data["negativeCycleDays"];
            this.usesLocation = _data["usesLocation"];
            this.showAvgPregnancyDays = _data["showAvgPregnancyDays"];
        }
    }

    static override fromJS(data: any): MoveToFarrowingLocation {
        data = typeof data === 'object' ? data : {};
        let result = new MoveToFarrowingLocation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchCycleDays"] = this.batchCycleDays;
        data["cycleDaysFrom"] = this.cycleDaysFrom;
        data["cycleDaysTo"] = this.cycleDaysTo;
        data["feedCurve"] = this.feedCurve ? this.feedCurve.toJSON() : <any>undefined;
        data["buildingId"] = this.buildingId;
        data["sectionId"] = this.sectionId;
        data["penId"] = this.penId;
        data["selectedType"] = this.selectedType;
        data["negativeCycleDays"] = this.negativeCycleDays;
        data["usesLocation"] = this.usesLocation;
        data["showAvgPregnancyDays"] = this.showAvgPregnancyDays;
        super.toJSON(data);
        return data;
    }
}

export interface IMoveToFarrowingLocation extends IWorkListSetting {
    batchCycleDays?: number | undefined;
    cycleDaysFrom?: number | undefined;
    cycleDaysTo?: number | undefined;
    feedCurve?: FeedCurve | undefined;
    buildingId?: string | undefined;
    sectionId?: string | undefined;
    penId?: string | undefined;
    selectedType: MoveToLocationTypes;
    negativeCycleDays: boolean;
    usesLocation: boolean;
    showAvgPregnancyDays: boolean;
}

export class MoveToMatingLocation extends WorkListSetting implements IMoveToMatingLocation {
    cycleDaysFrom?: number | undefined;
    cycleDaysTo?: number | undefined;
    feedCurve?: FeedCurve | undefined;
    selectedType!: MoveToLocationTypes;
    negativeCycleDays!: boolean;

    constructor(data?: IMoveToMatingLocation) {
        super(data);
        this._discriminator = "MoveToMatingLocation";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.cycleDaysFrom = _data["cycleDaysFrom"];
            this.cycleDaysTo = _data["cycleDaysTo"];
            this.feedCurve = _data["feedCurve"] ? FeedCurve.fromJS(_data["feedCurve"]) : <any>undefined;
            this.selectedType = _data["selectedType"];
            this.negativeCycleDays = _data["negativeCycleDays"];
        }
    }

    static override fromJS(data: any): MoveToMatingLocation {
        data = typeof data === 'object' ? data : {};
        let result = new MoveToMatingLocation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cycleDaysFrom"] = this.cycleDaysFrom;
        data["cycleDaysTo"] = this.cycleDaysTo;
        data["feedCurve"] = this.feedCurve ? this.feedCurve.toJSON() : <any>undefined;
        data["selectedType"] = this.selectedType;
        data["negativeCycleDays"] = this.negativeCycleDays;
        super.toJSON(data);
        return data;
    }
}

export interface IMoveToMatingLocation extends IWorkListSetting {
    cycleDaysFrom?: number | undefined;
    cycleDaysTo?: number | undefined;
    feedCurve?: FeedCurve | undefined;
    selectedType: MoveToLocationTypes;
    negativeCycleDays: boolean;
}

export class AllAnimalsEsfListSetting extends WorkListSetting implements IAllAnimalsEsfListSetting {
    negativeCycleDays!: boolean;
    reader?: ESFReader | undefined;

    constructor(data?: IAllAnimalsEsfListSetting) {
        super(data);
        this._discriminator = "AllAnimalsEsfListSetting";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.negativeCycleDays = _data["negativeCycleDays"];
            this.reader = _data["reader"];
        }
    }

    static override fromJS(data: any): AllAnimalsEsfListSetting {
        data = typeof data === 'object' ? data : {};
        let result = new AllAnimalsEsfListSetting();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["negativeCycleDays"] = this.negativeCycleDays;
        data["reader"] = this.reader;
        super.toJSON(data);
        return data;
    }
}

export interface IAllAnimalsEsfListSetting extends IWorkListSetting {
    negativeCycleDays: boolean;
    reader?: ESFReader | undefined;
}

export class DistriwinAllAnimalsListSetting extends WorkListSetting implements IDistriwinAllAnimalsListSetting {
    negativeCycleDays!: boolean;

    constructor(data?: IDistriwinAllAnimalsListSetting) {
        super(data);
        this._discriminator = "DistriwinAllAnimalsListSetting";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.negativeCycleDays = _data["negativeCycleDays"];
        }
    }

    static override fromJS(data: any): DistriwinAllAnimalsListSetting {
        data = typeof data === 'object' ? data : {};
        let result = new DistriwinAllAnimalsListSetting();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["negativeCycleDays"] = this.negativeCycleDays;
        super.toJSON(data);
        return data;
    }
}

export interface IDistriwinAllAnimalsListSetting extends IWorkListSetting {
    negativeCycleDays: boolean;
}

export class ShortageEsfListSetting extends WorkListSetting implements IShortageEsfListSetting {
    negativeCycleDays!: boolean;
    today!: boolean;
    yesterday!: boolean;
    feedRationPercentUnfed!: number;
    reader?: ESFReader | undefined;
    useShortenVersion!: boolean;

    constructor(data?: IShortageEsfListSetting) {
        super(data);
        this._discriminator = "ShortageEsfListSetting";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.negativeCycleDays = _data["negativeCycleDays"];
            this.today = _data["today"];
            this.yesterday = _data["yesterday"];
            this.feedRationPercentUnfed = _data["feedRationPercentUnfed"];
            this.reader = _data["reader"];
            this.useShortenVersion = _data["useShortenVersion"];
        }
    }

    static override fromJS(data: any): ShortageEsfListSetting {
        data = typeof data === 'object' ? data : {};
        let result = new ShortageEsfListSetting();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["negativeCycleDays"] = this.negativeCycleDays;
        data["today"] = this.today;
        data["yesterday"] = this.yesterday;
        data["feedRationPercentUnfed"] = this.feedRationPercentUnfed;
        data["reader"] = this.reader;
        data["useShortenVersion"] = this.useShortenVersion;
        super.toJSON(data);
        return data;
    }
}

export interface IShortageEsfListSetting extends IWorkListSetting {
    negativeCycleDays: boolean;
    today: boolean;
    yesterday: boolean;
    feedRationPercentUnfed: number;
    reader?: ESFReader | undefined;
    useShortenVersion: boolean;
}

export class FarrowingListSetting extends WorkListSetting implements IFarrowingListSetting {
    cycleDays!: number;
    usesLocation!: boolean;
    showAvgPregnancyDays!: boolean;
    selectedType!: FarrowingListTypes;

    constructor(data?: IFarrowingListSetting) {
        super(data);
        this._discriminator = "FarrowingListSetting";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.cycleDays = _data["cycleDays"];
            this.usesLocation = _data["usesLocation"];
            this.showAvgPregnancyDays = _data["showAvgPregnancyDays"];
            this.selectedType = _data["selectedType"];
        }
    }

    static override fromJS(data: any): FarrowingListSetting {
        data = typeof data === 'object' ? data : {};
        let result = new FarrowingListSetting();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cycleDays"] = this.cycleDays;
        data["usesLocation"] = this.usesLocation;
        data["showAvgPregnancyDays"] = this.showAvgPregnancyDays;
        data["selectedType"] = this.selectedType;
        super.toJSON(data);
        return data;
    }
}

export interface IFarrowingListSetting extends IWorkListSetting {
    cycleDays: number;
    usesLocation: boolean;
    showAvgPregnancyDays: boolean;
    selectedType: FarrowingListTypes;
}

export enum FarrowingListTypes {
    Location = "Location",
    PregnancyDays = "PregnancyDays",
}

export class WeaningListSetting extends WorkListSetting implements IWeaningListSetting {
    cycleDays!: number;
    selectedType!: WeaningListTypes;

    constructor(data?: IWeaningListSetting) {
        super(data);
        this._discriminator = "WeaningListSetting";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.cycleDays = _data["cycleDays"];
            this.selectedType = _data["selectedType"];
        }
    }

    static override fromJS(data: any): WeaningListSetting {
        data = typeof data === 'object' ? data : {};
        let result = new WeaningListSetting();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cycleDays"] = this.cycleDays;
        data["selectedType"] = this.selectedType;
        super.toJSON(data);
        return data;
    }
}

export interface IWeaningListSetting extends IWorkListSetting {
    cycleDays: number;
    selectedType: WeaningListTypes;
}

export enum WeaningListTypes {
    Location = "Location",
    PregnancyDays = "PregnancyDays",
}

export class MatingListSetting extends WorkListSetting implements IMatingListSetting {

    constructor(data?: IMatingListSetting) {
        super(data);
        this._discriminator = "MatingListSetting";
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): MatingListSetting {
        data = typeof data === 'object' ? data : {};
        let result = new MatingListSetting();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IMatingListSetting extends IWorkListSetting {
}

export class TasksInFarrowingBase extends WorkListSetting implements ITasksInFarrowingBase {
    nursingDaysFrom!: number;
    nursingDaysTo!: number;
    sowState!: SowState;
    boarPcs!: number;
    farrowingTaskTreatments?: FarrowingTaskTreatment[] | undefined;

    constructor(data?: ITasksInFarrowingBase) {
        super(data);
        this._discriminator = "TasksInFarrowingBase";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.nursingDaysFrom = _data["nursingDaysFrom"];
            this.nursingDaysTo = _data["nursingDaysTo"];
            this.sowState = _data["sowState"];
            this.boarPcs = _data["boarPcs"];
            if (Array.isArray(_data["farrowingTaskTreatments"])) {
                this.farrowingTaskTreatments = [] as any;
                for (let item of _data["farrowingTaskTreatments"])
                    this.farrowingTaskTreatments!.push(FarrowingTaskTreatment.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): TasksInFarrowingBase {
        data = typeof data === 'object' ? data : {};
        if (data["derivedTypeSelector"] === "TasksInFarrowingStableSetting") {
            let result = new TasksInFarrowingStableSetting();
            result.init(data);
            return result;
        }
        if (data["derivedTypeSelector"] === "TasksInFarrowingStableSetting2") {
            let result = new TasksInFarrowingStableSetting2();
            result.init(data);
            return result;
        }
        let result = new TasksInFarrowingBase();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nursingDaysFrom"] = this.nursingDaysFrom;
        data["nursingDaysTo"] = this.nursingDaysTo;
        data["sowState"] = this.sowState;
        data["boarPcs"] = this.boarPcs;
        if (Array.isArray(this.farrowingTaskTreatments)) {
            data["farrowingTaskTreatments"] = [];
            for (let item of this.farrowingTaskTreatments)
                data["farrowingTaskTreatments"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ITasksInFarrowingBase extends IWorkListSetting {
    nursingDaysFrom: number;
    nursingDaysTo: number;
    sowState: SowState;
    boarPcs: number;
    farrowingTaskTreatments?: FarrowingTaskTreatment[] | undefined;
}

export class TasksInFarrowingStableSetting extends TasksInFarrowingBase implements ITasksInFarrowingStableSetting {

    constructor(data?: ITasksInFarrowingStableSetting) {
        super(data);
        this._discriminator = "TasksInFarrowingStableSetting";
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): TasksInFarrowingStableSetting {
        data = typeof data === 'object' ? data : {};
        let result = new TasksInFarrowingStableSetting();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ITasksInFarrowingStableSetting extends ITasksInFarrowingBase {
}

export class FarrowingTaskTreatment implements IFarrowingTaskTreatment {
    subTaskNumber!: number;
    treatmentDefinitionId?: string | undefined;
    columnText?: string | undefined;
    treatAll?: boolean | undefined;

    constructor(data?: IFarrowingTaskTreatment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subTaskNumber = _data["subTaskNumber"];
            this.treatmentDefinitionId = _data["treatmentDefinitionId"];
            this.columnText = _data["columnText"];
            this.treatAll = _data["treatAll"];
        }
    }

    static fromJS(data: any): FarrowingTaskTreatment {
        data = typeof data === 'object' ? data : {};
        let result = new FarrowingTaskTreatment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subTaskNumber"] = this.subTaskNumber;
        data["treatmentDefinitionId"] = this.treatmentDefinitionId;
        data["columnText"] = this.columnText;
        data["treatAll"] = this.treatAll;
        return data;
    }
}

export interface IFarrowingTaskTreatment {
    subTaskNumber: number;
    treatmentDefinitionId?: string | undefined;
    columnText?: string | undefined;
    treatAll?: boolean | undefined;
}

export class TasksInFarrowingStableSetting2 extends TasksInFarrowingBase implements ITasksInFarrowingStableSetting2 {

    constructor(data?: ITasksInFarrowingStableSetting2) {
        super(data);
        this._discriminator = "TasksInFarrowingStableSetting2";
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): TasksInFarrowingStableSetting2 {
        data = typeof data === 'object' ? data : {};
        let result = new TasksInFarrowingStableSetting2();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ITasksInFarrowingStableSetting2 extends ITasksInFarrowingBase {
}

export class ScanningListSettingBase extends WorkListSetting implements IScanningListSettingBase {
    usesLocation!: boolean;
    cycleDaysFrom!: number;
    cycleDaysTo!: number;
    daysAfterMating!: number;

    constructor(data?: IScanningListSettingBase) {
        super(data);
        this._discriminator = "ScanningListSettingBase";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.usesLocation = _data["usesLocation"];
            this.cycleDaysFrom = _data["cycleDaysFrom"];
            this.cycleDaysTo = _data["cycleDaysTo"];
            this.daysAfterMating = _data["daysAfterMating"];
        }
    }

    static override fromJS(data: any): ScanningListSettingBase {
        data = typeof data === 'object' ? data : {};
        if (data["derivedTypeSelector"] === "ScanningListSetting") {
            let result = new ScanningListSetting();
            result.init(data);
            return result;
        }
        if (data["derivedTypeSelector"] === "ScanningListSetting2") {
            let result = new ScanningListSetting2();
            result.init(data);
            return result;
        }
        let result = new ScanningListSettingBase();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["usesLocation"] = this.usesLocation;
        data["cycleDaysFrom"] = this.cycleDaysFrom;
        data["cycleDaysTo"] = this.cycleDaysTo;
        data["daysAfterMating"] = this.daysAfterMating;
        super.toJSON(data);
        return data;
    }
}

export interface IScanningListSettingBase extends IWorkListSetting {
    usesLocation: boolean;
    cycleDaysFrom: number;
    cycleDaysTo: number;
    daysAfterMating: number;
}

export class ScanningListSetting extends ScanningListSettingBase implements IScanningListSetting {

    constructor(data?: IScanningListSetting) {
        super(data);
        this._discriminator = "ScanningListSetting";
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ScanningListSetting {
        data = typeof data === 'object' ? data : {};
        let result = new ScanningListSetting();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IScanningListSetting extends IScanningListSettingBase {
}

export class ScanningListSetting2 extends ScanningListSettingBase implements IScanningListSetting2 {

    constructor(data?: IScanningListSetting2) {
        super(data);
        this._discriminator = "ScanningListSetting2";
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ScanningListSetting2 {
        data = typeof data === 'object' ? data : {};
        let result = new ScanningListSetting2();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IScanningListSetting2 extends IScanningListSettingBase {
}

export class VaccineListSetting extends WorkListSetting implements IVaccineListSetting {
    vaccinePregnancyType!: VaccinePregnancyType;
    vaccineSubTasks?: VaccineSubTask[] | undefined;
    includeLitterTo!: number;
    showLocationOnList!: boolean;

    constructor(data?: IVaccineListSetting) {
        super(data);
        this._discriminator = "VaccineListSetting";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.vaccinePregnancyType = _data["vaccinePregnancyType"];
            if (Array.isArray(_data["vaccineSubTasks"])) {
                this.vaccineSubTasks = [] as any;
                for (let item of _data["vaccineSubTasks"])
                    this.vaccineSubTasks!.push(VaccineSubTask.fromJS(item));
            }
            this.includeLitterTo = _data["includeLitterTo"];
            this.showLocationOnList = _data["showLocationOnList"];
        }
    }

    static override fromJS(data: any): VaccineListSetting {
        data = typeof data === 'object' ? data : {};
        if (data["derivedTypeSelector"] === "VaccineListSetting1") {
            let result = new VaccineListSetting1();
            result.init(data);
            return result;
        }
        if (data["derivedTypeSelector"] === "VaccineListSetting2") {
            let result = new VaccineListSetting2();
            result.init(data);
            return result;
        }
        if (data["derivedTypeSelector"] === "VaccineListSetting3") {
            let result = new VaccineListSetting3();
            result.init(data);
            return result;
        }
        let result = new VaccineListSetting();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vaccinePregnancyType"] = this.vaccinePregnancyType;
        if (Array.isArray(this.vaccineSubTasks)) {
            data["vaccineSubTasks"] = [];
            for (let item of this.vaccineSubTasks)
                data["vaccineSubTasks"].push(item.toJSON());
        }
        data["includeLitterTo"] = this.includeLitterTo;
        data["showLocationOnList"] = this.showLocationOnList;
        super.toJSON(data);
        return data;
    }
}

export interface IVaccineListSetting extends IWorkListSetting {
    vaccinePregnancyType: VaccinePregnancyType;
    vaccineSubTasks?: VaccineSubTask[] | undefined;
    includeLitterTo: number;
    showLocationOnList: boolean;
}

export enum VaccinePregnancyType {
    Mating = "Mating",
    Farrowing = "Farrowing",
    Weaning = "Weaning",
    AgeYoungFemale = "AgeYoungFemale",
}

export class VaccineSubTask implements IVaccineSubTask {
    subTaskNumber!: number;
    vaccineDefinitionId?: string | undefined;
    columnText?: string | undefined;
    afterEventTasks?: AfterEventTask[] | undefined;
    ageYoungFemale!: number;

    constructor(data?: IVaccineSubTask) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subTaskNumber = _data["subTaskNumber"];
            this.vaccineDefinitionId = _data["vaccineDefinitionId"];
            this.columnText = _data["columnText"];
            if (Array.isArray(_data["afterEventTasks"])) {
                this.afterEventTasks = [] as any;
                for (let item of _data["afterEventTasks"])
                    this.afterEventTasks!.push(AfterEventTask.fromJS(item));
            }
            this.ageYoungFemale = _data["ageYoungFemale"];
        }
    }

    static fromJS(data: any): VaccineSubTask {
        data = typeof data === 'object' ? data : {};
        let result = new VaccineSubTask();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subTaskNumber"] = this.subTaskNumber;
        data["vaccineDefinitionId"] = this.vaccineDefinitionId;
        data["columnText"] = this.columnText;
        if (Array.isArray(this.afterEventTasks)) {
            data["afterEventTasks"] = [];
            for (let item of this.afterEventTasks)
                data["afterEventTasks"].push(item.toJSON());
        }
        data["ageYoungFemale"] = this.ageYoungFemale;
        return data;
    }
}

export interface IVaccineSubTask {
    subTaskNumber: number;
    vaccineDefinitionId?: string | undefined;
    columnText?: string | undefined;
    afterEventTasks?: AfterEventTask[] | undefined;
    ageYoungFemale: number;
}

export class AfterEventTask implements IAfterEventTask {
    afterEventNumber!: number;
    days!: number;
    treatSows!: boolean;
    treatGilt!: boolean;

    constructor(data?: IAfterEventTask) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.afterEventNumber = _data["afterEventNumber"];
            this.days = _data["days"];
            this.treatSows = _data["treatSows"];
            this.treatGilt = _data["treatGilt"];
        }
    }

    static fromJS(data: any): AfterEventTask {
        data = typeof data === 'object' ? data : {};
        let result = new AfterEventTask();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["afterEventNumber"] = this.afterEventNumber;
        data["days"] = this.days;
        data["treatSows"] = this.treatSows;
        data["treatGilt"] = this.treatGilt;
        return data;
    }
}

export interface IAfterEventTask {
    afterEventNumber: number;
    days: number;
    treatSows: boolean;
    treatGilt: boolean;
}

export class VaccineListSetting1 extends VaccineListSetting implements IVaccineListSetting1 {

    constructor(data?: IVaccineListSetting1) {
        super(data);
        this._discriminator = "VaccineListSetting1";
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): VaccineListSetting1 {
        data = typeof data === 'object' ? data : {};
        let result = new VaccineListSetting1();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IVaccineListSetting1 extends IVaccineListSetting {
}

export class VaccineListSetting2 extends VaccineListSetting implements IVaccineListSetting2 {

    constructor(data?: IVaccineListSetting2) {
        super(data);
        this._discriminator = "VaccineListSetting2";
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): VaccineListSetting2 {
        data = typeof data === 'object' ? data : {};
        let result = new VaccineListSetting2();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IVaccineListSetting2 extends IVaccineListSetting {
}

export class VaccineListSetting3 extends VaccineListSetting implements IVaccineListSetting3 {

    constructor(data?: IVaccineListSetting3) {
        super(data);
        this._discriminator = "VaccineListSetting3";
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): VaccineListSetting3 {
        data = typeof data === 'object' ? data : {};
        let result = new VaccineListSetting3();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IVaccineListSetting3 extends IVaccineListSetting {
}

export class MoveFromPregToPregSetting extends WorkListSetting implements IMoveFromPregToPregSetting {
    batchCycleDays?: number | undefined;
    selectedType!: MoveToLocationTypes;
    negativeCycleDays!: boolean;
    reader?: ESFReader | undefined;
    defaultFeedCurves?: DefaultFeedCurve[] | undefined;

    constructor(data?: IMoveFromPregToPregSetting) {
        super(data);
        this._discriminator = "MoveFromPregToPregSetting";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.batchCycleDays = _data["batchCycleDays"];
            this.selectedType = _data["selectedType"];
            this.negativeCycleDays = _data["negativeCycleDays"];
            this.reader = _data["reader"];
            if (Array.isArray(_data["defaultFeedCurves"])) {
                this.defaultFeedCurves = [] as any;
                for (let item of _data["defaultFeedCurves"])
                    this.defaultFeedCurves!.push(DefaultFeedCurve.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): MoveFromPregToPregSetting {
        data = typeof data === 'object' ? data : {};
        let result = new MoveFromPregToPregSetting();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchCycleDays"] = this.batchCycleDays;
        data["selectedType"] = this.selectedType;
        data["negativeCycleDays"] = this.negativeCycleDays;
        data["reader"] = this.reader;
        if (Array.isArray(this.defaultFeedCurves)) {
            data["defaultFeedCurves"] = [];
            for (let item of this.defaultFeedCurves)
                data["defaultFeedCurves"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IMoveFromPregToPregSetting extends IWorkListSetting {
    batchCycleDays?: number | undefined;
    selectedType: MoveToLocationTypes;
    negativeCycleDays: boolean;
    reader?: ESFReader | undefined;
    defaultFeedCurves?: DefaultFeedCurve[] | undefined;
}

export class MoveMatingToMatingSetting extends WorkListSetting implements IMoveMatingToMatingSetting {
    batchCycleDays?: number | undefined;
    selectedType!: MoveToLocationTypes;
    negativeCycleDays!: boolean;

    constructor(data?: IMoveMatingToMatingSetting) {
        super(data);
        this._discriminator = "MoveMatingToMatingSetting";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.batchCycleDays = _data["batchCycleDays"];
            this.selectedType = _data["selectedType"];
            this.negativeCycleDays = _data["negativeCycleDays"];
        }
    }

    static override fromJS(data: any): MoveMatingToMatingSetting {
        data = typeof data === 'object' ? data : {};
        let result = new MoveMatingToMatingSetting();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchCycleDays"] = this.batchCycleDays;
        data["selectedType"] = this.selectedType;
        data["negativeCycleDays"] = this.negativeCycleDays;
        super.toJSON(data);
        return data;
    }
}

export interface IMoveMatingToMatingSetting extends IWorkListSetting {
    batchCycleDays?: number | undefined;
    selectedType: MoveToLocationTypes;
    negativeCycleDays: boolean;
}

export class DepartureWorkListSetting extends WorkListSetting implements IDepartureWorkListSetting {

    constructor(data?: IDepartureWorkListSetting) {
        super(data);
        this._discriminator = "DepartureWorkListSetting";
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): DepartureWorkListSetting {
        data = typeof data === 'object' ? data : {};
        let result = new DepartureWorkListSetting();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDepartureWorkListSetting extends IWorkListSetting {
}

export class SowTaskSettings extends WorkListSetting implements ISowTaskSettings {
    sowState!: SowTaskState;
    startIntervalDays!: number;
    endIntervalDays!: number;
    sowWeight!: number;
    giltWeight!: number;
    sowTreatmentTasks?: SowTreatmentTask[] | undefined;

    constructor(data?: ISowTaskSettings) {
        super(data);
        this._discriminator = "SowTaskSettings";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sowState = _data["sowState"];
            this.startIntervalDays = _data["startIntervalDays"];
            this.endIntervalDays = _data["endIntervalDays"];
            this.sowWeight = _data["sowWeight"];
            this.giltWeight = _data["giltWeight"];
            if (Array.isArray(_data["sowTreatmentTasks"])) {
                this.sowTreatmentTasks = [] as any;
                for (let item of _data["sowTreatmentTasks"])
                    this.sowTreatmentTasks!.push(SowTreatmentTask.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): SowTaskSettings {
        data = typeof data === 'object' ? data : {};
        if (data["derivedTypeSelector"] === "SowTaskSettings1") {
            let result = new SowTaskSettings1();
            result.init(data);
            return result;
        }
        if (data["derivedTypeSelector"] === "SowTaskSettings2") {
            let result = new SowTaskSettings2();
            result.init(data);
            return result;
        }
        let result = new SowTaskSettings();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sowState"] = this.sowState;
        data["startIntervalDays"] = this.startIntervalDays;
        data["endIntervalDays"] = this.endIntervalDays;
        data["sowWeight"] = this.sowWeight;
        data["giltWeight"] = this.giltWeight;
        if (Array.isArray(this.sowTreatmentTasks)) {
            data["sowTreatmentTasks"] = [];
            for (let item of this.sowTreatmentTasks)
                data["sowTreatmentTasks"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISowTaskSettings extends IWorkListSetting {
    sowState: SowTaskState;
    startIntervalDays: number;
    endIntervalDays: number;
    sowWeight: number;
    giltWeight: number;
    sowTreatmentTasks?: SowTreatmentTask[] | undefined;
}

export enum SowTaskState {
    MatingPregnant = "MatingPregnant",
    FarrowingNursing = "FarrowingNursing",
    WeaningDry = "WeaningDry",
}

export class SowTreatmentTask implements ISowTreatmentTask {
    subTaskNumber!: number;
    treatmentDefinitionId?: string | undefined;
    columnText?: string | undefined;

    constructor(data?: ISowTreatmentTask) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subTaskNumber = _data["subTaskNumber"];
            this.treatmentDefinitionId = _data["treatmentDefinitionId"];
            this.columnText = _data["columnText"];
        }
    }

    static fromJS(data: any): SowTreatmentTask {
        data = typeof data === 'object' ? data : {};
        let result = new SowTreatmentTask();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subTaskNumber"] = this.subTaskNumber;
        data["treatmentDefinitionId"] = this.treatmentDefinitionId;
        data["columnText"] = this.columnText;
        return data;
    }
}

export interface ISowTreatmentTask {
    subTaskNumber: number;
    treatmentDefinitionId?: string | undefined;
    columnText?: string | undefined;
}

export class SowTaskSettings1 extends SowTaskSettings implements ISowTaskSettings1 {

    constructor(data?: ISowTaskSettings1) {
        super(data);
        this._discriminator = "SowTaskSettings1";
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): SowTaskSettings1 {
        data = typeof data === 'object' ? data : {};
        let result = new SowTaskSettings1();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISowTaskSettings1 extends ISowTaskSettings {
}

export class SowTaskSettings2 extends SowTaskSettings implements ISowTaskSettings2 {

    constructor(data?: ISowTaskSettings2) {
        super(data);
        this._discriminator = "SowTaskSettings2";
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): SowTaskSettings2 {
        data = typeof data === 'object' ? data : {};
        let result = new SowTaskSettings2();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISowTaskSettings2 extends ISowTaskSettings {
}

export class BasicMoveListSetting extends WorkListSetting implements IBasicMoveListSetting {

    constructor(data?: IBasicMoveListSetting) {
        super(data);
        this._discriminator = "BasicMoveListSetting";
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): BasicMoveListSetting {
        data = typeof data === 'object' ? data : {};
        let result = new BasicMoveListSetting();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IBasicMoveListSetting extends IWorkListSetting {
}

export abstract class BaseSingleSyncOfValidationSetup implements IBaseSingleSyncOfValidationSetup {
    syncTime!: Date;

    constructor(data?: IBaseSingleSyncOfValidationSetup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.syncTime = _data["syncTime"] ? new Date(_data["syncTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseSingleSyncOfValidationSetup {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseSingleSyncOfValidationSetup' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["syncTime"] = this.syncTime ? this.syncTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBaseSingleSyncOfValidationSetup {
    syncTime: Date;
}

export class SyncDataValidationSetup extends BaseSingleSyncOfValidationSetup implements ISyncDataValidationSetup {
    data?: ValidationSetup | undefined;

    constructor(data?: ISyncDataValidationSetup) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? ValidationSetup.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): SyncDataValidationSetup {
        data = typeof data === 'object' ? data : {};
        let result = new SyncDataValidationSetup();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ISyncDataValidationSetup extends IBaseSingleSyncOfValidationSetup {
    data?: ValidationSetup | undefined;
}

export class ValidationSetup extends SiteEntity implements IValidationSetup {
    weanedPenId?: string | undefined;
    qrCodeForSows!: boolean;
    qrCodeForLocations!: boolean;
    afterAvertion!: WeaningCode;
    validationIntervals?: ValidationInterval[] | undefined;

    constructor(data?: IValidationSetup) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.weanedPenId = _data["weanedPenId"];
            this.qrCodeForSows = _data["qrCodeForSows"];
            this.qrCodeForLocations = _data["qrCodeForLocations"];
            this.afterAvertion = _data["afterAvertion"];
            if (Array.isArray(_data["validationIntervals"])) {
                this.validationIntervals = [] as any;
                for (let item of _data["validationIntervals"])
                    this.validationIntervals!.push(ValidationInterval.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ValidationSetup {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationSetup();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weanedPenId"] = this.weanedPenId;
        data["qrCodeForSows"] = this.qrCodeForSows;
        data["qrCodeForLocations"] = this.qrCodeForLocations;
        data["afterAvertion"] = this.afterAvertion;
        if (Array.isArray(this.validationIntervals)) {
            data["validationIntervals"] = [];
            for (let item of this.validationIntervals)
                data["validationIntervals"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IValidationSetup extends ISiteEntity {
    weanedPenId?: string | undefined;
    qrCodeForSows: boolean;
    qrCodeForLocations: boolean;
    afterAvertion: WeaningCode;
    validationIntervals?: ValidationInterval[] | undefined;
}

export class ValidationInterval implements IValidationInterval {
    plan!: number;
    plus!: number;
    minus!: number;
    type!: PregnancyValidationType;

    constructor(data?: IValidationInterval) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plan = _data["plan"];
            this.plus = _data["plus"];
            this.minus = _data["minus"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): ValidationInterval {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationInterval();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plan"] = this.plan;
        data["plus"] = this.plus;
        data["minus"] = this.minus;
        data["type"] = this.type;
        return data;
    }
}

export interface IValidationInterval {
    plan: number;
    plus: number;
    minus: number;
    type: PregnancyValidationType;
}

export enum PregnancyValidationType {
    MatingAge = "MatingAge",
    AvertedToMating = "AvertedToMating",
    MatingToFarrowing = "MatingToFarrowing",
    FarrowingToAverted = "FarrowingToAverted",
}

export abstract class BaseSyncOfTreatment implements IBaseSyncOfTreatment {
    syncTime!: Date;

    protected _discriminator: string;

    constructor(data?: IBaseSyncOfTreatment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "BaseSyncOfTreatment";
    }

    init(_data?: any) {
        if (_data) {
            this.syncTime = _data["syncTime"] ? new Date(_data["syncTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseSyncOfTreatment {
        data = typeof data === 'object' ? data : {};
        if (data["_discriminator"] === "SyncDataTreatment") {
            let result = new SyncDataTreatment();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'BaseSyncOfTreatment' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_discriminator"] = this._discriminator;
        data["syncTime"] = this.syncTime ? this.syncTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBaseSyncOfTreatment {
    syncTime: Date;
}

export class SyncDataTreatment extends BaseSyncOfTreatment implements ISyncDataTreatment {
    datas?: Treatment[] | undefined;

    constructor(data?: ISyncDataTreatment) {
        super(data);
        this._discriminator = "SyncDataTreatment";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["datas"])) {
                this.datas = [] as any;
                for (let item of _data["datas"])
                    this.datas!.push(Treatment.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): SyncDataTreatment {
        data = typeof data === 'object' ? data : {};
        let result = new SyncDataTreatment();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.datas)) {
            data["datas"] = [];
            for (let item of this.datas)
                data["datas"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISyncDataTreatment extends IBaseSyncOfTreatment {
    datas?: Treatment[] | undefined;
}

export abstract class BaseSyncOfTreatmentPlan implements IBaseSyncOfTreatmentPlan {
    syncTime!: Date;

    protected _discriminator: string;

    constructor(data?: IBaseSyncOfTreatmentPlan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "BaseSyncOfTreatmentPlan";
    }

    init(_data?: any) {
        if (_data) {
            this.syncTime = _data["syncTime"] ? new Date(_data["syncTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseSyncOfTreatmentPlan {
        data = typeof data === 'object' ? data : {};
        if (data["_discriminator"] === "SyncDataTreatmentPlan") {
            let result = new SyncDataTreatmentPlan();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'BaseSyncOfTreatmentPlan' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_discriminator"] = this._discriminator;
        data["syncTime"] = this.syncTime ? this.syncTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBaseSyncOfTreatmentPlan {
    syncTime: Date;
}

export class SyncDataTreatmentPlan extends BaseSyncOfTreatmentPlan implements ISyncDataTreatmentPlan {
    datas?: TreatmentPlan[] | undefined;

    constructor(data?: ISyncDataTreatmentPlan) {
        super(data);
        this._discriminator = "SyncDataTreatmentPlan";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["datas"])) {
                this.datas = [] as any;
                for (let item of _data["datas"])
                    this.datas!.push(TreatmentPlan.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): SyncDataTreatmentPlan {
        data = typeof data === 'object' ? data : {};
        let result = new SyncDataTreatmentPlan();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.datas)) {
            data["datas"] = [];
            for (let item of this.datas)
                data["datas"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISyncDataTreatmentPlan extends IBaseSyncOfTreatmentPlan {
    datas?: TreatmentPlan[] | undefined;
}

export abstract class BaseSyncOfTreatmentDefinition implements IBaseSyncOfTreatmentDefinition {
    syncTime!: Date;

    protected _discriminator: string;

    constructor(data?: IBaseSyncOfTreatmentDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "BaseSyncOfTreatmentDefinition";
    }

    init(_data?: any) {
        if (_data) {
            this.syncTime = _data["syncTime"] ? new Date(_data["syncTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseSyncOfTreatmentDefinition {
        data = typeof data === 'object' ? data : {};
        if (data["_discriminator"] === "SyncDataTreatmentDefinition") {
            let result = new SyncDataTreatmentDefinition();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'BaseSyncOfTreatmentDefinition' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_discriminator"] = this._discriminator;
        data["syncTime"] = this.syncTime ? this.syncTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBaseSyncOfTreatmentDefinition {
    syncTime: Date;
}

export class SyncDataTreatmentDefinition extends BaseSyncOfTreatmentDefinition implements ISyncDataTreatmentDefinition {
    datas?: TreatmentDefinition[] | undefined;

    constructor(data?: ISyncDataTreatmentDefinition) {
        super(data);
        this._discriminator = "SyncDataTreatmentDefinition";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["datas"])) {
                this.datas = [] as any;
                for (let item of _data["datas"])
                    this.datas!.push(TreatmentDefinition.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): SyncDataTreatmentDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new SyncDataTreatmentDefinition();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.datas)) {
            data["datas"] = [];
            for (let item of this.datas)
                data["datas"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISyncDataTreatmentDefinition extends IBaseSyncOfTreatmentDefinition {
    datas?: TreatmentDefinition[] | undefined;
}

export class TreatmentDefinition extends SiteEntity implements ITreatmentDefinition {
    diagnoseId?: string | undefined;
    isActive!: boolean;
    isArchived!: boolean;
    frequency!: TreatmentFrequency;
    frequencyDays?: number | undefined;
    numberOfTreatments!: number;
    subTreatments?: SubTreatment[] | undefined;
    marking?: string | undefined;
    animalKinds?: AnimalKind[] | undefined;
    canBeATreatment!: boolean;

    constructor(data?: ITreatmentDefinition) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.diagnoseId = _data["diagnoseId"];
            this.isActive = _data["isActive"];
            this.isArchived = _data["isArchived"];
            this.frequency = _data["frequency"];
            this.frequencyDays = _data["frequencyDays"];
            this.numberOfTreatments = _data["numberOfTreatments"];
            if (Array.isArray(_data["subTreatments"])) {
                this.subTreatments = [] as any;
                for (let item of _data["subTreatments"])
                    this.subTreatments!.push(SubTreatment.fromJS(item));
            }
            this.marking = _data["marking"];
            if (Array.isArray(_data["animalKinds"])) {
                this.animalKinds = [] as any;
                for (let item of _data["animalKinds"])
                    this.animalKinds!.push(item);
            }
            this.canBeATreatment = _data["canBeATreatment"];
        }
    }

    static override fromJS(data: any): TreatmentDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentDefinition();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diagnoseId"] = this.diagnoseId;
        data["isActive"] = this.isActive;
        data["isArchived"] = this.isArchived;
        data["frequency"] = this.frequency;
        data["frequencyDays"] = this.frequencyDays;
        data["numberOfTreatments"] = this.numberOfTreatments;
        if (Array.isArray(this.subTreatments)) {
            data["subTreatments"] = [];
            for (let item of this.subTreatments)
                data["subTreatments"].push(item.toJSON());
        }
        data["marking"] = this.marking;
        if (Array.isArray(this.animalKinds)) {
            data["animalKinds"] = [];
            for (let item of this.animalKinds)
                data["animalKinds"].push(item);
        }
        data["canBeATreatment"] = this.canBeATreatment;
        super.toJSON(data);
        return data;
    }
}

export interface ITreatmentDefinition extends ISiteEntity {
    diagnoseId?: string | undefined;
    isActive: boolean;
    isArchived: boolean;
    frequency: TreatmentFrequency;
    frequencyDays?: number | undefined;
    numberOfTreatments: number;
    subTreatments?: SubTreatment[] | undefined;
    marking?: string | undefined;
    animalKinds?: AnimalKind[] | undefined;
    canBeATreatment: boolean;
}

export enum TreatmentFrequency {
    Once = "Once",
    EveryDay = "EveryDay",
    EveryOtherDay = "EveryOtherDay",
    EveryWeek = "EveryWeek",
}

export class SubTreatment implements ISubTreatment {
    id?: string | undefined;
    drugTypeId?: string | undefined;
    drugAmount?: DrugAmount | undefined;
    treatmentType!: TreatmentType;
    butcherQuarantine!: number;

    constructor(data?: ISubTreatment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.drugTypeId = _data["drugTypeId"];
            this.drugAmount = _data["drugAmount"] ? DrugAmount.fromJS(_data["drugAmount"]) : <any>undefined;
            this.treatmentType = _data["treatmentType"];
            this.butcherQuarantine = _data["butcherQuarantine"];
        }
    }

    static fromJS(data: any): SubTreatment {
        data = typeof data === 'object' ? data : {};
        let result = new SubTreatment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["drugTypeId"] = this.drugTypeId;
        data["drugAmount"] = this.drugAmount ? this.drugAmount.toJSON() : <any>undefined;
        data["treatmentType"] = this.treatmentType;
        data["butcherQuarantine"] = this.butcherQuarantine;
        return data;
    }
}

export interface ISubTreatment {
    id?: string | undefined;
    drugTypeId?: string | undefined;
    drugAmount?: DrugAmount | undefined;
    treatmentType: TreatmentType;
    butcherQuarantine: number;
}

export class DrugAmount implements IDrugAmount {
    amount!: number;
    perUnit!: number;
    unitType!: TreatmentUnit;

    constructor(data?: IDrugAmount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.perUnit = _data["perUnit"];
            this.unitType = _data["unitType"];
        }
    }

    static fromJS(data: any): DrugAmount {
        data = typeof data === 'object' ? data : {};
        let result = new DrugAmount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["perUnit"] = this.perUnit;
        data["unitType"] = this.unitType;
        return data;
    }
}

export interface IDrugAmount {
    amount: number;
    perUnit: number;
    unitType: TreatmentUnit;
}

export enum TreatmentUnit {
    PerKgPig = "PerKgPig",
    PerKgFood = "PerKgFood",
    PerAnimal = "PerAnimal",
}

export enum TreatmentType {
    Food = "Food",
    Water = "Water",
    Oral = "Oral",
    Injection = "Injection",
    OnTheSkin = "OnTheSkin",
}

export abstract class BaseSyncOfValveGroup implements IBaseSyncOfValveGroup {
    syncTime!: Date;

    protected _discriminator: string;

    constructor(data?: IBaseSyncOfValveGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "BaseSyncOfValveGroup";
    }

    init(_data?: any) {
        if (_data) {
            this.syncTime = _data["syncTime"] ? new Date(_data["syncTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseSyncOfValveGroup {
        data = typeof data === 'object' ? data : {};
        if (data["_discriminator"] === "SyncDataValveGroup") {
            let result = new SyncDataValveGroup();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'BaseSyncOfValveGroup' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_discriminator"] = this._discriminator;
        data["syncTime"] = this.syncTime ? this.syncTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBaseSyncOfValveGroup {
    syncTime: Date;
}

export class SyncDataValveGroup extends BaseSyncOfValveGroup implements ISyncDataValveGroup {
    datas?: ValveGroup[] | undefined;

    constructor(data?: ISyncDataValveGroup) {
        super(data);
        this._discriminator = "SyncDataValveGroup";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["datas"])) {
                this.datas = [] as any;
                for (let item of _data["datas"])
                    this.datas!.push(ValveGroup.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): SyncDataValveGroup {
        data = typeof data === 'object' ? data : {};
        let result = new SyncDataValveGroup();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.datas)) {
            data["datas"] = [];
            for (let item of this.datas)
                data["datas"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISyncDataValveGroup extends IBaseSyncOfValveGroup {
    datas?: ValveGroup[] | undefined;
}

export class ValveGroup implements IValveGroup {
    id?: string | undefined;
    isDeleted!: boolean;
    siteId?: string | undefined;
    buildingId?: string | undefined;
    zoneId?: string | undefined;
    locationString?: string | undefined;
    penStrings?: string[] | undefined;
    valveStrings?: string[] | undefined;
    penIds?: string[] | undefined;
    constantDeviation?: number | undefined;
    deviation?: number | undefined;
    deviationDays?: number | undefined;
    sowCount?: number | undefined;
    pigCount?: number | undefined;
    pigletCount?: number | undefined;
    feedUnitsPerDay!: number;
    feedingCurve?: number | undefined;
    availableFeedingCurves?: FeedCurve[] | undefined;
    sowCycle?: SowCycleType | undefined;
    weight?: number | undefined;
    type!: LocationType;
    penDays?: number | undefined;
    animalType?: AnimalType | undefined;
    sectionId?: string | undefined;
    order!: number;
    penOrder!: number;
    modifiedOn?: Date | undefined;
    lastSync?: Date | undefined;
    recipeName?: string | undefined;
    recipeNumber?: number | undefined;
    recipePercentage?: number | undefined;
    eatTime!: boolean;

    constructor(data?: IValveGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.siteId = _data["siteId"];
            this.buildingId = _data["buildingId"];
            this.zoneId = _data["zoneId"];
            this.locationString = _data["locationString"];
            if (Array.isArray(_data["penStrings"])) {
                this.penStrings = [] as any;
                for (let item of _data["penStrings"])
                    this.penStrings!.push(item);
            }
            if (Array.isArray(_data["valveStrings"])) {
                this.valveStrings = [] as any;
                for (let item of _data["valveStrings"])
                    this.valveStrings!.push(item);
            }
            if (Array.isArray(_data["penIds"])) {
                this.penIds = [] as any;
                for (let item of _data["penIds"])
                    this.penIds!.push(item);
            }
            this.constantDeviation = _data["constantDeviation"];
            this.deviation = _data["deviation"];
            this.deviationDays = _data["deviationDays"];
            this.sowCount = _data["sowCount"];
            this.pigCount = _data["pigCount"];
            this.pigletCount = _data["pigletCount"];
            this.feedUnitsPerDay = _data["feedUnitsPerDay"];
            this.feedingCurve = _data["feedingCurve"];
            if (Array.isArray(_data["availableFeedingCurves"])) {
                this.availableFeedingCurves = [] as any;
                for (let item of _data["availableFeedingCurves"])
                    this.availableFeedingCurves!.push(FeedCurve.fromJS(item));
            }
            this.sowCycle = _data["sowCycle"];
            this.weight = _data["weight"];
            this.type = _data["type"];
            this.penDays = _data["penDays"];
            this.animalType = _data["animalType"];
            this.sectionId = _data["sectionId"];
            this.order = _data["order"];
            this.penOrder = _data["penOrder"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.lastSync = _data["lastSync"] ? new Date(_data["lastSync"].toString()) : <any>undefined;
            this.recipeName = _data["recipeName"];
            this.recipeNumber = _data["recipeNumber"];
            this.recipePercentage = _data["recipePercentage"];
            this.eatTime = _data["eatTime"];
        }
    }

    static fromJS(data: any): ValveGroup {
        data = typeof data === 'object' ? data : {};
        let result = new ValveGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["siteId"] = this.siteId;
        data["buildingId"] = this.buildingId;
        data["zoneId"] = this.zoneId;
        data["locationString"] = this.locationString;
        if (Array.isArray(this.penStrings)) {
            data["penStrings"] = [];
            for (let item of this.penStrings)
                data["penStrings"].push(item);
        }
        if (Array.isArray(this.valveStrings)) {
            data["valveStrings"] = [];
            for (let item of this.valveStrings)
                data["valveStrings"].push(item);
        }
        if (Array.isArray(this.penIds)) {
            data["penIds"] = [];
            for (let item of this.penIds)
                data["penIds"].push(item);
        }
        data["constantDeviation"] = this.constantDeviation;
        data["deviation"] = this.deviation;
        data["deviationDays"] = this.deviationDays;
        data["sowCount"] = this.sowCount;
        data["pigCount"] = this.pigCount;
        data["pigletCount"] = this.pigletCount;
        data["feedUnitsPerDay"] = this.feedUnitsPerDay;
        data["feedingCurve"] = this.feedingCurve;
        if (Array.isArray(this.availableFeedingCurves)) {
            data["availableFeedingCurves"] = [];
            for (let item of this.availableFeedingCurves)
                data["availableFeedingCurves"].push(item.toJSON());
        }
        data["sowCycle"] = this.sowCycle;
        data["weight"] = this.weight;
        data["type"] = this.type;
        data["penDays"] = this.penDays;
        data["animalType"] = this.animalType;
        data["sectionId"] = this.sectionId;
        data["order"] = this.order;
        data["penOrder"] = this.penOrder;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["lastSync"] = this.lastSync ? this.lastSync.toISOString() : <any>undefined;
        data["recipeName"] = this.recipeName;
        data["recipeNumber"] = this.recipeNumber;
        data["recipePercentage"] = this.recipePercentage;
        data["eatTime"] = this.eatTime;
        return data;
    }
}

export interface IValveGroup {
    id?: string | undefined;
    isDeleted: boolean;
    siteId?: string | undefined;
    buildingId?: string | undefined;
    zoneId?: string | undefined;
    locationString?: string | undefined;
    penStrings?: string[] | undefined;
    valveStrings?: string[] | undefined;
    penIds?: string[] | undefined;
    constantDeviation?: number | undefined;
    deviation?: number | undefined;
    deviationDays?: number | undefined;
    sowCount?: number | undefined;
    pigCount?: number | undefined;
    pigletCount?: number | undefined;
    feedUnitsPerDay: number;
    feedingCurve?: number | undefined;
    availableFeedingCurves?: FeedCurve[] | undefined;
    sowCycle?: SowCycleType | undefined;
    weight?: number | undefined;
    type: LocationType;
    penDays?: number | undefined;
    animalType?: AnimalType | undefined;
    sectionId?: string | undefined;
    order: number;
    penOrder: number;
    modifiedOn?: Date | undefined;
    lastSync?: Date | undefined;
    recipeName?: string | undefined;
    recipeNumber?: number | undefined;
    recipePercentage?: number | undefined;
    eatTime: boolean;
}

export abstract class BaseSyncOfWorkListToTreatmentPlan implements IBaseSyncOfWorkListToTreatmentPlan {
    syncTime!: Date;

    protected _discriminator: string;

    constructor(data?: IBaseSyncOfWorkListToTreatmentPlan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "BaseSyncOfWorkListToTreatmentPlan";
    }

    init(_data?: any) {
        if (_data) {
            this.syncTime = _data["syncTime"] ? new Date(_data["syncTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseSyncOfWorkListToTreatmentPlan {
        data = typeof data === 'object' ? data : {};
        if (data["_discriminator"] === "SyncDataWorkListToTreatmentPlan") {
            let result = new SyncDataWorkListToTreatmentPlan();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'BaseSyncOfWorkListToTreatmentPlan' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_discriminator"] = this._discriminator;
        data["syncTime"] = this.syncTime ? this.syncTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBaseSyncOfWorkListToTreatmentPlan {
    syncTime: Date;
}

export class SyncDataWorkListToTreatmentPlan extends BaseSyncOfWorkListToTreatmentPlan implements ISyncDataWorkListToTreatmentPlan {
    datas?: WorkListToTreatmentPlan[] | undefined;

    constructor(data?: ISyncDataWorkListToTreatmentPlan) {
        super(data);
        this._discriminator = "SyncDataWorkListToTreatmentPlan";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["datas"])) {
                this.datas = [] as any;
                for (let item of _data["datas"])
                    this.datas!.push(WorkListToTreatmentPlan.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): SyncDataWorkListToTreatmentPlan {
        data = typeof data === 'object' ? data : {};
        let result = new SyncDataWorkListToTreatmentPlan();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.datas)) {
            data["datas"] = [];
            for (let item of this.datas)
                data["datas"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISyncDataWorkListToTreatmentPlan extends IBaseSyncOfWorkListToTreatmentPlan {
    datas?: WorkListToTreatmentPlan[] | undefined;
}

export class WorkListToTreatmentPlan extends SiteEntity implements IWorkListToTreatmentPlan {
    treatmentPlanId?: string | undefined;
    workListSettingId?: string | undefined;
    subTaskIdentifier?: string | undefined;
    diagnoseIdentifier?: string | undefined;

    constructor(data?: IWorkListToTreatmentPlan) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.treatmentPlanId = _data["treatmentPlanId"];
            this.workListSettingId = _data["workListSettingId"];
            this.subTaskIdentifier = _data["subTaskIdentifier"];
            this.diagnoseIdentifier = _data["diagnoseIdentifier"];
        }
    }

    static override fromJS(data: any): WorkListToTreatmentPlan {
        data = typeof data === 'object' ? data : {};
        let result = new WorkListToTreatmentPlan();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["treatmentPlanId"] = this.treatmentPlanId;
        data["workListSettingId"] = this.workListSettingId;
        data["subTaskIdentifier"] = this.subTaskIdentifier;
        data["diagnoseIdentifier"] = this.diagnoseIdentifier;
        super.toJSON(data);
        return data;
    }
}

export interface IWorkListToTreatmentPlan extends ISiteEntity {
    treatmentPlanId?: string | undefined;
    workListSettingId?: string | undefined;
    subTaskIdentifier?: string | undefined;
    diagnoseIdentifier?: string | undefined;
}

export abstract class BaseSyncOfNucleusManagementBreedingSettings implements IBaseSyncOfNucleusManagementBreedingSettings {
    syncTime!: Date;

    protected _discriminator: string;

    constructor(data?: IBaseSyncOfNucleusManagementBreedingSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "BaseSyncOfNucleusManagementBreedingSettings";
    }

    init(_data?: any) {
        if (_data) {
            this.syncTime = _data["syncTime"] ? new Date(_data["syncTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseSyncOfNucleusManagementBreedingSettings {
        data = typeof data === 'object' ? data : {};
        if (data["_discriminator"] === "SyncDataNucleusManagementBreedingSettings") {
            let result = new SyncDataNucleusManagementBreedingSettings();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'BaseSyncOfNucleusManagementBreedingSettings' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_discriminator"] = this._discriminator;
        data["syncTime"] = this.syncTime ? this.syncTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBaseSyncOfNucleusManagementBreedingSettings {
    syncTime: Date;
}

export class SyncDataNucleusManagementBreedingSettings extends BaseSyncOfNucleusManagementBreedingSettings implements ISyncDataNucleusManagementBreedingSettings {
    datas?: NucleusManagementBreedingSettings[] | undefined;

    constructor(data?: ISyncDataNucleusManagementBreedingSettings) {
        super(data);
        this._discriminator = "SyncDataNucleusManagementBreedingSettings";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["datas"])) {
                this.datas = [] as any;
                for (let item of _data["datas"])
                    this.datas!.push(NucleusManagementBreedingSettings.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): SyncDataNucleusManagementBreedingSettings {
        data = typeof data === 'object' ? data : {};
        let result = new SyncDataNucleusManagementBreedingSettings();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.datas)) {
            data["datas"] = [];
            for (let item of this.datas)
                data["datas"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISyncDataNucleusManagementBreedingSettings extends IBaseSyncOfNucleusManagementBreedingSettings {
    datas?: NucleusManagementBreedingSettings[] | undefined;
}

export class NucleusManagementBreedingSettings extends SiteEntity implements INucleusManagementBreedingSettings {
    breedingNumber?: string | undefined;
    numberBatches?: NumberBatch[] | undefined;

    constructor(data?: INucleusManagementBreedingSettings) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.breedingNumber = _data["breedingNumber"];
            if (Array.isArray(_data["numberBatches"])) {
                this.numberBatches = [] as any;
                for (let item of _data["numberBatches"])
                    this.numberBatches!.push(NumberBatch.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): NucleusManagementBreedingSettings {
        data = typeof data === 'object' ? data : {};
        let result = new NucleusManagementBreedingSettings();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["breedingNumber"] = this.breedingNumber;
        if (Array.isArray(this.numberBatches)) {
            data["numberBatches"] = [];
            for (let item of this.numberBatches)
                data["numberBatches"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface INucleusManagementBreedingSettings extends ISiteEntity {
    breedingNumber?: string | undefined;
    numberBatches?: NumberBatch[] | undefined;
}

export class NumberBatch implements INumberBatch {
    id?: string | undefined;
    race?: string | undefined;
    sowAssignable!: boolean;
    boarAssignable!: boolean;
    purchaseNumber?: string | undefined;
    startMatingNumber?: string | undefined;
    nextMatingNumber?: string | undefined;
    endMatingNumber?: string | undefined;
    priority?: number | undefined;

    constructor(data?: INumberBatch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.race = _data["race"];
            this.sowAssignable = _data["sowAssignable"];
            this.boarAssignable = _data["boarAssignable"];
            this.purchaseNumber = _data["purchaseNumber"];
            this.startMatingNumber = _data["startMatingNumber"];
            this.nextMatingNumber = _data["nextMatingNumber"];
            this.endMatingNumber = _data["endMatingNumber"];
            this.priority = _data["priority"];
        }
    }

    static fromJS(data: any): NumberBatch {
        data = typeof data === 'object' ? data : {};
        let result = new NumberBatch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["race"] = this.race;
        data["sowAssignable"] = this.sowAssignable;
        data["boarAssignable"] = this.boarAssignable;
        data["purchaseNumber"] = this.purchaseNumber;
        data["startMatingNumber"] = this.startMatingNumber;
        data["nextMatingNumber"] = this.nextMatingNumber;
        data["endMatingNumber"] = this.endMatingNumber;
        data["priority"] = this.priority;
        return data;
    }
}

export interface INumberBatch {
    id?: string | undefined;
    race?: string | undefined;
    sowAssignable: boolean;
    boarAssignable: boolean;
    purchaseNumber?: string | undefined;
    startMatingNumber?: string | undefined;
    nextMatingNumber?: string | undefined;
    endMatingNumber?: string | undefined;
    priority?: number | undefined;
}

export class SyncParams implements ISyncParams {
    siteId?: string | undefined;
    dateYesterday!: Date;
    stemAnimals!: Date;
    growthPigEvents!: Date;
    pregnancies!: Date;
    generalSettings!: Date;
    lardScanningEvents!: Date;
    workListSettings!: Date;
    drugTypes!: Date;
    markings!: Date;
    diagnoseCategories!: Date;
    diagnoses!: Date;
    reasons!: Date;
    validationSetup!: Date;
    treatments!: Date;
    stations!: Date;
    unitToPens!: Date;
    esfFeedCurves!: Date;
    esfFeedingStatus!: Date;
    treatmentPlans!: Date;
    treatmentDefinitions!: Date;
    matingBatches!: Date;
    moveEvents!: Date;
    matingBatchSettings!: Date;
    locations!: Date;
    valveGroups!: Date;
    workListToTreatmentPlans!: Date;
    processEquipments!: Date;
    processEquipmentData!: Date;
    esfDailyStatus!: Date;
    deadPigletsEvents!: Date;
    poolYoungFemales!: Date;
    distriwinOption!: Date;
    nucleusBreedSettings!: Date;
    breedTableItems!: Date;

    constructor(data?: ISyncParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.siteId = _data["siteId"];
            this.dateYesterday = _data["dateYesterday"] ? new Date(_data["dateYesterday"].toString()) : <any>undefined;
            this.stemAnimals = _data["stemAnimals"] ? new Date(_data["stemAnimals"].toString()) : <any>undefined;
            this.growthPigEvents = _data["growthPigEvents"] ? new Date(_data["growthPigEvents"].toString()) : <any>undefined;
            this.pregnancies = _data["pregnancies"] ? new Date(_data["pregnancies"].toString()) : <any>undefined;
            this.generalSettings = _data["generalSettings"] ? new Date(_data["generalSettings"].toString()) : <any>undefined;
            this.lardScanningEvents = _data["lardScanningEvents"] ? new Date(_data["lardScanningEvents"].toString()) : <any>undefined;
            this.workListSettings = _data["workListSettings"] ? new Date(_data["workListSettings"].toString()) : <any>undefined;
            this.drugTypes = _data["drugTypes"] ? new Date(_data["drugTypes"].toString()) : <any>undefined;
            this.markings = _data["markings"] ? new Date(_data["markings"].toString()) : <any>undefined;
            this.diagnoseCategories = _data["diagnoseCategories"] ? new Date(_data["diagnoseCategories"].toString()) : <any>undefined;
            this.diagnoses = _data["diagnoses"] ? new Date(_data["diagnoses"].toString()) : <any>undefined;
            this.reasons = _data["reasons"] ? new Date(_data["reasons"].toString()) : <any>undefined;
            this.validationSetup = _data["validationSetup"] ? new Date(_data["validationSetup"].toString()) : <any>undefined;
            this.treatments = _data["treatments"] ? new Date(_data["treatments"].toString()) : <any>undefined;
            this.stations = _data["stations"] ? new Date(_data["stations"].toString()) : <any>undefined;
            this.unitToPens = _data["unitToPens"] ? new Date(_data["unitToPens"].toString()) : <any>undefined;
            this.esfFeedCurves = _data["esfFeedCurves"] ? new Date(_data["esfFeedCurves"].toString()) : <any>undefined;
            this.esfFeedingStatus = _data["esfFeedingStatus"] ? new Date(_data["esfFeedingStatus"].toString()) : <any>undefined;
            this.treatmentPlans = _data["treatmentPlans"] ? new Date(_data["treatmentPlans"].toString()) : <any>undefined;
            this.treatmentDefinitions = _data["treatmentDefinitions"] ? new Date(_data["treatmentDefinitions"].toString()) : <any>undefined;
            this.matingBatches = _data["matingBatches"] ? new Date(_data["matingBatches"].toString()) : <any>undefined;
            this.moveEvents = _data["moveEvents"] ? new Date(_data["moveEvents"].toString()) : <any>undefined;
            this.matingBatchSettings = _data["matingBatchSettings"] ? new Date(_data["matingBatchSettings"].toString()) : <any>undefined;
            this.locations = _data["locations"] ? new Date(_data["locations"].toString()) : <any>undefined;
            this.valveGroups = _data["valveGroups"] ? new Date(_data["valveGroups"].toString()) : <any>undefined;
            this.workListToTreatmentPlans = _data["workListToTreatmentPlans"] ? new Date(_data["workListToTreatmentPlans"].toString()) : <any>undefined;
            this.processEquipments = _data["processEquipments"] ? new Date(_data["processEquipments"].toString()) : <any>undefined;
            this.processEquipmentData = _data["processEquipmentData"] ? new Date(_data["processEquipmentData"].toString()) : <any>undefined;
            this.esfDailyStatus = _data["esfDailyStatus"] ? new Date(_data["esfDailyStatus"].toString()) : <any>undefined;
            this.deadPigletsEvents = _data["deadPigletsEvents"] ? new Date(_data["deadPigletsEvents"].toString()) : <any>undefined;
            this.poolYoungFemales = _data["poolYoungFemales"] ? new Date(_data["poolYoungFemales"].toString()) : <any>undefined;
            this.distriwinOption = _data["distriwinOption"] ? new Date(_data["distriwinOption"].toString()) : <any>undefined;
            this.nucleusBreedSettings = _data["nucleusBreedSettings"] ? new Date(_data["nucleusBreedSettings"].toString()) : <any>undefined;
            this.breedTableItems = _data["breedTableItems"] ? new Date(_data["breedTableItems"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SyncParams {
        data = typeof data === 'object' ? data : {};
        let result = new SyncParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siteId"] = this.siteId;
        data["dateYesterday"] = this.dateYesterday ? this.dateYesterday.toISOString() : <any>undefined;
        data["stemAnimals"] = this.stemAnimals ? this.stemAnimals.toISOString() : <any>undefined;
        data["growthPigEvents"] = this.growthPigEvents ? this.growthPigEvents.toISOString() : <any>undefined;
        data["pregnancies"] = this.pregnancies ? this.pregnancies.toISOString() : <any>undefined;
        data["generalSettings"] = this.generalSettings ? this.generalSettings.toISOString() : <any>undefined;
        data["lardScanningEvents"] = this.lardScanningEvents ? this.lardScanningEvents.toISOString() : <any>undefined;
        data["workListSettings"] = this.workListSettings ? this.workListSettings.toISOString() : <any>undefined;
        data["drugTypes"] = this.drugTypes ? this.drugTypes.toISOString() : <any>undefined;
        data["markings"] = this.markings ? this.markings.toISOString() : <any>undefined;
        data["diagnoseCategories"] = this.diagnoseCategories ? this.diagnoseCategories.toISOString() : <any>undefined;
        data["diagnoses"] = this.diagnoses ? this.diagnoses.toISOString() : <any>undefined;
        data["reasons"] = this.reasons ? this.reasons.toISOString() : <any>undefined;
        data["validationSetup"] = this.validationSetup ? this.validationSetup.toISOString() : <any>undefined;
        data["treatments"] = this.treatments ? this.treatments.toISOString() : <any>undefined;
        data["stations"] = this.stations ? this.stations.toISOString() : <any>undefined;
        data["unitToPens"] = this.unitToPens ? this.unitToPens.toISOString() : <any>undefined;
        data["esfFeedCurves"] = this.esfFeedCurves ? this.esfFeedCurves.toISOString() : <any>undefined;
        data["esfFeedingStatus"] = this.esfFeedingStatus ? this.esfFeedingStatus.toISOString() : <any>undefined;
        data["treatmentPlans"] = this.treatmentPlans ? this.treatmentPlans.toISOString() : <any>undefined;
        data["treatmentDefinitions"] = this.treatmentDefinitions ? this.treatmentDefinitions.toISOString() : <any>undefined;
        data["matingBatches"] = this.matingBatches ? this.matingBatches.toISOString() : <any>undefined;
        data["moveEvents"] = this.moveEvents ? this.moveEvents.toISOString() : <any>undefined;
        data["matingBatchSettings"] = this.matingBatchSettings ? this.matingBatchSettings.toISOString() : <any>undefined;
        data["locations"] = this.locations ? this.locations.toISOString() : <any>undefined;
        data["valveGroups"] = this.valveGroups ? this.valveGroups.toISOString() : <any>undefined;
        data["workListToTreatmentPlans"] = this.workListToTreatmentPlans ? this.workListToTreatmentPlans.toISOString() : <any>undefined;
        data["processEquipments"] = this.processEquipments ? this.processEquipments.toISOString() : <any>undefined;
        data["processEquipmentData"] = this.processEquipmentData ? this.processEquipmentData.toISOString() : <any>undefined;
        data["esfDailyStatus"] = this.esfDailyStatus ? this.esfDailyStatus.toISOString() : <any>undefined;
        data["deadPigletsEvents"] = this.deadPigletsEvents ? this.deadPigletsEvents.toISOString() : <any>undefined;
        data["poolYoungFemales"] = this.poolYoungFemales ? this.poolYoungFemales.toISOString() : <any>undefined;
        data["distriwinOption"] = this.distriwinOption ? this.distriwinOption.toISOString() : <any>undefined;
        data["nucleusBreedSettings"] = this.nucleusBreedSettings ? this.nucleusBreedSettings.toISOString() : <any>undefined;
        data["breedTableItems"] = this.breedTableItems ? this.breedTableItems.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISyncParams {
    siteId?: string | undefined;
    dateYesterday: Date;
    stemAnimals: Date;
    growthPigEvents: Date;
    pregnancies: Date;
    generalSettings: Date;
    lardScanningEvents: Date;
    workListSettings: Date;
    drugTypes: Date;
    markings: Date;
    diagnoseCategories: Date;
    diagnoses: Date;
    reasons: Date;
    validationSetup: Date;
    treatments: Date;
    stations: Date;
    unitToPens: Date;
    esfFeedCurves: Date;
    esfFeedingStatus: Date;
    treatmentPlans: Date;
    treatmentDefinitions: Date;
    matingBatches: Date;
    moveEvents: Date;
    matingBatchSettings: Date;
    locations: Date;
    valveGroups: Date;
    workListToTreatmentPlans: Date;
    processEquipments: Date;
    processEquipmentData: Date;
    esfDailyStatus: Date;
    deadPigletsEvents: Date;
    poolYoungFemales: Date;
    distriwinOption: Date;
    nucleusBreedSettings: Date;
    breedTableItems: Date;
}

export class TreatmentAndTreatmentPlan extends SiteEntity implements ITreatmentAndTreatmentPlan {
    treatment?: Treatment | undefined;
    treatmentPlan?: TreatmentPlan | undefined;

    constructor(data?: ITreatmentAndTreatmentPlan) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.treatment = _data["treatment"] ? Treatment.fromJS(_data["treatment"]) : <any>undefined;
            this.treatmentPlan = _data["treatmentPlan"] ? TreatmentPlan.fromJS(_data["treatmentPlan"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): TreatmentAndTreatmentPlan {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentAndTreatmentPlan();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["treatment"] = this.treatment ? this.treatment.toJSON() : <any>undefined;
        data["treatmentPlan"] = this.treatmentPlan ? this.treatmentPlan.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ITreatmentAndTreatmentPlan extends ISiteEntity {
    treatment?: Treatment | undefined;
    treatmentPlan?: TreatmentPlan | undefined;
}

export class TreatmentAndTreatmentPlanList extends SiteEntity implements ITreatmentAndTreatmentPlanList {
    treatments?: Treatment[] | undefined;
    treatmentPlan?: TreatmentPlan | undefined;

    constructor(data?: ITreatmentAndTreatmentPlanList) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["treatments"])) {
                this.treatments = [] as any;
                for (let item of _data["treatments"])
                    this.treatments!.push(Treatment.fromJS(item));
            }
            this.treatmentPlan = _data["treatmentPlan"] ? TreatmentPlan.fromJS(_data["treatmentPlan"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): TreatmentAndTreatmentPlanList {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentAndTreatmentPlanList();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.treatments)) {
            data["treatments"] = [];
            for (let item of this.treatments)
                data["treatments"].push(item.toJSON());
        }
        data["treatmentPlan"] = this.treatmentPlan ? this.treatmentPlan.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ITreatmentAndTreatmentPlanList extends ISiteEntity {
    treatments?: Treatment[] | undefined;
    treatmentPlan?: TreatmentPlan | undefined;
}

export class UnknownAnimal extends SiteEntity implements IUnknownAnimal {
    animalNumber?: string | undefined;
    transponder?: string | undefined;
    location?: string | undefined;

    constructor(data?: IUnknownAnimal) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.animalNumber = _data["animalNumber"];
            this.transponder = _data["transponder"];
            this.location = _data["location"];
        }
    }

    static override fromJS(data: any): UnknownAnimal {
        data = typeof data === 'object' ? data : {};
        let result = new UnknownAnimal();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["animalNumber"] = this.animalNumber;
        data["transponder"] = this.transponder;
        data["location"] = this.location;
        super.toJSON(data);
        return data;
    }
}

export interface IUnknownAnimal extends ISiteEntity {
    animalNumber?: string | undefined;
    transponder?: string | undefined;
    location?: string | undefined;
}

export class MapUnknownAnimalModel implements IMapUnknownAnimalModel {
    siteId?: string | undefined;
    stemAnimalId?: string | undefined;
    unknownAnimalId?: string | undefined;
    animalNumber?: string | undefined;
    unknownAnimalNumber?: string | undefined;
    locationCode?: string | undefined;
    currentPenId?: string | undefined;
    newPenId?: string | undefined;
    transponder?: string | undefined;

    constructor(data?: IMapUnknownAnimalModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.siteId = _data["siteId"];
            this.stemAnimalId = _data["stemAnimalId"];
            this.unknownAnimalId = _data["unknownAnimalId"];
            this.animalNumber = _data["animalNumber"];
            this.unknownAnimalNumber = _data["unknownAnimalNumber"];
            this.locationCode = _data["locationCode"];
            this.currentPenId = _data["currentPenId"];
            this.newPenId = _data["newPenId"];
            this.transponder = _data["transponder"];
        }
    }

    static fromJS(data: any): MapUnknownAnimalModel {
        data = typeof data === 'object' ? data : {};
        let result = new MapUnknownAnimalModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siteId"] = this.siteId;
        data["stemAnimalId"] = this.stemAnimalId;
        data["unknownAnimalId"] = this.unknownAnimalId;
        data["animalNumber"] = this.animalNumber;
        data["unknownAnimalNumber"] = this.unknownAnimalNumber;
        data["locationCode"] = this.locationCode;
        data["currentPenId"] = this.currentPenId;
        data["newPenId"] = this.newPenId;
        data["transponder"] = this.transponder;
        return data;
    }
}

export interface IMapUnknownAnimalModel {
    siteId?: string | undefined;
    stemAnimalId?: string | undefined;
    unknownAnimalId?: string | undefined;
    animalNumber?: string | undefined;
    unknownAnimalNumber?: string | undefined;
    locationCode?: string | undefined;
    currentPenId?: string | undefined;
    newPenId?: string | undefined;
    transponder?: string | undefined;
}

export abstract class BaseSyncOfUserProfile implements IBaseSyncOfUserProfile {
    syncTime!: Date;

    protected _discriminator: string;

    constructor(data?: IBaseSyncOfUserProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "BaseSyncOfUserProfile";
    }

    init(_data?: any) {
        if (_data) {
            this.syncTime = _data["syncTime"] ? new Date(_data["syncTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseSyncOfUserProfile {
        data = typeof data === 'object' ? data : {};
        if (data["_discriminator"] === "SyncDataUserProfile") {
            let result = new SyncDataUserProfile();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'BaseSyncOfUserProfile' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_discriminator"] = this._discriminator;
        data["syncTime"] = this.syncTime ? this.syncTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBaseSyncOfUserProfile {
    syncTime: Date;
}

export class SyncDataUserProfile extends BaseSyncOfUserProfile implements ISyncDataUserProfile {
    datas?: UserProfile2[] | undefined;

    constructor(data?: ISyncDataUserProfile) {
        super(data);
        this._discriminator = "SyncDataUserProfile";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["datas"])) {
                this.datas = [] as any;
                for (let item of _data["datas"])
                    this.datas!.push(UserProfile2.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): SyncDataUserProfile {
        data = typeof data === 'object' ? data : {};
        let result = new SyncDataUserProfile();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.datas)) {
            data["datas"] = [];
            for (let item of this.datas)
                data["datas"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISyncDataUserProfile extends IBaseSyncOfUserProfile {
    datas?: UserProfile2[] | undefined;
}

export class UserSiteDTO implements IUserSiteDTO {
    siteName?: string | undefined;
    userId?: string | undefined;
    siteId?: string | undefined;

    constructor(data?: IUserSiteDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.siteName = _data["siteName"];
            this.userId = _data["userId"];
            this.siteId = _data["siteId"];
        }
    }

    static fromJS(data: any): UserSiteDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserSiteDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siteName"] = this.siteName;
        data["userId"] = this.userId;
        data["siteId"] = this.siteId;
        return data;
    }
}

export interface IUserSiteDTO {
    siteName?: string | undefined;
    userId?: string | undefined;
    siteId?: string | undefined;
}

export class VaccinationDefinition extends Unique implements IVaccinationDefinition {
    eventType!: VaccinationEvent;
    drugId?: string | undefined;
    vaccinationSettings?: VaccinationSetting[] | undefined;
    siteId?: string | undefined;
    diagnoseId?: string | undefined;

    constructor(data?: IVaccinationDefinition) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.eventType = _data["eventType"];
            this.drugId = _data["drugId"];
            if (Array.isArray(_data["vaccinationSettings"])) {
                this.vaccinationSettings = [] as any;
                for (let item of _data["vaccinationSettings"])
                    this.vaccinationSettings!.push(VaccinationSetting.fromJS(item));
            }
            this.siteId = _data["siteId"];
            this.diagnoseId = _data["diagnoseId"];
        }
    }

    static override fromJS(data: any): VaccinationDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new VaccinationDefinition();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventType"] = this.eventType;
        data["drugId"] = this.drugId;
        if (Array.isArray(this.vaccinationSettings)) {
            data["vaccinationSettings"] = [];
            for (let item of this.vaccinationSettings)
                data["vaccinationSettings"].push(item.toJSON());
        }
        data["siteId"] = this.siteId;
        data["diagnoseId"] = this.diagnoseId;
        super.toJSON(data);
        return data;
    }
}

export interface IVaccinationDefinition extends IUnique {
    eventType: VaccinationEvent;
    drugId?: string | undefined;
    vaccinationSettings?: VaccinationSetting[] | undefined;
    siteId?: string | undefined;
    diagnoseId?: string | undefined;
}

export enum VaccinationEvent {
    Mating = "Mating",
    Farrowing = "Farrowing",
    Averting = "Averting",
    Birthdate = "Birthdate",
}

export class VaccinationSetting implements IVaccinationSetting {
    animalKind!: AnimalKind;
    value!: number;
    dayType!: VaccinationDayType;

    constructor(data?: IVaccinationSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.animalKind = _data["animalKind"];
            this.value = _data["value"];
            this.dayType = _data["dayType"];
        }
    }

    static fromJS(data: any): VaccinationSetting {
        data = typeof data === 'object' ? data : {};
        let result = new VaccinationSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["animalKind"] = this.animalKind;
        data["value"] = this.value;
        data["dayType"] = this.dayType;
        return data;
    }
}

export interface IVaccinationSetting {
    animalKind: AnimalKind;
    value: number;
    dayType: VaccinationDayType;
}

export enum VaccinationDayType {
    Days1 = "Days1",
    Days2 = "Days2",
    Age1 = "Age1",
    Age2 = "Age2",
    Age3 = "Age3",
}

export class ValveGroupHistory implements IValveGroupHistory {
    id?: string | undefined;
    location?: string[] | undefined;
    message?: string | undefined;
    date!: Date;

    constructor(data?: IValveGroupHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["location"])) {
                this.location = [] as any;
                for (let item of _data["location"])
                    this.location!.push(item);
            }
            this.message = _data["message"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ValveGroupHistory {
        data = typeof data === 'object' ? data : {};
        let result = new ValveGroupHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.location)) {
            data["location"] = [];
            for (let item of this.location)
                data["location"].push(item);
        }
        data["message"] = this.message;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        return data;
    }
}

export interface IValveGroupHistory {
    id?: string | undefined;
    location?: string[] | undefined;
    message?: string | undefined;
    date: Date;
}

export class ValveGroupHistoryDto implements IValveGroupHistoryDto {
    id?: string | undefined;
    location?: string[] | undefined;
    valveGroupHistories?: ValveGroupHistoryUpdate[] | undefined;
    date!: Date;

    constructor(data?: IValveGroupHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["location"])) {
                this.location = [] as any;
                for (let item of _data["location"])
                    this.location!.push(item);
            }
            if (Array.isArray(_data["valveGroupHistories"])) {
                this.valveGroupHistories = [] as any;
                for (let item of _data["valveGroupHistories"])
                    this.valveGroupHistories!.push(ValveGroupHistoryUpdate.fromJS(item));
            }
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ValveGroupHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ValveGroupHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.location)) {
            data["location"] = [];
            for (let item of this.location)
                data["location"].push(item);
        }
        if (Array.isArray(this.valveGroupHistories)) {
            data["valveGroupHistories"] = [];
            for (let item of this.valveGroupHistories)
                data["valveGroupHistories"].push(item.toJSON());
        }
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        return data;
    }
}

export interface IValveGroupHistoryDto {
    id?: string | undefined;
    location?: string[] | undefined;
    valveGroupHistories?: ValveGroupHistoryUpdate[] | undefined;
    date: Date;
}

export class ValveGroupHistoryV1 extends SiteEntity implements IValveGroupHistoryV1 {
    valveGroupId?: string | undefined;
    message?: string | undefined;

    constructor(data?: IValveGroupHistoryV1) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.valveGroupId = _data["valveGroupId"];
            this.message = _data["message"];
        }
    }

    static override fromJS(data: any): ValveGroupHistoryV1 {
        data = typeof data === 'object' ? data : {};
        let result = new ValveGroupHistoryV1();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valveGroupId"] = this.valveGroupId;
        data["message"] = this.message;
        super.toJSON(data);
        return data;
    }
}

export interface IValveGroupHistoryV1 extends ISiteEntity {
    valveGroupId?: string | undefined;
    message?: string | undefined;
}

export class ValveGroupHistory2 extends SiteEntity implements IValveGroupHistory2 {
    valveGroupId?: string | undefined;
    valveGroupHistories?: ValveGroupHistoryUpdate[] | undefined;

    constructor(data?: IValveGroupHistory2) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.valveGroupId = _data["valveGroupId"];
            if (Array.isArray(_data["valveGroupHistories"])) {
                this.valveGroupHistories = [] as any;
                for (let item of _data["valveGroupHistories"])
                    this.valveGroupHistories!.push(ValveGroupHistoryUpdate.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ValveGroupHistory2 {
        data = typeof data === 'object' ? data : {};
        let result = new ValveGroupHistory2();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valveGroupId"] = this.valveGroupId;
        if (Array.isArray(this.valveGroupHistories)) {
            data["valveGroupHistories"] = [];
            for (let item of this.valveGroupHistories)
                data["valveGroupHistories"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IValveGroupHistory2 extends ISiteEntity {
    valveGroupId?: string | undefined;
    valveGroupHistories?: ValveGroupHistoryUpdate[] | undefined;
}

export class ValveGroup2 extends SiteEntity implements IValveGroup2 {
    constantDeviation?: number | undefined;
    deviation?: number | undefined;
    deviationDays?: number | undefined;
    sowCount?: number | undefined;
    pigCount?: number | undefined;
    sowCycle?: SowCycleType | undefined;
    weight?: number | undefined;
    penDays?: number | undefined;
    pigletCount?: number | undefined;
    consumation?: number | undefined;
    feedUnits?: number | undefined;
    feedingCurve?: number | undefined;
    lastSync?: Date | undefined;
    planning?: string | undefined;
    recipeNumber?: number | undefined;
    recipePercentage?: number | undefined;
    eatTime!: boolean;
    distriwinSortOrder?: number | undefined;

    constructor(data?: IValveGroup2) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.constantDeviation = _data["constantDeviation"];
            this.deviation = _data["deviation"];
            this.deviationDays = _data["deviationDays"];
            this.sowCount = _data["sowCount"];
            this.pigCount = _data["pigCount"];
            this.sowCycle = _data["sowCycle"];
            this.weight = _data["weight"];
            this.penDays = _data["penDays"];
            this.pigletCount = _data["pigletCount"];
            this.consumation = _data["consumation"];
            this.feedUnits = _data["feedUnits"];
            this.feedingCurve = _data["feedingCurve"];
            this.lastSync = _data["lastSync"] ? new Date(_data["lastSync"].toString()) : <any>undefined;
            this.planning = _data["planning"];
            this.recipeNumber = _data["recipeNumber"];
            this.recipePercentage = _data["recipePercentage"];
            this.eatTime = _data["eatTime"];
            this.distriwinSortOrder = _data["distriwinSortOrder"];
        }
    }

    static override fromJS(data: any): ValveGroup2 {
        data = typeof data === 'object' ? data : {};
        let result = new ValveGroup2();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["constantDeviation"] = this.constantDeviation;
        data["deviation"] = this.deviation;
        data["deviationDays"] = this.deviationDays;
        data["sowCount"] = this.sowCount;
        data["pigCount"] = this.pigCount;
        data["sowCycle"] = this.sowCycle;
        data["weight"] = this.weight;
        data["penDays"] = this.penDays;
        data["pigletCount"] = this.pigletCount;
        data["consumation"] = this.consumation;
        data["feedUnits"] = this.feedUnits;
        data["feedingCurve"] = this.feedingCurve;
        data["lastSync"] = this.lastSync ? this.lastSync.toISOString() : <any>undefined;
        data["planning"] = this.planning;
        data["recipeNumber"] = this.recipeNumber;
        data["recipePercentage"] = this.recipePercentage;
        data["eatTime"] = this.eatTime;
        data["distriwinSortOrder"] = this.distriwinSortOrder;
        super.toJSON(data);
        return data;
    }
}

export interface IValveGroup2 extends ISiteEntity {
    constantDeviation?: number | undefined;
    deviation?: number | undefined;
    deviationDays?: number | undefined;
    sowCount?: number | undefined;
    pigCount?: number | undefined;
    sowCycle?: SowCycleType | undefined;
    weight?: number | undefined;
    penDays?: number | undefined;
    pigletCount?: number | undefined;
    consumation?: number | undefined;
    feedUnits?: number | undefined;
    feedingCurve?: number | undefined;
    lastSync?: Date | undefined;
    planning?: string | undefined;
    recipeNumber?: number | undefined;
    recipePercentage?: number | undefined;
    eatTime: boolean;
    distriwinSortOrder?: number | undefined;
}

export class ValveGroupsSyncResponse implements IValveGroupsSyncResponse {
    status!: ValveGroupsSyncStatus;
    valveGroups?: ValveGroup[] | undefined;

    constructor(data?: IValveGroupsSyncResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["valveGroups"])) {
                this.valveGroups = [] as any;
                for (let item of _data["valveGroups"])
                    this.valveGroups!.push(ValveGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ValveGroupsSyncResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ValveGroupsSyncResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.valveGroups)) {
            data["valveGroups"] = [];
            for (let item of this.valveGroups)
                data["valveGroups"].push(item.toJSON());
        }
        return data;
    }
}

export interface IValveGroupsSyncResponse {
    status: ValveGroupsSyncStatus;
    valveGroups?: ValveGroup[] | undefined;
}

export enum ValveGroupsSyncStatus {
    Success = "Success",
    SourceSystemCommunicationFailed = "SourceSystemCommunicationFailed",
    UnknownError = "UnknownError",
}

export class ValveGroupUpdate implements IValveGroupUpdate {
    id?: string | undefined;
    constantDeviation?: number | undefined;
    deviation?: number | undefined;
    deviationDays?: number | undefined;
    feedingCurve?: number | undefined;
    modifiedOn!: Date;
    sowCycle?: SowCycleType | undefined;
    penIds?: string[] | undefined;
    pigCount?: number | undefined;
    weight?: number | undefined;
    penDays?: number | undefined;
    pigletCount?: number | undefined;
    recipeNumber?: number | undefined;

    constructor(data?: IValveGroupUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.constantDeviation = _data["constantDeviation"];
            this.deviation = _data["deviation"];
            this.deviationDays = _data["deviationDays"];
            this.feedingCurve = _data["feedingCurve"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.sowCycle = _data["sowCycle"];
            if (Array.isArray(_data["penIds"])) {
                this.penIds = [] as any;
                for (let item of _data["penIds"])
                    this.penIds!.push(item);
            }
            this.pigCount = _data["pigCount"];
            this.weight = _data["weight"];
            this.penDays = _data["penDays"];
            this.pigletCount = _data["pigletCount"];
            this.recipeNumber = _data["recipeNumber"];
        }
    }

    static fromJS(data: any): ValveGroupUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new ValveGroupUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["constantDeviation"] = this.constantDeviation;
        data["deviation"] = this.deviation;
        data["deviationDays"] = this.deviationDays;
        data["feedingCurve"] = this.feedingCurve;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["sowCycle"] = this.sowCycle;
        if (Array.isArray(this.penIds)) {
            data["penIds"] = [];
            for (let item of this.penIds)
                data["penIds"].push(item);
        }
        data["pigCount"] = this.pigCount;
        data["weight"] = this.weight;
        data["penDays"] = this.penDays;
        data["pigletCount"] = this.pigletCount;
        data["recipeNumber"] = this.recipeNumber;
        return data;
    }
}

export interface IValveGroupUpdate {
    id?: string | undefined;
    constantDeviation?: number | undefined;
    deviation?: number | undefined;
    deviationDays?: number | undefined;
    feedingCurve?: number | undefined;
    modifiedOn: Date;
    sowCycle?: SowCycleType | undefined;
    penIds?: string[] | undefined;
    pigCount?: number | undefined;
    weight?: number | undefined;
    penDays?: number | undefined;
    pigletCount?: number | undefined;
    recipeNumber?: number | undefined;
}

export class GrowthPigAdjustFeedUpdate implements IGrowthPigAdjustFeedUpdate {
    valveGroupId?: string | undefined;
    penId?: string | undefined;
    feedingCurve?: number | undefined;
    recipeName?: string | undefined;
    recipeNumber?: number | undefined;
    pigCount?: number | undefined;
    weight?: number | undefined;
    registrationDate?: Date | undefined;

    constructor(data?: IGrowthPigAdjustFeedUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valveGroupId = _data["valveGroupId"];
            this.penId = _data["penId"];
            this.feedingCurve = _data["feedingCurve"];
            this.recipeName = _data["recipeName"];
            this.recipeNumber = _data["recipeNumber"];
            this.pigCount = _data["pigCount"];
            this.weight = _data["weight"];
            this.registrationDate = _data["registrationDate"] ? new Date(_data["registrationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GrowthPigAdjustFeedUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new GrowthPigAdjustFeedUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valveGroupId"] = this.valveGroupId;
        data["penId"] = this.penId;
        data["feedingCurve"] = this.feedingCurve;
        data["recipeName"] = this.recipeName;
        data["recipeNumber"] = this.recipeNumber;
        data["pigCount"] = this.pigCount;
        data["weight"] = this.weight;
        data["registrationDate"] = this.registrationDate ? this.registrationDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGrowthPigAdjustFeedUpdate {
    valveGroupId?: string | undefined;
    penId?: string | undefined;
    feedingCurve?: number | undefined;
    recipeName?: string | undefined;
    recipeNumber?: number | undefined;
    pigCount?: number | undefined;
    weight?: number | undefined;
    registrationDate?: Date | undefined;
}

export class Valve2 extends SiteEntity implements IValve2 {
    valveGroupId?: string | undefined;
    scale!: number;
    code?: string | undefined;

    constructor(data?: IValve2) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.valveGroupId = _data["valveGroupId"];
            this.scale = _data["scale"];
            this.code = _data["code"];
        }
    }

    static override fromJS(data: any): Valve2 {
        data = typeof data === 'object' ? data : {};
        let result = new Valve2();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valveGroupId"] = this.valveGroupId;
        data["scale"] = this.scale;
        data["code"] = this.code;
        super.toJSON(data);
        return data;
    }
}

export interface IValve2 extends ISiteEntity {
    valveGroupId?: string | undefined;
    scale: number;
    code?: string | undefined;
}

export class RetryAdjustFeedTableItem implements IRetryAdjustFeedTableItem {
    location?: string | undefined;
    fixedValue?: string | undefined;
    building?: string | undefined;
    section?: string | undefined;
    pens?: string[] | undefined;
    date!: Date;
    weight?: string | undefined;
    valve?: string | undefined;
    penDays?: string | undefined;
    pigCount?: string | undefined;
    sowCycle?: string | undefined;
    variableModulation?: string | undefined;
    variableModulationDays?: string | undefined;
    feedingCurve?: string | undefined;
    cellColorStyle!: CellColorStyle;

    constructor(data?: IRetryAdjustFeedTableItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.location = _data["location"];
            this.fixedValue = _data["fixedValue"];
            this.building = _data["building"];
            this.section = _data["section"];
            if (Array.isArray(_data["pens"])) {
                this.pens = [] as any;
                for (let item of _data["pens"])
                    this.pens!.push(item);
            }
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.weight = _data["weight"];
            this.valve = _data["valve"];
            this.penDays = _data["penDays"];
            this.pigCount = _data["pigCount"];
            this.sowCycle = _data["sowCycle"];
            this.variableModulation = _data["variableModulation"];
            this.variableModulationDays = _data["variableModulationDays"];
            this.feedingCurve = _data["feedingCurve"];
            this.cellColorStyle = _data["cellColorStyle"];
        }
    }

    static fromJS(data: any): RetryAdjustFeedTableItem {
        data = typeof data === 'object' ? data : {};
        let result = new RetryAdjustFeedTableItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["location"] = this.location;
        data["fixedValue"] = this.fixedValue;
        data["building"] = this.building;
        data["section"] = this.section;
        if (Array.isArray(this.pens)) {
            data["pens"] = [];
            for (let item of this.pens)
                data["pens"].push(item);
        }
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["weight"] = this.weight;
        data["valve"] = this.valve;
        data["penDays"] = this.penDays;
        data["pigCount"] = this.pigCount;
        data["sowCycle"] = this.sowCycle;
        data["variableModulation"] = this.variableModulation;
        data["variableModulationDays"] = this.variableModulationDays;
        data["feedingCurve"] = this.feedingCurve;
        data["cellColorStyle"] = this.cellColorStyle;
        return data;
    }
}

export interface IRetryAdjustFeedTableItem {
    location?: string | undefined;
    fixedValue?: string | undefined;
    building?: string | undefined;
    section?: string | undefined;
    pens?: string[] | undefined;
    date: Date;
    weight?: string | undefined;
    valve?: string | undefined;
    penDays?: string | undefined;
    pigCount?: string | undefined;
    sowCycle?: string | undefined;
    variableModulation?: string | undefined;
    variableModulationDays?: string | undefined;
    feedingCurve?: string | undefined;
    cellColorStyle: CellColorStyle;
}

export class ValveFieldUpdateDto implements IValveFieldUpdateDto {
    id?: string | undefined;
    location?: string | undefined;
    building?: string | undefined;
    section?: string | undefined;
    pens?: string[] | undefined;
    buildingOrder?: number | undefined;
    sectionOrder?: number | undefined;
    penOrder?: number | undefined;
    valve?: string | undefined;
    animalType?: AnimalType | undefined;
    entityName?: string | undefined;
    fieldName?: string | undefined;
    value?: string | undefined;
    firstAttemptedOn!: Date;
    lastAttemptedOn!: Date;
    acknowledged!: boolean;
    siteId?: string | undefined;
    status!: ValveFieldUpdateStatus;

    constructor(data?: IValveFieldUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.location = _data["location"];
            this.building = _data["building"];
            this.section = _data["section"];
            if (Array.isArray(_data["pens"])) {
                this.pens = [] as any;
                for (let item of _data["pens"])
                    this.pens!.push(item);
            }
            this.buildingOrder = _data["buildingOrder"];
            this.sectionOrder = _data["sectionOrder"];
            this.penOrder = _data["penOrder"];
            this.valve = _data["valve"];
            this.animalType = _data["animalType"];
            this.entityName = _data["entityName"];
            this.fieldName = _data["fieldName"];
            this.value = _data["value"];
            this.firstAttemptedOn = _data["firstAttemptedOn"] ? new Date(_data["firstAttemptedOn"].toString()) : <any>undefined;
            this.lastAttemptedOn = _data["lastAttemptedOn"] ? new Date(_data["lastAttemptedOn"].toString()) : <any>undefined;
            this.acknowledged = _data["acknowledged"];
            this.siteId = _data["siteId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ValveFieldUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ValveFieldUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["location"] = this.location;
        data["building"] = this.building;
        data["section"] = this.section;
        if (Array.isArray(this.pens)) {
            data["pens"] = [];
            for (let item of this.pens)
                data["pens"].push(item);
        }
        data["buildingOrder"] = this.buildingOrder;
        data["sectionOrder"] = this.sectionOrder;
        data["penOrder"] = this.penOrder;
        data["valve"] = this.valve;
        data["animalType"] = this.animalType;
        data["entityName"] = this.entityName;
        data["fieldName"] = this.fieldName;
        data["value"] = this.value;
        data["firstAttemptedOn"] = this.firstAttemptedOn ? this.firstAttemptedOn.toISOString() : <any>undefined;
        data["lastAttemptedOn"] = this.lastAttemptedOn ? this.lastAttemptedOn.toISOString() : <any>undefined;
        data["acknowledged"] = this.acknowledged;
        data["siteId"] = this.siteId;
        data["status"] = this.status;
        return data;
    }
}

export interface IValveFieldUpdateDto {
    id?: string | undefined;
    location?: string | undefined;
    building?: string | undefined;
    section?: string | undefined;
    pens?: string[] | undefined;
    buildingOrder?: number | undefined;
    sectionOrder?: number | undefined;
    penOrder?: number | undefined;
    valve?: string | undefined;
    animalType?: AnimalType | undefined;
    entityName?: string | undefined;
    fieldName?: string | undefined;
    value?: string | undefined;
    firstAttemptedOn: Date;
    lastAttemptedOn: Date;
    acknowledged: boolean;
    siteId?: string | undefined;
    status: ValveFieldUpdateStatus;
}

export enum ValveFieldUpdateStatus {
    Created = "Created",
    Failed = "Failed",
    Succeeded = "Succeeded",
    RetryInProgress = "RetryInProgress",
    Acknowledged = "Acknowledged",
}

export class ValveUpdateError implements IValveUpdateError {
    location?: string | undefined;
    building?: string | undefined;
    section?: string | undefined;
    pens?: string[] | undefined;
    buildingOrder?: number | undefined;
    sectionOrder?: number | undefined;
    penOrder?: number | undefined;
    valve?: string | undefined;
    animalType?: AnimalType | undefined;
    createdOn?: Date | undefined;
    siteId?: string | undefined;
    status!: ValveFieldUpdateStatus;

    constructor(data?: IValveUpdateError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.location = _data["location"];
            this.building = _data["building"];
            this.section = _data["section"];
            if (Array.isArray(_data["pens"])) {
                this.pens = [] as any;
                for (let item of _data["pens"])
                    this.pens!.push(item);
            }
            this.buildingOrder = _data["buildingOrder"];
            this.sectionOrder = _data["sectionOrder"];
            this.penOrder = _data["penOrder"];
            this.valve = _data["valve"];
            this.animalType = _data["animalType"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.siteId = _data["siteId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ValveUpdateError {
        data = typeof data === 'object' ? data : {};
        let result = new ValveUpdateError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["location"] = this.location;
        data["building"] = this.building;
        data["section"] = this.section;
        if (Array.isArray(this.pens)) {
            data["pens"] = [];
            for (let item of this.pens)
                data["pens"].push(item);
        }
        data["buildingOrder"] = this.buildingOrder;
        data["sectionOrder"] = this.sectionOrder;
        data["penOrder"] = this.penOrder;
        data["valve"] = this.valve;
        data["animalType"] = this.animalType;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["siteId"] = this.siteId;
        data["status"] = this.status;
        return data;
    }
}

export interface IValveUpdateError {
    location?: string | undefined;
    building?: string | undefined;
    section?: string | undefined;
    pens?: string[] | undefined;
    buildingOrder?: number | undefined;
    sectionOrder?: number | undefined;
    penOrder?: number | undefined;
    valve?: string | undefined;
    animalType?: AnimalType | undefined;
    createdOn?: Date | undefined;
    siteId?: string | undefined;
    status: ValveFieldUpdateStatus;
}

export class MatingWorkListTableItem implements IMatingWorkListTableItem {
    animalNumber?: string | undefined;
    boar?: string | undefined;
    commited!: boolean;
    cycleDays?: string | undefined;
    grade?: string | undefined;
    matingDateTime?: string | undefined;
    cellColorStyle!: CellColorStyle;

    constructor(data?: IMatingWorkListTableItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.animalNumber = _data["animalNumber"];
            this.boar = _data["boar"];
            this.commited = _data["commited"];
            this.cycleDays = _data["cycleDays"];
            this.grade = _data["grade"];
            this.matingDateTime = _data["matingDateTime"];
            this.cellColorStyle = _data["cellColorStyle"];
        }
    }

    static fromJS(data: any): MatingWorkListTableItem {
        data = typeof data === 'object' ? data : {};
        let result = new MatingWorkListTableItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["animalNumber"] = this.animalNumber;
        data["boar"] = this.boar;
        data["commited"] = this.commited;
        data["cycleDays"] = this.cycleDays;
        data["grade"] = this.grade;
        data["matingDateTime"] = this.matingDateTime;
        data["cellColorStyle"] = this.cellColorStyle;
        return data;
    }
}

export interface IMatingWorkListTableItem {
    animalNumber?: string | undefined;
    boar?: string | undefined;
    commited: boolean;
    cycleDays?: string | undefined;
    grade?: string | undefined;
    matingDateTime?: string | undefined;
    cellColorStyle: CellColorStyle;
}

export class FarrowingWorkListTableItem implements IFarrowingWorkListTableItem {
    animalNumber?: string | undefined;
    batch?: string | undefined;
    cycleDays?: string | undefined;
    expectedFarrowing?: string | undefined;
    cellColorStyle!: CellColorStyle;

    constructor(data?: IFarrowingWorkListTableItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.animalNumber = _data["animalNumber"];
            this.batch = _data["batch"];
            this.cycleDays = _data["cycleDays"];
            this.expectedFarrowing = _data["expectedFarrowing"];
            this.cellColorStyle = _data["cellColorStyle"];
        }
    }

    static fromJS(data: any): FarrowingWorkListTableItem {
        data = typeof data === 'object' ? data : {};
        let result = new FarrowingWorkListTableItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["animalNumber"] = this.animalNumber;
        data["batch"] = this.batch;
        data["cycleDays"] = this.cycleDays;
        data["expectedFarrowing"] = this.expectedFarrowing;
        data["cellColorStyle"] = this.cellColorStyle;
        return data;
    }
}

export interface IFarrowingWorkListTableItem {
    animalNumber?: string | undefined;
    batch?: string | undefined;
    cycleDays?: string | undefined;
    expectedFarrowing?: string | undefined;
    cellColorStyle: CellColorStyle;
}

export class LardScanningEventWorkListTableItem implements ILardScanningEventWorkListTableItem {
    cycleDays?: string | undefined;
    litterNumber?: string | undefined;
    animalNumber?: string | undefined;
    date?: string | undefined;
    lardWidth?: string | undefined;
    isChecked?: string | undefined;
    cellColorStyle!: CellColorStyle;

    constructor(data?: ILardScanningEventWorkListTableItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cycleDays = _data["cycleDays"];
            this.litterNumber = _data["litterNumber"];
            this.animalNumber = _data["animalNumber"];
            this.date = _data["date"];
            this.lardWidth = _data["lardWidth"];
            this.isChecked = _data["isChecked"];
            this.cellColorStyle = _data["cellColorStyle"];
        }
    }

    static fromJS(data: any): LardScanningEventWorkListTableItem {
        data = typeof data === 'object' ? data : {};
        let result = new LardScanningEventWorkListTableItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cycleDays"] = this.cycleDays;
        data["litterNumber"] = this.litterNumber;
        data["animalNumber"] = this.animalNumber;
        data["date"] = this.date;
        data["lardWidth"] = this.lardWidth;
        data["isChecked"] = this.isChecked;
        data["cellColorStyle"] = this.cellColorStyle;
        return data;
    }
}

export interface ILardScanningEventWorkListTableItem {
    cycleDays?: string | undefined;
    litterNumber?: string | undefined;
    animalNumber?: string | undefined;
    date?: string | undefined;
    lardWidth?: string | undefined;
    isChecked?: string | undefined;
    cellColorStyle: CellColorStyle;
}

export class AllAnimalsEsfWorkListTableItem implements IAllAnimalsEsfWorkListTableItem {
    animalNumber?: string | undefined;
    currentLocation?: string | undefined;
    curve?: string | undefined;
    cycleDays?: string | undefined;
    eatenToday?: string | undefined;
    feDay?: string | undefined;
    fixedPercent?: string | undefined;
    deviationPeriod?: string | undefined;
    tempFeedDeviation?: string | undefined;
    cellColorStyle!: CellColorStyle;

    constructor(data?: IAllAnimalsEsfWorkListTableItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.animalNumber = _data["animalNumber"];
            this.currentLocation = _data["currentLocation"];
            this.curve = _data["curve"];
            this.cycleDays = _data["cycleDays"];
            this.eatenToday = _data["eatenToday"];
            this.feDay = _data["feDay"];
            this.fixedPercent = _data["fixedPercent"];
            this.deviationPeriod = _data["deviationPeriod"];
            this.tempFeedDeviation = _data["tempFeedDeviation"];
            this.cellColorStyle = _data["cellColorStyle"];
        }
    }

    static fromJS(data: any): AllAnimalsEsfWorkListTableItem {
        data = typeof data === 'object' ? data : {};
        let result = new AllAnimalsEsfWorkListTableItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["animalNumber"] = this.animalNumber;
        data["currentLocation"] = this.currentLocation;
        data["curve"] = this.curve;
        data["cycleDays"] = this.cycleDays;
        data["eatenToday"] = this.eatenToday;
        data["feDay"] = this.feDay;
        data["fixedPercent"] = this.fixedPercent;
        data["deviationPeriod"] = this.deviationPeriod;
        data["tempFeedDeviation"] = this.tempFeedDeviation;
        data["cellColorStyle"] = this.cellColorStyle;
        return data;
    }
}

export interface IAllAnimalsEsfWorkListTableItem {
    animalNumber?: string | undefined;
    currentLocation?: string | undefined;
    curve?: string | undefined;
    cycleDays?: string | undefined;
    eatenToday?: string | undefined;
    feDay?: string | undefined;
    fixedPercent?: string | undefined;
    deviationPeriod?: string | undefined;
    tempFeedDeviation?: string | undefined;
    cellColorStyle: CellColorStyle;
}

export class ShortageEsfWorkListTableItem implements IShortageEsfWorkListTableItem {
    animalNumber?: string | undefined;
    currentLocation?: string | undefined;
    curveToday?: string | undefined;
    curveYesterday?: string | undefined;
    cycleDays?: string | undefined;
    eatenToday?: string | undefined;
    eatenYesterday?: string | undefined;
    restToday?: string | undefined;
    restYesterday?: string | undefined;
    cellColorStyle!: CellColorStyle;

    constructor(data?: IShortageEsfWorkListTableItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.animalNumber = _data["animalNumber"];
            this.currentLocation = _data["currentLocation"];
            this.curveToday = _data["curveToday"];
            this.curveYesterday = _data["curveYesterday"];
            this.cycleDays = _data["cycleDays"];
            this.eatenToday = _data["eatenToday"];
            this.eatenYesterday = _data["eatenYesterday"];
            this.restToday = _data["restToday"];
            this.restYesterday = _data["restYesterday"];
            this.cellColorStyle = _data["cellColorStyle"];
        }
    }

    static fromJS(data: any): ShortageEsfWorkListTableItem {
        data = typeof data === 'object' ? data : {};
        let result = new ShortageEsfWorkListTableItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["animalNumber"] = this.animalNumber;
        data["currentLocation"] = this.currentLocation;
        data["curveToday"] = this.curveToday;
        data["curveYesterday"] = this.curveYesterday;
        data["cycleDays"] = this.cycleDays;
        data["eatenToday"] = this.eatenToday;
        data["eatenYesterday"] = this.eatenYesterday;
        data["restToday"] = this.restToday;
        data["restYesterday"] = this.restYesterday;
        data["cellColorStyle"] = this.cellColorStyle;
        return data;
    }
}

export interface IShortageEsfWorkListTableItem {
    animalNumber?: string | undefined;
    currentLocation?: string | undefined;
    curveToday?: string | undefined;
    curveYesterday?: string | undefined;
    cycleDays?: string | undefined;
    eatenToday?: string | undefined;
    eatenYesterday?: string | undefined;
    restToday?: string | undefined;
    restYesterday?: string | undefined;
    cellColorStyle: CellColorStyle;
}

export class WeaningWorkListTableItem implements IWeaningWorkListTableItem {
    animalNumber?: string | undefined;
    commited!: boolean;
    cycleDays?: string | undefined;
    isNursing!: boolean;
    numAlive?: string | undefined;
    totalWeight?: string | undefined;
    weaningDateTime?: string | undefined;
    cellColorStyle!: CellColorStyle;

    constructor(data?: IWeaningWorkListTableItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.animalNumber = _data["animalNumber"];
            this.commited = _data["commited"];
            this.cycleDays = _data["cycleDays"];
            this.isNursing = _data["isNursing"];
            this.numAlive = _data["numAlive"];
            this.totalWeight = _data["totalWeight"];
            this.weaningDateTime = _data["weaningDateTime"];
            this.cellColorStyle = _data["cellColorStyle"];
        }
    }

    static fromJS(data: any): WeaningWorkListTableItem {
        data = typeof data === 'object' ? data : {};
        let result = new WeaningWorkListTableItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["animalNumber"] = this.animalNumber;
        data["commited"] = this.commited;
        data["cycleDays"] = this.cycleDays;
        data["isNursing"] = this.isNursing;
        data["numAlive"] = this.numAlive;
        data["totalWeight"] = this.totalWeight;
        data["weaningDateTime"] = this.weaningDateTime;
        data["cellColorStyle"] = this.cellColorStyle;
        return data;
    }
}

export interface IWeaningWorkListTableItem {
    animalNumber?: string | undefined;
    commited: boolean;
    cycleDays?: string | undefined;
    isNursing: boolean;
    numAlive?: string | undefined;
    totalWeight?: string | undefined;
    weaningDateTime?: string | undefined;
    cellColorStyle: CellColorStyle;
}

export class MovingWorkListTableItemPdf implements IMovingWorkListTableItemPdf {
    animalNumber?: string | undefined;
    cycleDays?: string | undefined;
    cellColorStyle!: CellColorStyle;

    constructor(data?: IMovingWorkListTableItemPdf) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.animalNumber = _data["animalNumber"];
            this.cycleDays = _data["cycleDays"];
            this.cellColorStyle = _data["cellColorStyle"];
        }
    }

    static fromJS(data: any): MovingWorkListTableItemPdf {
        data = typeof data === 'object' ? data : {};
        let result = new MovingWorkListTableItemPdf();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["animalNumber"] = this.animalNumber;
        data["cycleDays"] = this.cycleDays;
        data["cellColorStyle"] = this.cellColorStyle;
        return data;
    }
}

export interface IMovingWorkListTableItemPdf {
    animalNumber?: string | undefined;
    cycleDays?: string | undefined;
    cellColorStyle: CellColorStyle;
}

export class TasksInFarrowingStableData implements ITasksInFarrowingStableData {
    farrowingTaskTreatmentHeader1?: string | undefined;
    farrowingTaskTreatmentHeader2?: string | undefined;
    farrowingTaskTreatmentHeader3?: string | undefined;
    farrowingTaskTreatmentHeader4?: string | undefined;
    tasksInFarrowingStableItems?: TasksInFarrowingStableItemPdf[] | undefined;

    constructor(data?: ITasksInFarrowingStableData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.farrowingTaskTreatmentHeader1 = _data["farrowingTaskTreatmentHeader1"];
            this.farrowingTaskTreatmentHeader2 = _data["farrowingTaskTreatmentHeader2"];
            this.farrowingTaskTreatmentHeader3 = _data["farrowingTaskTreatmentHeader3"];
            this.farrowingTaskTreatmentHeader4 = _data["farrowingTaskTreatmentHeader4"];
            if (Array.isArray(_data["tasksInFarrowingStableItems"])) {
                this.tasksInFarrowingStableItems = [] as any;
                for (let item of _data["tasksInFarrowingStableItems"])
                    this.tasksInFarrowingStableItems!.push(TasksInFarrowingStableItemPdf.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TasksInFarrowingStableData {
        data = typeof data === 'object' ? data : {};
        let result = new TasksInFarrowingStableData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["farrowingTaskTreatmentHeader1"] = this.farrowingTaskTreatmentHeader1;
        data["farrowingTaskTreatmentHeader2"] = this.farrowingTaskTreatmentHeader2;
        data["farrowingTaskTreatmentHeader3"] = this.farrowingTaskTreatmentHeader3;
        data["farrowingTaskTreatmentHeader4"] = this.farrowingTaskTreatmentHeader4;
        if (Array.isArray(this.tasksInFarrowingStableItems)) {
            data["tasksInFarrowingStableItems"] = [];
            for (let item of this.tasksInFarrowingStableItems)
                data["tasksInFarrowingStableItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITasksInFarrowingStableData {
    farrowingTaskTreatmentHeader1?: string | undefined;
    farrowingTaskTreatmentHeader2?: string | undefined;
    farrowingTaskTreatmentHeader3?: string | undefined;
    farrowingTaskTreatmentHeader4?: string | undefined;
    tasksInFarrowingStableItems?: TasksInFarrowingStableItemPdf[] | undefined;
}

export class TasksInFarrowingStableItemPdf implements ITasksInFarrowingStableItemPdf {
    animalNumber?: string | undefined;
    cycleDays?: string | undefined;
    isChecked!: boolean;
    farrowingTaskTreatmentColumn1?: FarrowingTaskTreatmentColumn | undefined;
    farrowingTaskTreatmentColumn2?: FarrowingTaskTreatmentColumn | undefined;
    farrowingTaskTreatmentColumn3?: FarrowingTaskTreatmentColumn | undefined;
    farrowingTaskTreatmentColumn4?: FarrowingTaskTreatmentColumn | undefined;
    cellColorStyle!: CellColorStyle;

    constructor(data?: ITasksInFarrowingStableItemPdf) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.animalNumber = _data["animalNumber"];
            this.cycleDays = _data["cycleDays"];
            this.isChecked = _data["isChecked"];
            this.farrowingTaskTreatmentColumn1 = _data["farrowingTaskTreatmentColumn1"] ? FarrowingTaskTreatmentColumn.fromJS(_data["farrowingTaskTreatmentColumn1"]) : <any>undefined;
            this.farrowingTaskTreatmentColumn2 = _data["farrowingTaskTreatmentColumn2"] ? FarrowingTaskTreatmentColumn.fromJS(_data["farrowingTaskTreatmentColumn2"]) : <any>undefined;
            this.farrowingTaskTreatmentColumn3 = _data["farrowingTaskTreatmentColumn3"] ? FarrowingTaskTreatmentColumn.fromJS(_data["farrowingTaskTreatmentColumn3"]) : <any>undefined;
            this.farrowingTaskTreatmentColumn4 = _data["farrowingTaskTreatmentColumn4"] ? FarrowingTaskTreatmentColumn.fromJS(_data["farrowingTaskTreatmentColumn4"]) : <any>undefined;
            this.cellColorStyle = _data["cellColorStyle"];
        }
    }

    static fromJS(data: any): TasksInFarrowingStableItemPdf {
        data = typeof data === 'object' ? data : {};
        let result = new TasksInFarrowingStableItemPdf();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["animalNumber"] = this.animalNumber;
        data["cycleDays"] = this.cycleDays;
        data["isChecked"] = this.isChecked;
        data["farrowingTaskTreatmentColumn1"] = this.farrowingTaskTreatmentColumn1 ? this.farrowingTaskTreatmentColumn1.toJSON() : <any>undefined;
        data["farrowingTaskTreatmentColumn2"] = this.farrowingTaskTreatmentColumn2 ? this.farrowingTaskTreatmentColumn2.toJSON() : <any>undefined;
        data["farrowingTaskTreatmentColumn3"] = this.farrowingTaskTreatmentColumn3 ? this.farrowingTaskTreatmentColumn3.toJSON() : <any>undefined;
        data["farrowingTaskTreatmentColumn4"] = this.farrowingTaskTreatmentColumn4 ? this.farrowingTaskTreatmentColumn4.toJSON() : <any>undefined;
        data["cellColorStyle"] = this.cellColorStyle;
        return data;
    }
}

export interface ITasksInFarrowingStableItemPdf {
    animalNumber?: string | undefined;
    cycleDays?: string | undefined;
    isChecked: boolean;
    farrowingTaskTreatmentColumn1?: FarrowingTaskTreatmentColumn | undefined;
    farrowingTaskTreatmentColumn2?: FarrowingTaskTreatmentColumn | undefined;
    farrowingTaskTreatmentColumn3?: FarrowingTaskTreatmentColumn | undefined;
    farrowingTaskTreatmentColumn4?: FarrowingTaskTreatmentColumn | undefined;
    cellColorStyle: CellColorStyle;
}

export class FarrowingTaskTreatmentColumn implements IFarrowingTaskTreatmentColumn {
    pcs?: string | undefined;
    amount?: string | undefined;

    constructor(data?: IFarrowingTaskTreatmentColumn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pcs = _data["pcs"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): FarrowingTaskTreatmentColumn {
        data = typeof data === 'object' ? data : {};
        let result = new FarrowingTaskTreatmentColumn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pcs"] = this.pcs;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IFarrowingTaskTreatmentColumn {
    pcs?: string | undefined;
    amount?: string | undefined;
}

export class VaccineWorkListPdfData implements IVaccineWorkListPdfData {
    vaccineSubColumnHeaders?: VaccineSubColumnHeader[] | undefined;
    vaccineWorkListTableItems?: VaccineWorkListTableItem[] | undefined;
    showBuilding!: boolean;
    showPen!: boolean;
    showLocation!: boolean;

    constructor(data?: IVaccineWorkListPdfData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["vaccineSubColumnHeaders"])) {
                this.vaccineSubColumnHeaders = [] as any;
                for (let item of _data["vaccineSubColumnHeaders"])
                    this.vaccineSubColumnHeaders!.push(VaccineSubColumnHeader.fromJS(item));
            }
            if (Array.isArray(_data["vaccineWorkListTableItems"])) {
                this.vaccineWorkListTableItems = [] as any;
                for (let item of _data["vaccineWorkListTableItems"])
                    this.vaccineWorkListTableItems!.push(VaccineWorkListTableItem.fromJS(item));
            }
            this.showBuilding = _data["showBuilding"];
            this.showPen = _data["showPen"];
            this.showLocation = _data["showLocation"];
        }
    }

    static fromJS(data: any): VaccineWorkListPdfData {
        data = typeof data === 'object' ? data : {};
        let result = new VaccineWorkListPdfData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.vaccineSubColumnHeaders)) {
            data["vaccineSubColumnHeaders"] = [];
            for (let item of this.vaccineSubColumnHeaders)
                data["vaccineSubColumnHeaders"].push(item.toJSON());
        }
        if (Array.isArray(this.vaccineWorkListTableItems)) {
            data["vaccineWorkListTableItems"] = [];
            for (let item of this.vaccineWorkListTableItems)
                data["vaccineWorkListTableItems"].push(item.toJSON());
        }
        data["showBuilding"] = this.showBuilding;
        data["showPen"] = this.showPen;
        data["showLocation"] = this.showLocation;
        return data;
    }
}

export interface IVaccineWorkListPdfData {
    vaccineSubColumnHeaders?: VaccineSubColumnHeader[] | undefined;
    vaccineWorkListTableItems?: VaccineWorkListTableItem[] | undefined;
    showBuilding: boolean;
    showPen: boolean;
    showLocation: boolean;
}

export class VaccineSubColumnHeader implements IVaccineSubColumnHeader {
    name?: string | undefined;
    subTaskNumber!: number;

    constructor(data?: IVaccineSubColumnHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.subTaskNumber = _data["subTaskNumber"];
        }
    }

    static fromJS(data: any): VaccineSubColumnHeader {
        data = typeof data === 'object' ? data : {};
        let result = new VaccineSubColumnHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["subTaskNumber"] = this.subTaskNumber;
        return data;
    }
}

export interface IVaccineSubColumnHeader {
    name?: string | undefined;
    subTaskNumber: number;
}

export class VaccineWorkListTableItem implements IVaccineWorkListTableItem {
    cycleDays?: string | undefined;
    animalNumber?: string | undefined;
    litterNumber?: string | undefined;
    batch?: string | undefined;
    buildingString?: string | undefined;
    sectionString?: string | undefined;
    penString?: string | undefined;
    vaccineSubColumns?: VaccineSubColumn[] | undefined;
    cellColorStyle!: CellColorStyle;

    constructor(data?: IVaccineWorkListTableItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cycleDays = _data["cycleDays"];
            this.animalNumber = _data["animalNumber"];
            this.litterNumber = _data["litterNumber"];
            this.batch = _data["batch"];
            this.buildingString = _data["buildingString"];
            this.sectionString = _data["sectionString"];
            this.penString = _data["penString"];
            if (Array.isArray(_data["vaccineSubColumns"])) {
                this.vaccineSubColumns = [] as any;
                for (let item of _data["vaccineSubColumns"])
                    this.vaccineSubColumns!.push(VaccineSubColumn.fromJS(item));
            }
            this.cellColorStyle = _data["cellColorStyle"];
        }
    }

    static fromJS(data: any): VaccineWorkListTableItem {
        data = typeof data === 'object' ? data : {};
        let result = new VaccineWorkListTableItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cycleDays"] = this.cycleDays;
        data["animalNumber"] = this.animalNumber;
        data["litterNumber"] = this.litterNumber;
        data["batch"] = this.batch;
        data["buildingString"] = this.buildingString;
        data["sectionString"] = this.sectionString;
        data["penString"] = this.penString;
        if (Array.isArray(this.vaccineSubColumns)) {
            data["vaccineSubColumns"] = [];
            for (let item of this.vaccineSubColumns)
                data["vaccineSubColumns"].push(item.toJSON());
        }
        data["cellColorStyle"] = this.cellColorStyle;
        return data;
    }
}

export interface IVaccineWorkListTableItem {
    cycleDays?: string | undefined;
    animalNumber?: string | undefined;
    litterNumber?: string | undefined;
    batch?: string | undefined;
    buildingString?: string | undefined;
    sectionString?: string | undefined;
    penString?: string | undefined;
    vaccineSubColumns?: VaccineSubColumn[] | undefined;
    cellColorStyle: CellColorStyle;
}

export class VaccineSubColumn implements IVaccineSubColumn {
    weekNumber?: string | undefined;
    subTaskNumber!: number;

    constructor(data?: IVaccineSubColumn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.weekNumber = _data["weekNumber"];
            this.subTaskNumber = _data["subTaskNumber"];
        }
    }

    static fromJS(data: any): VaccineSubColumn {
        data = typeof data === 'object' ? data : {};
        let result = new VaccineSubColumn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weekNumber"] = this.weekNumber;
        data["subTaskNumber"] = this.subTaskNumber;
        return data;
    }
}

export interface IVaccineSubColumn {
    weekNumber?: string | undefined;
    subTaskNumber: number;
}

export class ScanningWorkListPdfData implements IScanningWorkListPdfData {
    scanningSubColumnHeaders?: ScanningSubColumnHeader[] | undefined;
    scanningWorkListTableItems?: ScanningWorkListTableItem[] | undefined;
    showBuilding!: boolean;
    showPen!: boolean;
    showLocation!: boolean;

    constructor(data?: IScanningWorkListPdfData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["scanningSubColumnHeaders"])) {
                this.scanningSubColumnHeaders = [] as any;
                for (let item of _data["scanningSubColumnHeaders"])
                    this.scanningSubColumnHeaders!.push(ScanningSubColumnHeader.fromJS(item));
            }
            if (Array.isArray(_data["scanningWorkListTableItems"])) {
                this.scanningWorkListTableItems = [] as any;
                for (let item of _data["scanningWorkListTableItems"])
                    this.scanningWorkListTableItems!.push(ScanningWorkListTableItem.fromJS(item));
            }
            this.showBuilding = _data["showBuilding"];
            this.showPen = _data["showPen"];
            this.showLocation = _data["showLocation"];
        }
    }

    static fromJS(data: any): ScanningWorkListPdfData {
        data = typeof data === 'object' ? data : {};
        let result = new ScanningWorkListPdfData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.scanningSubColumnHeaders)) {
            data["scanningSubColumnHeaders"] = [];
            for (let item of this.scanningSubColumnHeaders)
                data["scanningSubColumnHeaders"].push(item.toJSON());
        }
        if (Array.isArray(this.scanningWorkListTableItems)) {
            data["scanningWorkListTableItems"] = [];
            for (let item of this.scanningWorkListTableItems)
                data["scanningWorkListTableItems"].push(item.toJSON());
        }
        data["showBuilding"] = this.showBuilding;
        data["showPen"] = this.showPen;
        data["showLocation"] = this.showLocation;
        return data;
    }
}

export interface IScanningWorkListPdfData {
    scanningSubColumnHeaders?: ScanningSubColumnHeader[] | undefined;
    scanningWorkListTableItems?: ScanningWorkListTableItem[] | undefined;
    showBuilding: boolean;
    showPen: boolean;
    showLocation: boolean;
}

export class ScanningSubColumnHeader implements IScanningSubColumnHeader {
    name?: string | undefined;
    subTaskNumber!: number;

    constructor(data?: IScanningSubColumnHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.subTaskNumber = _data["subTaskNumber"];
        }
    }

    static fromJS(data: any): ScanningSubColumnHeader {
        data = typeof data === 'object' ? data : {};
        let result = new ScanningSubColumnHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["subTaskNumber"] = this.subTaskNumber;
        return data;
    }
}

export interface IScanningSubColumnHeader {
    name?: string | undefined;
    subTaskNumber: number;
}

export class ScanningWorkListTableItem implements IScanningWorkListTableItem {
    cycleDays?: string | undefined;
    animalNumber?: string | undefined;
    litterNumber?: string | undefined;
    batch?: string | undefined;
    buildingString?: string | undefined;
    sectionString?: string | undefined;
    penString?: string | undefined;
    scanningSubColumns?: ScanningSubColumn[] | undefined;
    cellColorStyle!: CellColorStyle;

    constructor(data?: IScanningWorkListTableItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cycleDays = _data["cycleDays"];
            this.animalNumber = _data["animalNumber"];
            this.litterNumber = _data["litterNumber"];
            this.batch = _data["batch"];
            this.buildingString = _data["buildingString"];
            this.sectionString = _data["sectionString"];
            this.penString = _data["penString"];
            if (Array.isArray(_data["scanningSubColumns"])) {
                this.scanningSubColumns = [] as any;
                for (let item of _data["scanningSubColumns"])
                    this.scanningSubColumns!.push(ScanningSubColumn.fromJS(item));
            }
            this.cellColorStyle = _data["cellColorStyle"];
        }
    }

    static fromJS(data: any): ScanningWorkListTableItem {
        data = typeof data === 'object' ? data : {};
        let result = new ScanningWorkListTableItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cycleDays"] = this.cycleDays;
        data["animalNumber"] = this.animalNumber;
        data["litterNumber"] = this.litterNumber;
        data["batch"] = this.batch;
        data["buildingString"] = this.buildingString;
        data["sectionString"] = this.sectionString;
        data["penString"] = this.penString;
        if (Array.isArray(this.scanningSubColumns)) {
            data["scanningSubColumns"] = [];
            for (let item of this.scanningSubColumns)
                data["scanningSubColumns"].push(item.toJSON());
        }
        data["cellColorStyle"] = this.cellColorStyle;
        return data;
    }
}

export interface IScanningWorkListTableItem {
    cycleDays?: string | undefined;
    animalNumber?: string | undefined;
    litterNumber?: string | undefined;
    batch?: string | undefined;
    buildingString?: string | undefined;
    sectionString?: string | undefined;
    penString?: string | undefined;
    scanningSubColumns?: ScanningSubColumn[] | undefined;
    cellColorStyle: CellColorStyle;
}

export class ScanningSubColumn implements IScanningSubColumn {
    weekNumber?: string | undefined;
    scanResult?: string | undefined;
    subTaskNumber!: number;

    constructor(data?: IScanningSubColumn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.weekNumber = _data["weekNumber"];
            this.scanResult = _data["scanResult"];
            this.subTaskNumber = _data["subTaskNumber"];
        }
    }

    static fromJS(data: any): ScanningSubColumn {
        data = typeof data === 'object' ? data : {};
        let result = new ScanningSubColumn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weekNumber"] = this.weekNumber;
        data["scanResult"] = this.scanResult;
        data["subTaskNumber"] = this.subTaskNumber;
        return data;
    }
}

export interface IScanningSubColumn {
    weekNumber?: string | undefined;
    scanResult?: string | undefined;
    subTaskNumber: number;
}

export class DepartureWorkListTableItem implements IDepartureWorkListTableItem {
    animalNumber?: string | undefined;
    butcherQuarantine?: string | undefined;
    location?: string | undefined;
    pen?: string | undefined;
    departureDate?: string | undefined;
    departureType?: string | undefined;
    selectedDepartureReason?: string | undefined;
    departureReason?: string | undefined;
    price?: string | undefined;
    isChecked!: boolean;
    cellColorStyle!: CellColorStyle;

    constructor(data?: IDepartureWorkListTableItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.animalNumber = _data["animalNumber"];
            this.butcherQuarantine = _data["butcherQuarantine"];
            this.location = _data["location"];
            this.pen = _data["pen"];
            this.departureDate = _data["departureDate"];
            this.departureType = _data["departureType"];
            this.selectedDepartureReason = _data["selectedDepartureReason"];
            this.departureReason = _data["departureReason"];
            this.price = _data["price"];
            this.isChecked = _data["isChecked"];
            this.cellColorStyle = _data["cellColorStyle"];
        }
    }

    static fromJS(data: any): DepartureWorkListTableItem {
        data = typeof data === 'object' ? data : {};
        let result = new DepartureWorkListTableItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["animalNumber"] = this.animalNumber;
        data["butcherQuarantine"] = this.butcherQuarantine;
        data["location"] = this.location;
        data["pen"] = this.pen;
        data["departureDate"] = this.departureDate;
        data["departureType"] = this.departureType;
        data["selectedDepartureReason"] = this.selectedDepartureReason;
        data["departureReason"] = this.departureReason;
        data["price"] = this.price;
        data["isChecked"] = this.isChecked;
        data["cellColorStyle"] = this.cellColorStyle;
        return data;
    }
}

export interface IDepartureWorkListTableItem {
    animalNumber?: string | undefined;
    butcherQuarantine?: string | undefined;
    location?: string | undefined;
    pen?: string | undefined;
    departureDate?: string | undefined;
    departureType?: string | undefined;
    selectedDepartureReason?: string | undefined;
    departureReason?: string | undefined;
    price?: string | undefined;
    isChecked: boolean;
    cellColorStyle: CellColorStyle;
}

export class DistriwinAllAnimalsWorkListTableItem implements IDistriwinAllAnimalsWorkListTableItem {
    animalNumber?: string | undefined;
    animalKind?: string | undefined;
    condition?: string | undefined;
    days!: number;
    section?: string | undefined;
    pen?: string | undefined;
    penId?: string | undefined;
    cellColorStyle!: CellColorStyle;

    constructor(data?: IDistriwinAllAnimalsWorkListTableItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.animalNumber = _data["animalNumber"];
            this.animalKind = _data["animalKind"];
            this.condition = _data["condition"];
            this.days = _data["days"];
            this.section = _data["section"];
            this.pen = _data["pen"];
            this.penId = _data["penId"];
            this.cellColorStyle = _data["cellColorStyle"];
        }
    }

    static fromJS(data: any): DistriwinAllAnimalsWorkListTableItem {
        data = typeof data === 'object' ? data : {};
        let result = new DistriwinAllAnimalsWorkListTableItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["animalNumber"] = this.animalNumber;
        data["animalKind"] = this.animalKind;
        data["condition"] = this.condition;
        data["days"] = this.days;
        data["section"] = this.section;
        data["pen"] = this.pen;
        data["penId"] = this.penId;
        data["cellColorStyle"] = this.cellColorStyle;
        return data;
    }
}

export interface IDistriwinAllAnimalsWorkListTableItem {
    animalNumber?: string | undefined;
    animalKind?: string | undefined;
    condition?: string | undefined;
    days: number;
    section?: string | undefined;
    pen?: string | undefined;
    penId?: string | undefined;
    cellColorStyle: CellColorStyle;
}

export class BasicMoveListTableItem implements IBasicMoveListTableItem {
    stemAnimalId?: string | undefined;
    animalNumber?: string | undefined;
    idNumber?: string | undefined;
    moveDate!: Date;
    fromSection?: string | undefined;
    fromSectionId?: string | undefined;
    fromPen?: string | undefined;
    fromPenId?: string | undefined;
    toSection?: string | undefined;
    toSectionId?: string | undefined;
    toPen?: string | undefined;
    toPenId?: string | undefined;
    cellColorStyle!: CellColorStyle;

    constructor(data?: IBasicMoveListTableItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stemAnimalId = _data["stemAnimalId"];
            this.animalNumber = _data["animalNumber"];
            this.idNumber = _data["idNumber"];
            this.moveDate = _data["moveDate"] ? new Date(_data["moveDate"].toString()) : <any>undefined;
            this.fromSection = _data["fromSection"];
            this.fromSectionId = _data["fromSectionId"];
            this.fromPen = _data["fromPen"];
            this.fromPenId = _data["fromPenId"];
            this.toSection = _data["toSection"];
            this.toSectionId = _data["toSectionId"];
            this.toPen = _data["toPen"];
            this.toPenId = _data["toPenId"];
            this.cellColorStyle = _data["cellColorStyle"];
        }
    }

    static fromJS(data: any): BasicMoveListTableItem {
        data = typeof data === 'object' ? data : {};
        let result = new BasicMoveListTableItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stemAnimalId"] = this.stemAnimalId;
        data["animalNumber"] = this.animalNumber;
        data["idNumber"] = this.idNumber;
        data["moveDate"] = this.moveDate ? this.moveDate.toISOString() : <any>undefined;
        data["fromSection"] = this.fromSection;
        data["fromSectionId"] = this.fromSectionId;
        data["fromPen"] = this.fromPen;
        data["fromPenId"] = this.fromPenId;
        data["toSection"] = this.toSection;
        data["toSectionId"] = this.toSectionId;
        data["toPen"] = this.toPen;
        data["toPenId"] = this.toPenId;
        data["cellColorStyle"] = this.cellColorStyle;
        return data;
    }
}

export interface IBasicMoveListTableItem {
    stemAnimalId?: string | undefined;
    animalNumber?: string | undefined;
    idNumber?: string | undefined;
    moveDate: Date;
    fromSection?: string | undefined;
    fromSectionId?: string | undefined;
    fromPen?: string | undefined;
    fromPenId?: string | undefined;
    toSection?: string | undefined;
    toSectionId?: string | undefined;
    toPen?: string | undefined;
    toPenId?: string | undefined;
    cellColorStyle: CellColorStyle;
}

export class NucleusManagementArchiveFile extends SiteEntity implements INucleusManagementArchiveFile {
    fileName?: string | undefined;
    fileContents?: string | undefined;
    sentTime!: Date;
    connectionId?: string | undefined;

    constructor(data?: INucleusManagementArchiveFile) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileContents = _data["fileContents"];
            this.sentTime = _data["sentTime"] ? new Date(_data["sentTime"].toString()) : <any>undefined;
            this.connectionId = _data["connectionId"];
        }
    }

    static override fromJS(data: any): NucleusManagementArchiveFile {
        data = typeof data === 'object' ? data : {};
        let result = new NucleusManagementArchiveFile();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileContents"] = this.fileContents;
        data["sentTime"] = this.sentTime ? this.sentTime.toISOString() : <any>undefined;
        data["connectionId"] = this.connectionId;
        super.toJSON(data);
        return data;
    }
}

export interface INucleusManagementArchiveFile extends ISiteEntity {
    fileName?: string | undefined;
    fileContents?: string | undefined;
    sentTime: Date;
    connectionId?: string | undefined;
}

export class NucleusManagementConnection extends SiteEntity implements INucleusManagementConnection {
    username?: string | undefined;
    password?: string | undefined;
    provider!: NucleusManagementProvider;
    sendSetup?: NucleusManagementSendSetup | undefined;
    fetchSetup?: NucleusManagementFetchSetup | undefined;

    constructor(data?: INucleusManagementConnection) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
            this.provider = _data["provider"];
            this.sendSetup = _data["sendSetup"] ? NucleusManagementSendSetup.fromJS(_data["sendSetup"]) : <any>undefined;
            this.fetchSetup = _data["fetchSetup"] ? NucleusManagementFetchSetup.fromJS(_data["fetchSetup"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): NucleusManagementConnection {
        data = typeof data === 'object' ? data : {};
        let result = new NucleusManagementConnection();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        data["provider"] = this.provider;
        data["sendSetup"] = this.sendSetup ? this.sendSetup.toJSON() : <any>undefined;
        data["fetchSetup"] = this.fetchSetup ? this.fetchSetup.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface INucleusManagementConnection extends ISiteEntity {
    username?: string | undefined;
    password?: string | undefined;
    provider: NucleusManagementProvider;
    sendSetup?: NucleusManagementSendSetup | undefined;
    fetchSetup?: NucleusManagementFetchSetup | undefined;
}

export enum NucleusManagementProvider {
    DanBred = "DanBred",
    DanishGenetics = "DanishGenetics",
    SelfManaged = "SelfManaged",
}

export class NucleusManagementSetupBase implements INucleusManagementSetupBase {
    frequency!: NucleusManagementFrequency;
    dayOfWeek?: DayOfWeek | undefined;
    timeOfDay!: Date;

    constructor(data?: INucleusManagementSetupBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.frequency = _data["frequency"];
            this.dayOfWeek = _data["dayOfWeek"];
            this.timeOfDay = _data["timeOfDay"] ? new Date(_data["timeOfDay"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): NucleusManagementSetupBase {
        data = typeof data === 'object' ? data : {};
        let result = new NucleusManagementSetupBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["frequency"] = this.frequency;
        data["dayOfWeek"] = this.dayOfWeek;
        data["timeOfDay"] = this.timeOfDay ? this.timeOfDay.toISOString() : <any>undefined;
        return data;
    }
}

export interface INucleusManagementSetupBase {
    frequency: NucleusManagementFrequency;
    dayOfWeek?: DayOfWeek | undefined;
    timeOfDay: Date;
}

export class NucleusManagementSendSetup extends NucleusManagementSetupBase implements INucleusManagementSendSetup {
    emailAddress1?: string | undefined;
    emailAddress2?: string | undefined;

    constructor(data?: INucleusManagementSendSetup) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.emailAddress1 = _data["emailAddress1"];
            this.emailAddress2 = _data["emailAddress2"];
        }
    }

    static override fromJS(data: any): NucleusManagementSendSetup {
        data = typeof data === 'object' ? data : {};
        let result = new NucleusManagementSendSetup();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress1"] = this.emailAddress1;
        data["emailAddress2"] = this.emailAddress2;
        super.toJSON(data);
        return data;
    }
}

export interface INucleusManagementSendSetup extends INucleusManagementSetupBase {
    emailAddress1?: string | undefined;
    emailAddress2?: string | undefined;
}

export enum NucleusManagementFrequency {
    Daily = "Daily",
    Weekly = "Weekly",
    Monthly = "Monthly",
    Manual = "Manual",
}

export class NucleusManagementFetchSetup extends NucleusManagementSetupBase implements INucleusManagementFetchSetup {
    updateIndexes!: boolean;
    herdsToInclude?: string | undefined;

    constructor(data?: INucleusManagementFetchSetup) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.updateIndexes = _data["updateIndexes"];
            this.herdsToInclude = _data["herdsToInclude"];
        }
    }

    static override fromJS(data: any): NucleusManagementFetchSetup {
        data = typeof data === 'object' ? data : {};
        let result = new NucleusManagementFetchSetup();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updateIndexes"] = this.updateIndexes;
        data["herdsToInclude"] = this.herdsToInclude;
        super.toJSON(data);
        return data;
    }
}

export interface INucleusManagementFetchSetup extends INucleusManagementSetupBase {
    updateIndexes: boolean;
    herdsToInclude?: string | undefined;
}

export class NucleusManagementConnectionCreationDTO implements INucleusManagementConnectionCreationDTO {
    siteId?: string | undefined;
    username?: string | undefined;
    password?: string | undefined;
    provider!: NucleusManagementProvider;

    constructor(data?: INucleusManagementConnectionCreationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.siteId = _data["siteId"];
            this.username = _data["username"];
            this.password = _data["password"];
            this.provider = _data["provider"];
        }
    }

    static fromJS(data: any): NucleusManagementConnectionCreationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new NucleusManagementConnectionCreationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siteId"] = this.siteId;
        data["username"] = this.username;
        data["password"] = this.password;
        data["provider"] = this.provider;
        return data;
    }
}

export interface INucleusManagementConnectionCreationDTO {
    siteId?: string | undefined;
    username?: string | undefined;
    password?: string | undefined;
    provider: NucleusManagementProvider;
}

export class NucleusManagementConnectionUpdateDTO implements INucleusManagementConnectionUpdateDTO {
    connectionId?: string | undefined;
    username?: string | undefined;
    password?: string | undefined;

    constructor(data?: INucleusManagementConnectionUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.connectionId = _data["connectionId"];
            this.username = _data["username"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): NucleusManagementConnectionUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new NucleusManagementConnectionUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectionId"] = this.connectionId;
        data["username"] = this.username;
        data["password"] = this.password;
        return data;
    }
}

export interface INucleusManagementConnectionUpdateDTO {
    connectionId?: string | undefined;
    username?: string | undefined;
    password?: string | undefined;
}

export class Exception implements IException {
    message!: string;
    innerException?: Exception | undefined;
    source?: string | undefined;
    stackTrace?: string | undefined;

    constructor(data?: IException) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["Message"];
            this.innerException = _data["InnerException"] ? Exception.fromJS(_data["InnerException"]) : <any>undefined;
            this.source = _data["Source"];
            this.stackTrace = _data["StackTrace"];
        }
    }

    static fromJS(data: any): Exception {
        data = typeof data === 'object' ? data : {};
        let result = new Exception();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Message"] = this.message;
        data["InnerException"] = this.innerException ? this.innerException.toJSON() : <any>undefined;
        data["Source"] = this.source;
        data["StackTrace"] = this.stackTrace;
        return data;
    }
}

export interface IException {
    message: string;
    innerException?: Exception | undefined;
    source?: string | undefined;
    stackTrace?: string | undefined;
}

export class LocationHierarchyDto implements ILocationHierarchyDto {
    cloudToDeviceMessageId?: string | undefined;
    enterprise?: LocationHieracyItem | undefined;
    country?: LocationHieracyItem | undefined;
    sites?: SiteDto[] | undefined;
    options?: LocationsHierarchyOptionsDto | undefined;

    constructor(data?: ILocationHierarchyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cloudToDeviceMessageId = _data["cloudToDeviceMessageId"];
            this.enterprise = _data["enterprise"] ? LocationHieracyItem.fromJS(_data["enterprise"]) : <any>undefined;
            this.country = _data["country"] ? LocationHieracyItem.fromJS(_data["country"]) : <any>undefined;
            if (Array.isArray(_data["sites"])) {
                this.sites = [] as any;
                for (let item of _data["sites"])
                    this.sites!.push(SiteDto.fromJS(item));
            }
            this.options = _data["options"] ? LocationsHierarchyOptionsDto.fromJS(_data["options"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LocationHierarchyDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationHierarchyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cloudToDeviceMessageId"] = this.cloudToDeviceMessageId;
        data["enterprise"] = this.enterprise ? this.enterprise.toJSON() : <any>undefined;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        if (Array.isArray(this.sites)) {
            data["sites"] = [];
            for (let item of this.sites)
                data["sites"].push(item.toJSON());
        }
        data["options"] = this.options ? this.options.toJSON() : <any>undefined;
        return data;
    }
}

export interface ILocationHierarchyDto {
    cloudToDeviceMessageId?: string | undefined;
    enterprise?: LocationHieracyItem | undefined;
    country?: LocationHieracyItem | undefined;
    sites?: SiteDto[] | undefined;
    options?: LocationsHierarchyOptionsDto | undefined;
}

export class LocationHieracyItem implements ILocationHieracyItem {
    code?: string | undefined;
    name?: string | undefined;

    constructor(data?: ILocationHieracyItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): LocationHieracyItem {
        data = typeof data === 'object' ? data : {};
        let result = new LocationHieracyItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }
}

export interface ILocationHieracyItem {
    code?: string | undefined;
    name?: string | undefined;
}

export class SiteDto extends LocationHieracyItem implements ISiteDto {
    buildings?: BuildingDto[] | undefined;

    constructor(data?: ISiteDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["buildings"])) {
                this.buildings = [] as any;
                for (let item of _data["buildings"])
                    this.buildings!.push(BuildingDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): SiteDto {
        data = typeof data === 'object' ? data : {};
        let result = new SiteDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.buildings)) {
            data["buildings"] = [];
            for (let item of this.buildings)
                data["buildings"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISiteDto extends ILocationHieracyItem {
    buildings?: BuildingDto[] | undefined;
}

export class BuildingDto extends LocationHieracyItem implements IBuildingDto {
    sections?: SectionDto[] | undefined;

    constructor(data?: IBuildingDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["sections"])) {
                this.sections = [] as any;
                for (let item of _data["sections"])
                    this.sections!.push(SectionDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): BuildingDto {
        data = typeof data === 'object' ? data : {};
        let result = new BuildingDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sections)) {
            data["sections"] = [];
            for (let item of this.sections)
                data["sections"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IBuildingDto extends ILocationHieracyItem {
    sections?: SectionDto[] | undefined;
}

export class SectionDto extends LocationHieracyItem implements ISectionDto {
    pens?: PenDto[] | undefined;

    constructor(data?: ISectionDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["pens"])) {
                this.pens = [] as any;
                for (let item of _data["pens"])
                    this.pens!.push(PenDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): SectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SectionDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pens)) {
            data["pens"] = [];
            for (let item of this.pens)
                data["pens"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISectionDto extends ILocationHieracyItem {
    pens?: PenDto[] | undefined;
}

export class PenDto extends LocationHieracyItem implements IPenDto {
    valves?: LocationHieracyItem[] | undefined;

    constructor(data?: IPenDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["valves"])) {
                this.valves = [] as any;
                for (let item of _data["valves"])
                    this.valves!.push(LocationHieracyItem.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): PenDto {
        data = typeof data === 'object' ? data : {};
        let result = new PenDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.valves)) {
            data["valves"] = [];
            for (let item of this.valves)
                data["valves"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPenDto extends ILocationHieracyItem {
    valves?: LocationHieracyItem[] | undefined;
}

export class LocationsHierarchyOptionsDto implements ILocationsHierarchyOptionsDto {
    mode!: LocationsHierarchyMode;

    constructor(data?: ILocationsHierarchyOptionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mode = _data["mode"];
        }
    }

    static fromJS(data: any): LocationsHierarchyOptionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationsHierarchyOptionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mode"] = this.mode;
        return data;
    }
}

export interface ILocationsHierarchyOptionsDto {
    mode: LocationsHierarchyMode;
}

export enum LocationsHierarchyMode {
    StopIfSiteExists = "StopIfSiteExists",
    AppendIfSiteExists = "AppendIfSiteExists",
    OverwriteIfSiteExists = "OverwriteIfSiteExists",
}

export class SiteMonitoringReport implements ISiteMonitoringReport {
    siteId?: string | undefined;
    siteName?: string | undefined;
    siteLocationCode?: string | undefined;
    lastMessageTimestamp?: Date | undefined;

    constructor(data?: ISiteMonitoringReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.siteId = _data["siteId"];
            this.siteName = _data["siteName"];
            this.siteLocationCode = _data["siteLocationCode"];
            this.lastMessageTimestamp = _data["lastMessageTimestamp"] ? new Date(_data["lastMessageTimestamp"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SiteMonitoringReport {
        data = typeof data === 'object' ? data : {};
        let result = new SiteMonitoringReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siteId"] = this.siteId;
        data["siteName"] = this.siteName;
        data["siteLocationCode"] = this.siteLocationCode;
        data["lastMessageTimestamp"] = this.lastMessageTimestamp ? this.lastMessageTimestamp.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISiteMonitoringReport {
    siteId?: string | undefined;
    siteName?: string | undefined;
    siteLocationCode?: string | undefined;
    lastMessageTimestamp?: Date | undefined;
}

export class NotificationDto implements INotificationDto {
    id?: string | undefined;
    locationCode?: string | undefined;
    active!: boolean;
    activeAtDateTime!: Date;
    inActiveAtDateTime?: Date | undefined;
    notificationDefinitionId?: string | undefined;
    sourceSystem!: SourceSystem;

    constructor(data?: INotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.locationCode = _data["locationCode"];
            this.active = _data["active"];
            this.activeAtDateTime = _data["activeAtDateTime"] ? new Date(_data["activeAtDateTime"].toString()) : <any>undefined;
            this.inActiveAtDateTime = _data["inActiveAtDateTime"] ? new Date(_data["inActiveAtDateTime"].toString()) : <any>undefined;
            this.notificationDefinitionId = _data["notificationDefinitionId"];
            this.sourceSystem = _data["sourceSystem"];
        }
    }

    static fromJS(data: any): NotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["locationCode"] = this.locationCode;
        data["active"] = this.active;
        data["activeAtDateTime"] = this.activeAtDateTime ? this.activeAtDateTime.toISOString() : <any>undefined;
        data["inActiveAtDateTime"] = this.inActiveAtDateTime ? this.inActiveAtDateTime.toISOString() : <any>undefined;
        data["notificationDefinitionId"] = this.notificationDefinitionId;
        data["sourceSystem"] = this.sourceSystem;
        return data;
    }
}

export interface INotificationDto {
    id?: string | undefined;
    locationCode?: string | undefined;
    active: boolean;
    activeAtDateTime: Date;
    inActiveAtDateTime?: Date | undefined;
    notificationDefinitionId?: string | undefined;
    sourceSystem: SourceSystem;
}

export class NotificationDefinition extends Unique implements INotificationDefinition {
    notificationType!: NotificationType;
    sourceSystem!: SourceSystem;
    descriptions?: NotificationDefinitionDescription[] | undefined;
    definitionId?: string | undefined;

    constructor(data?: INotificationDefinition) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.notificationType = _data["notificationType"];
            this.sourceSystem = _data["sourceSystem"];
            if (Array.isArray(_data["descriptions"])) {
                this.descriptions = [] as any;
                for (let item of _data["descriptions"])
                    this.descriptions!.push(NotificationDefinitionDescription.fromJS(item));
            }
            this.definitionId = _data["definitionId"];
        }
    }

    static override fromJS(data: any): NotificationDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationDefinition();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notificationType"] = this.notificationType;
        data["sourceSystem"] = this.sourceSystem;
        if (Array.isArray(this.descriptions)) {
            data["descriptions"] = [];
            for (let item of this.descriptions)
                data["descriptions"].push(item.toJSON());
        }
        data["definitionId"] = this.definitionId;
        super.toJSON(data);
        return data;
    }
}

export interface INotificationDefinition extends IUnique {
    notificationType: NotificationType;
    sourceSystem: SourceSystem;
    descriptions?: NotificationDefinitionDescription[] | undefined;
    definitionId?: string | undefined;
}

export class NotificationDefinitionDescription implements INotificationDefinitionDescription {
    language?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    remedyDescription?: string | undefined;

    constructor(data?: INotificationDefinitionDescription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.remedyDescription = _data["remedyDescription"];
        }
    }

    static fromJS(data: any): NotificationDefinitionDescription {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationDefinitionDescription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language;
        data["title"] = this.title;
        data["description"] = this.description;
        data["remedyDescription"] = this.remedyDescription;
        return data;
    }
}

export interface INotificationDefinitionDescription {
    language?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    remedyDescription?: string | undefined;
}

export class PushNotification implements IPushNotification {
    fcmToken?: string | undefined;
    message?: string | undefined;
    title?: string | undefined;

    constructor(data?: IPushNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fcmToken = _data["fcmToken"];
            this.message = _data["message"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): PushNotification {
        data = typeof data === 'object' ? data : {};
        let result = new PushNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fcmToken"] = this.fcmToken;
        data["message"] = this.message;
        data["title"] = this.title;
        return data;
    }
}

export interface IPushNotification {
    fcmToken?: string | undefined;
    message?: string | undefined;
    title?: string | undefined;
}

export class UserProfileCreationRequest implements IUserProfileCreationRequest {
    adUserId?: string | undefined;
    userName?: string | undefined;
    siteId?: string | undefined;
    language?: string | undefined;

    constructor(data?: IUserProfileCreationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adUserId = _data["adUserId"];
            this.userName = _data["userName"];
            this.siteId = _data["siteId"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): UserProfileCreationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfileCreationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adUserId"] = this.adUserId;
        data["userName"] = this.userName;
        data["siteId"] = this.siteId;
        data["language"] = this.language;
        return data;
    }
}

export interface IUserProfileCreationRequest {
    adUserId?: string | undefined;
    userName?: string | undefined;
    siteId?: string | undefined;
    language?: string | undefined;
}

export class SegesInsightModel implements ISegesInsightModel {
    farm_ID?: string | undefined;
    farm_Name?: string | undefined;
    farm_CHR!: number;
    sows?: SegesInsightSowModel[] | undefined;

    constructor(data?: ISegesInsightModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.farm_ID = _data["farm_ID"];
            this.farm_Name = _data["farm_Name"];
            this.farm_CHR = _data["farm_CHR"];
            if (Array.isArray(_data["sows"])) {
                this.sows = [] as any;
                for (let item of _data["sows"])
                    this.sows!.push(SegesInsightSowModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SegesInsightModel {
        data = typeof data === 'object' ? data : {};
        let result = new SegesInsightModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["farm_ID"] = this.farm_ID;
        data["farm_Name"] = this.farm_Name;
        data["farm_CHR"] = this.farm_CHR;
        if (Array.isArray(this.sows)) {
            data["sows"] = [];
            for (let item of this.sows)
                data["sows"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISegesInsightModel {
    farm_ID?: string | undefined;
    farm_Name?: string | undefined;
    farm_CHR: number;
    sows?: SegesInsightSowModel[] | undefined;
}

export class SegesInsightSowModel implements ISegesInsightSowModel {
    sow_ID?: string | undefined;
    sow_Name?: string | undefined;
    birthdate?: Date | undefined;
    firstMating?: Date | undefined;
    deathDate?: Date | undefined;
    isDeleted!: boolean;
    deathType?: string | undefined;
    deathReason?: string | undefined;
    matings?: SegesInsightMatingModel[] | undefined;
    farrowings?: SegesInsightFarrowingModel[] | undefined;
    deadPiglets?: SegesInsightDeadPigletsModel[] | undefined;
    nursingWeanings?: SegesInsightNursingWeaingModel[] | undefined;
    weanings?: SegesInsightWeaningModel[] | undefined;
    lardScannings?: SegesInsightLardScanningModel[] | undefined;
    deletedMatings?: SegesInsightMatingModel[] | undefined;
    deletedFarrowings?: SegesInsightFarrowingModel[] | undefined;
    deletedDeadPiglets?: SegesInsightDeadPigletsModel[] | undefined;
    deletedNursingWeanings?: SegesInsightNursingWeaingModel[] | undefined;
    deletedWeanings?: SegesInsightWeaningModel[] | undefined;
    deletedLardScannings?: SegesInsightLardScanningModel[] | undefined;

    constructor(data?: ISegesInsightSowModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sow_ID = _data["sow_ID"];
            this.sow_Name = _data["sow_Name"];
            this.birthdate = _data["birthdate"] ? new Date(_data["birthdate"].toString()) : <any>undefined;
            this.firstMating = _data["firstMating"] ? new Date(_data["firstMating"].toString()) : <any>undefined;
            this.deathDate = _data["deathDate"] ? new Date(_data["deathDate"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deathType = _data["deathType"];
            this.deathReason = _data["deathReason"];
            if (Array.isArray(_data["matings"])) {
                this.matings = [] as any;
                for (let item of _data["matings"])
                    this.matings!.push(SegesInsightMatingModel.fromJS(item));
            }
            if (Array.isArray(_data["farrowings"])) {
                this.farrowings = [] as any;
                for (let item of _data["farrowings"])
                    this.farrowings!.push(SegesInsightFarrowingModel.fromJS(item));
            }
            if (Array.isArray(_data["deadPiglets"])) {
                this.deadPiglets = [] as any;
                for (let item of _data["deadPiglets"])
                    this.deadPiglets!.push(SegesInsightDeadPigletsModel.fromJS(item));
            }
            if (Array.isArray(_data["nursingWeanings"])) {
                this.nursingWeanings = [] as any;
                for (let item of _data["nursingWeanings"])
                    this.nursingWeanings!.push(SegesInsightNursingWeaingModel.fromJS(item));
            }
            if (Array.isArray(_data["weanings"])) {
                this.weanings = [] as any;
                for (let item of _data["weanings"])
                    this.weanings!.push(SegesInsightWeaningModel.fromJS(item));
            }
            if (Array.isArray(_data["lardScannings"])) {
                this.lardScannings = [] as any;
                for (let item of _data["lardScannings"])
                    this.lardScannings!.push(SegesInsightLardScanningModel.fromJS(item));
            }
            if (Array.isArray(_data["deletedMatings"])) {
                this.deletedMatings = [] as any;
                for (let item of _data["deletedMatings"])
                    this.deletedMatings!.push(SegesInsightMatingModel.fromJS(item));
            }
            if (Array.isArray(_data["deletedFarrowings"])) {
                this.deletedFarrowings = [] as any;
                for (let item of _data["deletedFarrowings"])
                    this.deletedFarrowings!.push(SegesInsightFarrowingModel.fromJS(item));
            }
            if (Array.isArray(_data["deletedDeadPiglets"])) {
                this.deletedDeadPiglets = [] as any;
                for (let item of _data["deletedDeadPiglets"])
                    this.deletedDeadPiglets!.push(SegesInsightDeadPigletsModel.fromJS(item));
            }
            if (Array.isArray(_data["deletedNursingWeanings"])) {
                this.deletedNursingWeanings = [] as any;
                for (let item of _data["deletedNursingWeanings"])
                    this.deletedNursingWeanings!.push(SegesInsightNursingWeaingModel.fromJS(item));
            }
            if (Array.isArray(_data["deletedWeanings"])) {
                this.deletedWeanings = [] as any;
                for (let item of _data["deletedWeanings"])
                    this.deletedWeanings!.push(SegesInsightWeaningModel.fromJS(item));
            }
            if (Array.isArray(_data["deletedLardScannings"])) {
                this.deletedLardScannings = [] as any;
                for (let item of _data["deletedLardScannings"])
                    this.deletedLardScannings!.push(SegesInsightLardScanningModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SegesInsightSowModel {
        data = typeof data === 'object' ? data : {};
        let result = new SegesInsightSowModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sow_ID"] = this.sow_ID;
        data["sow_Name"] = this.sow_Name;
        data["birthdate"] = this.birthdate ? this.birthdate.toISOString() : <any>undefined;
        data["firstMating"] = this.firstMating ? this.firstMating.toISOString() : <any>undefined;
        data["deathDate"] = this.deathDate ? this.deathDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deathType"] = this.deathType;
        data["deathReason"] = this.deathReason;
        if (Array.isArray(this.matings)) {
            data["matings"] = [];
            for (let item of this.matings)
                data["matings"].push(item.toJSON());
        }
        if (Array.isArray(this.farrowings)) {
            data["farrowings"] = [];
            for (let item of this.farrowings)
                data["farrowings"].push(item.toJSON());
        }
        if (Array.isArray(this.deadPiglets)) {
            data["deadPiglets"] = [];
            for (let item of this.deadPiglets)
                data["deadPiglets"].push(item.toJSON());
        }
        if (Array.isArray(this.nursingWeanings)) {
            data["nursingWeanings"] = [];
            for (let item of this.nursingWeanings)
                data["nursingWeanings"].push(item.toJSON());
        }
        if (Array.isArray(this.weanings)) {
            data["weanings"] = [];
            for (let item of this.weanings)
                data["weanings"].push(item.toJSON());
        }
        if (Array.isArray(this.lardScannings)) {
            data["lardScannings"] = [];
            for (let item of this.lardScannings)
                data["lardScannings"].push(item.toJSON());
        }
        if (Array.isArray(this.deletedMatings)) {
            data["deletedMatings"] = [];
            for (let item of this.deletedMatings)
                data["deletedMatings"].push(item.toJSON());
        }
        if (Array.isArray(this.deletedFarrowings)) {
            data["deletedFarrowings"] = [];
            for (let item of this.deletedFarrowings)
                data["deletedFarrowings"].push(item.toJSON());
        }
        if (Array.isArray(this.deletedDeadPiglets)) {
            data["deletedDeadPiglets"] = [];
            for (let item of this.deletedDeadPiglets)
                data["deletedDeadPiglets"].push(item.toJSON());
        }
        if (Array.isArray(this.deletedNursingWeanings)) {
            data["deletedNursingWeanings"] = [];
            for (let item of this.deletedNursingWeanings)
                data["deletedNursingWeanings"].push(item.toJSON());
        }
        if (Array.isArray(this.deletedWeanings)) {
            data["deletedWeanings"] = [];
            for (let item of this.deletedWeanings)
                data["deletedWeanings"].push(item.toJSON());
        }
        if (Array.isArray(this.deletedLardScannings)) {
            data["deletedLardScannings"] = [];
            for (let item of this.deletedLardScannings)
                data["deletedLardScannings"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISegesInsightSowModel {
    sow_ID?: string | undefined;
    sow_Name?: string | undefined;
    birthdate?: Date | undefined;
    firstMating?: Date | undefined;
    deathDate?: Date | undefined;
    isDeleted: boolean;
    deathType?: string | undefined;
    deathReason?: string | undefined;
    matings?: SegesInsightMatingModel[] | undefined;
    farrowings?: SegesInsightFarrowingModel[] | undefined;
    deadPiglets?: SegesInsightDeadPigletsModel[] | undefined;
    nursingWeanings?: SegesInsightNursingWeaingModel[] | undefined;
    weanings?: SegesInsightWeaningModel[] | undefined;
    lardScannings?: SegesInsightLardScanningModel[] | undefined;
    deletedMatings?: SegesInsightMatingModel[] | undefined;
    deletedFarrowings?: SegesInsightFarrowingModel[] | undefined;
    deletedDeadPiglets?: SegesInsightDeadPigletsModel[] | undefined;
    deletedNursingWeanings?: SegesInsightNursingWeaingModel[] | undefined;
    deletedWeanings?: SegesInsightWeaningModel[] | undefined;
    deletedLardScannings?: SegesInsightLardScanningModel[] | undefined;
}

export class SegesInsightMatingModel implements ISegesInsightMatingModel {
    id?: string | undefined;
    registrationDate!: Date;
    litter!: number;

    constructor(data?: ISegesInsightMatingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.registrationDate = _data["registrationDate"] ? new Date(_data["registrationDate"].toString()) : <any>undefined;
            this.litter = _data["litter"];
        }
    }

    static fromJS(data: any): SegesInsightMatingModel {
        data = typeof data === 'object' ? data : {};
        let result = new SegesInsightMatingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["registrationDate"] = this.registrationDate ? this.registrationDate.toISOString() : <any>undefined;
        data["litter"] = this.litter;
        return data;
    }
}

export interface ISegesInsightMatingModel {
    id?: string | undefined;
    registrationDate: Date;
    litter: number;
}

export class SegesInsightFarrowingModel implements ISegesInsightFarrowingModel {
    id?: string | undefined;
    registrationDate!: Date;
    litter!: number;
    alive!: number;
    dead?: number | undefined;

    constructor(data?: ISegesInsightFarrowingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.registrationDate = _data["registrationDate"] ? new Date(_data["registrationDate"].toString()) : <any>undefined;
            this.litter = _data["litter"];
            this.alive = _data["alive"];
            this.dead = _data["dead"];
        }
    }

    static fromJS(data: any): SegesInsightFarrowingModel {
        data = typeof data === 'object' ? data : {};
        let result = new SegesInsightFarrowingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["registrationDate"] = this.registrationDate ? this.registrationDate.toISOString() : <any>undefined;
        data["litter"] = this.litter;
        data["alive"] = this.alive;
        data["dead"] = this.dead;
        return data;
    }
}

export interface ISegesInsightFarrowingModel {
    id?: string | undefined;
    registrationDate: Date;
    litter: number;
    alive: number;
    dead?: number | undefined;
}

export class SegesInsightDeadPigletsModel implements ISegesInsightDeadPigletsModel {
    id?: string | undefined;
    registrationDate!: Date;
    litter!: number;
    count!: number;
    deathReason?: string | undefined;

    constructor(data?: ISegesInsightDeadPigletsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.registrationDate = _data["registrationDate"] ? new Date(_data["registrationDate"].toString()) : <any>undefined;
            this.litter = _data["litter"];
            this.count = _data["count"];
            this.deathReason = _data["deathReason"];
        }
    }

    static fromJS(data: any): SegesInsightDeadPigletsModel {
        data = typeof data === 'object' ? data : {};
        let result = new SegesInsightDeadPigletsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["registrationDate"] = this.registrationDate ? this.registrationDate.toISOString() : <any>undefined;
        data["litter"] = this.litter;
        data["count"] = this.count;
        data["deathReason"] = this.deathReason;
        return data;
    }
}

export interface ISegesInsightDeadPigletsModel {
    id?: string | undefined;
    registrationDate: Date;
    litter: number;
    count: number;
    deathReason?: string | undefined;
}

export class SegesInsightNursingWeaingModel implements ISegesInsightNursingWeaingModel {
    id?: string | undefined;
    registrationDate!: Date;
    litter!: number;
    count!: number;

    constructor(data?: ISegesInsightNursingWeaingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.registrationDate = _data["registrationDate"] ? new Date(_data["registrationDate"].toString()) : <any>undefined;
            this.litter = _data["litter"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): SegesInsightNursingWeaingModel {
        data = typeof data === 'object' ? data : {};
        let result = new SegesInsightNursingWeaingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["registrationDate"] = this.registrationDate ? this.registrationDate.toISOString() : <any>undefined;
        data["litter"] = this.litter;
        data["count"] = this.count;
        return data;
    }
}

export interface ISegesInsightNursingWeaingModel {
    id?: string | undefined;
    registrationDate: Date;
    litter: number;
    count: number;
}

export class SegesInsightWeaningModel implements ISegesInsightWeaningModel {
    id?: string | undefined;
    registrationDate!: Date;
    litter!: number;
    count!: number;

    constructor(data?: ISegesInsightWeaningModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.registrationDate = _data["registrationDate"] ? new Date(_data["registrationDate"].toString()) : <any>undefined;
            this.litter = _data["litter"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): SegesInsightWeaningModel {
        data = typeof data === 'object' ? data : {};
        let result = new SegesInsightWeaningModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["registrationDate"] = this.registrationDate ? this.registrationDate.toISOString() : <any>undefined;
        data["litter"] = this.litter;
        data["count"] = this.count;
        return data;
    }
}

export interface ISegesInsightWeaningModel {
    id?: string | undefined;
    registrationDate: Date;
    litter: number;
    count: number;
}

export class SegesInsightLardScanningModel implements ISegesInsightLardScanningModel {
    id?: string | undefined;
    registrationDate!: Date;
    weight?: number | undefined;
    width?: number | undefined;

    constructor(data?: ISegesInsightLardScanningModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.registrationDate = _data["registrationDate"] ? new Date(_data["registrationDate"].toString()) : <any>undefined;
            this.weight = _data["weight"];
            this.width = _data["width"];
        }
    }

    static fromJS(data: any): SegesInsightLardScanningModel {
        data = typeof data === 'object' ? data : {};
        let result = new SegesInsightLardScanningModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["registrationDate"] = this.registrationDate ? this.registrationDate.toISOString() : <any>undefined;
        data["weight"] = this.weight;
        data["width"] = this.width;
        return data;
    }
}

export interface ISegesInsightLardScanningModel {
    id?: string | undefined;
    registrationDate: Date;
    weight?: number | undefined;
    width?: number | undefined;
}

export class SegesInsightSowOnlyModel implements ISegesInsightSowOnlyModel {
    sow_ID?: string | undefined;
    sow_Name?: string | undefined;
    birthdate?: Date | undefined;
    deathDate?: Date | undefined;
    deathType?: string | undefined;
    deathReason?: string | undefined;

    constructor(data?: ISegesInsightSowOnlyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sow_ID = _data["sow_ID"];
            this.sow_Name = _data["sow_Name"];
            this.birthdate = _data["birthdate"] ? new Date(_data["birthdate"].toString()) : <any>undefined;
            this.deathDate = _data["deathDate"] ? new Date(_data["deathDate"].toString()) : <any>undefined;
            this.deathType = _data["deathType"];
            this.deathReason = _data["deathReason"];
        }
    }

    static fromJS(data: any): SegesInsightSowOnlyModel {
        data = typeof data === 'object' ? data : {};
        let result = new SegesInsightSowOnlyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sow_ID"] = this.sow_ID;
        data["sow_Name"] = this.sow_Name;
        data["birthdate"] = this.birthdate ? this.birthdate.toISOString() : <any>undefined;
        data["deathDate"] = this.deathDate ? this.deathDate.toISOString() : <any>undefined;
        data["deathType"] = this.deathType;
        data["deathReason"] = this.deathReason;
        return data;
    }
}

export interface ISegesInsightSowOnlyModel {
    sow_ID?: string | undefined;
    sow_Name?: string | undefined;
    birthdate?: Date | undefined;
    deathDate?: Date | undefined;
    deathType?: string | undefined;
    deathReason?: string | undefined;
}

export class SegesInsightSite implements ISegesInsightSite {
    siteId?: string | undefined;
    name?: string | undefined;
    chr!: number;

    constructor(data?: ISegesInsightSite) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.siteId = _data["siteId"];
            this.name = _data["name"];
            this.chr = _data["chr"];
        }
    }

    static fromJS(data: any): SegesInsightSite {
        data = typeof data === 'object' ? data : {};
        let result = new SegesInsightSite();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siteId"] = this.siteId;
        data["name"] = this.name;
        data["chr"] = this.chr;
        return data;
    }
}

export interface ISegesInsightSite {
    siteId?: string | undefined;
    name?: string | undefined;
    chr: number;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new ApiException(message, status, response, headers, result);
}

/* tslint:disable */